import { ɵɵdefineInjectable, Injectable, InjectionToken, Optional, Inject, Component, NgModule, EventEmitter, Input, Output, Renderer2, ElementRef, ViewChild, Pipe, Directive, HostListener, forwardRef, KeyValueDiffers, ContentChild, ɵɵinject, SkipSelf, ContentChildren, NgZone, ViewEncapsulation, ChangeDetectionStrategy, ErrorHandler, ChangeDetectorRef } from '@angular/core';
import { __awaiter, __decorate, __metadata } from 'tslib';
import { HttpErrorResponse, HttpHeaders, HttpClient as HttpClient$1, HttpParams, HttpClientModule } from '@angular/common/http';
import { of, Subject, interval, BehaviorSubject, ReplaySubject, Observable, forkJoin, iif, from } from 'rxjs';
import { mergeMap, catchError, finalize, map, filter, debounceTime, publishReplay, refCount, switchMap, takeWhile, delay, defaultIfEmpty, tap, shareReplay } from 'rxjs/operators';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { CommonModule as CommonModule$1, registerLocaleData, CurrencyPipe, DecimalPipe, Location, DatePipe, APP_BASE_HREF, DOCUMENT } from '@angular/common';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, FormControlName, NgControl, FormControl, ReactiveFormsModule, Validators, FormBuilder, ControlContainer } from '@angular/forms';
import equal from 'deep-equal';
import { createPatch, applyPatch } from 'rfc6902/rfc6902.min.js';
import * as momentLibrary from 'moment-mini';
import vanillaMasker from 'vanilla-masker';
import localePt from '@angular/common/locales/pt';
import { DomSanitizer, BrowserModule, By } from '@angular/platform-browser';
import Clipboard from 'clipboard';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NavigationEnd, Router, ActivatedRoute, NavigationStart, NavigationCancel, NavigationError, RouterModule } from '@angular/router';
import * as Keycloak_ from 'keycloak-js';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { AES, enc } from 'crypto-js';
import { isValid, util } from 'valid.js';
import Shepherd from 'shepherd.js';
import steps from '@elotech/arc/src/assets/components/onboarding/oxy.js';
import { QueryBuilderModule } from 'angular2-query-builder';
import { LRUCache } from 'lru-fast';
import { TestBed } from '@angular/core/testing';
import { SpyLocation } from '@angular/common/testing';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/platform-browser';
import * as ɵngcc5 from 'ngx-dropzone';
import * as ɵngcc6 from '@angular/router';
import * as ɵngcc7 from 'ng-recaptcha';
import * as ɵngcc8 from 'angular2-query-builder';

const _c0 = ["*"];
function AccordionItemComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function AccordionItemComponent_button_9_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.clickOnAddButton(ctx_r1.obj.indice, $event); });
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵtext(3, " Adicionar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function FormLabelColumnComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i");
    ɵngcc0.ɵɵelement(1, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("hint fa fa-question-circle clean module-color sm inline ", ctx_r0.hintPosition, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.hintMessage, ɵngcc0.ɵɵsanitizeHtml);
} }
function FormLabelColumnComponent_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵlistener("click", function FormLabelColumnComponent_a_6_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.clickLink(); });
    ɵngcc0.ɵɵelementStart(1, "u", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.linkTitle);
} }
const _c1 = ["listOption"];
function AutoCompleteComponent_div_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function AutoCompleteComponent_div_1_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const item_r9 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.removeItemFromMultiplo(item_r9); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("title", "Remover: " + ctx_r8.objToOption(item_r9));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.objToOption(item_r9));
} }
function AutoCompleteComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, AutoCompleteComponent_div_1_button_1_Template, 2, 2, "button", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.multipleSelected);
} }
function AutoCompleteComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} }
function AutoCompleteComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 15);
    ɵngcc0.ɵɵlistener("click", function AutoCompleteComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onClickSearch(); });
    ɵngcc0.ɵɵelementEnd();
} }
function AutoCompleteComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 16);
    ɵngcc0.ɵɵlistener("click", function AutoCompleteComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onClickClear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("id", "", ctx_r3.id, "_clearItem");
} }
function AutoCompleteComponent_li_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.noResultsMessage, " ");
} }
function AutoCompleteComponent_div_10_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 20);
    ɵngcc0.ɵɵlistener("click", function AutoCompleteComponent_div_10_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.openCreateModal(); });
    ɵngcc0.ɵɵelement(1, "em", 21);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r16.setDescriptionNewRecordAction(), " ");
} }
function AutoCompleteComponent_div_10_li_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r21 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "extra-info-", i_r21, "");
    ɵngcc0.ɵɵattribute("data-letter", ctx_r22.extraInfos[i_r21][0]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r22.extraInfos[i_r21]);
} }
function AutoCompleteComponent_div_10_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 22);
    ɵngcc0.ɵɵlistener("click", function AutoCompleteComponent_div_10_li_2_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const option_r20 = ctx.$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.onSelect(option_r20); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, AutoCompleteComponent_div_10_li_2_div_2_Template, 3, 3, "div", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r20 = ctx.$implicit;
    const i_r21 = ctx.index;
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("selected", i_r21 == ctx_r17.selectedIndex);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "option_", i_r21, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r20, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r17.extraInfos && ctx_r17.extraInfos[i_r21] && ctx_r17.extraInfos[i_r21][0]);
} }
function AutoCompleteComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, AutoCompleteComponent_div_10_li_1_Template, 3, 1, "li", 18);
    ɵngcc0.ɵɵtemplate(2, AutoCompleteComponent_div_10_li_2_Template, 3, 5, "li", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.isEnabledCreateRecord);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.options);
} }
function AutoCompleteComponent_div_11_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 27);
    ɵngcc0.ɵɵlistener("click", function AutoCompleteComponent_div_11_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.openCreate($event); });
    ɵngcc0.ɵɵtext(1, "Clique aqui para cadastrar.");
    ɵngcc0.ɵɵelementEnd();
} }
function AutoCompleteComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, AutoCompleteComponent_div_11_a_2_Template, 2, 0, "a", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.noResultsMessage, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.hasUrlCreate());
} }
const _c2 = function (a1) { return { "autocomplete-input": true, "required_with_button": a1 }; };
function PanelComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
} }
const _c3 = function (a0, a1) { return { "table": a0, "panel-form": a1 }; };
function EloTimelineHorizontalComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 8);
    ɵngcc0.ɵɵlistener("click", function EloTimelineHorizontalComponent_li_6_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const d_r2 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onClickDate(d_r2); });
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelement(2, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 11);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "dateformat");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const d_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", d_r2.selected ? "bg-gray-20" : "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", d_r2.selected ? "caption bg-primary-color gray-5" : "caption");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 3, d_r2.data), " ");
} }
function EloTimelineHorizontalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "elo-form-label-column", 12);
    ɵngcc0.ɵɵelementStart(2, "button", 13);
    ɵngcc0.ɵɵlistener("click", function EloTimelineHorizontalComponent_div_7_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.showDialogRemove = !ctx_r5.showDialogRemove; });
    ɵngcc0.ɵɵelement(3, "i", 14);
    ɵngcc0.ɵɵtext(4, " Remover Revis\u00E3o ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", "Remover revis\u00E3o");
} }
const _c4 = ["input"];
function CalendarComponent_li_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const weekDay_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(weekDay_r2);
} }
function CalendarComponent_li_15_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 13);
    ɵngcc0.ɵɵlistener("click", function CalendarComponent_li_15_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const dayCalendar_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.selectDate(dayCalendar_r3); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dayCalendar_r3 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("not-this-month", !dayCalendar_r3.isMonthOfSelectDate)("selected", dayCalendar_r3.isSelectDate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dayCalendar_r3.day, "");
} }
function DialogComponent_div_0_h3_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h3", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r1.title, " ");
} }
function DialogComponent_div_0_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_div_0_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onCancel(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.tittleCancel);
} }
function DialogComponent_div_0_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_div_0_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.disableOkButton ? ctx_r8.onDoNothing() : ctx_r8.onOk(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("btn positive inline ", ctx_r3.disableOkButton ? "disabled" : "", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.tittleOk);
} }
function DialogComponent_div_0_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_div_0_ng_template_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.disableOkButton ? ctx_r10.onDoNothing() : ctx_r10.onOk(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("btn positive inline ", ctx_r5.disableOkButton ? "disabled" : "", "");
    ɵngcc0.ɵɵproperty("debounceTime", ctx_r5.debounceTime);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.tittleOk);
} }
function DialogComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵtemplate(5, DialogComponent_div_0_h3_5_Template, 2, 1, "h3", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵelementStart(7, "div", 8);
    ɵngcc0.ɵɵprojection(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 9);
    ɵngcc0.ɵɵtemplate(10, DialogComponent_div_0_button_10_Template, 2, 1, "button", 10);
    ɵngcc0.ɵɵtemplate(11, DialogComponent_div_0_button_11_Template, 2, 4, "button", 11);
    ɵngcc0.ɵɵtemplate(12, DialogComponent_div_0_ng_template_12_Template, 2, 5, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(13);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("dialoguebox alt ", ctx_r0.classType, " open");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.title);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showCancel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.debounceTime)("ngIfElse", _r4);
} }
function EloTableDrilldownComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r5 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("colunm col-sm-", col_r5 == null ? null : col_r5.col, "");
    ɵngcc0.ɵɵclassProp("right", col_r5 == null ? null : col_r5.isDecimal);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(col_r5 == null ? null : col_r5.header);
} }
function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "decimalformat");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r13 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const item_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r18.headerSecondField, " : ", ɵngcc0.ɵɵpipeBind2(3, 2, item_r9[col_r13.secondField] || 0, "1.2-2"), "");
} }
const _c5 = function () { return { "justify-content": "flex-end" }; };
function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵlistener("click", function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const item_r9 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(3); return ctx_r21.onClick(item_r9); });
    ɵngcc0.ɵɵtemplate(1, EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_div_1_div_1_Template, 4, 5, "div", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "decimalformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext();
    const col_r13 = ctx_r24.$implicit;
    const j_r14 = ctx_r24.index;
    const item_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassMapInterpolate1("column col-sm-", col_r13 == null ? null : col_r13.col, " direction-row right");
    ɵngcc0.ɵɵclassProp("center-father", j_r14 === 0);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction0(11, _c5));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.showSecondField && (col_r13 == null ? null : col_r13.secondField));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(3, 8, item_r9[col_r13.field] || 0, "1.2-2"), " ");
} }
function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵlistener("click", function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_ng_template_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const item_r9 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r26 = ɵngcc0.ɵɵnextContext(3); return ctx_r26.onClick(item_r9); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext();
    const col_r13 = ctx_r29.$implicit;
    const j_r14 = ctx_r29.index;
    const item_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("column col-sm-", col_r13 == null ? null : col_r13.col, "");
    ɵngcc0.ɵɵclassProp("center-father", j_r14 === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r9[col_r13.field], " ");
} }
function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_div_1_Template, 4, 12, "div", 11);
    ɵngcc0.ɵɵtemplate(2, EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_ng_template_2_Template, 2, 6, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r13 = ctx.$implicit;
    const _r16 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r13 == null ? null : col_r13.isDecimal)("ngIfElse", _r16);
} }
function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c6 = function (a0, a1) { return { $implicit: a0, padding: a1 }; };
function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const padding_r7 = ɵngcc0.ɵɵnextContext().padding;
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c6, item_r9.data, padding_r7 + 1));
} }
const _c7 = function (a0) { return { "cursor": a0 }; };
function EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵtemplate(2, EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_2_Template, 4, 2, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_ng_container_3_Template, 2, 5, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const padding_r7 = ɵngcc0.ɵɵnextContext().padding;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate3("row reduced ", item_r9[ctx_r8.fieldHasChilds] ? "father" : "", " level-", padding_r7, " ", (item_r9 == null ? null : item_r9.open) ? "open" : "", "");
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(8, _c7, item_r9[ctx_r8.fieldHasChilds] ? "pointer" : ""));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.columns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r9 == null ? null : item_r9.data == null ? null : item_r9.data.length);
} }
function EloTableDrilldownComponent_div_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, EloTableDrilldownComponent_div_0_ng_template_5_ng_container_0_Template, 4, 10, "ng-container", 8);
} if (rf & 2) {
    const data_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngForOf", data_r6);
} }
function EloTableDrilldownComponent_div_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c8 = function (a0) { return { $implicit: a0, padding: 1 }; };
function EloTableDrilldownComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, EloTableDrilldownComponent_div_0_div_3_Template, 3, 6, "div", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵtemplate(5, EloTableDrilldownComponent_div_0_ng_template_5_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(7, EloTableDrilldownComponent_div_0_ng_container_7_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(6);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.columns);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c8, ctx_r0.data));
} }
function ArquivoComponent_li_6_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function ArquivoComponent_li_6_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const arq_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onView(arq_r1); });
    ɵngcc0.ɵɵelement(1, "i", 14);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵtext(3, "Visualizar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ArquivoComponent_li_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function ArquivoComponent_li_6_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const arq_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onDownload(arq_r1); });
    ɵngcc0.ɵɵelement(1, "i", 17);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵtext(3, "Download");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ArquivoComponent_li_6_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function ArquivoComponent_li_6_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const arq_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onRemove(arq_r1); });
    ɵngcc0.ɵɵelement(1, "i", 19);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵtext(3, "Excluir");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ArquivoComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵtemplate(5, ArquivoComponent_li_6_button_5_Template, 4, 0, "button", 10);
    ɵngcc0.ɵɵtemplate(6, ArquivoComponent_li_6_button_6_Template, 4, 0, "button", 11);
    ɵngcc0.ɵɵtemplate(7, ArquivoComponent_li_6_button_7_Template, 4, 0, "button", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const arq_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate((arq_r1 == null ? null : arq_r1.arquivo == null ? null : arq_r1.arquivo.nome) ? arq_r1 == null ? null : arq_r1.arquivo == null ? null : arq_r1.arquivo.nome : "Arquivo sem nome");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canView);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canDownload);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canRemove);
} }
const _c9 = ["botoesDireita"];
function BreadcrumbComponent_li_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a");
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const route_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-current", ctx_r4.routes[ctx_r4.routes.length - 1] === route_r2 ? "page" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(route_r2.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(route_r2.label);
} }
function BreadcrumbComponent_li_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function BreadcrumbComponent_li_7_ng_template_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const route_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onClick(route_r2); });
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const route_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", route_r2.url)("queryParams", route_r2.queryParams);
    ɵngcc0.ɵɵattribute("aria-current", ctx_r6.routes[ctx_r6.routes.length - 1] === route_r2 ? "page" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(route_r2.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(route_r2.label);
} }
function BreadcrumbComponent_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtemplate(1, BreadcrumbComponent_li_7_ng_container_1_Template, 5, 5, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbComponent_li_7_ng_template_2_Template, 4, 7, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const isLast_r3 = ctx.last;
    const _r5 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", isLast_r3)("ngIfElse", _r5);
} }
function BreadcrumbComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c10 = ["botoesBreadcrumb"];
const _c11 = function () { return { "border": "none", "width": "20px", "height": "20px", "padding": "0", "margin": "5.5px" }; };
function SectionComponent_header_2_article_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "article", 5);
    ɵngcc0.ɵɵelement(1, "i", 0);
    ɵngcc0.ɵɵelementStart(2, "h2", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(4, 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.icon);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.startedNavigation && ɵngcc0.ɵɵpureFunction0(5, _c11));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.caption, " ");
} }
function SectionComponent_header_2_elo_breadcrumb_2_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function SectionComponent_header_2_elo_breadcrumb_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SectionComponent_header_2_elo_breadcrumb_2_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 9);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.botoesBreadcrumb);
} }
function SectionComponent_header_2_elo_breadcrumb_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "elo-breadcrumb", 7);
    ɵngcc0.ɵɵtemplate(1, SectionComponent_header_2_elo_breadcrumb_2_ng_template_1_Template, 1, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("urlsToLabels", ctx_r2.urlsToLabels);
} }
function SectionComponent_header_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "header", 2);
    ɵngcc0.ɵɵtemplate(1, SectionComponent_header_2_article_1_Template, 5, 6, "article", 3);
    ɵngcc0.ɵɵtemplate(2, SectionComponent_header_2_elo_breadcrumb_2_Template, 3, 1, "elo-breadcrumb", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.enabledBreadcrumb);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.enabledBreadcrumb);
} }
const _c12 = ["*", [["", "title-content", ""]]];
const _c13 = function (a0) { return { "padding-bottom": a0 }; };
const _c14 = ["*", "[title-content]"];
function ConsultaDinamicaComponent_iframe_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "iframe", 2);
    ɵngcc0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r0.url), ɵngcc0.ɵɵsanitizeResourceUrl);
} }
const _c15 = function (a0) { return { "height": a0 }; };
const _c16 = function (a0) { return { "checked": a0 }; };
function ArvoreAvancadaComponent_arvore_avancada_node_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "arvore-avancada-node", 3);
    ɵngcc0.ɵɵlistener("onEdition", function ArvoreAvancadaComponent_arvore_avancada_node_2_Template_arvore_avancada_node_onEdition_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onEditionThen($event); })("onSelection", function ArvoreAvancadaComponent_arvore_avancada_node_2_Template_arvore_avancada_node_onSelection_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.emitirSelecionado($event); })("onDeletion", function ArvoreAvancadaComponent_arvore_avancada_node_2_Template_arvore_avancada_node_onDeletion_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onDeletionThen($event); })("onHeadClick", function ArvoreAvancadaComponent_arvore_avancada_node_2_Template_arvore_avancada_node_onHeadClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.headClick($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c16, node_r1.expanded))("node", node_r1)("formNode", ctx_r0.formNode)("showActions", true);
} }
function ArvoreAvancadaNodeHeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.hint);
} }
function ArvoreAvancadaNodeHeaderComponent_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c17 = function (a0) { return { node: a0 }; };
function ArvoreAvancadaNodeHeaderComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, ArvoreAvancadaNodeHeaderComponent_div_8_ng_container_1_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerActions)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c17, ctx_r1.node));
} }
function ArvoreAvancadaChildrenSummaryComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 2);
    ɵngcc0.ɵɵlistener("click", function ArvoreAvancadaChildrenSummaryComponent_ng_container_1_Template_li_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const summary_r1 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.selectNode($event, summary_r1); });
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "button", 5);
    ɵngcc0.ɵɵlistener("click", function ArvoreAvancadaChildrenSummaryComponent_ng_container_1_Template_button_click_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const summary_r1 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onEdit($event, summary_r1); });
    ɵngcc0.ɵɵelement(6, "i", 6);
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵtext(8, "Editar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 5);
    ɵngcc0.ɵɵlistener("click", function ArvoreAvancadaChildrenSummaryComponent_ng_container_1_Template_button_click_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const summary_r1 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.emitOnDelete($event, summary_r1); });
    ɵngcc0.ɵɵelement(10, "i", 8);
    ɵngcc0.ɵɵelementStart(11, "div", 7);
    ɵngcc0.ɵɵtext(12, "Remover");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const summary_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(summary_r1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "btnEdit-", i_r2, "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "btnRemove-", i_r2, "");
} }
function ArvoreAvancadaNodeComponent_ng_container_2_arvore_avancada_node_form_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "arvore-avancada-node-form", 5);
} if (rf & 2) {
    const form_r3 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵproperty("node", form_r3);
} }
function ArvoreAvancadaNodeComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ArvoreAvancadaNodeComponent_ng_container_2_arvore_avancada_node_form_1_Template, 1, 1, "arvore-avancada-node-form", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.node.expanded === true);
} }
function ArvoreAvancadaNodeComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "arvore-avancada-children-resume", 6);
    ɵngcc0.ɵɵlistener("onEdition", function ArvoreAvancadaNodeComponent_ng_template_4_Template_arvore_avancada_children_resume_onEdition_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onEditionThen($event); })("onSelecion", function ArvoreAvancadaNodeComponent_ng_template_4_Template_arvore_avancada_children_resume_onSelecion_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.emitirSelecionado($event); })("onDeletion", function ArvoreAvancadaNodeComponent_ng_template_4_Template_arvore_avancada_children_resume_onDeletion_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onDeletionThen($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("children", ctx_r2.node.children);
} }
function ArvoreAvancadaNodeFormComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c18 = ["dataTableFooter"];
const _c19 = ["dataTableSubtitles"];
const _c20 = ["dataTableExpand"];
function EloDatatableComponent_th_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 13);
    ɵngcc0.ɵɵelementStart(1, "elo-checkbox", 14);
    ɵngcc0.ɵɵlistener("onClick", function EloDatatableComponent_th_6_Template_elo_checkbox_onClick_1_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.clickSelectAll(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "", ctx_r0.selectionModeId, "_header");
    ɵngcc0.ɵɵproperty("checked", ctx_r0.isAllSelected());
} }
function EloDatatableComponent_th_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th");
} }
function EloDatatableComponent_th_8_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 18);
} if (rf & 2) {
    const column_r15 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("textContent", column_r15.header);
} }
const _c21 = function (a0) { return { column: a0 }; };
function EloDatatableComponent_th_8_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
} if (rf & 2) {
    const column_r15 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", column_r15.headerTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c21, column_r15));
} }
function EloDatatableComponent_th_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 15);
    ɵngcc0.ɵɵlistener("click", function EloDatatableComponent_th_8_Template_th_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const column_r15 = ctx.$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.clickHeaderTable(column_r15); });
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_th_8_span_1_Template, 1, 1, "span", 16);
    ɵngcc0.ɵɵtemplate(2, EloDatatableComponent_th_8_span_2_Template, 1, 4, "span", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r15 = ctx.$implicit;
    const isLast_r16 = ctx.last;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleMap("text-transform: " + ctx_r2.textTransform + ";");
    ɵngcc0.ɵɵclassProp("right", column_r15.isDecimal)("asc", ctx_r2.sortable && ctx_r2.getSort(column_r15.field, "asc"))("desc", ctx_r2.sortable && ctx_r2.getSort(column_r15.field, "desc"))("sortable", ctx_r2.sortable && column_r15.sortable && ctx_r2.pageParameters.sort.indexOf("column.field") === -1);
    ɵngcc0.ɵɵproperty("ngClass", column_r15.headerAlign)("ngStyle", isLast_r16 ? ctx_r2.getLastColumnStyle(column_r15) : column_r15.headerStyle)("hidden", column_r15.hidden);
    ɵngcc0.ɵɵattribute("colspan", column_r15.col);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r15.headerTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r15.headerTemplate);
} }
function EloDatatableComponent_th_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 20);
    ɵngcc0.ɵɵtext(1, " Selecione ");
    ɵngcc0.ɵɵelementEnd();
} }
function EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 27);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const headerAction_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", headerAction_r25.template);
} }
function EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵelementStart(2, "div", 30);
    ɵngcc0.ɵɵelementStart(3, "button", 31);
    ɵngcc0.ɵɵlistener("click", function EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_ng_template_2_Template_button_click_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const headerAction_r25 = ɵngcc0.ɵɵnextContext().$implicit; return headerAction_r25.clickIconButton($event); });
    ɵngcc0.ɵɵelement(4, "i");
    ɵngcc0.ɵɵelementStart(5, "div", 32);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const headerAction_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("id", headerAction_r25.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(headerAction_r25.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", headerAction_r25.description, " ");
} }
function EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 21);
    ɵngcc0.ɵɵtemplate(2, EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_ng_template_2_Template, 7, 5, "ng-template", null, 26, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const headerAction_r25 = ctx.$implicit;
    const _r27 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", headerAction_r25.template)("ngIfElse", _r27);
} }
function EloDatatableComponent_ng_container_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "th", 22);
    ɵngcc0.ɵɵelement(2, "i", 23);
    ɵngcc0.ɵɵelementStart(3, "div", 24);
    ɵngcc0.ɵɵtemplate(4, EloDatatableComponent_ng_container_10_ng_container_1_ng_container_4_Template, 4, 2, "ng-container", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r23.eloHeaderActions);
} }
function EloDatatableComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_ng_container_10_ng_container_1_Template, 5, 1, "ng-container", 21);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.eloHeaderActions.length > 1)("ngIfElse", _r5);
} }
function EloDatatableComponent_ng_template_11_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function EloDatatableComponent_ng_template_11_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_ng_template_11_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 27);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r35 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r35.eloHeaderActions[0].template);
} }
function EloDatatableComponent_ng_template_11_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "div", 30);
    ɵngcc0.ɵɵelementStart(2, "button", 31);
    ɵngcc0.ɵɵlistener("click", function EloDatatableComponent_ng_template_11_ng_template_1_div_1_Template_button_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const headerAction_r40 = ctx.ngIf; return headerAction_r40.clickIconButton($event); });
    ɵngcc0.ɵɵelement(3, "i");
    ɵngcc0.ɵɵelementStart(4, "div", 32);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const headerAction_r40 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("id", headerAction_r40.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(headerAction_r40.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", headerAction_r40.description, " ");
} }
function EloDatatableComponent_ng_template_11_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 28);
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_ng_template_11_ng_template_1_div_1_Template, 6, 5, "div", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r37.eloHeaderActions[0]);
} }
function EloDatatableComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, EloDatatableComponent_ng_template_11_ng_container_0_Template, 2, 1, "ng-container", 21);
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_ng_template_11_ng_template_1_Template, 2, 1, "ng-template", null, 26, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r36 = ɵngcc0.ɵɵreference(2);
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.eloHeaderActions[0] == null ? null : ctx_r6.eloHeaderActions[0].template)("ngIfElse", _r36);
} }
function EloDatatableComponent_th_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th", 34);
} }
function EloDatatableComponent_tr_17_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function EloDatatableComponent_tr_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_tr_17_ng_container_1_Template, 1, 0, "ng-container", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.dataTableFooter);
} }
function EloDatatableComponent_tr_18_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "td");
} if (rf & 2) {
    const column_r46 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("colspan", column_r46.col);
} }
function EloDatatableComponent_tr_18_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "td", 34);
} }
function EloDatatableComponent_tr_18_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelementStart(2, "elo-checkbox", 14);
    ɵngcc0.ɵɵlistener("onClick", function EloDatatableComponent_tr_18_Template_elo_checkbox_onClick_2_listener() { ɵngcc0.ɵɵrestoreView(_r48); const ctx_r47 = ɵngcc0.ɵɵnextContext(); return ctx_r47.clickSelectAll(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, EloDatatableComponent_tr_18_td_3_Template, 1, 1, "td", 25);
    ɵngcc0.ɵɵtemplate(4, EloDatatableComponent_tr_18_td_4_Template, 1, 0, "td", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "", ctx_r10.selectionModeId, "_footer");
    ɵngcc0.ɵɵproperty("checked", ctx_r10.isAllSelected());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.eloColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.haveAction());
} }
function EloDatatableComponent_tbody_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tbody", 35);
    ɵngcc0.ɵɵelementStart(1, "tr");
    ɵngcc0.ɵɵelementStart(2, "td", 36);
    ɵngcc0.ɵɵelementStart(3, "span", 37);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassMap(ctx_r11.classEmptyMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r11.emptyMessage, " ");
} }
function EloDatatableComponent_div_20_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function EloDatatableComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 38);
    ɵngcc0.ɵɵtemplate(1, EloDatatableComponent_div_20_ng_container_1_Template, 1, 0, "ng-container", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r12.dataTableSubtitles);
} }
const _c22 = ["dataTableCell"];
const _c23 = ["dataTableHeader"];
const _c24 = ["validationMessage"];
const _c25 = ["elo-row", ""];
function EloDataTableRowComponent_ng_container_0_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 7);
    ɵngcc0.ɵɵelementStart(1, "elo-checkbox", 8);
    ɵngcc0.ɵɵlistener("onClick", function EloDataTableRowComponent_ng_container_0_td_2_Template_elo_checkbox_onClick_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const object_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.table.clickCheckBox(object_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    const object_r1 = ctx_r12.$implicit;
    const i_r2 = ctx_r12.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("id", object_r1.id ? ctx_r3.selectionModeId + object_r1.id + "_" + i_r2 : ctx_r3.selectionModeId + i_r2);
    ɵngcc0.ɵɵproperty("checkAllowed", ctx_r3.table.checkAllowed(object_r1))("checked", ctx_r3.table.isSelected(object_r1))("titleCheckboxDisallowed", ctx_r3.table.titleCheckboxDisallowed);
} }
function EloDataTableRowComponent_ng_container_0_td_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵelementStart(1, "input", 9);
    ɵngcc0.ɵɵlistener("change", function EloDataTableRowComponent_ng_container_0_td_3_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); const object_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.table.clickRadioButton(object_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", ctx_r4.table.isSelected(object_r1));
} }
function EloDataTableRowComponent_ng_container_0_td_4_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r19 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r19.table == null ? null : ctx_r19.table.getValue(object_r1, column_r17.field, column_r17.enumOptions));
} }
function EloDataTableRowComponent_ng_container_0_td_4_samp_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "samp");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r20.table == null ? null : ctx_r20.table.getValue(object_r1, column_r17.field, column_r17.enumOptions));
} }
function EloDataTableRowComponent_ng_container_0_td_4_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "decimalformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 4, ctx_r21.table == null ? null : ctx_r21.table.getValue(object_r1, column_r17.field), column_r17.digits ? column_r17.digits : "1.2-2"));
} }
function EloDataTableRowComponent_ng_container_0_td_4_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "decimalformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r22 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind2(2, 4, ctx_r22.table == null ? null : ctx_r22.table.getValue(object_r1, column_r17.field), column_r17.digits ? column_r17.digits : "1.2-2"), "%");
} }
function EloDataTableRowComponent_ng_container_0_td_4_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "dateformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r23.table == null ? null : ctx_r23.table.getValue(object_r1, column_r17.field)));
} }
function EloDataTableRowComponent_ng_container_0_td_4_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "datehourformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r24 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r24.table == null ? null : ctx_r24.table.getValue(object_r1, column_r17.field)));
} }
function EloDataTableRowComponent_ng_container_0_td_4_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "cnpjCpf");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r25 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r25.table == null ? null : ctx_r25.table.getValue(object_r1, column_r17.field)));
} }
function EloDataTableRowComponent_ng_container_0_td_4_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "dateformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r26 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r26.table == null ? null : ctx_r26.table.getValue(object_r1, column_r17.field)));
} }
const _c26 = function (a0, a1, a2) { return { column: a0, object: a1, index: a2 }; };
function EloDataTableRowComponent_ng_container_0_td_4_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 14);
} if (rf & 2) {
    const column_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r45 = ɵngcc0.ɵɵnextContext();
    const object_r1 = ctx_r45.$implicit;
    const i_r2 = ctx_r45.index;
    ɵngcc0.ɵɵclassMapInterpolate1("td-content ", column_r17.class, "");
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", column_r17.cellTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(5, _c26, column_r17, object_r1, i_r2));
} }
const _c27 = function () { return {}; };
function EloDataTableRowComponent_ng_container_0_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 10);
    ɵngcc0.ɵɵelementStart(1, "b", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, EloDataTableRowComponent_ng_container_0_td_4_span_3_Template, 2, 4, "span", 12);
    ɵngcc0.ɵɵtemplate(4, EloDataTableRowComponent_ng_container_0_td_4_samp_4_Template, 2, 4, "samp", 12);
    ɵngcc0.ɵɵtemplate(5, EloDataTableRowComponent_ng_container_0_td_4_span_5_Template, 3, 7, "span", 12);
    ɵngcc0.ɵɵtemplate(6, EloDataTableRowComponent_ng_container_0_td_4_span_6_Template, 3, 7, "span", 12);
    ɵngcc0.ɵɵtemplate(7, EloDataTableRowComponent_ng_container_0_td_4_span_7_Template, 3, 6, "span", 12);
    ɵngcc0.ɵɵtemplate(8, EloDataTableRowComponent_ng_container_0_td_4_span_8_Template, 3, 6, "span", 12);
    ɵngcc0.ɵɵtemplate(9, EloDataTableRowComponent_ng_container_0_td_4_span_9_Template, 3, 6, "span", 12);
    ɵngcc0.ɵɵtemplate(10, EloDataTableRowComponent_ng_container_0_td_4_span_10_Template, 3, 6, "span", 12);
    ɵngcc0.ɵɵtemplate(11, EloDataTableRowComponent_ng_container_0_td_4_span_11_Template, 1, 9, "span", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r17 = ctx.$implicit;
    const isLast_r18 = ctx.last;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(column_r17.class);
    ɵngcc0.ɵɵproperty("hidden", column_r17.hidden || column_r17.hiddenTableData)("ngClass", column_r17.isDecimal ? "right" : "")("ngStyle", isLast_r18 ? ctx_r5.table.getLastColumnStyle(column_r17) : ɵngcc0.ɵɵpureFunction0(17, _c27));
    ɵngcc0.ɵɵattribute("colspan", isLast_r18 ? ctx_r5.table.getLastColumnColspan(column_r17) : column_r17.col);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(column_r17.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r17.isEditable && !column_r17.isDecimal && !column_r17.isPercentual && !column_r17.isDate && !column_r17.isCnpjCpf && !column_r17.isBoolean && !column_r17.cellTemplate && !column_r17.isDateTime && !column_r17.samp);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r17.samp);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r17.isEditable && column_r17.isDecimal && !column_r17.isPercentual && !column_r17.cellTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r17.isEditable && column_r17.isDecimal && column_r17.isPercentual && !column_r17.cellTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r17.isEditable && column_r17.isDate && !column_r17.cellTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r17.isEditable && !column_r17.isDate && !column_r17.cellTemplate && column_r17.isDateTime);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r17.isEditable && column_r17.isCnpjCpf && !column_r17.cellTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r17.isEditable && column_r17.isBoolean && !column_r17.cellTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r17.cellTemplate);
} }
function EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", action_r48.title, " ");
} }
function EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_div_3_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r59 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 27);
    ɵngcc0.ɵɵlistener("click", function EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_div_3_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r59); const link_r56 = ctx.$implicit; const action_r48 = ɵngcc0.ɵɵnextContext(3).$implicit; const object_r1 = ɵngcc0.ɵɵnextContext(3).$implicit; return action_r48.clickLink(object_r1, link_r56); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r56 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(link_r56);
} }
function EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtemplate(1, EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_div_3_a_1_Template, 2, 1, "a", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", action_r48.getLinks(object_r1));
} }
function EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("click", function EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r65); const action_r48 = ɵngcc0.ɵɵnextContext().$implicit; const object_r1 = ɵngcc0.ɵɵnextContext(3).$implicit; return action_r48.clickIconButton(object_r1); });
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵtemplate(2, EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_div_2_Template, 2, 1, "div", 24);
    ɵngcc0.ɵɵtemplate(3, EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_div_3_Template, 2, 1, "div", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = ɵngcc0.ɵɵnextContext();
    const action_r48 = ctx_r68.$implicit;
    const i_r49 = ctx_r68.index;
    const object_r1 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵclassProp("error", (object_r1 == null ? null : object_r1.error) && action_r48.showError)("links", action_r48.hasLinks);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "", action_r48.id, "_", i_r49, "");
    ɵngcc0.ɵɵproperty("removeAutoFocus", action_r48.removeAutoFocus);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(action_r48.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !action_r48.hasLinks);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", action_r48.hasLinks);
} }
function EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 28);
    ɵngcc0.ɵɵelement(1, "i", 29);
    ɵngcc0.ɵɵelementStart(2, "div", 25);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r48 = ɵngcc0.ɵɵnextContext().$implicit;
    const object_r1 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("href", action_r48.buildHRef(object_r1), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(action_r48.title);
} }
function EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 20);
    ɵngcc0.ɵɵtemplate(1, EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_button_1_Template, 4, 12, "button", 21);
    ɵngcc0.ɵɵtemplate(2, EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_a_2_Template, 4, 2, "a", 22);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r48 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngSwitch", action_r48.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", action_r48.complex());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", action_r48.link());
} }
function EloDataTableRowComponent_ng_container_0_td_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵtemplate(2, EloDataTableRowComponent_ng_container_0_td_5_div_1_ng_container_2_Template, 3, 3, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r46 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r46.table.tableActionVisibleTo(object_r1));
} }
function EloDataTableRowComponent_ng_container_0_td_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 15);
    ɵngcc0.ɵɵtemplate(1, EloDataTableRowComponent_ng_container_0_td_5_div_1_Template, 3, 1, "div", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("quickViewOpener", ctx_r6.isQuickViewOpener);
    ɵngcc0.ɵɵattribute("colspan", ctx_r6.colSpanActions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.table.tableActionVisibleTo(object_r1).length);
} }
function EloDataTableRowComponent_ng_container_0_td_6_Template(rf, ctx) { if (rf & 1) {
    const _r75 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵelementStart(1, "button-select", 30);
    ɵngcc0.ɵɵlistener("click", function EloDataTableRowComponent_ng_container_0_td_6_Template_button_select_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r75); const object_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r73 = ɵngcc0.ɵɵnextContext(); return ctx_r73.table.clickSelectOne(object_r1); });
    ɵngcc0.ɵɵtext(2, " Adicionar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c28 = function (a0) { return { object: a0 }; };
function EloDataTableRowComponent_ng_container_0_tr_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 31);
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelement(2, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("colspan", ctx_r8.table.columnCount);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.table.expandTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c28, object_r1));
} }
function EloDataTableRowComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r78 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "tr", 1);
    ɵngcc0.ɵɵlistener("dblclick", function EloDataTableRowComponent_ng_container_0_Template_tr_dblclick_1_listener() { ɵngcc0.ɵɵrestoreView(_r78); const object_r1 = ctx.$implicit; const ctx_r77 = ɵngcc0.ɵɵnextContext(); return ctx_r77.onRowDoubleClick(object_r1); });
    ɵngcc0.ɵɵtemplate(2, EloDataTableRowComponent_ng_container_0_td_2_Template, 2, 4, "td", 2);
    ɵngcc0.ɵɵtemplate(3, EloDataTableRowComponent_ng_container_0_td_3_Template, 2, 1, "td", 3);
    ɵngcc0.ɵɵtemplate(4, EloDataTableRowComponent_ng_container_0_td_4_Template, 12, 18, "td", 4);
    ɵngcc0.ɵɵtemplate(5, EloDataTableRowComponent_ng_container_0_td_5_Template, 2, 4, "td", 5);
    ɵngcc0.ɵɵtemplate(6, EloDataTableRowComponent_ng_container_0_td_6_Template, 3, 0, "td", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, EloDataTableRowComponent_ng_container_0_tr_7_Template, 3, 5, "tr", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const object_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("highlight", object_r1 == null ? null : object_r1.highlight)("warning", object_r1 == null ? null : object_r1.warning)("success", object_r1 == null ? null : object_r1.success)("error", object_r1 == null ? null : object_r1.error)("rowSelected", object_r1 == null ? null : object_r1.quickSelected)("reduced", ctx_r0.table.manyActions);
    ɵngcc0.ɵɵpropertyInterpolate("id", "table-line_" + i_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.table.isMultipleSelectionMode());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.table.isRadioSelectionMode());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.table.eloColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.table.haveAction());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.table.isSingleSelectionMode());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", object_r1 == null ? null : object_r1.expand);
} }
function EloCheckboxComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "input", 3);
    ɵngcc0.ɵɵlistener("click", function EloCheckboxComponent_div_0_Template_input_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.clickCheckbox($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "", ctx_r0.id, "_input_checkbox");
    ɵngcc0.ɵɵproperty("checked", ctx_r0.checked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("for", "", ctx_r0.id, "_input_checkbox");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function EloCheckboxComponent_em_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "em", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r1.titleCheckboxDisallowed);
} }
function PanelExpansiveComponent_div_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function PanelExpansiveComponent_div_2_button_2_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.newButton($event); });
    ɵngcc0.ɵɵelement(1, "em", 8);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.disabledButton);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.titleButtonNovo, " ");
} }
function PanelExpansiveComponent_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 10);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.extraButtons);
} }
function PanelExpansiveComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("click", function PanelExpansiveComponent_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.openToggle(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, PanelExpansiveComponent_div_2_button_2_Template, 4, 2, "button", 5);
    ɵngcc0.ɵɵtemplate(3, PanelExpansiveComponent_div_2_ng_container_3_Template, 1, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("inside-tab", ctx_r0.isInsideTab);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showButton && !ctx_r0.hideButtonNovo);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showButton && ctx_r0.extraButtons);
} }
const _c29 = function (a0, a1, a2, a3, a4) { return { "open": a0, "": a1, "table": a2, "panel-form": a3, "expansible": a4 }; };
function EloRadioButtonComponent_input_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 2);
    ɵngcc0.ɵɵlistener("click", function EloRadioButtonComponent_input_0_Template_input_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selectRadio($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("checked", ctx_r0.selected);
} }
function EloRadioButtonComponent_em_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "em", 3);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r1.titleRadioButtonDisallowed);
} }
function AuthenticationComponent_div_12_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelement(1, "i", 27);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.error, " ");
} }
function AuthenticationComponent_div_12_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "re-captcha", 28);
    ɵngcc0.ɵɵelementEnd();
} }
function AuthenticationComponent_div_12_a_17_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 29);
    ɵngcc0.ɵɵlistener("click", function AuthenticationComponent_div_12_a_17_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.goCadastro(); });
    ɵngcc0.ɵɵtext(1, " Crie sua conta ");
    ɵngcc0.ɵɵelementEnd();
} }
function AuthenticationComponent_div_12_a_18_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 30);
    ɵngcc0.ɵɵlistener("click", function AuthenticationComponent_div_12_a_18_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.showRecuperarAcesso(); });
    ɵngcc0.ɵɵtext(1, " Esqueceu sua senha? ");
    ɵngcc0.ɵɵelementEnd();
} }
function AuthenticationComponent_div_12_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 31);
    ɵngcc0.ɵɵtext(2, "ou conecte-se com");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 32);
    ɵngcc0.ɵɵlistener("click", function AuthenticationComponent_div_12_div_23_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.doX509Login(); });
    ɵngcc0.ɵɵelement(4, "i", 33);
    ɵngcc0.ɵɵtext(5, " Certificado ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AuthenticationComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "form", 12);
    ɵngcc0.ɵɵlistener("ngSubmit", function AuthenticationComponent_div_12_Template_form_ngSubmit_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onSubmit(ctx_r15.form.value); });
    ɵngcc0.ɵɵelementStart(2, "div", 13);
    ɵngcc0.ɵɵtemplate(3, AuthenticationComponent_div_12_div_3_Template, 3, 1, "div", 14);
    ɵngcc0.ɵɵelement(4, "input", 15);
    ɵngcc0.ɵɵelement(5, "input", 16);
    ɵngcc0.ɵɵelementStart(6, "select", 17);
    ɵngcc0.ɵɵelementStart(7, "option", 18);
    ɵngcc0.ɵɵtext(8, "Usu\u00E1rio");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "option", 19);
    ɵngcc0.ɵɵtext(10, "Elotech");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, " ` ");
    ɵngcc0.ɵɵtemplate(12, AuthenticationComponent_div_12_div_12_Template, 2, 0, "div", 9);
    ɵngcc0.ɵɵelementStart(13, "div");
    ɵngcc0.ɵɵelementStart(14, "button", 20);
    ɵngcc0.ɵɵtext(15, " Entrar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 21);
    ɵngcc0.ɵɵtemplate(17, AuthenticationComponent_div_12_a_17_Template, 2, 0, "a", 22);
    ɵngcc0.ɵɵtemplate(18, AuthenticationComponent_div_12_a_18_Template, 2, 0, "a", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 21);
    ɵngcc0.ɵɵelement(20, "input", 24);
    ɵngcc0.ɵɵelementStart(21, "label", 25);
    ɵngcc0.ɵɵtext(22, "Continuar conectado");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(23, AuthenticationComponent_div_12_div_23_Template, 6, 0, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.error);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.error ? "error user" : "user")("placeholder", ctx_r0.placeholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.error ? "error password" : "password");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", "USUARIO");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", "ELOTECH");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showCaptcha);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r0.isFormValid());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.authenticationService);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.authenticationService);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasX509Auth());
} }
function AuthenticationComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "access-recovery", 34);
    ɵngcc0.ɵɵlistener("onRecovery", function AuthenticationComponent_div_13_Template_access_recovery_onRecovery_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.accessRecovery($event); })("onBack", function AuthenticationComponent_div_13_Template_access_recovery_onBack_1_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.showLoginComponent(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r1.inputRecoveryPlaceholder)("form", ctx_r1.form);
} }
function AuthenticationComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "new-password", 35);
    ɵngcc0.ɵɵlistener("onSave", function AuthenticationComponent_div_14_Template_new_password_onSave_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.saveNewPassword($event); })("onBack", function AuthenticationComponent_div_14_Template_new_password_onBack_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.showLoginComponent(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("form", ctx_r2.form);
} }
function AuthenticationComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "recovery-message", 36);
    ɵngcc0.ɵɵlistener("onClick", function AuthenticationComponent_div_15_Template_recovery_message_onClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.recoveryOk($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("recovery", ctx_r3.recovery);
} }
function BlobPopupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "div", 5);
    ɵngcc0.ɵɵelement(3, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "h4");
    ɵngcc0.ɵɵtext(5, "Carregando...");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c30 = function (a1, a2) { return { "row block-content": true, "active": a1, "error": a2 }; };
function CrudButtonsOperationsComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function CrudButtonsOperationsComponent_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.delete(); });
    ɵngcc0.ɵɵtext(1, " Excluir ");
    ɵngcc0.ɵɵelementEnd();
} }
function CrudDetailInlineComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudDetailInlineComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "button", 10);
    ɵngcc0.ɵɵlistener("click", function CrudDetailInlineComponent_ng_container_0_div_2_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.add(); });
    ɵngcc0.ɵɵelement(4, "i", 11);
    ɵngcc0.ɵɵtext(5, " Adicionar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", !(ctx_r6.formGroupInsert == null ? null : ctx_r6.formGroupInsert.valid) || (ctx_r6.formGroupInsert == null ? null : ctx_r6.formGroupInsert.pristine));
} }
function CrudDetailInlineComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CrudDetailInlineComponent_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, CrudDetailInlineComponent_ng_container_0_div_2_Template, 6, 1, "div", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.insertTemplate)("ngTemplateOutletContext", ctx_r0.createContextInsert());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.insertTemplate);
} }
function CrudDetailInlineComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudDetailInlineComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelement(2, "label", 16);
    ɵngcc0.ɵɵelementStart(3, "button", 17);
    ɵngcc0.ɵɵlistener("click", function CrudDetailInlineComponent_div_1_div_2_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.add(); });
    ɵngcc0.ɵɵtext(4, " Adicionar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", !(ctx_r10.formGroupInsert == null ? null : ctx_r10.formGroupInsert.valid) || (ctx_r10.formGroupInsert == null ? null : ctx_r10.formGroupInsert.pristine));
} }
function CrudDetailInlineComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtemplate(1, CrudDetailInlineComponent_div_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, CrudDetailInlineComponent_div_1_div_2_Template, 5, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.insertTemplate)("ngTemplateOutletContext", ctx_r1.createContextInsert());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.insertTemplate);
} }
function CrudDetailInlineComponent_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudDetailInlineComponent_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 22);
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r14.footerTemplate);
} }
function CrudDetailInlineComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵelementStart(2, "div", 19);
    ɵngcc0.ɵɵtemplate(3, CrudDetailInlineComponent_ng_container_2_ng_container_3_Template, 1, 0, "ng-container", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, CrudDetailInlineComponent_ng_container_2_ng_container_4_Template, 1, 1, "ng-container", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.footerTemplate);
} }
function CrudDetailInlineComponent_ng_template_3_div_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 37);
    ɵngcc0.ɵɵlistener("click", function CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const i_r17 = ɵngcc0.ɵɵnextContext(2).index; const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.onDetails(i_r17); });
    ɵngcc0.ɵɵelement(1, "i", 38);
    ɵngcc0.ɵɵelementStart(2, "div", 39);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("title", ctx_r21.titleDetails);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r21.titleDetails, " ");
} }
function CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 40);
    ɵngcc0.ɵɵlistener("click", function CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r29); const item_r16 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.print(item_r16); });
    ɵngcc0.ɵɵelement(1, "i", 41);
    ɵngcc0.ɵɵelementStart(2, "div", 39);
    ɵngcc0.ɵɵtext(3, " Imprimir ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 42);
    ɵngcc0.ɵɵlistener("click", function CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r32); const i_r17 = ɵngcc0.ɵɵnextContext(2).index; const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.delete(i_r17); });
    ɵngcc0.ɵɵelement(1, "i", 43);
    ɵngcc0.ɵɵelementStart(2, "div", 39);
    ɵngcc0.ɵɵtext(3, " Excluir ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudDetailInlineComponent_ng_template_3_div_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵelementStart(1, "div", 33);
    ɵngcc0.ɵɵtemplate(2, CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_2_Template, 4, 2, "button", 34);
    ɵngcc0.ɵɵtemplate(3, CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_3_Template, 4, 0, "button", 35);
    ɵngcc0.ɵɵtemplate(4, CrudDetailInlineComponent_ng_template_3_div_6_div_3_button_4_Template, 4, 0, "button", 36);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.titleDetails && (ctx_r19.detailsVisibleWhenAttribute === "" || item_r16.get(ctx_r19.detailsVisibleWhenAttribute).value === true));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.getPrintVisibleWhenMultipleAttributes(item_r16));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.enableExcluir(item_r16));
} }
function CrudDetailInlineComponent_ng_template_3_div_6_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudDetailInlineComponent_ng_template_3_div_6_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 44);
    ɵngcc0.ɵɵtemplate(1, CrudDetailInlineComponent_ng_template_3_div_6_div_4_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = ɵngcc0.ɵɵnextContext();
    const i_r17 = ctx_r35.index;
    const item_r16 = ctx_r35.$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("has-form", ctx_r20.childHasForm);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r20.showChildTable[i_r17]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r20.detailTemplate)("ngTemplateOutletContext", ctx_r20.createContextDetail(item_r16, i_r17));
} }
function CrudDetailInlineComponent_ng_template_3_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵtemplate(2, CrudDetailInlineComponent_ng_template_3_div_6_ng_container_2_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(3, CrudDetailInlineComponent_ng_template_3_div_6_div_3_Template, 5, 3, "div", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, CrudDetailInlineComponent_ng_template_3_div_6_div_4_Template, 2, 5, "div", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const i_r17 = ctx.index;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    var tmp_2_0 = null;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("striped", i_r17 % 2)("reduced", ctx_r15.lineHighLight);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "", ctx_r15.arrayPropertyName, "_", (tmp_2_0 = item_r16.get("id")) == null ? null : tmp_2_0.value, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.listTemplate)("ngTemplateOutletContext", ctx_r15.createContextItem(item_r16, i_r17));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.titleDetails || ctx_r15.enableRemove);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.titleDetails);
} }
const _c31 = function (a0) { return { "max-height": a0 }; };
function CrudDetailInlineComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "div", 24);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 25);
    ɵngcc0.ɵɵelementStart(4, "div", 26);
    ɵngcc0.ɵɵelementStart(5, "div", 27);
    ɵngcc0.ɵɵtemplate(6, CrudDetailInlineComponent_ng_template_3_div_6_Template, 5, 10, "div", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    var tmp_2_0 = null;
    var tmp_7_0 = null;
    ɵngcc0.ɵɵclassProp("panel-table-outer", ctx_r4.footerTemplate)("fixed", ctx_r4.hasScroll);
    ɵngcc0.ɵɵproperty("hidden", (ctx_r4.form == null ? null : (tmp_2_0 = ctx_r4.form.get(ctx_r4.arrayPropertyName)) == null ? null : tmp_2_0.length) === 0)("ngClass", ctx_r4.class);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r4.hasScroll && ɵngcc0.ɵɵpureFunction1(10, _c31, ctx_r4.maxListLength));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r4.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formArrayName", ctx_r4.arrayPropertyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.form == null ? null : (tmp_7_0 = ctx_r4.form.get(ctx_r4.arrayPropertyName)) == null ? null : tmp_7_0.controls);
} }
function CrudFormComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelement(1, "button", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.isDisabled);
} }
function CrudFormComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "button", 7);
    ɵngcc0.ɵɵlistener("click", function CrudFormComponent_div_6_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.save(ctx_r2.form.getRawValue()); });
    ɵngcc0.ɵɵelement(2, "em", 8);
    ɵngcc0.ɵɵtext(3, "Adicionar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 9);
    ɵngcc0.ɵɵlistener("click", function CrudFormComponent_div_6_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.embeddedBack(); });
    ɵngcc0.ɵɵelement(5, "em", 10);
    ɵngcc0.ɵɵtext(6, "Cancelar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c32 = [[["", "inputs", ""]]];
const _c33 = ["[inputs]"];
const _c34 = ["eloColumns"];
function CrudFormDetailComponent_div_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function CrudFormDetailComponent_div_3_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.save(); });
    ɵngcc0.ɵɵelement(1, "em", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r5.form.valid || ctx_r5.form.pristine || ctx_r5.disableButtonSalvar);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.nameBtnSave, " ");
} }
function CrudFormDetailComponent_div_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "button", 14);
    ɵngcc0.ɵɵlistener("click", function CrudFormDetailComponent_div_3_ng_template_4_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.save(); });
    ɵngcc0.ɵɵelement(2, "em", 15);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r7.form.valid || ctx_r7.form.pristine || ctx_r7.disableButtonSalvar);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.nameBtnSave, " ");
} }
function CrudFormDetailComponent_div_3_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function CrudFormDetailComponent_div_3_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.cancel(); });
    ɵngcc0.ɵɵelement(1, "em", 18);
    ɵngcc0.ɵɵtext(2, " Cancelar ");
    ɵngcc0.ɵɵelementEnd();
} }
function CrudFormDetailComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵtemplate(3, CrudFormDetailComponent_div_3_button_3_Template, 3, 2, "button", 11);
    ɵngcc0.ɵɵtemplate(4, CrudFormDetailComponent_div_3_ng_template_4_Template, 4, 2, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(6, CrudFormDetailComponent_div_3_button_6_Template, 3, 0, "button", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(5);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.btnSaveHasFormGroup)("ngIfElse", _r6);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", (!ctx_r0.alwaysShowForm || ctx_r0.indexEdit !== null && ctx_r0.indexEdit >= 0) && ctx_r0.showButtonCancelar);
} }
function CrudFormDetailComponent_ng_container_7_elo_column_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "elo-column", 20);
} if (rf & 2) {
    const field_r16 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("field", field_r16.field)("header", field_r16.header)("hidden", field_r16.hidden)("isDecimal", field_r16.isDecimal)("digits", field_r16.digits)("isDate", field_r16.isDate);
} }
function CrudFormDetailComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CrudFormDetailComponent_ng_container_7_elo_column_1_Template, 1, 6, "elo-column", 19);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.fieldsToDisplay);
} }
const _c35 = function (a0, a1) { return { dataTable: a0, fieldsModels: a1 }; };
function CrudFormDetailComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 21);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.eloColumnsTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c35, ctx_r2.dataTable, ctx_r2.fieldsToDisplay));
} }
function CrudFormDetailComponent_elo_table_actions_11_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-table-actions", 22);
    ɵngcc0.ɵɵlistener("onClickIconButton", function CrudFormDetailComponent_elo_table_actions_11_Template_elo_table_actions_onClickIconButton_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onClickView($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", "Visualizar");
} }
function CrudFormDetailComponent_elo_table_actions_12_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-table-actions", 23);
    ɵngcc0.ɵɵlistener("onClickLink", function CrudFormDetailComponent_elo_table_actions_12_Template_elo_table_actions_onClickLink_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onClickLink($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("visibleWhenFunction", ctx_r4.visibleWhenFunctionLink)("linksFunction", ctx_r4.getLinks)("hasLinks", ctx_r4.hasLinks);
} }
const _c36 = [[["", "tableArea", ""]], [["", "actions", ""]], [["", "inputs", ""]]];
const _c37 = ["[tableArea]", "[actions]", "[inputs]"];
const _c38 = ["valorFiltro"];
const _c39 = ["filterHourValue"];
const _c40 = ["btnFiltro"];
const _c41 = ["inputFilter"];
function SearchFilterComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementContainer(1, 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.beforeExtraElement);
} }
function SearchFilterComponent_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", field_r12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", field_r12.caption, " ");
} }
function SearchFilterComponent_option_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", option_r13);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r13.caption, "");
} }
function SearchFilterComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "elo-datepicker", 22, 23);
    ɵngcc0.ɵɵelementStart(3, "div", 24);
    ɵngcc0.ɵɵelement(4, "input", 25, 26);
    ɵngcc0.ɵɵelement(6, "i", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SearchFilterComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "input", 28, 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("type", ctx_r5.filterType);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r5.placeHolder);
} }
function SearchFilterComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "elo-datepicker", 22, 23);
    ɵngcc0.ɵɵelementEnd();
} }
function SearchFilterComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 24);
    ɵngcc0.ɵɵelement(2, "input", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SearchFilterComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "elo-select", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r8.enumOptions);
} }
function SearchFilterComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "elo-select", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r9.booleanOptions);
} }
function SearchFilterComponent_div_27_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 33);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "i", 34);
    ɵngcc0.ɵɵlistener("click", function SearchFilterComponent_div_27_span_1_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r21); const filterItem_r19 = ctx.$implicit; const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.removeFilter(filterItem_r19); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const filterItem_r19 = ctx.$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3("", filterItem_r19.field.caption, " ", filterItem_r19.operator.caption, " ", ctx_r18.getSearchTagValue(filterItem_r19), "");
} }
function SearchFilterComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵtemplate(1, SearchFilterComponent_div_27_span_1_Template, 3, 3, "span", 32);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.getValidFilter());
} }
const _c42 = function (a0) { return { "has-input-datetime": a0 }; };
function CrudSearchComponent_search_filter_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "search-filter", 19);
    ɵngcc0.ɵɵlistener("onFilter", function CrudSearchComponent_search_filter_5_Template_search_filter_onFilter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onFilter($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("filtersDefaults", ctx_r0.filtersDefaults)("fieldsModels", ctx_r0.fieldsModelsFilter)("defaultField", ctx_r0.defaultField)("beforeExtraElement", ctx_r0.beforeExtraElement)("allowSearch", ctx_r0.allowSearch)("classInput", ctx_r0.classInputFilter);
} }
function CrudSearchComponent_div_7_elo_column_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "elo-column", 21);
} if (rf & 2) {
    const field_r18 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("enumOptions", field_r18.enumOptions)("field", field_r18.isCalculatedModel ? field_r18.fieldName : field_r18.fieldPath)("header", field_r18.caption)("isDate", field_r18.dataType === "LocalDate")("isDateTime", field_r18.dataType === "LocalDateTime");
} }
function CrudSearchComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CrudSearchComponent_div_7_elo_column_1_Template, 1, 5, "elo-column", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.fieldsModels);
} }
function CrudSearchComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 22);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.eloColumnsTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c35, ctx_r2.dataTable, ctx_r2.fieldsModels));
} }
function CrudSearchComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 23);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.dataTableFooterDynamic);
} }
function CrudSearchComponent_elo_header_actions_11_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-header-actions", 24);
    ɵngcc0.ɵɵlistener("onClickIconButton", function CrudSearchComponent_elo_header_actions_11_Template_elo_header_actions_onClickIconButton_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onRemoveAllClicked($event); });
    ɵngcc0.ɵɵelementEnd();
} }
function CrudSearchComponent_elo_header_actions_12_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-header-actions", 25);
    ɵngcc0.ɵɵlistener("onClickIconButton", function CrudSearchComponent_elo_header_actions_12_Template_elo_header_actions_onClickIconButton_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onPrint(); });
    ɵngcc0.ɵɵelementEnd();
} }
function CrudSearchComponent_elo_header_actions_13_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-header-actions", 26);
    ɵngcc0.ɵɵlistener("onClickIconButton", function CrudSearchComponent_elo_header_actions_13_Template_elo_header_actions_onClickIconButton_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.viewLogs(); });
    ɵngcc0.ɵɵelementEnd();
} }
function CrudSearchComponent_elo_table_actions_14_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-table-actions", 27);
    ɵngcc0.ɵɵlistener("onClickIconButton", function CrudSearchComponent_elo_table_actions_14_Template_elo_table_actions_onClickIconButton_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.edit($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", "Editar")("visibleWhenAttribute", ctx_r8.visibleWhenAttribute)("visibleWhenFunction", ctx_r8.visibleWhenFunction);
} }
function CrudSearchComponent_elo_table_actions_15_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-table-actions", 28);
    ɵngcc0.ɵɵlistener("onClickIconButton", function CrudSearchComponent_elo_table_actions_15_Template_elo_table_actions_onClickIconButton_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.onSelected($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", "Adicionar");
} }
function CrudSearchComponent_elo_table_actions_16_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-table-actions", 29);
    ɵngcc0.ɵɵlistener("onClickIconButton", function CrudSearchComponent_elo_table_actions_16_Template_elo_table_actions_onClickIconButton_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.onDelete($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", "Remover")("visibleWhenAttribute", ctx_r10.visibleWhenAttribute)("removeAutoFocus", true)("visibleWhenFunction", ctx_r10.visibleWhenFunction);
} }
function CrudSearchComponent_elo_table_actions_17_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-table-actions", 30);
    ɵngcc0.ɵɵlistener("onClickLink", function CrudSearchComponent_elo_table_actions_17_Template_elo_table_actions_onClickLink_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.onClickLink($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("visibleWhenFunction", ctx_r11.visibleWhenFunctionLink)("linksFunction", ctx_r11.getLinks)("hasLinks", ctx_r11.hasLinks);
} }
function CrudSearchComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudSearchComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "button", 32);
    ɵngcc0.ɵɵlistener("click", function CrudSearchComponent_div_22_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.new(); });
    ɵngcc0.ɵɵelementStart(2, "div", 33);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.titleNewButton, " ");
} }
function PaginationComponent_div_2_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1, "Todos");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("ngValue", 9999);
} }
function PaginationComponent_div_2_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", c_r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(c_r5);
} }
function PaginationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2, " Mostrar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function PaginationComponent_div_2_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onChangePageSize($event); });
    ɵngcc0.ɵɵtemplate(4, PaginationComponent_div_2_option_4_Template, 2, 1, "option", 7);
    ɵngcc0.ɵɵtemplate(5, PaginationComponent_div_2_option_5_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "b");
    ɵngcc0.ɵɵtext(7, " Itens ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.pageSize);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.allowShowAllItens);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.pageSizes);
} }
function PaginationComponent_ul_4_li_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 18);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_ul_4_li_8_Template_li_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const p_r9 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.onChangePageNumber(p_r9, $event); });
    ɵngcc0.ɵɵelementStart(1, "a", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("active", p_r9 === ctx_r8.currentPage);
    ɵngcc0.ɵɵproperty("value", p_r9);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(p_r9);
} }
function PaginationComponent_ul_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 10);
    ɵngcc0.ɵɵelementStart(1, "li", 11);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_ul_4_Template_li_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.first($event); });
    ɵngcc0.ɵɵelementStart(2, "a", 12);
    ɵngcc0.ɵɵelement(3, "span", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "li", 11);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_ul_4_Template_li_click_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.previous($event); });
    ɵngcc0.ɵɵelementStart(5, "a", 12);
    ɵngcc0.ɵɵelementStart(6, "span", 14);
    ɵngcc0.ɵɵtext(7, "\u00AB");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, PaginationComponent_ul_4_li_8_Template, 3, 4, "li", 15);
    ɵngcc0.ɵɵelementStart(9, "li", 11);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_ul_4_Template_li_click_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.next($event); });
    ɵngcc0.ɵɵelementStart(10, "a", 16);
    ɵngcc0.ɵɵelementStart(11, "span", 14);
    ɵngcc0.ɵɵtext(12, "\u00BB");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "li", 11);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_ul_4_Template_li_click_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.last($event); });
    ɵngcc0.ɵɵelementStart(14, "a", 12);
    ɵngcc0.ɵɵelement(15, "span", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.pageNumbers);
} }
function PaginationComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 20);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function EloSelectComponent_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    ɵngcc0.ɵɵproperty("value", i_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(option_r1 == null ? null : option_r1.label);
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c43 = function (a0, a1) { return { $implicit: a0, prefix: a1 }; };
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    const item_r7 = ctx_r15.$implicit;
    const i_r8 = ctx_r15.index;
    const prefix_r5 = ɵngcc0.ɵɵnextContext().prefix;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(5);
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c43, ctx_r12.getControls(item_r7.get(ctx_r12.arrayPropertyNameChild)), prefix_r5 + i_r8 + "." + ctx_r12.arrayPropertyNameChild + "."));
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_container_1_ng_container_1_Template, 2, 5, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(2, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext();
    const item_r7 = ctx_r17.$implicit;
    const i_r8 = ctx_r17.index;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    var tmp_0_0 = null;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (tmp_0_0 = ctx_r9.getControls(item_r7.get(ctx_r9.arrayPropertyNameChild))) == null ? null : tmp_0_0.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.itemTemplate)("ngTemplateOutletContext", ctx_r9.createContextItem(item_r7, i_r8));
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_template_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_template_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    const item_r7 = ctx_r21.$implicit;
    const i_r8 = ctx_r21.index;
    const prefix_r5 = ɵngcc0.ɵɵnextContext().prefix;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(5);
    const ctx_r19 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c43, ctx_r19.getControls(item_r7.get(ctx_r19.arrayPropertyNameChild)), prefix_r5 + i_r8 + "." + ctx_r19.arrayPropertyNameChild + "."));
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(1, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_template_2_ng_container_1_Template, 2, 5, "ng-container", 9);
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    const item_r7 = ctx_r23.$implicit;
    const i_r8 = ctx_r23.index;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    var tmp_2_0 = null;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r11.itemTemplate)("ngTemplateOutletContext", ctx_r11.createContextItem(item_r7, i_r8));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (tmp_2_0 = ctx_r11.getControls(item_r7.get(ctx_r11.arrayPropertyNameChild))) == null ? null : tmp_2_0.length);
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_container_1_Template, 3, 3, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(2, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_ng_template_2_Template, 2, 3, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r10 = ɵngcc0.ɵɵreference(3);
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.isReverse)("ngIfElse", _r10);
} }
function CrudOnePageEditableComponent_div_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CrudOnePageEditableComponent_div_0_ng_template_4_ng_container_0_Template, 4, 2, "ng-container", 6);
} if (rf & 2) {
    const controls_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngForOf", controls_r4);
} }
function CrudOnePageEditableComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudOnePageEditableComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵtemplate(4, CrudOnePageEditableComponent_div_0_ng_template_4_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(6, CrudOnePageEditableComponent_div_0_ng_container_6_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r1 = ɵngcc0.ɵɵreference(5);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c43, ctx_r0.getControls(ctx_r0.form == null ? null : ctx_r0.form.get(ctx_r0.arrayPropertyName)), ctx_r0.arrayPropertyNameChild + "."));
} }
function CrudSearchLogComponent_ng_template_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const object_r19 = ctx.object;
    ɵngcc0.ɵɵtextInterpolate2(" ", object_r19 == null ? null : object_r19.object == null ? null : object_r19.object.revisionNumber, "/", object_r19.id, " ");
} }
function CrudSearchLogComponent_ng_template_1_ng_template_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "p", 13);
    ɵngcc0.ɵɵtext(2, "Adi\u00E7\u00E3o");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudSearchLogComponent_ng_template_1_ng_template_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "p", 13);
    ɵngcc0.ɵɵtext(2, "Edi\u00E7\u00E3o");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudSearchLogComponent_ng_template_1_ng_template_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "p", 13);
    ɵngcc0.ɵɵtext(2, "Remo\u00E7\u00E3o");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudSearchLogComponent_ng_template_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, CrudSearchLogComponent_ng_template_1_ng_template_4_div_1_Template, 3, 0, "div", 9);
    ɵngcc0.ɵɵtemplate(2, CrudSearchLogComponent_ng_template_1_ng_template_4_div_2_Template, 3, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, CrudSearchLogComponent_ng_template_1_ng_template_4_div_3_Template, 3, 0, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r20 = ctx.object;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", object_r20.revType === "ADD");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", object_r20.revType === "MOD");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", object_r20.revType === "DEL");
} }
function CrudSearchLogComponent_ng_template_1_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "date");
} if (rf & 2) {
    const object_r24 = ctx.object;
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(1, 1, object_r24 == null ? null : object_r24.object == null ? null : object_r24.object.revisionDate, "dd/MM/yyyy HH:mm"), " ");
} }
function CrudSearchLogComponent_ng_template_1_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const object_r25 = ctx.object;
    ɵngcc0.ɵɵtextInterpolate(object_r25 == null ? null : object_r25.object == null ? null : object_r25.object.userName);
} }
function CrudSearchLogComponent_ng_template_1_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const object_r26 = ctx.object;
    ɵngcc0.ɵɵtextInterpolate(object_r26 == null ? null : object_r26.object == null ? null : object_r26.object.remoteIpAddress);
} }
function CrudSearchLogComponent_ng_template_1_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const object_r27 = ctx.object;
    ɵngcc0.ɵɵtextInterpolate(object_r27 == null ? null : object_r27.object == null ? null : object_r27.object.activeView);
} }
function CrudSearchLogComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "elo-column", 5);
    ɵngcc0.ɵɵtemplate(1, CrudSearchLogComponent_ng_template_1_ng_template_1_Template, 1, 2, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "elo-column", 5);
    ɵngcc0.ɵɵtemplate(4, CrudSearchLogComponent_ng_template_1_ng_template_4_Template, 4, 3, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "elo-column", 7);
    ɵngcc0.ɵɵtemplate(7, CrudSearchLogComponent_ng_template_1_ng_template_7_Template, 2, 4, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "elo-column", 7);
    ɵngcc0.ɵɵtemplate(10, CrudSearchLogComponent_ng_template_1_ng_template_10_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "elo-column", 5);
    ɵngcc0.ɵɵtemplate(13, CrudSearchLogComponent_ng_template_1_ng_template_13_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "elo-column", 5);
    ɵngcc0.ɵɵtemplate(16, CrudSearchLogComponent_ng_template_1_ng_template_16_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataTable_r6 = ctx.dataTable;
    ɵngcc0.ɵɵproperty("field", "revisionNumber")("header", "Revis\u00E3o / C\u00F3digo")("dataTable", dataTable_r6);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("field", "revType")("header", "Tipo Movimento")("dataTable", dataTable_r6);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("field", "revisionDate")("header", "Data")("dataTable", dataTable_r6)("isDateTime", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("field", "userName")("header", "Usu\u00E1rio")("dataTable", dataTable_r6)("isDateTime", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("field", "remoteIpAddress")("header", "Ip")("dataTable", dataTable_r6);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("field", "activeView")("header", "Tela")("dataTable", dataTable_r6);
} }
function CrudSearchLogComponent_ng_template_4_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "div", 24);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 24);
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 24);
    ɵngcc0.ɵɵelementStart(8, "span");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const compare_r32 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", compare_r32 == null ? null : compare_r32.path, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", compare_r32 == null ? null : compare_r32.before, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", compare_r32 == null ? null : compare_r32.after, " ");
} }
function CrudSearchLogComponent_ng_template_4_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵtemplate(1, CrudSearchLogComponent_ng_template_4_div_13_div_1_Template, 10, 3, "div", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r28 = ɵngcc0.ɵɵnextContext().object;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", object_r28 == null ? null : object_r28.comparisonsUser);
} }
function CrudSearchLogComponent_ng_template_4_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "div", 24);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 24);
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 24);
    ɵngcc0.ɵɵelementStart(8, "span");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const compare_r35 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", compare_r35 == null ? null : compare_r35.path, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", compare_r35 == null ? null : compare_r35.before, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", compare_r35 == null ? null : compare_r35.after, " ");
} }
function CrudSearchLogComponent_ng_template_4_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵtemplate(1, CrudSearchLogComponent_ng_template_4_div_14_div_1_Template, 10, 3, "div", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r28 = ɵngcc0.ɵɵnextContext().object;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", object_r28 == null ? null : object_r28.comparisonsDev);
} }
function CrudSearchLogComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "elo-panel");
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 17);
    ɵngcc0.ɵɵelementStart(3, "div", 18);
    ɵngcc0.ɵɵelementStart(4, "div", 19);
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtext(6, " Campo ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 20);
    ɵngcc0.ɵɵelementStart(8, "span");
    ɵngcc0.ɵɵtext(9, " Valor Anterior ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 20);
    ɵngcc0.ɵɵelementStart(11, "span");
    ɵngcc0.ɵɵtext(12, " Valor Atual ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, CrudSearchLogComponent_ng_template_4_div_13_Template, 2, 1, "div", 21);
    ɵngcc0.ɵɵtemplate(14, CrudSearchLogComponent_ng_template_4_div_14_Template, 2, 1, "div", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.visao === "user");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.visao === "dev");
} }
function CrudSearchLogComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "div", 26);
    ɵngcc0.ɵɵelementStart(3, "elo-switch-button", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function CrudSearchLogComponent_ng_template_6_Template_elo_switch_button_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r37 = ɵngcc0.ɵɵnextContext(); return ctx_r37.visao = $event; });
    ɵngcc0.ɵɵelement(4, "elo-switch-button-item", 28);
    ɵngcc0.ɵɵelement(5, "elo-switch-button-item", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.visao);
} }
function TableReportComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("small", ctx_r0.small);
} }
function TableReportGroupItensComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const header_r1 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate2("col-md-", header_r1.column, " ", header_r1.columnSize, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", header_r1.name, " ");
} }
function TableReportItemComponent_div_3_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "decimalformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const val_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, val_r1.value, "1.2-2"));
} }
function TableReportItemComponent_div_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const val_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(val_r1.value);
} }
function TableReportItemComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, TableReportItemComponent_div_3_p_1_Template, 3, 4, "p", 5);
    ɵngcc0.ɵɵtemplate(2, TableReportItemComponent_div_3_ng_template_2_Template, 2, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const val_r1 = ctx.$implicit;
    const _r3 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵclassMapInterpolate2("col-md-", val_r1.column, " group-column ", val_r1.columnSize, "");
    ɵngcc0.ɵɵproperty("ngClass", val_r1.blurValue ? "blur-value" : "")("ngClass", val_r1.dataHeader === "Data" ? "group-date" : "");
    ɵngcc0.ɵɵattribute("data-header", val_r1.dataHeader);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", val_r1.isDecimal)("ngIfElse", _r3);
} }
function TableReportTotalComponent_div_4_b_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "b");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "decimalformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const total_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, total_r1.value, "1.2-2"));
} }
function TableReportTotalComponent_div_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "b");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const total_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(total_r1.value);
} }
function TableReportTotalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, TableReportTotalComponent_div_4_b_1_Template, 3, 4, "b", 4);
    ɵngcc0.ɵɵtemplate(2, TableReportTotalComponent_div_4_ng_template_2_Template, 2, 1, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const total_r1 = ctx.$implicit;
    const _r3 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵclassMap(total_r1.columnSize);
    ɵngcc0.ɵɵattribute("data-header", total_r1.dataHeader);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", total_r1.isDecimal)("ngIfElse", _r3);
} }
function SwitchButtonComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 2);
    ɵngcc0.ɵɵlistener("click", function SwitchButtonComponent_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const button_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selectButton(button_r1); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r1 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("active", button_r1.selected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", button_r1.title, " ");
} }
function CrudTreeComponent_elo_accordion_item_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelement(2, "em", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "article");
    ɵngcc0.ɵɵelementStart(4, "p");
    ɵngcc0.ɵɵtext(5, "N\u00E3o existem itens cadastrados neste n\u00EDvel.");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const object_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" - ", object_r6[ctx_r7.otherField.field][ctx_r7.otherField.children], " ");
} }
function CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_button_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵelement(1, "i", 19);
    ɵngcc0.ɵɵelementStart(2, "div", 20);
    ɵngcc0.ɵɵtext(3, " Entrar N\u00EDvel ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21);
    ɵngcc0.ɵɵlistener("click", function CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_button_6_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const object_r6 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ctx_r12.edit($event, object_r6); });
    ɵngcc0.ɵɵelement(1, "i", 22);
    ɵngcc0.ɵɵelementStart(2, "div", 20);
    ɵngcc0.ɵɵtext(3, " Editar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("click", function CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_button_7_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const object_r6 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.onClickRemove($event, object_r6); });
    ɵngcc0.ɵɵelement(1, "i", 24);
    ɵngcc0.ɵɵelementStart(2, "div", 20);
    ɵngcc0.ɵɵtext(3, " Remover ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵlistener("click", function CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const object_r6 = ctx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.choice(object_r6); });
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_ng_container_3_Template, 2, 1, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 14);
    ɵngcc0.ɵɵtemplate(5, CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_button_5_Template, 4, 0, "button", 15);
    ɵngcc0.ɵɵtemplate(6, CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_button_6_Template, 4, 0, "button", 16);
    ɵngcc0.ɵɵtemplate(7, CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_button_7_Template, 4, 0, "button", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r6 = ctx.$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", object_r6.codigo, " - ", object_r6.descricao, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.otherField && object_r6[ctx_r5.otherField.field] && object_r6[ctx_r5.otherField.field][ctx_r5.otherField.children]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.reachedMaxLevel());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.permissionEdit);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.permissionRemove);
} }
function CrudTreeComponent_elo_accordion_item_1_ul_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 9);
    ɵngcc0.ɵɵtemplate(1, CrudTreeComponent_elo_accordion_item_1_ul_3_li_1_Template, 8, 6, "li", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.children);
} }
function CrudTreeComponent_elo_accordion_item_1_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CrudTreeComponent_elo_accordion_item_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtemplate(1, CrudTreeComponent_elo_accordion_item_1_div_4_ng_container_1_Template, 1, 0, "ng-container", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.crudTemplateRef)("ngTemplateOutletContext", ctx_r4.ctx);
} }
const _c44 = function (a0, a1) { return { "checked": a0, "done": a1 }; };
function CrudTreeComponent_elo_accordion_item_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-accordion-item", 1);
    ɵngcc0.ɵɵlistener("addButtons", function CrudTreeComponent_elo_accordion_item_1_Template_elo_accordion_item_addButtons_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onAddButton(); })("onChangeGroupSelected", function CrudTreeComponent_elo_accordion_item_1_Template_elo_accordion_item_onChangeGroupSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onChangeGroup($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, CrudTreeComponent_elo_accordion_item_1_div_2_Template, 6, 0, "div", 3);
    ɵngcc0.ɵɵtemplate(3, CrudTreeComponent_elo_accordion_item_1_ul_3_Template, 2, 1, "ul", 4);
    ɵngcc0.ɵɵtemplate(4, CrudTreeComponent_elo_accordion_item_1_div_4_Template, 2, 2, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c44, group_r1.isChecked, group_r1.itemSelected))("obj", group_r1)("hasPermission", ctx_r0.permissionCreate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.children.length === 0 && !ctx_r0.isEditing && group_r1.isChecked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isEditing && ctx_r0.children.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isEditing);
} }
function DetailInformationComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "elo-item-detail-information", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", item_r1);
} }
function EnviarEmailComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵelement(3, "input", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 14);
    ɵngcc0.ɵɵelementStart(5, "button", 15);
    ɵngcc0.ɵɵlistener("click", function EnviarEmailComponent_div_5_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r4); const i_r2 = ctx.index; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.removerItem(i_r2); });
    ɵngcc0.ɵɵelement(6, "i", 16);
    ɵngcc0.ɵɵtext(7, " Remover ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroupName", i_r2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "email_", i_r2, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "btnRemover_", i_r2, "");
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.getEmails().controls.length === 1);
} }
function LeisAtosAutoCompleteModalComponent_ng_container_0_elo_modal_3_ng_template_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const object_r7 = ctx.object;
    ɵngcc0.ɵɵtextInterpolate2(" ", object_r7.numero, "/", object_r7.exercicio, " ");
} }
function LeisAtosAutoCompleteModalComponent_ng_container_0_elo_modal_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "elo-column", 9);
    ɵngcc0.ɵɵelementStart(1, "elo-column", 10);
    ɵngcc0.ɵɵtemplate(2, LeisAtosAutoCompleteModalComponent_ng_container_0_elo_modal_3_ng_template_3_ng_template_2_Template, 1, 2, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "elo-column", 12);
    ɵngcc0.ɵɵelement(5, "elo-column", 13);
    ɵngcc0.ɵɵelement(6, "elo-column", 14);
} if (rf & 2) {
    const dataTable_r4 = ctx.dataTable;
    ɵngcc0.ɵɵproperty("dataTable", dataTable_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("dataTable", dataTable_r4);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("dataTable", dataTable_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("dataTable", dataTable_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("dataTable", dataTable_r4);
} }
function LeisAtosAutoCompleteModalComponent_ng_container_0_elo_modal_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-modal", 5);
    ɵngcc0.ɵɵlistener("openClose", function LeisAtosAutoCompleteModalComponent_ng_container_0_elo_modal_3_Template_elo_modal_openClose_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.openModal(); });
    ɵngcc0.ɵɵelementStart(1, "elo-panel", 6);
    ɵngcc0.ɵɵelementStart(2, "crud-search", 7);
    ɵngcc0.ɵɵlistener("eventSelected", function LeisAtosAutoCompleteModalComponent_ng_container_0_elo_modal_3_Template_crud_search_eventSelected_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.selecionarLeisAtos($event); });
    ɵngcc0.ɵɵtemplate(3, LeisAtosAutoCompleteModalComponent_ng_container_0_elo_modal_3_ng_template_3_Template, 7, 5, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("isOpen", ctx_r1.isActiveModal);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", "Pesquisa de Leis/Atos");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("fieldsToFilter", ctx_r1.fieldsToFilter)("fieldsToDisplay", ctx_r1.fieldsToDisplay)("entityService", ctx_r1.service)("enableCreate", false)("searchSelect", true)("enableRemove", true)("changeLocationOnFilter", false)("orderBy", "id,asc")("filterDefault", ctx_r1.filterDefault);
} }
function LeisAtosAutoCompleteModalComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0, 1);
    ɵngcc0.ɵɵelementStart(1, "elo-form-label-column", 2);
    ɵngcc0.ɵɵelementStart(2, "elo-autocomplete", 3);
    ɵngcc0.ɵɵlistener("onSearchModal", function LeisAtosAutoCompleteModalComponent_ng_container_0_Template_elo_autocomplete_onSearchModal_2_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.openModal(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, LeisAtosAutoCompleteModalComponent_ng_container_0_elo_modal_3_Template, 5, 11, "elo-modal", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("label", ctx_r0.label)("column", ctx_r0.column)("hintMessage", ctx_r0.hintMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("service", ctx_r0.service)("formControlName", ctx_r0.controlName)("searchModal", true)("isDisabled", ctx_r0.isDisabled)("findToOptions", ctx_r0.findToOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isActiveModal);
} }
const _c45 = function (a0) { return { "width": a0 }; };
function ConfiguracaoEntidadeKeycloakComponent_p_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 21);
    ɵngcc0.ɵɵtext(1, " Data opera\u00E7\u00E3o diferente do dia atual. ");
    ɵngcc0.ɵɵelementEnd();
} }
function ConfiguracaoEntidadeKeycloakComponent_a_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 22);
    ɵngcc0.ɵɵlistener("click", function ConfiguracaoEntidadeKeycloakComponent_a_9_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.resetToCurrentDateOperacaoField(); });
    ɵngcc0.ɵɵtext(1, " Clique para voltar a data atual. ");
    ɵngcc0.ɵɵelementEnd();
} }
function ConfiguracaoEntidadeKeycloakComponent_option_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 23);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entidade_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", entidade_r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", entidade_r8.nome, "");
} }
function ConfiguracaoEntidadeKeycloakComponent_option_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const exercicio_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", exercicio_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", exercicio_r9.exercicio, "");
} }
function ConfiguracaoEntidadeKeycloakComponent_option_40_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "monthname");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const competencia_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", competencia_r10)("disabled", competencia_r10.situacaoDescricao === "Bloqueado");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(2, 4, competencia_r10.mes), " - ", competencia_r10.situacaoDescricao, "");
} }
function ConfiguracaoEntidadeKeycloakComponent_ng_container_42_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "label", 26);
    ɵngcc0.ɵɵtext(3, " Data Opera\u00E7\u00E3o");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "elo-datepicker", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function ConfiguracaoEntidadeKeycloakComponent_ng_container_42_Template_elo_datepicker_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.dataOperacao = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.dataOperacao)("required", !ctx_r5.dataOperacao);
} }
function FeatureConfiguracaoEntidadeComponent_div_5_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entidade_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", entidade_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(entidade_r4.nome);
} }
function FeatureConfiguracaoEntidadeComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "label", 9);
    ɵngcc0.ɵɵtext(2, "Entidade");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 10);
    ɵngcc0.ɵɵlistener("change", function FeatureConfiguracaoEntidadeComponent_div_5_Template_select_change_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.changeEntidade($event.target.selectedIndex); })("ngModelChange", function FeatureConfiguracaoEntidadeComponent_div_5_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.entidade = $event; });
    ɵngcc0.ɵɵtemplate(4, FeatureConfiguracaoEntidadeComponent_div_5_option_4_Template, 2, 2, "option", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.entidade)("compareWith", ctx_r0.comparing());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.configuracaoEntidade.entidades);
} }
function FeatureConfiguracaoEntidadeComponent_div_6_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const exercicio_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", exercicio_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(exercicio_r9.exercicio);
} }
function FeatureConfiguracaoEntidadeComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "label", 13);
    ɵngcc0.ɵɵtext(2, "Exerc\u00EDcio");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 14);
    ɵngcc0.ɵɵlistener("change", function FeatureConfiguracaoEntidadeComponent_div_6_Template_select_change_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.changeExercicio($event.target.selectedIndex); })("ngModelChange", function FeatureConfiguracaoEntidadeComponent_div_6_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.exercicio = $event; });
    ɵngcc0.ɵɵtemplate(4, FeatureConfiguracaoEntidadeComponent_div_6_option_4_Template, 2, 2, "option", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.exercicio)("compareWith", ctx_r1.comparingByExercicio());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.configuracaoEntidade.exercicios);
} }
function FeatureConfiguracaoEntidadeComponent_div_7_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "monthname");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const competencia_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", competencia_r14)("disabled", competencia_r14.situacaoDescricao === "Bloqueado");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(2, 4, competencia_r14.mes), " - ", competencia_r14.situacaoDescricao, "");
} }
function FeatureConfiguracaoEntidadeComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "label", 17);
    ɵngcc0.ɵɵtext(2, "Compet\u00EAncia");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function FeatureConfiguracaoEntidadeComponent_div_7_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.competencia = $event; });
    ɵngcc0.ɵɵtemplate(4, FeatureConfiguracaoEntidadeComponent_div_7_option_4_Template, 3, 6, "option", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.competencia)("compareWith", ctx_r2.comparingByMes());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.configuracaoEntidade.competencias);
} }
function FeatureContribuinteComponent_aside_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "aside", 1);
    ɵngcc0.ɵɵelementStart(1, "h2", 2);
    ɵngcc0.ɵɵelement(2, "i", 3);
    ɵngcc0.ɵɵtext(3, "Contribuinte ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "label", 8);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "span");
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 5);
    ɵngcc0.ɵɵelementStart(13, "div", 6);
    ɵngcc0.ɵɵelementStart(14, "div", 7);
    ɵngcc0.ɵɵelementStart(15, "label", 8);
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "span");
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 5);
    ɵngcc0.ɵɵelementStart(20, "div", 6);
    ɵngcc0.ɵɵelementStart(21, "div", 7);
    ɵngcc0.ɵɵelementStart(22, "label", 8);
    ɵngcc0.ɵɵtext(23, "Inscri\u00E7\u00E3o Municipal");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "span");
    ɵngcc0.ɵɵtext(25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "div", 5);
    ɵngcc0.ɵɵelementStart(27, "div", 6);
    ɵngcc0.ɵɵelementStart(28, "div", 7);
    ɵngcc0.ɵɵelementStart(29, "label", 8);
    ɵngcc0.ɵɵtext(30, "Cidade");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "span");
    ɵngcc0.ɵɵtext(32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "div", 5);
    ɵngcc0.ɵɵelementStart(34, "div", 6);
    ɵngcc0.ɵɵelementStart(35, "div", 7);
    ɵngcc0.ɵɵelementStart(36, "label", 8);
    ɵngcc0.ɵɵtext(37, "Regime Fiscal");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(38, "span");
    ɵngcc0.ɵɵtext(39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(40, "div", 5);
    ɵngcc0.ɵɵelementStart(41, "div", 6);
    ɵngcc0.ɵɵelementStart(42, "div", 7);
    ɵngcc0.ɵɵelementStart(43, "button", 9);
    ɵngcc0.ɵɵlistener("click", function FeatureContribuinteComponent_aside_0_Template_button_click_43_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.alterarContribuinte(); });
    ɵngcc0.ɵɵelement(44, "i", 10);
    ɵngcc0.ɵɵtext(45, " Alterar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r0.toggled);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵtextInterpolate((ctx_r0.contribuinte.cnpjCpf == null ? null : ctx_r0.contribuinte.cnpjCpf.length) > 14 ? "Raz\u00E3o Social" : "Nome");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.contribuinte.razaoSocialNome);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate((ctx_r0.contribuinte.cnpjCpf == null ? null : ctx_r0.contribuinte.cnpjCpf.length) > 14 ? "CNPJ" : "CPF");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.contribuinte.cnpjCpf);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.contribuinte.cadastro);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.contribuinte.cidade);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.contribuinte.regimeFiscal);
} }
const _c46 = ["contentRef"];
function FeatureModulesComponent_ul_8_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵelementStart(1, "a", 12);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const modulo_r4 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r3.buildModuloUrl(modulo_r4 == null ? null : modulo_r4.uri), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(modulo_r4 == null ? null : modulo_r4.descricao);
} }
function FeatureModulesComponent_ul_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 7);
    ɵngcc0.ɵɵlistener("click", function FeatureModulesComponent_ul_8_Template_ul_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const area_r2 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.hideModules(area_r2); });
    ɵngcc0.ɵɵelementStart(1, "li", 8);
    ɵngcc0.ɵɵelementStart(2, "a");
    ɵngcc0.ɵɵelement(3, "img", 9);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, FeatureModulesComponent_ul_8_li_6_Template, 4, 2, "li", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const area_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("open", area_r2.open);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.getImage(area_r2 == null ? null : area_r2.area), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(area_r2 == null ? null : area_r2.descricaoArea);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.showListModules(area_r2.area));
} }
function FeatureSobreSistemaComponent_article_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "article", 22);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Total de Acessos");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "p");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.totalAcessos ? ctx_r0.totalAcessos : "Carregando...");
} }
function FeatureSobreSistemaComponent_li_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 23);
    ɵngcc0.ɵɵelementStart(1, "a", 24);
    ɵngcc0.ɵɵelement(2, "i", 25);
    ɵngcc0.ɵɵtext(3, "Confira as novidades da vers\u00E3o");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r1.urlNovidades, ɵngcc0.ɵɵsanitizeUrl);
} }
function FeatureUserComponent_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 10);
    ɵngcc0.ɵɵtext(1, "Minha Conta");
    ɵngcc0.ɵɵelementEnd();
} }
function FeatureUserComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵlistener("click", function FeatureUserComponent_li_5_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.callTour(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 11);
    ɵngcc0.ɵɵelement(2, "path", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(3, "article", 13);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Fazer o tour novamente.");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function FeatureUserComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵlistener("click", function FeatureUserComponent_li_6_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.goMinhaConta(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 14);
    ɵngcc0.ɵɵelement(2, "path", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(3, "article", 16);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Usu\u00E1rio");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.usuario == null ? null : ctx_r2.usuario.nome);
} }
function FeatureUserComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵelementStart(1, "li");
    ɵngcc0.ɵɵelement(2, "i", 18);
    ɵngcc0.ɵɵtext(3, " Login ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function FeatureUserComponent_li_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 10);
    ɵngcc0.ɵɵtext(1, " Par\u00E2metros ");
    ɵngcc0.ɵɵelementEnd();
} }
function FeatureUserComponent_li_9_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 19);
    ɵngcc0.ɵɵlistener("click", function FeatureUserComponent_li_9_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onChangeEntidade(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 20);
    ɵngcc0.ɵɵelement(2, "path", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(3, "article", 22);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Entidade");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r5.entidadePadrao);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r5.entidadePadrao, " ");
} }
function FeatureUserComponent_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵlistener("click", function FeatureUserComponent_li_10_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onChangeEntidade(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 23);
    ɵngcc0.ɵɵelement(2, "path", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(3, "article", 22);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Compet\u00EAncia");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r6.competenciaExercicioPadrao, " ");
} }
function FeatureUserComponent_li_14_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 25);
    ɵngcc0.ɵɵlistener("click", function FeatureUserComponent_li_14_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onLogout(); });
    ɵngcc0.ɵɵelement(1, "i", 26);
    ɵngcc0.ɵɵtext(2, "Sair ");
    ɵngcc0.ɵɵelementEnd();
} }
function FeaturesGroupComponent_feature_modules_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "feature-modules");
} }
function FeaturesGroupComponent_feature_notification_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "feature-notification");
} }
function FeaturesGroupComponent_notification_report_jasper_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "notification-report-jasper");
} }
function FeaturesGroupComponent_feature_configuracao_entidade_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "feature-configuracao-entidade", 7);
    ɵngcc0.ɵɵlistener("onGetExercicios", function FeaturesGroupComponent_feature_configuracao_entidade_7_Template_feature_configuracao_entidade_onGetExercicios_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.getExercicios($event); })("onCompetenciaSelecionada", function FeaturesGroupComponent_feature_configuracao_entidade_7_Template_feature_configuracao_entidade_onCompetenciaSelecionada_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.competenciaSelecionada($event); })("onGetCompetencias", function FeaturesGroupComponent_feature_configuracao_entidade_7_Template_feature_configuracao_entidade_onGetCompetencias_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.getCompetencias($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("configuracaoEntidade", ctx_r3.configuracaoEntidade)("showCompetencia", ctx_r3.showCompetencia)("showExercicio", ctx_r3.showExercicio);
} }
function FeaturesGroupComponent_configuracao_entidade_keycloak_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "configuracao-entidade-keycloak", 8);
    ɵngcc0.ɵɵlistener("onGetExercicios", function FeaturesGroupComponent_configuracao_entidade_keycloak_8_Template_configuracao_entidade_keycloak_onGetExercicios_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.getExercicios($event); })("onGetCompetencias", function FeaturesGroupComponent_configuracao_entidade_keycloak_8_Template_configuracao_entidade_keycloak_onGetCompetencias_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.getCompetencias($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("configuracaoEntidade", ctx_r4.configuracaoEntidade)("activeDataOperacaoField", ctx_r4.activeDataOperacaoField);
} }
function FeaturesGroupComponent_feature_contribuinte_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "feature-contribuinte", 9);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("contribuinte", ctx_r5.contribuinte);
} }
function NotificationReportJasperComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function NotificationReportJasperComponent_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.clearReports(); });
    ɵngcc0.ɵɵelement(1, "em", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵtext(3, "Limpar notifica\u00E7\u00F5es");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationReportJasperComponent_li_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const report_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(report_r6 == null ? null : report_r6.reportDate);
} }
function NotificationReportJasperComponent_li_6_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1, " Falha ");
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationReportJasperComponent_li_6_p_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1, " Click para baixar ");
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationReportJasperComponent_li_6_p_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1, " Executando ");
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationReportJasperComponent_li_6_p_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1, " Aguardando Execu\u00E7\u00E3o ");
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationReportJasperComponent_li_6_em_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "em", 21);
} }
function NotificationReportJasperComponent_li_6_em_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "em", 22);
} }
function NotificationReportJasperComponent_li_6_em_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "em", 23);
} }
function NotificationReportJasperComponent_li_6_em_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "em", 24);
} }
function NotificationReportJasperComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 12);
    ɵngcc0.ɵɵlistener("click", function NotificationReportJasperComponent_li_6_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const report_r6 = ctx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onClick(report_r6); });
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, NotificationReportJasperComponent_li_6_div_3_Template, 3, 1, "div", 14);
    ɵngcc0.ɵɵelementStart(4, "article", 15);
    ɵngcc0.ɵɵtemplate(5, NotificationReportJasperComponent_li_6_p_5_Template, 2, 0, "p", 6);
    ɵngcc0.ɵɵtemplate(6, NotificationReportJasperComponent_li_6_p_6_Template, 2, 0, "p", 6);
    ɵngcc0.ɵɵtemplate(7, NotificationReportJasperComponent_li_6_p_7_Template, 2, 0, "p", 6);
    ɵngcc0.ɵɵtemplate(8, NotificationReportJasperComponent_li_6_p_8_Template, 2, 0, "p", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, NotificationReportJasperComponent_li_6_em_9_Template, 1, 0, "em", 16);
    ɵngcc0.ɵɵtemplate(10, NotificationReportJasperComponent_li_6_em_10_Template, 1, 0, "em", 17);
    ɵngcc0.ɵɵtemplate(11, NotificationReportJasperComponent_li_6_em_11_Template, 1, 0, "em", 18);
    ɵngcc0.ɵɵtemplate(12, NotificationReportJasperComponent_li_6_em_12_Template, 1, 0, "em", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const report_r6 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate1("id", "report_", report_r6.requestId, "");
    ɵngcc0.ɵɵpropertyInterpolate("title", report_r6.messageError ? report_r6.messageError : report_r6.reportName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(report_r6 == null ? null : report_r6.reportName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", report_r6 == null ? null : report_r6.reportDate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", report_r6.status === "error" || report_r6.status === "failed");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", report_r6.status === "ready");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", report_r6.status === "execution");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", report_r6.status === "queued");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", report_r6.status === "error" || report_r6.status === "failed");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", report_r6.status === "ready");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", report_r6.status === "execution");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", report_r6.status === "queued");
} }
function NotificationReportJasperComponent_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "article", 25);
    ɵngcc0.ɵɵtext(2, " Nenhum relat\u00F3rio dispon\u00EDvel. ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationReportJasperComponent_elo_modal_10_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-modal", 26);
    ɵngcc0.ɵɵlistener("openClose", function NotificationReportJasperComponent_elo_modal_10_Template_elo_modal_openClose_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onOpenCloseModal($event); });
    ɵngcc0.ɵɵelementStart(1, "digital-certificate", 27);
    ɵngcc0.ɵɵlistener("onAssinar", function NotificationReportJasperComponent_elo_modal_10_Template_digital_certificate_onAssinar_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onAssinar($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("isOpen", ctx_r3.showDigitalCertificateForm)("customWidth", "30%");
} }
function EloNotificationComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "span", 3);
    ɵngcc0.ɵɵlistener("click", function EloNotificationComponent_div_1_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const notification_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.removeNotification(notification_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "h1", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p", 5);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r1 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("positive", notification_r1.type === 0)("negative", notification_r1.type === 1)("neutral", notification_r1.type === 2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", notification_r1.title, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", notification_r1.content, " ");
} }
const _c47 = ["file"];
function FileUploadComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.invalid ? ctx_r1.invalidMessage : ctx_r1.showRequiredMessage ? ctx_r1.requiredMessage : "", " ");
} }
function FloatButtonComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.hintContent);
} }
const _c48 = ["openButton"];
const _c49 = ["floatSidebar"];
const _c50 = ["container"];
function FloatSideBarComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FloatSideBarComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function HeaderComponent_figure_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "figure", 20);
    ɵngcc0.ɵɵelement(1, "img", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", "data:image/jpg;base64," + ctx_r0.brasaoByteArray, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeaderComponent_label_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.headerSubtitle);
} }
function HeaderComponent_li_14_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 9);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_li_14_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onClick("notificationReportJasper"); });
    ɵngcc0.ɵɵelement(1, "i", 23);
    ɵngcc0.ɵɵelementStart(2, "small", 24);
    ɵngcc0.ɵɵtext(3, "Relat\u00F3rios");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r2.item === "notificationReportJasper");
} }
function HeaderComponent_li_15_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 25);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_li_15_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onClick("contribuinte"); });
    ɵngcc0.ɵɵelement(1, "i", 26);
    ɵngcc0.ɵɵelementStart(2, "small", 24);
    ɵngcc0.ɵɵtext(3, "Contribuinte");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_li_16_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 27);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_li_16_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onClick("acessibilidade"); });
    ɵngcc0.ɵɵelement(1, "i", 28);
    ɵngcc0.ɵɵelementStart(2, "small", 24);
    ɵngcc0.ɵɵtext(3, "Acessibilidade");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r4.item === "acessibilidade");
} }
function HeaderComponent_li_17_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 29);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_li_17_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onClick("notification"); });
    ɵngcc0.ɵɵelement(1, "i", 30);
    ɵngcc0.ɵɵelementStart(2, "small", 24);
    ɵngcc0.ɵɵtext(3, "Notifica\u00E7\u00F5es");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r5.item === "notification");
} }
function HeaderComponent_li_18_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 31);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_li_18_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onClick("user"); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 32);
    ɵngcc0.ɵɵelement(2, "path", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(3, "small", 24);
    ɵngcc0.ɵɵtext(4, "Ajustes");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r6.item === "user");
} }
function HeaderComponent_li_19_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 34);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_li_19_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onClick("module"); });
    ɵngcc0.ɵɵelement(1, "i", 35);
    ɵngcc0.ɵɵelementStart(2, "small", 24);
    ɵngcc0.ɵɵtext(3, "M\u00F3dulos");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r7.item === "module");
} }
function HeaderComponent_figure_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "figure", 20);
    ɵngcc0.ɵɵelement(1, "img", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", "data:image/jpg;base64," + ctx_r8.brasaoByteArray, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeaderComponent_label_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.headerSubtitle);
} }
function ImageUploadComponent_img_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r1.imageSelected, ɵngcc0.ɵɵsanitizeUrl);
} }
function InformationComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function InformationComponent_div_0_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.buttonClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.buttonName);
} }
function InformationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelement(2, "em", 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "article");
    ɵngcc0.ɵɵelementStart(4, "h4", 3);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 4);
    ɵngcc0.ɵɵprojection(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, InformationComponent_div_0_button_8_Template, 2, 1, "button", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("info primary icon mb-xs ", ctx_r0.classInformation, "");
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.type);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.icon);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.enableButton);
} }
function ModalFormInsertComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ModalFormInsertComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "elo-modal", 1);
    ɵngcc0.ɵɵlistener("openClose", function ModalFormInsertComponent_div_0_Template_elo_modal_openClose_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onOpenClose(); });
    ɵngcc0.ɵɵtemplate(2, ModalFormInsertComponent_div_0_ng_container_2_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("isOpen", ctx_r0.isOpen);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.crudTemplateRef);
} }
function ModalMenuComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", item_r2.label, ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r2.value, "");
} }
function ModalMenuComponent_li_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 9);
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ModalMenuComponent_li_8_Template_button_click_1_listener() { const item_r3 = ctx.$implicit; return item_r3.onClickOption(item_r3); });
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("", item_r3.icon, " module-color");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3.titulo, " ");
} }
function PageCustomizedComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function PageCustomizedComponent_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.buttonClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.btnName);
} }
function QueryBuilderItemComponent_ng_container_2_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function QueryBuilderItemComponent_ng_container_2_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const removeRuleSet_r7 = ɵngcc0.ɵɵnextContext().removeRuleSet; return removeRuleSet_r7(); });
    ɵngcc0.ɵɵelement(1, "em", 11);
    ɵngcc0.ɵɵelementEnd();
} }
function QueryBuilderItemComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "button", 6);
    ɵngcc0.ɵɵlistener("click", function QueryBuilderItemComponent_ng_container_2_Template_button_click_2_listener() { const addRuleSet_r6 = ctx.addRuleSet; return addRuleSet_r6(); });
    ɵngcc0.ɵɵelement(3, "em", 7);
    ɵngcc0.ɵɵtext(4, " Grupo ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 8);
    ɵngcc0.ɵɵlistener("click", function QueryBuilderItemComponent_ng_container_2_Template_button_click_5_listener() { const addRule_r5 = ctx.addRule; return addRule_r5(); });
    ɵngcc0.ɵɵelement(6, "em", 7);
    ɵngcc0.ɵɵtext(7, " Condi\u00E7\u00E3o ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, QueryBuilderItemComponent_ng_container_2_button_8_Template, 2, 0, "button", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const removeRuleSet_r7 = ctx.removeRuleSet;
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", removeRuleSet_r7);
} }
function QueryBuilderItemComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 12);
    ɵngcc0.ɵɵlistener("click", function QueryBuilderItemComponent_ng_container_3_Template_button_click_1_listener() { const rule_r14 = ctx.$implicit; const removeRule_r15 = ctx.removeRule; return removeRule_r15(rule_r14); });
    ɵngcc0.ɵɵelement(2, "em", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function QueryBuilderItemComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "elo-switch-button", 13);
    ɵngcc0.ɵɵlistener("onSelected", function QueryBuilderItemComponent_ng_container_4_Template_elo_switch_button_onSelected_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ruleset_r17 = ctx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onSwitchButton($event, ruleset_r17); });
    ɵngcc0.ɵɵelement(2, "elo-switch-button-item", 14);
    ɵngcc0.ɵɵelement(3, "elo-switch-button-item", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ruleset_r17 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("selected", (ruleset_r17 == null ? null : ruleset_r17.condition) === "and");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", (ruleset_r17 == null ? null : ruleset_r17.condition) === "or");
} }
function QueryBuilderItemComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "textarea", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function QueryBuilderItemComponent_ng_container_5_Template_textarea_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const rule_r20 = ctx.$implicit; return rule_r20.value = $event; })("keyup", function QueryBuilderItemComponent_ng_container_5_Template_textarea_keyup_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); const rule_r20 = ctx.$implicit; const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.validateValue(rule_r20); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const rule_r20 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", rule_r20.value);
} }
function QueryBuilderTranslatorComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function QueryBuilderComponent_elo_query_builder_item_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-query-builder-item", 3);
    ɵngcc0.ɵɵlistener("onChangeQueryValue", function QueryBuilderComponent_elo_query_builder_item_1_Template_elo_query_builder_item_onChangeQueryValue_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onChangeQueryValue($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("queryValue", ctx_r0.queryBuilderValue)("config", ctx_r0.queryBuilderConfig);
} }
function QueryBuilderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "span", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.form.get("queryBuilderValue").errors.condicaoInvalida);
} }
function ReportSelectorComponent_elo_form_label_column_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-form-label-column", 4);
    ɵngcc0.ɵɵelementStart(1, "elo-autocomplete", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function ReportSelectorComponent_elo_form_label_column_2_Template_elo_autocomplete_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.grupoRelatorio = $event; })("onChangeValue", function ReportSelectorComponent_elo_form_label_column_2_Template_elo_autocomplete_onChangeValue_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onChangeGrupo(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.grupoRelatorio)("findToOptions", ctx_r0.findToOptions())("objToOption", ctx_r0.objToOption());
} }
function ReportSelectorComponent_elo_panel_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-panel", 6);
    ɵngcc0.ɵɵelementStart(1, "elo-datatable", 7);
    ɵngcc0.ɵɵelement(2, "elo-column", 8);
    ɵngcc0.ɵɵelement(3, "elo-column", 8);
    ɵngcc0.ɵɵelementStart(4, "elo-table-actions", 9);
    ɵngcc0.ɵɵlistener("onClickIconButton", function ReportSelectorComponent_elo_panel_3_Template_elo_table_actions_onClickIconButton_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onSelect($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap((ctx_r1.relatorios == null ? null : ctx_r1.relatorios.length) > 6 ? "fixed" : "");
    ɵngcc0.ɵɵproperty("values", ctx_r1.relatorios)("colSpanActions", 1)("emptyMessage", "N\u00E3o foram encontrados tipos de relat\u00F3rio.");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", "codigo")("header", "C\u00F3digo")("col", 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", "descricao")("header", "Descri\u00E7\u00E3o")("col", 10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", "Selecionar");
} }
function SidebarComponent_aside_0_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 14);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.imgModuleRebranding, ɵngcc0.ɵɵsanitizeUrl);
} }
function SidebarComponent_aside_0_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "elo-sidebar-item", 15);
    ɵngcc0.ɵɵlistener("onClearActivedMenus", function SidebarComponent_aside_0_div_10_Template_elo_sidebar_item_onClearActivedMenus_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.clearActivedMenus(); })("onCloseNotActivedMenus", function SidebarComponent_aside_0_div_10_Template_elo_sidebar_item_onCloseNotActivedMenus_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.closeNotActivedMenus(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", item_r5)("searchValue", ctx_r2.searchValue)("toggled", ctx_r2.toggled)("floatType", ctx_r2.floatType)("focusedSearchInput", ctx_r2.focusedSearchInput);
} }
function SidebarComponent_aside_0_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 16);
} }
function SidebarComponent_aside_0_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 17);
    ɵngcc0.ɵɵtext(2, " Recolher Menu ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function SidebarComponent_aside_0_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "aside", 1);
    ɵngcc0.ɵɵlistener("mouseenter", function SidebarComponent_aside_0_Template_aside_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onMouseEnter(); });
    ɵngcc0.ɵɵelementStart(1, "header", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, SidebarComponent_aside_0_img_3_Template, 1, 1, "img", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function SidebarComponent_aside_0_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.searchValue = $event; })("focus", function SidebarComponent_aside_0_Template_input_focus_7_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.handleOnFocus(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "i", 8);
    ɵngcc0.ɵɵlistener("click", function SidebarComponent_aside_0_Template_i_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.handleOnFocus(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "ul", 9);
    ɵngcc0.ɵɵtemplate(10, SidebarComponent_aside_0_div_10_Template, 2, 5, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "button", 11);
    ɵngcc0.ɵɵlistener("click", function SidebarComponent_aside_0_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onClickToggledButton(); });
    ɵngcc0.ɵɵtemplate(12, SidebarComponent_aside_0_div_12_Template, 1, 0, "div", 12);
    ɵngcc0.ɵɵtemplate(13, SidebarComponent_aside_0_ng_container_13_Template, 3, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("sidebar-toggle", ctx_r0.toggled)("float-type", ctx_r0.toggled)("focused-search", ctx_r0.focusedSearchInput)("clicked", ctx_r0.clicked)("fancy", ctx_r0.fancy);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.imgModule);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.searchValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.toggled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.toggled);
} }
function SidebarItemComponent_div_0_li_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.item.count);
} }
function SidebarItemComponent_div_0_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵlistener("mouseenter", function SidebarItemComponent_div_0_li_1_Template_li_mouseenter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.handleMouseEnterMenuFloatType($event); })("mouseleave", function SidebarItemComponent_div_0_li_1_Template_li_mouseleave_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.handleMouseLeaveMenuFloatType($event); });
    ɵngcc0.ɵɵelementStart(1, "a", 3);
    ɵngcc0.ɵɵlistener("click", function SidebarItemComponent_div_0_li_1_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.clickLink($event); });
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵtemplate(3, SidebarItemComponent_div_0_li_1_span_3_Template, 2, 1, "span", 4);
    ɵngcc0.ɵɵelementStart(4, "b");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("on", ctx_r1.item.active);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.item.hidden);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r1.item.enabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.item.enabled ? ctx_r1.item.icon : "fa fa-ban");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.item.count);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.item.name);
} }
function SidebarItemComponent_div_0_ng_container_2_elo_sidebar_item_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "elo-sidebar-item", 9);
    ɵngcc0.ɵɵlistener("onClearActivedMenus", function SidebarItemComponent_div_0_ng_container_2_elo_sidebar_item_7_Template_elo_sidebar_item_onClearActivedMenus_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.clearActivedMenus(); })("onCloseNotActivedMenus", function SidebarItemComponent_div_0_ng_container_2_elo_sidebar_item_7_Template_elo_sidebar_item_onCloseNotActivedMenus_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ctx_r12.closeNotActivedMenus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const itemChild_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("item", itemChild_r9)("searchValue", ctx_r8.internalSearchValue)("toggled", ctx_r8.toggled)("floatType", ctx_r8.floatType)("focusedSearchInput", ctx_r8.focusedSearchInput);
} }
function SidebarItemComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 2);
    ɵngcc0.ɵɵlistener("mouseenter", function SidebarItemComponent_div_0_ng_container_2_Template_li_mouseenter_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.handleMouseEnterMenuFloatType($event); })("mouseleave", function SidebarItemComponent_div_0_ng_container_2_Template_li_mouseleave_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.handleMouseLeaveMenuFloatType($event); });
    ɵngcc0.ɵɵelementStart(2, "a", 6);
    ɵngcc0.ɵɵlistener("click", function SidebarItemComponent_div_0_ng_container_2_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onClickSubMenu(); });
    ɵngcc0.ɵɵelement(3, "i");
    ɵngcc0.ɵɵelementStart(4, "b");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ul", 7);
    ɵngcc0.ɵɵtemplate(7, SidebarItemComponent_div_0_ng_container_2_elo_sidebar_item_7_Template, 1, 5, "elo-sidebar-item", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("top", ctx_r2.item.open)("on", ctx_r2.item.active);
    ɵngcc0.ɵɵproperty("hidden", ctx_r2.item.hidden);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("open", ctx_r2.item.open);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r2.item.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.item.name, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("visible-block", ctx_r2.item.open && ctx_r2.checkVisibleSubMenu());
    ɵngcc0.ɵɵattribute("attr-parent", ctx_r2.item.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.item.items);
} }
function SidebarItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, SidebarItemComponent_div_0_li_1_Template, 6, 10, "li", 1);
    ɵngcc0.ɵɵtemplate(2, SidebarItemComponent_div_0_ng_container_2_Template, 8, 15, "ng-container", 0);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.item.items.length === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(3, 2, ctx_r0.item.items.length > 0 && ctx_r0.hasChildWithAccess));
} }
function SortableHeaderComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 4);
} }
function SortableHeaderComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 5);
} }
function SortableHeaderComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} }
function SwitchComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("hint sm clean fa-question-circle module-color inline ", ctx_r0.hintPosition, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.hintMessage);
} }
function TabControlComponent_div_3_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(tab_r1.badge);
} }
function TabControlComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("click", function TabControlComponent_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const tab_r1 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.selectTab(tab_r1); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, TabControlComponent_div_3_span_2_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.getTabClass(tab_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tab_r1.title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tab_r1.badge);
} }
const _c51 = [[["", "buttons", ""]], "*"];
const _c52 = function (a0) { return { "pb-none": a0 }; };
const _c53 = function (a0) { return { "has-badge": a0 }; };
const _c54 = ["[buttons]", "*"];
function WidgetFrequentlyItemComponent_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 1);
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵelement(2, "em");
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "span", 5);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 6);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r0.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.icone);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.subTitle, " ");
} }
const _c55 = [[["", "highlight-detail", ""]]];
const _c56 = ["[highlight-detail]"];
function WidgetPanelComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵelement(1, "em");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.iconClass);
} }
const _c57 = [[["", "widget-title", ""]], [["", "widget-body", ""]], [["", "widget-footer", ""]]];
const _c58 = ["[widget-title]", "[widget-body]", "[widget-footer]"];
const _c59 = [[["", "progress-detail", ""]]];
const _c60 = ["[progress-detail]"];
function WizardControlComponent_li_3_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(step_r4.invalidMessage);
} }
function WizardControlComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 9);
    ɵngcc0.ɵɵlistener("click", function WizardControlComponent_li_3_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const step_r4 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.selectStep(step_r4); });
    ɵngcc0.ɵɵelement(1, "em");
    ɵngcc0.ɵɵtemplate(2, WizardControlComponent_li_3_p_2_Template, 2, 1, "p", 10);
    ɵngcc0.ɵɵelementStart(3, "div", 11);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r4 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    var tmp_5_0 = null;
    ɵngcc0.ɵɵclassProp("active", step_r4.selected || step_r4.done)("on", step_r4.showErrorMessage);
    ɵngcc0.ɵɵattribute("data-error", !step_r4.valid && step_r4.triedToValidate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(step_r4.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !step_r4.valid && step_r4.triedToValidate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "idStep_", ctx_r0.steps == null ? null : (tmp_5_0 = ctx_r0.steps.toArray()) == null ? null : tmp_5_0.indexOf(step_r4), "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r4.title, " ");
} }
function WizardControlComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function WizardControlComponent_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.selectStep(null, "next"); });
    ɵngcc0.ɵɵtext(1, "Pr\u00F3ximo");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", !ctx_r1.nextButtonOn);
} }
function WizardControlComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function WizardControlComponent_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.finalizeButtonClick(); });
    ɵngcc0.ɵɵtext(1, "Finalizar");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", !ctx_r2.finishButtonOn);
} }
function WizardControlComponent_div_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function WizardControlComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, WizardControlComponent_div_11_ng_container_1_Template, 1, 0, "ng-container", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.extraButtonsTemplate);
} }
function RodaAtalhosComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("click", function RodaAtalhosComponent_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const atalho_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.navegarPara(atalho_r3); })("mouseenter", function RodaAtalhosComponent_div_2_Template_div_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const atalho_r3 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.mouseEnter(atalho_r3); })("mouseleave", function RodaAtalhosComponent_div_2_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.mouseLeave(); });
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 5);
    ɵngcc0.ɵɵelementStart(3, "g", 6);
    ɵngcc0.ɵɵelementStart(4, "g", 7);
    ɵngcc0.ɵɵelement(5, "path", 8);
    ɵngcc0.ɵɵelement(6, "path", 9);
    ɵngcc0.ɵɵelement(7, "path", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const atalho_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(atalho_r3.icone);
} }
function RodaAtalhosComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 10);
    ɵngcc0.ɵɵtext(1, "Selecione ou digite o n\u00FAmero da op\u00E7\u00E3o desejada");
    ɵngcc0.ɵɵelementEnd();
} }
function RodaAtalhosComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.atalhoSelecionado.descricao);
} }
function ExceptionHandlerComponent_article_0_div_1_h3_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h3", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Data e Hora: ", ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r4.error.timestamp, "dd/MM/yyyy HH:mm:ss"), " ");
} }
function ExceptionHandlerComponent_article_0_div_1_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.error.message, " ");
} }
function ExceptionHandlerComponent_article_0_div_1_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const violation_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", violation_r10.field, " ", violation_r10.message, " ");
} }
function ExceptionHandlerComponent_article_0_div_1_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function ExceptionHandlerComponent_article_0_div_1_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.onClickSuggestion(); });
    ɵngcc0.ɵɵtext(1, " Poss\u00EDvel Solu\u00E7\u00E3o ");
    ɵngcc0.ɵɵelementEnd();
} }
function ExceptionHandlerComponent_article_0_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 16);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelement(5, "br");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelement(7, "br");
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelement(9, "br");
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Status: ", ctx_r8.error.status, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Error: ", ctx_r8.error.error, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Exception: ", ctx_r8.error.exception, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Path: ", ctx_r8.error.path, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Detail: ", ctx_r8.error.detail, " ");
} }
function ExceptionHandlerComponent_article_0_div_1_div_9_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const violation_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", violation_r14.suggestion, " ");
} }
function ExceptionHandlerComponent_article_0_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 16);
    ɵngcc0.ɵɵtemplate(2, ExceptionHandlerComponent_article_0_div_1_div_9_li_2_Template, 2, 1, "li", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.error.violations);
} }
function ExceptionHandlerComponent_article_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtemplate(1, ExceptionHandlerComponent_article_0_div_1_h3_1_Template, 3, 4, "h3", 6);
    ɵngcc0.ɵɵtemplate(2, ExceptionHandlerComponent_article_0_div_1_p_2_Template, 2, 1, "p", 7);
    ɵngcc0.ɵɵtemplate(3, ExceptionHandlerComponent_article_0_div_1_li_3_Template, 2, 2, "li", 8);
    ɵngcc0.ɵɵelementStart(4, "div");
    ɵngcc0.ɵɵelementStart(5, "button", 9);
    ɵngcc0.ɵɵlistener("click", function ExceptionHandlerComponent_article_0_div_1_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.onClickMoreInfo(); });
    ɵngcc0.ɵɵtext(6, " Mais Detalhes ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, ExceptionHandlerComponent_article_0_div_1_button_7_Template, 2, 0, "button", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, ExceptionHandlerComponent_article_0_div_1_div_8_Template, 11, 5, "div", 11);
    ɵngcc0.ɵɵtemplate(9, ExceptionHandlerComponent_article_0_div_1_div_9_Template, 3, 1, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.error.timestamp);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.error.violations || ctx_r1.error.violations.length <= 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.error.violations);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.existSuggestion);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.moreInfo);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.suggestion);
} }
function ExceptionHandlerComponent_article_0_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 16);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r17.error, " ");
} }
function ExceptionHandlerComponent_article_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "p", 13);
    ɵngcc0.ɵɵtext(3, " Houve uma instabilidade em nossos servidores, tente mais tarde! ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div");
    ɵngcc0.ɵɵelementStart(5, "button", 9);
    ɵngcc0.ɵɵlistener("click", function ExceptionHandlerComponent_article_0_div_2_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onClickMoreInfo(); });
    ɵngcc0.ɵɵtext(6, " Mais Detalhes ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, ExceptionHandlerComponent_article_0_div_2_div_7_Template, 3, 1, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.moreInfo);
} }
function ExceptionHandlerComponent_article_0_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 18);
    ɵngcc0.ɵɵlistener("click", function ExceptionHandlerComponent_article_0_span_3_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.onBack(); });
    ɵngcc0.ɵɵtext(1, " Reiniciar ");
    ɵngcc0.ɵɵelementEnd();
} }
function ExceptionHandlerComponent_article_0_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "article", 1);
    ɵngcc0.ɵɵlistener("keyup.esc", function ExceptionHandlerComponent_article_0_Template_article_keyup_esc_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.onClose(); });
    ɵngcc0.ɵɵtemplate(1, ExceptionHandlerComponent_article_0_div_1_Template, 10, 6, "div", 2);
    ɵngcc0.ɵɵtemplate(2, ExceptionHandlerComponent_article_0_div_2_Template, 8, 1, "div", 2);
    ɵngcc0.ɵɵtemplate(3, ExceptionHandlerComponent_article_0_span_3_Template, 2, 0, "span", 3);
    ɵngcc0.ɵɵelementStart(4, "span", 4);
    ɵngcc0.ɵɵlistener("click", function ExceptionHandlerComponent_article_0_Template_span_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onClose(); });
    ɵngcc0.ɵɵtext(5, " Ok");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isHttpError);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isHttpError);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showReiniciarButton);
} }
const _c61 = function (a0, a1) { return { "panel-table-filter": a0, "panel-filter": a1 }; };
function ReportFormatComponent_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const formatType_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", formatType_r1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(formatType_r1);
} }
function CamposDinamicosComponent_div_0_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelementStart(3, "b", 8);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "campos-dinamicos-respostas", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const grupo_r2 = ctx_r5.$implicit;
    const i_r3 = ctx_r5.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "grupo_", grupo_r2.value == null ? null : grupo_r2.value.id, "");
    ɵngcc0.ɵɵproperty("formGroupName", i_r3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", grupo_r2.value == null ? null : grupo_r2.value.descricao, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("form", ctx_r4.form)("grupoForm", grupo_r2)("indexGrupoResposta", i_r3)("fieldNameResposta", ctx_r4.fieldNameResposta)("fieldNameGrupos", ctx_r4.fieldNameGrupos);
} }
function CamposDinamicosComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CamposDinamicosComponent_div_0_div_3_div_1_Template, 6, 8, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grupo_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!(grupo_r2.value == null ? null : grupo_r2.value.ativo));
} }
function CamposDinamicosComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "form", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵtemplate(3, CamposDinamicosComponent_div_0_div_3_Template, 2, 1, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("formArrayName", ctx_r0.fieldNameGrupos);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.form.get(ctx_r0.fieldNameGrupos)["controls"]);
} }
function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "input", 10);
    ɵngcc0.ɵɵlistener("blur", function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_2_Template_input_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(4); return ctx_r9.changeRespostasEntity(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    const resposta_r2 = ctx_r11.$implicit;
    const i_r3 = ctx_r11.index;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "campo_", resposta_r2.value == null ? null : resposta_r2.value.campo.id, "_", i_r3, "");
    ɵngcc0.ɵɵpropertyInterpolate("type", ctx_r5.getTipoCampoFromEnum[resposta_r2.value == null ? null : resposta_r2.value.campo.tipo]);
} }
function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "input", 11);
    ɵngcc0.ɵɵlistener("blur", function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_3_Template_input_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(4); return ctx_r12.changeRespostasEntity(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    const resposta_r2 = ctx_r14.$implicit;
    const i_r3 = ctx_r14.index;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "campo_", resposta_r2.value == null ? null : resposta_r2.value.campo.id, "_", i_r3, "");
    ɵngcc0.ɵɵpropertyInterpolate("type", ctx_r6.getTipoCampoFromEnum[resposta_r2.value == null ? null : resposta_r2.value.campo.tipo]);
} }
function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "input", 12);
    ɵngcc0.ɵɵlistener("blur", function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_4_Template_input_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(4); return ctx_r15.changeRespostasEntity(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    const resposta_r2 = ctx_r17.$implicit;
    const i_r3 = ctx_r17.index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "campo_", resposta_r2.value == null ? null : resposta_r2.value.campo.id, "_", i_r3, "");
    ɵngcc0.ɵɵpropertyInterpolate("type", ctx_r7.getTipoCampoFromEnum[resposta_r2.value == null ? null : resposta_r2.value.campo.tipo]);
} }
function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_5_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r19 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", a_r19);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", a_r19 == null ? null : a_r19.codigo, " - ", a_r19 == null ? null : a_r19.descricao, " ");
} }
function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "select", 13);
    ɵngcc0.ɵɵlistener("change", function CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_5_Template_select_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(4); return ctx_r20.changeRespostasEntity(); });
    ɵngcc0.ɵɵelement(2, "option", 14);
    ɵngcc0.ɵɵtemplate(3, CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_5_option_3_Template, 2, 3, "option", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    const resposta_r2 = ctx_r22.$implicit;
    const i_r3 = ctx_r22.index;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "campo_", resposta_r2.value == null ? null : resposta_r2.value.campo.id, "_", i_r3, "");
    ɵngcc0.ɵɵproperty("compareWith", ctx_r8.compareWith());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.getAlternativasAtivas(resposta_r2.value == null ? null : resposta_r2.value.campo.alternativas));
} }
function CamposDinamicosRespostasComponent_div_0_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "elo-form-label-column", 8);
    ɵngcc0.ɵɵtemplate(2, CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_2_Template, 2, 3, "div", 9);
    ɵngcc0.ɵɵtemplate(3, CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_3_Template, 2, 3, "div", 9);
    ɵngcc0.ɵɵtemplate(4, CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_4_Template, 2, 3, "div", 9);
    ɵngcc0.ɵɵtemplate(5, CamposDinamicosRespostasComponent_div_0_div_3_div_1_div_5_Template, 4, 4, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    const i_r3 = ctx_r23.index;
    const resposta_r2 = ctx_r23.$implicit;
    ɵngcc0.ɵɵproperty("formGroupName", i_r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("label", resposta_r2.value == null ? null : resposta_r2.value.campo.descricao);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (resposta_r2.value == null ? null : resposta_r2.value.campo.tipo) === "TEXTO" || (resposta_r2.value == null ? null : resposta_r2.value.campo.tipo) === "DATA");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (resposta_r2.value == null ? null : resposta_r2.value.campo.tipo) === "INTEIRO");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (resposta_r2.value == null ? null : resposta_r2.value.campo.tipo) === "DECIMAL");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (resposta_r2.value == null ? null : resposta_r2.value.campo.tipo) === "MULTIPLA_ESCOLHA");
} }
function CamposDinamicosRespostasComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtemplate(1, CamposDinamicosRespostasComponent_div_0_div_3_div_1_Template, 6, 6, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const resposta_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    var tmp_0_0 = null;
    ɵngcc0.ɵɵpropertyInterpolate1("id", "respostas_", ctx_r1.form == null ? null : (tmp_0_0 = ctx_r1.form.get("id")) == null ? null : tmp_0_0.value, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!(resposta_r2.value == null ? null : resposta_r2.value.campo == null ? null : resposta_r2.value.campo.ativo));
} }
function CamposDinamicosRespostasComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, CamposDinamicosRespostasComponent_div_0_div_3_Template, 2, 2, "div", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.grupoForm);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.grupoForm.get("respostas")["controls"]);
} }
function CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_p_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r8 = ɵngcc0.ɵɵnextContext().object;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", object_r8.valor, " ");
} }
function CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r8 = ɵngcc0.ɵɵnextContext().object;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", object_r8.valor, " ");
} }
function CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "decimalformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r8 = ɵngcc0.ɵɵnextContext().object;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, object_r8.valor, "1.2-2"), " ");
} }
function CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "dateformat");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r8 = ɵngcc0.ɵɵnextContext().object;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, object_r8.valor), " ");
} }
function CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const object_r8 = ɵngcc0.ɵɵnextContext().object;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", object_r8.alternativa.codigo, " - ", object_r8.alternativa.descricao, " ");
} }
function CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_p_0_Template, 2, 1, "p", 0);
    ɵngcc0.ɵɵtemplate(1, CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_p_1_Template, 2, 1, "p", 0);
    ɵngcc0.ɵɵtemplate(2, CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_p_2_Template, 3, 4, "p", 0);
    ɵngcc0.ɵɵtemplate(3, CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_p_3_Template, 3, 3, "p", 0);
    ɵngcc0.ɵɵtemplate(4, CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_div_4_Template, 2, 2, "div", 0);
} if (rf & 2) {
    const object_r8 = ctx.object;
    ɵngcc0.ɵɵproperty("ngIf", (object_r8 == null ? null : object_r8.campo == null ? null : object_r8.campo.tipo) === "TEXTO");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (object_r8 == null ? null : object_r8.campo == null ? null : object_r8.campo.tipo) === "INTEIRO");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (object_r8 == null ? null : object_r8.campo == null ? null : object_r8.campo.tipo) === "DECIMAL");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (object_r8 == null ? null : object_r8.campo == null ? null : object_r8.campo.tipo) === "DATA");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (object_r8 == null ? null : object_r8.campo == null ? null : object_r8.campo.tipo) === "MULTIPLA_ESCOLHA");
} }
function CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementContainerStart(1);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "div", 10);
    ɵngcc0.ɵɵelementStart(4, "elo-datatable", 11);
    ɵngcc0.ɵɵelement(5, "elo-column", 12);
    ɵngcc0.ɵɵelement(6, "elo-column", 13);
    ɵngcc0.ɵɵelementStart(7, "elo-column", 14);
    ɵngcc0.ɵɵtemplate(8, CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_ng_template_8_Template, 5, 5, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grupo_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassMap("fancy fixed");
    ɵngcc0.ɵɵproperty("values", grupo_r2.respostas)("emptyMessage", "Sem registros");
} }
function CamposDinamicosViewComponent_div_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "b", 6);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, CamposDinamicosViewComponent_div_0_div_1_div_1_div_5_Template, 10, 4, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grupo_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵpropertyInterpolate1("id", "grupo_", grupo_r2.id, "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", grupo_r2.descricao, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", grupo_r2.respostas.length > 0);
} }
function CamposDinamicosViewComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CamposDinamicosViewComponent_div_0_div_1_div_1_Template, 6, 3, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grupo_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!grupo_r2.ativo);
} }
function CamposDinamicosViewComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CamposDinamicosViewComponent_div_0_div_1_Template, 2, 1, "div", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.gruposRespostas);
} }
class CommonService {
    getTitle() {
        return 'sandbox';
    }
}
CommonService.ɵfac = function CommonService_Factory(t) { return new (t || CommonService)(); };
CommonService.ɵprov = ɵɵdefineInjectable({ factory: function CommonService_Factory() { return new CommonService(); }, token: CommonService, providedIn: "root" });

const APPLICATION_JSON_PATCH = 'application/json-patch+json';

// tslint:disable-next-line: variable-name
const HttpClientInterceptorToken = new InjectionToken('HttpClientInterceptorToken');

const HTTP_ERROR_LIST = [
    { codigo: 400, descricao: 'Requisição inválida' },
    { codigo: 401, descricao: 'Não autorizado' },
    { codigo: 402, descricao: 'Pagamento necessário' },
    { codigo: 403, descricao: 'Proibido' },
    { codigo: 404, descricao: 'Não encontrado' },
    { codigo: 405, descricao: 'Método não permitido' },
    { codigo: 406, descricao: 'Não Aceitável' },
    { codigo: 407, descricao: 'Autenticação de proxy necessária' },
    { codigo: 408, descricao: 'Tempo de requisição esgotou (Timeout)' },
    { codigo: 409, descricao: 'Conflito' },
    { codigo: 410, descricao: 'Gone' },
    { codigo: 411, descricao: 'comprimento necessário' },
    { codigo: 412, descricao: 'Pré-condição falhou' },
    { codigo: 413, descricao: 'Entidade de solicitação muito grande' },
    { codigo: 414, descricao: 'Pedido-URI Too Long' },
    { codigo: 415, descricao: 'Tipo de mídia não suportado' },
    { codigo: 416, descricao: 'Solicitada de Faixa Não Satisfatória' },
    { codigo: 417, descricao: 'Falha na expectativa' },
    { codigo: 418, descricao: 'Eu sou um bule de chá' },
    { codigo: 422, descricao: 'Entidade improcessável (WebDAV) (RFC codigo: 4918)' },
    { codigo: 423, descricao: 'Fechado (WebDAV) (RFC codigo: 4918)' },
    { codigo: 424, descricao: 'Falha de Dependência (WebDAV) (RFC codigo: 4918)' },
    { codigo: 425, descricao: 'coleção não ordenada (RFC 3648)' },
    { codigo: 426, descricao: 'Upgrade Obrigatório (RFC 2817)' },
    { codigo: 450, descricao: 'bloqueados pelo Controle de Pais do Windows' },
    { codigo: 499, descricao: 'cliente fechou Pedido (utilizado em ERPs/VPSA)' },
    { codigo: 500, descricao: 'Erro interno do servidor (Internal Server Error)' },
    { codigo: 501, descricao: 'Não implementado (Not implemented)' },
    { codigo: 502, descricao: 'Bad Gateway' },
    { codigo: 503, descricao: 'Serviço indisponível (Service Unavailable)' },
    { codigo: 504, descricao: 'Gateway Time-Out' },
    { codigo: 505, descricao: 'HTTP Version not supported' },
    { codigo: 506, descricao: 'VARIANT_ALSO_NEGOTIATES' },
    { codigo: 507, descricao: 'INSUFFICIENT_STORAGE' },
    { codigo: 508, descricao: 'LOOP_DETECTED' },
    { codigo: 509, descricao: 'BANDWIDTH_LIMIT_EXCEEDED' },
    { codigo: 510, descricao: 'NOT_EXTENDED' },
    { codigo: 511, descricao: 'NETWORK_AUTHENTICATION_REQUIRED' },
];

class HttpError {
    constructor(message, status, error) {
        this.violations = [];
        this.message = message;
        this.error = error;
        this.status = status;
    }
    static fromServer(errorFromServer) {
        this.throwError(errorFromServer);
    }
    static isError(codigo) {
        let errorFiltered = HTTP_ERROR_LIST.filter((httpError) => {
            return httpError.codigo === codigo;
        });
        return errorFiltered.length > 0;
    }
    static getErrorMessage(codigo) {
        let errorFiltered = HTTP_ERROR_LIST.filter((httpError) => {
            return httpError.codigo === codigo;
        });
        return errorFiltered[0].descricao;
    }
    static throwErrorBlob(errorFromServer) {
        return __awaiter(this, void 0, void 0, function* () {
            let error = JSON.parse(yield errorFromServer.text());
            if (error.timestamp) {
                const finalDate = new Date(Date.parse(error.timestamp));
                error.timestamp = finalDate;
            }
            HttpError.fromServer(error);
        });
    }
    static throwError(errorFromServer) {
        const httpError = new HttpError(errorFromServer.message, errorFromServer.status, errorFromServer.error);
        httpError.timestamp = errorFromServer.timestamp;
        httpError.exception = errorFromServer.exception;
        httpError.path = errorFromServer.path;
        httpError.detail = errorFromServer.detail;
        httpError.violations = errorFromServer.violations;
        throw httpError;
    }
}

const CONNECTION_ERROR = 'Erro de conexão com o servidor';
const STATUS_401_MESSAGE = 'Não autorizado';
const STATUS_401 = 401;
class HttpClientUtils {
    static addUrlParameter(url, parameter) {
        let signParameters = '?';
        if (url.includes('?')) {
            signParameters = '&';
        }
        return url + signParameters + parameter;
    }
    static handleError(error) {
        return __awaiter(this, void 0, void 0, function* () {
            if (error instanceof HttpErrorResponse) {
                if (error.status === STATUS_401) {
                    throw new HttpError(STATUS_401_MESSAGE, error.status, error);
                }
                else {
                    if (HttpClientUtils.hasContentTypeJson(error)) {
                        if (error.error instanceof Blob) {
                            yield HttpError.throwErrorBlob(error.error);
                        }
                        else {
                            throw HttpError.fromServer(typeof (error.error) === 'string' ? JSON.parse(error.error) : error.error);
                        }
                    }
                    else {
                        throw new HttpError(error.error && !(error.error instanceof ErrorEvent) ? error.error : CONNECTION_ERROR, error.status);
                    }
                }
            }
            throw new HttpError(CONNECTION_ERROR, 0, error);
        });
    }
    static buildUrlWithBase(httpParams, urlBase) {
        let mountUrl = `${urlBase}${httpParams.resource}`;
        if (httpParams.id) {
            mountUrl += `/${httpParams.id}`;
        }
        if (httpParams.search) {
            mountUrl = HttpClientUtils.addUrlParameter(mountUrl, `search=${encodeURI(httpParams.search.replace(/\n|\r/g, ''))}`);
        }
        if (httpParams.fields) {
            mountUrl = HttpClientUtils.addUrlParameter(mountUrl, `fields=${httpParams.fields}`);
        }
        if (httpParams.page) {
            mountUrl = HttpClientUtils.addUrlParameter(mountUrl, httpParams.page.toUrlParameters());
        }
        return mountUrl;
    }
    static buildUrl(httpParams, urlResolver) {
        let urlBase = httpParams.requestOrigin ? urlResolver.getUrlOrigin() :
            urlResolver.getUrlResolved(httpParams.location);
        return HttpClientUtils.buildUrlWithBase(httpParams, urlBase);
    }
    static getHeaders(extraHeaders) {
        let headers = new HttpHeaders().append('Content-Type', 'application/json');
        if (extraHeaders) {
            extraHeaders.keys().forEach(keyExtra => headers = headers.set(keyExtra, extraHeaders.get(keyExtra)));
        }
        return headers;
    }
    static handleResponse(httpParams, response) {
        if (httpParams.observeResponse) {
            return response;
        }
        if (httpParams.responseType === 'blob') {
            return response.body;
        }
        else if (httpParams.responseType === 'text') {
            return response.body;
        }
        else if (HttpClientUtils.hasContentTypeJson(response)) {
            return response.body;
        }
        return response.body;
    }
    static addToken(httpParams, token) {
        httpParams.headersExtra = httpParams.headersExtra.append('Authorization', 'Bearer ' + token);
    }
    static hasContentTypeJson(response) {
        if (response.headers && response.headers.has('Content-Type')) {
            return response.headers.get('Content-Type').indexOf('json') >= 0;
        }
        return false;
    }
}

class UrlResolver {
    constructor(url, urlUserInfo = '') {
        this.url = url;
        this.urlUserInfo = urlUserInfo;
    }
    getUrlResolved(location) {
        if (location) {
            return `${this.getRootUrl(this.url)}${location}`;
        }
        return this.url;
    }
    getUrlOrigin() {
        return window.location.origin;
    }
    getUrlUserInfo() {
        return this.urlUserInfo;
    }
    getRootUrl(url) {
        if (url.includes('http')) {
            return url.toString().replace(/^(.*\/\/[^\/?#]*).*$/, '$1');
        }
        return '';
    }
}

class HttpClient {
    constructor(http, urlResolver, interceptors) {
        this.http = http;
        this.urlResolver = urlResolver;
        this.interceptors = interceptors;
    }
    get(httpParams) {
        httpParams.requestMethod = 'GET';
        return this.request(httpParams);
    }
    post(httpParams) {
        httpParams.requestMethod = 'POST';
        return this.request(httpParams);
    }
    put(httpParams) {
        httpParams.requestMethod = 'PUT';
        return this.request(httpParams);
    }
    patch(httpParams) {
        httpParams.requestMethod = 'PATCH';
        return this.request(httpParams);
    }
    del(httpParams) {
        httpParams.requestMethod = 'DELETE';
        return this.request(httpParams);
    }
    request(httpParams) {
        if (!httpParams.headersExtra) {
            httpParams.headersExtra = new HttpHeaders();
        }
        let observableChain = of(httpParams);
        let interceptorsInstances = this.getInterceptors();
        for (let i = 0; i < interceptorsInstances.length; i++) {
            let interceptorInstance = interceptorsInstances[i];
            if (interceptorInstance.interceptRequest) {
                observableChain = observableChain.pipe(mergeMap(params => interceptorInstance.interceptRequest(params)));
            }
        }
        observableChain = observableChain.pipe(mergeMap(params => this.internalRequest(params)));
        for (let i = 0; i < interceptorsInstances.length; i++) {
            let interceptorInstance = interceptorsInstances[i];
            if (interceptorInstance.interceptResponse) {
                observableChain = observableChain.pipe(mergeMap(response => interceptorInstance.interceptResponse(httpParams, response)));
            }
            if (interceptorInstance.catchError) {
                observableChain = observableChain.pipe(catchError(e => interceptorInstance.catchError(httpParams, e)));
            }
            if (interceptorInstance.finally) {
                observableChain = observableChain.pipe(finalize(() => interceptorInstance.finally(httpParams)));
            }
        }
        return observableChain.pipe(map(response => HttpClientUtils.handleResponse(httpParams, response)), catchError((error) => __awaiter(this, void 0, void 0, function* () { return yield HttpClientUtils.handleError(error); })));
    }
    getInterceptors() {
        if (this.interceptors) {
            return this.interceptors;
        }
        return [];
    }
    internalRequest(httpParams) {
        if (httpParams.requestMethod === 'GET'
            || httpParams.requestMethod === 'DELETE') {
            return this.http.request(httpParams.requestMethod, HttpClientUtils.buildUrl(httpParams, this.urlResolver), {
                headers: HttpClientUtils.getHeaders(httpParams.headersExtra),
                observe: 'response',
                responseType: httpParams.responseType
            });
        }
        if (httpParams.requestMethod === 'POST'
            || httpParams.requestMethod === 'PUT'
            || httpParams.requestMethod === 'PATCH') {
            if (httpParams.requestMethod === 'PATCH') {
                httpParams.headersExtra = httpParams.headersExtra.set('Content-Type', APPLICATION_JSON_PATCH);
            }
            let headers = HttpClientUtils.getHeaders(httpParams.headersExtra);
            if (httpParams.body instanceof FormData) {
                headers = headers.delete('Content-Type');
            }
            return this.http.request(httpParams.requestMethod, HttpClientUtils.buildUrl(httpParams, this.urlResolver), {
                headers: headers,
                observe: 'response',
                body: httpParams.body,
                responseType: httpParams.responseType
            });
        }
    }
}
HttpClient.ɵfac = function HttpClient_Factory(t) { return new (t || HttpClient)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(UrlResolver), ɵngcc0.ɵɵinject(HttpClientInterceptorToken, 8)); };
HttpClient.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HttpClient, factory: HttpClient.ɵfac });
HttpClient.ctorParameters = () => [
    { type: HttpClient$1 },
    { type: UrlResolver },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [HttpClientInterceptorToken,] }] }
];

class WindowService {
    static getWindow() {
        return window;
    }
    getHref() {
        return window.location.href;
    }
    openTab(url) {
        return window.open(url, '_blank');
    }
    openTabWithContext(projectName, url) {
        return window.open(`/${projectName}/${BaseHref.extract().value}${url}`, '_blank');
    }
    getUserAgent() {
        return navigator.userAgent;
    }
    downloadBlob(url, fileName) {
        const link = document.createElement('a');
        document.body.appendChild(link);
        link.id = 'blobElement';
        link.style = 'display: none';
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    }
    refresh() {
        window.location.reload();
    }
    usingSSL() {
        return /^https.*/.test(window.location.protocol);
    }
    base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        let sliceSize = 1024;
        let byteCharacters = atob(base64Data);
        let bytesLength = byteCharacters.length;
        let slicesCount = Math.ceil(bytesLength / sliceSize);
        let byteArrays = new Array(slicesCount);
        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            let begin = sliceIndex * sliceSize;
            let end = Math.min(begin + sliceSize, bytesLength);
            let bytes = new Array(end - begin);
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
}
WindowService.ɵfac = function WindowService_Factory(t) { return new (t || WindowService)(); };
WindowService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: WindowService, factory: WindowService.ɵfac });

class BaseHref {
    constructor(entidade = 0, mes = new Date().getMonth() + 1, ano = new Date().getFullYear()) {
        this.entidade = entidade;
        this.mes = mes;
        this.ano = ano;
    }
    static getRegExp(projectName = '') {
        return RegExp(`${projectName}\/(e([0-9]+)m([0-9]+)a([0-9]+))`);
    }
    static setup(projectName) {
        const windowLocal = WindowService.getWindow();
        const { pathname, search } = window.location;
        const baseHref = BaseHref.extract();
        if (pathname.includes(projectName) &&
            !BaseHref.getRegExp(projectName).test(pathname)) {
            let newPath = pathname.replace(projectName, `${projectName}/${baseHref.value}`);
            if (!!search && !newPath.includes(search)) {
                newPath = `${newPath}${search}`;
            }
            windowLocal.history.replaceState({}, '', newPath);
        }
        return `/${projectName}/${baseHref.value}/`;
    }
    static extract() {
        const pathName = WindowService.getWindow().location.pathname;
        const baseHreftRegExp = BaseHref.getRegExp();
        if (baseHreftRegExp.test(pathName)) {
            const groups = baseHreftRegExp.exec(pathName);
            return new BaseHref(Number(groups[2]), Number(groups[3]), Number(groups[4]));
        }
        return new BaseHref().copy(Cookie.get(BaseHref.COOKIE_KEY));
    }
    static testCurrPath() {
        return BaseHref.getRegExp().test(WindowService.getWindow().location.pathname);
    }
    get value() {
        return `e${this.entidade}m${this.mes}a${this.ano}`;
    }
    change() {
        const pathName = WindowService.getWindow().location.pathname;
        Cookie.set(BaseHref.COOKIE_KEY, JSON.stringify(this), 7, '/', window.location.hostname);
        WindowService.getWindow().history.replaceState({}, '', pathName.replace(BaseHref.getRegExp().exec(pathName)[1], this.value));
        WindowService.getWindow().location.reload();
    }
    copy(json) {
        if (json) {
            let jsonObj = JSON.parse(json);
            for (let prop in jsonObj) {
                this[prop] = jsonObj[prop];
            }
        }
        return this;
    }
}
BaseHref.COOKIE_KEY = 'BASE_HREF';

class CommonComponent {
}
CommonComponent.ɵfac = function CommonComponent_Factory(t) { return new (t || CommonComponent)(); };
CommonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommonComponent, selectors: [["lib-common"]], decls: 2, vars: 0, template: function CommonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " common works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });

class CommonModule {
}
CommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CommonModule });
CommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CommonModule_Factory(t) { return new (t || CommonModule)(); }, imports: [[]] });

class AccordionComponent {
}
AccordionComponent.ɵfac = function AccordionComponent_Factory(t) { return new (t || AccordionComponent)(); };
AccordionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccordionComponent, selectors: [["elo-accordion"]], ngContentSelectors: _c0, decls: 3, vars: 0, consts: [[1, "advtree"], [1, "advtree-container"]], template: function AccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });

class AccordionItemComponent {
    constructor() {
        this.obj = {};
        this.disableClick = false;
        this.hasPermission = true;
        this.onChangeGroupSelected = new EventEmitter();
        this.confirmButtons = new EventEmitter();
        this.addButtons = new EventEmitter();
    }
    clickOnConfirmButtons(indice) {
        this.confirmButtons.emit({ indice });
    }
    changeGroupSelected(indice) {
        this.onChangeGroupSelected.emit({ indice });
    }
    clickOnAddButton(indice, event) {
        event.stopPropagation();
        this.addButtons.emit({ indice });
    }
}
AccordionItemComponent.ɵfac = function AccordionItemComponent_Factory(t) { return new (t || AccordionItemComponent)(); };
AccordionItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccordionItemComponent, selectors: [["elo-accordion-item"]], inputs: { obj: "obj", disableClick: "disableClick", hasPermission: "hasPermission" }, outputs: { onChangeGroupSelected: "onChangeGroupSelected", confirmButtons: "confirmButtons", addButtons: "addButtons" }, ngContentSelectors: _c0, decls: 11, vars: 4, consts: [[1, "advtree-header", 3, "click"], [1, "advtree-title"], [1, "id", "hint", "module-color", "top-left"], [1, "hint-content"], [1, "title"], [1, "advtree-actions"], ["id", "btnAdvtreeAdd", "class", "btn circle", 3, "click", 4, "ngIf"], ["id", "btnAdvtreeAdd", 1, "btn", "circle", 3, "click"], [1, "fa", "fa-plus"], [1, "btn-actions-label"]], template: function AccordionItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function AccordionItemComponent_Template_div_click_0_listener() { return ctx.changeGroupSelected(ctx.obj.indice); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3, "# ");
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵtemplate(9, AccordionItemComponent_button_9_Template, 4, 0, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(10);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate2(" #", ctx.obj.indice, " - ", ctx.obj.itemSelected ? ctx.obj.itemSelected : ctx.obj.titleDefault, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.obj.itemSelected ? ctx.obj.itemSelected : ctx.obj.titleDefault);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.obj.isEditing && ctx.hasPermission);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
AccordionItemComponent.propDecorators = {
    obj: [{ type: Input }],
    disableClick: [{ type: Input }],
    hasPermission: [{ type: Input }],
    onChangeGroupSelected: [{ type: Output }],
    confirmButtons: [{ type: Output }],
    addButtons: [{ type: Output }]
};

class FormLabelColumnComponent {
    constructor() {
        this.hintPosition = 'left';
        this.hintIconLeftAlign = false;
        this.linkTitle = '';
        this.showLink = false;
        this.onClickLink = new EventEmitter();
        this.offsetClass = '';
    }
    ngOnInit() {
        if (this.offset && this.offset.length > 0) {
            this.offsetClass = `col-md-offset-${this.offset}`;
        }
    }
    clickLink() {
        this.onClickLink.emit();
    }
}
FormLabelColumnComponent.ɵfac = function FormLabelColumnComponent_Factory(t) { return new (t || FormLabelColumnComponent)(); };
FormLabelColumnComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormLabelColumnComponent, selectors: [["elo-form-label-column"]], inputs: { hintPosition: "hintPosition", hintIconLeftAlign: "hintIconLeftAlign", linkTitle: "linkTitle", showLink: "showLink", label: "label", color: "color", column: "column", offset: "offset", hintMessage: "hintMessage" }, outputs: { onClickLink: "onClickLink" }, ngContentSelectors: _c0, decls: 8, vars: 10, consts: [[1, "form-group"], [1, "label"], [3, "class", 4, "ngIf"], ["class", "pull-right", 3, "click", 4, "ngIf"], [1, "hint-content", 3, "innerHTML"], [1, "pull-right", 3, "click"], ["id", "linkTitle"]], template: function FormLabelColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "label", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵtemplate(4, FormLabelColumnComponent_i_4_Template, 2, 4, "i", 2);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵtemplate(6, FormLabelColumnComponent_a_6_Template, 3, 1, "a", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate2("col-md-", ctx.column, " ", ctx.offsetClass, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("color", ctx.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", !ctx.hintIconLeftAlign ? ctx.label : "", " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hintMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.hintIconLeftAlign ? ctx.label : "", " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLink);
    } }, directives: [ɵngcc2.NgIf], styles: ["[_nghost-%COMP%] .hint:not(.input).sm{height:0}"] });
FormLabelColumnComponent.propDecorators = {
    label: [{ type: Input }],
    color: [{ type: Input }],
    column: [{ type: Input }],
    offset: [{ type: Input }],
    hintMessage: [{ type: Input }],
    hintPosition: [{ type: Input }],
    hintIconLeftAlign: [{ type: Input }],
    linkTitle: [{ type: Input }],
    showLink: [{ type: Input }],
    onClickLink: [{ type: Output }]
};

class FormLabelColumnModule {
}
FormLabelColumnModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FormLabelColumnModule });
FormLabelColumnModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FormLabelColumnModule_Factory(t) { return new (t || FormLabelColumnModule)(); }, imports: [[CommonModule$1]] });

// @dynamic
class StringUtils {
    static onlyLetters(value) {
        if (value) {
            let result = '';
            let matches = value.match(/[A-z]/g);
            if (matches) {
                matches.forEach(str => result += str);
            }
            return result;
        }
        return value;
    }
    static capitalizeEachWord(phrase) {
        if (!phrase) {
            return '';
        }
        return phrase.split(' ').map((word) => word.toUpperCase()[0] + word.slice(1)).join(' ');
    }
    static toLowerCaseFirstLetter(word) {
        if (!word) {
            return '';
        }
        return word.charAt(0).toLowerCase() + word.substring(1);
    }
    static join(values, delimiter) {
        return values.reduce((prev, current) => {
            if (prev && current) {
                return `${prev} ${delimiter} ${current}`;
            }
            else if (prev) {
                return prev;
            }
            else {
                return current;
            }
        });
    }
    static removeAccent(value) {
        const accents = `ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž´\`~^[]{}!@#$%¨&*()-=+'"/\\`;
        const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
        value.split('');
        let strAccentsOut = [];
        let strAccentsLen = value.length;
        for (let y = 0; y < strAccentsLen; y++) {
            if (accents.indexOf(value[y]) !== -1) {
                strAccentsOut[y] = accentsOut.substr(accents.indexOf(value[y]), 1);
            }
            else {
                strAccentsOut[y] = value[y];
            }
        }
        return strAccentsOut.join('');
    }
    static removeSpecialCharacters(value) {
        if (!value) {
            return;
        }
        let re = /\[|\]|{|}|\(|\)|~|\^|%|¨|#|`|"|&|/gi;
        return value.replace(re, '');
    }
    static replaceAll(target, search, replacement) {
        return target.split(search).join(replacement);
    }
    static countOccurrence(target, search) {
        let count = 0;
        for (let i = 0; target.length > i; i++) {
            if (target.charAt(i) === search) {
                count++;
            }
        }
        return count;
    }
    static getArrayId(input) {
        let match = input.match(StringUtils.idPattern);
        return match ? match.join(',') : '';
    }
    static removeArrayId(input) {
        return StringUtils.replaceAll(input, StringUtils.idPattern, '');
    }
    static removeArrayUUID(input) {
        return StringUtils.replaceAll(input, StringUtils.uuidPattern, '');
    }
    static getArrayUUID(input) {
        let match = input.match(StringUtils.uuidPattern);
        return match ? match.join(',') : '';
    }
}
StringUtils.idPattern = /\[\d+\]/g;
StringUtils.uuidPattern = /\[[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}\]/g;

const KEYCLOAK_AUTH_RESOURCES_CONFIG = new InjectionToken('keycloak-auth-resources.config');
const AUTH_RESOURCES_CONFIG = new InjectionToken('auth-resources.config');
const AUTH_RESOURCES_CONFIG_UNICO = {
    urlApi: '/api/authenticate',
    urlMe: '/api/usuarios/me',
    fieldsMe: 'id,usuario,email,nome,cargo,matricula,modulos.modulo.id,modulos.modulo.descricao,' +
        'modulos.modulo.path,modulos.modulo.url,grupos.nome,usuarioRecursos.nome',
    urlFormDefault: 'login/auth',
    tokenKey: 'authorization',
    hostDev: 'http://juggernaut.elotech.localnet',
    app: 'unico'
};
const AUTH_RESOURCES_CONFIG_ISS = {
    urlApi: '/api/authentication/login',
    urlX509Api: '/api/authentication/x509login',
    urlMe: '/api/usuarios/me',
    fieldsMe: 'nome,username',
    urlFormDefault: 'auth',
    tokenKey: 'authorization_iss',
    hostDev: 'http://localhost:4200',
    app: 'iss'
};
const AUTH_RESOURCES_CONFIG_PORTAL_SERVICOS = {
    urlApi: '/api/authenticate',
    urlMe: '/api/acesso-web/me',
    fieldsMe: 'id,cpf,nome,rg,orgaoEmissor,ufEmissor,identificacaoProfissional,tipoConselho,administrador,ativo,dataCadastro',
    urlFormDefault: 'autenticacao',
    tokenKey: 'authorization_ps',
    hostDev: 'http://localhost:4200',
    app: 'ps'
};

class AssertUtilsApp {
    static assert(value, description) {
        if (!value) {
            throw new Error('Assert fails ' + description);
        }
    }
}

const INVALID_VALUE = '#INVALID&VALUE#';
function autoCompleteValidator(c) {
    return (c.value === INVALID_VALUE) ? {
        'Valor inválido': {
            valid: false
        }
    } : null;
}
class AutoCompleteComponent {
    constructor(authResourcesConfig, renderer, elementRef) {
        this.authResourcesConfig = authResourcesConfig;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.multiplo = false;
        this.multipleSelected = [];
        this.onChangeMultipleValue = new EventEmitter();
        this.options = [];
        this.placeholder = '';
        this.noResultsMessage = 'Nenhum resultado.';
        this.urlCreate = '';
        this.onChangeValue = new EventEmitter();
        this.onSearchModal = new EventEmitter();
        this.searchModal = false;
        this.isDisabled = false;
        this.findToOptions = null;
        this.objToOption = null;
        this.debounceTime = 200;
        this.autoSelect = false;
        this.isEnabledCreateRecord = false;
        this.descriptionNewRecord = null;
        this.validateDeps = false;
        this.onInsertButton = new EventEmitter();
        this.onCreateRecord = new EventEmitter();
        this.emptyRecord = false;
        this.removeDot = false;
        this.showItens = false;
        this.loading = false;
        this.selectedIndex = 0;
        this.lastSubscription = null;
        this.onValueChange = new Subject();
        this.removeDotIfNecessary = (searchValue) => {
            if (this.removeDot) {
                searchValue = StringUtils.replaceAll(searchValue, '.', '');
            }
            return searchValue;
        };
        this.onChange = () => null;
    }
    validServiceOrMethods() {
        if (this.options.length === 0 && !this.service && (!this.findToOptions || !this.objToOption)) {
            AssertUtilsApp.assert(this.service, 'service not found in autoComplete');
            AssertUtilsApp.assert(this.findToOptions, 'findToOptions not found in autoComplete');
            AssertUtilsApp.assert(this.objToOption, 'objToOption not found in autoComplete');
        }
    }
    ngOnInit() {
        this.unRegisterGlobalClick = this.renderer.listen('body', 'click', (event) => {
            if (!this.elementRef.nativeElement.contains(event.target)) {
                this.showItens = false;
            }
        });
        if (!('__karma__' in window) || this.validateDeps) {
            this.validServiceOrMethods();
        }
        if (this.service) {
            this.findToOptions = (searchValue) => this.service.findToOptions(this.removeDotIfNecessary(searchValue));
            this.objToOption = (item) => this.service.objToOption(item);
            if (this.autoSelect) {
                setTimeout(() => {
                    this.service.findToOptions('').pipe(filter(data => !!data)).subscribe(data => {
                        this.dataFromService = data;
                        this.dataFromService.forEach(obj => this.options.push(this.objToOption(obj)));
                        if (this.dataFromService.length === 1) {
                            this.value = this.objToOption(data[0]);
                        }
                    });
                }, 100);
            }
        }
        this.onValueChange.pipe(debounceTime(this.debounceTime))
            .subscribe(value => {
            if (this.lastSubscription && !this.lastSubscription.closed) {
                this.lastSubscription.unsubscribe();
            }
            if (!value) {
                this.onChange(null);
            }
            this.loading = true;
            this.lastSubscription = this.findToOptions(this.sanitizeValue(this.internalValue))
                .subscribe(data => {
                this.handleData(data);
                this.loading = false;
            }, err => {
                this.loading = false;
                throw err;
            });
        });
    }
    ngOnDestroy() {
        this.unRegisterGlobalClick();
    }
    setDescriptionNewRecordAction() {
        if (this.descriptionNewRecord) {
            return 'Incluir ' + this.descriptionNewRecord;
        }
        else {
            return 'Incluir cadastro';
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    get value() {
        return this.internalValue;
    }
    set value(value) {
        this.internalValue = value;
        if (this.findToOptions) {
            if (this.options.indexOf(this.internalValue) >= 0) {
                this.attrToModel();
            }
            else {
                this.onValueChange.next(this.internalValue ? this.internalValue : null);
            }
        }
        else {
            this.attrToModel();
        }
    }
    get noResults() {
        if (this.findToOptions) {
            return this.options.length === 0 && this.lastSubscription && this.lastSubscription.closed;
        }
        return this.options.length === 0;
    }
    onClickClear() {
        if (!this.isDisabled) {
            this.value = '';
            this.onChange(null);
            this.onChangeValue.emit(null);
        }
    }
    writeValue(obj) {
        if (this.objToOption) {
            if (obj) {
                this.internalValue = this.objToOption(obj);
            }
            else {
                this.internalValue = '';
            }
        }
        else {
            this.internalValue = obj;
        }
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    onFocus() {
        if (!this.hasValue()) {
            this.onValueChange.next(this.internalValue);
        }
    }
    onKeyDown(event) {
        if (this.options.length > 0) {
            if ((event.key === 'Tab' || event.key === 'Enter') && this.showItens) {
                event.preventDefault();
                this.onSelect(this.options[this.selectedIndex]);
                if (this.observer)
                    this.observer.disconnect();
            }
            else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                if (event.key === 'ArrowUp') {
                    this.selectedIndex--;
                }
                else {
                    this.selectedIndex++;
                }
                if (this.selectedIndex < 0) {
                    this.selectedIndex = 0;
                }
                else if (this.selectedIndex === this.options.length) {
                    this.selectedIndex = this.options.length - 1;
                }
                if (this.showItens) {
                    this.observer = new MutationObserver(mutations => {
                        mutations.forEach(() => {
                            this._scrollIntoView(this.listOption.nativeElement, document.querySelector('#autocomplete-container li.selected'));
                        });
                    });
                    this.observer.observe(document.querySelector('#autocomplete-container li.selected'), {
                        attributes: true
                    });
                }
            }
            else if (event.key === 'Escape') {
                this.showItens = false;
                if (this.observer)
                    this.observer.disconnect();
            }
        }
    }
    onSelect(option) {
        this.value = option;
        this.showItens = false;
        this.onChangeValue.emit(this.value);
        this.addToMultiplo(option);
    }
    addToMultiplo(option) {
        if (!this.multiplo) {
            return;
        }
        if (this.multiplo && option) {
            const found = this.multipleSelected.find(op => this.objToOption(op) === option);
            if (!found) {
                const index = this.options.indexOf(option);
                if (index !== -1) {
                    const object = this.dataFromService[index];
                    this.multipleSelected.push(object);
                    this.onChangeMultipleValue.emit(this.multipleSelected);
                }
            }
            this.value = '';
        }
    }
    removeItemFromMultiplo(option) {
        if (option) {
            this.multipleSelected = this.multipleSelected
                .filter(op => {
                if (op && op.id && option.id) {
                    return op.id !== option.id;
                }
                if (op && op.uuid && option.uuid) {
                    return op.uuid !== option.uuid;
                }
                return JSON.stringify(op) !== JSON.stringify(option);
            });
            this.onChangeMultipleValue.emit(this.multipleSelected);
        }
    }
    hasValue() {
        return !!this.internalValue;
    }
    openCreate(event) {
        event.preventDefault();
        window.open(this.authResourcesConfig.isDev ? `${this.authResourcesConfig.hostDev}${this.urlCreate}` : `${window.location.origin}${this.urlCreate}`);
    }
    openCreateModal() {
        this.onCreateRecord.emit(this.value);
    }
    hasUrlCreate() {
        return this.urlCreate.length > 0;
    }
    onClickSearch() {
        this.onSearchModal.emit();
    }
    _isDocumentElement(el) {
        return [document.documentElement, document.body, window].indexOf(el) > -1;
    }
    _scrollTo(el, top) {
        if (this._isDocumentElement(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    sanitizeValue(value) {
        const replaceValues = [
            { value: '%', replace: '\%25' },
            { value: '*', replace: '\*' },
            { value: '[', replace: '\%5B' },
            { value: ']', replace: '\%5D' },
            { value: '"', replace: '' },
            { value: '\\', replace: '%5C' },
            { value: '#', replace: '%23' },
            { value: '&', replace: '%26' }
        ];
        if (this.removeDot) {
            replaceValues.push({ value: '.', replace: '' });
        }
        let valueChange = value;
        replaceValues.forEach(r => valueChange = valueChange.split(r.value).join(r.replace));
        return valueChange;
    }
    _scrollIntoView(parentElement, childFocusedElement) {
        const parentRect = parentElement.getBoundingClientRect();
        const focusedRect = childFocusedElement.getBoundingClientRect();
        const overScroll = childFocusedElement.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > parentRect.bottom) {
            this._scrollTo(parentElement, Math.min(childFocusedElement.offsetTop +
                childFocusedElement.clientHeight -
                parentElement.offsetHeight +
                overScroll, parentElement.scrollHeight));
        }
        else if (focusedRect.top - overScroll < parentRect.top) {
            this._scrollTo(parentElement, Math.max(childFocusedElement.offsetTop - overScroll, 0));
        }
    }
    attrToModel() {
        if ((this.options.indexOf(this.internalValue) >= 0) || (!this.internalValue)) {
            if (this.dataFromService && this.internalValue) {
                this.onChange(this.dataFromService[this.options.indexOf(this.internalValue)]);
            }
            else {
                this.onChange(this.internalValue ? this.internalValue : null);
            }
        }
        else {
            this.onChange(INVALID_VALUE);
        }
    }
    handleData(data) {
        this.dataFromService = data;
        this.options = [];
        this.dataFromService.forEach(obj => this.options.push(this.objToOption(obj)));
        this.attrToModel();
        this.showItens = this.options.length > 0 || this.isEnabledCreateRecord;
        this.selectedIndex = 0;
        this.listOption.nativeElement.scrollTop = 0;
    }
}
AutoCompleteComponent.ɵfac = function AutoCompleteComponent_Factory(t) { return new (t || AutoCompleteComponent)(ɵngcc0.ɵɵdirectiveInject(AUTH_RESOURCES_CONFIG), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AutoCompleteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AutoCompleteComponent, selectors: [["elo-autocomplete"]], viewQuery: function AutoCompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listOption = _t.first);
    } }, inputs: { multiplo: "multiplo", multipleSelected: "multipleSelected", options: "options", placeholder: "placeholder", noResultsMessage: "noResultsMessage", urlCreate: "urlCreate", searchModal: "searchModal", isDisabled: "isDisabled", findToOptions: "findToOptions", objToOption: "objToOption", debounceTime: "debounceTime", autoSelect: "autoSelect", isEnabledCreateRecord: "isEnabledCreateRecord", descriptionNewRecord: "descriptionNewRecord", validateDeps: "validateDeps", emptyRecord: "emptyRecord", removeDot: "removeDot", id: "id", error: "error", service: "service", insertIcon: "insertIcon", extraInfos: "extraInfos" }, outputs: { onChangeMultipleValue: "onChangeMultipleValue", onChangeValue: "onChangeValue", onSearchModal: "onSearchModal", onInsertButton: "onInsertButton", onCreateRecord: "onCreateRecord" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: AutoCompleteComponent },
            { provide: NG_VALIDATORS, multi: true, useValue: autoCompleteValidator }
        ])], ngContentSelectors: _c0, decls: 12, vars: 22, consts: [["id", "autocomplete-container"], ["class", "multiple", 4, "ngIf"], ["type", "text", "autocomplete", "off", "autocorrect", "off", "spellcheck", "off", 3, "id", "ngClass", "ngModel", "placeholder", "disabled", "click", "focus", "ngModelChange", "keydown"], ["class", "fa fa-circle-o-notch spinner", 4, "ngIf"], ["class", "fa fa-search input-icon", "id", "search", 3, "click", 4, "ngIf"], ["class", "fa fa-times input-icon", "aria-hidden", "true", 3, "id", "click", 4, "ngIf"], [1, "autocomplete"], ["listOption", ""], ["class", "autocomplete-item", "id", "option_empty", 4, "ngIf"], [4, "ngIf"], ["class", "help-message", 4, "ngIf"], [1, "multiple"], ["class", "btn positive round interactive inline full-xs option", 3, "title", "click", 4, "ngFor", "ngForOf"], [1, "btn", "positive", "round", "interactive", "inline", "full-xs", "option", 3, "title", "click"], [1, "fa", "fa-circle-o-notch", "spinner"], ["id", "search", 1, "fa", "fa-search", "input-icon", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-times", "input-icon", 3, "id", "click"], ["id", "option_empty", 1, "autocomplete-item"], ["class", "autocomplete-item item-new", 3, "click", 4, "ngIf"], ["class", "autocomplete-item", 3, "selected", "id", "click", 4, "ngFor", "ngForOf"], [1, "autocomplete-item", "item-new", 3, "click"], [1, "fa", "fa-plus-circle"], [1, "autocomplete-item", 3, "id", "click"], ["class", "extra-info split-letter right", 3, "id", 4, "ngIf"], [1, "extra-info", "split-letter", "right", 3, "id"], [1, "help-message"], ["href", "#", 3, "click", 4, "ngIf"], ["href", "#", 3, "click"]], template: function AutoCompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AutoCompleteComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("click", function AutoCompleteComponent_Template_input_click_2_listener() { return ctx.onFocus(); })("focus", function AutoCompleteComponent_Template_input_focus_2_listener() { return ctx.onFocus(); })("ngModelChange", function AutoCompleteComponent_Template_input_ngModelChange_2_listener($event) { return ctx.value = $event; })("keydown", function AutoCompleteComponent_Template_input_keydown_2_listener($event) { return ctx.onKeyDown($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, AutoCompleteComponent_i_3_Template, 1, 0, "i", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵtemplate(5, AutoCompleteComponent_i_5_Template, 1, 0, "i", 4);
        ɵngcc0.ɵɵtemplate(6, AutoCompleteComponent_i_6_Template, 1, 1, "i", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6, 7);
        ɵngcc0.ɵɵtemplate(9, AutoCompleteComponent_li_9_Template, 2, 1, "li", 8);
        ɵngcc0.ɵɵtemplate(10, AutoCompleteComponent_div_10_Template, 3, 2, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, AutoCompleteComponent_div_11_Template, 3, 2, "div", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiplo && ctx.multipleSelected && ctx.multipleSelected.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("error", ctx.error)("loading", ctx.loading)("has-input-icon", (ctx.searchModal || ctx.hasValue()) && !ctx.isDisabled && !ctx.loading);
        ɵngcc0.ɵɵpropertyInterpolate1("id", "", ctx.id, "_input");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(20, _c2, ctx.searchModal))("ngModel", ctx.value)("placeholder", ctx.placeholder)("disabled", ctx.isDisabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchModal && !ctx.isDisabled && !ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasValue() && !ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("open", ctx.showItens);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", (!ctx.options || ctx.options.length === 0) && ctx.emptyRecord);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showItens);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.emptyRecord && (ctx.noResults && (!ctx.isEnabledCreateRecord || ctx.hasUrlCreate())));
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.DefaultValueAccessor, ɵngcc2.NgClass, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc2.NgForOf], styles: [".error[_ngcontent-%COMP%] {\n        border: 1px solid red;\n      }\n      .multiple[_ngcontent-%COMP%] {\n        max-height: 98px;\n        overflow: scroll;\n      }\n      .multiple[_ngcontent-%COMP%], .option[_ngcontent-%COMP%] {\n        margin-bottom: 2px;\n        font-size: 10px;\"\n      }"] });
AutoCompleteComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_RESOURCES_CONFIG,] }] },
    { type: Renderer2 },
    { type: ElementRef }
];
AutoCompleteComponent.propDecorators = {
    multiplo: [{ type: Input }],
    multipleSelected: [{ type: Input }],
    onChangeMultipleValue: [{ type: Output }],
    id: [{ type: Input }],
    options: [{ type: Input }],
    error: [{ type: Input }],
    service: [{ type: Input }],
    placeholder: [{ type: Input }],
    noResultsMessage: [{ type: Input }],
    urlCreate: [{ type: Input }],
    onChangeValue: [{ type: Output }],
    onSearchModal: [{ type: Output }],
    searchModal: [{ type: Input }],
    isDisabled: [{ type: Input }],
    findToOptions: [{ type: Input }],
    objToOption: [{ type: Input }],
    debounceTime: [{ type: Input }],
    autoSelect: [{ type: Input }],
    isEnabledCreateRecord: [{ type: Input }],
    descriptionNewRecord: [{ type: Input }],
    validateDeps: [{ type: Input }],
    insertIcon: [{ type: Input }],
    onInsertButton: [{ type: Output }],
    onCreateRecord: [{ type: Output }],
    extraInfos: [{ type: Input }],
    emptyRecord: [{ type: Input }],
    removeDot: [{ type: Input }],
    listOption: [{ type: ViewChild, args: ['listOption', { static: true },] }]
};

class AutoCompleteModule {
}
AutoCompleteModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AutoCompleteModule });
AutoCompleteModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AutoCompleteModule_Factory(t) { return new (t || AutoCompleteModule)(); }, imports: [[CommonModule$1, FormsModule]] });

class PanelComponent {
    constructor() {
        this.pbNone = false;
    }
}
PanelComponent.ɵfac = function PanelComponent_Factory(t) { return new (t || PanelComponent)(); };
PanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PanelComponent, selectors: [["elo-panel"]], inputs: { pbNone: "pbNone", title: "title", hasTable: "hasTable", hasForm: "hasForm" }, ngContentSelectors: _c0, decls: 4, vars: 7, consts: [[1, "panel", 3, "ngClass"], ["class", "panel-title", 4, "ngIf"], [1, "panel-body"], [1, "panel-title"]], template: function PanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, PanelComponent_h2_1_Template, 2, 1, "h2", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c3, ctx.hasTable, ctx.hasForm));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("pb-none", ctx.pbNone);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf], encapsulation: 2 });
PanelComponent.propDecorators = {
    title: [{ type: Input }],
    hasTable: [{ type: Input }],
    hasForm: [{ type: Input }],
    pbNone: [{ type: Input }]
};

class PanelModule {
}
PanelModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PanelModule });
PanelModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PanelModule_Factory(t) { return new (t || PanelModule)(); }, imports: [[CommonModule$1]] });

class AccordionModule {
}
AccordionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AccordionModule });
AccordionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AccordionModule_Factory(t) { return new (t || AccordionModule)(); }, providers: [], imports: [[
            CommonModule$1,
            FormLabelColumnModule,
            AutoCompleteModule,
            PanelModule
        ]] });

/**
 * Created by douglas on 17/06/2016.
 */
class PageParameters {
    constructor(size, page, sort) {
        this.size = 5;
        this.page = 1;
        this.sort = '';
        this.sortWithTranslation = '';
        this.size = size;
        this.page = page;
        this.sort = sort;
    }
    static newPage(size) {
        return new PageParameters(size, 0, 'ASC');
    }
    toUrlParameters() {
        let urlParameters = `size=${this.size}`;
        if (this.page) {
            urlParameters += `&page=${this.page}`;
        }
        if (this.sort) {
            urlParameters += `&sort=${this.sortWithTranslation ? this.sortWithTranslation : this.sort}`;
        }
        return urlParameters;
    }
}

const deepCopy = (object) => {
    return JSON.parse(JSON.stringify(object));
};
const deepEqual = equal;

const operationOrder = [1, 0, 2];
var JsonUpdateOperation;
(function (JsonUpdateOperation) {
    JsonUpdateOperation[JsonUpdateOperation["ADD"] = 0] = "ADD";
    JsonUpdateOperation[JsonUpdateOperation["REPLACE"] = 1] = "REPLACE";
    JsonUpdateOperation[JsonUpdateOperation["REMOVE"] = 2] = "REMOVE";
})(JsonUpdateOperation || (JsonUpdateOperation = {}));
class JsonUpdatePartial {
    static replace(value, path) {
        return JsonUpdatePartial.of(JsonUpdateOperation.REPLACE, value, path);
    }
    static add(value, path) {
        return JsonUpdatePartial.of(JsonUpdateOperation.ADD, value, path);
    }
    static remove(value, path) {
        return JsonUpdatePartial.of(JsonUpdateOperation.REMOVE, value, path);
    }
    static of(operation, value, path) {
        if (!path) {
            return null;
        }
        const jsonPartial = new JsonUpdatePartial();
        jsonPartial.op = operation;
        jsonPartial.path = path;
        jsonPartial.value = value;
        if (jsonPartial.op === JsonUpdateOperation.REMOVE) {
            jsonPartial.value = undefined;
        }
        return jsonPartial;
    }
    compare(other) {
        const order = operationOrder[this.op.valueOf()];
        const orderOther = operationOrder[other.op.valueOf()];
        if (order > orderOther) {
            return -1;
        }
        else if (order < orderOther) {
            return 1;
        }
        let compare = 0;
        if (this.op === JsonUpdateOperation.REMOVE) {
            compare = other.path.localeCompare(this.path, 'en-US');
        }
        else {
            compare = this.path.localeCompare(other.path);
        }
        if (compare === 0 && this.value) {
            return this.value.localeCompare(other.value);
        }
        return compare;
    }
}

const CONTAINS_OPERATION = 1;
const EQUAL_OPERATION = 2;
const NOT_EQUAL_OPERATION = 3;
const GREATER_OPERATION = 4;
const LESS_OPERATION = 5;
const GREATER_OR_EQUAL_OPERATION = 6;
const LESS_OR_EQUAL_OPERATION = 7;
const STARTS_WITH_OPERATION = 8;
const ENDS_WITH_OPERATION = 9;
const NOT_CONTAINS_OPERATION = 10;
const CONTAINED_IN_OPERATION = 11;
const NOT_CONTAINED_IN_OPERATION = 12;
const CONTAINS_CAPTION = 'Contém';
const NOT_CONTAINS_CAPTION = 'Não contém';
const STARTS_WITH_CAPTION = 'Inicia com';
const ENDS_WITH_CAPTION = 'Termina com';
const CONTAINED_IN_CAPTION = 'Contido em';
const NOT_CONTAINED_IN_CAPTION = 'Não contido em';

class OperatorsFilter {
    getOperatorsByType() {
        const operatorsByType = new Map();
        operatorsByType.set(['String'], this.getOperation(CONTAINS_OPERATION));
        operatorsByType.set(['String'], this.getOperation(NOT_CONTAINS_OPERATION));
        operatorsByType.set(['String'], this.getOperation(STARTS_WITH_OPERATION));
        operatorsByType.set(['String'], this.getOperation(ENDS_WITH_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'String', 'LocalDate', 'LocalDateTime', 'Enum', 'Boolean', 'Integer'], this.getOperation(EQUAL_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'String', 'LocalDate', 'LocalDateTime', 'Enum', 'Boolean', 'Integer'], this.getOperation(NOT_EQUAL_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'LocalDate', 'Date', 'LocalTime', 'LocalDateTime', 'Integer'], this.getOperation(GREATER_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'LocalDate', 'Date', 'LocalTime', 'LocalDateTime', 'Integer'], this.getOperation(LESS_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'LocalDate', 'Date', 'LocalDateTime', 'Integer'], this.getOperation(GREATER_OR_EQUAL_OPERATION));
        operatorsByType.set(['Long', 'BigDecimal', 'Double', 'LocalDate', 'Date', 'LocalDateTime', 'Integer'], this.getOperation(LESS_OR_EQUAL_OPERATION));
        operatorsByType.set(['Long', 'Integer'], this.getOperation(CONTAINED_IN_OPERATION));
        operatorsByType.set(['Long', 'Integer'], this.getOperation(NOT_CONTAINED_IN_OPERATION));
        return operatorsByType;
    }
    getFilterItemByType() {
        const filterItemByType = new Map();
        filterItemByType.set(['Long'], 'text');
        filterItemByType.set(['BigDecimal'], 'number');
        filterItemByType.set(['Double'], 'number');
        filterItemByType.set(['String'], 'text');
        filterItemByType.set(['LocalDate'], 'date');
        filterItemByType.set(['Date'], 'date');
        filterItemByType.set(['LocalDateTime'], 'dateTime');
        filterItemByType.set(['LocalTime'], 'time');
        filterItemByType.set(['Enum'], '');
        filterItemByType.set(['Boolean'], '');
        filterItemByType.set(['Integer'], 'text');
        return filterItemByType;
    }
    getOperation(id) {
        return Object.assign(Object.assign({}, this.getOperations().get(id)), { id: id });
    }
    getOperations() {
        const operations = new Map();
        operations.set(CONTAINS_OPERATION, { caption: CONTAINS_CAPTION, value: '==' });
        operations.set(NOT_CONTAINS_OPERATION, { caption: NOT_CONTAINS_CAPTION, value: '!=' });
        operations.set(EQUAL_OPERATION, { caption: 'Igual', value: '==' });
        operations.set(NOT_EQUAL_OPERATION, { caption: 'Diferente', value: '!=' });
        operations.set(GREATER_OPERATION, { caption: 'Maior', value: '>' });
        operations.set(LESS_OPERATION, { caption: 'Menor', value: '<' });
        operations.set(GREATER_OR_EQUAL_OPERATION, { caption: 'Maior ou Igual', value: '>=' });
        operations.set(LESS_OR_EQUAL_OPERATION, { caption: 'Menor ou Igual', value: '<=' });
        operations.set(STARTS_WITH_OPERATION, { caption: STARTS_WITH_CAPTION, value: '==' });
        operations.set(ENDS_WITH_OPERATION, { caption: ENDS_WITH_CAPTION, value: '==' });
        operations.set(CONTAINED_IN_OPERATION, { caption: CONTAINED_IN_CAPTION, value: '=ci=' });
        operations.set(NOT_CONTAINED_IN_OPERATION, { caption: NOT_CONTAINED_IN_CAPTION, value: '=nci=' });
        return operations;
    }
}
const operatorsFilter = new OperatorsFilter();

class SearchFilter {
    constructor() {
        this.useQueryParams = true;
        this.strFiltroPage = '';
        this.urlOriginal = '';
    }
    setUseQueryParams(useQueryParams) {
        this.useQueryParams = useQueryParams;
    }
    onFilter(filters, location, activatedRoute, routerService, changeLocation) {
        this.attrFilters(filters);
        if (!this.urlOriginal) {
            this.urlOriginal = location.path(true);
            if (this.hasFilter(activatedRoute)) {
                const filter = activatedRoute.snapshot.queryParams['filter'];
                this.urlOriginal = this.useQueryParams ? this.urlOriginal.replace('?filter=', '').replace('&filter=', '').replace(filter, '') : this.urlOriginal;
            }
        }
        if (changeLocation) {
            if (filters.length > 0 && this.useQueryParams) {
                const signal = this.urlOriginal.includes('?') ? '&' : '?';
                const newUrl = this.urlOriginal + signal + 'filter=' + this.serializeFilters(filters);
                location.replaceState(newUrl);
                routerService.setCurrentRoute(newUrl);
            }
            else {
                location.replaceState(this.urlOriginal);
                routerService.setCurrentRoute(this.urlOriginal);
            }
        }
        return this.strFiltroPage;
    }
    handleModel(model, fieldsToDisplay) {
        this.fieldsModels = [];
        if (model && model.fields) {
            for (let i = 0; i < fieldsToDisplay.length; i++) {
                this.addFieldModel(model, fieldsToDisplay[i]);
            }
        }
        return this.fieldsModels;
    }
    attrFilters(filters) {
        let strfiltro = '';
        for (let filter in filters) {
            if (strfiltro !== '') {
                strfiltro = strfiltro + ' and ';
            }
            const operator = operatorsFilter.getOperations().get(filters[filter].op);
            let searchValue = filters[filter].value;
            switch (operator.caption) {
                case CONTAINS_CAPTION:
                case NOT_CONTAINS_CAPTION:
                    searchValue = '*' + StringUtils.removeSpecialCharacters(searchValue) + '*';
                    break;
                case STARTS_WITH_CAPTION:
                    searchValue = StringUtils.removeSpecialCharacters(searchValue) + '*';
                    break;
                case ENDS_WITH_CAPTION:
                    searchValue = '*' + StringUtils.removeSpecialCharacters(searchValue);
            }
            if (this.hasWhiteSpaces(searchValue)) {
                searchValue = `"${searchValue}"`;
            }
            switch (operator.caption) {
                case CONTAINED_IN_CAPTION:
                case NOT_CONTAINED_IN_CAPTION:
                    strfiltro += this.getContainedInFilter(filters[filter].field, searchValue, operator.caption);
                    break;
                default:
                    strfiltro += filters[filter].field + operator.value + searchValue;
            }
        }
        this.strFiltroPage = strfiltro;
        return this.strFiltroPage;
    }
    serializeFilters(filters) {
        return filters.map(filter => `${filter.field};${filter.op};${filter.value}`).toString();
    }
    addFieldModel(model, fieldsToDisplay, caption) {
        let modelField = model.fields[fieldsToDisplay];
        if (modelField) {
            this.pushFieldModel(caption, modelField);
        }
        else {
            let fieldsSplit = fieldsToDisplay.split('.');
            if (fieldsSplit[0] === fieldsToDisplay) {
                this.pushFieldModel('', Object.assign(Object.assign({}, model), { fieldFullPath: `${model.fieldName}.${fieldsToDisplay}`, calculatedModel: true }));
            }
            else {
                let modelFieldChild = model.fields[fieldsSplit[0]];
                let fieldsToSplitNexLevel = fieldsSplit.splice(1, fieldsSplit.length);
                let fieldToDisplayChild = fieldsToSplitNexLevel.join('.');
                if (modelFieldChild) {
                    this.addFieldModel(modelFieldChild, fieldToDisplayChild, modelFieldChild.caption);
                }
            }
        }
    }
    pushFieldModel(caption, modelField) {
        this.fieldsModels.push({
            caption: caption ? `${caption} ${modelField.caption}` : modelField.caption,
            dataType: modelField.dataType,
            fieldPath: modelField.calculatedModel ? modelField.fieldPath : modelField.fieldFullPath,
            enumOptions: modelField.enumOptions,
            isEnum: this.isEnum(modelField),
            booleanOptions: modelField.booleanOptions,
            isBoolean: modelField.dataType === 'Boolean' ? true : false,
            isCalculatedModel: modelField.calculatedModel,
            fieldName: modelField.fieldFullPath,
            removeDot: modelField.removeDot || false
        });
    }
    isEnum(modelField) {
        return modelField.enumOptions ? modelField.enumOptions.length > 0 : false;
    }
    hasWhiteSpaces(value) {
        return value.indexOf && value.indexOf(' ') >= 0;
    }
    hasFilter(activatedRoute) {
        return activatedRoute.snapshot.queryParams && activatedRoute.snapshot.queryParams['filter'];
    }
    getContainedInFilter(field, searchValue, operator) {
        const BETWEEN_REGEX = new RegExp(/^(\d+-\d+)$/);
        let betweenList = [];
        let inList = [];
        let retorno = '';
        searchValue.split(',').forEach(item => {
            if (BETWEEN_REGEX.test(item)) {
                betweenList.push(item);
            }
            else {
                inList.push(item);
            }
        });
        if (inList.length > 0) {
            if (operator === CONTAINED_IN_CAPTION) {
                retorno += `${field}=in=(${inList.join(',')})`;
            }
            else {
                retorno += `${field}=out=(${inList.join(',')})`;
            }
        }
        if (betweenList.length > 0) {
            betweenList.forEach(item => {
                let interval = item.split('-');
                if (retorno.length > 0) {
                    if (operator === CONTAINED_IN_CAPTION) {
                        retorno += ' or ';
                    }
                    else {
                        retorno += ' and ';
                    }
                }
                if (operator === CONTAINED_IN_CAPTION) {
                    retorno += `(${field}>=${interval[0]} and ${field}<=${interval[1]})`;
                }
                else {
                    retorno += `(${field}<${interval[0]} or ${field}>${interval[1]})`;
                }
            });
        }
        return `(${retorno})`;
    }
}

class RevisionCompare {
    constructor(path, current, before, after, operation) {
        this.path = path;
        this.current = current;
        this.before = before;
        this.after = after;
        this.operation = operation;
    }
}

class JsonUtil {
    static removeNullKeys(obj) {
        if (obj) {
            for (let propName in obj) {
                if (obj[propName] === null || typeof obj[propName] === 'undefined' || obj[propName] === '') {
                    delete obj[propName];
                }
                else if (Array.isArray(obj[propName])) {
                    let arrayValue = obj[propName];
                    arrayValue.forEach(obj => JsonUtil.removeNullKeys(obj));
                }
                else if (typeof obj[propName] === 'object' && !Array.isArray(obj[propName])) {
                    JsonUtil.removeNullKeys(obj[propName]);
                    if (Object.keys(obj[propName]).length === 0) {
                        delete obj[propName];
                    }
                }
            }
        }
        return obj;
    }
    static orderArraysById(obj) {
        if (obj) {
            for (let propName in obj) {
                if (Array.isArray(obj[propName])) {
                    obj[propName].sort((a, b) => {
                        const valueA = JsonUtil.coalesce(a['id']);
                        const valueB = JsonUtil.coalesce(b['id']);
                        if (valueA < valueB) {
                            return -1;
                        }
                        if (valueA > valueB) {
                            return 1;
                        }
                        return 0;
                    });
                    obj[propName].forEach(e => JsonUtil.orderArraysById(e));
                }
            }
        }
    }
    static flattern(input) {
        let result = {};
        JsonUtil.recurse(input, '', result);
        return result;
    }
    static recurse(current, property, result) {
        if (Object(current) !== current) {
            result[property] = current;
        }
        else if (Array.isArray(current)) {
            // tslint:disable-next-line: no-var-keyword
            for (var i = 0, j = current.length; i < j; i++) {
                JsonUtil.recurse(current[i], `${property}[${current[i].id ? current[i].id : i}]`, result);
            }
            if (j === 0)
                result[property] = [];
        }
        else {
            let isEmpty = true;
            for (let p in current) {
                isEmpty = false;
                let prop = property ? property + '.' + p : p;
                prop = StringUtils.removeArrayUUID(prop);
                prop = StringUtils.removeArrayId(prop);
                prop = StringUtils.replaceAll(prop, ' ', '');
                JsonUtil.recurse(current[p], property ? property + ' .' + p : p, result);
            }
            if (isEmpty && property)
                result[property] = {};
        }
    }
    static compareJson(before, after) {
        const result = {};
        if (Object.is(before, after)) {
            return undefined;
        }
        if (!after || typeof after !== 'object') {
            return after;
        }
        Object.keys(before || {}).concat(Object.keys(after || {})).forEach(key => {
            if (after[key] !== before[key] && !Object.is(before[key], after[key])) {
                result[key] = after[key];
            }
            if (typeof after[key] === 'object' && typeof before[key] === 'object') {
                const value = JsonUtil.compareJson(before[key], after[key]);
                if (value !== undefined) {
                    result[key] = value;
                }
            }
        });
        return result;
    }
    static replaceKeyWithFieldModel(json, fieldsModel) {
        let result = {};
        let jsonFlatted = this.flattern(json);
        Object.keys(jsonFlatted).forEach(oldJsonKey => {
            let id = `${StringUtils.getArrayUUID(oldJsonKey)}${StringUtils.getArrayId(oldJsonKey)}`;
            let cleanedKey = StringUtils.replaceAll(StringUtils.removeArrayId(StringUtils.removeArrayUUID(oldJsonKey)), ' ', '');
            let newJsonKey = new SearchFilter().handleModel(fieldsModel, [cleanedKey]);
            if (newJsonKey && newJsonKey.length === 1) {
                result[`${newJsonKey[0].caption} ${id}`] = jsonFlatted[oldJsonKey];
            }
            else {
                result[`${newJsonKey} ${id}`] = jsonFlatted[oldJsonKey];
            }
        });
        return result;
    }
    static findCaptionForKeyOnJson(key, modelObj) {
        if (modelObj.fields[key].caption) {
            return modelObj.fields[key].caption;
        }
        else {
            this.findCaptionForKeyOnJson(key, modelObj);
        }
    }
    static getComparisonsFromJson(before, after) {
        let flatterBefore = JsonUtil.flattern(before);
        let flatterAfter = JsonUtil.flattern(after);
        let comparison = JsonUtil.compareJson(flatterBefore, flatterAfter);
        let comparisons = [];
        Object.keys(comparison).forEach((key) => {
            if (Array.isArray(flatterBefore[key]) && flatterBefore[key].length === 0 && !flatterAfter[key]) {
                return;
            }
            if (Array.isArray(flatterAfter[key]) && flatterAfter[key].length === 0 && !flatterBefore[key]) {
                return;
            }
            if (Array.isArray(flatterAfter[key]) && flatterAfter[key].length === 0 && Array.isArray(flatterAfter[key]) && flatterAfter[key].length === 0) {
                return;
            }
            if (comparison[key] && !flatterBefore[key]) {
                comparisons.push(new RevisionCompare(key, JsonUtil.returnEmptyIfUndefined(comparison, key), JsonUtil.returnEmptyIfUndefined(flatterBefore, key), JsonUtil.returnEmptyIfUndefined(flatterAfter, key), 'add'));
            }
            else if (flatterBefore[key] && !flatterAfter[key]) {
                comparisons.push(new RevisionCompare(key, JsonUtil.returnEmptyIfUndefined(comparison, key), JsonUtil.returnEmptyIfUndefined(flatterBefore, key), JsonUtil.returnEmptyIfUndefined(flatterAfter, key), 'remove'));
            }
            else {
                comparisons.push(new RevisionCompare(key, JsonUtil.returnEmptyIfUndefined(comparison, key), JsonUtil.returnEmptyIfUndefined(flatterBefore, key), JsonUtil.returnEmptyIfUndefined(flatterAfter, key), 'update'));
            }
        });
        return comparisons;
    }
    static returnEmptyIfUndefined(obj, key) {
        return obj[key] ? obj[key] : '';
    }
    static coalesce(value) {
        if (!value) {
            return Number.MAX_VALUE;
        }
        return Number.parseInt(value);
    }
}

const MIN_PATH = 3;
class JsonPatchUtil {
    static getOpByString(op) {
        switch (op) {
            case 'add':
                return JsonUpdateOperation.ADD;
            case 'replace':
                return JsonUpdateOperation.REPLACE;
            case 'remove':
                return JsonUpdateOperation.REMOVE;
            default:
                throw 'not found op';
        }
    }
    static compare(originalObject, actualObject) {
        let copyOriginalObject = deepCopy(originalObject);
        let copyActualObject = deepCopy(actualObject);
        let originalObjCopy = JSON.parse(JSON.stringify(copyOriginalObject));
        JsonUtil.orderArraysById(originalObjCopy);
        JsonUtil.orderArraysById(copyActualObject);
        JsonPatchUtil.adjustRemovedFromArray(originalObjCopy, copyActualObject);
        let patches = createPatch(originalObjCopy, copyActualObject);
        let patchesAdapters = [];
        let originalToPatch = JSON.parse(JSON.stringify(originalObjCopy));
        let patchesArrayReplace = [];
        patches.forEach(patch => {
            let patchesArrayReplaceFilter = patchesArrayReplace.filter(p => patch.path.startsWith(p.path));
            if (patchesArrayReplaceFilter.length === 0 || patch.op !== 'replace') {
                let patchAdapt = JsonPatchUtil.adaptPath(originalToPatch, copyActualObject, patch, patchesArrayReplace);
                if (patchAdapt) {
                    patchesAdapters.push(patchAdapt);
                }
            }
        });
        patchesAdapters = JsonPatchUtil.adaptArrayReplace(patchesAdapters, patchesArrayReplace);
        return patchesAdapters.sort((a, b) => a.compare(b));
    }
    static adaptArrayReplace(patchesAdapters, patchesArrayReplace) {
        patchesArrayReplace.forEach(patchArrayReplace => {
            patchesAdapters = patchesAdapters.filter(patch => !patch.path.startsWith(`${patchArrayReplace.path}/`));
            let path = patchArrayReplace.path.slice(0, patchArrayReplace.path.lastIndexOf('/'));
            patchesAdapters.push(JsonUpdatePartial.of(JsonUpdateOperation.REMOVE, undefined, `${path}/${patchArrayReplace.id}`));
            patchesAdapters.push(JsonUpdatePartial.of(JsonUpdateOperation.ADD, patchArrayReplace.obj, path));
        });
        patchesAdapters.forEach(patch => {
            if (patch.value instanceof Object) {
                patch.value = JSON.stringify(patch.value);
            }
        });
        return patchesAdapters;
    }
    static adaptPath(originalObject, actualObject, patch, patchesArrayReplace) {
        let newPath = '';
        let current = originalObject;
        let currentActual = actualObject;
        let path = patch.path.split('/');
        for (let i = 0; i < path.length; i++) {
            let part = path[i];
            if (current && part !== '') {
                let newPart = part;
                if (Array.isArray(current)) {
                    let arrayCurrent = current;
                    current = arrayCurrent[parseInt(part)];
                    if (currentActual) {
                        currentActual = currentActual[parseInt(part)];
                    }
                    if (current) {
                        newPart = current.id || part;
                        if (patch.op !== 'add' && path[i + 1] === 'id' && current.id) {
                            newPart = part;
                            const patchOnReplace = newPath + '/' + newPart;
                            if (patchesArrayReplace.filter(pr => patchOnReplace.startsWith(pr.path)).length === 0) {
                                patchesArrayReplace.push({ id: current.id, obj: currentActual, path: patchOnReplace });
                            }
                        }
                        else if (patch.op === 'add' && currentActual instanceof Object && !path[i + 1]) {
                            newPart = '';
                        }
                    }
                    else {
                        newPart = '';
                    }
                }
                else {
                    current = current[part];
                    if (currentActual) {
                        currentActual = currentActual[part];
                    }
                }
                if (newPart !== '') {
                    newPath = newPath + '/' + newPart;
                }
            }
        }
        if (Array.isArray(current) && !currentActual) {
            return null;
        }
        applyPatch(originalObject, [patch]);
        const isEmpty = patch.value === null || typeof patch.value === 'undefined' || patch.value === '';
        const patchResult = JsonUpdatePartial.of(JsonPatchUtil.getOpByString(isEmpty ? 'remove' : patch.op), patch.value, newPath);
        return patchResult;
    }
    static adjustRemovedFromArray(originalObject, actualObject) {
        if (!(originalObject instanceof Object)) {
            return;
        }
        for (let key in originalObject) {
            let value = originalObject[key];
            if (Array.isArray(value)) {
                const otherArray = actualObject[key] ? actualObject[key] : [];
                const arrayRemoved = value.filter(obj => otherArray.filter(objOther => obj.id === objOther.id && obj.id).length === 0);
                if (arrayRemoved.length > 0) {
                    const newArray = [];
                    value.forEach(e => {
                        if (arrayRemoved.indexOf(e) < 0) {
                            newArray.push(e);
                        }
                    });
                    arrayRemoved.forEach(e => newArray.push(e));
                    originalObject[key] = newArray;
                }
                value = originalObject[key];
                value.forEach(e => {
                    const otherValue = otherArray.filter(otherObj => otherObj.id === e.id && e.id)[0];
                    if (otherValue) {
                        JsonPatchUtil.adjustRemovedFromArray(e, otherValue);
                    }
                });
            }
            else if (actualObject[key]) {
                JsonPatchUtil.adjustRemovedFromArray(value, actualObject[key]);
            }
        }
    }
}

const PAGE_SIZE = 15;
class EntityService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.fields = [];
        this.ignoreFields = false;
    }
    findOne(id, fields) {
        return this.httpClient.get({
            resource: `${this.resource}`,
            id: `${id}`,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    post(entity, fields) {
        return this.httpClient.post({
            resource: `${this.resource}`,
            body: entity,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    patch(id, patches, fields) {
        return this.httpClient.patch({
            resource: `${this.resource}`,
            body: patches, id: id ? `${id}` : null,
            fields: this.calculeFields(fields),
            location: this.location,
            headersExtra: this.headerExra
        });
    }
    put(id, entity, fields) {
        return this.httpClient.put({
            resource: `${this.resource}`,
            body: entity,
            id: `${id}`,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    remove(id) {
        return this.httpClient.del({
            resource: `${this.resource}`,
            id: `${id}`,
            location: this.location
        });
    }
    print(filter, fields, page) {
        return this.httpClient.get({
            resource: `${this.resource}/report?${page.toUrlParameters()}`,
            responseType: 'text',
            fields: fields,
            search: this.buildSearch(filter),
            location: this.location
        }).pipe(map(html => {
            return URL.createObjectURL(new Blob([html], { type: 'text/html' }));
        }));
    }
    newTemplate() {
        return this.httpClient.get({
            resource: `${this.resource}/template`,
            location: this.location
        });
    }
    findAllUnlimited(fields, pageRequest = new PageParameters(9999)) {
        const requestParams = {
            resource: `${this.resource}`,
            page: pageRequest,
            fields: this.calculeFields(fields),
            location: this.location
        };
        return this.httpClient.get(requestParams).pipe(map(page => page.content));
    }
    findAll(page, search, fields, disableSpinner) {
        return this.httpClient.get({
            resource: `${this.resource}`,
            page: page,
            search: this.buildSearch(search),
            disableSpinner: disableSpinner,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    findToAutoComplete(search, fields, sort = 'id,asc') {
        return this.findAll(new PageParameters(PAGE_SIZE, 0, sort), search, fields, true);
    }
    loadFieldModels(fields = '') {
        return this.httpClient.get({
            resource: `${this.resource}/model`,
            fields: fields
        });
    }
    getFields() {
        return this.fields;
    }
    defaultSearch() {
        return null;
    }
    postOrPatch(entity, entityBefore) {
        if (entity.id) {
            return this.patch(entity.id, JsonPatchUtil.compare(JsonUtil.removeNullKeys(entityBefore), JsonUtil.removeNullKeys(entity)));
        }
        else {
            return this.post(entity);
        }
    }
    calculeFields(fields) {
        if (this.ignoreFields) {
            return null;
        }
        return fields || this.fields.toString();
    }
    buildSearch(search) {
        let defaultSearch = this.defaultSearch();
        if (!search && !defaultSearch) {
            return undefined;
        }
        let finalSearch = '';
        if (defaultSearch) {
            finalSearch += defaultSearch;
            finalSearch += search ? ' and ' : '';
        }
        finalSearch += search ? search : '';
        return finalSearch;
    }
}
EntityService.ɵfac = function EntityService_Factory(t) { return new (t || EntityService)(ɵngcc0.ɵɵinject(HttpClient)); };
EntityService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EntityService, factory: EntityService.ɵfac });
EntityService.ctorParameters = () => [
    { type: HttpClient }
];

class AppConfigService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.resource = '/api/app-info';
    }
    getUsuarioPadrao() {
        const requestParams = {
            resource: `${this.resource}/usuario`
        };
        return this.httpClient.get(requestParams);
    }
    getExercicios(entidade) {
        const requestParams = {
            resource: `${this.resource}/exercicios/${entidade.id}`
        };
        return this.httpClient.get(requestParams);
    }
}
AppConfigService.ɵfac = function AppConfigService_Factory(t) { return new (t || AppConfigService)(ɵngcc0.ɵɵinject(HttpClient)); };
AppConfigService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AppConfigService, factory: AppConfigService.ɵfac });
AppConfigService.ctorParameters = () => [
    { type: HttpClient }
];

const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto',
    'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
class MonthUtils {
    static getMonthName(month) {
        return monthNames[month - 1];
    }
    static getMonths() {
        return monthNames;
    }
}

const FROM_FORMAT = 'YYYY-MM-DD';
const TO_FORMAT = 'DD/MM/YYYY';
const DIA_1 = 1;
const DIA_30 = 30;
const SABADO = 6;
const DOMINGO = 0;
const moment = momentLibrary;
// @dynamic
class DateUtils {
    static getFormatHtml5() {
        return moment.HTML5_FMT.DATETIME_LOCAL_SECONDS;
    }
    static format(value, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        const formater = moment(value, fromFormat);
        formater.utcOffset(0);
        if (formater.isValid()) {
            return formater.format(toFormat);
        }
        return '';
    }
    static differenceBetweenDays(dataInicio, dataFim) {
        let a = moment(dataInicio);
        let b = moment(dataFim);
        let diffDays = b.diff(a, 'days');
        return diffDays;
    }
    static differenceBetweenMonths(dataInicio, dataFim) {
        let a = moment(dataInicio);
        let b = moment(dataFim);
        let diffMonths = b.diff(a, 'months');
        return diffMonths;
    }
    static differenceBetweenYear(dataInicio, dataFim) {
        let a = moment(dataInicio);
        let b = moment(dataFim);
        let diffMonths = b.diff(a, 'years');
        return diffMonths;
    }
    static now(fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment().toDate(), fromFormat, toFormat);
    }
    static getDateFromString(value, fromFormat = FROM_FORMAT) {
        return moment(value, fromFormat).toDate();
    }
    static getMonthName(month) {
        return MonthUtils.getMonthName(month);
    }
    static smallerDate(dateSelected, date = new Date()) {
        return moment(date, TO_FORMAT).isAfter(dateSelected);
    }
    static isAfterOrEquals(dateSelected, date = new Date()) {
        return moment(date, TO_FORMAT).isSameOrBefore(dateSelected);
    }
    static isBeforeOrEquals(dateSelected, date = new Date()) {
        return moment(date, TO_FORMAT).isSameOrAfter(dateSelected);
    }
    static isDaySmallerDate(dateSelected, date = new Date()) {
        return moment(date, FROM_FORMAT).startOf('day').isAfter(dateSelected);
    }
    static greaterDate(dateSelected, date = new Date()) {
        return moment(date, TO_FORMAT).isBefore(dateSelected);
    }
    static nowHour() {
        return moment().format('HH:mm');
    }
    static addDays(date, daysToAdd, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).add(daysToAdd, 'days'), fromFormat, toFormat);
    }
    static addMonths(date, monthsToAdd, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).add(monthsToAdd, 'months'), fromFormat, toFormat);
    }
    static addYears(date, yearsToAdd, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).add(yearsToAdd, 'years'), fromFormat, toFormat);
    }
    static removeDays(date, daysToRemove, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).subtract(daysToRemove, 'days'), fromFormat, toFormat);
    }
    static removeMonths(date, monthsToRemove, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).subtract(monthsToRemove, 'months'), fromFormat, toFormat);
    }
    static removeYears(date, yearsToRemove, fromFormat = FROM_FORMAT, toFormat = TO_FORMAT) {
        return this.format(moment(date).subtract(yearsToRemove, 'years'), fromFormat, toFormat);
    }
    static dateTimeFormat(date, hour) {
        return [date, hour].join('T');
    }
    static dateTimeFormatFilter(date) {
        let array = date.split('T');
        return `${this.format(array[0])} - ${array[1]}Hs`;
    }
    static dateStartYear(year) {
        if (year) {
            return `${year}-01-01`;
        }
        else {
            return `${new Date().getFullYear()}-01-01`;
        }
    }
    static dateEndYear(year) {
        if (year) {
            return `${year}-12-31`;
        }
        else {
            return `${new Date().getFullYear()}-12-31`;
        }
    }
    static dateStartMonthYear(date) {
        const dateMoment = moment(date);
        return this.specificDate({ yyyy: dateMoment.year(), mm: dateMoment.month() + 1, dd: 1 });
    }
    static dateEndMonthYear(date) {
        const dateMoment = moment(date);
        return this.specificDate({ yyyy: dateMoment.year(), mm: dateMoment.month() + 1, dd: dateMoment.daysInMonth() });
    }
    static lastDate(month, year) {
        return this.lastMonthDate(new Date(year, month, 1));
    }
    static lastMonthDateMoment(month, year) {
        const daysInMonth = moment(this.lastDate(month, year)).daysInMonth();
        return this.specificDate({ yyyy: year, mm: month + 1, dd: daysInMonth });
    }
    static lastMonthDate(date) {
        if (!date)
            return;
        const year = moment(date).year();
        const month = moment(date).month();
        const daysInMonth = moment(date).daysInMonth();
        return new Date(year, month, daysInMonth);
    }
    static firstDate(month, year) {
        return new Date(year, month, 1);
    }
    static specificDate(dateParam) {
        const date = this.now();
        const { yyyy, mm, dd } = dateParam;
        const [day, month, year] = date.split('/');
        const specificDate = [
            dd || day,
            mm || month,
            yyyy || year
        ].join('-');
        return this.format(specificDate, TO_FORMAT, FROM_FORMAT);
    }
    static getMaxDate(dates) {
        if (dates.length) {
            return DateUtils.format(moment.max(...dates.map(d => moment(d))).toDate(), TO_FORMAT, FROM_FORMAT);
        }
    }
    static getYearByDate(date) {
        if (!date)
            return;
        return moment(date).year();
    }
    static isValid(date) {
        return moment(date).isValid();
    }
    static isWeekend(date) {
        const dayOfWeek = this.getDateFromString(date).getDay();
        return SABADO === dayOfWeek || DOMINGO === dayOfWeek;
    }
    static formatToUTC(value, format) {
        return moment.utc(value, format);
    }
}

class EloTimelineHorizontalComponent {
    constructor() {
        this.dates = [];
        this.description = 'Inserir nova data';
        this.onSelected = new EventEmitter();
        this.onRemove = new EventEmitter();
        this.showCalendar = false;
        this.showDialogRemove = false;
    }
    onClickIncluirData() {
        this.showCalendar = !this.showCalendar;
    }
    onSelectDate(selectedDate) {
        const dataFormatada = DateUtils.format(selectedDate, TO_FORMAT, FROM_FORMAT);
        this.dates.forEach(d => d.selected = false);
        if (this.dates.map(d => d.data).includes(dataFormatada)) {
            let dateFound = this.dates.find(d => d.data === dataFormatada);
            dateFound.selected = true;
            this.onSelected.emit(dateFound);
        }
        else {
            let newDateObj = { data: dataFormatada, selected: true };
            this.dates.push(newDateObj);
            this.onSelected.emit(newDateObj);
        }
        this.dates.sort((a, b) => DateUtils.differenceBetweenDays(DateUtils.getDateFromString(a.data), b.data));
        this.showCalendar = !this.showCalendar;
    }
    onClickDate(event) {
        this.dates.forEach(d => d.selected = false);
        event.selected = true;
        this.onSelected.emit(event);
    }
    onRemoveDate() {
        let indexToRemove = this.dates.findIndex(d => d.selected);
        if (indexToRemove > -1) {
            this.onRemove.emit(this.dates.find(d => d.selected));
            this.dates.splice(indexToRemove, 1);
            this.onClickDate(this.dates[0]);
        }
        this.showDialogRemove = !this.showDialogRemove;
    }
}
EloTimelineHorizontalComponent.ɵfac = function EloTimelineHorizontalComponent_Factory(t) { return new (t || EloTimelineHorizontalComponent)(); };
EloTimelineHorizontalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloTimelineHorizontalComponent, selectors: [["elo-timeline-horizontal"]], inputs: { dates: "dates", description: "description" }, outputs: { onSelected: "onSelected", onRemove: "onRemove" }, decls: 11, vars: 5, consts: [[1, "row"], [1, "timeline-horizontal-container"], ["id", "liInsertRevisao", 2, "cursor", "pointer", 3, "click"], [1, "caption"], ["style", "cursor: pointer", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "row", 4, "ngIf"], [3, "show", "onSelectDate"], [3, "show", "onOkEvent", "onCancelEvent"], [2, "cursor", "pointer", 3, "ngClass", "click"], [1, "values"], [1, "value", "mt-md"], [3, "ngClass"], ["column", "3"], ["id", "btnRemoveRevisao", "type", "button", 1, "btn", "negative", "icon-left", 3, "title", "click"], [1, "fa", "fa-trash"]], template: function EloTimelineHorizontalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ul");
        ɵngcc0.ɵɵelementStart(3, "li", 2);
        ɵngcc0.ɵɵlistener("click", function EloTimelineHorizontalComponent_Template_li_click_3_listener() { return ctx.onClickIncluirData(); });
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, EloTimelineHorizontalComponent_li_6_Template, 6, 5, "li", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, EloTimelineHorizontalComponent_div_7_Template, 5, 1, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "elo-calendar", 6);
        ɵngcc0.ɵɵlistener("onSelectDate", function EloTimelineHorizontalComponent_Template_elo_calendar_onSelectDate_8_listener($event) { return ctx.onSelectDate($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "elo-dialog", 7);
        ɵngcc0.ɵɵlistener("onOkEvent", function EloTimelineHorizontalComponent_Template_elo_dialog_onOkEvent_9_listener() { return ctx.onRemoveDate(); })("onCancelEvent", function EloTimelineHorizontalComponent_Template_elo_dialog_onCancelEvent_9_listener() { return ctx.showDialogRemove = !ctx.showDialogRemove; });
        ɵngcc0.ɵɵtext(10, " A Revis\u00E3o do Divisor ser\u00E1 apagada. Deseja continuar?\n");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.description);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.dates);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dates.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("show", ctx.showCalendar);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("show", ctx.showDialogRemove);
    } }, directives: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, CalendarComponent, DialogComponent, ɵngcc2.NgClass, FormLabelColumnComponent]; }, pipes: function () { return [DateFormatPipe]; }, encapsulation: 2 });
EloTimelineHorizontalComponent.propDecorators = {
    dates: [{ type: Input }],
    description: [{ type: Input }],
    onSelected: [{ type: Output }],
    onRemove: [{ type: Output }]
};

class BooleanTextPipe {
    transform(value) {
        if (value) {
            return 'Sim';
        }
        return 'Não';
    }
}
BooleanTextPipe.ɵfac = function BooleanTextPipe_Factory(t) { return new (t || BooleanTextPipe)(); };
BooleanTextPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "booleanText", type: BooleanTextPipe, pure: true });

class CapitalizePipe {
    // transform(value: any, args: any[]): any {
    // }
    transform(txt) {
        if (!txt) {
            return;
        }
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
}
CapitalizePipe.ɵfac = function CapitalizePipe_Factory(t) { return new (t || CapitalizePipe)(); };
CapitalizePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "capitalize", type: CapitalizePipe, pure: true });

// @dynamic
class MaskUtils {
    static formatCPF(value) {
        value = MaskUtils.replaceCaracteres(value);
        if (value) {
            return vanillaMasker.toPattern(value, '999.999.999-999');
        }
        return value;
    }
    static formatCNPJ(value) {
        value = MaskUtils.replaceCaracteres(value);
        if (value) {
            return vanillaMasker.toPattern(value, '99.999.999/9999-99');
        }
        return value;
    }
    static formatCnpjCpf(value) {
        value = MaskUtils.replaceCaracteres(value);
        if (value) {
            if (value.length <= MaskUtils.CPF) {
                return this.formatCPF(value);
            }
            else {
                return this.formatCNPJ(value);
            }
        }
        return value;
    }
    static formatDias(value) {
        if (value) {
            let pattern = String(value)
                .replace(/[0-9]/g, '9')
                .replace('.', ',') + ' Dia(s)';
            return vanillaMasker.toPattern(value, { pattern: pattern, placeholder: '' });
        }
    }
    static formatPercentual(value) {
        if (value) {
            let pattern = String(value)
                .replace(/[0-9]/g, '9')
                .replace(/\./g, ',');
            return vanillaMasker.toPattern(value, { pattern: `${pattern} %`, placeholder: '0' });
        }
    }
    static formatHora(value) {
        if (value) {
            let pattern = String(value)
                .replace(/[0-9]/g, '9')
                .replace('.', ':');
            return vanillaMasker.toPattern(value, { pattern: pattern, placeholder: '0' });
        }
    }
    static formatCEP(value) {
        value = MaskUtils.replaceCaracteres(value);
        if (value) {
            return vanillaMasker.toPattern(value, '99999-999');
        }
        return value;
    }
    static replaceCaracteres(value) {
        let valueStr = String(value);
        return valueStr.replace(/[\.|\-|\/|(|)|\s]/g, '');
    }
    static formatMoney(value) {
        return vanillaMasker.toMoney(value);
    }
    static formatCompetencia(value) {
        return vanillaMasker.toPattern(value, '99/9999');
    }
    static formatTelefoneCelular(value) {
        if (!value) {
            return value;
        }
        else if (value.length === 10) {
            return vanillaMasker.toPattern(value, '(99) 9999-9999');
        }
        else if (value.length === 11) {
            return vanillaMasker.toPattern(value, '(99) 99999-9999');
        }
    }
    static formatByPattern(value, pattern) {
        return vanillaMasker.toPattern(value, pattern.replace(/#/g, 'S'));
    }
}
MaskUtils.CPF = 11;

class CepPipe {
    transform(value) {
        return value ? MaskUtils.formatCEP(value) : value;
    }
}
CepPipe.ɵfac = function CepPipe_Factory(t) { return new (t || CepPipe)(); };
CepPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cep", type: CepPipe, pure: true });

class CnpjCpfPipe {
    transform(value) {
        return MaskUtils.formatCnpjCpf(value);
    }
}
CnpjCpfPipe.ɵfac = function CnpjCpfPipe_Factory(t) { return new (t || CnpjCpfPipe)(); };
CnpjCpfPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cnpjCpf", type: CnpjCpfPipe, pure: true });

class CountdownPipe {
    transform(text, args) {
        let maxLength = args || 140;
        let length = text ? text.length : 0;
        return (maxLength - length);
    }
}
CountdownPipe.ɵfac = function CountdownPipe_Factory(t) { return new (t || CountdownPipe)(); };
CountdownPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "countdown", type: CountdownPipe, pure: false });

registerLocaleData(localePt);

/**
 Pipe para formatar valores monetários, no formato do real
 */
class CurrencyFormatPipe {
    transform(value, currencyCode = 'BRL', display, digits) {
        if (value === null || value === undefined) {
            return '';
        }
        let currencyPipe = new CurrencyPipe('pt');
        let newValue = currencyPipe.transform(value, currencyCode, display ? display : 'symbol', digits);
        return newValue;
    }
}
CurrencyFormatPipe.ɵfac = function CurrencyFormatPipe_Factory(t) { return new (t || CurrencyFormatPipe)(); };
CurrencyFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "currencyformat", type: CurrencyFormatPipe, pure: true });

const DATEVIEWFORMAT = 'DD/MM/YYYY';
const DATEMODELFORMAT = 'YYYY-MM-DD';
class DateFormatPipe {
    transform(value, viewFormat = DATEVIEWFORMAT, modelFormat = DATEMODELFORMAT) {
        return DateUtils.format(value, modelFormat, viewFormat);
    }
}
DateFormatPipe.ɵfac = function DateFormatPipe_Factory(t) { return new (t || DateFormatPipe)(); };
DateFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "dateformat", type: DateFormatPipe, pure: true });

const DATEHOURVIEWFORMAT = 'DD/MM/YYYY HH:mm';
const DATEHOURMODELFORMAT = 'YYYY-MM-DDTHH:mm:ss';
class DateHourFormatPipe {
    transform(value, viewFormat = DATEHOURVIEWFORMAT, modelFormat = DATEHOURMODELFORMAT) {
        const date = DateUtils.formatToUTC(value, DATEHOURMODELFORMAT);
        if (date.isValid()) {
            return date.format(DATEHOURVIEWFORMAT);
        }
        return '';
    }
}
DateHourFormatPipe.ɵfac = function DateHourFormatPipe_Factory(t) { return new (t || DateHourFormatPipe)(); };
DateHourFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "datehourformat", type: DateHourFormatPipe, pure: true });

/**
 * Pipe para formatar numeros na formatação do Brasil (usando . e , nos lugares corretos)
 */
class DecimalFormatPipe {
    transform(value, digits) {
        if (value === null || value === undefined) {
            return '';
        }
        let currencyPipe = new DecimalPipe('pt');
        let newValue = currencyPipe.transform(value, digits);
        return newValue;
    }
}
DecimalFormatPipe.ɵfac = function DecimalFormatPipe_Factory(t) { return new (t || DecimalFormatPipe)(); };
DecimalFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "decimalformat", type: DecimalFormatPipe, pure: true });

/**
 Pipe para formatar valores em percentual
 */
class DiasFormatPipe {
    transform(value, currencyCode = 'BRL', display, digits) {
        if (value === null || value === undefined) {
            return '';
        }
        return value.toFixed(2).toString().replace('.', ',') + ' Dia(s)';
    }
}
DiasFormatPipe.ɵfac = function DiasFormatPipe_Factory(t) { return new (t || DiasFormatPipe)(); };
DiasFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "diasformat", type: DiasFormatPipe, pure: true });

class DiasPorExtensoPipe {
    transform(value) {
        value = value === undefined ? 0 : value;
        value = +value;
        if (Number.isNaN(value)) {
            return '#ValorNaoNumerico';
        }
        return value === 1 ? `${value} dia` : `${value} dias`;
    }
}
DiasPorExtensoPipe.ɵfac = function DiasPorExtensoPipe_Factory(t) { return new (t || DiasPorExtensoPipe)(); };
DiasPorExtensoPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "diasPorExtenso", type: DiasPorExtensoPipe, pure: true });

class FilterPipe {
    /**
     * Filtra o array de acordo com o termo de pesquisa, utilizado em objetos que possuem atributos para pesquisa
     *
     * @param items array que será transformado
     *
     * @param searchTerm termo de pesquisa que será levado em conta para filtrar o array
     *
     * @param path caminho do objeto que deseja filtrar, exemplo: item.descricao
     *
     * @param isFormArray booleano que deve ser informado caso o array seja um formArray,
     *    pois é necessário fazer uma desestruturação na propriedade value, que é o array.
     *    Geralmente utilizado em table editable, default: false
     */
    transform(items, searchTerm, path, isFormArray = false) {
        if (!items) {
            return [];
        }
        if (!searchTerm) {
            return items;
        }
        return isFormArray
            ? items.filter(({ value }) => this.applyFilter(path, value, searchTerm))
            : items.filter(value => this.applyFilter(path, value, searchTerm));
    }
    resolve(path, obj) {
        let value = '';
        const filterValues = path.split('|');
        for (let filterValue of filterValues) {
            value += filterValue.split('.').reduce((prev, curr) => prev ? prev[curr] : null, obj);
        }
        return value;
    }
    applyFilter(path, value, searchTerm) {
        return this.resolve(path, value)
            .toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
    }
}
FilterPipe.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); };
FilterPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "filter", type: FilterPipe, pure: true });

/**
 Pipe para formatar valores em percentual
 */
class PercentageFormatPipe {
    transform(value, currencyCode = 'BRL', display, digits) {
        if (value === null || value === undefined) {
            return '';
        }
        return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(value) + '%';
    }
}
PercentageFormatPipe.ɵfac = function PercentageFormatPipe_Factory(t) { return new (t || PercentageFormatPipe)(); };
PercentageFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "percentageformat", type: PercentageFormatPipe, pure: true });

class SafeUrlPipe {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    transform(url) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafeUrlPipe.ɵfac = function SafeUrlPipe_Factory(t) { return new (t || SafeUrlPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer)); };
SafeUrlPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "safe", type: SafeUrlPipe, pure: true });
SafeUrlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];

class SimNaoPipe {
    transform(value) {
        if (value === 'S' || value === '1') {
            return 'Sim';
        }
        return 'Não';
    }
}
SimNaoPipe.ɵfac = function SimNaoPipe_Factory(t) { return new (t || SimNaoPipe)(); };
SimNaoPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "simNao", type: SimNaoPipe, pure: true });

class SubTipoPipe {
    transform(value) {
        if ('P' === value) {
            return 'Positiva';
        }
        if ('N' === value) {
            return 'Negativa';
        }
        if ('X' === value) {
            return 'Positiva com efeito de negativa';
        }
        return value;
    }
}
SubTipoPipe.ɵfac = function SubTipoPipe_Factory(t) { return new (t || SubTipoPipe)(); };
SubTipoPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "subTipo", type: SubTipoPipe, pure: true });

class TelefonePipe {
    transform(value) {
        return MaskUtils.formatTelefoneCelular(value);
    }
}
TelefonePipe.ɵfac = function TelefonePipe_Factory(t) { return new (t || TelefonePipe)(); };
TelefonePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "telefone", type: TelefonePipe, pure: true });

class PipeModule {
}
PipeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PipeModule });
PipeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PipeModule_Factory(t) { return new (t || PipeModule)(); }, imports: [[CommonModule$1]] });

const VIEWFORMAT = 'DD/MM/YYYY';
const MODELFORMAT = 'YYYY-MM-DD';
const INVALID_DATE = 'Invalid date';
const ONLY_NUMBERS_BAR_REGEX = /[^\/0-9\]]|[aA-zZ]/g;
function datePickerValidator(c) {
    return (c.value === INVALID_DATE) ? {
        validateDate: {
            valid: false
        }
    } : null;
}
class DatePickerComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.viewFormat = VIEWFORMAT;
        this.modelFormat = MODELFORMAT;
        this.disable = false;
        this.showCalendar = false;
        this.onTop = false;
        this.onRight = false;
        this.date = '';
        this.onChange = () => null;
    }
    get value() {
        return this.date;
    }
    set value(value) {
        const valueWithRegex = value.replace(ONLY_NUMBERS_BAR_REGEX, '');
        if (value !== valueWithRegex) {
            value = valueWithRegex;
            this.input.nativeElement.value = value;
        }
        this.date = value;
        if (!this.date) {
            this.onChange('');
        }
        else if (!this.isDateComplete()) {
            this.date = this.formatPartialDate(this.date, this.viewFormat);
            this.onChange('Invalid date');
        }
        else {
            this.onChange(moment(this.date, this.viewFormat, true).format(this.modelFormat));
        }
    }
    writeValue(obj) {
        if (obj) {
            this.date = moment(obj, this.modelFormat).format(this.viewFormat);
        }
        else {
            this.date = null;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    getDateToCalendar() {
        const dateToCalendar = moment(this.value, this.viewFormat, true);
        if (dateToCalendar.isValid()) {
            return dateToCalendar.format(this.viewFormat);
        }
        return '';
    }
    onClickInput() {
        if (!this.disable) {
            let heightDocument = window.innerHeight;
            heightDocument = heightDocument - 36; // footer height
            let heightDatepicker = 280;
            let datePicker = document.querySelector('#' + this.id + ' .datepicker');
            if (datePicker && datePicker.classList && !datePicker.classList.contains('open')) {
                datePicker.setAttribute('style', 'height: ' + heightDatepicker +
                    'px; position: fixed; display: block; margin-top: -' +
                    window.pageYOffset + 'px; opacity: 1;');
                let datepickerOffsetLeft = datePicker.offsetLeft + datePicker.offsetWidth;
                let datepickerOffsetTop = datePicker.offsetTop;
                datePicker.setAttribute('style', 'position: absolute;margin-top: 0;');
                if (datepickerOffsetTop + heightDatepicker > heightDocument) {
                    this.onTop = true;
                }
                else {
                    this.onTop = false;
                }
                if (window.innerWidth < datepickerOffsetLeft) {
                    this.onRight = true;
                }
                else {
                    this.onRight = false;
                }
            }
            this.showCalendar = !this.showCalendar;
        }
    }
    onSelectDate(date) {
        this.value = date;
        this.showCalendar = false;
    }
    ngOnInit() {
        this.unRegisterGlobalClick = this.renderer.listen('body', 'click', (event) => {
            this.closeCalendarGlobal(event);
        });
        this.input.nativeElement.disabled = this.disable;
    }
    ngOnDestroy() {
        if (this.unRegisterGlobalClick) {
            this.unRegisterGlobalClick();
        }
    }
    onKeyDown(event) {
        if (event.key === 'Tab') {
            this.showCalendar = false;
        }
    }
    closeCalendarGlobal(event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.showCalendar = false;
        }
    }
    isDateComplete() {
        return this.date.length === this.viewFormat.length;
    }
    formatPartialDate(dateParam, viewFormatParam) {
        const separator = viewFormatParam[viewFormatParam.search(/\W/)];
        const qtdSeparatorDate = StringUtils.countOccurrence(dateParam, separator);
        const qtdSeparatorFormat = StringUtils.countOccurrence(viewFormatParam, separator);
        if (qtdSeparatorDate !== qtdSeparatorFormat) {
            dateParam = StringUtils.replaceAll(dateParam, separator, '');
            for (let i = 0; i < dateParam.length; i++) {
                if (viewFormatParam[i + 1] === separator && dateParam[i + 1] !== separator) {
                    dateParam = [dateParam.slice(0, i + 1), separator, dateParam.slice(i + 1)].join('');
                }
            }
        }
        return dateParam;
    }
}
DatePickerComponent.ɵfac = function DatePickerComponent_Factory(t) { return new (t || DatePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DatePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DatePickerComponent, selectors: [["elo-datepicker"]], viewQuery: function DatePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c4, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { viewFormat: "viewFormat", modelFormat: "modelFormat", disable: "disable", id: "id" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: DatePickerComponent },
            { provide: NG_VALIDATORS, multi: true, useValue: datePickerValidator }
        ])], decls: 5, vars: 8, consts: [["type", "text", "autocomplete", "off", 1, "has-input-icon", 3, "id", "ngModel", "maxlength", "disabled", "ngModelChange", "click", "keydown"], ["input", ""], ["aria-hidden", "true", 1, "fa", "fa-calendar", "input-icon", 3, "click"], [3, "show", "onTop", "onRight", "selectedDate", "onSelectDate"], ["calendar", ""]], template: function DatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DatePickerComponent_Template_input_ngModelChange_0_listener($event) { return ctx.value = $event; })("click", function DatePickerComponent_Template_input_click_0_listener() { return ctx.onClickInput(); })("keydown", function DatePickerComponent_Template_input_keydown_0_listener($event) { return ctx.onKeyDown($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "i", 2);
        ɵngcc0.ɵɵlistener("click", function DatePickerComponent_Template_i_click_2_listener() { return ctx.onClickInput(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "elo-calendar", 3, 4);
        ɵngcc0.ɵɵlistener("onSelectDate", function DatePickerComponent_Template_elo_calendar_onSelectDate_3_listener($event) { return ctx.onSelectDate($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate1("id", "", ctx.id, "_input");
        ɵngcc0.ɵɵproperty("ngModel", ctx.value)("maxlength", ctx.viewFormat.length)("disabled", ctx.disable);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("show", ctx.showCalendar)("onTop", ctx.onTop)("onRight", ctx.onRight && ctx.showCalendar)("selectedDate", ctx.getDateToCalendar());
    } }, directives: function () { return [ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.MaxLengthValidator, CalendarComponent]; }, encapsulation: 2 });
DatePickerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
DatePickerComponent.propDecorators = {
    viewFormat: [{ type: Input }],
    modelFormat: [{ type: Input }],
    id: [{ type: Input }],
    input: [{ type: ViewChild, args: ['input', { static: true },] }],
    disable: [{ type: Input }]
};

const WEEK = 6;
class CalendarComponent {
    constructor() {
        this.viewFormat = VIEWFORMAT;
        this.show = true;
        this.onTop = false;
        this.onRight = false;
        this.locale = {
            dayNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto',
                'Setembro', 'Outubro', 'Novembro', 'Dezembro']
        };
        this.onSelectDate = new EventEmitter();
        this.days = [];
        this.date = moment();
    }
    set selectedDate(value) {
        if (value) {
            this.date = moment(value, this.viewFormat, true);
        }
        else {
            this.date = moment();
        }
        this.generateCalendarForSelectDateMonth();
    }
    get month() {
        return this.date.month();
    }
    get year() {
        return this.date.year();
    }
    get day() {
        return this.date.date();
    }
    ngOnInit() {
        this.generateCalendarForSelectDateMonth();
    }
    nextMonth() {
        this.date.add(1, 'month');
        this.selectedDate = this.date.format(this.viewFormat);
    }
    prevMonth() {
        this.date.subtract(1, 'month');
        this.selectedDate = this.date.format(this.viewFormat);
    }
    nextYear() {
        this.date.add(1, 'year');
        this.selectedDate = this.date.format(this.viewFormat);
    }
    prevYear() {
        this.date.subtract(1, 'year');
        this.selectedDate = this.date.format(this.viewFormat);
    }
    selectDate(calendarDate) {
        this.date.set({ 'year': calendarDate.year, 'month': calendarDate.month, 'date': calendarDate.day });
        this.generateCalendarForSelectDateMonth();
        this.onSelectDate.emit(this.date.format(this.viewFormat));
    }
    generateCalendarForSelectDateMonth() {
        this.days = [];
        const startDay = this.date.clone().startOf('month');
        startDay.subtract(startDay.weekday(), 'days');
        const endDay = this.date.clone().endOf('month');
        endDay.add(WEEK - endDay.weekday(), 'days');
        while (startDay.isSameOrBefore(endDay)) {
            this.days.push({
                day: startDay.date(),
                month: startDay.month(),
                year: startDay.year(),
                isMonthOfSelectDate: startDay.month() === this.date.month(),
                isSelectDate: startDay.format(this.viewFormat) === this.date.format(this.viewFormat)
            });
            startDay.add(1, 'days');
        }
    }
}
CalendarComponent.ɵfac = function CalendarComponent_Factory(t) { return new (t || CalendarComponent)(); };
CalendarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CalendarComponent, selectors: [["elo-calendar"]], inputs: { viewFormat: "viewFormat", show: "show", onTop: "onTop", onRight: "onRight", locale: "locale", selectedDate: "selectedDate" }, outputs: { onSelectDate: "onSelectDate" }, decls: 16, vars: 10, consts: [[1, "datepicker"], [1, "datepicker-header"], [1, "datepicker-header-year"], [1, "fa", "fa-chevron-left", 3, "click"], [1, "year-number"], [1, "fa", "fa-chevron-right", 3, "click"], [1, "datepicker-header-month"], [1, "month-name"], [1, "datepicker-calendar"], [1, "datepicker-calendar-header"], ["class", "item", 4, "ngFor", "ngForOf"], ["class", "item", 3, "not-this-month", "selected", "click", 4, "ngFor", "ngForOf"], [1, "item"], [1, "item", 3, "click"]], template: function CalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "em", 3);
        ɵngcc0.ɵɵlistener("click", function CalendarComponent_Template_em_click_3_listener() { return ctx.prevYear(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "b", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "em", 5);
        ɵngcc0.ɵɵlistener("click", function CalendarComponent_Template_em_click_6_listener() { return ctx.nextYear(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "em", 3);
        ɵngcc0.ɵɵlistener("click", function CalendarComponent_Template_em_click_8_listener() { return ctx.prevMonth(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "b", 7);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "em", 5);
        ɵngcc0.ɵɵlistener("click", function CalendarComponent_Template_em_click_11_listener() { return ctx.nextMonth(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵelementStart(13, "div", 9);
        ɵngcc0.ɵɵtemplate(14, CalendarComponent_li_14_Template, 2, 1, "li", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(15, CalendarComponent_li_15_Template, 2, 5, "li", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("open", ctx.show)("top", ctx.onTop)("right", ctx.onRight);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.year);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.locale.monthNames[ctx.month]);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.locale.dayNames);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.days);
    } }, directives: [ɵngcc2.NgForOf], encapsulation: 2 });
CalendarComponent.propDecorators = {
    viewFormat: [{ type: Input }],
    show: [{ type: Input }],
    onTop: [{ type: Input }],
    onRight: [{ type: Input }],
    selectedDate: [{ type: Input }],
    locale: [{ type: Input }],
    onSelectDate: [{ type: Output }]
};

class CalendarModule {
}
CalendarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CalendarModule });
CalendarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CalendarModule_Factory(t) { return new (t || CalendarModule)(); }, imports: [[CommonModule$1]] });

class MaskFormatDirective {
    constructor(formControlName, elementRef) {
        this.formControlName = formControlName;
        this.elementRef = elementRef;
    }
    set maskFormat(value) {
        this._maskFormat = value;
        if (this.formControlName) {
            this.attrValue(this.formControlName.value);
        }
    }
    onBlur() {
        if (!this.formControlName) {
            this.elementRef.nativeElement.value = this.toPattern(MaskUtils.replaceCaracteres(this.elementRef.nativeElement.value));
        }
    }
    ngOnInit() {
        if (this.formControlName) {
            this.subscription = this.formControlName.valueChanges.subscribe(value => this.attrValue(value));
            this.attrValue(this.formControlName.value);
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    attrValue(value) {
        if (this._maskFormat) {
            let beforeValue = MaskUtils.replaceCaracteres(value);
            let maskedValue = this.toPattern(beforeValue);
            if (value) {
                let selectionEnd = this.elementRef.nativeElement.selectionEnd;
                selectionEnd += maskedValue.length - beforeValue.length;
                this.formControlName.valueAccessor.writeValue(maskedValue);
                if (this.formControlName.value !== MaskUtils.replaceCaracteres(maskedValue)) {
                    this.formControlName.control.setValue(MaskUtils.replaceCaracteres(maskedValue));
                }
                setTimeout(() => this.elementRef.nativeElement.setSelectionRange(selectionEnd, selectionEnd), 0);
            }
        }
    }
    toPattern(value) {
        let formats = this._maskFormat.split('|');
        let formatToUse = '';
        let formatFilter = formats.filter(format => MaskUtils.replaceCaracteres(format).length >= value.length);
        if (formatFilter.length > 0) {
            formatToUse = formatFilter[0];
        }
        else {
            formatToUse = formats[formats.length - 1];
        }
        return MaskUtils.formatByPattern(value, formatToUse);
    }
}
MaskFormatDirective.ɵfac = function MaskFormatDirective_Factory(t) { return new (t || MaskFormatDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MaskFormatDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MaskFormatDirective, selectors: [["", "maskFormat", ""]], hostBindings: function MaskFormatDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function MaskFormatDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { maskFormat: "maskFormat" } });
MaskFormatDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];
MaskFormatDirective.propDecorators = {
    maskFormat: [{ type: Input }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};

class CepDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '99999-999';
    }
}
CepDirective.ɵfac = function CepDirective_Factory(t) { return new (t || CepDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CepDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CepDirective, selectors: [["", "cep", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
CepDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];

class ClipboardDirective {
    constructor(elmRef) {
        this.elmRef = elmRef;
        this.onSuccess = new EventEmitter();
        this.onError = new EventEmitter();
    }
    ngOnInit() {
        let option = !!this.targetElm ? { target: () => this.targetElm } : { text: () => this.clipboardContent };
        this.clipboard = new Clipboard(this.elmRef.nativeElement, option);
        this.clipboard.on('success', () => this.onSuccess.emit(true));
        this.clipboard.on('error', () => this.onError.emit(true));
    }
    ngOnDestroy() {
        if (this.clipboard) {
            this.clipboard.destroy();
        }
    }
}
ClipboardDirective.ɵfac = function ClipboardDirective_Factory(t) { return new (t || ClipboardDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ClipboardDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ClipboardDirective, selectors: [["", "clipboard", ""]], inputs: { targetElm: "targetElm", clipboardContent: "clipboardContent" }, outputs: { onSuccess: "onSuccess", onError: "onError" } });
ClipboardDirective.ctorParameters = () => [
    { type: ElementRef }
];
ClipboardDirective.propDecorators = {
    targetElm: [{ type: Input }],
    clipboardContent: [{ type: Input }],
    onSuccess: [{ type: Output }],
    onError: [{ type: Output }]
};

class CnpjCpfDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '999.999.999-99|99.999.999/9999-99';
    }
}
CnpjCpfDirective.ɵfac = function CnpjCpfDirective_Factory(t) { return new (t || CnpjCpfDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CnpjCpfDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CnpjCpfDirective, selectors: [["", "cnpjCpf", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
CnpjCpfDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];

class CnpjDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '99.999.999/9999-99';
    }
}
CnpjDirective.ɵfac = function CnpjDirective_Factory(t) { return new (t || CnpjDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CnpjDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CnpjDirective, selectors: [["", "cnpj", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
CnpjDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];

class Competencia {
    constructor(mes, ano) {
        this.mes = mes;
        this.ano = ano;
    }
}

class CompetenciaUtils {
    /**
     * Função utilizada para retornar o mês da competência passada por parâmetro
     * * @param  competencia no formato 012016 (MMYYYY)
     * @param  competencia
     */
    static getMesDaCompetencia(competencia) {
        if (!competencia) {
            return null;
        }
        return competencia.toString().substring(0, 2);
    }
    /**
     * Função utilizada para retornar o mês da competência passada por parâmetro
     * @param  competencia no formato 012016 (MMYYYY)
     * @returns
     */
    static getAnoDaCompetencia(competencia) {
        if (!competencia) {
            return null;
        }
        return competencia.toString().substring(2, 6);
    }
    /**
     * Função utilizada para retornar a competência de uma data
     * * @param date
     */
    static getCompetenciaFromDate(date) {
        if (!date) {
            return null;
        }
        return new Competencia(date.getMonth() + 1, date.getFullYear());
    }
}

var KEY_CODE;
(function (KEY_CODE) {
    KEY_CODE[KEY_CODE["UP_ARROW"] = 38] = "UP_ARROW";
    KEY_CODE[KEY_CODE["DOWN_ARROW"] = 40] = "DOWN_ARROW";
})(KEY_CODE || (KEY_CODE = {}));
class CompetenciaDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '99/9999';
        this.elementRef.nativeElement.setAttribute('autocomplete', 'off');
    }
    keyEvent(event) {
        // tslint:disable-next-line: deprecation
        if (event.keyCode === KEY_CODE.UP_ARROW) {
            this.increment();
        }
        // tslint:disable-next-line: deprecation
        if (event.keyCode === KEY_CODE.DOWN_ARROW) {
            this.decrement();
        }
    }
    getAnoAtual() {
        let currentDate = new Date();
        return currentDate.getFullYear();
    }
    increment() {
        let mes = parseInt(CompetenciaUtils.getMesDaCompetencia(this.formControlName.control.value));
        let ano = parseInt(CompetenciaUtils.getAnoDaCompetencia(this.formControlName.control.value));
        ano = !ano ? this.getAnoAtual() : ano;
        if (isNaN(mes)) {
            mes = 1;
        }
        else {
            if (mes >= 12) {
                mes = 0;
                ano++;
            }
            mes++;
        }
        let mesString = this.formatarMes(mes);
        mesString = mesString + ano;
        this.escreverNovoValor(mesString);
    }
    decrement() {
        let mes = parseInt(CompetenciaUtils.getMesDaCompetencia(this.formControlName.control.value));
        let ano = parseInt(CompetenciaUtils.getAnoDaCompetencia(this.formControlName.control.value));
        ano = !ano ? this.getAnoAtual() : ano;
        if (isNaN(mes)) {
            mes = 1;
        }
        else {
            if (mes === 1) {
                mes = 13;
                ano--;
            }
            mes--;
        }
        let mesString = this.formatarMes(mes);
        mesString = mesString + ano;
        this.escreverNovoValor(mesString);
    }
    escreverNovoValor(novoValor) {
        this.formControlName.valueAccessor.writeValue(novoValor);
        this.formControlName.control.setValue(novoValor);
    }
    formatarMes(mes) {
        if (isNaN(mes)) {
            return '01';
        }
        return mes < 10 ? '0' + mes : '' + mes;
    }
}
CompetenciaDirective.ɵfac = function CompetenciaDirective_Factory(t) { return new (t || CompetenciaDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CompetenciaDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CompetenciaDirective, selectors: [["", "competencia", ""]], hostBindings: function CompetenciaDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keyup", function CompetenciaDirective_keyup_HostBindingHandler($event) { return ctx.keyEvent($event); });
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
CompetenciaDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];
CompetenciaDirective.propDecorators = {
    keyEvent: [{ type: HostListener, args: ['keyup', ['$event'],] }]
};

class CpfDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '999.999.999-99';
    }
}
CpfDirective.ɵfac = function CpfDirective_Factory(t) { return new (t || CpfDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CpfDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CpfDirective, selectors: [["", "cpf", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
CpfDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];

class InputManager {
    constructor(htmlInputElement) {
        this.htmlInputElement = htmlInputElement;
    }
    setCursorAt(position) {
        if (this.htmlInputElement.setSelectionRange) {
            this.htmlInputElement.focus();
            this.htmlInputElement.setSelectionRange(position, position);
        }
        else if (this.htmlInputElement.createTextRange) {
            let textRange = this.htmlInputElement.createTextRange();
            textRange.collapse(true);
            textRange.moveEnd('character', position);
            textRange.moveStart('character', position);
            textRange.select();
        }
    }
    updateValueAndCursor(newRawValue, oldLength, selectionStart) {
        this.rawValue = newRawValue;
        let newLength = newRawValue.length;
        selectionStart = selectionStart - (oldLength - newLength);
        this.setCursorAt(selectionStart);
    }
    get canInputMoreNumbers() {
        let haventReachedMaxLength = !(this.rawValue.length >= this.htmlInputElement.maxLength && this.htmlInputElement.maxLength >= 0);
        let selectionStart = this.inputSelection.selectionStart;
        let selectionEnd = this.inputSelection.selectionEnd;
        let haveNumberSelected = (selectionStart !== selectionEnd &&
            this.htmlInputElement.value.substring(selectionStart, selectionEnd).match(/\d/)) ? true : false;
        let startWithZero = (this.htmlInputElement.value.substring(0, 1) === '0');
        return haventReachedMaxLength || haveNumberSelected || startWithZero;
    }
    get inputSelection() {
        let selectionStart = 0;
        let selectionEnd = 0;
        if (typeof this.htmlInputElement.selectionStart === 'number' && typeof this.htmlInputElement.selectionEnd === 'number') {
            selectionStart = this.htmlInputElement.selectionStart;
            selectionEnd = this.htmlInputElement.selectionEnd;
        }
        else {
            let range = document.selection.createRange();
            if (range && range.parentElement() === this.htmlInputElement) {
                let lenght = this.htmlInputElement.value.length;
                let normalizedValue = this.htmlInputElement.value.replace(/\r\n/g, '\n');
                let startRange = this.htmlInputElement.createTextRange();
                startRange.moveToBookmark(range.getBookmark());
                let endRange = this.htmlInputElement.createTextRange();
                endRange.collapse(false);
                if (startRange.compareEndPoints('StartToEnd', endRange) > -1) {
                    selectionStart = selectionEnd = lenght;
                }
                else {
                    selectionStart = -startRange.moveStart('character', -lenght);
                    selectionStart += normalizedValue.slice(0, selectionStart).split('\n').length - 1;
                    if (startRange.compareEndPoints('EndToEnd', endRange) > -1) {
                        selectionEnd = lenght;
                    }
                    else {
                        selectionEnd = -startRange.moveEnd('character', -lenght);
                        selectionEnd += normalizedValue.slice(0, selectionEnd).split('\n').length - 1;
                    }
                }
            }
        }
        return {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    }
    get rawValue() {
        return this.htmlInputElement && this.htmlInputElement.value;
    }
    set rawValue(value) {
        this._storedRawValue = value;
        if (this.htmlInputElement) {
            this.htmlInputElement.value = value;
        }
    }
    get storedRawValue() {
        return this._storedRawValue;
    }
}

class InputService {
    constructor(htmlInputElement, options) {
        this.htmlInputElement = htmlInputElement;
        this.options = options;
        this.inputManager = new InputManager(this.htmlInputElement);
    }
    addNumber(keyCode) {
        if (!this.rawValue) {
            this.rawValue = this.applyMask(false, '');
        }
        let keyChar = String.fromCharCode(keyCode);
        let selectionStart = this.inputSelection.selectionStart;
        let selectionEnd = this.inputSelection.selectionEnd;
        this.rawValue = this.rawValue.substring(0, selectionStart) + keyChar + this.rawValue.substring(selectionEnd, this.rawValue.length);
        this.updateFieldValue(selectionStart + 1);
    }
    applyMask(isNumber, rawValue) {
        let { allowNegative, precision, prefix, suffix, decimal, thousands, applyMask } = this.options;
        if (applyMask) {
            return this.doMask(isNumber, rawValue);
        }
        let onlyNumbers;
        if (isNumber) {
            onlyNumbers = rawValue.replace('.', decimal).replace(/[^0-9,]/g, '');
        }
        else {
            onlyNumbers = rawValue.replace(/[^0-9,]/g, '');
        }
        if (!onlyNumbers) {
            return '';
        }
        if (onlyNumbers.includes(decimal)) {
            const parts = onlyNumbers.split(decimal);
            const decimalPart = parts[1] || '';
            onlyNumbers = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + decimal + decimalPart.substring(0, precision);
        }
        else {
            onlyNumbers = onlyNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        }
        let isZero = rawValue === '0';
        let operator = (rawValue.indexOf('-') > -1 && allowNegative && !isZero) ? '-' : '';
        return operator + prefix + onlyNumbers + suffix;
    }
    doMask(isNumber, rawValue) {
        let { allowNegative, decimal, precision, prefix, suffix, thousands } = this.options;
        rawValue = isNumber ? Number(rawValue).toFixed(precision) : rawValue;
        let onlyNumbers = rawValue.replace(/[^0-9]/g, '');
        if (!onlyNumbers) {
            return '';
        }
        let integerPart = onlyNumbers.slice(0, onlyNumbers.length - precision).replace(/^0*/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        if (integerPart === '') {
            integerPart = '0';
        }
        let newRawValue = integerPart;
        let decimalPart = onlyNumbers.slice(onlyNumbers.length - precision);
        if (precision > 0) {
            decimalPart = '0'.repeat(precision - decimalPart.length) + decimalPart;
            newRawValue += decimal + decimalPart;
        }
        let isZero = parseInt(integerPart) === 0 && (parseInt(decimalPart) === 0 || decimalPart === '');
        let operator = (rawValue.indexOf('-') > -1 && allowNegative && !isZero) ? '-' : '';
        return operator + prefix + newRawValue + suffix;
    }
    clearMask(rawValue) {
        if (rawValue === null) {
            return null;
        }
        let value = rawValue.replace(this.options.prefix, '').replace(this.options.suffix, '');
        if (this.options.thousands) {
            value = value.replace(new RegExp('\\' + this.options.thousands, 'g'), '');
        }
        if (this.options.decimal) {
            value = value.replace(this.options.decimal, '.');
        }
        return parseFloat(value);
    }
    changeToNegative() {
        if (this.options.allowNegative && this.rawValue !== '' && this.rawValue.charAt(0) !== '-' && this.value !== 0) {
            this.rawValue = '-' + this.rawValue;
        }
    }
    changeToPositive() {
        this.rawValue = this.rawValue.replace('-', '');
    }
    removeNumber(keyCode) {
        let selectionEnd = this.inputSelection.selectionEnd;
        let selectionStart = this.inputSelection.selectionStart;
        if (selectionStart > this.rawValue.length - this.options.suffix.length) {
            selectionEnd = this.rawValue.length - this.options.suffix.length;
            selectionStart = this.rawValue.length - this.options.suffix.length;
        }
        selectionEnd = keyCode === 46 || keyCode === 63272 ? selectionEnd + 1 : selectionEnd;
        selectionStart = keyCode === 8 ? selectionStart - 1 : selectionStart;
        this.rawValue = this.rawValue.substring(0, selectionStart) + this.rawValue.substring(selectionEnd, this.rawValue.length);
        this.updateFieldValue(selectionStart);
    }
    updateFieldValue(selectionStart) {
        let newRawValue = this.applyMask(false, this.rawValue || '');
        selectionStart = selectionStart === undefined ? this.rawValue.length : selectionStart;
        this.inputManager.updateValueAndCursor(newRawValue, this.rawValue.length, selectionStart);
    }
    updateOptions(options) {
        let value = this.value;
        this.options = options;
        this.value = value;
    }
    get canInputMoreNumbers() {
        return this.inputManager.canInputMoreNumbers;
    }
    get inputSelection() {
        return this.inputManager.inputSelection;
    }
    get rawValue() {
        return this.inputManager.rawValue;
    }
    set rawValue(value) {
        this.inputManager.rawValue = value;
    }
    get storedRawValue() {
        return this.inputManager.storedRawValue;
    }
    get value() {
        return this.clearMask(this.rawValue);
    }
    set value(value) {
        this.rawValue = this.applyMask(true, '' + value);
    }
}

class InputHandler {
    constructor(htmlInputElement, options) {
        this.inputService = new InputService(htmlInputElement, options);
        this.htmlInputElement = htmlInputElement;
    }
    handleCut(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        setTimeout(() => {
            this.inputService.updateFieldValue();
            this.setValue(this.inputService.value);
            this.updateModel();
        }, 0);
    }
    handleInput(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        let keyCode = this.inputService.rawValue.charCodeAt(this.inputService.rawValue.length - 1);
        let rawValueLength = this.inputService.rawValue.length;
        let rawValueSelectionEnd = this.inputService.inputSelection.selectionEnd;
        let storedRawValueLength = this.inputService.storedRawValue.length;
        this.inputService.rawValue = this.inputService.storedRawValue;
        if (rawValueLength !== rawValueSelectionEnd || Math.abs(rawValueLength - storedRawValueLength) !== 1) {
            this.setCursorPosition(event);
            return;
        }
        if (rawValueLength < storedRawValueLength) {
            if (this.inputService.value !== 0) {
                this.inputService.removeNumber(8);
            }
            else {
                this.setValue(null);
            }
        }
        if (rawValueLength > storedRawValueLength) {
            switch (keyCode) {
                case 43:
                    this.inputService.changeToPositive();
                    break;
                case 45:
                    this.inputService.changeToNegative();
                    break;
                default:
                    if (!this.inputService.canInputMoreNumbers || (isNaN(this.inputService.value) && String.fromCharCode(keyCode).match(/\d/) === null)) {
                        return;
                    }
                    this.inputService.addNumber(keyCode);
            }
        }
        this.setCursorPosition(event);
        this.updateModel();
    }
    handleKeydown(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        let keyCode = event.which || event.charCode || event.keyCode;
        if (keyCode === 8 || keyCode === 46 || keyCode === 63272) {
            event.preventDefault();
            let selectionRangeLength = Math.abs(this.inputService.inputSelection.selectionEnd - this.inputService.inputSelection.selectionStart);
            if (selectionRangeLength === this.inputService.rawValue.length || this.inputService.value === 0) {
                this.setValue(null);
                this.updateModel();
            }
            if (selectionRangeLength === 0 && !isNaN(this.inputService.value)) {
                this.inputService.removeNumber(keyCode);
                this.updateModel();
            }
            this.updateModel();
        }
    }
    handleKeypress(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        let keyCode = event.which || event.charCode || event.keyCode;
        if (keyCode === undefined || [9, 13].indexOf(keyCode) !== -1 || this.isArrowEndHomeKeyInFirefox(event)) {
            return;
        }
        switch (keyCode) {
            case 43:
                this.inputService.changeToPositive();
                break;
            case 45:
                this.inputService.changeToNegative();
                break;
            default:
                if (this.inputService.canInputMoreNumbers && (!isNaN(this.inputService.value) || String.fromCharCode(keyCode).match(/\d/) !== null)) {
                    this.inputService.addNumber(keyCode);
                }
        }
        event.preventDefault();
        this.updateModel();
    }
    handlePaste(event) {
        if (this.htmlInputElement && this.htmlInputElement.readOnly) {
            return;
        }
        setTimeout(() => {
            this.inputService.updateFieldValue();
            this.setValue(this.inputService.value);
            this.updateModel();
        }, 1);
    }
    updateModel() {
        if (isNaN(this.inputService.value)) {
            this.onModelChange(null);
        }
        else {
            this.onModelChange(this.inputService.value);
        }
    }
    updateOptions(options) {
        this.inputService.updateOptions(options);
    }
    getOnModelChange() {
        return this.onModelChange;
    }
    setOnModelChange(callbackFunction) {
        this.onModelChange = callbackFunction;
    }
    getOnModelTouched() {
        return this.onModelTouched;
    }
    setOnModelTouched(callbackFunction) {
        this.onModelTouched = callbackFunction;
    }
    setValue(value) {
        this.inputService.value = value;
    }
    isArrowEndHomeKeyInFirefox(event) {
        if ([35, 36, 37, 38, 39, 40].indexOf(event.keyCode) !== -1 && (event.charCode === undefined || event.charCode === 0)) {
            return true;
        }
        return false;
    }
    setCursorPosition(event) {
        setTimeout(() => {
            event.target.setSelectionRange(event.target.value.length, event.target.value.length);
        }, 0);
    }
}

const CURRENCY_MASK_CONFIG = new InjectionToken('currency.mask.config');
const CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => CurrencyMaskDirective),
    multi: true
};
class CurrencyMaskDirective {
    constructor(currencyMaskConfig, elementRef, keyValueDiffers) {
        this.currencyMaskConfig = currencyMaskConfig;
        this.elementRef = elementRef;
        this.keyValueDiffers = keyValueDiffers;
        this.options = {};
        this.optionsTemplate = {
            align: 'right',
            allowNegative: true,
            allowZero: true,
            decimal: '.',
            precision: 2,
            prefix: '$ ',
            suffix: '',
            thousands: ',',
            applyMask: true
        };
        if (this.currencyMaskConfig) {
            this.optionsTemplate = this.currencyMaskConfig;
        }
        this.keyValueDiffer = this.keyValueDiffers.find({}).create();
    }
    ngAfterViewInit() {
        this.elementRef.nativeElement.style.textAlign = this.options.align ? this.options.align : this.optionsTemplate.align;
    }
    ngDoCheck() {
        if (this.keyValueDiffer.diff(this.options)) {
            this.elementRef.nativeElement.style.textAlign = this.options.align ? this.options.align : this.optionsTemplate.align;
            this.inputHandler.updateOptions(Object.assign({}, this.optionsTemplate, this.options));
        }
    }
    ngOnInit() {
        this.inputHandler = new InputHandler(this.elementRef.nativeElement, Object.assign({}, this.optionsTemplate, this.options));
    }
    handleBlur(event) {
        this.inputHandler.getOnModelTouched().apply(event);
    }
    handleCut(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleCut(event);
        }
    }
    handleInput(event) {
        if (this.isChromeAndroid()) {
            this.inputHandler.handleInput(event);
        }
    }
    handleKeydown(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeydown(event);
        }
    }
    handleKeypress(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeypress(event);
        }
    }
    handlePaste(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handlePaste(event);
        }
    }
    isChromeAndroid() {
        return /chrome/i.test(navigator.userAgent) && /android/i.test(navigator.userAgent);
    }
    registerOnChange(callbackFunction) {
        this.inputHandler.setOnModelChange(callbackFunction);
    }
    registerOnTouched(callbackFunction) {
        this.inputHandler.setOnModelTouched(callbackFunction);
    }
    setDisabledState(value) {
        this.elementRef.nativeElement.disabled = value;
    }
    writeValue(value) {
        this.inputHandler.setValue(value);
    }
}
CurrencyMaskDirective.ɵfac = function CurrencyMaskDirective_Factory(t) { return new (t || CurrencyMaskDirective)(ɵngcc0.ɵɵdirectiveInject(CURRENCY_MASK_CONFIG, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
CurrencyMaskDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CurrencyMaskDirective, selectors: [["", "currencyMask", ""]], hostBindings: function CurrencyMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function CurrencyMaskDirective_blur_HostBindingHandler($event) { return ctx.handleBlur($event); })("cut", function CurrencyMaskDirective_cut_HostBindingHandler($event) { return ctx.handleCut($event); })("input", function CurrencyMaskDirective_input_HostBindingHandler($event) { return ctx.handleInput($event); })("keydown", function CurrencyMaskDirective_keydown_HostBindingHandler($event) { return ctx.handleKeydown($event); })("keypress", function CurrencyMaskDirective_keypress_HostBindingHandler($event) { return ctx.handleKeypress($event); })("paste", function CurrencyMaskDirective_paste_HostBindingHandler($event) { return ctx.handlePaste($event); });
    } }, inputs: { options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR])] });
CurrencyMaskDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [CURRENCY_MASK_CONFIG,] }] },
    { type: ElementRef },
    { type: KeyValueDiffers }
];
CurrencyMaskDirective.propDecorators = {
    options: [{ type: Input }],
    handleBlur: [{ type: HostListener, args: ['blur', ['$event'],] }],
    handleCut: [{ type: HostListener, args: ['cut', ['$event'],] }],
    handleInput: [{ type: HostListener, args: ['input', ['$event'],] }],
    handleKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    handleKeypress: [{ type: HostListener, args: ['keypress', ['$event'],] }],
    handlePaste: [{ type: HostListener, args: ['paste', ['$event'],] }]
};

class DisableControlDirective {
    constructor(ngControl) {
        this.ngControl = ngControl;
        this.disableControl = false;
    }
    ngOnChanges(changes) {
        if (changes['disableControl']) {
            const action = this.disableControl ? 'disable' : 'enable';
            this.ngControl.control[action]();
        }
    }
}
DisableControlDirective.ɵfac = function DisableControlDirective_Factory(t) { return new (t || DisableControlDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl)); };
DisableControlDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DisableControlDirective, selectors: [["", "disableControl", ""]], inputs: { disableControl: "disableControl" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DisableControlDirective.ctorParameters = () => [
    { type: NgControl }
];
DisableControlDirective.propDecorators = {
    disableControl: [{ type: Input }]
};

class DoubleClickCopyDirective {
    constructor(element) {
        this.element = element;
        this.onCopy = new EventEmitter();
    }
    onDblClick() {
        const selection = getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.element.nativeElement);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        this.onCopy.emit(range);
    }
}
DoubleClickCopyDirective.ɵfac = function DoubleClickCopyDirective_Factory(t) { return new (t || DoubleClickCopyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DoubleClickCopyDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DoubleClickCopyDirective, selectors: [["", "doubleClickCopy", ""]], hostBindings: function DoubleClickCopyDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dblclick", function DoubleClickCopyDirective_dblclick_HostBindingHandler($event) { return ctx.onDblClick($event); });
    } }, outputs: { onCopy: "onCopy" } });
DoubleClickCopyDirective.ctorParameters = () => [
    { type: ElementRef }
];
DoubleClickCopyDirective.propDecorators = {
    onCopy: [{ type: Output }],
    onDblClick: [{ type: HostListener, args: ['dblclick', ['$event'],] }]
};

const ELODECIMAL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => EloDecimalDirective),
    multi: true
};
const customCurrencyMaskConfig = {
    align: 'right',
    allowNegative: false,
    allowZero: true,
    decimal: ',',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: '.',
    applyMask: true
};
class EloDecimalDirective extends CurrencyMaskDirective {
    constructor(elementRef, keyValueDiffers) {
        super(customCurrencyMaskConfig, elementRef, keyValueDiffers);
        this.textAlign = 'right';
        this.allowNegative = false;
        this.suffix = '';
        this.prefix = '';
        this.precision = 2;
    }
    ngOnInit() {
        this.options.allowNegative = this.allowNegative;
        this.options.suffix = this.suffix;
        this.options.prefix = this.prefix;
        this.options.precision = this.precision;
        this.options.align = this.textAlign;
        super.ngOnInit();
    }
}
EloDecimalDirective.ɵfac = function EloDecimalDirective_Factory(t) { return new (t || EloDecimalDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
EloDecimalDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: EloDecimalDirective, selectors: [["", "eloDecimal", ""]], inputs: { textAlign: "textAlign", allowNegative: "allowNegative", suffix: "suffix", prefix: "prefix", precision: "precision" }, features: [ɵngcc0.ɵɵProvidersFeature([ELODECIMAL_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature] });
EloDecimalDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: KeyValueDiffers }
];
EloDecimalDirective.propDecorators = {
    textAlign: [{ type: Input }],
    allowNegative: [{ type: Input }],
    suffix: [{ type: Input }],
    prefix: [{ type: Input }],
    precision: [{ type: Input }]
};

const ELONUMBER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => EloNumberDirective),
    multi: true
};
const customCurrencyMaskConfig$1 = {
    align: 'right',
    allowNegative: false,
    allowZero: true,
    decimal: ',',
    precision: 0,
    prefix: '',
    suffix: '',
    thousands: '.',
    applyMask: false
};
class EloNumberDirective extends CurrencyMaskDirective {
    constructor(elementRef, keyValueDiffers) {
        super(customCurrencyMaskConfig$1, elementRef, keyValueDiffers);
        this.allowNegative = false;
        this.prefix = '';
        this.suffix = '';
        this.align = 'right';
        this.precision = 0;
        this.thousands = '.';
    }
    ngOnInit() {
        this.options.allowNegative = this.allowNegative;
        this.options.prefix = this.prefix;
        this.options.suffix = this.suffix;
        this.options.align = this.align;
        this.options.precision = this.precision;
        this.options.thousands = this.thousands;
        super.ngOnInit();
    }
}
EloNumberDirective.ɵfac = function EloNumberDirective_Factory(t) { return new (t || EloNumberDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
EloNumberDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: EloNumberDirective, selectors: [["", "eloNumber", ""]], inputs: { allowNegative: "allowNegative", prefix: "prefix", suffix: "suffix", align: "align", precision: "precision", thousands: "thousands" }, features: [ɵngcc0.ɵɵProvidersFeature([ELONUMBER_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature] });
EloNumberDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: KeyValueDiffers }
];
EloNumberDirective.propDecorators = {
    allowNegative: [{ type: Input }],
    prefix: [{ type: Input }],
    suffix: [{ type: Input }],
    align: [{ type: Input }],
    precision: [{ type: Input }],
    thousands: [{ type: Input }]
};

const FOCUS_REMOVER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => FocusRemoverDirective),
    multi: true
};
class FocusRemoverDirective {
    constructor(elRef) {
        this.elRef = elRef;
        this.removeAutoFocus = true;
    }
    onClick() {
        if (this.removeAutoFocus) {
            this.elRef.nativeElement.blur();
        }
    }
}
FocusRemoverDirective.ɵfac = function FocusRemoverDirective_Factory(t) { return new (t || FocusRemoverDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FocusRemoverDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FocusRemoverDirective, selectors: [["", "removeAutoFocus", ""]], hostBindings: function FocusRemoverDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FocusRemoverDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { removeAutoFocus: "removeAutoFocus" }, features: [ɵngcc0.ɵɵProvidersFeature([FOCUS_REMOVER_VALUE_ACCESSOR])] });
FocusRemoverDirective.ctorParameters = () => [
    { type: ElementRef }
];
FocusRemoverDirective.propDecorators = {
    removeAutoFocus: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click',] }]
};

class AutofocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        setTimeout(() => {
            this.elementRef.nativeElement.focus();
        }, 0);
    }
}
AutofocusDirective.ɵfac = function AutofocusDirective_Factory(t) { return new (t || AutofocusDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AutofocusDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AutofocusDirective, selectors: [["", "eloAutoFocus", ""]] });
AutofocusDirective.ctorParameters = () => [
    { type: ElementRef }
];

const ERRO_MINUTOS = {
    mensagemGenerica: {
        mensagem: 'Os minutos precisam ser menores que 60'
    }
};
const ERRO_ZERO = {
    mensagemGenerica: {
        mensagem: 'As horas precisam ser maior que zero'
    }
};
const ERRO_TAMANHO = {
    'minlength': {
        requiredLength: 4
    }
};
class HoraLancamentoDirective {
    constructor(_elementRef, _control) {
        this._elementRef = _elementRef;
        this._control = _control;
    }
    ngOnInit() {
        this._control.valueChanges.subscribe(val => {
            if (val && this.validateLenght(val)) {
                this.validateMinutos(val);
                this.validateZero(val);
            }
        });
    }
    onEvent($event) {
        if ($event.inputType.includes('delete')) {
            return;
        }
        let val = this._handle(this._elementRef.nativeElement.value);
        val = val.replace(/\s/g, '');
        val = val.replace(/[^0-9:]/g, '');
        this._control.control.setValue(val, { emitEvent: false });
    }
    validateMinutos(val) {
        if (val.length === 5) {
            if (this.minutosIncorretos(val, 3)) {
                this._control.control.setErrors(ERRO_MINUTOS);
            }
        }
        else if (val.length === 6) {
            if (this.minutosIncorretos(val, 4)) {
                this._control.control.setErrors(ERRO_MINUTOS);
            }
        }
    }
    minutosIncorretos(val, indiceMinutos) {
        return parseInt(val.split('')[indiceMinutos]) > 5;
    }
    validateLenght(val) {
        if (val.trim().length < 5) {
            this._control.control.setErrors(ERRO_TAMANHO);
            return false;
        }
        else {
            return true;
        }
    }
    _handle(val) {
        if (!val) {
            return val;
        }
        let arr = val.split('');
        if (this.maiorQueTresSemDoisPontos(arr)) {
            arr = this.adicionarDoisPontos(arr);
        }
        let indiceDoisPontos = arr.indexOf(':');
        if (this.possuiMaisDeDoisElementosADireitaDosDoisPontos(arr, indiceDoisPontos)) {
            arr = this.trocarDoisPontosPeloElementoAEsquerda(arr, indiceDoisPontos);
        }
        if (this.doisPontosEmPosicaoErrada(arr)) {
            this.removerDoisPontos(arr);
            arr = this.adicionarDoisPontos(arr);
        }
        this.removerElementosExtras(arr);
        return arr.join('');
    }
    removerDoisPontos(arr) {
        while (arr.includes(':')) {
            arr.splice(arr.indexOf(':'), 1);
        }
    }
    adicionarDoisPontos(arr) {
        if (arr.length < 5) {
            arr = this.adicionarDoisPontosNaPosicao(arr, 3);
        }
        else {
            arr = this.adicionarDoisPontosNaPosicao(arr, 4);
        }
        return arr;
    }
    trocarDoisPontosPeloElementoAEsquerda(arr, indiceDoisPontos) {
        let arrSwap = arr.splice(indiceDoisPontos, 2);
        arr = [
            ...arr.slice(0, indiceDoisPontos),
            arrSwap[1],
            arrSwap[0],
            ...arr.slice(indiceDoisPontos)
        ];
        return arr;
    }
    possuiMaisDeDoisElementosADireitaDosDoisPontos(arr, indiceDoisPonstos) {
        return arr.includes(':')
            && arr.slice(indiceDoisPonstos + 1).length > 2;
    }
    removerElementosExtras(arr) {
        while (arr.length > 6) {
            arr.pop();
        }
    }
    adicionarDoisPontosNaPosicao(arr, posicao) {
        return [...arr.slice(0, posicao - 1), ':', ...arr.slice(posicao - 1)];
    }
    maiorQueTresSemDoisPontos(arr) {
        return arr.length > 3 && !arr.includes(':');
    }
    doisPontosEmPosicaoErrada(arr) {
        if (arr.includes(':')) {
            let qntdEncontradao = 0;
            let len = arr.length;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === ':') {
                    qntdEncontradao++;
                    if (len <= 5 && i !== 2) {
                        return true;
                    }
                    else if (i !== 3) {
                        return true;
                    }
                }
            }
            return qntdEncontradao > 1;
        }
        return true;
    }
    validateZero(val) {
        if (parseInt(val.replace(/[:]/, '')) === 0) {
            this._control.control.setErrors(ERRO_ZERO);
        }
    }
}
HoraLancamentoDirective.ɵfac = function HoraLancamentoDirective_Factory(t) { return new (t || HoraLancamentoDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl)); };
HoraLancamentoDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: HoraLancamentoDirective, selectors: [["", "horaLancamento", ""]], hostBindings: function HoraLancamentoDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function HoraLancamentoDirective_input_HostBindingHandler($event) { return ctx.onEvent($event); });
    } } });
HoraLancamentoDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgControl }
];
HoraLancamentoDirective.propDecorators = {
    onEvent: [{ type: HostListener, args: ['input', ['$event'],] }]
};

class HoraDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '99:99';
    }
}
HoraDirective.ɵfac = function HoraDirective_Factory(t) { return new (t || HoraDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
HoraDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: HoraDirective, selectors: [["", "hora", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
HoraDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];

class NativeElementManager {
    constructor(element) {
        this.element = element;
    }
    acceptableInput() {
        return this.element.validity.valid || this.element.validity.valueMissing || this.element.validity.stepMismatch;
    }
    elementValue() {
        return String(this.element.value);
    }
    setValue(value) {
        this.element.value = value;
    }
}
class NonNegativeDirective {
    constructor(formControlName, elementRef) {
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.validValue = '';
        this.setElementManager(new NativeElementManager(this.elementRef.nativeElement));
    }
    setElementManager(elementManager) {
        this.elementManager = elementManager;
    }
    validateValue(value) {
        if (value === undefined || value === null) {
            return false;
        }
        return /^[0-9]*$/.test(value);
    }
    focusListener() {
        this.validValue = this.elementManager.elementValue();
    }
    inputListener() {
        if (this.elementManager.acceptableInput()) {
            this.sanitizeValue(this.elementManager.elementValue());
        }
        this.updateValue();
    }
    sanitizeValue(value) {
        let newValue = value.replace('.', '');
        if (this.validateValue(newValue)) {
            this.validValue = newValue;
        }
    }
    updateValue() {
        if (this.formControlName) {
            this.formControlName.control.setValue(this.validValue);
        }
        else {
            if (this.elementManager.elementValue() !== this.validValue) {
                this.elementManager.setValue(this.validValue);
            }
        }
    }
}
NonNegativeDirective.ɵfac = function NonNegativeDirective_Factory(t) { return new (t || NonNegativeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NonNegativeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NonNegativeDirective, selectors: [["", "nonNegative", ""]], hostBindings: function NonNegativeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function NonNegativeDirective_focus_HostBindingHandler() { return ctx.focusListener(); })("input", function NonNegativeDirective_input_HostBindingHandler() { return ctx.inputListener(); });
    } } });
NonNegativeDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];
NonNegativeDirective.propDecorators = {
    focusListener: [{ type: HostListener, args: ['focus',] }],
    inputListener: [{ type: HostListener, args: ['input',] }]
};

class PlacaDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = 'AAA-9999';
    }
}
PlacaDirective.ɵfac = function PlacaDirective_Factory(t) { return new (t || PlacaDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
PlacaDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PlacaDirective, selectors: [["", "placa", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
PlacaDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];

class PreventMultiClickDirective {
    constructor(el) {
        this.el = el;
        this.debounceTime = 500;
        this.clicks = new Subject();
    }
    ngOnInit() {
        this.subscription = this.clicks.pipe(debounceTime(500)).subscribe(() => {
            this.el.nativeElement.attributes.removeNamedItem('disabled');
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next();
        this.el.nativeElement.setAttribute('disabled', true);
    }
}
PreventMultiClickDirective.ɵfac = function PreventMultiClickDirective_Factory(t) { return new (t || PreventMultiClickDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
PreventMultiClickDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PreventMultiClickDirective, selectors: [["", "preventMultiClick", ""]], hostBindings: function PreventMultiClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function PreventMultiClickDirective_click_HostBindingHandler($event) { return ctx.clickEvent($event); });
    } }, inputs: { debounceTime: "debounceTime" } });
PreventMultiClickDirective.ctorParameters = () => [
    { type: ElementRef }
];
PreventMultiClickDirective.propDecorators = {
    debounceTime: [{ type: Input }],
    clickEvent: [{ type: HostListener, args: ['click', ['$event'],] }]
};

class SelectOnFocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    onFocus() {
        this.elementRef.nativeElement.select();
    }
}
SelectOnFocusDirective.ɵfac = function SelectOnFocusDirective_Factory(t) { return new (t || SelectOnFocusDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SelectOnFocusDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SelectOnFocusDirective, selectors: [["", "selectOnFocus", ""]], hostBindings: function SelectOnFocusDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function SelectOnFocusDirective_focus_HostBindingHandler() { return ctx.onFocus(); });
    } } });
SelectOnFocusDirective.ctorParameters = () => [
    { type: ElementRef }
];
SelectOnFocusDirective.propDecorators = {
    onFocus: [{ type: HostListener, args: ['focus',] }]
};

class SingleClickButtonDirective {
    constructor(el) {
        this.el = el;
    }
    onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.el.nativeElement.setAttribute('disabled', true);
    }
}
SingleClickButtonDirective.ɵfac = function SingleClickButtonDirective_Factory(t) { return new (t || SingleClickButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SingleClickButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SingleClickButtonDirective, selectors: [["", "singleClickButton", ""]], hostBindings: function SingleClickButtonDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SingleClickButtonDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } } });
SingleClickButtonDirective.ctorParameters = () => [
    { type: ElementRef }
];
SingleClickButtonDirective.propDecorators = {
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};

class TelefoneDirective extends MaskFormatDirective {
    constructor(formControlName, elementRef) {
        super(formControlName, elementRef);
        this.formControlName = formControlName;
        this.elementRef = elementRef;
        this.maskFormat = '(99) 9999-9999|(99) 9-9999-9999';
    }
}
TelefoneDirective.ɵfac = function TelefoneDirective_Factory(t) { return new (t || TelefoneDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TelefoneDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TelefoneDirective, selectors: [["", "telefone", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
TelefoneDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: ElementRef }
];

class ZeroWhenEmptyDirective {
    constructor(formControl) {
        this.formControl = formControl;
    }
    onBlur() {
        if (!this.formControl.value || this.formControl.value.toString().trim().length <= 0) {
            this.formControl.valueAccessor.writeValue(0);
            this.formControl.control.setValue(0, { emitEvent: false });
        }
    }
}
ZeroWhenEmptyDirective.ɵfac = function ZeroWhenEmptyDirective_Factory(t) { return new (t || ZeroWhenEmptyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl)); };
ZeroWhenEmptyDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ZeroWhenEmptyDirective, selectors: [["", "zeroWhenEmpty", ""]], hostBindings: function ZeroWhenEmptyDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function ZeroWhenEmptyDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } } });
ZeroWhenEmptyDirective.ctorParameters = () => [
    { type: NgControl }
];
ZeroWhenEmptyDirective.propDecorators = {
    onBlur: [{ type: HostListener, args: ['blur',] }]
};

class DirectivesModule {
}
DirectivesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DirectivesModule });
DirectivesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DirectivesModule_Factory(t) { return new (t || DirectivesModule)(); } });

class DialogComponent {
    constructor() {
        this.show = false;
        this.showCancel = true;
        /**
        * @param classType positive, negative, neutral or warning
        */
        this.classType = 'neutral';
        this.tittleCancel = 'Cancelar';
        this.tittleOk = 'Ok';
        this.disableOkButton = false;
        this.debounceTime = 0;
        this.onOkEvent = new EventEmitter();
        this.onCancelEvent = new EventEmitter();
    }
    onOk() {
        this.onOkEvent.emit();
    }
    onCancel() {
        this.onCancelEvent.emit();
    }
    onDoNothing() { return; }
    handleKeyboardEvent(event) {
        if (event.code === 'Escape' && this.show && this.showCancel) {
            this.onCancel();
        }
        if (event.key === 'Enter' && this.show) {
            this.onOk();
        }
    }
}
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(); };
DialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["elo-dialog"]], hostBindings: function DialogComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function DialogComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { show: "show", showCancel: "showCancel", classType: "classType", tittleCancel: "tittleCancel", tittleOk: "tittleOk", disableOkButton: "disableOkButton", debounceTime: "debounceTime", title: "title" }, outputs: { onOkEvent: "onOkEvent", onCancelEvent: "onCancelEvent" }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [["id", "dialogConfirm", 3, "class", 4, "ngIf"], ["id", "dialogConfirm"], [1, "alt-box"], [1, "alt-box-content"], [1, "row"], [1, "col-md-12", "form-group"], ["class", "title", 4, "ngIf"], ["id", "content", 1, "row"], [1, "col-md-12"], [1, "alt-footer", "right"], ["type", "button", "id", "btCancel", "class", "btn neutral inline", "singleClickButton", "", 3, "click", 4, "ngIf"], ["eloAutoFocus", "", "type", "button", "id", "btOk", 3, "class", "click", 4, "ngIf", "ngIfElse"], ["debounceButton", ""], [1, "title"], ["type", "button", "id", "btCancel", "singleClickButton", "", 1, "btn", "neutral", "inline", 3, "click"], ["eloAutoFocus", "", "type", "button", "id", "btOk", 3, "click"], ["eloAutoFocus", "", "type", "button", "id", "btOk", "preventMultiClick", "", 3, "debounceTime", "click"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DialogComponent_div_0_Template, 14, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [ɵngcc2.NgIf, SingleClickButtonDirective, AutofocusDirective, PreventMultiClickDirective], encapsulation: 2 });
DialogComponent.propDecorators = {
    show: [{ type: Input }],
    showCancel: [{ type: Input }],
    classType: [{ type: Input }],
    tittleCancel: [{ type: Input }],
    tittleOk: [{ type: Input }],
    title: [{ type: Input }],
    disableOkButton: [{ type: Input }],
    debounceTime: [{ type: Input }],
    onOkEvent: [{ type: Output }],
    onCancelEvent: [{ type: Output }],
    handleKeyboardEvent: [{ type: HostListener, args: ['document:keydown', ['$event'],] }]
};

class DialogModule {
}
DialogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DialogModule });
DialogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DialogModule_Factory(t) { return new (t || DialogModule)(); }, imports: [[CommonModule$1, DirectivesModule], CommonModule$1] });

class EloTimelineHorizontalModule {
}
EloTimelineHorizontalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloTimelineHorizontalModule });
EloTimelineHorizontalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloTimelineHorizontalModule_Factory(t) { return new (t || EloTimelineHorizontalModule)(); }, imports: [[
            CommonModule$1,
            FormLabelColumnModule,
            PipeModule,
            CalendarModule,
            DialogModule
        ]] });

class EloTableDrilldownComponent {
    constructor() {
        this.showSecondField = false;
        this.headerSecondField = 'Valor Divisor';
        this.onClickElement = new EventEmitter();
        this.fieldHasChilds = 'hasChilds';
    }
    onClick(e) {
        e.open = !e.open;
        this.onClickElement.emit(e);
    }
}
EloTableDrilldownComponent.ɵfac = function EloTableDrilldownComponent_Factory(t) { return new (t || EloTableDrilldownComponent)(); };
EloTableDrilldownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloTableDrilldownComponent, selectors: [["elo-table-drilldown"]], inputs: { showSecondField: "showSecondField", headerSecondField: "headerSecondField", fieldHasChilds: "fieldHasChilds", data: "data", columns: "columns" }, outputs: { onClickElement: "onClickElement" }, decls: 1, vars: 1, consts: [["class", "table-editable tree", 4, "ngIf"], [1, "table-editable", "tree"], [1, "table-editable-header"], [1, "row"], [3, "class", "right", 4, "ngFor", "ngForOf"], [1, "table-editable-content"], ["recursiveList", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngFor", "ngForOf"], [3, "ngStyle"], [4, "ngIf"], [3, "class", "center-father", "ngStyle", "click", 4, "ngIf", "ngIfElse"], ["colWithoutDigits", ""], [3, "ngStyle", "click"], ["class", "hint clean fa-exclamation-circle  center-right module-color sm ml-xs", 4, "ngIf"], [1, "hint", "clean", "fa-exclamation-circle", "center-right", "module-color", "sm", "ml-xs"], [1, "hint-content"], [3, "click"]], template: function EloTableDrilldownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EloTableDrilldownComponent_div_0_Template, 8, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.length);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgStyle], pipes: [DecimalFormatPipe], styles: [".center-father[_ngcontent-%COMP%] { margin: auto 0px }"] });
EloTableDrilldownComponent.propDecorators = {
    data: [{ type: Input }],
    columns: [{ type: Input }],
    showSecondField: [{ type: Input }],
    headerSecondField: [{ type: Input }],
    onClickElement: [{ type: Output }],
    fieldHasChilds: [{ type: Input }]
};

class EloTableDrilldownModule {
}
EloTableDrilldownModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloTableDrilldownModule });
EloTableDrilldownModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloTableDrilldownModule_Factory(t) { return new (t || EloTableDrilldownModule)(); }, imports: [[
            CommonModule$1,
            PipeModule,
        ]] });

var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["positive"] = 0] = "positive";
    NotificationType[NotificationType["negative"] = 1] = "negative";
    NotificationType[NotificationType["neutral"] = 2] = "neutral";
})(NotificationType || (NotificationType = {}));

class EloNotificationService {
    constructor() {
        this.notificationSource = new Subject();
        this.notificationObservers = this.notificationSource.asObservable();
    }
    success(title, content, routeOwner) {
        this.notificationSource.next({ title: title, content: content, type: NotificationType.positive, routeOwner: routeOwner });
    }
    error(title, content, routeOwner) {
        this.notificationSource.next({ title: title, content: content, type: NotificationType.negative, routeOwner: routeOwner });
    }
    errorObject(title, error, routeOwner) {
        if (error.violations && error.violations.length > 0) {
            error.violations.forEach((violation) => {
                let message = `${violation.fieldName} ${violation.message}`;
                this.notificationSource.next({
                    title: title,
                    content: message.trim(),
                    type: NotificationType.negative,
                    routeOwner: routeOwner
                });
            });
        }
        else {
            this.error(title, error.message, routeOwner);
        }
    }
    info(title, content, routeOwner) {
        this.notificationSource.next({ title: title, content: content, type: NotificationType.neutral, routeOwner: routeOwner });
    }
}
EloNotificationService.ɵfac = function EloNotificationService_Factory(t) { return new (t || EloNotificationService)(); };
EloNotificationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EloNotificationService, factory: EloNotificationService.ɵfac });

class ArquivoComponent {
    constructor(notificationService, windowService) {
        this.notificationService = notificationService;
        this.windowService = windowService;
        this.canRemove = true;
        this.canDownload = true;
        this.canView = true;
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.form, 'form');
        AssertUtilsApp.assert(this.service, 'service foda');
        AssertUtilsApp.assert(this.filePath, 'filePath');
        AssertUtilsApp.assert(this.arrayPropertyName, 'arrayPropertyName');
    }
    onView(arquivoSelecionado) {
        var _a, _b;
        this.service.gerarUrlParaDownload((_a = arquivoSelecionado === null || arquivoSelecionado === void 0 ? void 0 : arquivoSelecionado.arquivo) === null || _a === void 0 ? void 0 : _a.fullPath, (_b = arquivoSelecionado === null || arquivoSelecionado === void 0 ? void 0 : arquivoSelecionado.arquivo) === null || _b === void 0 ? void 0 : _b.nome).subscribe((response) => {
            fetch(response.urlAssinada)
                .then(data => data.blob())
                .then(blob => {
                var _a;
                const file = new Blob([blob], { type: (_a = arquivoSelecionado === null || arquivoSelecionado === void 0 ? void 0 : arquivoSelecionado.arquivo) === null || _a === void 0 ? void 0 : _a.mimeType });
                const fileURL = URL.createObjectURL(file);
                this.windowService.openTab(fileURL);
            })
                .catch(error => this.notificationService.error('Erro!', 'Não foi possível encontrar o arquivo - ' + error.message));
        });
    }
    onDownload(arquivoSelecionado) {
        var _a, _b;
        this.service.gerarUrlParaDownload((_a = arquivoSelecionado === null || arquivoSelecionado === void 0 ? void 0 : arquivoSelecionado.arquivo) === null || _a === void 0 ? void 0 : _a.fullPath, (_b = arquivoSelecionado === null || arquivoSelecionado === void 0 ? void 0 : arquivoSelecionado.arquivo) === null || _b === void 0 ? void 0 : _b.nome).subscribe((response) => {
            var _a;
            this.windowService.downloadBlob(response.urlAssinada, (_a = arquivoSelecionado === null || arquivoSelecionado === void 0 ? void 0 : arquivoSelecionado.arquivo) === null || _a === void 0 ? void 0 : _a.nome);
        });
    }
    onSelect(event) {
        var _a;
        if (((_a = event === null || event === void 0 ? void 0 : event.addedFiles) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            event.addedFiles.forEach((file) => {
                if (this.form.get(this.arrayPropertyName).value
                    .some(a => { var _a; return ((_a = a === null || a === void 0 ? void 0 : a.arquivo) === null || _a === void 0 ? void 0 : _a.nome) === file.name; })) {
                    return this.notificationService.error('Atenção!', 'Esse arquivo já foi inserido.');
                }
                this.notificationService.info('Atenção!', 'Adicionando arquivo');
                this.service.gerarUrlParaUpload(this.filePath, file.name, file.type)
                    .subscribe((arquivoUrl) => {
                    this.service.enviarArquivoS3(file, arquivoUrl.urlAssinada)
                        .subscribe(() => {
                        const arquivo = {
                            nome: file.name,
                            mimeType: file.type,
                            tamanhoArquivo: file.size,
                            fullPath: arquivoUrl.fullPath,
                            dataCriacao: arquivoUrl.dataCriacao
                        };
                        this.service.post(arquivo).subscribe((arquivoSaved) => this.form.get(this.arrayPropertyName)
                            .push(new FormControl({ arquivo: arquivoSaved })));
                        this.form.markAsDirty();
                    }, error => this.notificationService.error('Erro!', 'Não foi possível salvar o arquivo - ' + error.message));
                });
            });
        }
    }
    onRemove(arquivoSelecionado) {
        const index = this.form.get(this.arrayPropertyName).value.indexOf(arquivoSelecionado === null || arquivoSelecionado === void 0 ? void 0 : arquivoSelecionado.arquivo);
        this.form.get(this.arrayPropertyName).removeAt(index);
        this.form.markAsDirty();
    }
}
ArquivoComponent.ɵfac = function ArquivoComponent_Factory(t) { return new (t || ArquivoComponent)(ɵngcc0.ɵɵdirectiveInject(EloNotificationService), ɵngcc0.ɵɵdirectiveInject(WindowService)); };
ArquivoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ArquivoComponent, selectors: [["arquivo-component"]], inputs: { canRemove: "canRemove", canDownload: "canDownload", canView: "canView", service: "service", form: "form", arrayPropertyName: "arrayPropertyName", filePath: "filePath" }, decls: 7, vars: 1, consts: [[1, "dragdrop"], [2, "all", "unset", 3, "change"], ["tabindex", "0", 1, "dropzone"], ["data-message", "Clique ou arraste arquivos aqui.", 1, "dragdrop-space"], ["id", "anexos", "type", "file", "multiple", "", "aria-label", "Campo para anexar arquivos", 2, "display", "none"], ["class", "col-md-12", 4, "ngFor", "ngForOf"], [1, "col-md-12"], [1, "dragdrop-item"], [1, "name"], [1, "buttons"], ["id", "buttonOnView", "type", "button", "class", "btn circle", 3, "click", 4, "ngIf"], ["id", "buttonOnDownload", "type", "button", "class", "btn circle", 3, "click", 4, "ngIf"], ["id", "buttonOnRemove", "type", "button", "class", "btn circle", 3, "click", 4, "ngIf"], ["id", "buttonOnView", "type", "button", 1, "btn", "circle", 3, "click"], [1, "fa", "fa-eye"], [1, "btn-actions-label"], ["id", "buttonOnDownload", "type", "button", 1, "btn", "circle", 3, "click"], [1, "fa", "fa-download"], ["id", "buttonOnRemove", "type", "button", 1, "btn", "circle", 3, "click"], [1, "fa", "fa-trash"]], template: function ArquivoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ngx-dropzone", 1);
        ɵngcc0.ɵɵlistener("change", function ArquivoComponent_Template_ngx_dropzone_change_1_listener($event) { return ctx.onSelect($event); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "input", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "ul");
        ɵngcc0.ɵɵtemplate(6, ArquivoComponent_li_6_Template, 8, 4, "li", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var tmp_0_0 = null;
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.form == null ? null : (tmp_0_0 = ctx.form.get(ctx.arrayPropertyName)) == null ? null : tmp_0_0.value);
    } }, directives: [ɵngcc5.NgxDropzoneComponent, ɵngcc2.NgForOf, ɵngcc2.NgIf], encapsulation: 2 });
ArquivoComponent.ctorParameters = () => [
    { type: EloNotificationService },
    { type: WindowService }
];
ArquivoComponent.propDecorators = {
    canRemove: [{ type: Input }],
    canDownload: [{ type: Input }],
    canView: [{ type: Input }],
    service: [{ type: Input }],
    form: [{ type: Input }],
    arrayPropertyName: [{ type: Input }],
    filePath: [{ type: Input }]
};

class ArquivoModule {
}
ArquivoModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ArquivoModule });
ArquivoModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ArquivoModule_Factory(t) { return new (t || ArquivoModule)(); }, imports: [[
            NgxDropzoneModule,
            CommonModule$1
        ]] });

class ActuatorService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.resource = '/actuator';
    }
    getInfo() {
        return this.httpClient.get({
            resource: `${this.resource}/info`,
        });
    }
}
ActuatorService.ɵfac = function ActuatorService_Factory(t) { return new (t || ActuatorService)(ɵngcc0.ɵɵinject(HttpClient)); };
ActuatorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ActuatorService, factory: ActuatorService.ɵfac });
ActuatorService.ctorParameters = () => [
    { type: HttpClient }
];

class VersionReloadHandlerComponent {
    constructor(actuatorService, windowService) {
        this.actuatorService = actuatorService;
        this.windowService = windowService;
        this.DEFAULT_VALUE_VERSION = null;
        this.currentVersion = this.DEFAULT_VALUE_VERSION;
    }
    ngOnInit() {
        this.versionHandler();
    }
    closeDialog() {
        this.currentVersion = false;
    }
    refreshVersion() {
        this.windowService.refresh();
    }
    versionHandler() {
        this.verifyVersion = interval(60000).subscribe(() => {
            if (!this.version) {
                this.actuatorService.getInfo().subscribe(api => {
                    var _a;
                    this.version = ((_a = api === null || api === void 0 ? void 0 : api.build) === null || _a === void 0 ? void 0 : _a.version) || this.DEFAULT_VALUE_VERSION;
                });
            }
            else {
                this.actuatorService.getInfo().subscribe(api => {
                    var _a, _b;
                    if (this.version !== ((_a = api === null || api === void 0 ? void 0 : api.build) === null || _a === void 0 ? void 0 : _a.version)) {
                        this.currentVersion = ((_b = api === null || api === void 0 ? void 0 : api.build) === null || _b === void 0 ? void 0 : _b.version) || this.DEFAULT_VALUE_VERSION;
                    }
                });
            }
        });
    }
}
VersionReloadHandlerComponent.ɵfac = function VersionReloadHandlerComponent_Factory(t) { return new (t || VersionReloadHandlerComponent)(ɵngcc0.ɵɵdirectiveInject(ActuatorService), ɵngcc0.ɵɵdirectiveInject(WindowService)); };
VersionReloadHandlerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VersionReloadHandlerComponent, selectors: [["version-reload-handler"]], decls: 17, vars: 5, consts: [[3, "tittleOk", "show", "tittleCancel", "onOkEvent", "onCancelEvent"], [2, "text-align", "center"], [1, "red-60", "typography-bold"], [1, "mt-xs"]], template: function VersionReloadHandlerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "elo-dialog", 0);
        ɵngcc0.ɵɵlistener("onOkEvent", function VersionReloadHandlerComponent_Template_elo_dialog_onOkEvent_0_listener() { return ctx.refreshVersion(); })("onCancelEvent", function VersionReloadHandlerComponent_Template_elo_dialog_onCancelEvent_0_listener() { return ctx.closeDialog(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h3");
        ɵngcc0.ɵɵtext(3, "Vers\u00E3o do sistema atualizada");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "hr");
        ɵngcc0.ɵɵelementStart(5, "span", 2);
        ɵngcc0.ɵɵtext(6, "Reinicie a p\u00E1gina para evitar diverg\u00EAncia de dados");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "hr");
        ɵngcc0.ɵɵelementStart(8, "div", 3);
        ɵngcc0.ɵɵelementStart(9, "p", 3);
        ɵngcc0.ɵɵtext(10, "Vers\u00E3o atual: ");
        ɵngcc0.ɵɵelementStart(11, "b");
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "p");
        ɵngcc0.ɵɵtext(14, "Vers\u00E3o nova: ");
        ɵngcc0.ɵɵelementStart(15, "b");
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("tittleOk", "Reiniciar a p\u00E1gina (F5)")("show", !!ctx.currentVersion)("tittleCancel", "N\u00E3o reiniciar");
        ɵngcc0.ɵɵadvance(12);
        ɵngcc0.ɵɵtextInterpolate(ctx.version);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.currentVersion);
    } }, directives: [DialogComponent], encapsulation: 2 });
VersionReloadHandlerComponent.ctorParameters = () => [
    { type: ActuatorService },
    { type: WindowService }
];

class VersionReloadModule {
}
VersionReloadModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: VersionReloadModule });
VersionReloadModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function VersionReloadModule_Factory(t) { return new (t || VersionReloadModule)(); }, providers: [ActuatorService], imports: [[
            CommonModule$1,
            DialogModule
        ]] });

class IFrameStore {
    constructor() {
        this._hasIframe = new BehaviorSubject(false);
    }
    set hasIframe(val) {
        this._hasIframe.next(val);
    }
    get hasIframeObservable() {
        return this._hasIframe.asObservable();
    }
}
IFrameStore.ɵfac = function IFrameStore_Factory(t) { return new (t || IFrameStore)(); };
IFrameStore.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: IFrameStore, factory: IFrameStore.ɵfac });

class SectionService {
    constructor() {
        this.sections = [];
    }
    registerContent(section) {
        if (!this.sections.find(s => s.route === section.route)) {
            this.sections.push(section);
        }
    }
    getContents() {
        return this.sections;
    }
}
SectionService.ɵfac = function SectionService_Factory(t) { return new (t || SectionService)(); };
SectionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SectionService, factory: SectionService.ɵfac });

class RouterService {
    constructor(router) {
        this.router = router;
        this.previousRoute = null;
        this.currentRoute = null;
        if (router && router.events) {
            router.events.subscribe(event => this.handleNavigationEvent(event));
        }
    }
    setCurrentRoute(route) {
        this.currentRoute = route;
    }
    setPreviousRoute(route) {
        this.previousRoute = route;
    }
    getPreviousRoute() {
        return this.previousRoute;
    }
    navigateByUrl(url, extras) {
        this.router.navigateByUrl(url, extras);
    }
    getCurrentRoute() {
        return this.currentRoute;
    }
    handleNavigationEvent(event) {
        if (event instanceof NavigationEnd) {
            this.previousRoute = this.currentRoute;
            this.currentRoute = event.url;
        }
    }
}
RouterService.ɵfac = function RouterService_Factory(t) { return new (t || RouterService)(ɵngcc0.ɵɵinject(ɵngcc6.Router)); };
RouterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: RouterService, factory: RouterService.ɵfac });
RouterService.ctorParameters = () => [
    { type: Router }
];

class NavigateUtils {
    getQueryParams(url) {
        if (!url) {
            return '';
        }
        const urls = url.split('?');
        if (urls.length) {
            if (urls.length <= 1) {
                return '';
            }
            else {
                return Object.assign(urls[1].split('&'));
            }
        }
    }
    getKey(param) {
        const params = param.split('=');
        return params && params.length === 2 ? params[0] : '';
    }
    getValue(param) {
        const params = param.split('=');
        return params && params.length === 2 ? params[1] : '';
    }
    createQueryParamsFromParams(params) {
        const queryParams = {};
        if (params) {
            params.forEach(param => {
                const key = this.getKey(param);
                const value = this.getValue(param);
                if (key && value) {
                    queryParams[key] = decodeURI(value);
                }
            });
        }
        return queryParams;
    }
    updateParams(url, params) {
        const queryParam = this.createQueryParamsFromParams(this.getQueryParams(url));
        if (params && params.length > 0) {
            params.forEach(p => queryParam[p.param] = p.value);
            Object.keys(queryParam).forEach((key) => !queryParam[key] && delete queryParam[key]);
        }
        return queryParam;
    }
    updateUrlParams(params, router) {
        const updatedParams = this.updateParams(router.url, params);
        if (Object.keys(updatedParams).length) {
            router.navigate([], { queryParams: updatedParams });
        }
    }
    createParamFromStringArray(array, form) {
        const params = [];
        array.forEach(param => {
            params.push({ param: param, value: form.get(param).value });
        });
        return params;
    }
}
NavigateUtils.ɵfac = function NavigateUtils_Factory(t) { return new (t || NavigateUtils)(); };
NavigateUtils.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NavigateUtils, factory: NavigateUtils.ɵfac });

class BreadcrumbComponent {
    constructor(router, activatedRoute, routerService, navigateUtils) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.routerService = routerService;
        this.navigateUtils = navigateUtils;
        this.homeLabel = 'Início';
        this.homeUrl = 'home';
        this.urlsToLabels = [];
        this.routes = [];
        this.labelsAnalisadas = [];
        this.qtdNiveis = 0;
        this.urlsWithIds = [];
    }
    ngOnInit() {
        setTimeout(() => {
            this.attrRoute(this.activatedRoute.root);
        }, 0);
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((nav) => {
            this.resetarRotasIfChangeDomain(nav);
            this.qtdNiveis = 0;
            this.contarNiveisBreadcrumb(this.activatedRoute.root);
            this.labelsAnalisadas = [];
            this.attrRoute(this.activatedRoute.root);
        });
    }
    onClick(route) {
        if (route.iframe) {
            route.onClick();
        }
    }
    resetarRotasIfChangeDomain(nav) {
        if (this.routes && !this.routes.find(r => nav.url.includes(r.url))) {
            this.routes = [];
        }
    }
    contarNiveisBreadcrumb(route) {
        for (let child of route.children) {
            this.qtdNiveis++;
            this.contarNiveisBreadcrumb(child);
        }
    }
    attrRoute(route) {
        for (let child of route.children) {
            let url = child.snapshot.url.map(segment => segment.path).join('/');
            let urlRoot = '';
            if (this.routes.length > 0) {
                urlRoot = `${this.routes
                    .map(r => r.url)
                    .reduce((p, c) => `${p}/${c}`)}/`;
            }
            if (url && url !== '/' && url !== this.homeUrl) {
                const label = this.findLabelIfExists(url, child);
                const routeByLabel = this.routes.find(r => r.label === label);
                const queryParams = this.findQueryParams();
                this.labelsAnalisadas.push(label);
                if (!routeByLabel) {
                    const INICIO = 1;
                    this.routes.push({
                        url: urlRoot + url,
                        label: label,
                        icon: this.findIconIfExists(url),
                        queryParams: queryParams,
                        ordinal: this.labelsAnalisadas.length + INICIO
                    });
                }
                else {
                    this.updateParamsIfUltimoNivel(queryParams, routeByLabel);
                }
            }
            this.attrRoute(child);
        }
        this.removeRotasNaoAnalisadas();
    }
    updateParamsIfUltimoNivel(queryParams, route) {
        const isUltimoNivel = this.qtdNiveis === route.ordinal;
        const isBreadcrumbAumentando = this.routes.length < this.qtdNiveis;
        if (isUltimoNivel && isBreadcrumbAumentando) {
            route.queryParams = queryParams;
        }
    }
    removeRotasNaoAnalisadas() {
        this.routes = this.routes.filter(r => this.labelsAnalisadas.find(label => label === r.label));
    }
    findQueryParams() {
        if (this.routerService.getPreviousRoute()) {
            const queryParams = this.navigateUtils.getQueryParams(this.routerService.getPreviousRoute());
            return this.navigateUtils.createQueryParamsFromParams(queryParams);
        }
        return '';
    }
    findLabelIfExists(url, route) {
        this.urlsWithIds = deepCopy(this.urlsToLabels);
        let isTypeId = url.replace(/[^0-9]/g, '');
        let uuid = url.match(/\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/);
        if (uuid && uuid.length > 0) {
            isTypeId = uuid[0];
        }
        if (isTypeId) {
            this.urlsWithIds.map(urlToLabel => {
                urlToLabel.url = !!urlToLabel.url && urlToLabel.url.replace(':id', isTypeId);
            });
        }
        let found = this.findUrl(url);
        if (found) {
            found = this.urlsToLabels[this.urlsWithIds.indexOf(found)];
            return found.labelResolver ? found.labelResolver(route) : found.label;
        }
        return 'Detalhes';
    }
    findIconIfExists(url) {
        const found = this.findUrl(url);
        if (found && found.icon) {
            return found.icon;
        }
        return 'fa fa-files-o iconmoon';
    }
    findUrl(url) {
        const params = this.activatedRoute.snapshot.queryParams;
        if (Object.keys(params).length && isNaN(url) && url !== 'new') {
            let label = this.urlsWithIds.find(value => value.url === url && value.params && value.params.queryParams
                && deepEqual(value.params.queryParams, params));
            return label ? label : this.urlsWithIds.find(urlToLabel => urlToLabel.url === url);
        }
        else {
            return this.urlsWithIds.find(urlToLabel => urlToLabel.url === url);
        }
    }
}
BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(RouterService), ɵngcc0.ɵɵdirectiveInject(NavigateUtils)); };
BreadcrumbComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["elo-breadcrumb"]], contentQueries: function BreadcrumbComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c9, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.botoesDireita = _t.first);
    } }, inputs: { homeLabel: "homeLabel", homeUrl: "homeUrl", urlsToLabels: "urlsToLabels" }, decls: 10, vars: 4, consts: [["aria-label", "Breadcrumbs", "id", "idBreadcrumbs", 1, "nav-breadcrumbs"], ["routerLink", ""], [1, "fa", "fa-home"], [4, "ngFor", "ngForOf"], ["role", "group", 1, "nav-buttons"], [4, "ngTemplateOutlet"], [4, "ngIf", "ngIfElse"], ["notLast", ""], [3, "routerLink", "queryParams", "click"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ol");
        ɵngcc0.ɵɵelementStart(2, "li");
        ɵngcc0.ɵɵelementStart(3, "a", 1);
        ɵngcc0.ɵɵelement(4, "i", 2);
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, BreadcrumbComponent_li_7_Template, 4, 2, "li", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵtemplate(9, BreadcrumbComponent_ng_container_9_Template, 1, 0, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-current", ctx.routes.length === 0 ? "page" : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.homeLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.routes);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.botoesDireita);
    } }, directives: [ɵngcc6.RouterLinkWithHref, ɵngcc2.NgForOf, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgIf], encapsulation: 2 });
BreadcrumbComponent.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute },
    { type: RouterService },
    { type: NavigateUtils }
];
BreadcrumbComponent.propDecorators = {
    homeLabel: [{ type: Input }],
    homeUrl: [{ type: Input }],
    urlsToLabels: [{ type: Input }],
    botoesDireita: [{ type: ContentChild, args: ['botoesDireita',] }]
};

const CLASS_FLOATING_BUTTON = '.btn-save';
class SectionComponent {
    constructor(router, elt, service, iframeParams, authResourcesConfig) {
        this.router = router;
        this.elt = elt;
        this.service = service;
        this.iframeParams = iframeParams;
        this.authResourcesConfig = authResourcesConfig;
        this.sidebarTree = [];
        this.enabled = true;
        this.fullScreen = false;
        this.hideHeader = false;
        this.route = '';
        this.startedNavigation = false;
        this.router.events.subscribe(event => this.handleRouteEvent(event));
    }
    get icon() {
        if (this.startedNavigation) {
            return 'fa fa-spinner fa-pulse fa-3x fa-fw';
        }
        let sidebarItem = this.findSidebarItem(this.sidebarTree);
        if (sidebarItem) {
            return sidebarItem.icon;
        }
        return 'fa fa-frown-o';
    }
    get caption() {
        if (this.startedNavigation) {
            return 'Carregando...';
        }
        let sidebarItem = this.findSidebarItem(this.sidebarTree);
        if (sidebarItem) {
            return sidebarItem.name;
        }
        return 'Não Encontrado';
    }
    handleRouteEvent(event) {
        if (event instanceof NavigationEnd) {
            this.startedNavigation = false;
            this.route = event.urlAfterRedirects.replace('/', '');
            setTimeout(() => this.hasFloatingButton =
                this.elt.nativeElement.querySelectorAll(CLASS_FLOATING_BUTTON).length > 0, 100);
        }
        else if (event instanceof NavigationStart) {
            this.startedNavigation = true;
        }
        else if (event instanceof NavigationCancel || event instanceof NavigationError) {
            this.startedNavigation = false;
        }
    }
    matchSidebar(sidebar, considerQueryParams) {
        const posicaoBarra = this.route.indexOf('/');
        const posicaoInicioParams = this.route.indexOf('?');
        let contextRoute = this.route ? this.route : this.getCurrentLocation();
        if (contextRoute.startsWith(`${this.authResourcesConfig.app}/`)) {
            contextRoute = contextRoute.replace(`${this.authResourcesConfig.app}/`, '');
        }
        if (posicaoBarra > 0 && posicaoInicioParams > 0) {
            if (posicaoBarra < posicaoInicioParams) {
                contextRoute = this.route.substring(0, posicaoBarra);
            }
            else {
                contextRoute = this.route.substring(0, posicaoInicioParams);
            }
        }
        else if (posicaoBarra > 0) {
            contextRoute = this.route.substring(0, posicaoBarra);
        }
        else if (posicaoInicioParams > 0) {
            contextRoute = this.route.substring(0, posicaoInicioParams);
        }
        if (considerQueryParams) {
            return this.matchSideBarQueryParams(sidebar, contextRoute);
        }
        else {
            return contextRoute === sidebar.route;
        }
    }
    internalFindSidebarItem(sidebarTree, considerQueryParams) {
        if (sidebarTree) {
            for (let i = 0; i < sidebarTree.length; i++) {
                if (this.matchSidebar(sidebarTree[i], considerQueryParams)) {
                    return sidebarTree[i];
                }
                let sidebarFound = this.internalFindSidebarItem(sidebarTree[i].items, considerQueryParams);
                if (sidebarFound) {
                    return sidebarFound;
                }
            }
        }
    }
    findSidebarItem(sidebarTree) {
        let sidebarFound = this.internalFindSidebarItem(sidebarTree, true);
        if (!sidebarFound) {
            sidebarFound = this.internalFindSidebarItem(sidebarTree, false);
        }
        if (sidebarFound) {
            return sidebarFound;
        }
        else {
            return this.service.getContents().find(s => this.route.startsWith(s.route));
        }
    }
    getCurrentLocation() {
        return window.location.pathname.replace('/', '');
    }
    matchSideBarQueryParams(sidebar, contextRoute) {
        if (sidebar.params) {
            const queryParams = sidebar.params['queryParams'];
            if (queryParams) {
                let matchParams = true;
                Object.keys(queryParams).forEach(key => {
                    const paramValue = queryParams[key];
                    matchParams = matchParams && this.route.includes(key.concat('='.concat(paramValue)));
                });
                return contextRoute === sidebar.route && matchParams;
            }
        }
        return false;
    }
}
SectionComponent.ɵfac = function SectionComponent_Factory(t) { return new (t || SectionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(SectionService), ɵngcc0.ɵɵdirectiveInject(IFrameStore), ɵngcc0.ɵɵdirectiveInject(AUTH_RESOURCES_CONFIG)); };
SectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SectionComponent, selectors: [["main-section"]], contentQueries: function SectionComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c10, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.botoesBreadcrumb = _t.first);
    } }, viewQuery: function SectionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BreadcrumbComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.breadCrumb = _t.first);
    } }, inputs: { sidebarTree: "sidebarTree", enabled: "enabled", fullScreen: "fullScreen", hideHeader: "hideHeader", toggled: "toggled", enabledBreadcrumb: "enabledBreadcrumb", urlsToLabels: "urlsToLabels" }, ngContentSelectors: _c14, decls: 4, vars: 14, consts: [[3, "ngStyle"], ["class", "main-content-header", 4, "ngIf"], [1, "main-content-header"], ["class", "page-name-outer", 4, "ngIf"], [3, "urlsToLabels", 4, "ngIf"], [1, "page-name-outer"], ["id", "window-title", 1, "page-name"], [3, "urlsToLabels"], ["botoesDireita", ""], [4, "ngTemplateOutlet"]], template: function SectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c12);
        ɵngcc0.ɵɵelementStart(0, "section", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, SectionComponent_header_2_Template, 3, 2, "header", 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("main-content", ctx.enabled)("sidebar-toggle", ctx.toggled && ctx.enabled)("fullScreen", ctx.fullScreen)("has-iframe", ɵngcc0.ɵɵpipeBind1(1, 10, ctx.iframeParams == null ? null : ctx.iframeParams.hasIframeObservable));
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(12, _c13, ctx.hasFloatingButton ? "80px" : "0px"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enabled && !ctx.hideHeader);
    } }, directives: [ɵngcc2.NgStyle, ɵngcc2.NgIf, BreadcrumbComponent, ɵngcc2.NgTemplateOutlet], pipes: [ɵngcc2.AsyncPipe], encapsulation: 2 });
SectionComponent.ctorParameters = () => [
    { type: Router },
    { type: ElementRef },
    { type: SectionService },
    { type: IFrameStore },
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_RESOURCES_CONFIG,] }] }
];
SectionComponent.propDecorators = {
    toggled: [{ type: Input }],
    sidebarTree: [{ type: Input }],
    enabled: [{ type: Input }],
    enabledBreadcrumb: [{ type: Input }],
    urlsToLabels: [{ type: Input }],
    fullScreen: [{ type: Input }],
    hideHeader: [{ type: Input }],
    botoesBreadcrumb: [{ type: ContentChild, args: ['botoesBreadcrumb',] }],
    breadCrumb: [{ type: ViewChild, args: [BreadcrumbComponent,] }]
};

class UsuarioInfoUtils {
    static usuarioInfoHasDefined(usuarioInfo) {
        return usuarioInfo && usuarioInfo.entidadePadrao && usuarioInfo.exercicioPadrao && usuarioInfo.mesPadrao;
    }
    static usuarioInfoHasDefinedOrcamento(usuarioInfo) {
        return usuarioInfo && usuarioInfo.entidadePadrao && usuarioInfo.exercicioPadrao;
    }
    static getEntidadePrincipal(usuarioInfo) {
        if (usuarioInfo.entidadePadrao) {
            return usuarioInfo.entidadePadrao;
        }
        if (usuarioInfo.entidades && usuarioInfo.entidades.length > 0) {
            let entidade = usuarioInfo.entidades.find(ent => ent.principal);
            if (!entidade) {
                entidade = usuarioInfo.entidades[0];
            }
            return entidade;
        }
        return null;
    }
    static getModuloPrincipal(usuarioInfo, moduloSuggest) {
        if (usuarioInfo.modulos && usuarioInfo.modulos.length > 0) {
            let modulo;
            if (moduloSuggest) {
                modulo = usuarioInfo.modulos.find(mod => mod.id === moduloSuggest);
            }
            else {
                modulo = usuarioInfo.modulos.find(mod => mod.principal);
            }
            if (!modulo) {
                modulo = usuarioInfo.modulos[0];
            }
            return modulo;
        }
        return null;
    }
}

const DAYS_EXPIRES_REMEMBER = 10;
const ELOTECH_DOMAIN = '.elotech.localnet';
const MODULO_KEY = 'modulo';
class AuthParams {
    constructor(authResourcesConfig) {
        this.authResourcesConfig = authResourcesConfig;
        this.onLoginSource = new ReplaySubject();
        this.onLoginObservers = this.onLoginSource.asObservable();
        this.moduloFromUrl = '--';
        this.usuarioInfoMemory = null;
        this.tokenKey = this.authResourcesConfig.tokenKey;
        this.moduloFromUrl = this.getModuloFromUrl();
        if (this.isLogged()) {
            this.onLoginSource.next(true);
        }
    }
    isLogged() {
        return Cookie.get(this.tokenKey) !== null;
    }
    getToken() {
        return Cookie.get(this.tokenKey);
    }
    setLogged(token, rememberMe) {
        let days = rememberMe ? DAYS_EXPIRES_REMEMBER : 0;
        Cookie.set(this.tokenKey, token, days, '/', this.getDomain());
        this.onLoginSource.next(true);
    }
    logout() {
        Cookie.set(this.tokenKey, Cookie.get(this.tokenKey), -1, '/', this.getDomain());
        this.usuarioInfoMemory = null;
        this.onLoginSource.next(false);
    }
    setUsuarioInfo(usuarioInfo, useConfig = true) {
        this.usuarioInfoMemory = usuarioInfo;
        if (!this.usuarioInfoMemory.entidadePadrao) {
            if (this.usuarioInfoMemory.entidades) {
                this.usuarioInfoMemory.entidadePadrao = usuarioInfo.entidades.find(entidade => entidade.principal);
            }
        }
        if (BaseHref.testCurrPath() && this.usuarioInfoMemory.entidadePadrao && this.usuarioInfoMemory.entidades.length > 0) {
            const baseHrefFromUrl = BaseHref.extract();
            if (baseHrefFromUrl.entidade === 0 || !useConfig) {
                const baseHref = new BaseHref(this.usuarioInfoMemory.entidadePadrao.id, this.usuarioInfoMemory.mesPadrao, this.usuarioInfoMemory.exercicioPadrao);
                baseHref.change();
            }
            else {
                this.usuarioInfoMemory.entidadePadrao = usuarioInfo.entidades.find(entidade => entidade.id === baseHrefFromUrl.entidade);
                this.usuarioInfoMemory.exercicioPadrao = baseHrefFromUrl.ano;
                this.usuarioInfoMemory.mesPadrao = baseHrefFromUrl.mes;
            }
        }
    }
    getUsuarioInfo() {
        return this.usuarioInfoMemory;
    }
    hasUsuarioInfo() {
        return this.usuarioInfoMemory !== null;
    }
    getModuloFromUrl() {
        const locationSearch = this.getLocationSearch().replace('?', '');
        return new HttpParams({ fromString: locationSearch }).get(MODULO_KEY);
    }
    getLocationSearch() {
        return window.location.search;
    }
    getInitialModuloFromUrl() {
        return this.moduloFromUrl;
    }
    getActualModulo() {
        if (this.hasUsuarioInfo()) {
            return UsuarioInfoUtils.getModuloPrincipal(this.getUsuarioInfo(), this.getInitialModuloFromUrl());
        }
        return null;
    }
    getDomain() {
        let domain = window.location.hostname;
        if (domain.includes(ELOTECH_DOMAIN)) {
            domain = ELOTECH_DOMAIN;
        }
        return domain;
    }
}
AuthParams.ɵfac = function AuthParams_Factory(t) { return new (t || AuthParams)(ɵngcc0.ɵɵinject(AUTH_RESOURCES_CONFIG)); };
AuthParams.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthParams, factory: AuthParams.ɵfac });
AuthParams.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_RESOURCES_CONFIG,] }] }
];

class RolesCache {
    static create(userRoles) {
        if (userRoles.length && userRoles.length !== 0) {
            this.roles = userRoles.map(role => role.name);
            this.isLoaded.next(true);
        }
        else {
            this.isLoaded.next(false);
        }
    }
    static getAllRoles() {
        if (this.roles.length) {
            return this.roles;
        }
        return [];
    }
}
RolesCache.roles = [];
RolesCache.isLoaded = new BehaviorSubject(false);

// tslint:disable-next-line: variable-name
const Keycloak = Keycloak_;
const initOptions = {
    onLoad: 'login-required'
};
class KeycloakAuthHttp {
    constructor(_httpClient, _keycloakAuthResourceConfig, authParams) {
        this._httpClient = _httpClient;
        this._keycloakAuthResourceConfig = _keycloakAuthResourceConfig;
        this.authParams = authParams;
        if (!KeycloakAuthHttp._keycloak) {
            KeycloakAuthHttp._keycloak = Keycloak(this._keycloakAuthResourceConfig);
        }
    }
    isLogged() {
        return KeycloakAuthHttp._keycloak.authenticated;
    }
    hasPermissionByRoute(route) {
        const permissions = this._keycloakAuthResourceConfig.permissions;
        if (!route || !permissions || !permissions.length) {
            return of(true);
        }
        const searchRoute = route.startsWith('/') ? route.replace('/', '') : route;
        const permissaoRota = permissions.find(p => p.route === searchRoute);
        return new Observable(subscriber => {
            RolesCache.isLoaded.subscribe(isLoaded => {
                if (isLoaded) {
                    subscriber.next(permissaoRota &&
                        RolesCache.getAllRoles().includes(permissaoRota.role));
                }
            });
        });
    }
    getPermissionsByRole(role) {
        return of(RolesCache.getAllRoles().filter(roleUsuario => roleUsuario.startsWith(role)));
    }
    logoutAndGoToAuthForm() {
        KeycloakAuthHttp._keycloak.logout();
    }
    getUsuarioLogado() {
        this.getUser().then(usuario => {
            return usuario;
        });
    }
    getUser() {
        if (!KeycloakAuthHttp._userInfoPromise) {
            KeycloakAuthHttp._userInfoPromise = new Promise(resolve => {
                return KeycloakAuthHttp._keycloak.loadUserInfo().success(userInfo => {
                    resolve(userInfo);
                });
            });
        }
        return KeycloakAuthHttp._userInfoPromise;
    }
    getToken() {
        return KeycloakAuthHttp._keycloak.token;
    }
    refreshToken() {
        return new Promise((resolve, reject) => {
            KeycloakAuthHttp._keycloak
                .updateToken(5)
                .success(refreshed => {
                resolve(refreshed);
            })
                .error(err => {
                reject(err);
            });
        });
    }
    getTokenParsed() {
        return KeycloakAuthHttp._keycloak.tokenParsed;
    }
    isAllowedAdmin() {
        return KeycloakAuthHttp._keycloak.hasRealmRole(this._keycloakAuthResourceConfig.adminRealmRole);
    }
    getEntidade() {
        return (KeycloakAuthHttp._keycloak.idTokenParsed &&
            KeycloakAuthHttp._keycloak.idTokenParsed['entidade']);
    }
    getExercicio() {
        return (KeycloakAuthHttp._keycloak.idTokenParsed &&
            KeycloakAuthHttp._keycloak.idTokenParsed['exercicio']);
    }
    hasRole(role) {
        return KeycloakAuthHttp._keycloak.hasResourceRole(role, this._keycloakAuthResourceConfig.resourceRole);
    }
    init(options = initOptions) {
        return new Promise((resolve, reject) => {
            KeycloakAuthHttp._keycloak
                .init(options)
                .success((authenticated) => {
                if (authenticated) {
                    resolve(authenticated);
                }
                else {
                    reject();
                }
            })
                .error(error => reject(error));
        });
    }
    getModulos() {
        let httpHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.getToken()}`,
            'x-tenant-host': window.location.host
        });
        return this._httpClient.get(`/keycloak-api/usuario/me/modulos`, {
            headers: httpHeader
        });
    }
    getUserProfile() {
        return KeycloakAuthHttp._keycloak.loadUserProfile();
    }
    sobrescreverAttributos(attributes) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.getToken()}`,
            'x-tenant-host': window.location.host
        });
        return this._httpClient.put(`/keycloak-api/usuario/me/attributes`, attributes, { headers });
    }
    isAdmin() {
        throw new Error('Method not implemented.');
    }
    setUsuarioInfo(userInfo) {
        Cookie.set('DATA_OPERACAO', JSON.stringify(userInfo.dataOperacao), 1, '/', window.location.hostname);
        this.authParams.setUsuarioInfo(userInfo);
    }
    getUsuarioInfo() {
        return this.authParams.getUsuarioInfo();
    }
    findAllEntidadesByUsuario(idUsuario) {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.getToken()}`,
            'x-tenant-host': window.location.host
        });
        return this._httpClient.get(`/keycloak-api/usuario/${idUsuario}/entidades`, { headers });
    }
}
KeycloakAuthHttp.ɵfac = function KeycloakAuthHttp_Factory(t) { return new (t || KeycloakAuthHttp)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(KEYCLOAK_AUTH_RESOURCES_CONFIG), ɵngcc0.ɵɵinject(AuthParams)); };
KeycloakAuthHttp.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: KeycloakAuthHttp, factory: KeycloakAuthHttp.ɵfac });
KeycloakAuthHttp._keycloak = null;
KeycloakAuthHttp._userInfoPromise = null;
KeycloakAuthHttp.ctorParameters = () => [
    { type: HttpClient$1 },
    { type: undefined, decorators: [{ type: Inject, args: [KEYCLOAK_AUTH_RESOURCES_CONFIG,] }] },
    { type: AuthParams }
];

class BreadcrumbIframeService {
    createBreadcrumb(section) {
        WindowService.getWindow().onmessage = (element) => {
            this.setRoutesBreadcrumb(section, element);
        };
    }
    setRoutesBreadcrumb(section, element) {
        var _a, _b, _c;
        const routes = (_a = section === null || section === void 0 ? void 0 : section.breadCrumb) === null || _a === void 0 ? void 0 : _a.routes;
        const iframeSrc = (_b = this.iframeSelector()) === null || _b === void 0 ? void 0 : _b.src;
        if ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.query) {
            let urlRoot = '';
            if (routes.length > 0) {
                urlRoot = `${routes.map(r => r.url).reduce((p, c) => `${p}/${c}`)}/`;
            }
            routes[routes.length - 1].iframe = true;
            routes[routes.length - 1].onClick = () => {
                let iframeElement = this.iframeSelector();
                iframeElement.src = iframeSrc;
                routes.pop();
            };
            this.createRoutes(routes, urlRoot, element);
        }
    }
    createRoutes(routes, urlRoot, element) {
        routes.push({
            url: urlRoot,
            label: element.data.query.name,
            icon: 'fa fa-search',
            queryParams: '',
            ordinal: routes.length + 1,
        });
    }
    iframeSelector() {
        return document.querySelector('iframe');
    }
}
BreadcrumbIframeService.ɵfac = function BreadcrumbIframeService_Factory(t) { return new (t || BreadcrumbIframeService)(); };
BreadcrumbIframeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BreadcrumbIframeService, factory: BreadcrumbIframeService.ɵfac });

class ConsultaDinamicaComponent {
    constructor(_keycloak, _breadcrumbIframe, section) {
        this._keycloak = _keycloak;
        this._breadcrumbIframe = _breadcrumbIframe;
        this.section = section;
        this.altura = '80vh';
        this._breadcrumbIframe.createBreadcrumb(this.section);
    }
    ngOnInit() {
        this.entidade = this._keycloak.getUsuarioInfo().entidadePadrao.id;
        this.competenciaAtual = this._keycloak.getUsuarioInfo().mesPadrao;
        this.exercicio = this._keycloak.getUsuarioInfo().exercicioPadrao;
        const origin = WindowService.getWindow().location.origin;
        if (!this.url) {
            this.url = `${origin}/unico/consulta-de-dados-dinamica?iframe=true&modulo=${this.modulo}&entidade=${this.entidade}&exercicio=${this.exercicio}&competencia=${this.competenciaAtual}`;
        }
    }
}
ConsultaDinamicaComponent.ɵfac = function ConsultaDinamicaComponent_Factory(t) { return new (t || ConsultaDinamicaComponent)(ɵngcc0.ɵɵdirectiveInject(KeycloakAuthHttp), ɵngcc0.ɵɵdirectiveInject(BreadcrumbIframeService), ɵngcc0.ɵɵdirectiveInject(SectionComponent)); };
ConsultaDinamicaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConsultaDinamicaComponent, selectors: [["consulta-dinamica"]], inputs: { altura: "altura", url: "url", modulo: "modulo" }, decls: 2, vars: 4, consts: [[3, "ngStyle"], ["id", "iframe", 3, "src", 4, "ngIf"], ["id", "iframe", 3, "src"]], template: function ConsultaDinamicaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ConsultaDinamicaComponent_iframe_1_Template, 2, 3, "iframe", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(2, _c15, ctx.altura));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.url);
    } }, directives: [ɵngcc2.NgStyle, ɵngcc2.NgIf], pipes: [SafeUrlPipe], styles: ["#iframe[_ngcontent-%COMP%] {width:100%; height: 100%;}"] });
ConsultaDinamicaComponent.ctorParameters = () => [
    { type: KeycloakAuthHttp },
    { type: BreadcrumbIframeService },
    { type: SectionComponent }
];
ConsultaDinamicaComponent.propDecorators = {
    modulo: [{ type: Input }],
    altura: [{ type: Input }],
    url: [{ type: Input }]
};

class ConsultaDinamicaModule {
}
ConsultaDinamicaModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ConsultaDinamicaModule });
ConsultaDinamicaModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ConsultaDinamicaModule_Factory(t) { return new (t || ConsultaDinamicaModule)(); }, providers: [WindowService, BreadcrumbIframeService], imports: [[CommonModule$1, PipeModule]] });

class ArvoreAvancadaComponent {
    constructor() {
        this.onSelection = new EventEmitter();
        this.onEdition = new EventEmitter();
        this.onDeletion = new EventEmitter();
        this.onHeadClick = new EventEmitter();
    }
    onDeletionThen(node) {
        this.onDeletion.emit(node);
    }
    headClick(node) {
        this.onHeadClick.emit(node);
    }
    onEditionThen(node) {
        this.onEdition.emit(node);
    }
    emitirSelecionado(node) {
        this.onSelection.emit(node);
    }
    get visibleNodes() {
        return this._getAllNodes().filter(node => node.visible);
    }
    _getAllNodes() {
        let allNodes = [];
        this.nodes.forEach(node => {
            allNodes = [...allNodes, node, ...this._mapChildren(node)];
        });
        return allNodes;
    }
    _mapChildren(node) {
        let result = [];
        if (node.children.length > 0) {
            node.children.forEach(child => {
                result = [...result, child, ...this._mapChildren(child)];
            });
        }
        return result;
    }
}
ArvoreAvancadaComponent.ɵfac = function ArvoreAvancadaComponent_Factory(t) { return new (t || ArvoreAvancadaComponent)(); };
ArvoreAvancadaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ArvoreAvancadaComponent, selectors: [["arvore-avancada"]], inputs: { nodes: "nodes", formNode: "formNode" }, outputs: { onSelection: "onSelection", onEdition: "onEdition", onDeletion: "onDeletion", onHeadClick: "onHeadClick" }, decls: 3, vars: 1, consts: [[1, "advtree"], [1, "advtree-container"], ["class", "advtree-item", 3, "ngClass", "node", "formNode", "showActions", "onEdition", "onSelection", "onDeletion", "onHeadClick", 4, "ngFor", "ngForOf"], [1, "advtree-item", 3, "ngClass", "node", "formNode", "showActions", "onEdition", "onSelection", "onDeletion", "onHeadClick"]], template: function ArvoreAvancadaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, ArvoreAvancadaComponent_arvore_avancada_node_2_Template, 1, 6, "arvore-avancada-node", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.visibleNodes);
    } }, directives: function () { return [ɵngcc2.NgForOf, ArvoreAvancadaNodeComponent, ɵngcc2.NgClass]; }, encapsulation: 2 });
ArvoreAvancadaComponent.propDecorators = {
    nodes: [{ type: Input }],
    formNode: [{ type: Input }],
    onSelection: [{ type: Output }],
    onEdition: [{ type: Output }],
    onDeletion: [{ type: Output }],
    onHeadClick: [{ type: Output }]
};

class ArvoreAvancadaNodeHeaderComponent {
    constructor() {
        this.showActions = false;
        this.onHeadClick = new EventEmitter();
    }
    set content(levelHeader) {
        this.headerActions = levelHeader.headerActions;
        this.levelNumber = levelHeader.levelNumber;
        this.levelName = levelHeader.levelName;
        this.hint = levelHeader.hint;
    }
    headClick(node) {
        this.onHeadClick.emit(node);
    }
    ngOnInit() {
        this.content = this.node.header;
    }
    ngOnChanges(changes) {
        this.content = changes.node.currentValue.header;
    }
}
ArvoreAvancadaNodeHeaderComponent.ɵfac = function ArvoreAvancadaNodeHeaderComponent_Factory(t) { return new (t || ArvoreAvancadaNodeHeaderComponent)(); };
ArvoreAvancadaNodeHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ArvoreAvancadaNodeHeaderComponent, selectors: [["arvore-avancada-node-header"]], inputs: { showActions: "showActions", node: "node" }, outputs: { onHeadClick: "onHeadClick" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 9, vars: 4, consts: [["type", "radio", "aria-label", "Seletor item \u00E1rvore", "name", "advtree-selector", 1, "advtree-selector", 3, "click"], [1, "advtree-header", 3, "click"], [1, "advtree-title"], [1, "id", "hint", "module-color", "top-left"], ["class", "hint-content", 4, "ngIf"], [1, "title"], ["class", "advtree-actions", 4, "ngIf"], [1, "hint-content"], [1, "advtree-actions"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function ArvoreAvancadaNodeHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0);
        ɵngcc0.ɵɵlistener("click", function ArvoreAvancadaNodeHeaderComponent_Template_input_click_0_listener() { return ctx.headClick(ctx.node); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function ArvoreAvancadaNodeHeaderComponent_Template_div_click_1_listener() { return ctx.headClick(ctx.node); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵtemplate(5, ArvoreAvancadaNodeHeaderComponent_div_5_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, ArvoreAvancadaNodeHeaderComponent_div_8_Template, 2, 4, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.levelNumber, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hint);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.node.summary);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showActions);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
ArvoreAvancadaNodeHeaderComponent.propDecorators = {
    showActions: [{ type: Input }],
    node: [{ type: Input }],
    onHeadClick: [{ type: Output }]
};

class ArvoreAvancadaChildrenSummaryComponent {
    constructor() {
        this.onEdition = new EventEmitter();
        this.onSelecion = new EventEmitter();
        this.onDeletion = new EventEmitter();
    }
    get summaries() {
        return this.children.map(c => c.summary);
    }
    onEdit(event, resume) {
        if (event)
            event.stopPropagation();
        this.onEdition.emit(resume);
    }
    selectNode(event, summary) {
        if (event)
            event.stopPropagation();
        let found = this.children.find(child => child.summary === summary);
        if (found) {
            this.onSelecion.emit(found);
        }
    }
    emitOnDelete(event, summary) {
        if (event)
            event.stopPropagation();
        this.onDeletion.emit(summary);
    }
}
ArvoreAvancadaChildrenSummaryComponent.ɵfac = function ArvoreAvancadaChildrenSummaryComponent_Factory(t) { return new (t || ArvoreAvancadaChildrenSummaryComponent)(); };
ArvoreAvancadaChildrenSummaryComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ArvoreAvancadaChildrenSummaryComponent, selectors: [["arvore-avancada-children-resume"]], inputs: { children: "children" }, outputs: { onEdition: "onEdition", onSelecion: "onSelecion", onDeletion: "onDeletion" }, decls: 2, vars: 1, consts: [[1, "list"], [4, "ngFor", "ngForOf"], [3, "click"], [1, "description"], [1, "btn-actions"], ["type", "button", 1, "btn", "circle", 3, "id", "click"], [1, "fa", "fa-pencil"], [1, "btn-actions-label"], [1, "fa", "fa-trash"]], template: function ArvoreAvancadaChildrenSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, ArvoreAvancadaChildrenSummaryComponent_ng_container_1_Template, 13, 3, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.summaries);
    } }, directives: [ɵngcc2.NgForOf], encapsulation: 2 });
ArvoreAvancadaChildrenSummaryComponent.propDecorators = {
    children: [{ type: Input }],
    onEdition: [{ type: Output }],
    onSelecion: [{ type: Output }],
    onDeletion: [{ type: Output }]
};

class ArvoreAvancadaNodeComponent {
    constructor() {
        this.onSelection = new EventEmitter();
        this.showActions = false;
        this.onEdition = new EventEmitter();
        this.onDeletion = new EventEmitter();
        this.onHeadClick = new EventEmitter();
        this.checked = false;
    }
    headClick(node) {
        this.onHeadClick.emit(node);
    }
    emitirSelecionado(node) {
        this.onSelection.emit(node);
    }
    onEditionThen(summary) {
        const found = this._findNode(summary);
        this.onEdition.emit(found);
    }
    onDeletionThen(summary) {
        this.onDeletion.emit(this._findNode(summary));
    }
    _findNode(summary) {
        let found = this.node.children.find(child => child.summary === summary);
        if (found) {
            return found;
        }
        else {
            throw 'Registro não foi encontrado';
        }
    }
}
ArvoreAvancadaNodeComponent.ɵfac = function ArvoreAvancadaNodeComponent_Factory(t) { return new (t || ArvoreAvancadaNodeComponent)(); };
ArvoreAvancadaNodeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ArvoreAvancadaNodeComponent, selectors: [["arvore-avancada-node"]], inputs: { showActions: "showActions", node: "node", formNode: "formNode" }, outputs: { onSelection: "onSelection", onEdition: "onEdition", onDeletion: "onDeletion", onHeadClick: "onHeadClick" }, decls: 6, vars: 6, consts: [[3, "node", "showActions", "onHeadClick"], [1, "advtree-content"], [4, "ngIf", "ngIfElse"], ["list", ""], [3, "node", 4, "ngIf"], [3, "node"], [3, "children", "onEdition", "onSelecion", "onDeletion"]], template: function ArvoreAvancadaNodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "arvore-avancada-node-header", 0);
        ɵngcc0.ɵɵlistener("onHeadClick", function ArvoreAvancadaNodeComponent_Template_arvore_avancada_node_header_onHeadClick_0_listener($event) { return ctx.headClick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, ArvoreAvancadaNodeComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵtemplate(4, ArvoreAvancadaNodeComponent_ng_template_4_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("node", ctx.node)("showActions", ctx.showActions);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(3, 4, ctx.formNode))("ngIfElse", _r1);
    } }, directives: function () { return [ArvoreAvancadaNodeHeaderComponent, ɵngcc2.NgIf, ArvoreAvancadaNodeFormComponent, ArvoreAvancadaChildrenSummaryComponent]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, encapsulation: 2 });
ArvoreAvancadaNodeComponent.propDecorators = {
    node: [{ type: Input }],
    onSelection: [{ type: Output }],
    showActions: [{ type: Input }],
    onEdition: [{ type: Output }],
    onDeletion: [{ type: Output }],
    onHeadClick: [{ type: Output }],
    formNode: [{ type: Input }]
};

class ArvoreAvancadaNodeFormComponent {
}
ArvoreAvancadaNodeFormComponent.ɵfac = function ArvoreAvancadaNodeFormComponent_Factory(t) { return new (t || ArvoreAvancadaNodeFormComponent)(); };
ArvoreAvancadaNodeFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ArvoreAvancadaNodeFormComponent, selectors: [["arvore-avancada-node-form"]], inputs: { node: "node" }, decls: 1, vars: 4, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function ArvoreAvancadaNodeFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ArvoreAvancadaNodeFormComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.node == null ? null : ctx.node.formTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c17, ctx.node));
    } }, directives: [ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
ArvoreAvancadaNodeFormComponent.propDecorators = {
    node: [{ type: Input }]
};

class ArvoreAvancadaModule {
}
ArvoreAvancadaModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ArvoreAvancadaModule });
ArvoreAvancadaModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ArvoreAvancadaModule_Factory(t) { return new (t || ArvoreAvancadaModule)(); }, imports: [[
            CommonModule$1,
            FormsModule,
        ]] });

class AssinaturaSelectorComponent {
    constructor() {
        this.onSelectAssinatura = new EventEmitter();
        this.assinaturas = [];
        this.assinaturasPadrao = [];
    }
    ngOnInit() {
        if (this.assinaturaService) {
            this.loadAssinaturaList();
        }
    }
    loadAssinaturaList() {
        this.assinaturaService.findAtivos().subscribe(list => {
            this.assinaturas = list;
            this.assinaturasPadrao = [];
            list.forEach(element => {
                if (element.padrao) {
                    this.assinaturasPadrao.push(element);
                }
            });
            this.selectAssinatura(this.assinaturasPadrao);
        });
    }
    selectAssinatura(selecionados) {
        this.assinaturasPadrao = selecionados;
        this.onSelectAssinatura.emit(this.assinaturasPadrao.map((assinatura) => assinatura.id).join('-'));
    }
}
AssinaturaSelectorComponent.ɵfac = function AssinaturaSelectorComponent_Factory(t) { return new (t || AssinaturaSelectorComponent)(); };
AssinaturaSelectorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AssinaturaSelectorComponent, selectors: [["assinatura-selector"]], inputs: { assinaturaService: "assinaturaService" }, outputs: { onSelectAssinatura: "onSelectAssinatura" }, decls: 5, vars: 6, consts: [[1, "mt-sm"], ["title", "Assinaturas", 3, "hasForm"], ["selectionModeId", "assinaturas", "id", "assinaturas", "selectionMode", "multiple", 3, "emptyMessage", "values", "selection", "onModifySelection"], ["field", "cargo.descricao", "header", "Cargo"], ["field", "pessoa", "header", "Nome"]], template: function AssinaturaSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "elo-panel", 1);
        ɵngcc0.ɵɵelementStart(2, "elo-datatable", 2);
        ɵngcc0.ɵɵlistener("onModifySelection", function AssinaturaSelectorComponent_Template_elo_datatable_onModifySelection_2_listener($event) { return ctx.selectAssinatura($event); });
        ɵngcc0.ɵɵelement(3, "elo-column", 3);
        ɵngcc0.ɵɵelement(4, "elo-column", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hasForm", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap("fancy fixed");
        ɵngcc0.ɵɵproperty("emptyMessage", "N\u00E3o foi encontrado assinaturas.")("values", ctx.assinaturas)("selection", ctx.assinaturasPadrao);
    } }, directives: function () { return [PanelComponent, EloDatatableComponent, EloColumnComponent]; }, encapsulation: 2 });
AssinaturaSelectorComponent.propDecorators = {
    assinaturaService: [{ type: Input }],
    onSelectAssinatura: [{ type: Output }]
};

class ObjectUtilService {
    /**
     * @param selection conjunto de dados
     * @param entity objeto a ser encontrado no conjnto
     *
     // tslint:disable-next-line: no-redundant-jsdoc
     * @returns retorna -1 quando não encontra, retorna a posição do array quando encontra
     */
    findIndexInSelection(selection, entity) {
        let index = -1;
        if (selection) {
            for (let i = 0; i < selection.length; i++) {
                if (this.equals(entity, selection[i])) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }
    equals(obj1, obj2) {
        if (obj1 === null && obj2 === null) {
            return true;
        }
        if (obj1 === null || obj2 === null) {
            return false;
        }
        if (obj1 === obj2) {
            return true;
        }
        if (typeof obj1 === 'object' && typeof obj2 === 'object') {
            if (obj1['id'] && obj2['id']) {
                if (obj1['id'] === obj2['id']) {
                    return true;
                }
            }
            for (let p in obj1) {
                if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
                    return false;
                }
                switch (typeof (obj1[p])) {
                    case 'object':
                        if (!this.equals(obj1[p], obj2[p])) {
                            return false;
                        }
                        break;
                    case 'function':
                        if (typeof (obj2[p]) === 'undefined' || (p !== 'compare' && obj1[p].toString() !== obj2[p].toString())) {
                            return false;
                        }
                        break;
                    default:
                        if (obj1[p] !== obj2[p]) {
                            return false;
                        }
                        break;
                }
            }
            for (let prop in obj2) {
                if (typeof (obj1[prop]) === 'undefined') {
                    return false;
                }
            }
            return true;
        }
        return false;
    }
}
ObjectUtilService.ɵfac = function ObjectUtilService_Factory(t) { return new (t || ObjectUtilService)(); };
ObjectUtilService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ObjectUtilService, factory: ObjectUtilService.ɵfac });

var EloTableActionType;
(function (EloTableActionType) {
    EloTableActionType[EloTableActionType["complex"] = 1] = "complex";
    EloTableActionType[EloTableActionType["link"] = 2] = "link";
})(EloTableActionType || (EloTableActionType = {}));
// tslint:disable-next-line:directive-class-suffix
class EloTableAction {
    constructor() {
        this.visible = true;
        /**
         * Nome do atributo do objeto que é booleano, se true exibe o table action
         * Caso não seja booleano, está submisso as regras do javascript, por exemplo:
         *
         * number = 0 isso é false
         * null = false
         * undefined = false
         *
         */
        this.visibleWhenAttribute = '';
    }
    complex() {
        return EloTableActionType.complex;
    }
    link() {
        return EloTableActionType.link;
    }
    addOn(table) {
        if (table) {
            table.addTableActions(this);
        }
    }
}
EloTableAction.ɵfac = function EloTableAction_Factory(t) { return new (t || EloTableAction)(); };
EloTableAction.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: EloTableAction, inputs: { visible: "visible", visibleWhenAttribute: "visibleWhenAttribute", icon: "icon", title: "title", id: "id", visibleWhenFunction: "visibleWhenFunction" } });
EloTableAction.propDecorators = {
    icon: [{ type: Input }],
    visible: [{ type: Input }],
    title: [{ type: Input }],
    id: [{ type: Input }],
    visibleWhenAttribute: [{ type: Input }],
    visibleWhenFunction: [{ type: Input }]
};

function EloTableActionTypeAware(constructor) {
    constructor.prototype.EloTableActionType = EloTableActionType;
}
class EloDatatableComponent {
    constructor(eloObjectUtilService) {
        this.eloObjectUtilService = eloObjectUtilService;
        this.emptyMessage = 'Não foram encontrados resultados, adicione registros clicando em + .';
        /**
         * Informar selecionModeId único quando selectionMode for 'multiple' e houver mais de 1 grupo de checkbox
         */
        this.selectionModeId = '';
        /**
         * Irá emitir o elemento selecionado
         */
        this.onClickCheckbox = new EventEmitter();
        /**
         * Irá emitir o elemento selecionado
         */
        this.onClickRadioButton = new EventEmitter();
        /**
         * Emit o click do botão de selecionar apenas um item da linha
         */
        this.onSelectOne = new EventEmitter();
        /**
         * Ira emitir todos os elementos selecionados
         */
        this.onModifySelection = new EventEmitter();
        /**
         * Deve ser setada para que funcione a ordenação no click do header
         */
        this.onTableHeadClick = new EventEmitter();
        /**
         * Deve ser setada para true caso a grid tenha ordenação pela coluna do header
         */
        this.sortable = false;
        this.isQuickViewOpener = false;
        this.manyActions = false;
        this.onInputChange = new EventEmitter();
        this.rowDoubleClickFunction = null;
        this.enableScrollX = false;
        this.textTransform = 'capitalize';
        this.eloColumns = [];
        this.eloTableActions = [];
        this.eloHeaderActions = [];
    }
    get expandTemplate() {
        if (this.childExpandTemplate) {
            return this.childExpandTemplate;
        }
        return this.paramExpandTemplate;
    }
    addColumn(column) {
        let columnFound = this.eloColumns.find(col => col.field === column.field);
        if (columnFound) {
            columnFound.field = column.field;
            columnFound.header = column.header;
            columnFound.isDecimal = column.isDecimal;
            columnFound.isDate = column.isDate;
            columnFound.enumOptions = column.enumOptions;
        }
        else {
            this.eloColumns.push(column);
        }
    }
    addTableActions(tableActions) {
        this.eloTableActions.push(tableActions);
    }
    addTableActionsAt(tableActions, index) {
        this.eloTableActions.splice(index, 0, tableActions);
    }
    addHeaderActions(headerActions) {
        this.eloHeaderActions.push(headerActions);
    }
    isMultipleSelectionMode() {
        return this.selectionMode === 'multiple';
    }
    isSingleSelectionMode() {
        return this.selectionMode === 'single';
    }
    isRadioSelectionMode() {
        return this.selectionMode === 'radio';
    }
    clickSelectAll() {
        this.selectAll();
        this.onModifySelection.emit(this.selection);
    }
    clickHeaderTable(column) {
        if (this.sortable && column.sortable) {
            this.onTableHeadClick.emit(column.field);
        }
    }
    get columnCount() {
        let count;
        this.selectionMode === 'multiple' ? count = 1 : count = 0;
        this.eloColumns.forEach(column => {
            count += 1;
        });
        return count + 1;
    }
    selectAll() {
        if (!this.isAllSelected()) {
            this.selection = this.selectableObjects();
        }
        else {
            this.selection = [];
        }
    }
    selectableObjects() {
        if (this.values) {
            return this.values.filter((obj) => {
                if (this.fieldShowCheckbox) {
                    return obj[this.fieldShowCheckbox];
                }
                return true;
            });
        }
    }
    clickCheckBox(entity) {
        this.handleSelection(entity);
        entity.selected = this.isSelected(entity);
        this.onClickCheckbox.emit(entity);
    }
    clickSelectOne(entity) {
        this.handleSelection(entity);
        this.onSelectOne.emit(entity);
    }
    clickRadioButton(entity) {
        this.handleSelection(entity);
        this.onClickRadioButton.emit(entity);
    }
    handleSelection(entity) {
        let selectionIndex = this.eloObjectUtilService.findIndexInSelection(this.selection, entity);
        this.selection = this.selection || [];
        if (selectionIndex !== -1) { // se está no array, remove
            this.selection.splice(selectionIndex, 1);
        }
        else { // se não está, adiciona ao array dos selecionados
            this.selection.push(entity);
        }
        this.onModifySelection.emit(this.selection);
    }
    isSelected(entity) {
        return this.eloObjectUtilService.findIndexInSelection(this.selection, entity) !== -1;
    }
    isAllSelected() {
        return this.selection && this.selectableObjects() && (this.selection.length === this.selectableObjects().length);
    }
    checkAllowed(object) {
        if (object && this.fieldShowCheckbox) {
            return object[this.fieldShowCheckbox];
        }
        return true;
    }
    tableActionVisibleTo(object) {
        return this.eloTableActionsVisibles.filter(action => {
            if (action.visibleWhenFunction) {
                return action.visibleWhenFunction(object, action);
            }
            return action.visibleWhenAttribute === '' || object[action.visibleWhenAttribute];
        });
    }
    get eloTableActionsVisibles() {
        return this.eloTableActions.filter(action => action.visible);
    }
    haveAction() {
        return this.eloTableActionsVisibles.length > 0 || this.eloHeaderActions.length > 0;
    }
    haveHeaderAction() {
        return this.eloHeaderActions.length > 0 || (this.eloTableActionsVisibles.length > 0 && !this.enableScrollX);
    }
    enableHeaderActionColspan() {
        return this.haveAction() && this.eloHeaderActions.length > 1 && !this.enableScrollX;
    }
    getValue(obj, field, enumOptions) {
        let value = obj;
        field.split('.').forEach(fieldPart => {
            if (!value) {
                return;
            }
            value = value[fieldPart];
        });
        if (enumOptions && enumOptions.length > 0) {
            const optionFound = enumOptions.find(option => option.codigo === value);
            if (optionFound) {
                return optionFound.descricao;
            }
        }
        if (typeof value === 'boolean') {
            return value ? 'Sim' : 'Não';
        }
        return value;
    }
    getSort(column, order) {
        return this.pageParameters.sort
            && this.pageParameters.sort.indexOf(`${column},${order}`) !== -1;
    }
    getLastColumnStyle(column) {
        return ((column.isDecimal || column.headerAlign === 'right')
            && this.haveHeaderAction() && this.eloHeaderActions.length > 1) ?
            { 'padding-right': '25px' } : {};
    }
    getLastColumnColspan(column) {
        const col = column.col || 1;
        return (this.haveHeaderAction() && this.eloHeaderActions.length > 1) ? col + 1 : col;
    }
}
EloDatatableComponent.ɵfac = function EloDatatableComponent_Factory(t) { return new (t || EloDatatableComponent)(ɵngcc0.ɵɵdirectiveInject(ObjectUtilService)); };
EloDatatableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloDatatableComponent, selectors: [["elo-datatable"]], contentQueries: function EloDatatableComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c18, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c19, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c20, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dataTableFooter = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dataTableSubtitles = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.childExpandTemplate = _t.first);
    } }, inputs: { emptyMessage: "emptyMessage", selectionModeId: "selectionModeId", sortable: "sortable", isQuickViewOpener: "isQuickViewOpener", manyActions: "manyActions", rowDoubleClickFunction: "rowDoubleClickFunction", enableScrollX: "enableScrollX", textTransform: "textTransform", selection: "selection", values: "values", paramExpandTemplate: "paramExpandTemplate", selectionMode: "selectionMode", fieldShowCheckbox: "fieldShowCheckbox", titleCheckboxDisallowed: "titleCheckboxDisallowed", pageParameters: "pageParameters", class: "class", colSpanActions: "colSpanActions", classEmptyMessage: "classEmptyMessage" }, outputs: { onClickCheckbox: "onClickCheckbox", onClickRadioButton: "onClickRadioButton", onSelectOne: "onSelectOne", onModifySelection: "onModifySelection", onTableHeadClick: "onTableHeadClick", onInputChange: "onInputChange" }, ngContentSelectors: _c0, decls: 21, vars: 22, consts: [[1, "table", "table-responsive"], [1, "panel-table-outer"], [3, "hidden"], ["class", "column-checkbox", 4, "ngIf"], [4, "ngIf"], [3, "style", "right", "asc", "desc", "sortable", "ngClass", "ngStyle", "hidden", "click", 4, "ngFor", "ngForOf"], ["style", "width: 8%", 4, "ngIf"], ["headerButton", ""], ["class", "has-btn-actions", 4, "ngIf"], ["elo-row", "", 3, "objects", "colSpanActions", "isQuickViewOpener", "selectionModeId", "rowDoubleClickFunction"], ["row", ""], ["id", "message-error", 4, "ngIf"], ["class", "subtitles", 4, "ngIf"], [1, "column-checkbox"], [3, "id", "checked", "onClick"], [3, "ngClass", "ngStyle", "hidden", "click"], [3, "textContent", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "textContent"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [2, "width", "8%"], [4, "ngIf", "ngIfElse"], [1, "many-header-buttons"], [1, "fa", "fa-ellipsis-v", "many-header-buttons-icon"], [1, "many-header-buttons-options"], [4, "ngFor", "ngForOf"], ["defaultHeaderButton", ""], [4, "ngTemplateOutlet"], ["key", "header-actions", 1, "header-button"], [1, "btn-actions"], [1, "btn-actions-inner"], ["type", "button", 1, "btn", "circle", 3, "id", "click"], [1, "btn-actions-label"], ["class", "btn-actions", 4, "ngIf"], [1, "has-btn-actions"], ["id", "message-error"], [1, "center"], ["id", "idEmptyMessageDataTable"], [1, "subtitles"]], template: function EloDatatableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "table");
        ɵngcc0.ɵɵelementStart(4, "thead", 2);
        ɵngcc0.ɵɵelementStart(5, "tr");
        ɵngcc0.ɵɵtemplate(6, EloDatatableComponent_th_6_Template, 2, 2, "th", 3);
        ɵngcc0.ɵɵtemplate(7, EloDatatableComponent_th_7_Template, 1, 0, "th", 4);
        ɵngcc0.ɵɵtemplate(8, EloDatatableComponent_th_8_Template, 3, 16, "th", 5);
        ɵngcc0.ɵɵtemplate(9, EloDatatableComponent_th_9_Template, 2, 0, "th", 6);
        ɵngcc0.ɵɵtemplate(10, EloDatatableComponent_ng_container_10_Template, 2, 2, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(11, EloDatatableComponent_ng_template_11_Template, 3, 2, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(13, EloDatatableComponent_th_13_Template, 1, 0, "th", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "tbody", 9, 10);
        ɵngcc0.ɵɵelementStart(16, "tfoot", 2);
        ɵngcc0.ɵɵtemplate(17, EloDatatableComponent_tr_17_Template, 2, 1, "tr", 4);
        ɵngcc0.ɵɵtemplate(18, EloDatatableComponent_tr_18_Template, 5, 4, "tr", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, EloDatatableComponent_tbody_19_Template, 5, 4, "tbody", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(20, EloDatatableComponent_div_20_Template, 2, 1, "div", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("has-header-button", (ctx.eloHeaderActions == null ? null : ctx.eloHeaderActions.length) === 0);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassMapInterpolate1("panel-table ", ctx.class, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.values == null ? null : ctx.values.length));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMultipleSelectionMode());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isRadioSelectionMode());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.eloColumns);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSingleSelectionMode());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.haveHeaderAction());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableHeaderActionColspan());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("objects", ctx.values)("colSpanActions", ctx.colSpanActions)("isQuickViewOpener", ctx.isQuickViewOpener)("selectionModeId", ctx.selectionModeId)("rowDoubleClickFunction", ctx.rowDoubleClickFunction);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", (ctx.values == null ? null : ctx.values.length) == 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dataTableFooter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMultipleSelectionMode());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.values || ctx.values.length == 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dataTableSubtitles);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc2.NgForOf, EloDataTableRowComponent, EloCheckboxComponent, ɵngcc2.NgClass, ɵngcc2.NgStyle, ɵngcc2.NgTemplateOutlet]; }, encapsulation: 2 });
EloDatatableComponent.ctorParameters = () => [
    { type: ObjectUtilService }
];
EloDatatableComponent.propDecorators = {
    values: [{ type: Input }],
    dataTableFooter: [{ type: ContentChild, args: ['dataTableFooter',] }],
    dataTableSubtitles: [{ type: ContentChild, args: ['dataTableSubtitles',] }],
    childExpandTemplate: [{ type: ContentChild, args: ['dataTableExpand',] }],
    paramExpandTemplate: [{ type: Input }],
    emptyMessage: [{ type: Input }],
    selection: [{ type: Input }],
    selectionMode: [{ type: Input }],
    selectionModeId: [{ type: Input }],
    fieldShowCheckbox: [{ type: Input }],
    titleCheckboxDisallowed: [{ type: Input }],
    onClickCheckbox: [{ type: Output }],
    onClickRadioButton: [{ type: Output }],
    onSelectOne: [{ type: Output }],
    onModifySelection: [{ type: Output }],
    onTableHeadClick: [{ type: Output }],
    sortable: [{ type: Input }],
    pageParameters: [{ type: Input }],
    class: [{ type: Input }],
    colSpanActions: [{ type: Input }],
    isQuickViewOpener: [{ type: Input }],
    manyActions: [{ type: Input }],
    onInputChange: [{ type: Output }],
    classEmptyMessage: [{ type: Input }],
    rowDoubleClickFunction: [{ type: Input }],
    enableScrollX: [{ type: Input }],
    textTransform: [{ type: Input }]
};

class EloColumnComponent {
    constructor(table) {
        this.table = table;
        this.headerAlign = 'left';
        this.isPercentual = false;
        this.isEditable = false;
        this.isEditing = false;
        /**
         * Esconder ou não a coluna
         * Por padrão é mostrada
         */
        this.hidden = false;
        /**
         * Esconder ou não a tag <td> da table
         * Por padrão é mostrada
         */
        this.hiddenTableData = false;
        this.sortable = true;
        this.samp = false;
        this.dataTable = table;
    }
    ngOnInit() {
        this.dataTable.addColumn(this);
    }
}
EloColumnComponent.ɵfac = function EloColumnComponent_Factory(t) { return new (t || EloColumnComponent)(ɵngcc0.ɵɵdirectiveInject(EloDatatableComponent)); };
EloColumnComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloColumnComponent, selectors: [["elo-column"]], contentQueries: function EloColumnComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c22, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c23, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c24, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cellTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.validationMessageTemplate = _t.first);
    } }, inputs: { headerAlign: "headerAlign", isPercentual: "isPercentual", isEditable: "isEditable", isEditing: "isEditing", hidden: "hidden", hiddenTableData: "hiddenTableData", sortable: "sortable", samp: "samp", dataTable: "dataTable", field: "field", header: "header", isDecimal: "isDecimal", digits: "digits", isDate: "isDate", isDateTime: "isDateTime", isCnpjCpf: "isCnpjCpf", enumOptions: "enumOptions", col: "col", class: "class", headerStyle: "headerStyle" }, decls: 0, vars: 0, template: function EloColumnComponent_Template(rf, ctx) { }, encapsulation: 2 });
EloColumnComponent.ctorParameters = () => [
    { type: EloDatatableComponent }
];
EloColumnComponent.propDecorators = {
    field: [{ type: Input }],
    header: [{ type: Input }],
    headerAlign: [{ type: Input }],
    isDecimal: [{ type: Input }],
    isPercentual: [{ type: Input }],
    digits: [{ type: Input }],
    isDate: [{ type: Input }],
    isDateTime: [{ type: Input }],
    isCnpjCpf: [{ type: Input }],
    enumOptions: [{ type: Input }],
    col: [{ type: Input }],
    cellTemplate: [{ type: ContentChild, args: ['dataTableCell',] }],
    headerTemplate: [{ type: ContentChild, args: ['dataTableHeader',] }],
    validationMessageTemplate: [{ type: ContentChild, args: ['validationMessage',] }],
    class: [{ type: Input }],
    isEditable: [{ type: Input }],
    isEditing: [{ type: Input }],
    dataTable: [{ type: Input }],
    hidden: [{ type: Input }],
    hiddenTableData: [{ type: Input }],
    sortable: [{ type: Input }],
    samp: [{ type: Input }],
    headerStyle: [{ type: Input }]
};

let EloDataTableRowComponent = class EloDataTableRowComponent {
    constructor(table) {
        this.table = table;
        this.isQuickViewOpener = false;
        this.selectionModeId = '';
        this.isEditing = {};
        this.index = 0;
        this.rowDoubleClickFunction = null;
    }
    onRowDoubleClick(object) {
        if (this.rowDoubleClickFunction) {
            this.rowDoubleClickFunction(object);
        }
    }
};
EloDataTableRowComponent.ɵfac = function EloDataTableRowComponent_Factory(t) { return new (t || EloDataTableRowComponent)(ɵngcc0.ɵɵdirectiveInject(forwardRef(() => EloDatatableComponent))); };
EloDataTableRowComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloDataTableRowComponent, selectors: [["", "elo-row", ""]], inputs: { isQuickViewOpener: "isQuickViewOpener", selectionModeId: "selectionModeId", index: "index", rowDoubleClickFunction: "rowDoubleClickFunction", objects: "objects", colSpanActions: "colSpanActions" }, attrs: _c25, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [3, "id", "dblclick"], ["class", "column-checkbox", 4, "ngIf"], [4, "ngIf"], [3, "hidden", "class", "ngClass", "ngStyle", 4, "ngFor", "ngForOf"], ["class", "has-btn-actions", 3, "quickViewOpener", 4, "ngIf"], ["class", "child-table", 4, "ngIf"], [1, "column-checkbox"], [3, "id", "checkAllowed", "checked", "titleCheckboxDisallowed", "onClick"], ["name", "select-radio", "type", "radio", "value", "object", 3, "checked", "change"], [3, "hidden", "ngClass", "ngStyle"], [1, "td-label"], [3, "class", 4, "ngIf"], [3, "class", "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "has-btn-actions"], ["class", "btn-actions", 4, "ngIf"], [1, "btn-actions"], [1, "btn-actions-inner"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [3, "ngSwitch"], ["class", "btn", "type", "button", 3, "removeAutoFocus", "error", "id", "links", "click", 4, "ngSwitchCase"], ["class", "btn center", "target", "_blank", "rel", "noopener noreferrer", 3, "href", 4, "ngSwitchCase"], ["type", "button", 1, "btn", 3, "removeAutoFocus", "id", "click"], ["class", "btn-actions-label", 4, "ngIf"], [1, "btn-actions-label"], ["href", "javascript:void(0)", 3, "click", 4, "ngFor", "ngForOf"], ["href", "javascript:void(0)", 3, "click"], ["target", "_blank", "rel", "noopener noreferrer", 1, "btn", "center", 3, "href"], [1, "fa", "fa-print", 2, "line-height", "21px"], [3, "click"], [1, "child-table"]], template: function EloDataTableRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EloDataTableRowComponent_ng_container_0_Template, 8, 19, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.objects);
    } }, directives: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, EloCheckboxComponent, ɵngcc2.NgClass, ɵngcc2.NgStyle, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, FocusRemoverDirective, ButtonSelectOneComponent]; }, pipes: function () { return [DecimalFormatPipe, DateFormatPipe, DateHourFormatPipe, CnpjCpfPipe]; }, encapsulation: 2 });
EloDataTableRowComponent.ctorParameters = () => [
    { type: EloDatatableComponent, decorators: [{ type: Inject, args: [forwardRef(() => EloDatatableComponent),] }] }
];
EloDataTableRowComponent.propDecorators = {
    objects: [{ type: Input }],
    colSpanActions: [{ type: Input }],
    isQuickViewOpener: [{ type: Input }],
    selectionModeId: [{ type: Input }],
    index: [{ type: Input }],
    rowDoubleClickFunction: [{ type: Input }]
};
EloDataTableRowComponent = __decorate([
    EloTableActionTypeAware,
    __metadata("design:paramtypes", [EloDatatableComponent])
], EloDataTableRowComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HttpClient, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: UrlResolver }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [HttpClientInterceptorToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WindowService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-common',
                template: `
    <p>
      common works!
    </p>
  `
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CommonModule, { declarations: [CommonComponent], exports: [CommonComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonModule, [{
        type: NgModule,
        args: [{
                declarations: [CommonComponent],
                imports: [],
                exports: [CommonComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccordionComponent, [{
        type: Component,
        args: [{
                selector: 'elo-accordion',
                template: "<div class=\"advtree\">\n    <div class=\"advtree-container\">\n        <ng-content></ng-content>\n    </div>\n</div>\n"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccordionItemComponent, [{
        type: Component,
        args: [{
                selector: 'elo-accordion-item',
                template: "<div class=\"advtree-header\" (click)=\"changeGroupSelected(obj.indice)\">\n  <div class=\"advtree-title\">\n    <span class=\"id hint module-color top-left\">#\n      <div class=\"hint-content\">\n        #{{obj.indice}} - {{obj.itemSelected ? obj.itemSelected : obj.titleDefault }}\n      </div>\n    </span>\n    <span class=\"title\">{{obj.itemSelected ? obj.itemSelected : obj.titleDefault }}</span>\n  </div>\n\n  <div class=\"advtree-actions\">\n    <button id=\"btnAdvtreeAdd\" class=\"btn circle\" *ngIf=\"!obj.isEditing && hasPermission\" (click)=\"clickOnAddButton(obj.indice, $event)\">\n      <i class=\"fa fa-plus\"></i>\n      <div class=\"btn-actions-label\">\n        Adicionar\n      </div>\n    </button>\n  </div>\n\n</div>\n<ng-content></ng-content>\n"
            }]
    }], function () { return []; }, { obj: [{
            type: Input
        }], disableClick: [{
            type: Input
        }], hasPermission: [{
            type: Input
        }], onChangeGroupSelected: [{
            type: Output
        }], confirmButtons: [{
            type: Output
        }], addButtons: [{
            type: Output
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormLabelColumnComponent, [{
        type: Component,
        args: [{
                selector: 'elo-form-label-column',
                template: "<div class=\"col-md-{{column}} {{offsetClass}}\">\n  <div class=\"form-group\">\n    <label class=\"label\" [style.color]=\"color\">\n      {{ !hintIconLeftAlign ? label : '' }}\n      <i *ngIf=\"hintMessage\" class=\"hint fa fa-question-circle clean module-color sm inline {{hintPosition}}\">\n        <div class=\"hint-content\" [innerHTML]=\"hintMessage\"></div>\n      </i>\n      {{ hintIconLeftAlign ? label : ''}}\n\n      <a (click)=\"clickLink()\" class=\"pull-right\" *ngIf=\"showLink\">\n        <u id=\"linkTitle\">{{linkTitle}}</u>\n      </a>\n    </label>\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                styles: [":host>>>.hint:not(.input).sm{height:0}"]
            }]
    }], function () { return []; }, { hintPosition: [{
            type: Input
        }], hintIconLeftAlign: [{
            type: Input
        }], linkTitle: [{
            type: Input
        }], showLink: [{
            type: Input
        }], onClickLink: [{
            type: Output
        }], label: [{
            type: Input
        }], color: [{
            type: Input
        }], column: [{
            type: Input
        }], offset: [{
            type: Input
        }], hintMessage: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormLabelColumnModule, { declarations: function () { return [FormLabelColumnComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [FormLabelColumnComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormLabelColumnModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [FormLabelColumnComponent],
                exports: [FormLabelColumnComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutoCompleteComponent, [{
        type: Component,
        args: [{
                selector: 'elo-autocomplete',
                template: "<div id=\"autocomplete-container\">\n  <div *ngIf=\"multiplo && multipleSelected && multipleSelected.length > 0\" class=\"multiple\">\n    <button class=\"btn positive round interactive inline full-xs option\"\n      [title]=\"'Remover: ' + this.objToOption(item)\" *ngFor=\"let item of multipleSelected\"\n      (click)=\"removeItemFromMultiplo(item)\">{{this.objToOption(item)}}</button>\n  </div>\n\n  <input id=\"{{id}}_input\" [ngClass]=\"{'autocomplete-input': true, 'required_with_button': searchModal}\"\n    [class.error]=\"error\" type=\"text\" (click)=\"onFocus()\" (focus)=\"onFocus()\" [(ngModel)]=\"value\"\n    (keydown)=\"onKeyDown($event)\" [placeholder]=\"placeholder\" [disabled]=\"isDisabled\" autocomplete=\"off\"\n    autocorrect=\"off\" spellcheck=\"off\" [class.loading]=\"loading\"\n    [class.has-input-icon]=\"(searchModal || hasValue()) && !isDisabled && !loading\">\n\n  <i class=\"fa fa-circle-o-notch spinner\" *ngIf=\"loading\"></i>\n\n  <ng-content></ng-content>\n\n  <i class=\"fa fa-search input-icon\" id=\"search\" *ngIf=\"searchModal && !isDisabled && !loading\"\n    (click)=\"onClickSearch()\"></i>\n  <i id=\"{{id}}_clearItem\" class=\"fa fa-times input-icon\" aria-hidden=\"true\" (click)=\"onClickClear()\"\n    *ngIf=\"hasValue()  && !loading\"></i>\n\n  <div class=\"autocomplete\" [class.open]=\"showItens\" #listOption>\n    <li *ngIf=\"(!options || options.length === 0) && emptyRecord\"\n        class=\"autocomplete-item\"\n        id=\"option_empty\">\n        {{noResultsMessage}}\n    </li>\n    <div *ngIf=\"showItens\">\n      <li *ngIf=\"isEnabledCreateRecord\" class=\"autocomplete-item item-new\" (click)=\"openCreateModal()\">\n        <em class=\"fa fa-plus-circle\"></em>{{setDescriptionNewRecordAction()}}\n      </li>\n      <li *ngFor=\"let option of options; let i = index\" class=\"autocomplete-item\" [class.selected]=\"i == selectedIndex\"\n        (click)=\"onSelect(option)\" id=\"option_{{i}}\">\n        {{option}}\n        <div id=\"extra-info-{{i}}\"class=\"extra-info split-letter right\" attr.data-letter=\"{{extraInfos[i][0]}}\" *ngIf=\"extraInfos && extraInfos[i] && extraInfos[i][0]\">\n          <p>{{extraInfos[i]}}</p>\n        </div>\n      </li>\n    </div>\n  </div>\n\n  <div class=\"help-message\" *ngIf=\"!emptyRecord && (noResults && (!isEnabledCreateRecord || hasUrlCreate()))\">\n    {{noResultsMessage}}\n    <a *ngIf=\"hasUrlCreate()\" href=\"#\" (click)=\"openCreate($event)\">Clique aqui para cadastrar.</a>\n  </div>\n\n</div>\n",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: AutoCompleteComponent },
                    { provide: NG_VALIDATORS, multi: true, useValue: autoCompleteValidator }
                ],
                styles: [`
      .error {
        border: 1px solid red;
      }
      .multiple {
        max-height: 98px;
        overflow: scroll;
      }
      .multiple, .option {
        margin-bottom: 2px;
        font-size: 10px;"
      }
    `]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_RESOURCES_CONFIG]
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { multiplo: [{
            type: Input
        }], multipleSelected: [{
            type: Input
        }], onChangeMultipleValue: [{
            type: Output
        }], options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], noResultsMessage: [{
            type: Input
        }], urlCreate: [{
            type: Input
        }], onChangeValue: [{
            type: Output
        }], onSearchModal: [{
            type: Output
        }], searchModal: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], findToOptions: [{
            type: Input
        }], objToOption: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], autoSelect: [{
            type: Input
        }], isEnabledCreateRecord: [{
            type: Input
        }], descriptionNewRecord: [{
            type: Input
        }], validateDeps: [{
            type: Input
        }], onInsertButton: [{
            type: Output
        }], onCreateRecord: [{
            type: Output
        }], emptyRecord: [{
            type: Input
        }], removeDot: [{
            type: Input
        }], id: [{
            type: Input
        }], error: [{
            type: Input
        }], service: [{
            type: Input
        }], insertIcon: [{
            type: Input
        }], extraInfos: [{
            type: Input
        }], listOption: [{
            type: ViewChild,
            args: ['listOption', { static: true }]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AutoCompleteModule, { declarations: function () { return [AutoCompleteComponent]; }, imports: function () { return [CommonModule$1, FormsModule]; }, exports: function () { return [AutoCompleteComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutoCompleteModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, FormsModule],
                exports: [AutoCompleteComponent],
                declarations: [AutoCompleteComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelComponent, [{
        type: Component,
        args: [{
                selector: 'elo-panel',
                template: "<div class=\"panel\" [ngClass]=\"{'table': hasTable, 'panel-form' : hasForm}\">\n  <h2 class=\"panel-title\" *ngIf=\"title\">\n    {{title}}\n  </h2>\n  <div class=\"panel-body\" [class.pb-none]=\"pbNone\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { pbNone: [{
            type: Input
        }], title: [{
            type: Input
        }], hasTable: [{
            type: Input
        }], hasForm: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PanelModule, { declarations: function () { return [PanelComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [PanelComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [PanelComponent],
                declarations: [PanelComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AccordionModule, { declarations: function () { return [AccordionComponent, AccordionItemComponent]; }, imports: function () { return [CommonModule$1, FormLabelColumnModule, AutoCompleteModule, PanelModule]; }, exports: function () { return [AccordionComponent, AccordionItemComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccordionModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    FormLabelColumnModule,
                    AutoCompleteModule,
                    PanelModule
                ],
                declarations: [
                    AccordionComponent,
                    AccordionItemComponent
                ],
                exports: [
                    AccordionComponent,
                    AccordionItemComponent
                ],
                providers: []
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppConfigService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloTimelineHorizontalComponent, [{
        type: Component,
        args: [{
                selector: 'elo-timeline-horizontal',
                template: "<div class=\"row\">\n  <div class=\"timeline-horizontal-container\">\n    <ul>\n      <li id=\"liInsertRevisao\" style=\"cursor: pointer\" (click)=\"onClickIncluirData()\">\n        <div class=\"caption\">{{description}}</div>\n      </li>\n      <li *ngFor=\"let d of dates;\" (click)=\"onClickDate(d)\"\n        [ngClass]=\"d.selected ? 'bg-gray-20' : ''\" style=\"cursor: pointer\">\n        <div class=\"values\">\n          <div class=\"value mt-md\"></div>\n        </div>\n        <div [ngClass]=\"d.selected ? 'caption bg-primary-color gray-5' : 'caption'\">\n          {{ d.data | dateformat }}\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>\n\n<div class=\"row\" *ngIf=\"dates.length\">\n\n  <elo-form-label-column column=\"3\">\n    <button id=\"btnRemoveRevisao\" class=\"btn negative icon-left\" type=\"button\" [title]=\"'Remover revis\u00E3o'\"\n      (click)=\"showDialogRemove = !showDialogRemove\">\n      <i class=\"fa fa-trash\"></i>\n      Remover Revis\u00E3o\n    </button>\n  </elo-form-label-column>\n\n</div>\n\n<elo-calendar [show]=\"showCalendar\" (onSelectDate)=\"onSelectDate($event)\"></elo-calendar>\n\n<elo-dialog [show]=\"showDialogRemove\" (onOkEvent)=\"onRemoveDate()\" (onCancelEvent)=\"showDialogRemove = !showDialogRemove\">\n  A Revis\u00E3o do Divisor ser\u00E1 apagada. Deseja continuar?\n</elo-dialog>\n"
            }]
    }], function () { return []; }, { dates: [{
            type: Input
        }], description: [{
            type: Input
        }], onSelected: [{
            type: Output
        }], onRemove: [{
            type: Output
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BooleanTextPipe, [{
        type: Pipe,
        args: [{
                name: 'booleanText'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CapitalizePipe, [{
        type: Pipe,
        args: [{
                name: 'capitalize'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CepPipe, [{
        type: Pipe,
        args: [{
                name: 'cep'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CnpjCpfPipe, [{
        type: Pipe,
        args: [{
                name: 'cnpjCpf'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CountdownPipe, [{
        type: Pipe,
        args: [{
                name: 'countdown',
                pure: false
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CurrencyFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'currencyformat'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'dateformat'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateHourFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'datehourformat'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DecimalFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'decimalformat'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DiasFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'diasformat'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DiasPorExtensoPipe, [{
        type: Pipe,
        args: [{
                name: 'diasPorExtenso'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PercentageFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'percentageformat'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SafeUrlPipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: ɵngcc4.DomSanitizer }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SimNaoPipe, [{
        type: Pipe,
        args: [{
                name: 'simNao'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SubTipoPipe, [{
        type: Pipe,
        args: [{
                name: 'subTipo'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TelefonePipe, [{
        type: Pipe,
        args: [{
                name: 'telefone'
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PipeModule, { declarations: function () { return [CurrencyFormatPipe, DecimalFormatPipe, SubTipoPipe, CnpjCpfPipe, DateFormatPipe, BooleanTextPipe, CepPipe, CapitalizePipe, CountdownPipe, DateHourFormatPipe, SimNaoPipe, FilterPipe, DiasPorExtensoPipe, PercentageFormatPipe, DiasFormatPipe, TelefonePipe, SafeUrlPipe]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [CurrencyFormatPipe, DecimalFormatPipe, SubTipoPipe, CnpjCpfPipe, DateFormatPipe, BooleanTextPipe, CepPipe, CapitalizePipe, CountdownPipe, DateHourFormatPipe, SimNaoPipe, FilterPipe, DiasPorExtensoPipe, PercentageFormatPipe, DiasFormatPipe, TelefonePipe, SafeUrlPipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PipeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [CurrencyFormatPipe, DecimalFormatPipe, SubTipoPipe, CnpjCpfPipe, DateFormatPipe,
                    BooleanTextPipe, CepPipe, CapitalizePipe, CountdownPipe, DateHourFormatPipe, SimNaoPipe, FilterPipe,
                    DiasPorExtensoPipe, PercentageFormatPipe, DiasFormatPipe, TelefonePipe, SafeUrlPipe],
                exports: [CurrencyFormatPipe, DecimalFormatPipe, SubTipoPipe, CnpjCpfPipe, DateFormatPipe,
                    BooleanTextPipe, CepPipe, CapitalizePipe, CountdownPipe, DateHourFormatPipe, SimNaoPipe, FilterPipe,
                    DiasPorExtensoPipe, PercentageFormatPipe, DiasFormatPipe, TelefonePipe, SafeUrlPipe]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DatePickerComponent, [{
        type: Component,
        args: [{
                selector: 'elo-datepicker',
                template: "<input #input id=\"{{id}}_input\" type=\"text\" class=\"has-input-icon\" [(ngModel)]=\"value\" (click)=\"onClickInput()\"\n    [maxlength]=\"viewFormat.length\" (keydown)=\"onKeyDown($event)\" [disabled]=\"disable\" autocomplete=\"off\">\n<i class=\"fa fa-calendar input-icon\" aria-hidden=\"true\" (click)=\"onClickInput()\"></i>\n<elo-calendar #calendar [show]=\"showCalendar\" [onTop]=\"onTop\" [onRight]=\"onRight && showCalendar\"\n    [selectedDate]=\"getDateToCalendar()\" (onSelectDate)=\"onSelectDate($event)\"></elo-calendar>",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: DatePickerComponent },
                    { provide: NG_VALIDATORS, multi: true, useValue: datePickerValidator }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { viewFormat: [{
            type: Input
        }], modelFormat: [{
            type: Input
        }], disable: [{
            type: Input
        }], id: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CalendarComponent, [{
        type: Component,
        args: [{
                selector: 'elo-calendar',
                template: "<div class=\"datepicker\" [class.open]=\"show\" [class.top]=\"onTop\" [class.right]=\"onRight\">\n\t<div class=\"datepicker-header\">\n\t\t<div class=\"datepicker-header-year\">\n\t\t\t<em class=\"fa fa-chevron-left\" (click)=\"prevYear()\"></em>\n\t\t\t<b class=\"year-number\">{{year}}</b>\n\t\t\t<em class=\"fa fa-chevron-right\" (click)=\"nextYear()\"></em>\n\t\t</div>\n\t\t<div class=\"datepicker-header-month\">\n\t\t\t<em class=\"fa fa-chevron-left\" (click)=\"prevMonth()\"></em>\n\t\t\t<b class=\"month-name\">{{locale.monthNames[month]}}</b>\n\t\t\t<em class=\"fa fa-chevron-right\" (click)=\"nextMonth()\"></em>\n\t\t</div>\n\t</div>\n\n\t<div class=\"datepicker-calendar\">\n\t\t<div class=\"datepicker-calendar-header\">\n\t\t\t<li class=\"item\" *ngFor=\"let weekDay of locale.dayNames\">{{weekDay}}</li>\n\t\t</div>\n\t\t<li *ngFor=\"let dayCalendar of days\" (click)=\"selectDate(dayCalendar)\" class=\"item\"\n      [class.not-this-month]=\"!dayCalendar.isMonthOfSelectDate\"\n\t\t\t[class.selected]=\"dayCalendar.isSelectDate\">\n\t\t\t{{dayCalendar.day}}</li>\n\t</div>\n</div>\n"
            }]
    }], function () { return []; }, { viewFormat: [{
            type: Input
        }], show: [{
            type: Input
        }], onTop: [{
            type: Input
        }], onRight: [{
            type: Input
        }], locale: [{
            type: Input
        }], onSelectDate: [{
            type: Output
        }], selectedDate: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CalendarModule, { declarations: function () { return [CalendarComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [CalendarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CalendarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [CalendarComponent],
                exports: [CalendarComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MaskFormatDirective, [{
        type: Directive,
        args: [{ selector: '[maskFormat]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { maskFormat: [{
            type: Input
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CepDirective, [{
        type: Directive,
        args: [{ selector: '[cep]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ClipboardDirective, [{
        type: Directive,
        args: [{
                selector: '[clipboard]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { onSuccess: [{
            type: Output
        }], onError: [{
            type: Output
        }], targetElm: [{
            type: Input
        }], clipboardContent: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CnpjCpfDirective, [{
        type: Directive,
        args: [{ selector: '[cnpjCpf]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CnpjDirective, [{
        type: Directive,
        args: [{ selector: '[cnpj]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CompetenciaDirective, [{
        type: Directive,
        args: [{ selector: '[competencia]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { keyEvent: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CpfDirective, [{
        type: Directive,
        args: [{ selector: '[cpf]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CurrencyMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[currencyMask]',
                providers: [CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [CURRENCY_MASK_CONFIG]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.KeyValueDiffers }]; }, { options: [{
            type: Input
        }], handleBlur: [{
            type: HostListener,
            args: ['blur', ['$event']]
        }], handleCut: [{
            type: HostListener,
            args: ['cut', ['$event']]
        }], handleInput: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], handleKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], handleKeypress: [{
            type: HostListener,
            args: ['keypress', ['$event']]
        }], handlePaste: [{
            type: HostListener,
            args: ['paste', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DisableControlDirective, [{
        type: Directive,
        args: [{ selector: '[disableControl]' }]
    }], function () { return [{ type: ɵngcc3.NgControl }]; }, { disableControl: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DoubleClickCopyDirective, [{
        type: Directive,
        args: [{ selector: '[doubleClickCopy]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { onCopy: [{
            type: Output
        }], onDblClick: [{
            type: HostListener,
            args: ['dblclick', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloDecimalDirective, [{
        type: Directive,
        args: [{
                selector: '[eloDecimal]',
                providers: [ELODECIMAL_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.KeyValueDiffers }]; }, { textAlign: [{
            type: Input
        }], allowNegative: [{
            type: Input
        }], suffix: [{
            type: Input
        }], prefix: [{
            type: Input
        }], precision: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloNumberDirective, [{
        type: Directive,
        args: [{
                selector: '[eloNumber]',
                providers: [ELONUMBER_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.KeyValueDiffers }]; }, { allowNegative: [{
            type: Input
        }], prefix: [{
            type: Input
        }], suffix: [{
            type: Input
        }], align: [{
            type: Input
        }], precision: [{
            type: Input
        }], thousands: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FocusRemoverDirective, [{
        type: Directive,
        args: [{
                selector: '[removeAutoFocus]',
                providers: [FOCUS_REMOVER_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { removeAutoFocus: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutofocusDirective, [{
        type: Directive,
        args: [{ selector: '[eloAutoFocus]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HoraLancamentoDirective, [{
        type: Directive,
        args: [{
                selector: '[horaLancamento]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc3.NgControl }]; }, { onEvent: [{
            type: HostListener,
            args: ['input', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HoraDirective, [{
        type: Directive,
        args: [{ selector: '[hora]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NonNegativeDirective, [{
        type: Directive,
        args: [{
                selector: '[nonNegative]'
            }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { focusListener: [{
            type: HostListener,
            args: ['focus']
        }], inputListener: [{
            type: HostListener,
            args: ['input']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PlacaDirective, [{
        type: Directive,
        args: [{ selector: '[placa]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PreventMultiClickDirective, [{
        type: Directive,
        args: [{ selector: '[preventMultiClick]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { debounceTime: [{
            type: Input
        }], clickEvent: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SelectOnFocusDirective, [{
        type: Directive,
        args: [{ selector: '[selectOnFocus]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { onFocus: [{
            type: HostListener,
            args: ['focus']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SingleClickButtonDirective, [{
        type: Directive,
        args: [{ selector: '[singleClickButton]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TelefoneDirective, [{
        type: Directive,
        args: [{ selector: '[telefone]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ZeroWhenEmptyDirective, [{
        type: Directive,
        args: [{ selector: '[zeroWhenEmpty]' }]
    }], function () { return [{ type: ɵngcc3.NgControl }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DirectivesModule, { declarations: [CnpjCpfDirective, CpfDirective, CnpjDirective, NonNegativeDirective, CepDirective, ClipboardDirective, DoubleClickCopyDirective, MaskFormatDirective, AutofocusDirective, TelefoneDirective, SelectOnFocusDirective, CurrencyMaskDirective, EloDecimalDirective, EloNumberDirective, CompetenciaDirective, ZeroWhenEmptyDirective, PlacaDirective, HoraDirective, HoraLancamentoDirective, FocusRemoverDirective, DisableControlDirective, SingleClickButtonDirective, PreventMultiClickDirective], exports: [CnpjCpfDirective, CpfDirective, CnpjDirective, NonNegativeDirective, CepDirective, ClipboardDirective, DoubleClickCopyDirective, MaskFormatDirective, AutofocusDirective, TelefoneDirective, SelectOnFocusDirective, CurrencyMaskDirective, EloDecimalDirective, EloNumberDirective, CompetenciaDirective, ZeroWhenEmptyDirective, PlacaDirective, HoraDirective, HoraLancamentoDirective, FocusRemoverDirective, DisableControlDirective, SingleClickButtonDirective, PreventMultiClickDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DirectivesModule, [{
        type: NgModule,
        args: [{
                declarations: [CnpjCpfDirective, CpfDirective, CnpjDirective, NonNegativeDirective, CepDirective,
                    ClipboardDirective, DoubleClickCopyDirective, MaskFormatDirective, AutofocusDirective, TelefoneDirective,
                    SelectOnFocusDirective, CurrencyMaskDirective, EloDecimalDirective, EloNumberDirective, CompetenciaDirective, ZeroWhenEmptyDirective, PlacaDirective,
                    HoraDirective, HoraLancamentoDirective, FocusRemoverDirective, DisableControlDirective, SingleClickButtonDirective, PreventMultiClickDirective],
                exports: [CnpjCpfDirective, CpfDirective, CnpjDirective, NonNegativeDirective, CepDirective,
                    ClipboardDirective, DoubleClickCopyDirective, MaskFormatDirective, AutofocusDirective, TelefoneDirective,
                    SelectOnFocusDirective, CurrencyMaskDirective, EloDecimalDirective, EloNumberDirective, CompetenciaDirective, ZeroWhenEmptyDirective, PlacaDirective,
                    HoraDirective, HoraLancamentoDirective, FocusRemoverDirective, DisableControlDirective, SingleClickButtonDirective, PreventMultiClickDirective]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{
                selector: 'elo-dialog',
                template: "<div id=\"dialogConfirm\" *ngIf=\"show\" class=\"dialoguebox alt {{classType}} open\">\n\n  <div class=\"alt-box\">\n    <div class=\"alt-box-content\">\n      <div class=\"row\">\n        <div class=\"col-md-12 form-group\">\n          <h3 *ngIf=\"title\" class=\"title\">{{ title }} </h3>\n        </div>\n      </div>\n      <div id=\"content\" class=\"row\">\n        <div class=\"col-md-12\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n\n      <div class=\"alt-footer right\">\n        <button type=\"button\" *ngIf=\"showCancel\" id=\"btCancel\" class=\"btn neutral inline\"\n          (click)=\"onCancel()\" singleClickButton>{{tittleCancel}}</button>\n        <button *ngIf=\"!debounceTime;else debounceButton\" eloAutoFocus type=\"button\" id=\"btOk\" class=\"btn positive inline {{disableOkButton ? 'disabled' : ''}}\"\n          (click)=\"disableOkButton ? onDoNothing() : onOk()\">{{tittleOk}}</button>\n        <ng-template #debounceButton>\n          <button eloAutoFocus type=\"button\" id=\"btOk\" class=\"btn positive inline {{disableOkButton ? 'disabled' : ''}}\"\n            preventMultiClick [debounceTime]=\"debounceTime\" (click)=\"disableOkButton ? onDoNothing() : onOk()\">{{tittleOk}}</button>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n\n</div>"
            }]
    }], function () { return []; }, { show: [{
            type: Input
        }], showCancel: [{
            type: Input
        }], classType: [{
            type: Input
        }], tittleCancel: [{
            type: Input
        }], tittleOk: [{
            type: Input
        }], disableOkButton: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], onOkEvent: [{
            type: Output
        }], onCancelEvent: [{
            type: Output
        }], handleKeyboardEvent: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], title: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DialogModule, { declarations: function () { return [DialogComponent]; }, imports: function () { return [CommonModule$1, DirectivesModule]; }, exports: function () { return [DialogComponent, CommonModule$1]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, DirectivesModule],
                exports: [DialogComponent, CommonModule$1],
                declarations: [DialogComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloTimelineHorizontalModule, { declarations: function () { return [EloTimelineHorizontalComponent]; }, imports: function () { return [CommonModule$1, FormLabelColumnModule, PipeModule, CalendarModule, DialogModule]; }, exports: function () { return [EloTimelineHorizontalComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloTimelineHorizontalModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    FormLabelColumnModule,
                    PipeModule,
                    CalendarModule,
                    DialogModule
                ],
                declarations: [EloTimelineHorizontalComponent],
                exports: [EloTimelineHorizontalComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloTableDrilldownComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-drilldown',
                template: "<div class=\"table-editable tree\" *ngIf=\"data?.length\">\n  <div class=\"table-editable-header \">\n\n    <div class=\"row\">\n      <div class=\"colunm col-sm-{{col?.col}}\" *ngFor=\"let col of columns;\" [class.right]=\"col?.isDecimal\">\n        <span>{{col?.header}}</span>\n      </div>\n    </div>\n\n  </div>\n\n  <div class=\"table-editable-content\">\n    <ng-template #recursiveList let-data let-padding=\"padding\">\n      <ng-container *ngFor=\"let item of data; let i = index;\">\n\n        <div class=\"row reduced {{item[fieldHasChilds] ? 'father' : ''}} level-{{padding}} {{item?.open ? 'open' : ''}}\"\n          [ngStyle]=\"{ 'cursor': item[fieldHasChilds] ? 'pointer' : '' }\">\n\n          <ng-container *ngFor=\"let col of columns; let j = index;\">\n\n            <div class=\"column col-sm-{{col?.col}} direction-row right\" *ngIf=\"col?.isDecimal;else colWithoutDigits\"\n              (click)=\"onClick(item)\" [class.center-father]=\"j === 0\" [ngStyle]=\"{'justify-content': 'flex-end'}\">\n\n              <div *ngIf=\"showSecondField && col?.secondField\"\n                class=\"hint clean fa-exclamation-circle  center-right module-color sm ml-xs\">\n                <div class=\"hint-content\"> {{headerSecondField}} : {{ item[col.secondField] || 0 | decimalformat : \"1.2-2\" }}</div>\n              </div>\n\n              {{ item[col.field] || 0 | decimalformat : \"1.2-2\"}}\n\n            </div>\n\n            <ng-template #colWithoutDigits>\n              <div class=\"column col-sm-{{col?.col}}\" (click)=\"onClick(item)\" [class.center-father]=\"j === 0\">\n                {{item[col.field]}}\n              </div>\n\n            </ng-template>\n\n          </ng-container>\n\n        </div>\n\n        <ng-container *ngIf=\"item?.data?.length\">\n          <ng-container *ngTemplateOutlet=\"recursiveList; context:{ $implicit: item.data, padding: padding + 1}\">\n          </ng-container>\n        </ng-container>\n\n      </ng-container>\n    </ng-template>\n\n    <ng-container *ngTemplateOutlet=\"recursiveList; context:{ $implicit: data, padding: 1  }\">\n    </ng-container>\n  </div>\n</div>\n",
                styles: ['.center-father { margin: auto 0px }']
            }]
    }], function () { return []; }, { showSecondField: [{
            type: Input
        }], headerSecondField: [{
            type: Input
        }], onClickElement: [{
            type: Output
        }], fieldHasChilds: [{
            type: Input
        }], data: [{
            type: Input
        }], columns: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloTableDrilldownModule, { declarations: function () { return [EloTableDrilldownComponent]; }, imports: function () { return [CommonModule$1, PipeModule]; }, exports: function () { return [EloTableDrilldownComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloTableDrilldownModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    PipeModule,
                ],
                declarations: [EloTableDrilldownComponent],
                exports: [EloTableDrilldownComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloNotificationService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ArquivoComponent, [{
        type: Component,
        args: [{
                selector: 'arquivo-component',
                template: "<div class=\"dragdrop\">\n\n  <ngx-dropzone (change)=\"onSelect($event)\" style=\"all: unset\">\n\n    <div tabindex=\"0\" class=\"dropzone\">\n\n      <div class=\"dragdrop-space \" data-message=\"Clique ou arraste arquivos aqui.\">\n        <input id=\"anexos\" type=\"file\" style=\"display:none\" multiple\n          aria-label=\"Campo para anexar arquivos\"/>\n      </div>\n\n    </div>\n\n  </ngx-dropzone>\n\n  <ul>\n\n    <li class=\"col-md-12\" *ngFor=\"let arq of form?.get(arrayPropertyName)?.value\">\n\n      <div class=\"dragdrop-item\">\n\n        <div class=\"name\">{{ arq?.arquivo?.nome ? arq?.arquivo?.nome : 'Arquivo sem nome' }}</div>\n        <div class=\"buttons\">\n\n          <button id=\"buttonOnView\" type=\"button\" class=\"btn circle\" (click)=\"onView(arq)\" *ngIf=\"canView\">\n            <i class=\"fa fa-eye\"></i>\n            <div class=\"btn-actions-label\">Visualizar</div>\n          </button>\n\n          <button id=\"buttonOnDownload\" type=\"button\" class=\"btn circle\" (click)=\"onDownload(arq)\" *ngIf=\"canDownload\">\n            <i class=\"fa fa-download\"></i>\n            <div class=\"btn-actions-label\">Download</div>\n          </button>\n\n          <button id=\"buttonOnRemove\" type=\"button\" class=\"btn circle\" (click)=\"onRemove(arq)\" *ngIf=\"canRemove\" >\n            <i class=\"fa fa-trash\"></i>\n            <div class=\"btn-actions-label\">Excluir</div>\n          </button>\n\n        </div>\n\n      </div>\n    </li>\n\n  </ul>\n\n</div>\n"
            }]
    }], function () { return [{ type: EloNotificationService }, { type: WindowService }]; }, { canRemove: [{
            type: Input
        }], canDownload: [{
            type: Input
        }], canView: [{
            type: Input
        }], service: [{
            type: Input
        }], form: [{
            type: Input
        }], arrayPropertyName: [{
            type: Input
        }], filePath: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ArquivoModule, { declarations: function () { return [ArquivoComponent]; }, imports: function () { return [NgxDropzoneModule,
        CommonModule$1]; }, exports: function () { return [ArquivoComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ArquivoModule, [{
        type: NgModule,
        args: [{
                imports: [
                    NgxDropzoneModule,
                    CommonModule$1
                ],
                declarations: [ArquivoComponent],
                exports: [ArquivoComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ActuatorService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VersionReloadHandlerComponent, [{
        type: Component,
        args: [{
                selector: 'version-reload-handler',
                template: "<elo-dialog [tittleOk]=\"'Reiniciar a p\u00E1gina (F5)'\" [show]=\"!!currentVersion\"\n   (onOkEvent)=\"refreshVersion()\" [tittleCancel]=\"'N\u00E3o reiniciar'\"\n  (onCancelEvent)=\"closeDialog()\">\n\n  <div style=\"text-align: center\">\n    <h3>Vers\u00E3o do sistema atualizada</h3>\n    <hr>\n    <span class=\"red-60 typography-bold\">Reinicie a p\u00E1gina para evitar diverg\u00EAncia de dados</span>\n  </div>\n  <hr>\n  <div class=\"mt-xs\">\n    <p class=\"mt-xs\">Vers\u00E3o atual: <b>{{version}}</b></p>\n    <p>Vers\u00E3o nova: <b>{{currentVersion}}</b></p>\n  </div>\n\n</elo-dialog>"
            }]
    }], function () { return [{ type: ActuatorService }, { type: WindowService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VersionReloadModule, { declarations: function () { return [VersionReloadHandlerComponent]; }, imports: function () { return [CommonModule$1, DialogModule]; }, exports: function () { return [VersionReloadHandlerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VersionReloadModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    DialogModule
                ],
                exports: [
                    VersionReloadHandlerComponent
                ],
                declarations: [VersionReloadHandlerComponent],
                providers: [ActuatorService]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IFrameStore, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SectionService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RouterService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc6.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavigateUtils, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'elo-breadcrumb',
                template: "<nav aria-label=\"Breadcrumbs\" class=\"nav-breadcrumbs\" id=\"idBreadcrumbs\">\n  <ol>\n    <li><a routerLink=\"\" [attr.aria-current]=\"routes.length === 0? 'page': null\">\n        <i class=\"fa fa-home\"></i><span>{{homeLabel}}</span></a></li>\n\n    <li *ngFor=\"let route of routes; let isLast = last;\">\n      <ng-container *ngIf=\"isLast; else notLast\">\n        <a [attr.aria-current]=\"routes[routes.length-1]===route? 'page': null\">\n          <i class={{route.icon}}></i><span>{{route.label}}</span></a>\n      </ng-container>\n\n      <ng-template #notLast>\n        <a (click)=\"onClick(route)\" [routerLink]=\"route.url\" [queryParams]=\"route.queryParams\"\n          [attr.aria-current]=\"routes[routes.length-1]===route? 'page': null\">\n          <i class={{route.icon}}></i><span>{{route.label}}</span></a>\n      </ng-template>\n    </li>\n\n  </ol>\n  <div class=\"nav-buttons\" role=\"group\">\n    <ng-container *ngTemplateOutlet=\"botoesDireita\"></ng-container>\n  </div>\n</nav>"
            }]
    }], function () { return [{ type: ɵngcc6.Router }, { type: ɵngcc6.ActivatedRoute }, { type: RouterService }, { type: NavigateUtils }]; }, { homeLabel: [{
            type: Input
        }], homeUrl: [{
            type: Input
        }], urlsToLabels: [{
            type: Input
        }], botoesDireita: [{
            type: ContentChild,
            args: ['botoesDireita']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SectionComponent, [{
        type: Component,
        args: [{
                selector: 'main-section',
                template: "<section [ngStyle]=\"{'padding-bottom': hasFloatingButton ? '80px' : '0px'}\"\n         [class.main-content]=\"enabled\"\n         [class.sidebar-toggle]=\"toggled && enabled\"\n         [class.fullScreen]=\"fullScreen\"\n         [class.has-iframe]=\"this.iframeParams?.hasIframeObservable | async\">\n\n  <header class=\"main-content-header\" *ngIf=\"enabled && !hideHeader\">\n    <article class=\"page-name-outer\" *ngIf=\"!enabledBreadcrumb\">\n      <i class=\"{{icon}}\" [ngStyle]=\"startedNavigation && {'border': 'none', 'width': '20px', 'height': '20px', 'padding': '0', 'margin': '5.5px'}\"></i>\n      <h2 class=\"page-name\" id=\"window-title\">\n        {{caption}}\n      </h2>\n      <ng-content select=\"[title-content]\"></ng-content>\n    </article>\n    <elo-breadcrumb [urlsToLabels]=\"urlsToLabels\" *ngIf=\"enabledBreadcrumb\">\n      <ng-template #botoesDireita>\n        <ng-container *ngTemplateOutlet=\"botoesBreadcrumb\"></ng-container>\n      </ng-template>\n    </elo-breadcrumb>\n  </header>\n\n  <ng-content></ng-content>\n</section>\n"
            }]
    }], function () { return [{ type: ɵngcc6.Router }, { type: ɵngcc0.ElementRef }, { type: SectionService }, { type: IFrameStore }, { type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_RESOURCES_CONFIG]
            }] }]; }, { sidebarTree: [{
            type: Input
        }], enabled: [{
            type: Input
        }], fullScreen: [{
            type: Input
        }], hideHeader: [{
            type: Input
        }], toggled: [{
            type: Input
        }], enabledBreadcrumb: [{
            type: Input
        }], urlsToLabels: [{
            type: Input
        }], botoesBreadcrumb: [{
            type: ContentChild,
            args: ['botoesBreadcrumb']
        }], breadCrumb: [{
            type: ViewChild,
            args: [BreadcrumbComponent]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthParams, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_RESOURCES_CONFIG]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(KeycloakAuthHttp, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [KEYCLOAK_AUTH_RESOURCES_CONFIG]
            }] }, { type: AuthParams }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbIframeService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConsultaDinamicaComponent, [{
        type: Component,
        args: [{
                selector: 'consulta-dinamica',
                template: "<div [ngStyle]=\"{'height': altura}\">\n  <iframe [src]=\"url | safe\" *ngIf=\"url\" id=\"iframe\"></iframe>\n</div>\n",
                styles: ['#iframe {width:100%; height: 100%;}']
            }]
    }], function () { return [{ type: KeycloakAuthHttp }, { type: BreadcrumbIframeService }, { type: SectionComponent }]; }, { altura: [{
            type: Input
        }], url: [{
            type: Input
        }], modulo: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ConsultaDinamicaModule, { declarations: function () { return [ConsultaDinamicaComponent]; }, imports: function () { return [CommonModule$1, PipeModule]; }, exports: function () { return [ConsultaDinamicaComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConsultaDinamicaModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, PipeModule],
                declarations: [ConsultaDinamicaComponent],
                exports: [ConsultaDinamicaComponent],
                providers: [WindowService, BreadcrumbIframeService]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ArvoreAvancadaComponent, [{
        type: Component,
        args: [{
                selector: 'arvore-avancada',
                template: `
    <div class="advtree">
      <div class="advtree-container">
        <arvore-avancada-node class="advtree-item" [ngClass]="{'checked': node.expanded}"
                              *ngFor="let node of visibleNodes"
                              [node]="node"
                              [formNode]="formNode"
                              [showActions]="true"
                              (onEdition)="onEditionThen($event)"
                              (onSelection)="emitirSelecionado($event)"
                              (onDeletion)="onDeletionThen($event)"
                              (onHeadClick)="headClick($event)">
        </arvore-avancada-node>
      </div>
    </div>
  `
            }]
    }], function () { return []; }, { onSelection: [{
            type: Output
        }], onEdition: [{
            type: Output
        }], onDeletion: [{
            type: Output
        }], onHeadClick: [{
            type: Output
        }], nodes: [{
            type: Input
        }], formNode: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ArvoreAvancadaNodeHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'arvore-avancada-node-header',
                template: `
    <input type="radio" aria-label="Seletor item árvore" class="advtree-selector" name="advtree-selector" (click)="headClick(node)"/>
    <div class="advtree-header" (click)="headClick(node)">
      <div class="advtree-title">
        <span class="id hint module-color top-left">{{levelNumber}}
            <div class="hint-content" *ngIf="hint">{{hint}}</div>
        </span>
        <span class="title">{{node.summary}}</span>
      </div>
      <div class="advtree-actions" *ngIf="showActions">
        <ng-container *ngTemplateOutlet="headerActions; context: {node: node}">
        </ng-container>
      </div>
    </div>
  `
            }]
    }], function () { return []; }, { showActions: [{
            type: Input
        }], onHeadClick: [{
            type: Output
        }], node: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ArvoreAvancadaChildrenSummaryComponent, [{
        type: Component,
        args: [{
                selector: 'arvore-avancada-children-resume',
                template: `
    <ul class="list ">
      <ng-container *ngFor="let summary of summaries; let i = index">
        <li (click)="selectNode($event, summary)">
          <div class="description">{{summary}}</div>
          <div class="btn-actions">
            <button id="btnEdit-{{i}}" type="button" class="btn circle" (click)="onEdit($event, summary)">
              <i class="fa fa-pencil"></i>
              <div class="btn-actions-label">Editar</div>
            </button>
            <button id="btnRemove-{{i}}" type="button" class="btn circle" (click)="emitOnDelete($event, summary)">
              <i class="fa fa-trash"></i>
              <div class="btn-actions-label">Remover</div>
            </button>
          </div>
        </li>
      </ng-container>
    </ul>
  `
            }]
    }], function () { return []; }, { onEdition: [{
            type: Output
        }], onSelecion: [{
            type: Output
        }], onDeletion: [{
            type: Output
        }], children: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ArvoreAvancadaNodeComponent, [{
        type: Component,
        args: [{
                selector: 'arvore-avancada-node',
                template: `
    <arvore-avancada-node-header [node]="node"
                                 [showActions]="showActions"
                                 (onHeadClick)="headClick($event)">
    </arvore-avancada-node-header>
    <div class="advtree-content">
      <ng-container *ngIf="(formNode | async) as form;else list">
        <arvore-avancada-node-form *ngIf="node.expanded === true"
                                   [node]="form">
        </arvore-avancada-node-form>
      </ng-container>
      <ng-template #list>
        <arvore-avancada-children-resume [children]="node.children"
                                         (onEdition)="onEditionThen($event)"
                                         (onSelecion)="emitirSelecionado($event)"
                                         (onDeletion)="onDeletionThen($event)">
        </arvore-avancada-children-resume>
      </ng-template>
    </div>
  `
            }]
    }], function () { return []; }, { onSelection: [{
            type: Output
        }], showActions: [{
            type: Input
        }], onEdition: [{
            type: Output
        }], onDeletion: [{
            type: Output
        }], onHeadClick: [{
            type: Output
        }], node: [{
            type: Input
        }], formNode: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ArvoreAvancadaNodeFormComponent, [{
        type: Component,
        args: [{
                selector: 'arvore-avancada-node-form',
                template: `
    <ng-container *ngTemplateOutlet="node?.formTemplate; context:{ node: node }"></ng-container>
  `
            }]
    }], null, { node: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ArvoreAvancadaModule, { declarations: function () { return [ArvoreAvancadaComponent, ArvoreAvancadaNodeComponent, ArvoreAvancadaNodeHeaderComponent, ArvoreAvancadaNodeFormComponent, ArvoreAvancadaChildrenSummaryComponent]; }, imports: function () { return [CommonModule$1,
        FormsModule]; }, exports: function () { return [ArvoreAvancadaComponent, ArvoreAvancadaNodeComponent, ArvoreAvancadaNodeHeaderComponent, ArvoreAvancadaNodeFormComponent, ArvoreAvancadaChildrenSummaryComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ArvoreAvancadaModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    FormsModule,
                ],
                declarations: [
                    ArvoreAvancadaComponent,
                    ArvoreAvancadaNodeComponent,
                    ArvoreAvancadaNodeHeaderComponent,
                    ArvoreAvancadaNodeFormComponent,
                    ArvoreAvancadaChildrenSummaryComponent,
                ],
                exports: [
                    ArvoreAvancadaComponent,
                    ArvoreAvancadaNodeComponent,
                    ArvoreAvancadaNodeHeaderComponent,
                    ArvoreAvancadaNodeFormComponent,
                    ArvoreAvancadaChildrenSummaryComponent,
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AssinaturaSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'assinatura-selector',
                template: "<div class=\"mt-sm\">\n  <elo-panel title=\"Assinaturas\" [hasForm]=\"true\">\n    <elo-datatable selectionModeId=\"assinaturas\" [emptyMessage]=\"'N\u00E3o foi encontrado assinaturas.'\" id=\"assinaturas\"\n      selectionMode=\"multiple\" [values]=\"assinaturas\" (onModifySelection)=\"selectAssinatura($event)\"\n      [selection]=\"assinaturasPadrao\" [class]=\"'fancy fixed'\">\n      <elo-column field=\"cargo.descricao\" header=\"Cargo\"></elo-column>\n      <elo-column field=\"pessoa\" header=\"Nome\"></elo-column>\n    </elo-datatable>\n  </elo-panel>\n</div>\n"
            }]
    }], function () { return []; }, { onSelectAssinatura: [{
            type: Output
        }], assinaturaService: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ObjectUtilService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloTableAction, [{
        type: Directive
    }], function () { return []; }, { visible: [{
            type: Input
        }], visibleWhenAttribute: [{
            type: Input
        }], icon: [{
            type: Input
        }], title: [{
            type: Input
        }], id: [{
            type: Input
        }], visibleWhenFunction: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloDatatableComponent, [{
        type: Component,
        args: [{
                selector: 'elo-datatable',
                template: "<div class=\"table table-responsive\" [class.has-header-button]=\"eloHeaderActions?.length === 0\">\n  <div class=\"panel-table-outer\">\n    <ng-content></ng-content>\n    <table class=\"panel-table {{class}}\">\n      <thead [hidden]=\"!values?.length\">\n        <tr>\n          <th *ngIf=\"isMultipleSelectionMode()\" class=\"column-checkbox\">\n            <elo-checkbox id=\"{{selectionModeId}}_header\" (onClick)=\"clickSelectAll()\" [checked]=\"isAllSelected()\">\n            </elo-checkbox>\n          </th>\n\n          <th *ngIf=\"isRadioSelectionMode()\"></th>\n\n          <th [style]=\"'text-transform: '+ textTransform +';'\" *ngFor=\"let column of eloColumns; let isLast = last;\"\n            (click)=\"clickHeaderTable(column)\" [class.right]=\"column.isDecimal\"\n            [class.asc]=\"sortable && getSort(column.field,'asc')\"\n            [class.desc]=\"sortable && getSort(column.field,'desc')\"\n            [class.sortable]=\"sortable && column.sortable && pageParameters.sort.indexOf('column.field') === -1\"\n            [ngClass]=\"column.headerAlign\" [ngStyle]=\"isLast ? getLastColumnStyle(column) : column.headerStyle\"\n            [hidden]=\"column.hidden\" [attr.colspan]=\"column.col\">\n            <span *ngIf=\"!column.headerTemplate\" [textContent]=\"column.header\"></span>\n            <span *ngIf=\"column.headerTemplate\" [ngTemplateOutlet]=\"column.headerTemplate\"\n              [ngTemplateOutletContext]=\"{column: column}\"></span>\n          </th>\n\n          <th style=\"width: 8%\" *ngIf=\"isSingleSelectionMode()\">\n            Selecione\n          </th>\n\n          <ng-container *ngIf=\"haveHeaderAction()\">\n            <ng-container *ngIf=\"eloHeaderActions.length > 1;else headerButton\">\n              <th class=\"many-header-buttons\"><i class=\"fa fa-ellipsis-v many-header-buttons-icon\"></i>\n                <div class=\"many-header-buttons-options\">\n                  <ng-container *ngFor=\"let headerAction of eloHeaderActions\">\n                    <ng-container *ngIf=\"headerAction.template; else defaultHeaderButton\">\n                      <ng-container *ngTemplateOutlet=\"headerAction.template\"></ng-container>\n                    </ng-container>\n                    <ng-template #defaultHeaderButton>\n                      <div class=\"header-button\" key=\"header-actions\">\n                        <div class=\"btn-actions\">\n                          <div class=\"btn-actions-inner\">\n                            <button type=\"button\" id=\"{{headerAction.id}}\" class=\"btn circle\"\n                              (click)=\"headerAction.clickIconButton($event)\">\n                              <i class=\"{{headerAction.icon}}\"></i>\n                              <div class=\"btn-actions-label\">\n                                {{headerAction.description}}\n                              </div>\n                            </button>\n                          </div>\n                        </div>\n                      </div>\n                    </ng-template>\n                  </ng-container>\n                </div>\n              </th>\n            </ng-container>\n          </ng-container>\n          <ng-template #headerButton>\n            <ng-container *ngIf=\"eloHeaderActions[0]?.template; else defaultHeaderButton\">\n              <ng-container *ngTemplateOutlet=\"eloHeaderActions[0].template\"></ng-container>\n            </ng-container>\n            <ng-template #defaultHeaderButton>\n              <th class=\"header-button\" key=\"header-actions\">\n                <div class=\"btn-actions\" *ngIf=\"eloHeaderActions[0] as headerAction\">\n                  <div class=\"btn-actions-inner\">\n                    <button type=\"button\" id=\"{{headerAction.id}}\" class=\"btn circle\"\n                      (click)=\"headerAction.clickIconButton($event)\">\n                      <i class=\"{{headerAction.icon}}\"></i>\n                      <div class=\"btn-actions-label\">\n                        {{headerAction.description}}\n                      </div>\n                    </button>\n                  </div>\n                </div>\n              </th>\n            </ng-template>\n          </ng-template>\n\n          <th *ngIf=\"enableHeaderActionColspan()\" class=\"has-btn-actions\"></th>\n        </tr>\n      </thead>\n\n      <tbody elo-row #row [objects]=\"values\" [colSpanActions]=\"colSpanActions\" [isQuickViewOpener]=\"isQuickViewOpener\"\n        [selectionModeId]=\"selectionModeId\" [rowDoubleClickFunction]=\"rowDoubleClickFunction\"></tbody>\n\n      <tfoot [hidden]=\"values?.length == 0\">\n        <tr *ngIf=\"dataTableFooter\">\n          <ng-container *ngTemplateOutlet=\"dataTableFooter\"></ng-container>\n        </tr>\n        <tr *ngIf=\"isMultipleSelectionMode()\">\n          <td>\n            <elo-checkbox id=\"{{selectionModeId}}_footer\" (onClick)=\"clickSelectAll()\" [checked]=\"isAllSelected()\">\n            </elo-checkbox>\n          </td>\n\n          <td *ngFor=\"let column of eloColumns\" [attr.colspan]=\"column.col\"></td>\n\n          <td *ngIf=\"haveAction()\" class=\"has-btn-actions\"></td>\n        </tr>\n      </tfoot>\n\n      <tbody id=\"message-error\" *ngIf=\"!values || values.length == 0\">\n        <tr>\n          <td class=\"center\">\n            <span class={{classEmptyMessage}} id=\"idEmptyMessageDataTable\">\n              {{emptyMessage}}\n            </span>\n          </td>\n        </tr>\n      </tbody>\n\n    </table>\n\n    <div *ngIf=\"dataTableSubtitles\" class=\"subtitles\">\n      <ng-container *ngTemplateOutlet=\"dataTableSubtitles\"></ng-container>\n    </div>\n\n  </div>\n</div>"
            }]
    }], function () { return [{ type: ObjectUtilService }]; }, { emptyMessage: [{
            type: Input
        }], selectionModeId: [{
            type: Input
        }], onClickCheckbox: [{
            type: Output
        }], onClickRadioButton: [{
            type: Output
        }], onSelectOne: [{
            type: Output
        }], onModifySelection: [{
            type: Output
        }], onTableHeadClick: [{
            type: Output
        }], sortable: [{
            type: Input
        }], isQuickViewOpener: [{
            type: Input
        }], manyActions: [{
            type: Input
        }], onInputChange: [{
            type: Output
        }], rowDoubleClickFunction: [{
            type: Input
        }], enableScrollX: [{
            type: Input
        }], textTransform: [{
            type: Input
        }], selection: [{
            type: Input
        }], values: [{
            type: Input
        }], dataTableFooter: [{
            type: ContentChild,
            args: ['dataTableFooter']
        }], dataTableSubtitles: [{
            type: ContentChild,
            args: ['dataTableSubtitles']
        }], childExpandTemplate: [{
            type: ContentChild,
            args: ['dataTableExpand']
        }], paramExpandTemplate: [{
            type: Input
        }], selectionMode: [{
            type: Input
        }], fieldShowCheckbox: [{
            type: Input
        }], titleCheckboxDisallowed: [{
            type: Input
        }], pageParameters: [{
            type: Input
        }], class: [{
            type: Input
        }], colSpanActions: [{
            type: Input
        }], classEmptyMessage: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloColumnComponent, [{
        type: Component,
        args: [{
                selector: 'elo-column',
                template: ''
            }]
    }], function () { return [{ type: EloDatatableComponent }]; }, { headerAlign: [{
            type: Input
        }], isPercentual: [{
            type: Input
        }], isEditable: [{
            type: Input
        }], isEditing: [{
            type: Input
        }], hidden: [{
            type: Input
        }], hiddenTableData: [{
            type: Input
        }], sortable: [{
            type: Input
        }], samp: [{
            type: Input
        }], dataTable: [{
            type: Input
        }], field: [{
            type: Input
        }], header: [{
            type: Input
        }], isDecimal: [{
            type: Input
        }], digits: [{
            type: Input
        }], isDate: [{
            type: Input
        }], isDateTime: [{
            type: Input
        }], isCnpjCpf: [{
            type: Input
        }], enumOptions: [{
            type: Input
        }], col: [{
            type: Input
        }], cellTemplate: [{
            type: ContentChild,
            args: ['dataTableCell']
        }], headerTemplate: [{
            type: ContentChild,
            args: ['dataTableHeader']
        }], validationMessageTemplate: [{
            type: ContentChild,
            args: ['validationMessage']
        }], class: [{
            type: Input
        }], headerStyle: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloDataTableRowComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: '[elo-row]',
                template: "<ng-container *ngFor=\"let object of objects; index as i\">\n  <tr id=\"{{'table-line_' + i }}\" [class.highlight]=\"object?.highlight\" [class.warning]=\"object?.warning\"\n    [class.success]=\"object?.success\" [class.error]=\"object?.error\" [class.rowSelected]=\"object?.quickSelected\"\n    [class.reduced]=\"table.manyActions\" (dblclick)=\"onRowDoubleClick(object)\">\n    <td *ngIf=\"table.isMultipleSelectionMode()\" class=\"column-checkbox\">\n      <elo-checkbox id=\"{{object.id ? (selectionModeId + object.id + '_' + i) : selectionModeId + i }}\"\n        [checkAllowed]=\"table.checkAllowed(object)\" [checked]=\"table.isSelected(object)\"\n        [titleCheckboxDisallowed]=\"table.titleCheckboxDisallowed\" (onClick)=\"table.clickCheckBox(object)\">\n      </elo-checkbox>\n    </td>\n    <td *ngIf=\"table.isRadioSelectionMode()\">\n      <input (change)=\"table.clickRadioButton(object)\" name=\"select-radio\" type=\"radio\" value=\"object\" [checked]=\"table.isSelected(object)\" />\n    </td>\n\n    <td *ngFor=\"let column of table.eloColumns; let isLast = last;\" [hidden]=\"column.hidden || column.hiddenTableData\"\n      [attr.colspan]=\"isLast ? table.getLastColumnColspan(column) : column.col\" class=\"{{column.class}}\"\n      [ngClass]=\" column.isDecimal ? 'right': ''\" [ngStyle]=\"isLast ? table.getLastColumnStyle(column) : {}\">\n      <b class=\"td-label\">{{column.header}}</b>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && !column.isDecimal && !column.isPercentual && !column.isDate && !column.isCnpjCpf && !column.isBoolean && !column.cellTemplate && !column.isDateTime && !column.samp\">{{table?.getValue(object,\n        column.field, column.enumOptions)}}</span>\n      <samp class=\"td-content {{column.class}}\" *ngIf=\"column.samp\">{{table?.getValue(object, column.field,\n        column.enumOptions)}}</samp>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDecimal && !column.isPercentual && !column.cellTemplate\">{{table?.getValue(object,\n        column.field) | decimalformat: column.digits\n        ? column.digits : \"1.2-2\" }}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDecimal && column.isPercentual && !column.cellTemplate\">{{table?.getValue(object,\n        column.field) | decimalformat: column.digits\n        ? column.digits : \"1.2-2\" }}%</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isDate && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        dateformat}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && !column.isDate && !column.cellTemplate && column.isDateTime\">{{table?.getValue(object,\n        column.field) | datehourformat}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isCnpjCpf && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        cnpjCpf}}</span>\n      <span class=\"td-content {{column.class}}\"\n        *ngIf=\"!column.isEditable && column.isBoolean && !column.cellTemplate\">{{table?.getValue(object, column.field) |\n        dateformat}}</span>\n      <span class=\"td-content {{column.class}}\" *ngIf=\"column.cellTemplate\" [ngTemplateOutlet]=\"column.cellTemplate\"\n        [ngTemplateOutletContext]=\"{column: column, object: object, index: i}\"></span>\n    </td>\n    <td *ngIf=\"table.haveAction()\" [attr.colspan]=\"colSpanActions\" [class.quickViewOpener]=\"isQuickViewOpener\"\n      class=\"has-btn-actions\">\n      <div class=\"btn-actions\" *ngIf=\"table.tableActionVisibleTo(object).length\">\n        <div class=\"btn-actions-inner\">\n          <ng-container *ngFor=\"let action of table.tableActionVisibleTo(object);let i = index\"\n            [ngSwitch]=\"action.type\">\n            <button *ngSwitchCase=\"action.complex()\" class=\"btn\" [removeAutoFocus]=\"action.removeAutoFocus\"\n              [class.error]=\"object?.error && action.showError\" id=\"{{action.id}}_{{i}}\" [class.links]=\"action.hasLinks\"\n              type=\"button\" (click)=\"action.clickIconButton(object)\">\n              <i class=\"{{action.icon}}\"></i>\n              <div class=\"btn-actions-label\" *ngIf=\"!action.hasLinks\">\n                {{action.title}}\n              </div>\n              <div class=\"btn-actions-label\" *ngIf=\"action.hasLinks\">\n                <a href=\"javascript:void(0)\" *ngFor=\"let link of action.getLinks(object)\"\n                  (click)=\"action.clickLink(object, link)\">{{link}}</a>\n              </div>\n            </button>\n\n            <a *ngSwitchCase=\"action.link()\" href=\"{{action.buildHRef(object)}}\" class=\"btn center\" target=\"_blank\"\n              rel=\"noopener noreferrer\">\n              <i class=\"fa fa-print\" style=\"line-height: 21px\"></i>\n              <div class=\"btn-actions-label\">{{ action.title }}</div>\n            </a>\n          </ng-container>\n        </div>\n      </div>\n    </td>\n\n    <td *ngIf=\"table.isSingleSelectionMode()\">\n      <button-select (click)=\"table.clickSelectOne(object)\">\n        Adicionar\n      </button-select>\n    </td>\n  </tr>\n  <tr class=\"child-table\" *ngIf=\"object?.expand\">\n    <td [attr.colspan]=\"table.columnCount\">\n      <div [ngTemplateOutlet]=\"table.expandTemplate\" [ngTemplateOutletContext]=\"{object: object}\"></div>\n    </td>\n  </tr>\n</ng-container>"
            }]
    }], function () { return [{ type: EloDatatableComponent, decorators: [{
                type: Inject,
                args: [forwardRef(() => EloDatatableComponent)]
            }] }]; }, { isQuickViewOpener: [{
            type: Input
        }], selectionModeId: [{
            type: Input
        }], index: [{
            type: Input
        }], rowDoubleClickFunction: [{
            type: Input
        }], objects: [{
            type: Input
        }], colSpanActions: [{
            type: Input
        }] }); })();

class EloHeaderActionsComponent {
    constructor(table) {
        this.table = table;
        this.visible = true;
        this.id = Date.now();
        /**
         * Irá emitir o elemento da linha selecionada
         */
        this.onClickIconButton = new EventEmitter();
        table.addHeaderActions(this);
    }
    clickIconButton(object) {
        this.onClickIconButton.emit(object);
    }
}
EloHeaderActionsComponent.ɵfac = function EloHeaderActionsComponent_Factory(t) { return new (t || EloHeaderActionsComponent)(ɵngcc0.ɵɵdirectiveInject(EloDatatableComponent)); };
EloHeaderActionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloHeaderActionsComponent, selectors: [["elo-header-actions"]], inputs: { visible: "visible", id: "id", icon: "icon", description: "description", template: "template" }, outputs: { onClickIconButton: "onClickIconButton" }, decls: 0, vars: 0, template: function EloHeaderActionsComponent_Template(rf, ctx) { }, encapsulation: 2 });
EloHeaderActionsComponent.ctorParameters = () => [
    { type: EloDatatableComponent }
];
EloHeaderActionsComponent.propDecorators = {
    icon: [{ type: Input }],
    visible: [{ type: Input }],
    id: [{ type: Input }],
    description: [{ type: Input }],
    template: [{ type: Input }],
    onClickIconButton: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloHeaderActionsComponent, [{
        type: Component,
        args: [{
                selector: 'elo-header-actions',
                template: ''
            }]
    }], function () { return [{ type: EloDatatableComponent }]; }, { visible: [{
            type: Input
        }], id: [{
            type: Input
        }], onClickIconButton: [{
            type: Output
        }], icon: [{
            type: Input
        }], description: [{
            type: Input
        }], template: [{
            type: Input
        }] }); })();

class EloTableActionLinkComponent extends EloTableAction {
    constructor(table) {
        super();
        this.table = table;
        this.onBuildHRef = new EventEmitter();
        this.addOn(table);
    }
    get type() {
        return EloTableActionType.link;
    }
    buildHRef(value) {
        let href = '';
        let buildHrefEvent = {
            href: href,
            object: value
        };
        this.onBuildHRef.emit(buildHrefEvent);
        return buildHrefEvent.href;
    }
}
EloTableActionLinkComponent.ɵfac = function EloTableActionLinkComponent_Factory(t) { return new (t || EloTableActionLinkComponent)(ɵngcc0.ɵɵdirectiveInject(EloDatatableComponent, 8)); };
EloTableActionLinkComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloTableActionLinkComponent, selectors: [["elo-table-action-link"]], outputs: { onBuildHRef: "onBuildHRef" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function EloTableActionLinkComponent_Template(rf, ctx) { }, encapsulation: 2 });
EloTableActionLinkComponent.ctorParameters = () => [
    { type: EloDatatableComponent, decorators: [{ type: Optional }] }
];
EloTableActionLinkComponent.propDecorators = {
    onBuildHRef: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloTableActionLinkComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-action-link',
                template: ''
            }]
    }], function () { return [{ type: EloDatatableComponent, decorators: [{
                type: Optional
            }] }]; }, { onBuildHRef: [{
            type: Output
        }] }); })();

class EloTableActionsComponent extends EloTableAction {
    constructor(table) {
        super();
        this.table = table;
        this.showError = false;
        this.hasLinks = false;
        this.quickViewOpener = false;
        this.removeAutoFocus = false;
        /**
         * Irá emitir o elemento da linha selecionada
         */
        this.onClickLink = new EventEmitter();
        this.onClickIconButton = new EventEmitter();
        this.addOn(table);
    }
    get type() {
        return EloTableActionType.complex;
    }
    clickIconButton(object) {
        this.onClickIconButton.emit(object);
    }
    clickLink(object, link) {
        object.link = link;
        this.onClickLink.emit(object);
    }
    getLinks(object) {
        if (this.links) {
            return this.links;
        }
        if (this.linksFunction) {
            return this.linksFunction(object);
        }
    }
}
EloTableActionsComponent.ɵfac = function EloTableActionsComponent_Factory(t) { return new (t || EloTableActionsComponent)(ɵngcc0.ɵɵdirectiveInject(EloDatatableComponent, 8)); };
EloTableActionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloTableActionsComponent, selectors: [["elo-table-actions"]], inputs: { showError: "showError", hasLinks: "hasLinks", quickViewOpener: "quickViewOpener", removeAutoFocus: "removeAutoFocus", links: "links", linksFunction: "linksFunction" }, outputs: { onClickLink: "onClickLink", onClickIconButton: "onClickIconButton" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function EloTableActionsComponent_Template(rf, ctx) { }, encapsulation: 2 });
EloTableActionsComponent.ctorParameters = () => [
    { type: EloDatatableComponent, decorators: [{ type: Optional }] }
];
EloTableActionsComponent.propDecorators = {
    showError: [{ type: Input }],
    hasLinks: [{ type: Input }],
    links: [{ type: Input }],
    linksFunction: [{ type: Input }],
    quickViewOpener: [{ type: Input }],
    removeAutoFocus: [{ type: Input }],
    onClickLink: [{ type: Output }],
    onClickIconButton: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloTableActionsComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-actions',
                template: ''
            }]
    }], function () { return [{ type: EloDatatableComponent, decorators: [{
                type: Optional
            }] }]; }, { showError: [{
            type: Input
        }], hasLinks: [{
            type: Input
        }], quickViewOpener: [{
            type: Input
        }], removeAutoFocus: [{
            type: Input
        }], onClickLink: [{
            type: Output
        }], onClickIconButton: [{
            type: Output
        }], links: [{
            type: Input
        }], linksFunction: [{
            type: Input
        }] }); })();

class EloTableSubtitleComponent {
    constructor() {
        this.type = '';
    }
}
EloTableSubtitleComponent.ɵfac = function EloTableSubtitleComponent_Factory(t) { return new (t || EloTableSubtitleComponent)(); };
EloTableSubtitleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloTableSubtitleComponent, selectors: [["elo-table-subtitle"]], inputs: { type: "type" }, ngContentSelectors: _c0, decls: 2, vars: 3, template: function EloTableSubtitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("subtitle ", ctx.type, "");
    } }, encapsulation: 2 });
EloTableSubtitleComponent.ctorParameters = () => [];
EloTableSubtitleComponent.propDecorators = {
    type: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloTableSubtitleComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-subtitle',
                template: `
    <div class="subtitle {{type}}">
      <ng-content></ng-content>
    </div>
`
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }] }); })();

class DomHandlerService {
    addClass(element, className) {
        if (element.classList) {
            element.classList.add(className);
        }
        else {
            element.className += ' ' + className;
        }
    }
    addMultipleClasses(element, className) {
        if (element.classList) {
            let styles = className.split(' ');
            for (let i = 0; i < styles.length; i++) {
                element.classList.add(styles[i]);
            }
        }
        else {
            let styles = className.split(' ');
            for (let i = 0; i < styles.length; i++) {
                element.className += ' ' + styles[i];
            }
        }
    }
    removeClass(element, className) {
        if (element.classList) {
            element.classList.remove(className);
        }
        else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }
    hasClass(element, className) {
        if (element.classList) {
            return element.classList.contains(className);
        }
        else {
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
        }
    }
    find(element, selector) {
        return element.querySelectorAll(selector);
    }
    findSingle(element, selector) {
        return element.querySelector(selector);
    }
    index(element) {
        let children = element.parentNode.childNodes;
        let num = 0;
        for (let i = 0; i < children.length; i++) {
            if (children[i] === element)
                return num;
            if (children[i].nodeType === 1)
                num++;
        }
        return -1;
    }
    getUserAgent() {
        return navigator.userAgent;
    }
}
DomHandlerService.ɵfac = function DomHandlerService_Factory(t) { return new (t || DomHandlerService)(); };
DomHandlerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DomHandlerService, factory: DomHandlerService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DomHandlerService, [{
        type: Injectable
    }], null, null); })();

class ButtonSelectOneComponent {
    constructor() {
        this.onClick = new EventEmitter();
    }
    buttonClick(event) {
        if (this.enable()) {
            this.clicked = !this.clicked;
            let buttonSelectOneEvent = { originalEvent: event, clicked: this.clicked };
            this.onClick.emit(buttonSelectOneEvent);
        }
    }
    enable() {
        return !this.disabled;
    }
}
ButtonSelectOneComponent.ɵfac = function ButtonSelectOneComponent_Factory(t) { return new (t || ButtonSelectOneComponent)(); };
ButtonSelectOneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ButtonSelectOneComponent, selectors: [["button-select"]], inputs: { clicked: "clicked", title: "title", disabled: "disabled" }, outputs: { onClick: "onClick" }, decls: 6, vars: 0, consts: [[1, "btn-actions"], [1, "btn-actions-inner"], ["type", "button", 1, "btn", "ng-star-inserted", 3, "click"], [1, "fa", "fa-plus"], [1, "btn-actions-label"]], template: function ButtonSelectOneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function ButtonSelectOneComponent_Template_button_click_2_listener($event) { return ctx.buttonClick($event); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtext(5, " Adicionar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
ButtonSelectOneComponent.propDecorators = {
    title: [{ type: Input }],
    clicked: [{ type: Input }],
    disabled: [{ type: Input }],
    onClick: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonSelectOneComponent, [{
        type: Component,
        args: [{
                selector: 'button-select',
                template: `<div class="btn-actions">
                <div class="btn-actions-inner">
                  <button class="btn ng-star-inserted" type="button" (click)="buttonClick($event)">
                    <i class="fa fa-plus"></i>
                    <div class="btn-actions-label">
                      Adicionar
                    </div>
                  </button>
                </div>
             </div>
            `
            }]
    }], function () { return []; }, { onClick: [{
            type: Output
        }], clicked: [{
            type: Input
        }], title: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class ButtonSelectOneModule {
}
ButtonSelectOneModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ButtonSelectOneModule });
ButtonSelectOneModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ButtonSelectOneModule_Factory(t) { return new (t || ButtonSelectOneModule)(); }, imports: [[CommonModule$1, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonSelectOneModule, { declarations: function () { return [ButtonSelectOneComponent]; }, imports: function () { return [CommonModule$1, FormsModule]; }, exports: function () { return [ButtonSelectOneComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonSelectOneModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, FormsModule],
                declarations: [ButtonSelectOneComponent],
                exports: [ButtonSelectOneComponent]
            }]
    }], null, null); })();

/**
 * @ToDo implementar name e value
 */
class EloCheckboxComponent {
    constructor() {
        this.label = '';
        this.checkAllowed = true;
        this.titleCheckboxDisallowed = 'Seleção não permitida';
        this.onClick = new EventEmitter();
    }
    clickCheckbox(event) {
        if (this.enable()) {
            this.checked = !this.checked;
            let eloCheckboxEvent = { originalEvent: event, checked: this.checked };
            this.onClick.emit(eloCheckboxEvent);
        }
    }
    enable() {
        return !this.disabled;
    }
}
EloCheckboxComponent.ɵfac = function EloCheckboxComponent_Factory(t) { return new (t || EloCheckboxComponent)(); };
EloCheckboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloCheckboxComponent, selectors: [["elo-checkbox"]], inputs: { label: "label", checkAllowed: "checkAllowed", titleCheckboxDisallowed: "titleCheckboxDisallowed", checked: "checked", id: "id", disabled: "disabled" }, outputs: { onClick: "onClick" }, decls: 2, vars: 2, consts: [["class", "checkbox-container", 4, "ngIf"], ["class", "fa fa-ban", "style", "color: #da0e0e", 3, "title", 4, "ngIf"], [1, "checkbox-container"], ["type", "checkbox", 1, "checkbox-item-input", "input-checkbox", 3, "id", "checked", "click"], [1, "checkbox-item-label", 3, "for"], [1, "fa", "fa-ban", 2, "color", "#da0e0e", 3, "title"]], template: function EloCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EloCheckboxComponent_div_0_Template, 4, 4, "div", 0);
        ɵngcc0.ɵɵtemplate(1, EloCheckboxComponent_em_1_Template, 1, 1, "em", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.checkAllowed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.checkAllowed);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
EloCheckboxComponent.propDecorators = {
    id: [{ type: Input }],
    label: [{ type: Input }],
    checkAllowed: [{ type: Input }],
    titleCheckboxDisallowed: [{ type: Input }],
    checked: [{ type: Input }],
    disabled: [{ type: Input }],
    onClick: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'elo-checkbox',
                template: `
  <div *ngIf="checkAllowed" class="checkbox-container">
    <input class="checkbox-item-input input-checkbox" id="{{id}}_input_checkbox" type="checkbox" [checked]="checked" (click)="clickCheckbox($event)">
    <label class="checkbox-item-label" for="{{id}}_input_checkbox">{{label}}</label>
  </div>
  <em *ngIf="!checkAllowed" class="fa fa-ban" style="color: #da0e0e" title="{{titleCheckboxDisallowed}}"></em>
`
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], checkAllowed: [{
            type: Input
        }], titleCheckboxDisallowed: [{
            type: Input
        }], onClick: [{
            type: Output
        }], checked: [{
            type: Input
        }], id: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class EloCheckboxModule {
}
EloCheckboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloCheckboxModule });
EloCheckboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloCheckboxModule_Factory(t) { return new (t || EloCheckboxModule)(); }, imports: [[CommonModule$1, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloCheckboxModule, { declarations: function () { return [EloCheckboxComponent]; }, imports: function () { return [CommonModule$1, FormsModule]; }, exports: function () { return [EloCheckboxComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, FormsModule],
                declarations: [EloCheckboxComponent],
                exports: [EloCheckboxComponent]
            }]
    }], null, null); })();

class PanelExpansiveComponent {
    constructor() {
        this.collapsed = false;
        this.title = 'Título obrigatório!';
        this.hasTable = false;
        this.hasForm = true;
        this.expansive = true;
        this.showButton = false;
        this.disabledButton = false;
        this.hideButtonNovo = false;
        this.titleButtonNovo = 'Novo';
        this.enableScrollX = false;
        this.isInsideTab = false;
        this.onExpand = new EventEmitter();
        this.onNewItem = new EventEmitter();
    }
    openToggle() {
        this.collapsed = false;
        if (!this.collapsed) {
            this.onExpand.emit();
        }
    }
    closeToggle() {
        this.collapsed = !this.collapsed;
    }
    newButton(event) {
        event.stopPropagation();
        this.collapsed = false;
        this.onNewItem.emit();
    }
}
PanelExpansiveComponent.ɵfac = function PanelExpansiveComponent_Factory(t) { return new (t || PanelExpansiveComponent)(); };
PanelExpansiveComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PanelExpansiveComponent, selectors: [["elo-panel-expansive"]], inputs: { collapsed: "collapsed", title: "title", hasTable: "hasTable", hasForm: "hasForm", expansive: "expansive", showButton: "showButton", disabledButton: "disabledButton", hideButtonNovo: "hideButtonNovo", titleButtonNovo: "titleButtonNovo", enableScrollX: "enableScrollX", isInsideTab: "isInsideTab", extraButtons: "extraButtons" }, outputs: { onExpand: "onExpand", onNewItem: "onNewItem" }, ngContentSelectors: _c0, decls: 5, vars: 11, consts: [[1, "panel", 3, "ngClass"], [1, "dropdown-arrow", 3, "click"], ["class", "panel-title", "style", "cursor: default !important", 3, "inside-tab", "click", 4, "ngIf"], ["id", "content"], [1, "panel-title", 2, "cursor", "default !important", 3, "click"], ["id", "buttonNovo", "class", "btn circle pull-right module-color", "type", "button", 3, "disabled", "click", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], ["id", "buttonNovo", "type", "button", 1, "btn", "circle", "pull-right", "module-color", 3, "disabled", "click"], [1, "fa", "fa-plus"], [1, "btn-actions-label"], [3, "ngTemplateOutlet"]], template: function PanelExpansiveComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵlistener("click", function PanelExpansiveComponent_Template_span_click_1_listener() { return ctx.closeToggle(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, PanelExpansiveComponent_div_2_Template, 4, 5, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction5(5, _c29, !ctx.collapsed, ctx.collapsed, ctx.hasTable, ctx.hasForm, ctx.expansive));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("panel-body ", ctx.enableScrollX ? "scroll-x" : "", "");
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
PanelExpansiveComponent.propDecorators = {
    collapsed: [{ type: Input }],
    title: [{ type: Input }],
    hasTable: [{ type: Input }],
    hasForm: [{ type: Input }],
    expansive: [{ type: Input }],
    showButton: [{ type: Input }],
    disabledButton: [{ type: Input }],
    hideButtonNovo: [{ type: Input }],
    titleButtonNovo: [{ type: Input }],
    extraButtons: [{ type: Input }],
    enableScrollX: [{ type: Input }],
    isInsideTab: [{ type: Input }],
    onExpand: [{ type: Output }],
    onNewItem: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelExpansiveComponent, [{
        type: Component,
        args: [{
                selector: 'elo-panel-expansive',
                template: "<div class=\"panel\"\n  [ngClass]=\"{'open': !collapsed,'':collapsed,'table':hasTable,'panel-form':hasForm, 'expansible':expansive}\">\n  <span class=\"dropdown-arrow\" (click)=\"closeToggle()\"></span>\n  <div *ngIf=\"title\" class=\"panel-title\" [class.inside-tab]=\"isInsideTab\" (click)=\"openToggle()\" style=\"cursor: default !important\">\n    {{title}}\n    <button id=\"buttonNovo\" class=\"btn circle pull-right module-color\" type=\"button\"\n      *ngIf=\"showButton && !hideButtonNovo\" [disabled]=\"disabledButton\" (click)=\"newButton($event)\">\n      <em class=\"fa fa-plus\"></em>\n      <div class=\"btn-actions-label\">\n        {{titleButtonNovo}}\n      </div>\n    </button>\n    <ng-container [ngTemplateOutlet]=\"extraButtons\" *ngIf=\"showButton && extraButtons\"></ng-container>\n  </div>\n  <div id=\"content\" class=\"panel-body {{ enableScrollX ? 'scroll-x' : '' }}\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { collapsed: [{
            type: Input
        }], title: [{
            type: Input
        }], hasTable: [{
            type: Input
        }], hasForm: [{
            type: Input
        }], expansive: [{
            type: Input
        }], showButton: [{
            type: Input
        }], disabledButton: [{
            type: Input
        }], hideButtonNovo: [{
            type: Input
        }], titleButtonNovo: [{
            type: Input
        }], enableScrollX: [{
            type: Input
        }], isInsideTab: [{
            type: Input
        }], onExpand: [{
            type: Output
        }], onNewItem: [{
            type: Output
        }], extraButtons: [{
            type: Input
        }] }); })();

class PanelExpansiveModule {
}
PanelExpansiveModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PanelExpansiveModule });
PanelExpansiveModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PanelExpansiveModule_Factory(t) { return new (t || PanelExpansiveModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PanelExpansiveModule, { declarations: function () { return [PanelExpansiveComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [PanelExpansiveComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelExpansiveModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [PanelExpansiveComponent],
                declarations: [PanelExpansiveComponent]
            }]
    }], null, null); })();

class EloRadioButtonComponent {
    constructor() {
        this.selectAllowed = true;
        this.titleRadioButtonDisallowed = 'Seleção não permitida';
        this.selected = false;
        this.disabled = false;
        this.onClick = new EventEmitter();
    }
    selectRadio(event) {
        if (this.enable()) {
            this.selected = !this.selected;
            let eloRadioButtonEvent = { originalEvent: event, checked: this.selected };
            this.onClick.emit(eloRadioButtonEvent);
        }
    }
    enable() {
        return !this.disabled;
    }
}
EloRadioButtonComponent.ɵfac = function EloRadioButtonComponent_Factory(t) { return new (t || EloRadioButtonComponent)(); };
EloRadioButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloRadioButtonComponent, selectors: [["elo-radiobutton"]], inputs: { selectAllowed: "selectAllowed", titleRadioButtonDisallowed: "titleRadioButtonDisallowed", selected: "selected", disabled: "disabled" }, outputs: { onClick: "onClick" }, decls: 2, vars: 2, consts: [["type", "radio", 3, "checked", "click", 4, "ngIf"], ["class", "fa fa-ban", "style", "color: #da0e0e", 3, "title", 4, "ngIf"], ["type", "radio", 3, "checked", "click"], [1, "fa", "fa-ban", 2, "color", "#da0e0e", 3, "title"]], template: function EloRadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EloRadioButtonComponent_input_0_Template, 1, 1, "input", 0);
        ɵngcc0.ɵɵtemplate(1, EloRadioButtonComponent_em_1_Template, 1, 1, "em", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectAllowed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.selectAllowed);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
EloRadioButtonComponent.propDecorators = {
    selectAllowed: [{ type: Input }],
    titleRadioButtonDisallowed: [{ type: Input }],
    selected: [{ type: Input }],
    disabled: [{ type: Input }],
    onClick: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloRadioButtonComponent, [{
        type: Component,
        args: [{
                selector: 'elo-radiobutton',
                template: `
    <input *ngIf="selectAllowed" type="radio" [checked]="selected" (click)="selectRadio($event)">
    <em *ngIf="!selectAllowed" class="fa fa-ban" style="color: #da0e0e" title="{{titleRadioButtonDisallowed}}"></em>
`
            }]
    }], function () { return []; }, { selectAllowed: [{
            type: Input
        }], titleRadioButtonDisallowed: [{
            type: Input
        }], selected: [{
            type: Input
        }], disabled: [{
            type: Input
        }], onClick: [{
            type: Output
        }] }); })();

class EloRadioButtonModule {
}
EloRadioButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloRadioButtonModule });
EloRadioButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloRadioButtonModule_Factory(t) { return new (t || EloRadioButtonModule)(); }, imports: [[CommonModule$1, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloRadioButtonModule, { declarations: function () { return [EloRadioButtonComponent]; }, imports: function () { return [CommonModule$1, FormsModule]; }, exports: function () { return [EloRadioButtonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloRadioButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, FormsModule],
                declarations: [EloRadioButtonComponent],
                exports: [EloRadioButtonComponent]
            }]
    }], null, null); })();

class EloDatatableModule {
}
EloDatatableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloDatatableModule });
EloDatatableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloDatatableModule_Factory(t) { return new (t || EloDatatableModule)(); }, providers: [DomHandlerService, ObjectUtilService, EloDatatableComponent], imports: [[
            CommonModule$1,
            PanelModule,
            PanelExpansiveModule,
            FormsModule,
            ReactiveFormsModule,
            EloCheckboxModule,
            EloRadioButtonModule,
            ButtonSelectOneModule,
            PipeModule,
            DirectivesModule
        ], EloCheckboxModule, EloRadioButtonModule, ButtonSelectOneModule, PipeModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloDatatableModule, { declarations: function () { return [EloDatatableComponent, EloColumnComponent, EloTableActionsComponent, EloTableActionLinkComponent, EloHeaderActionsComponent, EloDataTableRowComponent, EloTableSubtitleComponent]; }, imports: function () { return [CommonModule$1, PanelModule, PanelExpansiveModule, FormsModule,
        ReactiveFormsModule, EloCheckboxModule, EloRadioButtonModule, ButtonSelectOneModule, PipeModule, DirectivesModule]; }, exports: function () { return [EloDatatableComponent, EloColumnComponent, EloTableActionsComponent, EloHeaderActionsComponent, EloTableActionLinkComponent, EloTableSubtitleComponent, EloCheckboxModule, EloRadioButtonModule, ButtonSelectOneModule, PipeModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloDatatableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    PanelModule,
                    PanelExpansiveModule,
                    FormsModule,
                    ReactiveFormsModule,
                    EloCheckboxModule,
                    EloRadioButtonModule,
                    ButtonSelectOneModule,
                    PipeModule,
                    DirectivesModule
                ],
                declarations: [
                    EloDatatableComponent,
                    EloColumnComponent,
                    EloTableActionsComponent,
                    EloTableActionLinkComponent,
                    EloHeaderActionsComponent,
                    EloDataTableRowComponent,
                    EloTableSubtitleComponent
                ],
                exports: [
                    EloDatatableComponent,
                    EloColumnComponent,
                    EloTableActionsComponent,
                    EloHeaderActionsComponent,
                    EloTableActionLinkComponent,
                    EloTableSubtitleComponent,
                    EloCheckboxModule,
                    EloRadioButtonModule,
                    ButtonSelectOneModule,
                    PipeModule
                ],
                providers: [DomHandlerService, ObjectUtilService, EloDatatableComponent]
            }]
    }], null, null); })();

class AssinaturaSelectorModule {
}
AssinaturaSelectorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AssinaturaSelectorModule });
AssinaturaSelectorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AssinaturaSelectorModule_Factory(t) { return new (t || AssinaturaSelectorModule)(); }, imports: [[
            CommonModule$1,
            PanelModule,
            EloDatatableModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AssinaturaSelectorModule, { declarations: function () { return [AssinaturaSelectorComponent]; }, imports: function () { return [CommonModule$1, PanelModule, EloDatatableModule]; }, exports: function () { return [AssinaturaSelectorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AssinaturaSelectorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    PanelModule,
                    EloDatatableModule,
                ],
                declarations: [AssinaturaSelectorComponent],
                exports: [AssinaturaSelectorComponent]
            }]
    }], null, null); })();

const GROUP_ADMIN = 'Administradores';
const isUserAdmin = (user) => {
    if (user && user.grupos) {
        return user.grupos.filter(grupo => grupo.nome === GROUP_ADMIN).length > 0;
    }
    return false;
};
class Usuario {
}
class UsuarioTrocaSenha {
}

const permissions = [
    { 'recurso': 'AGENCIA_READ', 'route': 'agencias' },
    { 'recurso': 'AGENCIA_CREATE', 'route': 'agencias/new' },
    { 'recurso': 'AGENCIA_UPDATE', 'route': 'agencias/:id' },
    { 'recurso': 'BAIRRO_READ', 'route': 'bairros' },
    { 'recurso': 'BAIRRO_CREATE', 'route': 'bairros/new' },
    { 'recurso': 'BAIRRO_UPDATE', 'route': 'bairros/:id' },
    { 'recurso': 'LOGRADOURO_READ', 'route': 'logradouros' },
    { 'recurso': 'LOGRADOURO_CREATE', 'route': 'logradouros/new' },
    { 'recurso': 'LOGRADOURO_UPDATE', 'route': 'logradouros/:id' },
    { 'recurso': 'BANCO_READ', 'route': 'bancos' },
    { 'recurso': 'BANCO_CREATE', 'route': 'bancos/new' },
    { 'recurso': 'BANCO_UPDATE', 'route': 'bancos/:id' },
    { 'recurso': 'CIDADE_READ', 'route': 'cidades' },
    { 'recurso': 'CIDADE_CREATE', 'route': 'cidades/new' },
    { 'recurso': 'CIDADE_UPDATE', 'route': 'cidades/:id' },
    { 'recurso': 'ENTIDADE_READ', 'route': 'entidades' },
    { 'recurso': 'ENTIDADE_CREATE', 'route': 'entidades/new' },
    { 'recurso': 'ENTIDADE_UPDATE', 'route': 'entidades/:id' },
    { 'recurso': 'PAIS_READ', 'route': 'paises' },
    { 'recurso': 'PAIS_CREATE', 'route': 'paises/new' },
    { 'recurso': 'PAIS_UPDATE', 'route': 'paises/:id' },
    { 'recurso': 'PESSOA_READ', 'route': 'pessoas' },
    { 'recurso': 'PESSOA_CREATE', 'route': 'pessoas/new' },
    { 'recurso': 'PESSOA_UPDATE', 'route': 'pessoas/:id' },
    { 'recurso': 'UF_READ', 'route': 'ufs' },
    { 'recurso': 'UF_CREATE', 'route': 'ufs/new' },
    { 'recurso': 'UF_UPDATE', 'route': 'ufs/:id' },
    { 'recurso': 'MODULO_READ', 'route': 'cadastromodulos' },
    { 'recurso': 'MODULO_CREATE', 'route': 'cadastromodulos/new' },
    { 'recurso': 'MODULO_UPDATE', 'route': 'cadastromodulos/:id' },
    { 'recurso': 'USUARIO_READ', 'route': 'usuarios' },
    { 'recurso': 'USUARIO_CREATE', 'route': 'usuarios/new' },
    { 'recurso': 'USUARIO_UPDATE', 'route': 'usuarios/:id' },
    { 'recurso': 'GRUPO_READ', 'route': 'grupos' },
    { 'recurso': 'GRUPO_CREATE', 'route': 'grupos/new' },
    { 'recurso': 'GRUPO_UPDATE', 'route': 'grupos/:id' },
    { 'recurso': 'UNIFICACAO_CREATE', 'route': 'batch' },
    { 'recurso': 'VALIDACAO_BANCO_READ', 'route': 'db_validate' },
    { 'recurso': 'ENTRADA_READ', 'route': 'entrada' },
    { 'recurso': 'ENTRADA_CREATE', 'route': 'entrada/new' },
    { 'recurso': 'ENTRADA_UPDATE', 'route': 'entrada/:id' },
    { 'recurso': 'ENTRADA_READ', 'route': 'entrada/:idView/view' },
    { 'recurso': 'SAIDA_READ', 'route': 'saida' },
    { 'recurso': 'SAIDA_CREATE', 'route': 'saida/new' },
    { 'recurso': 'SAIDA_UPDATE', 'route': 'saida/:id' },
    { 'recurso': 'SAIDA_READ', 'route': 'saida/:idView/view' },
    { 'recurso': 'LOTE_READ', 'route': 'lotes' },
    { 'recurso': 'LOTE_CREATE', 'route': 'lotes/new' },
    { 'recurso': 'LOTE_UPDATE', 'route': 'lotes/:id' },
    { 'recurso': 'LOTE_READ', 'route': 'lotes/:idView/view' },
    { 'recurso': 'REQUISICAO_APROVACAO', 'route': 'requisicoes/:id/aprovar' },
    { 'recurso': 'REQUISICAO_READ', 'route': 'requisicoes' },
    { 'recurso': 'REQUISICAO_CREATE', 'route': 'requisicoes/new' },
    { 'recurso': 'REQUISICAO_UPDATE', 'route': 'requisicoes/:id' },
    { 'recurso': 'REQUISICAO_READ', 'route': 'requisicoes/:idView/view' },
    { 'recurso': 'CONSULTA_SALDO_READ', 'route': 'consulta-saldo' },
    { 'recurso': 'AGENDAMENTO_ENTREGA_READ', 'route': 'agendamento-entrega' },
    {
        'recurso': 'AGENDAMENTO_ENTREGA_CREATE',
        'route': 'agendamento-entrega/new'
    },
    {
        'recurso': 'AGENDAMENTO_ENTREGA_UPDATE',
        'route': 'agendamento-entrega/:id'
    },
    {
        'recurso': 'AGENDAMENTO_ENTREGA_READ',
        'route': 'agendamento-entrega/:idView/view'
    },
    { 'recurso': 'CENTRO_CUSTO_READ', 'route': 'centroscusto' },
    { 'recurso': 'CENTRO_CUSTO_CREATE', 'route': 'centroscusto/new' },
    { 'recurso': 'CENTRO_CUSTO_UPDATE', 'route': 'centroscusto/:id' },
    { 'recurso': 'DOCA_ENTREGA_READ', 'route': 'docas-entrega' },
    { 'recurso': 'DOCA_ENTREGA_CREATE', 'route': 'docas-entrega/new' },
    { 'recurso': 'DOCA_ENTREGA_UPDATE', 'route': 'docas-entrega/:id' },
    { 'recurso': 'EMPENHO_BLOQUEADO_READ', 'route': 'empenhos-bloqueado' },
    { 'recurso': 'EMPENHO_BLOQUEADO_CREATE', 'route': 'empenhos-bloqueado/new' },
    { 'recurso': 'EMPENHO_BLOQUEADO_UPDATE', 'route': 'empenhos-bloqueado/:id' },
    { 'recurso': 'EXERCICIO_READ', 'route': 'exercicios' },
    { 'recurso': 'EXERCICIO_CREATE', 'route': 'exercicios/new' },
    { 'recurso': 'EXERCICIO_UPDATE', 'route': 'exercicios/:id' },
    { 'recurso': 'FABRICANTE_READ', 'route': 'fabricantes' },
    { 'recurso': 'FABRICANTE_CREATE', 'route': 'fabricantes/new' },
    { 'recurso': 'FABRICANTE_UPDATE', 'route': 'fabricantes/:id' },
    { 'recurso': 'ITEM_READ', 'route': 'itens' },
    { 'recurso': 'ITEM_CREATE', 'route': 'itens/new' },
    { 'recurso': 'ITEM_UPDATE', 'route': 'itens/:id' },
    { 'recurso': 'MODELO_CLASSIFICACAO_READ', 'route': 'modelos' },
    { 'recurso': 'MODELO_CLASSIFICACAO_CREATE', 'route': 'modelos/new' },
    { 'recurso': 'MODELO_CLASSIFICACAO_UPDATE', 'route': 'modelos/:id' },
    { 'recurso': 'NATUREZA_DESPESA_READ', 'route': 'naturezas-despesa' },
    { 'recurso': 'NATUREZA_DESPESA_CREATE', 'route': 'naturezas-despesa/new' },
    { 'recurso': 'NATUREZA_DESPESA_UPDATE', 'route': 'naturezas-despesa/:id' },
    { 'recurso': 'PALETE_READ', 'route': 'paletes' },
    { 'recurso': 'PALETE_CREATE', 'route': 'paletes/new' },
    { 'recurso': 'PALETE_UPDATE', 'route': 'paletes/:id' },
    { 'recurso': 'TIPO_CENTRO_CUSTO_READ', 'route': 'tipos-centro-custo' },
    { 'recurso': 'TIPO_CENTRO_CUSTO_CREATE', 'route': 'tipos-centro-custo/new' },
    { 'recurso': 'TIPO_CENTRO_CUSTO_UPDATE', 'route': 'tipos-centro-custo/:id' },
    { 'recurso': 'TIPO_ITEM_READ', 'route': 'tipos-itens' },
    { 'recurso': 'TIPO_ITEM_CREATE', 'route': 'tipos-itens/new' },
    { 'recurso': 'TIPO_ITEM_UPDATE', 'route': 'tipos-itens/:id' },
    { 'recurso': 'TIPO_MOVIMENTACAO_READ', 'route': 'tipos-movimento' },
    { 'recurso': 'TIPO_MOVIMENTACAO_CREATE', 'route': 'tipos-movimento/new' },
    { 'recurso': 'TIPO_MOVIMENTACAO_UPDATE', 'route': 'tipos-movimento/:id' },
    { 'recurso': 'UNIDADE_MEDIDA_READ', 'route': 'unidade-medida' },
    { 'recurso': 'UNIDADE_MEDIDA_CREATE', 'route': 'unidade-medida/new' },
    { 'recurso': 'UNIDADE_MEDIDA_UPDATE', 'route': 'unidade-medida/:id' },
    {
        'recurso': 'RELATORIO_BALANCO_REQUISICAO_READ',
        'route': 'relatorio-balanco-requisicao'
    },
    { 'recurso': 'RELATORIO_REQUISICAO_READ', 'route': 'relatorio-requisicao' },
    {
        'recurso': 'RELATORIO_SALDO_REQUISICAO_READ',
        'route': 'relatorio-saldo-requisitar'
    },
    {
        'recurso': 'RELATORIO_ITEM_FORNECEDOR_READ',
        'route': 'consulta-item-fornecedor'
    },
    { 'recurso': 'DEVOLUCAO_READ', 'route': 'devolucoes' },
    { 'recurso': 'DEVOLUCAO_CREATE', 'route': 'devolucoes/new' },
    { 'recurso': 'DEVOLUCAO_UPDATE', 'route': 'devolucoes/:id' },
    { 'recurso': 'MOVIMENTACAO_READ', 'route': 'relatorio-consumo' },
    { 'recurso': 'TRANSFERENCIA_READ', 'route': 'transferencia' },
    { 'recurso': 'TRANSFERENCIA_CREATE', 'route': 'transferencia/new' },
    { 'recurso': 'TRANSFERENCIA_UPDATE', 'route': 'transferencia/:id' },
    { 'recurso': 'TRANSFERENCIA_READ', 'route': 'transferencia/:idView/view' },
    {
        'recurso': 'CONFIGURACAO_PERMISSAO_USUARIO',
        'route': 'permissao/centro-custo/:username'
    },
    { 'recurso': 'CONFIGURACAO_PERMISSAO_USUARIO', 'route': 'permissao' },
    { 'recurso': 'FRACIONAR_ITEM', 'route': 'fraciona-items' },
    { 'recurso': 'RELATORIO_POSICAO_ESTOQUE', 'route': 'posicao-de-estoque' },
    { 'recurso': 'INVENTARIO_READ', 'route': 'inventarios' },
    { 'recurso': 'INVENTARIO_READ', 'route': 'inventarios/:id/view' },
    { 'recurso': 'INVENTARIO_UPDATE', 'route': 'inventarios/:id' },
    { 'recurso': 'INVENTARIO_CREATE', 'route': 'inventarios/new' },
    { 'recurso': 'ROTA_ENTREGA_READ', 'route': 'rotas-entrega' },
    { 'recurso': 'ROTA_ENTREGA_UPDATE', 'route': 'rotas-entrega/:id' },
    { 'recurso': 'ROTA_ENTREGA_CREATE', 'route': 'rotas-entrega/new' },
    { 'recurso': 'PARAMETRO_ITEM', 'route': 'parametro-itens' },
    { 'recurso': 'COMISSAO_READ', 'route': 'comissoes' },
    { 'recurso': 'COMISSAO_UPDATE', 'route': 'comissoes/:id' },
    { 'recurso': 'COMISSAO_CREATE', 'route': 'comissoes/new' },
    { 'recurso': 'FRACIONA_ITENS_READ', 'route': 'fraciona-itens' },
    { 'recurso': 'CLASSIFICACAO_READ', 'route': 'classificacoes' },
    { 'recurso': 'CLASSIFICACAO_UPDATE', 'route': 'classificacoes/:id' },
    { 'recurso': 'CLASSIFICACAO_CREATE', 'route': 'classificacoes/new' },
    { 'recurso': 'REMANEJO_LOTE_READ', 'route': 'remanejo-lotes' },
    { 'recurso': 'CONTROLE_COTA_READ', 'route': 'itens-centro-consumo' },
    { 'recurso': 'CONTROLE_COTA_UPDATE', 'route': 'itens-centro-consumo/:id' },
    { 'recurso': 'CONTROLE_COTA_CREATE', 'route': 'itens-centro-consumo/new' },
    { 'recurso': 'RELATORIO_CONTROLE_COTA', 'route': 'relatorio-consumo-anual' },
    {
        'recurso': 'REENVIAR_MOVIMENTACAO_CUSTOS',
        'route': 'reenviar-movimentacao-saida'
    },
    { 'recurso': 'IMPRESSAO_ETIQUETAS_READ', 'route': 'impressao-etiquetas' },
    {
        'recurso': 'PONTO_PEDIDO_READ',
        'route': 'dashboard-item-ponto-pedido'
    },
    { 'recurso': 'CONSULTA_ALOCADOR', 'route': 'consulta-alocador' },
    { 'recurso': 'CONSULTA_CENTRO_OBJETO', 'route': 'consulta-centro-objeto' },
    { 'recurso': 'OBJETO_CUSTO', 'route': 'objeto-custo' },
    { 'recurso': 'OBJETO_CUSTO_CREATE', 'route': 'objeto-custo/new' },
    { 'recurso': 'OBJETO_CUSTO_UPDATE', 'route': 'objeto-custo/:id' },
    { 'recurso': 'DIVISOR', 'route': 'divisor' },
    { 'recurso': 'DIVISOR_CREATE', 'route': 'divisor/new' },
    { 'recurso': 'DIVISOR_UPDATE', 'route': 'divisor/:id' },
    { 'recurso': 'CUSTOS_CENTRO_CUSTO', 'route': 'centro-custo' },
    { 'recurso': 'VISAO_CUSTO', 'route': 'visao-custo' },
    { 'recurso': 'VISAO_CUSTO', 'route': 'visao-custo/preview/:id/:inicio/:fim' },
    { 'recurso': 'VISAO_CUSTO_CREATE', 'route': 'visao-custo/new' },
    { 'recurso': 'VISAO_CUSTO_UPDATE', 'route': 'visao-custo/:id' },
    { 'recurso': 'ALOCADOR_CUSTO', 'route': 'alocador' },
    { 'recurso': 'ALOCADOR_CUSTO_CREATE', 'route': 'alocador/new' },
    { 'recurso': 'ALOCADOR_CUSTO_UPDATE', 'route': 'alocador/:id' },
    { 'recurso': 'TIPO_CUSTO', 'route': 'tipo-custo' },
    { 'recurso': 'TIPO_CUSTO_CREATE', 'route': 'tipo-custo/new' },
    { 'recurso': 'TIPO_CUSTO_UPDATE', 'route': 'tipo-custo/:id' },
    { 'recurso': 'CUSTOS_UNIDADE_MEDIDA', 'route': 'unidade-medida' },
    { 'recurso': 'CUSTOS_UNIDADE_MEDIDA_CREATE', 'route': 'unidade-medida/new' },
    { 'recurso': 'CUSTOS_UNIDADE_MEDIDA_UPDATE', 'route': 'unidade-medida/:id' },
    { 'recurso': 'DASHBOARD_CUSTOS', 'route': 'dashboard-custos' },
    { 'recurso': 'DASHBOARD_CUSTOS_CREATE', 'route': 'dashboard-custos/new' },
    { 'recurso': 'DASHBOARD_CUSTOS_UPDATE', 'route': 'dashboard-custos/:id' },
    {
        'recurso': 'LANCAMENTO_INTEGRACAO',
        'route': 'lancamento-integracao/:idView/view'
    },
    { 'recurso': 'LANCAMENTO_INTEGRACAO', 'route': 'lancamento-integracao' },
    { 'recurso': 'PPA', 'route': 'ppa' },
    { 'recurso': 'PPA_CREATE', 'route': 'ppa/new' },
    { 'recurso': 'PPA_UPDATE', 'route': 'ppa/:id' },
    { 'recurso': 'VERSAO', 'route': 'versao' },
    { 'recurso': 'VERSAO_CREATE', 'route': 'versao/new' },
    { 'recurso': 'VERSAO_UPDATE', 'route': 'versao/:id' },
    { 'recurso': 'VERSAO_UPDATE', 'route': 'aprovar-versao' },
    { 'recurso': 'EMENDA_PARLAMENTAR', 'route': 'emenda-parlamentar' },
    { 'recurso': 'EMENDA_PARLAMENTAR_CREATE', 'route': 'emenda-parlamentar/new' },
    { 'recurso': 'EMENDA_PARLAMENTAR_UPDATE', 'route': 'emenda-parlamentar/:id' },
    { 'recurso': 'MACRO_OBJETIVO', 'route': 'macro-objetivo' },
    { 'recurso': 'MACRO_OBJETIVO_CREATE', 'route': 'macro-objetivo/new' },
    { 'recurso': 'MACRO_OBJETIVO_UPDATE', 'route': 'macro-objetivo/:id' },
    { 'recurso': 'PUBLICO_ALVO', 'route': 'publico-alvo' },
    { 'recurso': 'PUBLICO_ALVO_CREATE', 'route': 'publico-alvo/new' },
    { 'recurso': 'PUBLICO_ALVO_UPDATE', 'route': 'publico-alvo/:id' },
    { 'recurso': 'CONFIGURACAO_PARAMETRO', 'route': 'configuracao-parametro' },
    {
        'recurso': 'CONFIGURACAO_PARAMETRO_CREATE',
        'route': 'configuracao-parametro/new'
    },
    {
        'recurso': 'CONFIGURACAO_PARAMETRO_UPDATE',
        'route': 'configuracao-parametro/:id'
    },
    { 'recurso': 'RECEITA', 'route': 'receita' },
    { 'recurso': 'RECEITA_CREATE', 'route': 'receita/new' },
    { 'recurso': 'RECEITA_UPDATE', 'route': 'receita/:id' },
    { 'recurso': 'RECEITA_PADRAO_TCE', 'route': 'receita-padrao-tce' },
    { 'recurso': 'RECEITA_PADRAO_TCE_CREATE', 'route': 'receita-padrao-tce/new' },
    { 'recurso': 'RECEITA_PADRAO_TCE_UPDATE', 'route': 'receita-padrao-tce/:id' },
    { 'recurso': 'ESTIMATIVA_RECEITA', 'route': 'estimativa-receita' },
    { 'recurso': 'ESTIMATIVA_RECEITA_CREATE', 'route': 'estimativa-receita' },
    {
        'recurso': 'ESTIMATIVA_RECEITA_UPDATE',
        'route': 'estimativa-receita/edit'
    },
    { 'recurso': 'SUBFUNCAO', 'route': 'subfuncoes' },
    { 'recurso': 'SUBFUNCAO_CREATE', 'route': 'subfuncoes/new' },
    { 'recurso': 'SUBFUNCAO_UPDATE', 'route': 'subfuncoes/:id' },
    { 'recurso': 'FONTE_RECURSO', 'route': 'fonte-recurso' },
    { 'recurso': 'FONTE_RECURSO_CREATE', 'route': 'fonte-recurso/new' },
    { 'recurso': 'FONTE_RECURSO_UPDATE', 'route': 'fonte-recurso/:id' },
    { 'recurso': 'CONFIGURACAO_PARAMETRO', 'route': 'configuracao-parametros' },
    {
        'recurso': 'CONFIGURACAO_PARAMETRO_CREATE',
        'route': 'configuracao-parametros/new'
    },
    {
        'recurso': 'CONFIGURACAO_PARAMETRO_UPDATE',
        'route': 'configuracao-parametros/:id'
    },
    { 'recurso': 'ACOES', 'route': 'acao-detalhada' },
    { 'recurso': 'ACOES_CREATE', 'route': 'acao-detalhada/new' },
    { 'recurso': 'ACOES_UPDATE', 'route': 'acao-detalhada/:id' },
    { 'recurso': 'DESPESA_PADRAO_TCE', 'route': 'despesa-padrao-tce' },
    { 'recurso': 'DESPESA_PADRAO_TCE_CREATE', 'route': 'despesa-padrao-tce/new' },
    { 'recurso': 'DESPESA_PADRAO_TCE_UPDATE', 'route': 'despesa-padrao-tce/:id' },
    { 'recurso': 'DESPESA', 'route': 'despesa' },
    { 'recurso': 'DESPESA_CREATE', 'route': 'despesa/new' },
    { 'recurso': 'DESPESA_UPDATE', 'route': 'despesa/:id' },
    { 'recurso': 'DOTACAO', 'route': 'dotacao' },
    { 'recurso': 'DOTACAO_CREATE', 'route': 'dotacao/new' },
    { 'recurso': 'DOTACAO_UPDATE', 'route': 'dotacao/:id' },
    { 'recurso': 'LDO_VARIAVEL', 'route': 'ldo-variavel' },
    { 'recurso': 'LDO_VARIAVEL_UPDATE', 'route': 'ldo-variavel/:id' },
    { 'recurso': 'LOA_RECEITA', 'route': 'loa-receitas' },
    { 'recurso': 'LOA_RECEITA_CREATE', 'route': 'loa-receitas/:id/edit' },
    { 'recurso': 'LOA_RECEITA_UPDATE', 'route': 'loa-receitas/:id' },
    { 'recurso': 'LOA_VERSAO', 'route': 'loa-versao' },
    { 'recurso': 'LOA_VERSAO_CREATE', 'route': 'loa-versao/new' },
    { 'recurso': 'LOA_VERSAO_UPDATE', 'route': 'loa-versao/:id' },
    { 'recurso': 'LDO_VERSAO', 'route': 'ldo-versao' },
    { 'recurso': 'LDO_VERSAO_CREATE', 'route': 'ldo-versao/new' },
    { 'recurso': 'LDO_VERSAO_UPDATE', 'route': 'ldo-versao/:id' },
    { 'recurso': 'CONSULTA_PPA_DESPESA', 'route': 'consulta-ppa-despesa' },
    { 'recurso': 'CONSULTA_LOA_RECEITA', 'route': 'consulta-loa-receita' },
    { 'recurso': 'CONSULTA_ESTIMATIVA', 'route': 'consulta-estimativa-receita' },
    { 'recurso': 'CONSULTA_DOTACAO', 'route': 'consulta-loa-dotacao' },
    { 'recurso': 'DESPESA_PADRAO_TCE', 'route': 'importar-despesa-padrao' }
];

const BASE_URL = '/';
const REDIRECT_PARAM = 'redirect';
class AuthHttp {
    constructor(httpClient, router, authParams, authResourcesConfig) {
        this.httpClient = httpClient;
        this.router = router;
        this.authParams = authParams;
        this.authResourcesConfig = authResourcesConfig;
        this.lastUrl = BASE_URL;
    }
    login(user) {
        return this.internalLogin(this.authResourcesConfig.urlApi, user);
    }
    x509Login(user) {
        return this.internalLogin(this.authResourcesConfig.urlX509Api, user);
    }
    getUsuarioLogado() {
        const requestParams = {
            resource: this.authResourcesConfig.urlMe,
            fields: this.authResourcesConfig.fieldsMe,
            disableSpinner: true
        };
        if (!this.usuarioLogado) {
            this.usuarioLogado = this.httpClient.get(requestParams)
                .pipe(publishReplay(1), refCount());
        }
        return this.usuarioLogado;
    }
    getX509Token(providerUrl) {
        let originCall = !/https?:\/\/.*/.test(providerUrl);
        const requestParams = {
            resource: originCall ? '/x509-auth-provider/auth' : '/auth',
            location: providerUrl,
            disableSpinner: true,
            requestOrigin: originCall,
        };
        return this.httpClient.get(requestParams);
    }
    goToAuthForm(url) {
        this.setLastUrl();
        if (this.authResourcesConfig.urlForm) {
            if (!this.router.url.startsWith(this.authResourcesConfig.urlForm)) {
                this.router.navigateByUrl(this.authResourcesConfig.urlForm);
            }
        }
        else {
            let urlForm = this.authResourcesConfig.isDev ? `${this.authResourcesConfig.hostDev}/${this.authResourcesConfig.urlFormDefault}` :
                `${window.location.origin}/${this.authResourcesConfig.urlFormDefault}`;
            urlForm += `?${REDIRECT_PARAM}=${url ? url : window.location.href}`;
            this.redirect(urlForm);
        }
    }
    goToLastUrl() {
        const redirectUrl = this.getRedirectUrl();
        if (redirectUrl) {
            this.redirect(redirectUrl);
        }
        else {
            this.router.navigateByUrl(this.lastUrl);
        }
    }
    goToAuthFormIfExists(url) {
        if (this.authResourcesConfig.urlForm) {
            this.goToAuthForm(url);
        }
        else {
            this.logoutAndGoToAuthForm();
        }
    }
    logoutAndGoToAuthForm() {
        this.logout();
        this.goToAuthForm();
        this.setLastUrl(BASE_URL);
    }
    getLastUrl() {
        return this.lastUrl;
    }
    logout() {
        this.usuarioLogado = null;
        this.authParams.logout();
    }
    isLogged() {
        return this.authParams.isLogged();
    }
    isAdmin() {
        return this.getUsuarioLogado().pipe(map(user => {
            return isUserAdmin(user);
        }));
    }
    isAdminUser(usuario) {
        return isUserAdmin(usuario);
    }
    setLastUrl(url) {
        let urlToCompare = url ? url : window.location.pathname;
        if (urlToCompare === this.authResourcesConfig.urlForm) {
            this.lastUrl = BASE_URL;
        }
        else {
            this.lastUrl = urlToCompare.replace(this.getHref(), BASE_URL);
        }
    }
    redirect(url) {
        window.location.href = url;
    }
    getPermissionsByRole(role) {
        return this.getUsuarioLogado().
            pipe(map(user => user.recursos.filter(recurso => recurso.startsWith(role))));
    }
    hasPermissionByRoute(route) {
        if (!route) {
            return of(true);
        }
        const searchRoute = route.startsWith('/') ? route.replace('/', '') : route;
        const permissaoRota = permissions.find(p => p.route === searchRoute);
        return this.getUsuarioLogado().pipe(map(usuario => {
            if (!permissaoRota) {
                return true;
            }
            else if (usuario.recursos) {
                return usuario.recursos.includes(permissaoRota.recurso);
            }
        }));
    }
    getRedirectUrl() {
        return this.router.parseUrl(window.location.search).queryParams[REDIRECT_PARAM];
    }
    getHref() {
        let base = document.getElementsByTagName('base')[0];
        if (base) {
            return base.getAttribute('href');
        }
    }
    setUsuarioInfo(usuarioInfo, useConfig = false) {
        this.authParams.setUsuarioInfo(Object.assign({}, usuarioInfo), useConfig);
    }
    getUsuarioInfo() {
        return this.authParams.getUsuarioInfo();
    }
    internalLogin(urlApi, user) {
        return this.httpClient.post({ resource: urlApi, body: user })
            .pipe(map((response) => {
            this.authParams.setLogged(response.id_token, user.rememberMe);
            return response;
        }));
    }
}
AuthHttp.ɵfac = function AuthHttp_Factory(t) { return new (t || AuthHttp)(ɵngcc0.ɵɵinject(HttpClient), ɵngcc0.ɵɵinject(ɵngcc6.Router), ɵngcc0.ɵɵinject(AuthParams), ɵngcc0.ɵɵinject(AUTH_RESOURCES_CONFIG)); };
AuthHttp.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthHttp, factory: AuthHttp.ɵfac });
AuthHttp.ctorParameters = () => [
    { type: HttpClient },
    { type: Router },
    { type: AuthParams },
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_RESOURCES_CONFIG,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthHttp, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: ɵngcc6.Router }, { type: AuthParams }, { type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_RESOURCES_CONFIG]
            }] }]; }, null); })();

class AuthenticationComponent {
    constructor(_fb, _authHttp, _windowService, activatedRoute) {
        this._fb = _fb;
        this._authHttp = _authHttp;
        this._windowService = _windowService;
        this.activatedRoute = activatedRoute;
        this.showLoginForm = false;
        this.showAccessRecoveryForm = false;
        this.showNewPasswordForm = false;
        this.showRecoveryMessageComponent = false;
        this.placeholder = 'Nome de Usuário';
    }
    ngOnInit() {
        this.resetCode = this.activatedRoute.snapshot.queryParams['reset'];
        if (this.resetCode && this.resetCode.length > 0) {
            this.showNewPasswordComponent();
        }
        else {
            this.showLoginForm = true;
            this.showCaptcha = false;
            this.form = this._fb.group({
                username: ['', Validators.required],
                password: ['', Validators.required],
                tipo: ['USUARIO'],
                captcha: [''],
                rememberMe: [false],
            });
            this.validateUser();
        }
    }
    showLoginComponent() {
        this.showAccessRecoveryForm = false;
        this.showNewPasswordForm = false;
        this.showLoginForm = true;
        this.showCaptcha = false;
        this.form = this._fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            tipo: ['USUARIO'],
            captcha: [''],
            rememberMe: [false],
        });
        this.validateUser();
    }
    showRecuperarAcesso() {
        this.showLoginForm = false;
        this.showNewPasswordForm = false;
        this.showAccessRecoveryForm = true;
        this.form = this._fb.group({
            username: [null, Validators.required],
        });
    }
    showNewPasswordComponent() {
        this.showAccessRecoveryForm = false;
        this.showLoginForm = false;
        this.showNewPasswordForm = true;
        this.form = this._fb.group({
            resetCode: [this.resetCode, Validators.required],
            password: [null, Validators.required],
            confirmPassword: [null, Validators.required],
        });
    }
    onSubmit(user) {
        this.error = '';
        this._authHttp.login(user).subscribe(() => this.handleSuccess(), (e) => this.handleError(e));
    }
    doX509Login() {
        let providerUrl = this.form.get('username').value;
        if (!/https?:\/\/.*/.test(providerUrl)) {
            providerUrl = 'https://auth.iss.elotech.com.br:8443';
        }
        this._authHttp.getX509Token(providerUrl).subscribe((token) => {
            let user = {
                x509Token: token,
            };
            this._authHttp.x509Login(user).subscribe(() => this.handleSuccess(), (e) => this.handleError(e));
        }, (e) => this.handleError(e));
    }
    handleSuccess() {
        this._authHttp.goToLastUrl();
    }
    goCadastro() {
        this._authHttp.redirect(window.location.href.split('/auth')[0] + '/usuario');
    }
    handleError(error) {
        this.error = error.message;
        if (error.status === 401) {
            this.error = 'Usuário ou senha incorretos.';
            if (this.showCaptcha) {
                this.form.get('captcha').reset();
            }
        }
        else if (error.status === 418) {
            this.showCaptcha = true;
        }
        else if (error.status === 500) {
            this.error = 'Usuário ou senha incorretos.';
        }
        else {
            throw error;
        }
    }
    accessRecovery(object) {
        this.authenticationService.passwordRecovery(object).subscribe(() => {
            this.showDialogWithMessage('Enviamos um e-mail com as instruções para criar uma nova senha.', 'login');
        }, (error) => {
            this.showDialogWithMessage(error.message, 'recovery');
        });
    }
    saveNewPassword(object) {
        this.authenticationService.resetPassword(object).subscribe(() => {
            this.showDialogWithMessage('Senha alterada com sucesso', 'login');
        }, (error) => {
            this.showDialogWithMessage(error.message, 'new-password');
        });
    }
    showDialogWithMessage(message, showComponentAfterOk) {
        this.showRecoveryMessageComponent = true;
        this.showLoginForm = false;
        this.showAccessRecoveryForm = false;
        this.showNewPasswordForm = false;
        this.recovery = {
            message: message,
            showComponentAfterOk: showComponentAfterOk,
        };
    }
    recoveryOk(showComponentAfterOk) {
        this.showRecoveryMessageComponent = false;
        switch (showComponentAfterOk) {
            case 'recovery':
                this.showRecuperarAcesso();
                break;
            case 'new-password':
                this.showNewPasswordComponent();
                break;
            default:
                this.showLoginComponent();
                break;
        }
    }
    isFormValid() {
        if (!this.showCaptcha) {
            return true;
        }
        return this.form.get('captcha').value !== '';
    }
    hasX509Auth() {
        return this.x509Auth && this._windowService.usingSSL();
    }
    validateUser() {
        if (this._authHttp.isLogged()) {
            this._authHttp.isAdmin().subscribe((admin) => (this.isAdmin = admin), () => this._authHttp.logout());
        }
    }
}
AuthenticationComponent.ɵfac = function AuthenticationComponent_Factory(t) { return new (t || AuthenticationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(AuthHttp), ɵngcc0.ɵɵdirectiveInject(WindowService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ActivatedRoute)); };
AuthenticationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthenticationComponent, selectors: [["user-authentication"]], inputs: { placeholder: "placeholder", showCaptcha: "showCaptcha", urlBrasao: "urlBrasao", entidadeCidade: "entidadeCidade", inputRecoveryPlaceholder: "inputRecoveryPlaceholder", authenticationService: "authenticationService", x509Auth: "x509Auth" }, decls: 18, vars: 6, consts: [[1, "login", "modal", "open"], [1, "login-outer"], [1, "login-inner"], [1, "login-box"], [1, "login-header"], [3, "src"], ["onerror", "this.style.display='none'", "src", "img/common/login_logo.jpg"], ["src", "img/common/logo_oxy_login.png", "alt", "Logo Oxy Login"], [1, "login-city-name", "typography-size-20px", "typography-medium"], [4, "ngIf"], [1, "login-box-footer"], ["src", "img/common/logo-footer-new.png", "alt", "Logo Tecnologia Elotech"], [1, "login-form", 3, "formGroup", "ngSubmit"], [1, "login-form-group"], ["class", "error-message mb-xs", 4, "ngIf"], ["id", "user", "type", "text", "formControlName", "username", 3, "ngClass", "placeholder"], ["id", "password", "type", "password", "placeholder", "Senha", "formControlName", "password", 3, "ngClass"], ["id", "select-filter", "name", "select-filter", "formControlName", "tipo"], ["selected", "", 3, "value"], [3, "value"], ["id", "btn-login", 1, "send-btn"], [1, "login-form-list"], ["href", "javascript:void(0)", 3, "click", 4, "ngIf"], ["id", "recovery-password", "href", "javascript:void(0)", 3, "click", 4, "ngIf"], ["type", "checkbox", "id", "rememberme", "formControlName", "rememberMe", 1, "input-checkbox"], ["for", "rememberme"], [1, "error-message", "mb-xs"], [1, "fa", "fa-times-circle", "icon"], ["id", "captcha", "formControlName", "captcha"], ["href", "javascript:void(0)", 3, "click"], ["id", "recovery-password", "href", "javascript:void(0)", 3, "click"], [1, "divider"], ["id", "x509Login", "type", "button", 1, "certificado", 3, "click"], [1, "fa", "fa-lock"], [3, "placeholder", "form", "onRecovery", "onBack"], [3, "form", "onSave", "onBack"], [3, "recovery", "onClick"]], template: function AuthenticationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "section", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "header", 4);
        ɵngcc0.ɵɵelementStart(5, "figure");
        ɵngcc0.ɵɵelement(6, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "figure");
        ɵngcc0.ɵɵelement(8, "img", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(9, "img", 7);
        ɵngcc0.ɵɵelementStart(10, "h2", 8);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, AuthenticationComponent_div_12_Template, 24, 13, "div", 9);
        ɵngcc0.ɵɵtemplate(13, AuthenticationComponent_div_13_Template, 2, 2, "div", 9);
        ɵngcc0.ɵɵtemplate(14, AuthenticationComponent_div_14_Template, 2, 1, "div", 9);
        ɵngcc0.ɵɵtemplate(15, AuthenticationComponent_div_15_Template, 2, 1, "div", 9);
        ɵngcc0.ɵɵelementStart(16, "footer", 10);
        ɵngcc0.ɵɵelement(17, "img", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.urlBrasao, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.entidadeCidade == null ? null : ctx.entidadeCidade.cidade == null ? null : ctx.entidadeCidade.cidade.descricao, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLoginForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showAccessRecoveryForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNewPasswordForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRecoveryMessageComponent);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgClass, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc3.CheckboxControlValueAccessor, ɵngcc7.RecaptchaComponent, ɵngcc7.RecaptchaValueAccessorDirective, AccessRecoveryComponent, NewPasswordComponent, RecoveryMessageComponent]; }, encapsulation: 2 });
AuthenticationComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: AuthHttp },
    { type: WindowService },
    { type: ActivatedRoute }
];
AuthenticationComponent.propDecorators = {
    urlBrasao: [{ type: Input }],
    entidadeCidade: [{ type: Input }],
    inputRecoveryPlaceholder: [{ type: Input }],
    authenticationService: [{ type: Input }],
    showCaptcha: [{ type: Input }],
    x509Auth: [{ type: Input }],
    placeholder: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationComponent, [{
        type: Component,
        args: [{
                selector: 'user-authentication',
                template: "<section class=\"login modal open\">\n  <div class=\"login-outer\">\n    <div class=\"login-inner\">\n      <div class=\"login-box\">\n        <header class=\"login-header\">\n          <figure>\n            <img src=\"{{ urlBrasao }}\" />\n          </figure>\n\n          <figure>\n            <img\n              onerror=\"this.style.display='none'\"\n              src=\"img/common/login_logo.jpg\"\n            />\n          </figure>\n\n          <img src=\"img/common/logo_oxy_login.png\" alt=\"Logo Oxy Login\" />\n          <h2 class=\"login-city-name typography-size-20px typography-medium\">\n            {{ entidadeCidade?.cidade?.descricao }}\n          </h2>\n        </header>\n\n        <div *ngIf=\"showLoginForm\">\n          <form\n            class=\"login-form\"\n            [formGroup]=\"form\"\n            (ngSubmit)=\"onSubmit(form.value)\"\n          >\n            <div class=\"login-form-group\">\n              <div class=\"error-message mb-xs\" *ngIf=\"error\">\n                <i class=\"fa fa-times-circle icon\"></i>\n                {{ error }}\n              </div>\n\n              <input\n                id=\"user\"\n                type=\"text\"\n                [ngClass]=\"error ? 'error user' : 'user'\"\n                [placeholder]=\"placeholder\"\n                formControlName=\"username\"\n              />\n              <input\n                id=\"password\"\n                type=\"password\"\n                [ngClass]=\"error ? 'error password' : 'password'\"\n                placeholder=\"Senha\"\n                formControlName=\"password\"\n              />\n              <select\n                id=\"select-filter\"\n                name=\"select-filter\"\n                formControlName=\"tipo\"\n              >\n                <option selected [value]=\"'USUARIO'\">Usu\u00E1rio</option>\n                <option [value]=\"'ELOTECH'\">Elotech</option>\n              </select>\n              `\n              <div *ngIf=\"showCaptcha\">\n                <re-captcha id=\"captcha\" formControlName=\"captcha\"></re-captcha>\n              </div>\n\n              <div>\n                <button\n                  id=\"btn-login\"\n                  class=\"send-btn\"\n                  [class.disabled]=\"!isFormValid()\"\n                >\n                  Entrar\n                </button>\n              </div>\n\n              <div class=\"login-form-list\">\n                <a\n                  (click)=\"goCadastro()\"\n                  href=\"javascript:void(0)\"\n                  *ngIf=\"authenticationService\"\n                >\n                  Crie sua conta\n                </a>\n\n                <a\n                  id=\"recovery-password\"\n                  href=\"javascript:void(0)\"\n                  (click)=\"showRecuperarAcesso()\"\n                  *ngIf=\"authenticationService\"\n                >\n                  Esqueceu sua senha?\n                </a>\n              </div>\n\n              <div class=\"login-form-list\">\n                <input\n                  type=\"checkbox\"\n                  class=\"input-checkbox\"\n                  id=\"rememberme\"\n                  formControlName=\"rememberMe\"\n                />\n                <label for=\"rememberme\">Continuar conectado</label>\n              </div>\n\n              <div *ngIf=\"hasX509Auth()\">\n                <p class=\"divider\">ou conecte-se com</p>\n                <button\n                  id=\"x509Login\"\n                  type=\"button\"\n                  class=\"certificado\"\n                  (click)=\"doX509Login()\"\n                >\n                  <i class=\"fa fa-lock\"></i>\n                  Certificado\n                </button>\n              </div>\n            </div>\n          </form>\n        </div>\n\n        <div *ngIf=\"showAccessRecoveryForm\">\n          <access-recovery\n            [placeholder]=\"inputRecoveryPlaceholder\"\n            [form]=\"form\"\n            (onRecovery)=\"accessRecovery($event)\"\n            (onBack)=\"showLoginComponent()\"\n          ></access-recovery>\n        </div>\n\n        <div *ngIf=\"showNewPasswordForm\">\n          <new-password\n            [form]=\"form\"\n            (onSave)=\"saveNewPassword($event)\"\n            (onBack)=\"showLoginComponent()\"\n          ></new-password>\n        </div>\n\n        <div *ngIf=\"showRecoveryMessageComponent\">\n          <recovery-message\n            [recovery]=\"recovery\"\n            (onClick)=\"recoveryOk($event)\"\n          ></recovery-message>\n        </div>\n\n        <footer class=\"login-box-footer\">\n          <img\n            src=\"img/common/logo-footer-new.png\"\n            alt=\"Logo Tecnologia Elotech\"\n          />\n        </footer>\n      </div>\n    </div>\n  </div>\n</section>\n"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: AuthHttp }, { type: WindowService }, { type: ɵngcc6.ActivatedRoute }]; }, { placeholder: [{
            type: Input
        }], showCaptcha: [{
            type: Input
        }], urlBrasao: [{
            type: Input
        }], entidadeCidade: [{
            type: Input
        }], inputRecoveryPlaceholder: [{
            type: Input
        }], authenticationService: [{
            type: Input
        }], x509Auth: [{
            type: Input
        }] }); })();

class AccessRecoveryComponent {
    constructor() {
        this.placeholder = 'Nome de Usuário';
        this.onRecovery = new EventEmitter();
        this.onBack = new EventEmitter();
    }
    recovery() {
        this.onRecovery.emit(this.form.getRawValue());
    }
    back() {
        this.onBack.emit();
    }
}
AccessRecoveryComponent.ɵfac = function AccessRecoveryComponent_Factory(t) { return new (t || AccessRecoveryComponent)(); };
AccessRecoveryComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccessRecoveryComponent, selectors: [["access-recovery"]], inputs: { placeholder: "placeholder", form: "form" }, outputs: { onRecovery: "onRecovery", onBack: "onBack" }, decls: 8, vars: 3, consts: [[1, "login-form", 3, "formGroup"], [1, "login-form-group"], ["id", "user", "type", "text", "formControlName", "username", 1, "user", 3, "placeholder"], ["id", "btnRecovery", 1, "btn", "send-btn", 3, "disabled", "click"], [1, "login-form-list"], ["id", "btnBack", "href", "javascript:void(0)", 3, "click"]], template: function AccessRecoveryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "input", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function AccessRecoveryComponent_Template_button_click_3_listener() { return ctx.recovery(); });
        ɵngcc0.ɵɵtext(4, " Recuperar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "a", 5);
        ɵngcc0.ɵɵlistener("click", function AccessRecoveryComponent_Template_a_click_6_listener() { return ctx.back(); });
        ɵngcc0.ɵɵtext(7, " Voltar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.form.invalid);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
AccessRecoveryComponent.propDecorators = {
    form: [{ type: Input }],
    placeholder: [{ type: Input }],
    onRecovery: [{ type: Output }],
    onBack: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessRecoveryComponent, [{
        type: Component,
        args: [{
                selector: 'access-recovery',
                template: "<form class=\"login-form\" [formGroup]=\"form\">\n\n  <div class=\"login-form-group\">\n\n    <input id=\"user\" class=\"user\" type=\"text\" [placeholder]=\"placeholder\" formControlName=\"username\">\n\n    <button id=\"btnRecovery\" class=\"btn send-btn\"\n            [disabled]=\"form.invalid\"\n            (click)=\"recovery()\">\n      Recuperar\n    </button>\n\n  </div>\n\n  <div class=\"login-form-list\">\n    <a id=\"btnBack\" href=\"javascript:void(0)\" (click)=\"back()\">\n      Voltar\n    </a>\n  </div>\n\n</form>\n"
            }]
    }], function () { return []; }, { placeholder: [{
            type: Input
        }], onRecovery: [{
            type: Output
        }], onBack: [{
            type: Output
        }], form: [{
            type: Input
        }] }); })();

class NewPasswordComponent {
    constructor() {
        this.onSave = new EventEmitter();
        this.onBack = new EventEmitter();
    }
    save() {
        this.onSave.emit(this.form.getRawValue());
    }
    back() {
        this.onBack.emit();
    }
}
NewPasswordComponent.ɵfac = function NewPasswordComponent_Factory(t) { return new (t || NewPasswordComponent)(); };
NewPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NewPasswordComponent, selectors: [["new-password"]], inputs: { form: "form" }, outputs: { onSave: "onSave", onBack: "onBack" }, decls: 15, vars: 2, consts: [[1, "login-form", 3, "formGroup"], [1, "login-form-group"], [1, "form-group"], ["for", "password", 1, "label"], ["id", "password", "type", "password", "formControlName", "password", 1, "password"], ["for", "confirm-password", 1, "label"], ["id", "confirm-password", "type", "password", "formControlName", "confirmPassword", 1, "password"], ["id", "btnSaveNewPassword", 1, "btn", "send-btn", 3, "disabled", "click"], [1, "login-form-list"], ["href", "javascript:void(0)", 3, "click"]], template: function NewPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtext(4, "Nova Senha");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "input", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 2);
        ɵngcc0.ɵɵelementStart(7, "label", 5);
        ɵngcc0.ɵɵtext(8, "Confirmar Senha");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(9, "input", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 7);
        ɵngcc0.ɵɵlistener("click", function NewPasswordComponent_Template_button_click_10_listener() { return ctx.save(); });
        ɵngcc0.ɵɵtext(11, " Salvar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵelementStart(13, "a", 9);
        ɵngcc0.ɵɵlistener("click", function NewPasswordComponent_Template_a_click_13_listener() { return ctx.back(); });
        ɵngcc0.ɵɵtext(14, " Ir para login ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("disabled", ctx.form.invalid);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
NewPasswordComponent.propDecorators = {
    form: [{ type: Input }],
    onSave: [{ type: Output }],
    onBack: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NewPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'new-password',
                template: "<form class=\"login-form\" [formGroup]=\"form\">\n\n  <div class=\"login-form-group\">\n\n    <div class=\"form-group\">\n      <label for=\"password\" class=\"label\">Nova Senha</label>\n      <input id=\"password\" class=\"password\" type=\"password\" formControlName=\"password\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"confirm-password\" class=\"label\">Confirmar Senha</label>\n      <input id=\"confirm-password\" class=\"password\" type=\"password\" formControlName=\"confirmPassword\">\n    </div>\n\n    <button id=\"btnSaveNewPassword\" class=\"btn send-btn\" [disabled]=\"form.invalid\" (click)=\"save()\">\n      Salvar\n    </button>\n\n  </div>\n\n  <div class=\"login-form-list\">\n    <a href=\"javascript:void(0)\" (click)=\"back()\">\n      Ir para login\n    </a>\n  </div>\n\n</form>\n"
            }]
    }], function () { return []; }, { onSave: [{
            type: Output
        }], onBack: [{
            type: Output
        }], form: [{
            type: Input
        }] }); })();

class RecoveryMessageComponent {
    constructor() {
        this.onClick = new EventEmitter();
    }
    click() {
        this.onClick.emit(this.recovery.showComponentAfterOk);
    }
}
RecoveryMessageComponent.ɵfac = function RecoveryMessageComponent_Factory(t) { return new (t || RecoveryMessageComponent)(); };
RecoveryMessageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RecoveryMessageComponent, selectors: [["recovery-message"]], inputs: { recovery: "recovery" }, outputs: { onClick: "onClick" }, decls: 6, vars: 1, consts: [[1, "login-form"], [1, "login-form-group"], ["id", "btnRecoveryMessageOk", 1, "btn", "send-btn", 3, "click"]], template: function RecoveryMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "p");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵlistener("click", function RecoveryMessageComponent_Template_button_click_4_listener() { return ctx.click(); });
        ɵngcc0.ɵɵtext(5, " Ok ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.recovery.message);
    } }, encapsulation: 2 });
RecoveryMessageComponent.propDecorators = {
    recovery: [{ type: Input }],
    onClick: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RecoveryMessageComponent, [{
        type: Component,
        args: [{
                selector: 'recovery-message',
                template: "<div class=\"login-form\">\n\n  <div class=\"login-form-group\">\n\n    <p>{{recovery.message}}</p>\n\n    <button id=\"btnRecoveryMessageOk\" class=\"btn send-btn\" (click)=\"click()\">\n      Ok\n    </button>\n  </div>\n\n</div>\n"
            }]
    }], function () { return []; }, { onClick: [{
            type: Output
        }], recovery: [{
            type: Input
        }] }); })();

const ɵ0 = {
    siteKey: '6Lf0QX8UAAAAAKji3EmHWAa1qYdGd9_Mr_Pavi5O',
};
class AuthenticationModule {
}
AuthenticationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuthenticationModule });
AuthenticationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AuthenticationModule_Factory(t) { return new (t || AuthenticationModule)(); }, providers: [
        WindowService,
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: ɵ0
        },
    ], imports: [[CommonModule$1, FormsModule, ReactiveFormsModule, RecaptchaModule,
            RecaptchaFormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthenticationModule, { declarations: function () { return [AuthenticationComponent, AccessRecoveryComponent, NewPasswordComponent, RecoveryMessageComponent]; }, imports: function () { return [CommonModule$1, FormsModule, ReactiveFormsModule, RecaptchaModule,
        RecaptchaFormsModule]; }, exports: function () { return [AuthenticationComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, FormsModule, ReactiveFormsModule, RecaptchaModule,
                    RecaptchaFormsModule],
                declarations: [AuthenticationComponent, AccessRecoveryComponent, NewPasswordComponent,
                    RecoveryMessageComponent],
                exports: [AuthenticationComponent],
                providers: [
                    WindowService,
                    {
                        provide: RECAPTCHA_SETTINGS,
                        useValue: ɵ0
                    },
                ]
            }]
    }], null, null); })();

class CanDeactivateGuard {
    constructor() {
        this.eventEmitter = new EventEmitter();
    }
    canDeactivate(component) {
        if (component.form && component.form.dirty) {
            const subject = new Subject();
            this.eventEmitter.next(subject);
            return subject.asObservable();
        }
        return of(true);
    }
    getEventEmitter() {
        return this.eventEmitter;
    }
}
CanDeactivateGuard.ɵfac = function CanDeactivateGuard_Factory(t) { return new (t || CanDeactivateGuard)(); };
CanDeactivateGuard.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CanDeactivateGuard, factory: CanDeactivateGuard.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CanDeactivateGuard, [{
        type: Injectable
    }], function () { return []; }, null); })();

class BackConfirmComponent {
    constructor(_canDeactivateGuard) {
        this._canDeactivateGuard = _canDeactivateGuard;
        this.showBackConfirm = false;
        this.handleCanDeactivateSubject = new Subject();
    }
    ngOnInit() {
        this.handleCanDeactivateRoute();
    }
    handleCanDeactivateRoute() {
        this._canDeactivateGuard.getEventEmitter().subscribe((subject) => {
            this.showBackConfirm = true;
            this.handleCanDeactivateSubject = subject;
        });
    }
    allowRouteChange() {
        this.showBackConfirm = false;
        this.handleCanDeactivateSubject.next(true);
    }
    cancelBackConfirm() {
        this.showBackConfirm = false;
        this.handleCanDeactivateSubject.next(false);
    }
}
BackConfirmComponent.ɵfac = function BackConfirmComponent_Factory(t) { return new (t || BackConfirmComponent)(ɵngcc0.ɵɵdirectiveInject(CanDeactivateGuard)); };
BackConfirmComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BackConfirmComponent, selectors: [["back-confirm-component"]], decls: 2, vars: 1, consts: [[3, "show", "onOkEvent", "onCancelEvent"]], template: function BackConfirmComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "elo-dialog", 0);
        ɵngcc0.ɵɵlistener("onOkEvent", function BackConfirmComponent_Template_elo_dialog_onOkEvent_0_listener() { return ctx.allowRouteChange(); })("onCancelEvent", function BackConfirmComponent_Template_elo_dialog_onCancelEvent_0_listener() { return ctx.cancelBackConfirm(); });
        ɵngcc0.ɵɵtext(1, " Os dados n\u00E3o salvos ser\u00E3o perdidos. Continuar?\n");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("show", ctx.showBackConfirm);
    } }, directives: [DialogComponent], encapsulation: 2 });
BackConfirmComponent.ctorParameters = () => [
    { type: CanDeactivateGuard }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BackConfirmComponent, [{
        type: Component,
        args: [{
                selector: 'back-confirm-component',
                template: "<elo-dialog [show]=\"showBackConfirm\" (onOkEvent)=\"allowRouteChange()\" (onCancelEvent)=\"cancelBackConfirm()\">\n  Os dados n\u00E3o salvos ser\u00E3o perdidos. Continuar?\n</elo-dialog>\n"
            }]
    }], function () { return [{ type: CanDeactivateGuard }]; }, null); })();

class BackConfirmModule {
}
BackConfirmModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BackConfirmModule });
BackConfirmModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BackConfirmModule_Factory(t) { return new (t || BackConfirmModule)(); }, providers: [
        CanDeactivateGuard
    ], imports: [[
            DialogModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BackConfirmModule, { declarations: [BackConfirmComponent], imports: [DialogModule], exports: [BackConfirmComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BackConfirmModule, [{
        type: NgModule,
        args: [{
                imports: [
                    DialogModule
                ],
                declarations: [
                    BackConfirmComponent
                ],
                providers: [
                    CanDeactivateGuard
                ],
                exports: [
                    BackConfirmComponent
                ]
            }]
    }], null, null); })();

class BlobPopupExecutorFactory {
}

class BlobPopupService {
    constructor(blobPopupExecutorFactory) {
        this.blobPopupExecutorFactory = blobPopupExecutorFactory;
        this.paramsCache = new Map();
    }
    encodeParams(params) {
        let strParams = JSON.stringify(params);
        if (!this.paramsCache.has(strParams)) {
            let b64 = AES.encrypt(strParams, this.buildEncodePassword()).toString();
            let e64 = enc.Base64.parse(b64);
            this.paramsCache.set(strParams, e64.toString(enc.Hex));
        }
        return this.paramsCache.get(strParams);
    }
    decodeParams(encodedParams) {
        let reb64 = enc.Hex.parse(encodedParams);
        let bytes = reb64.toString(enc.Base64);
        let strParams = AES.decrypt(bytes, this.buildEncodePassword()).toString(enc.Utf8);
        return JSON.parse(strParams);
    }
    execute(routeSnapshot) {
        return new Observable(observer => {
            let executor = this.blobPopupExecutorFactory.getExecutorById(routeSnapshot.params['executor']);
            if (!executor) {
                observer.next('/page-not-found');
                return;
            }
            let params = this.loadParams(routeSnapshot, executor.requireEncodedParams).then(params => {
                executor.execute(params).subscribe(blob => observer.next(blob));
            }).catch(error => {
                observer.next('/page-blocked');
            });
        });
    }
    buildEncodePassword() {
        return '3l0tech#';
    }
    loadParams(routeSnapshot, requireEncodecParams) {
        return new Promise((resolve, reject) => {
            let encodedParams = routeSnapshot.params['params'];
            if (encodedParams) {
                resolve(this.decodeParams(encodedParams));
            }
            else if (requireEncodecParams) {
                reject('Encoded params required.');
            }
            resolve(routeSnapshot.queryParams);
        });
    }
}
BlobPopupService.ɵfac = function BlobPopupService_Factory(t) { return new (t || BlobPopupService)(ɵngcc0.ɵɵinject(BlobPopupExecutorFactory)); };
BlobPopupService.ɵprov = ɵɵdefineInjectable({ factory: function BlobPopupService_Factory() { return new BlobPopupService(ɵɵinject(BlobPopupExecutorFactory)); }, token: BlobPopupService, providedIn: "root" });
BlobPopupService.ctorParameters = () => [
    { type: BlobPopupExecutorFactory }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlobPopupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: BlobPopupExecutorFactory }]; }, null); })();

class BlobPopupComponent {
    constructor(_route, service) {
        this._route = _route;
        this.service = service;
        this.showDiv = true;
    }
    ngOnInit() {
        this.service.execute(this._route.snapshot).subscribe(blob => {
            this.showDiv = false;
            document.querySelector('iframe').src = blob;
        });
    }
}
BlobPopupComponent.ɵfac = function BlobPopupComponent_Factory(t) { return new (t || BlobPopupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(BlobPopupService)); };
BlobPopupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlobPopupComponent, selectors: [["elo-blob-popup"]], decls: 3, vars: 1, consts: [["class", "blob content-loader spin", 4, "ngIf"], [1, "container-white"], ["src", "", "type", "application/pdf", "id", "iframe", "width", "100%", "height", "100%", 1, "container-fill"], [1, "blob", "content-loader", "spin"], [1, "content-loader-inner"], [1, "item-a"], [1, "item-b"]], template: function BlobPopupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BlobPopupComponent_div_0_Template, 6, 0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "iframe", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDiv);
    } }, directives: [ɵngcc2.NgIf], styles: [".container-white[_ngcontent-%COMP%]{background:#fff;bottom:0;height:100%;left:0;margin:auto;overflow:show;position:fixed;right:0;top:0;width:100%;z-index:999998}.container-fill[_ngcontent-%COMP%]{height:100%;overflow:auto;width:100%}"] });
BlobPopupComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: BlobPopupService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlobPopupComponent, [{
        type: Component,
        args: [{
                selector: 'elo-blob-popup',
                template: "<div *ngIf=\"showDiv\" class=\"blob content-loader spin\">\n  <div class=\"content-loader-inner\">\n    <div class=\"item-a\"></div>\n    <div class=\"item-b\"></div>\n  </div>\n  <h4>Carregando...</h4>\n</div>\n\n<div class=\"container-white\">\n  <iframe src=\"\" type=\"application/pdf\" id=\"iframe\" width=\"100%\" height=\"100%\"\n  class=\"container-fill\">\n  </iframe>\n</div>\n",
                styles: [".container-white{background:#fff;bottom:0;height:100%;left:0;margin:auto;overflow:show;position:fixed;right:0;top:0;width:100%;z-index:999998}.container-fill{height:100%;overflow:auto;width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc6.ActivatedRoute }, { type: BlobPopupService }]; }, null); })();

class BlobPopupModule {
}
BlobPopupModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BlobPopupModule });
BlobPopupModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BlobPopupModule_Factory(t) { return new (t || BlobPopupModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BlobPopupModule, { declarations: function () { return [BlobPopupComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [BlobPopupComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlobPopupModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [BlobPopupComponent],
                exports: [BlobPopupComponent]
            }]
    }], null, null); })();

class BlockContentComponent {
    constructor() {
        this.valid = true;
        this.active = false;
    }
}
BlockContentComponent.ɵfac = function BlockContentComponent_Factory(t) { return new (t || BlockContentComponent)(); };
BlockContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlockContentComponent, selectors: [["elo-block-content"]], inputs: { valid: "valid", active: "active", title: "title", message: "message" }, ngContentSelectors: _c0, decls: 9, vars: 6, consts: [[3, "ngClass"], [1, "col-sm-2"], [1, "message-area"], [1, "col-sm-6"], [1, "title"], [1, "content"]], template: function BlockContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c30, ctx.active, !ctx.valid));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
    } }, directives: [ɵngcc2.NgClass], encapsulation: 2 });
BlockContentComponent.propDecorators = {
    title: [{ type: Input }],
    valid: [{ type: Input }],
    active: [{ type: Input }],
    message: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlockContentComponent, [{
        type: Component,
        args: [{
                selector: 'elo-block-content',
                template: "<div [ngClass]=\"{'row block-content': true, 'active': active, 'error': !valid}\">\n    <div class=\"col-sm-2\">\n        <div class=\"message-area\">{{message}}</div>\n    </div>\n    <div class=\"col-sm-6\">\n        <div class=\"title\">\n            {{title}}\n        </div>\n        <div class=\"content\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return []; }, { valid: [{
            type: Input
        }], active: [{
            type: Input
        }], title: [{
            type: Input
        }], message: [{
            type: Input
        }] }); })();

class BlockContentModule {
}
BlockContentModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BlockContentModule });
BlockContentModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BlockContentModule_Factory(t) { return new (t || BlockContentModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BlockContentModule, { declarations: function () { return [BlockContentComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [BlockContentComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlockContentModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [BlockContentComponent],
                declarations: [BlockContentComponent]
            }]
    }], null, null); })();

class BreadcrumbModule {
}
BreadcrumbModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BreadcrumbModule });
BreadcrumbModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BreadcrumbModule_Factory(t) { return new (t || BreadcrumbModule)(); }, providers: [NavigateUtils], imports: [[CommonModule$1, RouterModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BreadcrumbModule, { declarations: function () { return [BreadcrumbComponent]; }, imports: function () { return [CommonModule$1, RouterModule]; }, exports: function () { return [BreadcrumbComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, RouterModule],
                providers: [NavigateUtils],
                exports: [BreadcrumbComponent],
                declarations: [BreadcrumbComponent]
            }]
    }], null, null); })();

class DatePickerModule {
}
DatePickerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DatePickerModule });
DatePickerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DatePickerModule_Factory(t) { return new (t || DatePickerModule)(); }, imports: [[FormsModule, CalendarModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DatePickerModule, { declarations: function () { return [DatePickerComponent]; }, imports: function () { return [FormsModule, CalendarModule]; }, exports: function () { return [DatePickerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DatePickerModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, CalendarModule],
                declarations: [DatePickerComponent],
                exports: [DatePickerComponent]
            }]
    }], null, null); })();

class ChipComponent {
    constructor() {
        this.isCenter = true;
        this.iconPosition = 'left';
        this.chipIcon = '';
    }
    center() {
        return this.isCenter ? ' center' : '';
    }
}
ChipComponent.ɵfac = function ChipComponent_Factory(t) { return new (t || ChipComponent)(); };
ChipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChipComponent, selectors: [["chip-component"]], inputs: { isCenter: "isCenter", iconPosition: "iconPosition", chipIcon: "chipIcon", col: "col", text: "text", className: "className" }, decls: 5, vars: 11, consts: [[1, "chip-text"]], template: function ChipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelement(2, "span");
        ɵngcc0.ɵɵelementStart(3, "p", 0);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("col-md-", ctx.col, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("chip-container ", ctx.className + ctx.center(), " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate2("", ctx.chipIcon, " chip-icon-", ctx.iconPosition, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.text);
    } }, encapsulation: 2 });
ChipComponent.propDecorators = {
    col: [{ type: Input }],
    text: [{ type: Input }],
    className: [{ type: Input }],
    isCenter: [{ type: Input }],
    iconPosition: [{ type: Input }],
    chipIcon: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChipComponent, [{
        type: Component,
        args: [{
                selector: 'chip-component',
                template: `
    <div class="col-md-{{col}}">
      <div class="chip-container {{className + center()}} ">
        <span class="{{chipIcon}} chip-icon-{{iconPosition}}"></span>
        <p class="chip-text">{{text}}</p>
      </div>
    </div>
  `
            }]
    }], function () { return []; }, { isCenter: [{
            type: Input
        }], iconPosition: [{
            type: Input
        }], chipIcon: [{
            type: Input
        }], col: [{
            type: Input
        }], text: [{
            type: Input
        }], className: [{
            type: Input
        }] }); })();

class ChipModule {
}
ChipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ChipModule });
ChipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ChipModule_Factory(t) { return new (t || ChipModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ChipModule, { declarations: [ChipComponent], exports: [ChipComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChipModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ChipComponent,
                ],
                exports: [
                    ChipComponent
                ]
            }]
    }], null, null); })();

class CrudButtonsComponent {
    constructor() {
        this.backEventEmitter = new EventEmitter();
    }
    back() {
        this.backEventEmitter.emit();
    }
}
CrudButtonsComponent.ɵfac = function CrudButtonsComponent_Factory(t) { return new (t || CrudButtonsComponent)(); };
CrudButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudButtonsComponent, selectors: [["crud-buttons-component"]], inputs: { form: "form" }, outputs: { backEventEmitter: "backEventEmitter" }, decls: 3, vars: 1, consts: [["id", "buttons", 1, "btn-save"], ["id", "save", 1, "btn", "positive", 3, "disabled"], ["id", "back", "type", "button", 1, "btn", "other", "fa", "fa-chevron-left", 3, "click"]], template: function CrudButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "button", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function CrudButtonsComponent_Template_button_click_2_listener() { return ctx.back(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !ctx.form.valid || ctx.form.pristine);
    } }, encapsulation: 2 });
CrudButtonsComponent.propDecorators = {
    backEventEmitter: [{ type: Output }],
    form: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'crud-buttons-component',
                template: "<div id=\"buttons\" class=\"btn-save\">\n  <button id=\"save\" class=\"btn positive\" [disabled]=\"!form.valid || form.pristine\"></button>\n\n  <button id=\"back\" class=\"btn other fa fa-chevron-left\" type=\"button\" (click)=\"back()\">\n  </button>\n</div>\n"
            }]
    }], function () { return []; }, { backEventEmitter: [{
            type: Output
        }], form: [{
            type: Input
        }] }); })();

class CrudButtonsModule {
}
CrudButtonsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudButtonsModule });
CrudButtonsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudButtonsModule_Factory(t) { return new (t || CrudButtonsModule)(); }, imports: [[
            DialogModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudButtonsModule, { declarations: [CrudButtonsComponent], imports: [DialogModule], exports: [CrudButtonsComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudButtonsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    DialogModule
                ],
                declarations: [
                    CrudButtonsComponent
                ],
                exports: [
                    CrudButtonsComponent
                ]
            }]
    }], null, null); })();

class CrudButtonsOperationsComponent {
    constructor() {
        this.showDelete = false;
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.onClose, 'onClose event');
        AssertUtilsApp.assert(this.form, 'form');
        AssertUtilsApp.assert(this.service, 'service');
        this.attrValues();
    }
    cancel() {
        this.onClose.emit();
    }
    save() {
        this.service.postOrPatch(this.form.value, this.beforeValue).subscribe(() => this.onClose.emit());
    }
    delete() {
        this.showDelete = true;
    }
    onOkdelete() {
        this.service.remove(this.beforeValue.id).subscribe(() => this.onClose.emit());
        this.showDelete = false;
    }
    onCancelDelete() {
        this.showDelete = false;
    }
    attrValues() {
        if (this.beforeValue) {
            if (this.beforeValue.id) {
                this.form.reset(this.beforeValue);
            }
            else {
                for (let key in this.beforeValue) {
                    let value = this.beforeValue[key];
                    if (value && this.form.get(key)) {
                        this.form.get(key).setValue(value);
                    }
                }
                this.form.reset(this.form.value);
            }
        }
    }
}
CrudButtonsOperationsComponent.ɵfac = function CrudButtonsOperationsComponent_Factory(t) { return new (t || CrudButtonsOperationsComponent)(); };
CrudButtonsOperationsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudButtonsOperationsComponent, selectors: [["crud-buttons-operations"]], inputs: { onClose: "onClose", form: "form", beforeValue: "beforeValue", service: "service" }, decls: 9, vars: 3, consts: [["id", "dialog-delete", 3, "show", "onOkEvent", "onCancelEvent"], [1, "row"], [1, "col-md-12", "mt-xs"], ["id", "btnSalvarForm", "type", "button", 1, "btn", "positive", "inline", 3, "disabled", "click"], ["id", "btnCancelarForm", "type", "button", 1, "btn", "negative", "inline", 3, "click"], ["id", "btnExcluirForm", "type", "button", "class", "btn neutral inline", 3, "click", 4, "ngIf"], ["id", "btnExcluirForm", "type", "button", 1, "btn", "neutral", "inline", 3, "click"]], template: function CrudButtonsOperationsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "elo-dialog", 0);
        ɵngcc0.ɵɵlistener("onOkEvent", function CrudButtonsOperationsComponent_Template_elo_dialog_onOkEvent_0_listener() { return ctx.onOkdelete(); })("onCancelEvent", function CrudButtonsOperationsComponent_Template_elo_dialog_onCancelEvent_0_listener() { return ctx.onCancelDelete(); });
        ɵngcc0.ɵɵtext(1, " Confirma exclus\u00E3o deste registro?\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵlistener("click", function CrudButtonsOperationsComponent_Template_button_click_4_listener() { return ctx.save(); });
        ɵngcc0.ɵɵtext(5, " Salvar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 4);
        ɵngcc0.ɵɵlistener("click", function CrudButtonsOperationsComponent_Template_button_click_6_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(7, " Cancelar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, CrudButtonsOperationsComponent_button_8_Template, 2, 0, "button", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("show", ctx.showDelete);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", !ctx.form.valid || ctx.form.pristine);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.beforeValue == null ? null : ctx.beforeValue.id);
    } }, directives: [DialogComponent, ɵngcc2.NgIf], encapsulation: 2 });
CrudButtonsOperationsComponent.propDecorators = {
    onClose: [{ type: Input }],
    form: [{ type: Input }],
    beforeValue: [{ type: Input }],
    service: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudButtonsOperationsComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'crud-buttons-operations',
                template: "<elo-dialog id=\"dialog-delete\" [show]=\"showDelete\" (onOkEvent)=\"onOkdelete()\" (onCancelEvent)=\"onCancelDelete()\">\n  Confirma exclus\u00E3o deste registro?\n</elo-dialog>\n<div class=\"row\">\n  <div class=\"col-md-12 mt-xs\">\n    <button id=\"btnSalvarForm\" type=\"button\" class=\"btn positive inline\" (click)=\"save()\" [disabled]=\"!form.valid || form.pristine\">\n      Salvar\n    </button>\n    <button id=\"btnCancelarForm\" type=\"button\" class=\"btn negative inline\" (click)=\"cancel()\">\n      Cancelar\n    </button>\n    <button id=\"btnExcluirForm\" *ngIf=\"beforeValue?.id\"  type=\"button\" class=\"btn neutral inline\" (click)=\"delete()\">\n      Excluir\n    </button>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { onClose: [{
            type: Input
        }], form: [{
            type: Input
        }], beforeValue: [{
            type: Input
        }], service: [{
            type: Input
        }] }); })();

class CrudButtonsOperationsModule {
}
CrudButtonsOperationsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudButtonsOperationsModule });
CrudButtonsOperationsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudButtonsOperationsModule_Factory(t) { return new (t || CrudButtonsOperationsModule)(); }, imports: [[CommonModule$1, DialogModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudButtonsOperationsModule, { declarations: function () { return [CrudButtonsOperationsComponent]; }, imports: function () { return [CommonModule$1, DialogModule]; }, exports: function () { return [CrudButtonsOperationsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudButtonsOperationsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, DialogModule],
                declarations: [CrudButtonsOperationsComponent],
                exports: [CrudButtonsOperationsComponent]
            }]
    }], null, null); })();

class CrudDetailInlineComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.titleDetails = '';
        this.detailsVisibleWhenAttribute = '';
        this.printVisibleWhenMultipleAttribute = '';
        this.enableRemove = true;
        this.enablePrint = false;
        this.childHasForm = false;
        this.buttonNewLine = true;
        this.lineHighLight = false;
        this.class = '';
        this.maxListLength = '500px';
        this.hasScroll = false;
        this.onDelete = new EventEmitter();
        this.onInsert = new EventEmitter();
        this.onPrint = new EventEmitter();
        this.onAttrForm = new EventEmitter();
        this.visibleWhenFunction = null;
        this.showDelete = false;
        this.showChildTable = [];
        this.beforeDelete = () => of(true);
        this.createContextItem = (form, index) => ({ form, index });
        this.createContextInsert = () => ({ form: this.formGroupInsert });
    }
    set entity(entity) {
        if (entity) {
            this._entity = entity;
            this.loadForm(this._entity, this.form.get(this.arrayPropertyName));
        }
    }
    set orderFunction(functionRef) {
        if (functionRef) {
            this.form.get(this.arrayPropertyName).controls.sort((a, b) => functionRef(a.value, b.value));
        }
    }
    ngOnInit() {
        this.formGroupInsert = this.formCreate();
        AssertUtilsApp.assert(this.form, 'form');
        AssertUtilsApp.assert(this.formCreate, 'formCreate');
        AssertUtilsApp.assert(this.listTemplate, 'listTemplate');
        AssertUtilsApp.assert(this.arrayPropertyName, 'arrayPropertyName');
    }
    enableExcluir(item) {
        if (this.visibleWhenFunction && !this.visibleWhenFunction(item)) {
            return false;
        }
        return this.enableRemove;
    }
    getPrintVisibleWhenMultipleAttributes(item) {
        let printVisible = true;
        if (!item || !this.printVisibleWhenMultipleAttribute) {
            return false;
        }
        this.printVisibleWhenMultipleAttribute.split('|').forEach(atributo => {
            if (!item.get(atributo) || !item.get(atributo).value) {
                printVisible = false;
            }
        });
        return printVisible;
    }
    createContextDetail(formDetail, index) {
        let entityDetail = null;
        if (this._entity) {
            entityDetail = this._entity[this.arrayPropertyName][index];
        }
        return { formDetail, entityDetail };
    }
    delete(index) {
        this.showDelete = true;
        this.indexToDelete = index;
        this.showChildTable[index] = false;
    }
    add() {
        const formToInsert = this.formCreate();
        const value = formToInsert.value;
        formToInsert.reset(this.formGroupInsert.value);
        this.form.get(this.arrayPropertyName).push(formToInsert);
        this.onInsert.emit(this.formGroupInsert.value);
        this.formGroupInsert.reset(value);
        this.form.markAsDirty();
        this.form.updateValueAndValidity();
    }
    onOkDelete() {
        this.beforeDelete(this._entity && this._entity[this.arrayPropertyName][this.indexToDelete]).subscribe(() => this.removeItem(this.indexToDelete));
    }
    removeItem(indexToDelete) {
        if (this._entity && this._entity[this.arrayPropertyName]) {
            this._entity[this.arrayPropertyName].splice(indexToDelete, 1);
        }
        this.showDelete = false;
        this.form.get(this.arrayPropertyName).removeAt(indexToDelete);
        this.form.markAsDirty();
        this.onDelete.emit(this.form.get(this.arrayPropertyName).value);
    }
    onCancelDelete() {
        this.showDelete = false;
    }
    onDetails(index) {
        if (this.showChildTable[index]) {
            this.showChildTable[index] = !this.showChildTable[index];
        }
        else {
            this.showChildTable[index] = true;
        }
    }
    print(item) {
        this.onPrint.emit(item);
    }
    loadForm(entity, formArray) {
        const objArray = entity[this.arrayPropertyName];
        if (objArray) {
            const empty = formArray.length === 0;
            while (formArray.length > 0) {
                formArray.removeAt(0);
            }
            objArray.forEach(obj => {
                let form = this.formCreate();
                form.reset(obj, { emitEvent: false });
                this.onAttrForm.emit(form);
                if (empty) {
                    setTimeout(() => formArray.push(form), 0);
                }
                else {
                    formArray.push(form);
                }
            });
        }
    }
}
CrudDetailInlineComponent.ɵfac = function CrudDetailInlineComponent_Factory(t) { return new (t || CrudDetailInlineComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
CrudDetailInlineComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudDetailInlineComponent, selectors: [["crud-detail-inline"]], inputs: { titleDetails: "titleDetails", detailsVisibleWhenAttribute: "detailsVisibleWhenAttribute", printVisibleWhenMultipleAttribute: "printVisibleWhenMultipleAttribute", enableRemove: "enableRemove", enablePrint: "enablePrint", childHasForm: "childHasForm", buttonNewLine: "buttonNewLine", lineHighLight: "lineHighLight", class: "class", maxListLength: "maxListLength", hasScroll: "hasScroll", visibleWhenFunction: "visibleWhenFunction", beforeDelete: "beforeDelete", entity: "entity", orderFunction: "orderFunction", form: "form", arrayPropertyName: "arrayPropertyName", formCreate: "formCreate", listTemplate: "listTemplate", insertTemplate: "insertTemplate", detailTemplate: "detailTemplate", footerTemplate: "footerTemplate" }, outputs: { onDelete: "onDelete", onInsert: "onInsert", onPrint: "onPrint", onAttrForm: "onAttrForm" }, ngContentSelectors: _c0, decls: 7, vars: 5, consts: [[4, "ngIf"], ["class", "row", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["crud", ""], [3, "show", "onOkEvent", "onCancelEvent"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "row has-not-table", 4, "ngIf"], [1, "row", "has-not-table"], [1, "col-md-12", "col-xs-12"], [1, "form-group", "pull-right"], ["id", "btnAdd", "type", "button", "title", "Adicionar", 1, "btn", "module-color", "icon-left", 3, "disabled", "click"], [1, "fa", "fa-plus"], [1, "row"], ["class", "col-md-1 pl-none", 4, "ngIf"], [1, "col-md-1", "pl-none"], [1, "form-group"], [1, "label"], ["id", "btnAdd", "type", "button", 1, "btn", "module-color", "right", 3, "disabled", "click"], [1, "panel", "table", "mt-xs"], [1, "panel-body"], [4, "ngTemplateOutlet"], [3, "ngTemplateOutlet", 4, "ngIf"], [3, "ngTemplateOutlet"], ["id", "tableEditable", 1, "table-editable", 3, "hidden", "ngClass"], [1, "table-editable-header", "hidden-xs"], [1, "table-editable-content", 3, "ngStyle"], [3, "formGroup"], [3, "formArrayName"], [4, "ngFor", "ngForOf"], [1, "row", 3, "id"], ["class", "col-md-1 col-xs-12 column btn-actions", 4, "ngIf"], ["class", "child-table", "id", "child", 3, "has-form", "hidden", 4, "ngIf"], [1, "col-md-1", "col-xs-12", "column", "btn-actions"], [1, "btn-actions-inner"], ["id", "btnDetails", "class", "btn", "type", "button", 3, "title", "click", 4, "ngIf"], ["id", "btnImprimir", "class", "btn", "type", "button", "title", "Imprimir", 3, "click", 4, "ngIf"], ["id", "btnExcluir", "class", "btn", "type", "button", "title", "Excluir", 3, "click", 4, "ngIf"], ["id", "btnDetails", "type", "button", 1, "btn", 3, "title", "click"], [1, "fa", "fa-chevron-down"], [1, "btn-actions-label"], ["id", "btnImprimir", "type", "button", "title", "Imprimir", 1, "btn", 3, "click"], [1, "fa", "fa-print"], ["id", "btnExcluir", "type", "button", "title", "Excluir", 1, "btn", 3, "click"], [1, "fa", "fa-trash"], ["id", "child", 1, "child-table", 3, "hidden"]], template: function CrudDetailInlineComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CrudDetailInlineComponent_ng_container_0_Template, 3, 3, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, CrudDetailInlineComponent_div_1_Template, 3, 3, "div", 1);
        ɵngcc0.ɵɵtemplate(2, CrudDetailInlineComponent_ng_container_2_Template, 5, 2, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, CrudDetailInlineComponent_ng_template_3_Template, 7, 12, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(5, "elo-dialog", 4);
        ɵngcc0.ɵɵlistener("onOkEvent", function CrudDetailInlineComponent_Template_elo_dialog_onOkEvent_5_listener() { return ctx.onOkDelete(); })("onCancelEvent", function CrudDetailInlineComponent_Template_elo_dialog_onCancelEvent_5_listener() { return ctx.onCancelDelete(); });
        ɵngcc0.ɵɵtext(6, " Apagar?\n");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonNewLine);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.buttonNewLine);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.footerTemplate)("ngIfElse", _r3);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("show", ctx.showDelete);
    } }, directives: [ɵngcc2.NgIf, DialogComponent, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgClass, ɵngcc2.NgStyle, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.FormArrayName, ɵngcc2.NgForOf], encapsulation: 2 });
CrudDetailInlineComponent.ctorParameters = () => [
    { type: FormBuilder }
];
CrudDetailInlineComponent.propDecorators = {
    form: [{ type: Input }],
    arrayPropertyName: [{ type: Input }],
    formCreate: [{ type: Input }],
    listTemplate: [{ type: Input }],
    insertTemplate: [{ type: Input }],
    detailTemplate: [{ type: Input }],
    titleDetails: [{ type: Input }],
    detailsVisibleWhenAttribute: [{ type: Input }],
    printVisibleWhenMultipleAttribute: [{ type: Input }],
    enableRemove: [{ type: Input }],
    enablePrint: [{ type: Input }],
    childHasForm: [{ type: Input }],
    buttonNewLine: [{ type: Input }],
    lineHighLight: [{ type: Input }],
    footerTemplate: [{ type: Input }],
    class: [{ type: Input }],
    maxListLength: [{ type: Input }],
    hasScroll: [{ type: Input }],
    onDelete: [{ type: Output }],
    onInsert: [{ type: Output }],
    onPrint: [{ type: Output }],
    onAttrForm: [{ type: Output }],
    visibleWhenFunction: [{ type: Input }],
    entity: [{ type: Input }],
    orderFunction: [{ type: Input }],
    beforeDelete: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudDetailInlineComponent, [{
        type: Component,
        args: [{
                selector: 'crud-detail-inline',
                template: "<ng-container *ngIf=\"buttonNewLine\">\n  <ng-container *ngTemplateOutlet=\"insertTemplate;context:createContextInsert()\"></ng-container>\n  <div class=\"row has-not-table\" *ngIf=\"insertTemplate\">\n    <div class=\"col-md-12 col-xs-12\">\n      <div class=\"form-group pull-right\">\n        <button id=\"btnAdd\" class=\"btn module-color icon-left\" type=\"button\" title=\"Adicionar\" (click)=\"add()\"\n          [disabled]=\"!formGroupInsert?.valid || formGroupInsert?.pristine\">\n          <i class=\"fa fa-plus\"></i>\n          Adicionar\n        </button>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<div class=\"row\" *ngIf=\"!buttonNewLine\">\n  <ng-container *ngTemplateOutlet=\"insertTemplate;context:createContextInsert()\"></ng-container>\n  <div class=\"col-md-1 pl-none\" *ngIf=\"insertTemplate\">\n    <div class=\"form-group\">\n      <label class=\"label\"></label>\n      <button id=\"btnAdd\" class=\"btn module-color right\" type=\"button\" (click)=\"add()\"\n        [disabled]=\"!formGroupInsert?.valid || formGroupInsert?.pristine\">\n        Adicionar\n      </button>\n    </div>\n  </div>\n</div>\n\n<ng-container *ngIf=\"footerTemplate; else crud\">\n  <div class=\"panel table mt-xs\">\n    <div class=\"panel-body\">\n      <ng-container *ngTemplateOutlet=\"crud\"></ng-container>\n    </div>\n    <ng-container [ngTemplateOutlet]=\"footerTemplate\" *ngIf=\"footerTemplate\"></ng-container>\n  </div>\n</ng-container>\n\n<ng-template #crud>\n  <div id=\"tableEditable\" class=\"table-editable\" [class.panel-table-outer]=\"footerTemplate\" [class.fixed]=\"hasScroll\"\n    [hidden]=\"form?.get(arrayPropertyName)?.length === 0\" [ngClass]=\"class\">\n\n    <div class=\"table-editable-header hidden-xs\">\n      <ng-content></ng-content>\n    </div>\n\n    <div class=\"table-editable-content\" [ngStyle]=\"hasScroll && {'max-height': maxListLength}\">\n\n      <div [formGroup]=\"form\">\n        <div [formArrayName]=\"arrayPropertyName\">\n          <div *ngFor=\"let item of form?.get(arrayPropertyName)?.controls; let i=index\">\n            <div class=\"row\" [class.striped]=\"i % 2\" [class.reduced]=\"lineHighLight\"\n              id=\"{{arrayPropertyName}}_{{item.get('id')?.value}}\">\n              <ng-container *ngTemplateOutlet=\"listTemplate;context:createContextItem(item, i)\">\n              </ng-container>\n              <div class=\"col-md-1 col-xs-12 column btn-actions\" *ngIf=\"titleDetails || enableRemove\">\n                <div class=\"btn-actions-inner\">\n                  <button id=\"btnDetails\"\n                    *ngIf=\"titleDetails && (detailsVisibleWhenAttribute === '' || item.get(detailsVisibleWhenAttribute).value === true)\"\n                    class=\"btn\" type=\"button\" [title]=\"titleDetails\" (click)=\"onDetails(i)\">\n                    <i class=\"fa fa-chevron-down\"></i>\n                    <div class=\"btn-actions-label\">\n                      {{titleDetails}}\n                    </div>\n                  </button>\n                  <button id=\"btnImprimir\" *ngIf=\"getPrintVisibleWhenMultipleAttributes(item)\" class=\"btn\" type=\"button\"\n                    title=\"Imprimir\" (click)=\"print(item)\">\n                    <i class=\"fa fa-print\"></i>\n                    <div class=\"btn-actions-label\">\n                      Imprimir\n                    </div>\n                  </button>\n\n                  <button id=\"btnExcluir\" *ngIf=\"enableExcluir(item)\" class=\"btn\"\n                    type=\"button\" title=\"Excluir\" (click)=\"delete(i)\">\n                    <i class=\"fa fa-trash\"></i>\n                    <div class=\"btn-actions-label\">\n                      Excluir\n                    </div>\n                  </button>\n                </div>\n              </div>\n            </div>\n            <div class=\"child-table\" [class.has-form]=\"childHasForm\" *ngIf=\"titleDetails\" [hidden]=\"!showChildTable[i]\"\n              id=\"child\">\n              <ng-container *ngTemplateOutlet=\"detailTemplate;context:createContextDetail(item, i)\"></ng-container>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<elo-dialog [show]=\"showDelete\" (onOkEvent)=\"onOkDelete()\" (onCancelEvent)=\"onCancelDelete()\">\n  Apagar?\n</elo-dialog>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { titleDetails: [{
            type: Input
        }], detailsVisibleWhenAttribute: [{
            type: Input
        }], printVisibleWhenMultipleAttribute: [{
            type: Input
        }], enableRemove: [{
            type: Input
        }], enablePrint: [{
            type: Input
        }], childHasForm: [{
            type: Input
        }], buttonNewLine: [{
            type: Input
        }], lineHighLight: [{
            type: Input
        }], class: [{
            type: Input
        }], maxListLength: [{
            type: Input
        }], hasScroll: [{
            type: Input
        }], onDelete: [{
            type: Output
        }], onInsert: [{
            type: Output
        }], onPrint: [{
            type: Output
        }], onAttrForm: [{
            type: Output
        }], visibleWhenFunction: [{
            type: Input
        }], beforeDelete: [{
            type: Input
        }], entity: [{
            type: Input
        }], orderFunction: [{
            type: Input
        }], form: [{
            type: Input
        }], arrayPropertyName: [{
            type: Input
        }], formCreate: [{
            type: Input
        }], listTemplate: [{
            type: Input
        }], insertTemplate: [{
            type: Input
        }], detailTemplate: [{
            type: Input
        }], footerTemplate: [{
            type: Input
        }] }); })();

class FormControlValidationMsgDirective {
    constructor(formControlName, renderer, elementRef) {
        this.formControlName = formControlName;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.MODELO_MASCARA_REGEX = '^[#.]+$';
        this.CNH_MINIMA_REGEX = '^[A-E]+$';
        this.CONTAINED_IN_REGEX = '^\d+(,\d+|(\d+-\d+))*$';
        this.mapTranslate = new Map();
        this.children = [];
        this.hasTouched = false;
        this.mapTranslate.set('required', () => '(requerido) ');
        this.mapTranslate.set('minlength', (obj) => `(tamanho mínimo ${obj.requiredLength}) `);
        this.mapTranslate.set('maxlength', (obj) => `(tamanho máximo ${obj.requiredLength}) `);
        this.mapTranslate.set('min', (obj) => `(valor mínimo ${obj.min}) `);
        this.mapTranslate.set('max', (obj) => `(valor máximo ${obj.max}) `);
        this.mapTranslate.set('pattern', (obj) => this.buildPatternMessageValidator(obj.requiredPattern));
        this.mapTranslate.set('email', () => `(email inválido) `);
        this.mapTranslate.set('url', () => `(url inválida) `);
        this.mapTranslate.set('competencia', () => `(competência inválida)`);
        this.mapTranslate.set('competencia-minima', (obj) => `(competência mínima ${obj})`);
        this.mapTranslate.set('competencia-maxima', (obj) => `(competência máxima ${obj})`);
        this.mapTranslate.set('maxvalue', (obj) => `(valor máximo ${obj})`);
        this.mapTranslate.set('minvalue', (obj) => `(valor mínimo ${obj})`);
        this.mapTranslate.set('maxdate', (obj) => `(data máxima ${obj})`);
        this.mapTranslate.set('mindate', (obj) => `(data mínima ${obj})`);
        this.mapTranslate.set('dataCompetencia', (obj) => `(data fora da competência) `);
        this.mapTranslate.set('competenciaAberta', (obj) => `(competência está fechada) `);
        this.mapTranslate.set('differentValue', message => `(${message}) `);
        this.mapTranslate.set('sameValue', message => `(${message}) `);
        this.mapTranslate.set('valorMaior', (obj) => `(valor maior que ${obj})`);
        this.mapTranslate.set('vazio', (obj) => `(valor ${obj} está vazio)`);
        this.mapTranslate.set('validateDate', () => `(data inválida)`);
        this.mapTranslate.set('somaValor', (obj) => `A soma dos valores deve ser igual a ${obj.value}`);
        this.mapTranslate.set('conflictDate', () => `(conflito entre datas)`);
        this.mapTranslate.set('validateDateNotSmaller', (obj) => `(data mínima ${obj.dataMinima})`);
        this.mapTranslate.set('validateDateNotGreater', (obj) => `(data máxima ${obj.dataMaxima})`);
        this.mapTranslate.set('validateHourNotSmaller', (obj) => `(hora mínima ${obj.horaMinima})`);
        this.mapTranslate.set('validateDateNotGreaterYear', (obj) => `(ano deve ser igual a ${obj.yearMaximo})`);
        this.mapTranslate.set('codigoJaUtilizado', (obj) => `(código ${obj.codigo} já utilizado)`);
        this.mapTranslate.set('mensagemGenerica', (obj) => `${obj.mensagem}`);
        this.mapTranslate.set('[#.]+', () => 'Mensagem custom');
        this.mapTranslate.set('cnpj_invalid', () => '(CNPJ inválido)');
        this.mapTranslate.set('isCompetenciaAberta', (message) => `(${message}) `);
        this.mapTranslate.set('isExercicioValid', (message) => `(${message}) `);
        this.mapTranslate.set('dateNotWeekend', () => `(data não pode ser no fim de semana)`);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.removeErrorsMessages();
        this.destroyNode(this.msgElement);
        if (this.hintElement) {
            this.destroyNode(this.hintElement);
        }
        this.renderer.removeChild(this.elementRef.nativeElement.parentNode, this.msgElement);
    }
    ngOnInit() {
        if (!this.formControlName) {
            this.formControlName = this.formControlAttr;
        }
        this.createMessageElement();
        if (this.formControlName.status === 'INVALID' && (this.formControlName.touched || this.formControlName.dirty)) {
            this.addErrorsMessages();
        }
        this.subscription = this.formControlName.statusChanges.subscribe(status => {
            this.removeErrorsMessages();
            if (status === 'INVALID' && (this.hasTouched || this.formControlName.dirty)) {
                this.addErrorsMessages();
            }
        });
    }
    addErrorIfNecessary() {
        this.removeErrorsMessages();
        if (this.formControlName.invalid) {
            this.addErrorsMessages();
        }
    }
    onBlur(event) {
        this.hasTouched = true;
        this.addErrorIfNecessary();
    }
    createMessageElement() {
        this.msgElement = this.renderer.createElement('p');
        this.renderer.addClass(this.msgElement, 'help-message');
        this.renderer.appendChild(this.elementRef.nativeElement.parentNode, this.msgElement);
    }
    removeErrorsMessages() {
        this.children.forEach(child => {
            this.renderer.removeChild(this.msgElement, child);
        });
        this.children = [];
    }
    addErrorsMessages() {
        Object.keys(this.formControlName.errors).forEach(key => {
            let keyTranslated = `(${key}) `;
            if (this.mapTranslate.has(key)) {
                keyTranslated = this.mapTranslate.get(key)(this.formControlName.errors[key]);
            }
            const child = document.createTextNode(keyTranslated);
            this.children.push(child);
            this.renderer.appendChild(this.msgElement, child);
            this.renderHintError(this.formControlName.errors[key]['hintMessage']);
        });
    }
    destroyNode(node) {
        if (this.renderer.destroyNode instanceof Function) {
            this.renderer.destroyNode(node);
        }
    }
    buildPatternMessageValidator(requiredPattern) {
        const msg = '(padrão requerido';
        switch (requiredPattern) {
            case this.MODELO_MASCARA_REGEX:
                return `${msg} #.##.###)`;
            case this.CNH_MINIMA_REGEX:
                return `(A,B,C,D,E,AB)`;
            case this.CONTAINED_IN_REGEX:
                return `${msg} # | #,#... | #,#...,#-# | #-#)`;
            default:
                return `${msg} ${requiredPattern})`;
        }
    }
    renderHintError(hintMessage) {
        if (!hintMessage) {
            return;
        }
        this.hintElement = this.renderer.createElement('div');
        ['hint', 'fa-exclamation-circle', 'clean', 'inline', 'negative', 'sm'].forEach(x => this.renderer.addClass(this.hintElement, x));
        const divHintContent = this.renderer.createElement('div');
        this.renderer.addClass(divHintContent, 'hint-content');
        this.renderer.appendChild(this.hintElement, divHintContent);
        this.renderer.appendChild(divHintContent, document.createTextNode(hintMessage));
        this.renderer.appendChild(this.msgElement, this.hintElement);
        this.children.push(this.hintElement);
    }
}
FormControlValidationMsgDirective.ɵfac = function FormControlValidationMsgDirective_Factory(t) { return new (t || FormControlValidationMsgDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormControlName, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FormControlValidationMsgDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FormControlValidationMsgDirective, selectors: [["", "formControlValidationMsg", ""]], hostBindings: function FormControlValidationMsgDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function FormControlValidationMsgDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event); });
    } }, inputs: { formControlAttr: "formControlAttr" } });
FormControlValidationMsgDirective.ctorParameters = () => [
    { type: FormControlName, decorators: [{ type: Optional }] },
    { type: Renderer2 },
    { type: ElementRef }
];
FormControlValidationMsgDirective.propDecorators = {
    formControlAttr: [{ type: Input }],
    onBlur: [{ type: HostListener, args: ['blur', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormControlValidationMsgDirective, [{
        type: Directive,
        args: [{ selector: '[formControlValidationMsg]' }]
    }], function () { return [{ type: ɵngcc3.FormControlName, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur', ['$event']]
        }], formControlAttr: [{
            type: Input
        }] }); })();

class FormControlValidationMsgModule {
}
FormControlValidationMsgModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FormControlValidationMsgModule });
FormControlValidationMsgModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FormControlValidationMsgModule_Factory(t) { return new (t || FormControlValidationMsgModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormControlValidationMsgModule, { declarations: [FormControlValidationMsgDirective], exports: [FormControlValidationMsgDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormControlValidationMsgModule, [{
        type: NgModule,
        args: [{
                declarations: [FormControlValidationMsgDirective],
                exports: [FormControlValidationMsgDirective]
            }]
    }], null, null); })();

class CrudDetailInlineModule {
}
CrudDetailInlineModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudDetailInlineModule });
CrudDetailInlineModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudDetailInlineModule_Factory(t) { return new (t || CrudDetailInlineModule)(); }, imports: [[
            CommonModule$1,
            PanelModule,
            DialogModule,
            DirectivesModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudDetailInlineModule, { declarations: function () { return [CrudDetailInlineComponent]; }, imports: function () { return [CommonModule$1, PanelModule, DialogModule, DirectivesModule, ReactiveFormsModule, FormControlValidationMsgModule]; }, exports: function () { return [CrudDetailInlineComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudDetailInlineModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    PanelModule,
                    DialogModule,
                    DirectivesModule,
                    ReactiveFormsModule,
                    FormControlValidationMsgModule
                ],
                declarations: [CrudDetailInlineComponent],
                exports: [CrudDetailInlineComponent]
            }]
    }], null, null); })();

class CrudFormComponent {
    constructor(activatedRoute, location, eloNotificationService, routerService, windowService) {
        this.activatedRoute = activatedRoute;
        this.location = location;
        this.eloNotificationService = eloNotificationService;
        this.routerService = routerService;
        this.windowService = windowService;
        this.showFormButtons = true;
        this.onAttrEntity = new EventEmitter();
        this.onAttrBeforeEntity = new EventEmitter();
        this.onChangeState = new EventEmitter();
        this.useTemplate = false;
        this.enablePut = false;
        this.backOnSave = false;
        this.requestSave = null;
        this.requestBack = null;
        this.enableSecurityExit = false;
        // route usada na exclusão da carga de dados/back quando a tela esta embutida no modal
        this.routeOwner = '';
        this.forcePost = false;
        this.emitEvent = false;
        this.embedded = false;
        this.initializeDirty = false;
        this.ignorePreviousRoute = false;
        this.isInsertMode = true;
        this.showBackConfirm = false;
        this.formValid = true;
        this.handleException = (error) => { throw error; };
    }
    loadEntity(id) {
        if (this.sameRouteOwner && id && id !== CrudFormComponent.NEW_ID) {
            this.isInsertMode = false;
            this.entityService.findOne(id).subscribe(entity => this.attrEntity(entity));
        }
        else if (this.useTemplate) {
            AssertUtilsApp.assert(this.entityService.newTemplate, 'entity service newTemplate not found');
            this.entityService.newTemplate().subscribe(template => this.attrEntityUseTemplate(template));
        }
    }
    attrEntityUseTemplate(entity) {
        this.attrEntity(entity);
        if (this.initializeDirty) {
            this.form.markAsDirty();
        }
    }
    attrEntity(entity) {
        this.form.reset(entity, { emitEvent: this.emitEvent });
        this.onAttrEntity.emit(entity);
        this.beforeEditEntity = deepCopy(entity);
        this.onAttrBeforeEntity.emit(this.beforeEditEntity);
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.entityService, 'entity service');
        AssertUtilsApp.assert(this.form, 'form');
        this.sameRouteOwner = this.isSameRouteOwner();
        if (this.embedded) {
            AssertUtilsApp.assert(this.embeddedEntityId, 'embeddedEntityId must be set');
            this.loadEntity(this.embeddedEntityId);
        }
        else {
            this.loadEntity(this.activatedRoute.snapshot.params['id']);
        }
        this.subscribeRequestSave();
        if (this.requestBack) {
            this.requestBack.subscribe(() => this.back());
        }
        this.form.statusChanges.subscribe(status => this.formValid = status === 'VALID');
    }
    subscribeRequestSave() {
        if (this.requestSave) {
            this.requestSave.subscribe(() => {
                if (!this.form.pristine) {
                    this.save(this.form.getRawValue());
                }
            });
        }
    }
    attrEntityAfterSave(entity) {
        if (this.embedded) {
            this.embeddedBack();
        }
        else {
            if (this.isInsertMode && !this.backOnSave && this.sameRouteOwner) {
                this.location.replaceState(this.location.path(true).replace('new', encodeURIComponent(entity.id)));
            }
            this.isInsertMode = false;
            this.onChangeState.emit(this.isInsertMode);
            const entityToAttr = entity ? entity : this.form.value;
            this.attrEntity(entityToAttr);
            this.eloNotificationService.success(this.caption, 'Salvo(a) com sucesso', this.routeOwner);
            if (this.backOnSave && this.sameRouteOwner) {
                this.back();
            }
        }
    }
    save(entityToSave) {
        if (this.form.invalid) {
            return;
        }
        if (!this.isInsertMode && !this.forcePost) {
            if (this.form.pristine) {
                this.attrEntityAfterSave(entityToSave);
            }
            else if (this.enablePut) {
                this.isDisabled = true;
                this.entityService.put(entityToSave.id, JsonUtil.removeNullKeys(entityToSave)).
                    pipe(finalize(() => this.isDisabled = false)).subscribe(entity => this.attrEntityAfterSave(entity), error => this.handleException(error));
            }
            else {
                this.isDisabled = true;
                this.entityService.patch(entityToSave.id, JsonPatchUtil.compare(JsonUtil.removeNullKeys(this.beforeEditEntity), JsonUtil.removeNullKeys(entityToSave))).
                    pipe(finalize(() => this.isDisabled = false))
                    .subscribe(entity => this.attrEntityAfterSave(entity), error => this.handleException(error));
            }
        }
        else {
            this.isDisabled = true;
            this.entityService.post(JsonUtil.removeNullKeys(entityToSave)).
                pipe(finalize(() => this.isDisabled = false)).subscribe(entity => this.attrEntityAfterSave(entity), error => this.handleException(error));
        }
    }
    embeddedBack() {
        if (this.embeddedOnClose) {
            this.embeddedOnClose();
        }
    }
    back() {
        if (this.routerService.getPreviousRoute() && !this.ignorePreviousRoute) {
            this.location.back();
        }
        else {
            const urlList = this.location.path().split('/')[1];
            this.routerService.navigateByUrl(`/${urlList}`, this.navigationExtras);
        }
    }
    openSecurityAlert($event) {
        if (this.enableSecurityExit && !this.form.pristine) {
            $event.returnValue = true;
        }
    }
    isSameRouteOwner() {
        return this.windowService.getHref().includes(this.routeOwner);
    }
}
CrudFormComponent.ɵfac = function CrudFormComponent_Factory(t) { return new (t || CrudFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Location), ɵngcc0.ɵɵdirectiveInject(EloNotificationService), ɵngcc0.ɵɵdirectiveInject(RouterService), ɵngcc0.ɵɵdirectiveInject(WindowService)); };
CrudFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudFormComponent, selectors: [["elo-crudform"]], hostBindings: function CrudFormComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("beforeunload", function CrudFormComponent_beforeunload_HostBindingHandler($event) { return ctx.openSecurityAlert($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { showFormButtons: "showFormButtons", useTemplate: "useTemplate", enablePut: "enablePut", backOnSave: "backOnSave", requestSave: "requestSave", requestBack: "requestBack", enableSecurityExit: "enableSecurityExit", routeOwner: "routeOwner", forcePost: "forcePost", emitEvent: "emitEvent", embedded: "embedded", initializeDirty: "initializeDirty", ignorePreviousRoute: "ignorePreviousRoute", handleException: "handleException", caption: "caption", form: "form", entityService: "entityService", embeddedEntityId: "embeddedEntityId", embeddedOnClose: "embeddedOnClose", navigationExtras: "navigationExtras" }, outputs: { onAttrEntity: "onAttrEntity", onAttrBeforeEntity: "onAttrBeforeEntity", onChangeState: "onChangeState" }, ngContentSelectors: _c33, decls: 7, vars: 3, consts: [["autocomplete", "off", 3, "formGroup", "ngSubmit"], ["autocomplete", "false", "name", "hidden", "type", "text", 2, "display", "none"], ["id", "buttons", "class", "btn-save", 4, "ngIf"], ["id", "embeddedButtons", "class", "align-group mt-xs mb-xs", 4, "ngIf"], ["id", "buttons", 1, "btn-save"], ["id", "save", 1, "btn", "positive", 3, "disabled"], ["id", "embeddedButtons", 1, "align-group", "mt-xs", "mb-xs"], ["id", "btnEmbbededSave", "type", "button", 1, "btn", "positive", "inline", "icon-left", 3, "click"], [1, "fa", "fa-check"], ["id", "btnEmbeddedCancel", "type", "button", 1, "btn", "negative", "inline", "icon-right", 3, "click"], [1, "fa", "fa-times"]], template: function CrudFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c32);
        ɵngcc0.ɵɵelement(0, "back-confirm-component");
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function CrudFormComponent_Template_form_ngSubmit_2_listener() { return ctx.save(ctx.form.getRawValue()); });
        ɵngcc0.ɵɵelement(3, "input", 1);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵtemplate(5, CrudFormComponent_div_5_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(6, CrudFormComponent_div_6_Template, 7, 0, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.embedded && ctx.showFormButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.embedded && ctx.showFormButtons);
    } }, directives: [BackConfirmComponent, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc2.NgIf], encapsulation: 2 });
CrudFormComponent.NEW_ID = 'new';
CrudFormComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Location },
    { type: EloNotificationService },
    { type: RouterService },
    { type: WindowService }
];
CrudFormComponent.propDecorators = {
    caption: [{ type: Input }],
    form: [{ type: Input }],
    showFormButtons: [{ type: Input }],
    entityService: [{ type: Input }],
    onAttrEntity: [{ type: Output }],
    onAttrBeforeEntity: [{ type: Output }],
    onChangeState: [{ type: Output }],
    useTemplate: [{ type: Input }],
    enablePut: [{ type: Input }],
    backOnSave: [{ type: Input }],
    requestSave: [{ type: Input }],
    requestBack: [{ type: Input }],
    enableSecurityExit: [{ type: Input }],
    routeOwner: [{ type: Input }],
    forcePost: [{ type: Input }],
    emitEvent: [{ type: Input }],
    embedded: [{ type: Input }],
    embeddedEntityId: [{ type: Input }],
    embeddedOnClose: [{ type: Input }],
    initializeDirty: [{ type: Input }],
    ignorePreviousRoute: [{ type: Input }],
    navigationExtras: [{ type: Input }],
    handleException: [{ type: Input }],
    openSecurityAlert: [{ type: HostListener, args: ['window:beforeunload', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudFormComponent, [{
        type: Component,
        args: [{
                selector: 'elo-crudform',
                template: "<back-confirm-component></back-confirm-component>\n<div>\n  <form [formGroup]=\"form\" autocomplete=\"off\" (ngSubmit)=\"save(form.getRawValue())\">\n    <input autocomplete=\"false\" name=\"hidden\" type=\"text\" style=\"display:none;\">\n    <ng-content select=\"[inputs]\"></ng-content>\n    <div id=\"buttons\" class=\"btn-save\" *ngIf=\"!embedded && showFormButtons\">\n      <button id=\"save\" class=\"btn positive\" [disabled]=\"isDisabled\"></button>\n    </div>\n    <div id=\"embeddedButtons\" class=\"align-group mt-xs mb-xs\" *ngIf=\"embedded && showFormButtons\">\n      <button id=\"btnEmbbededSave\" type=\"button\" class=\"btn positive inline icon-left\" (click)=\"save(form.getRawValue())\">\n        <em class=\"fa fa-check\"></em>Adicionar\n      </button>\n\n      <button id=\"btnEmbeddedCancel\" type=\"button\" class=\"btn negative inline icon-right\" (click)=\"embeddedBack()\">\n        <em class=\"fa fa-times\"></em>Cancelar\n      </button>\n    </div>\n  </form>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc6.ActivatedRoute }, { type: ɵngcc2.Location }, { type: EloNotificationService }, { type: RouterService }, { type: WindowService }]; }, { showFormButtons: [{
            type: Input
        }], onAttrEntity: [{
            type: Output
        }], onAttrBeforeEntity: [{
            type: Output
        }], onChangeState: [{
            type: Output
        }], useTemplate: [{
            type: Input
        }], enablePut: [{
            type: Input
        }], backOnSave: [{
            type: Input
        }], requestSave: [{
            type: Input
        }], requestBack: [{
            type: Input
        }], enableSecurityExit: [{
            type: Input
        }], routeOwner: [{
            type: Input
        }], forcePost: [{
            type: Input
        }], emitEvent: [{
            type: Input
        }], embedded: [{
            type: Input
        }], initializeDirty: [{
            type: Input
        }], ignorePreviousRoute: [{
            type: Input
        }], handleException: [{
            type: Input
        }], openSecurityAlert: [{
            type: HostListener,
            args: ['window:beforeunload', ['$event']]
        }], caption: [{
            type: Input
        }], form: [{
            type: Input
        }], entityService: [{
            type: Input
        }], embeddedEntityId: [{
            type: Input
        }], embeddedOnClose: [{
            type: Input
        }], navigationExtras: [{
            type: Input
        }] }); })();

class CrudFormModule {
}
CrudFormModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudFormModule });
CrudFormModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudFormModule_Factory(t) { return new (t || CrudFormModule)(); }, providers: [CanDeactivateGuard], imports: [[FormsModule, ReactiveFormsModule, DialogModule, RouterModule, BackConfirmModule], FormsModule, ReactiveFormsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudFormModule, { declarations: function () { return [CrudFormComponent]; }, imports: function () { return [FormsModule, ReactiveFormsModule, DialogModule, RouterModule, BackConfirmModule]; }, exports: function () { return [CrudFormComponent, FormsModule, ReactiveFormsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudFormModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, ReactiveFormsModule, DialogModule, RouterModule, BackConfirmModule],
                declarations: [CrudFormComponent],
                exports: [CrudFormComponent, FormsModule, ReactiveFormsModule],
                providers: [CanDeactivateGuard]
            }]
    }], null, null); })();

const resolvePath = (object, path, defaultValue) => path
    .split('.')
    .reduce((o, p) => o ? o[p] : defaultValue, object);
const ɵ0$1 = resolvePath;
class CrudFormDetailComponent {
    constructor(formBuilder, crudForm, crudFormDetail) {
        this.formBuilder = formBuilder;
        this.crudForm = crudForm;
        this.crudFormDetail = crudFormDetail;
        this.hideListWhenAdd = false;
        this.enableRemove = true;
        this.disableButtonNovo = false;
        this.disableButtonSalvar = false;
        this.panelExpansive = true;
        this.nameBtnSave = 'Adicionar';
        this.visibleWhenFunction = null;
        this.hasLinks = false;
        this.getLinks = null;
        this.beforeSave = null;
        this.visibleWhenFunctionLink = null;
        this.manyActions = false;
        this.quickView = false;
        this.hideButtonNovo = false;
        this.hideButtonUpdate = false;
        this.alwaysShowForm = false;
        this.btnSaveHasFormGroup = false;
        this.isInsideTab = false;
        this.showButtonCancelar = true;
        this.onModifySelection = new EventEmitter();
        this.onChangeValue = new EventEmitter();
        this.onAttrEntity = new EventEmitter();
        this.onGrandChildrenEntity = new EventEmitter();
        this.afterSave = new EventEmitter();
        this.onResetEntity = new EventEmitter();
        this.onView = new EventEmitter();
        this.onIconClicked = new EventEmitter();
        this.showForm = false;
        this.showDelete = false;
        this.indexEdit = -1;
        this.objArrayValues = [];
        this.onEditIndex = (index) => -1;
    }
    ngOnInit() {
        this.reset();
        if (this.crudFormDetail) {
            this.crudFormDetail.onAttrEntity.subscribe(entity => {
                this.loadFormArray(resolvePath(entity, this.arrayPropertyName, []), this.formArray);
            });
            this.crudFormDetail.onGrandChildrenEntity.subscribe(data => {
                this.loadFormArray(resolvePath(data.entity, this.arrayPropertyName, []), data.formGroup.get(this.arrayPropertyName));
            });
            this.crudFormDetail.onResetEntity.subscribe(() => {
                this.loadFormArray([], this.formArray);
            });
        }
        else {
            this.crudForm.onAttrEntity.subscribe(entity => {
                this.loadFormArray(resolvePath(entity, this.arrayPropertyName, []), this.formArray);
            });
        }
    }
    ngAfterContentInit() {
        this.eloTableActions.forEach(tb => this.dataTable.addTableActions(tb));
    }
    onDelete(itemToRemove) {
        this.itemToRemove = itemToRemove;
        this.showDelete = true;
    }
    cancelDelete() {
        this.showDelete = false;
    }
    delete() {
        this.showDelete = false;
        let index = this.formArray.value.indexOf(this.itemToRemove);
        this.formArray.removeAt(index);
        this.formArray.markAsDirty();
        if (this.onChangeValue)
            this.onChangeValue.emit(this.formArray);
    }
    save() {
        if (this.beforeSave)
            this.beforeSave();
        if (this.indexEdit >= 0) {
            let formGroup = this.formArray.at(this.indexEdit);
            formGroup.reset(this.form.value);
            this.objArrayValues[this.indexEdit] = this.form.value;
            this.onGrandChildrenEntity.emit({ formGroup: formGroup, entity: this.form.value });
        }
        else {
            let formGroup = this.formCreate();
            formGroup.reset(this.form.value);
            this.formArray.push(formGroup);
            this.objArrayValues.push(this.form.value);
            this.onGrandChildrenEntity.emit({ entity: this.form.value, formGroup: formGroup });
        }
        if (this.afterSave)
            this.afterSave.emit(this.form.value);
        this.reset();
        this.formArray.markAsDirty();
        this.formArray.updateValueAndValidity();
        if (this.onChangeValue)
            this.onChangeValue.emit(this.formArray);
    }
    cancel() {
        this.reset();
    }
    editItem(item) {
        this.indexEdit = this.formArray.value.indexOf(item);
        this.onEditIndex(this.indexEdit);
        this.form.reset(this.formArray.at(this.indexEdit).value);
        this.showForm = true;
        this.onAttrEntity.emit(this.objArrayValues[this.indexEdit]);
    }
    reset() {
        this.form.reset(this.formCreate().value, { emitEvent: false });
        this.indexEdit = -1;
        this.showForm = false;
        this.onEditIndex(this.indexEdit);
    }
    newItem() {
        this.reset();
        this.onResetEntity.emit();
        this.showForm = true;
    }
    get formArray() {
        if (this.crudFormDetail) {
            return this.crudFormDetail.form.get(this.arrayPropertyName);
        }
        return this.crudForm.form.get(this.arrayPropertyName);
    }
    onClickView(obj) {
        this.onView.emit(obj);
        this.onEditIndex(this.formArray.value.indexOf(obj));
    }
    onClickLink(object) {
        this.onIconClicked.emit(object);
    }
    clickSelect(selection) {
        this.onModifySelection.emit(selection);
    }
    loadFormArray(objArray, formArray) {
        this.objArrayValues = objArray;
        if (this.objArrayValues) {
            while (formArray.length > 0) {
                formArray.removeAt(0);
            }
            this.objArrayValues.forEach(obj => {
                let form = this.formCreate();
                this.onGrandChildrenEntity.emit({ entity: obj, formGroup: form });
                form.reset(obj, { emitEvent: false });
                formArray.push(form);
            });
        }
    }
}
CrudFormDetailComponent.ɵfac = function CrudFormDetailComponent_Factory(t) { return new (t || CrudFormDetailComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(CrudFormComponent), ɵngcc0.ɵɵdirectiveInject(CrudFormDetailComponent, 12)); };
CrudFormDetailComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudFormDetailComponent, selectors: [["crud-form-detail"]], contentQueries: function CrudFormDetailComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c34, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, EloTableActionsComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.eloColumnsTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.eloTableActions = _t);
    } }, viewQuery: function CrudFormDetailComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(EloDatatableComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dataTable = _t.first);
    } }, inputs: { hideListWhenAdd: "hideListWhenAdd", enableRemove: "enableRemove", disableButtonNovo: "disableButtonNovo", disableButtonSalvar: "disableButtonSalvar", panelExpansive: "panelExpansive", nameBtnSave: "nameBtnSave", visibleWhenFunction: "visibleWhenFunction", hasLinks: "hasLinks", getLinks: "getLinks", beforeSave: "beforeSave", visibleWhenFunctionLink: "visibleWhenFunctionLink", manyActions: "manyActions", quickView: "quickView", hideButtonNovo: "hideButtonNovo", hideButtonUpdate: "hideButtonUpdate", alwaysShowForm: "alwaysShowForm", btnSaveHasFormGroup: "btnSaveHasFormGroup", isInsideTab: "isInsideTab", showButtonCancelar: "showButtonCancelar", onEditIndex: "onEditIndex", caption: "caption", form: "form", fieldsToDisplay: "fieldsToDisplay", formCreate: "formCreate", hideButtonNovoAndUpdate: "hideButtonNovoAndUpdate", hideButtonRemove: "hideButtonRemove", arrayPropertyName: "arrayPropertyName", selectionMode: "selectionMode", selection: "selection", extraButtons: "extraButtons" }, outputs: { onModifySelection: "onModifySelection", onChangeValue: "onChangeValue", onAttrEntity: "onAttrEntity", onGrandChildrenEntity: "onGrandChildrenEntity", afterSave: "afterSave", onResetEntity: "onResetEntity", onView: "onView", onIconClicked: "onIconClicked" }, ngContentSelectors: _c37, decls: 14, vars: 25, consts: [[3, "show", "onOkEvent", "onCancelEvent"], [3, "expansive", "title", "disabledButton", "isInsideTab", "showButton", "hideButtonNovo", "extraButtons", "onNewItem"], [4, "ngIf"], ["id", "hiddenDataTable", 2, "padding-right", "7px", "padding-left", "7px", 3, "hidden"], [1, "border", "striped", 3, "values", "manyActions", "selectionMode", "selection", "isQuickViewOpener", "onModifySelection"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], ["icon", "fa fa-pencil", 3, "title", "visible", "visibleWhenFunction", "onClickIconButton"], ["icon", "fa fa-trash", 3, "title", "visible", "visibleWhenFunction", "onClickIconButton"], ["icon", "fa fa-eye", "id", "idView", 3, "title", "onClickIconButton", 4, "ngIf"], ["icon", "fa fa-list-ul", "id", "idLinks", 3, "visibleWhenFunction", "linksFunction", "hasLinks", "onClickLink", 4, "ngIf"], [1, "align-group", "mt-xs", "mb-xs"], ["id", "btnSave", "type", "button", "class", "btn positive inline icon-left", 3, "disabled", "click", 4, "ngIf", "ngIfElse"], ["formGroupSave", ""], ["id", "btnCancel", "type", "button", "class", "btn negative inline icon-right", 3, "click", 4, "ngIf"], ["id", "btnSave", "type", "button", 1, "btn", "positive", "inline", "icon-left", 3, "disabled", "click"], [1, "fa", "fa-check"], [1, "form-group"], ["id", "btnCancel", "type", "button", 1, "btn", "negative", "inline", "icon-right", 3, "click"], [1, "fa", "fa-times"], [3, "field", "header", "hidden", "isDecimal", "digits", "isDate", 4, "ngFor", "ngForOf"], [3, "field", "header", "hidden", "isDecimal", "digits", "isDate"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["icon", "fa fa-eye", "id", "idView", 3, "title", "onClickIconButton"], ["icon", "fa fa-list-ul", "id", "idLinks", 3, "visibleWhenFunction", "linksFunction", "hasLinks", "onClickLink"]], template: function CrudFormDetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c36);
        ɵngcc0.ɵɵelementStart(0, "elo-dialog", 0);
        ɵngcc0.ɵɵlistener("onOkEvent", function CrudFormDetailComponent_Template_elo_dialog_onOkEvent_0_listener() { return ctx.delete(); })("onCancelEvent", function CrudFormDetailComponent_Template_elo_dialog_onCancelEvent_0_listener() { return ctx.cancelDelete(); });
        ɵngcc0.ɵɵtext(1, " Apagar?\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "elo-panel-expansive", 1);
        ɵngcc0.ɵɵlistener("onNewItem", function CrudFormDetailComponent_Template_elo_panel_expansive_onNewItem_2_listener() { return ctx.newItem(); });
        ɵngcc0.ɵɵtemplate(3, CrudFormDetailComponent_div_3_Template, 7, 3, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "elo-datatable", 4);
        ɵngcc0.ɵɵlistener("onModifySelection", function CrudFormDetailComponent_Template_elo_datatable_onModifySelection_6_listener($event) { return ctx.clickSelect($event); });
        ɵngcc0.ɵɵtemplate(7, CrudFormDetailComponent_ng_container_7_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(8, CrudFormDetailComponent_ng_container_8_Template, 1, 5, "ng-container", 5);
        ɵngcc0.ɵɵelementStart(9, "elo-table-actions", 6);
        ɵngcc0.ɵɵlistener("onClickIconButton", function CrudFormDetailComponent_Template_elo_table_actions_onClickIconButton_9_listener($event) { return ctx.editItem($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "elo-table-actions", 7);
        ɵngcc0.ɵɵlistener("onClickIconButton", function CrudFormDetailComponent_Template_elo_table_actions_onClickIconButton_10_listener($event) { return ctx.onDelete($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, CrudFormDetailComponent_elo_table_actions_11_Template, 1, 1, "elo-table-actions", 8);
        ɵngcc0.ɵɵtemplate(12, CrudFormDetailComponent_elo_table_actions_12_Template, 1, 3, "elo-table-actions", 9);
        ɵngcc0.ɵɵprojection(13, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("show", ctx.showDelete);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ctx.caption);
        ɵngcc0.ɵɵproperty("expansive", ctx.panelExpansive)("disabledButton", ctx.disableButtonNovo)("isInsideTab", ctx.isInsideTab)("showButton", !ctx.showForm && !ctx.hideButtonNovoAndUpdate)("hideButtonNovo", ctx.hideButtonNovo)("extraButtons", ctx.extraButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showForm || ctx.alwaysShowForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.showForm && ctx.hideListWhenAdd);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("values", ctx.formArray == null ? null : ctx.formArray.value)("manyActions", ctx.manyActions)("selectionMode", ctx.selectionMode)("selection", ctx.selection)("isQuickViewOpener", ctx.quickView);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.eloColumnsTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.eloColumnsTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", "Editar")("visible", !ctx.hideButtonNovoAndUpdate && !ctx.hideButtonUpdate)("visibleWhenFunction", ctx.visibleWhenFunction);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", "Excluir")("visible", ctx.enableRemove)("visibleWhenFunction", ctx.visibleWhenFunction);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.quickView);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasLinks);
    } }, directives: [DialogComponent, PanelExpansiveComponent, ɵngcc2.NgIf, EloDatatableComponent, EloTableActionsComponent, ɵngcc2.NgForOf, EloColumnComponent, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
CrudFormDetailComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: CrudFormComponent },
    { type: CrudFormDetailComponent, decorators: [{ type: SkipSelf }, { type: Optional }] }
];
CrudFormDetailComponent.propDecorators = {
    caption: [{ type: Input }],
    form: [{ type: Input }],
    fieldsToDisplay: [{ type: Input }],
    formCreate: [{ type: Input }],
    hideButtonNovoAndUpdate: [{ type: Input }],
    hideButtonRemove: [{ type: Input }],
    hideListWhenAdd: [{ type: Input }],
    arrayPropertyName: [{ type: Input }],
    enableRemove: [{ type: Input }],
    disableButtonNovo: [{ type: Input }],
    disableButtonSalvar: [{ type: Input }],
    panelExpansive: [{ type: Input }],
    nameBtnSave: [{ type: Input }],
    visibleWhenFunction: [{ type: Input }],
    hasLinks: [{ type: Input }],
    getLinks: [{ type: Input }],
    beforeSave: [{ type: Input }],
    visibleWhenFunctionLink: [{ type: Input }],
    manyActions: [{ type: Input }],
    quickView: [{ type: Input }],
    selectionMode: [{ type: Input }],
    selection: [{ type: Input }],
    hideButtonNovo: [{ type: Input }],
    hideButtonUpdate: [{ type: Input }],
    alwaysShowForm: [{ type: Input }],
    extraButtons: [{ type: Input }],
    btnSaveHasFormGroup: [{ type: Input }],
    isInsideTab: [{ type: Input }],
    showButtonCancelar: [{ type: Input }],
    onModifySelection: [{ type: Output }],
    onChangeValue: [{ type: Output }],
    onAttrEntity: [{ type: Output }],
    onGrandChildrenEntity: [{ type: Output }],
    afterSave: [{ type: Output }],
    onResetEntity: [{ type: Output }],
    onView: [{ type: Output }],
    onIconClicked: [{ type: Output }],
    eloColumnsTemplate: [{ type: ContentChild, args: ['eloColumns',] }],
    eloTableActions: [{ type: ContentChildren, args: [EloTableActionsComponent, { descendants: true },] }],
    dataTable: [{ type: ViewChild, args: [EloDatatableComponent, { static: true },] }],
    onEditIndex: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudFormDetailComponent, [{
        type: Component,
        args: [{
                selector: 'crud-form-detail',
                template: "<elo-dialog [show]=\"showDelete\" (onOkEvent)=\"delete()\" (onCancelEvent)=\"cancelDelete()\">\n  Apagar?\n</elo-dialog>\n\n<elo-panel-expansive [expansive]=\"panelExpansive\" title=\"{{caption}}\" [disabledButton]=\"disableButtonNovo\" [isInsideTab]=\"isInsideTab\"\n  (onNewItem)=\"newItem()\" [showButton]=\"!showForm && !hideButtonNovoAndUpdate\" [hideButtonNovo]=\"hideButtonNovo\"\n  [extraButtons]=\"extraButtons\">\n\n  <div *ngIf=\"showForm || alwaysShowForm\">\n\n    <ng-content select=\"[inputs]\"></ng-content>\n\n    <div class=\"align-group mt-xs mb-xs\">\n      <button id=\"btnSave\" type=\"button\" class=\"btn positive inline icon-left\" (click)=\"save()\"\n        [disabled]=\"(!form.valid || form.pristine) || disableButtonSalvar\" *ngIf=\"!btnSaveHasFormGroup; else formGroupSave\">\n        <em class=\"fa fa-check\"></em>\n        {{nameBtnSave}}\n      </button>\n\n      <ng-template #formGroupSave>\n        <div class=\"form-group\">\n          <button id=\"btnSave\" type=\"button\" class=\"btn positive inline icon-left\" (click)=\"save()\"\n                  [disabled]=\"(!form.valid || form.pristine) || disableButtonSalvar\">\n                  <em class=\"fa fa-check\"></em>\n                  {{nameBtnSave}}\n          </button>\n        </div>\n      </ng-template>\n\n      <button id=\"btnCancel\" type=\"button\" class=\"btn negative inline icon-right\" (click)=\"cancel()\" \n        *ngIf=\"(!alwaysShowForm || (indexEdit !== null && indexEdit >= 0)) && showButtonCancelar\">\n        <em class=\"fa fa-times\"></em>\n        Cancelar\n      </button>\n    </div>\n\n  </div>\n\n  <ng-content select=\"[tableArea]\"></ng-content>\n\n  <div id=\"hiddenDataTable\" style=\"padding-right: 7px;padding-left: 7px\" [hidden]=\"showForm && hideListWhenAdd\">\n    <elo-datatable [values]=\"formArray?.value\" class=\"border striped\" [manyActions]=\"manyActions\"\n      [selectionMode]=\"selectionMode\" (onModifySelection)=\"clickSelect($event)\" [selection]=\"selection\"\n      [isQuickViewOpener]=\"quickView\">\n      <ng-container *ngIf=\"!eloColumnsTemplate\">\n        <elo-column *ngFor=\"let field of fieldsToDisplay\" [field]=\"field.field\" [header]=\"field.header\"\n          [hidden]=\"field.hidden\" [isDecimal]=\"field.isDecimal\" [digits]=\"field.digits\" [isDate]=\"field.isDate\">\n        </elo-column>\n      </ng-container>\n      <ng-container *ngIf=\"eloColumnsTemplate\" [ngTemplateOutlet]=\"eloColumnsTemplate\"\n        [ngTemplateOutletContext]=\"{dataTable: dataTable, fieldsModels: fieldsToDisplay}\">\n      </ng-container>\n      <elo-table-actions [title]=\"'Editar'\" icon='fa fa-pencil' [visible]=\"!hideButtonNovoAndUpdate && !hideButtonUpdate\"\n        [visibleWhenFunction]=\"visibleWhenFunction\" (onClickIconButton)=\"editItem($event)\"></elo-table-actions>\n      <elo-table-actions [title]=\"'Excluir'\" icon='fa fa-trash' [visible]=\"enableRemove\"\n        [visibleWhenFunction]=\"visibleWhenFunction\" (onClickIconButton)=\"onDelete($event)\"></elo-table-actions>\n      <elo-table-actions *ngIf=\"quickView\" [title]=\"'Visualizar'\" icon='fa fa-eye' id=\"idView\"\n        (onClickIconButton)=\"onClickView($event)\">\n      </elo-table-actions>\n      <elo-table-actions [visibleWhenFunction]=\"visibleWhenFunctionLink\" icon='fa fa-list-ul' id=\"idLinks\"\n        (onClickLink)=\"onClickLink($event)\" [linksFunction]=\"getLinks\" [hasLinks]=\"hasLinks\" *ngIf=\"hasLinks\">\n      </elo-table-actions>\n      <ng-content select=\"[actions]\"></ng-content>\n\n    </elo-datatable>\n  </div>\n</elo-panel-expansive>\n"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: CrudFormComponent }, { type: CrudFormDetailComponent, decorators: [{
                type: SkipSelf
            }, {
                type: Optional
            }] }]; }, { hideListWhenAdd: [{
            type: Input
        }], enableRemove: [{
            type: Input
        }], disableButtonNovo: [{
            type: Input
        }], disableButtonSalvar: [{
            type: Input
        }], panelExpansive: [{
            type: Input
        }], nameBtnSave: [{
            type: Input
        }], visibleWhenFunction: [{
            type: Input
        }], hasLinks: [{
            type: Input
        }], getLinks: [{
            type: Input
        }], beforeSave: [{
            type: Input
        }], visibleWhenFunctionLink: [{
            type: Input
        }], manyActions: [{
            type: Input
        }], quickView: [{
            type: Input
        }], hideButtonNovo: [{
            type: Input
        }], hideButtonUpdate: [{
            type: Input
        }], alwaysShowForm: [{
            type: Input
        }], btnSaveHasFormGroup: [{
            type: Input
        }], isInsideTab: [{
            type: Input
        }], showButtonCancelar: [{
            type: Input
        }], onModifySelection: [{
            type: Output
        }], onChangeValue: [{
            type: Output
        }], onAttrEntity: [{
            type: Output
        }], onGrandChildrenEntity: [{
            type: Output
        }], afterSave: [{
            type: Output
        }], onResetEntity: [{
            type: Output
        }], onView: [{
            type: Output
        }], onIconClicked: [{
            type: Output
        }], onEditIndex: [{
            type: Input
        }], caption: [{
            type: Input
        }], form: [{
            type: Input
        }], fieldsToDisplay: [{
            type: Input
        }], formCreate: [{
            type: Input
        }], hideButtonNovoAndUpdate: [{
            type: Input
        }], hideButtonRemove: [{
            type: Input
        }], arrayPropertyName: [{
            type: Input
        }], selectionMode: [{
            type: Input
        }], selection: [{
            type: Input
        }], extraButtons: [{
            type: Input
        }], eloColumnsTemplate: [{
            type: ContentChild,
            args: ['eloColumns']
        }], eloTableActions: [{
            type: ContentChildren,
            args: [EloTableActionsComponent, { descendants: true }]
        }], dataTable: [{
            type: ViewChild,
            args: [EloDatatableComponent, { static: true }]
        }] }); })();

class CrudFormDetailModule {
}
CrudFormDetailModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudFormDetailModule });
CrudFormDetailModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudFormDetailModule_Factory(t) { return new (t || CrudFormDetailModule)(); }, imports: [[FormsModule, ReactiveFormsModule, DialogModule, EloDatatableModule, PanelExpansiveModule], FormsModule, ReactiveFormsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudFormDetailModule, { declarations: function () { return [CrudFormDetailComponent]; }, imports: function () { return [FormsModule, ReactiveFormsModule, DialogModule, EloDatatableModule, PanelExpansiveModule]; }, exports: function () { return [CrudFormDetailComponent, FormsModule, ReactiveFormsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudFormDetailModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, ReactiveFormsModule, DialogModule, EloDatatableModule, PanelExpansiveModule],
                declarations: [CrudFormDetailComponent],
                exports: [CrudFormDetailComponent, FormsModule, ReactiveFormsModule]
            }]
    }], null, null); })();

// @dynamic
class FormUtils {
    static equals(prop) {
        return (obj1, obj2) => {
            if (!obj1 || !obj2) {
                return false;
            }
            return obj1[prop] === obj2[prop];
        };
    }
    /**
     * Marca todos os controls do Form como dirty
     * @param formGroup - formGroup a ser validado
     */
    static markFormGroupDirty(formGroup) {
        Object.values(formGroup.controls).forEach(control => {
            if (control.invalid) {
                control.markAsDirty();
                control.updateValueAndValidity();
                if (control.controls) {
                    this.markFormGroupDirty(control);
                }
            }
        });
    }
    static clearArray(objArray) {
        while (objArray.length > 0) {
            objArray.removeAt(0);
        }
    }
}

class NumberUtils {
    static isNumeric(value) {
        return (value - parseFloat(value) + 1) >= 0;
    }
    static onlyNumbers(value) {
        if (value) {
            return value.replace(/\D/g, '');
        }
        return value;
    }
    static toFixedTrunc(value, n = 2) {
        const f = Math.pow(10, n);
        return (Math.trunc(value * f) / f).toFixed(n);
    }
    static round(value, decimals = 2) {
        const exponential = 'e';
        return Number(Math.round(value + exponential + decimals) + exponential + '-' + decimals);
    }
    static isSameValue(value1, value2, error = 0.001) {
        return Math.abs(NumberUtils.round(value1) - NumberUtils.round(value2)) <= error;
    }
    static sumValue(value1, value2, round = 2) {
        return NumberUtils.round(NumberUtils.round(value1, round) + NumberUtils.round(value2, round), round);
    }
    static sumArray(array, propertyName = '', round = 2) {
        let total = 0;
        array.forEach(item => total = NumberUtils.sumValue(total, propertyName ? item[propertyName] : item, round));
        return total;
    }
    static calculePercentage(value, percentage) {
        const valueRound = NumberUtils.round(value);
        const percentageRound = NumberUtils.round(percentage);
        return NumberUtils.round(valueRound * percentageRound / 100);
    }
    static calculePercentageValue(value, valueTotal) {
        if (NumberUtils.isSameValue(valueTotal, 0)) {
            return 0;
        }
        return NumberUtils.round((value / valueTotal) * 100);
    }
    static coalesce(value) {
        if (value) {
            return value;
        }
        return 0;
    }
    static abbreviateNumber(value) {
        let newValue = parseInt(value);
        if (newValue >= 1000 || newValue <= -1000) {
            let suffixes = ['', 'Mil', 'Mi', 'Bi', 'Ti'];
            let suffixNum = Math.floor(('' + newValue).length / 3);
            newValue = parseFloat((suffixNum !== 0 ? (newValue / Math.pow(1000, suffixNum)) : newValue));
            if (newValue > -1 && newValue < 1) {
                newValue = newValue * 1000;
                suffixNum--;
            }
            newValue = parseInt(newValue) + ' ' + suffixes[suffixNum];
        }
        return newValue;
    }
}

const INVALID_DATE$1 = 'Invalid date';
// @dynamic
class EloValidators {
    static sameValue(formControlReference) {
        return (control) => {
            const isSame = formControlReference.value === control.value;
            return isSame ? null : { 'sameValue': 'valores diferentes' };
        };
    }
    static differentValue(message, isEquals) {
        return (control) => isEquals(control) ? { 'differentValue': message } : null;
    }
    static lessEqualThan(formControlReference) {
        return (control) => {
            let isLessOrEqual;
            if (control.value) {
                if (typeof control.value === 'string') {
                    isLessOrEqual = +formControlReference.value >= +control.value.replace(',', '.');
                }
                else {
                    isLessOrEqual = +formControlReference.value >= +control.value;
                }
            }
            return isLessOrEqual ? null : { 'lessOrEqualValue': formControlReference.value + ' maior que ' + control.value };
        };
    }
    static greaterThanZero() {
        const ZERO = 0;
        return (control) => {
            return control.value && control.value > ZERO ? null : {
                'valor deve ser maior que 0': true
            };
        };
    }
    static email() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const EMAIL_REGEXP = /^[a-zA-Z0-9-_]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,15})$/;
            const valid = control.value && control.value.length > 0 && EMAIL_REGEXP.test(control.value);
            return valid ? null : { 'email': false };
        };
    }
    static siteUrl() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const URL_REGEXP = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!%\$&'\(\)\*\+,;=.]+$/;
            const valid = control.value && control.value.length > 0 && URL_REGEXP.test(control.value);
            return valid ? null : { 'url': false };
        };
    }
    static competencia() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const COMPETENCIA_REGEXP = /^(0[1-9]|1[012])+(\/?[12][0-9]{3})$/;
            const valid = control.value && control.value.length > 0 && COMPETENCIA_REGEXP.test(control.value);
            return valid ? null : { 'competencia': false };
        };
    }
    static containedInValidator() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const BETWEEN_REGEXP = /^\d+(,\d+|(\d+-\d+))*$/;
            const valid = control.value && control.value.length > 0 && BETWEEN_REGEXP.test(control.value);
            return valid ? null : { 'pattern': false };
        };
    }
    /**
     * Ideal utilizar com o campo input de tipo datetime-local
     */
    static dateTimeNotSmaller(formControlReference) {
        return (control) => {
            const valueReference = formControlReference.value;
            const valueControl = control.value;
            if (valueControl && valueReference) {
                const [dataReference, horaReference] = valueReference.split('T');
                const [dataControl, horaControl] = valueControl.split('T');
                const datasIguais = moment(dataReference).isSame(dataControl);
                const dataInvalida = DateUtils.smallerDate(new Date(dataControl), new Date(dataReference));
                const horaInvalida = horaReference > horaControl;
                if (dataInvalida || (datasIguais && horaInvalida)) {
                    return {
                        validateDateTimeNotSmaller: {
                            valid: false,
                            dataHoraMinima: DateUtils.dateTimeFormat(dataReference, horaReference)
                        }
                    };
                }
                return null;
            }
            return null;
        };
    }
    /*
     * Pega o value do form, e troca o - por / para criar um Date
     *
     * Ideal para utilizar esse Validator em um atributo do form que utilize o componente elo-datepicker
     */
    static dateNotSmaller(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl && valueControlReference) {
                let dataMinima = new Date(valueControlReference.replace(/\-/gi, '/'));
                return DateUtils.smallerDate(new Date(valueControl.replace(/\-/gi, '/')), dataMinima) ?
                    {
                        validateDateNotSmaller: {
                            valid: false,
                            dataMinima: DateUtils.format(dataMinima, 'DD/MM/YYYY')
                        }
                    } : null;
            }
        };
    }
    static dateNotGreater(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl && valueControlReference) {
                let dataMaxima = new Date(valueControlReference.replace(/\-/gi, '/'));
                return DateUtils.greaterDate(new Date(valueControl.replace(/\-/gi, '/')), dataMaxima) ?
                    {
                        validateDateNotGreater: {
                            valid: false,
                            dataMaxima: DateUtils.format(dataMaxima, 'DD/MM/YYYY')
                        }
                    } : null;
            }
        };
    }
    static competenciaNotSmaller(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl && valueControlReference && valueControlReference.inicioCompetencia && valueControl.inicioCompetencia) {
                let dataMinima = new Date(valueControlReference.inicioCompetencia.replace(/\-/gi, '/'));
                return DateUtils.smallerDate(new Date(valueControl.inicioCompetencia.replace(/\-/gi, '/')), dataMinima) ? { 'competencia-minima': DateUtils.format(dataMinima, 'DD/MM/YYYY', 'MM/YYYY') } : null;
            }
        };
    }
    static conditionalValidator(validatorFn, conditionFn, conditionControls = []) {
        return EloValidators.internalConditionalValidator(validatorFn, conditionFn, conditionControls);
    }
    static conditionalValidatorOnField(validatorFn, conditionFn, conditionControls = []) {
        return EloValidators.internalConditionalValidator(validatorFn, conditionFn, conditionControls, true);
    }
    static dateCompetencia(usuarioInfo) {
        return (control) => {
            if (!control.value) {
                return { 'requerido': true };
            }
            if (!usuarioInfo) {
                return { 'competência não configurada': true };
            }
            const date = DateUtils.getDateFromString(control.value);
            if (usuarioInfo.mesPadrao !== date.getMonth() + 1 ||
                usuarioInfo.exercicioPadrao !== date.getFullYear()) {
                return { 'dataCompetencia': false };
            }
            return null;
        };
    }
    static competenciaValidator(usuarioInfo) {
        return (control) => {
            if (!usuarioInfo) {
                return { 'competência não configurada': true };
            }
            if (usuarioInfo.situacaoPadrao !== 'Aberto') {
                return { 'competenciaAberta': false };
            }
            return null;
        };
    }
    /* Valor digitado maior igual ao valor do form */
    static greaterThanEquals(value, customMessage = 'valorMaior') {
        return (control) => {
            return control.value > value ? { [customMessage]: value } : null;
        };
    }
    static smallerThanEquals(value, customMessage = 'menorValor') {
        return (control) => {
            return control.value < value ? { [customMessage]: value } : null;
        };
    }
    static cpfValidator() {
        return (control) => {
            return isValid(control.value, [util.isCpf]) ? null : { 'CPF inválido': true };
        };
    }
    static cnpjValidator() {
        return (control) => {
            return isValid(control.value, [util.isCnpj]) ? null : { 'cnpj_invalid': true };
        };
    }
    static validadeCnhValidator(data) {
        return (control) => {
            const { value } = control;
            let dataSubtract = data
                ? moment(data).subtract(30, 'days').format(FROM_FORMAT)
                : moment().subtract(30, 'days').format(FROM_FORMAT);
            if (value) {
                return moment(value.validadeCNH).isBefore(dataSubtract)
                    ? { 'Motorista com CNH vencida a mais de 30 dias': true }
                    : null;
            }
        };
    }
    static horaQuantityValidator() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const HORA_REGEXP = /^([0-9]+):[0-5][0-9]?$/;
            const valid = control.value && control.value.length > 0 && HORA_REGEXP.test(control.value);
            return valid ? null : { 'mensagemGenerica': { valid: false, mensagem: '(A hora informada é invalida) ' } };
        };
    }
    static horaValidator() {
        return (control) => {
            if (!control.value) {
                return null;
            }
            const HORA_REGEXP = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]?$/;
            const valid = control.value && control.value.length > 0 && HORA_REGEXP.test(control.value);
            return valid ? null : { 'hora': false };
        };
    }
    static numberGreaterThan(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl === null || valueControlReference === null)
                return null;
            let result = (valueControl >= valueControlReference);
            return result ? null : { minvalue: valueControlReference };
        };
    }
    static numberLessThan(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl === null || valueControlReference === null)
                return null;
            let result = (valueControl <= valueControlReference);
            return result ? null : { maxvalue: valueControlReference };
        };
    }
    static hourLessThan(formControlReference) {
        return (control) => {
            if (!control.value || !formControlReference.value)
                return null;
            let valueControl = Number(control.value.replace(':', '.'));
            let valueControlReference = Number(formControlReference.value.replace(':', '.'));
            if (valueControl === null || valueControlReference === null)
                return null;
            let result = (valueControl <= valueControlReference);
            return result ? null : { 'maxvalue': formControlReference.value };
        };
    }
    static hourGreaterThan(formControlReference) {
        return (control) => {
            if (!control.value || !formControlReference.value)
                return null;
            let valueControl = Number(control.value.replace(':', '.'));
            let valueControlReference = Number(formControlReference.value.replace(':', '.'));
            if (valueControl === null || valueControlReference === null)
                return null;
            let result = (valueControl >= valueControlReference);
            return result ? null : { minvalue: formControlReference.value };
        };
    }
    static hourNotSmaller(formControlReference) {
        return (control) => {
            let valueControl = control.value;
            let valueControlReference = formControlReference.value;
            if (valueControl && valueControlReference) {
                let dataMinima = new Date('01/01/2018 ' + valueControlReference);
                let dataDigitada = new Date('01/01/2018 ' + valueControl);
                return DateUtils.smallerDate(dataDigitada, dataMinima) ? {
                    validateHourNotSmaller: {
                        valid: false,
                        horaMinima: valueControlReference
                    }
                } : null;
            }
        };
    }
    /**
     * @param control - Espera um control com a data no formato YYYY-MM-DD, ideal quando utilizado com elo-datepicker.
    */
    static dateNotWeekend() {
        return (control) => {
            let valueControl = control.value;
            if (valueControl) {
                return DateUtils.isWeekend(valueControl)
                    ? { dateNotWeekend: { valid: false } }
                    : null;
            }
        };
    }
    static dateNotSmallerDate(data) {
        return (control) => {
            let valueControl = control.value;
            if (valueControl && data) {
                let dataMinima = DateUtils.getDateFromString(data);
                return DateUtils.smallerDate(valueControl, dataMinima)
                    ? {
                        validateDateNotSmaller: {
                            valid: false,
                            dataMinima: DateUtils.format(dataMinima, 'DD/MM/YYYY')
                        }
                    }
                    : null;
            }
        };
    }
    static dayNotSmallerOrEqualsDay(data) {
        return (control) => {
            let valueControl = control.value;
            if (valueControl && data) {
                let dataMinima = DateUtils.getDateFromString(data);
                return DateUtils.isDaySmallerDate(valueControl, dataMinima)
                    ? {
                        validateDateNotSmaller: {
                            valid: false,
                            dataMinima: DateUtils.format(dataMinima, 'DD/MM/YYYY')
                        }
                    }
                    : null;
            }
        };
    }
    static dateNotGreaterDate(data) {
        return (control) => {
            let valueControl = control.value;
            if (valueControl && data) {
                let dataMaxima = DateUtils.getDateFromString(data);
                return DateUtils.greaterDate(new Date(valueControl.replace(/\-/gi, '/')), dataMaxima) ?
                    {
                        validateDateNotGreater: {
                            valid: false,
                            dataMaxima: DateUtils.format(dataMaxima, 'DD/MM/YYYY')
                        }
                    } : null;
            }
        };
    }
    static dateEqualYear(data) {
        return (control) => {
            let valueControl = control.value;
            if (valueControl && data) {
                let dataYear = DateUtils.getDateFromString(data);
                const date = DateUtils.getDateFromString(control.value);
                if (dataYear.getFullYear() !== date.getFullYear()) {
                    return {
                        validateDateNotGreaterYear: {
                            valid: false,
                            yearMaximo: dataYear.getFullYear()
                        }
                    };
                }
                return null;
            }
        };
    }
    static obrigatorioBy(functionRequired) {
        return (control) => {
            if (functionRequired()) {
                return Validators.required(control);
            }
            return null;
        };
    }
    static isNumeric() {
        return (control) => {
            if (control.value && control.value.length > 0 && (!NumberUtils.isNumeric(control.value) || control.value.toString().includes('.'))) {
                return { 'Valor deve conter apenas números.': '' };
            }
            return null;
        };
    }
    static sumEqual(controlValueBase, formFields, customMessage = 'somaValor') {
        let hasSubscription = false;
        return (control) => {
            if (!hasSubscription) {
                hasSubscription = true;
                controlValueBase.valueChanges.subscribe(() => control.updateValueAndValidity());
            }
            const baseValue = NumberUtils.round(controlValueBase.value);
            let isSumEquals = true;
            control.controls.forEach(innerControl => {
                const sumArray = formFields
                    .map(field => parseFloat(innerControl.get(field).value))
                    .reduce((preview, current) => preview + current);
                isSumEquals = isSumEquals && (NumberUtils.round(sumArray) === baseValue);
            });
            return isSumEquals ? null : { [customMessage]: controlValueBase };
        };
    }
    static sumEqualValue(value, fieldName, customMessage = 'somaValor') {
        return (control) => {
            const sumArray = control.controls.map(form => form.get(fieldName) && form.get(fieldName).value && parseFloat(form.get(fieldName).value))
                .reduce((preview, current) => preview + current, 0);
            return NumberUtils.isSameValue(sumArray, value, 0.001) ? null : { [customMessage]: value };
        };
    }
    static invalidDate() {
        return (control) => {
            return (control.value === INVALID_DATE$1) ? {
                validateDate: { valid: false }
            } : null;
        };
    }
    static asyncValidatorWrapper(validatorFn) {
        return (control) => {
            if (!control.value || control.pristine) {
                return of(null);
            }
            return validatorFn(control);
        };
    }
    static asyncConditionalValidator(validatorFn, conditionFn, conditionControls = []) {
        return (control) => {
            conditionControls.forEach(ctrl => {
                ctrl.valueChanges.subscribe(() => control.updateValueAndValidity());
            });
            if (conditionFn()) {
                return validatorFn(control);
            }
            return of(null);
        };
    }
    static internalConditionalValidator(validatorFn, conditionFn, conditionControls = [], innerFunction = false) {
        let hasSubscription = false;
        return (control) => {
            if (!hasSubscription) {
                conditionControls.forEach(ctrl => {
                    ctrl.valueChanges.subscribe(() => control.updateValueAndValidity());
                });
                hasSubscription = true;
            }
            if (conditionFn()) {
                return innerFunction ? validatorFn()(control) : validatorFn(control);
            }
            return null;
        };
    }
}

class SearchFilterComponent {
    constructor(fb) {
        this.fb = fb;
        this.operatorsByType = new Map();
        this.filterItemByType = new Map();
        this.filterType = 'text';
        this.enumOptions = [];
        this.booleanOptions = [];
        this.placeHolder = 'Digite o filtro';
        this.classInput = '';
        this.filtersDefaults = [];
        this.fieldsModels = [];
        this.onFilter = new EventEmitter();
        this.allowSearch = true;
        this.operatorsByType = operatorsFilter.getOperatorsByType();
        this.filterItemByType = operatorsFilter.getFilterItemByType();
    }
    ngOnChanges() {
        if (this.allowSearch) {
            this.setDefaults();
        }
    }
    ngOnInit() {
        this.filterItens = this.fb.array([
            this.initFilterItem()
        ]);
        this.form = this.fb.group({
            filterItens: this.filterItens
        });
        this.setDefaults();
    }
    ngAfterViewInit() {
        let btnWidth = this.btnFiltro.nativeElement.clientWidth;
        this.inputFilter.nativeElement.style.width = 'calc(100% - ' + btnWidth + 'px)';
    }
    initFilterItem() {
        const field = new FormControl('', Validators.required);
        const operator = new FormControl('', Validators.required);
        field.valueChanges.subscribe(value => {
            this.loadFilterOptions(value);
            this.loadFilterItemType(value);
            this.focus();
        });
        operator.valueChanges.subscribe(operatorValue => {
            let valueControl = operator.parent.get('value');
            this.placeHolder = 'Digite o filtro';
            if (this.isNumericValue()) {
                if (this.isOperatorContainedIn(operatorValue)) {
                    valueControl.setValidators([EloValidators.containedInValidator(), Validators.required]);
                    this.placeHolder = 'Digite o filtro (ex: 1 | 1,2,3 | 10-15 | 1,2,3,10-15)';
                }
                else {
                    valueControl.setValidators([EloValidators.isNumeric(), Validators.required]);
                }
            }
            else {
                valueControl.setValidators([Validators.required]);
            }
            valueControl.updateValueAndValidity();
        });
        return this.fb.group({
            field: field,
            operator: operator,
            value: [''],
            valid: [false]
        });
    }
    filter() {
        let filterActual = this.filterItens.at(0).get('field').value;
        if (filterActual.dataType === 'LocalDateTime') {
            this.formatValueToLocalDateTime();
        }
        if (filterActual.removeDot) {
            this.removeDotsOfValue();
        }
        this.addFormFilter();
        this.onFilter.emit(this.getFiltersToEmit());
        this.focus();
        this.setDefaultSelectedField(false);
    }
    removeDuplicatedFilter() {
        let filterActual = this.filterItens.at(0).get('field').value;
        let operatorActual = this.filterItens.at(0).get('operator').value;
        let filterRepeatedArray = this.filterItens.value.filter((filterItem) => filterItem.valid && (filterItem.field.fieldPath === filterActual.fieldPath && filterItem.operator.value === operatorActual.value));
        filterRepeatedArray.forEach(filterRepeated => {
            let filterIndexToDelete = this.filterItens.value.indexOf(filterRepeated);
            this.filterItens.removeAt(filterIndexToDelete);
        });
    }
    removeFilter(filter) {
        let index = this.filterItens.value.indexOf(filter);
        this.filterItens.removeAt(index);
        let itemDefault = this.filtersDefaults.filter(f => f.field === filter.field.fieldPath)[0];
        let indexDefault = this.filtersDefaults.indexOf(itemDefault);
        if (indexDefault >= 0) {
            this.filtersDefaults.splice(indexDefault, 1);
        }
        this.onFilter.emit(this.getFiltersToEmit());
        this.focus();
    }
    getValidFilter() {
        return this.filterItens.value.filter((filterItem) => filterItem.valid);
    }
    loadFilterOptions(field) {
        this.isEnum = field.isEnum;
        this.isBoolean = field.isBoolean;
        this.isInteger = field.dataType === 'Integer';
        this.isLong = field.dataType === 'Long';
        if (this.isEnum) {
            this.enumOptions = field.enumOptions.map(value => {
                return { label: value.descricao, value: value.codigo };
            });
        }
        if (this.isBoolean) {
            this.booleanOptions = [{ label: 'Sim', value: true }, { label: 'Não', value: false }];
        }
        let opIndex;
        if (this.filterItens.length > 1) {
            opIndex = this.filterItens.at(1).get('operator').value.id;
        }
        this.filterOptions = [];
        this.operatorsByType.forEach((value, key) => {
            let fieldType = field.dataType;
            if (this.isEnum) {
                fieldType = 'Enum';
            }
            if (this.isBoolean) {
                fieldType = 'Boolean';
            }
            if (this.isSameType(key, fieldType)) {
                this.filterOptions.push(value);
            }
        });
        this.filterItens.at(0).get('operator').setValue(this.filterOptions[0]);
        this.filterItens.at(0).get('value').setValue('');
    }
    focus() {
        setTimeout(() => {
            if (this.filtro && this.filtro.nativeElement) {
                this.filtro.nativeElement.focus();
            }
        });
    }
    loadFilterItemType(field) {
        this.filterItemByType.forEach((value, key) => {
            if (key.indexOf(field.dataType) >= 0) {
                this.filterType = value;
            }
        });
    }
    isDate() {
        return this.filterType === 'date';
    }
    isDateTime() {
        return this.filterType === 'dateTime';
    }
    isTime() {
        return this.filterType === 'time';
    }
    isNumericValue() {
        return this.isInteger || this.isLong;
    }
    isOperatorContainedIn(operatorValue) {
        return operatorValue.value === '=ci=' || operatorValue.value === '=nci=';
    }
    getSearchTagValue(filterItem) {
        if (filterItem.field.isEnum) {
            const optionFound = filterItem.field.enumOptions.find(option => option.codigo === filterItem.value);
            if (optionFound) {
                return optionFound.descricao;
            }
        }
        if (filterItem.field.dataType === 'LocalDate') {
            return DateUtils.format(filterItem.value);
        }
        if (filterItem.field.dataType === 'LocalDateTime') {
            return DateUtils.dateTimeFormatFilter(filterItem.value);
        }
        if (filterItem.field.isBoolean) {
            return filterItem.value === true || filterItem.value === 'true' ? 'Sim' : 'Não';
        }
        return filterItem.value;
    }
    compareWith() {
        return FormUtils.equals('id');
    }
    setDefaults() {
        this.addFiltersDefaultsToForm();
        this.setDefaultSelectedField(true);
    }
    isSameType(key, fieldType) {
        return key.indexOf(fieldType) >= 0;
    }
    getFiltersToEmit() {
        return this.getValidFilter().map(f => {
            return {
                field: f.field.fieldPath,
                op: f.operator.id,
                value: f.value,
            };
        });
    }
    setDefaultSelectedField(isLoading) {
        const field = this.filterItens ? this.filterItens.at(0).get('field') : null;
        if (this.fieldsModels && this.fieldsModels.length > 0 && field && !field.value) {
            if (!isLoading && this.filterItens.length > 1) {
                field.setValue(this.filterItens.at(1).get('field').value);
            }
            else {
                const defaultFieldModel = this.fieldsModels.find(m => m.fieldPath === this.defaultField);
                field.setValue(defaultFieldModel || this.fieldsModels[0]);
            }
        }
    }
    addFormFilter() {
        this.removeDuplicatedFilter();
        this.filterItens.at(0).get('valid').setValue(true);
        this.filterItens.insert(0, this.initFilterItem());
    }
    addFiltersDefaultsToForm() {
        if (this.filterItens && this.fieldsModels && this.fieldsModels.length > 0) {
            this.filtersDefaults.forEach(filter => {
                const formGroup = this.filterItens.at(0);
                const field = this.fieldsModels.filter(m => m.fieldPath === filter.field)[0];
                const op = operatorsFilter.getOperation(filter.op);
                if (field && op) {
                    formGroup.get('field').setValue(field);
                    formGroup.get('operator').setValue(op);
                    formGroup.get('value').setValue(filter.value);
                    this.addFormFilter();
                }
            });
        }
    }
    formatValueToLocalDateTime() {
        const valueActual = this.filterItens.at(0).get('value').value;
        const hour = this.getHour();
        const localDateTime = DateUtils.dateTimeFormat(valueActual, hour);
        this.filterItens.at(0).get('value').setValue(localDateTime);
    }
    getHour() {
        return this.filterHour && this.filterHour.nativeElement.value
            ? this.filterHour.nativeElement.value
            : '12:00';
    }
    removeDotsOfValue() {
        var _a;
        const valueActual = this.filterItens.at(0).get('value').value;
        if (((_a = this.filterItens.at(0).get('operator').value) === null || _a === void 0 ? void 0 : _a.id) === EQUAL_OPERATION) {
            this.filterItens.at(0).get('operator').setValue({ id: STARTS_WITH_OPERATION, caption: STARTS_WITH_CAPTION, value: '==' });
        }
        this.filterItens.at(0).get('value').setValue(StringUtils.replaceAll(valueActual, '.', ''));
    }
}
SearchFilterComponent.ɵfac = function SearchFilterComponent_Factory(t) { return new (t || SearchFilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
SearchFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SearchFilterComponent, selectors: [["search-filter"]], viewQuery: function SearchFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c38, true);
        ɵngcc0.ɵɵviewQuery(_c39, true);
        ɵngcc0.ɵɵstaticViewQuery(_c40, true);
        ɵngcc0.ɵɵstaticViewQuery(_c41, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filtro = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filterHour = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.btnFiltro = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputFilter = _t.first);
    } }, inputs: { classInput: "classInput", filtersDefaults: "filtersDefaults", fieldsModels: "fieldsModels", allowSearch: "allowSearch", defaultField: "defaultField", beforeExtraElement: "beforeExtraElement" }, outputs: { onFilter: "onFilter" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 28, vars: 18, consts: [[1, "panel-table-filter"], [3, "formGroup", "ngSubmit"], ["formArrayName", "filterItens"], [3, "formGroup"], [4, "ngIf"], [1, "row", 3, "ngClass"], [1, "col-sm-3"], [1, "form-group"], ["id", "filter-fields", "type", "select", "placeholder", "Campos", "formControlName", "field"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "col-sm-2"], ["id", "filter-operators", "type", "select", "placeholder", "Op\u00E7\u00F5es", "formControlName", "operator", 3, "compareWith"], [1, "col-sm-7"], ["class", "group-datetime", "id", "dateTime", 4, "ngIf"], ["id", "inputFilter", 1, "button-input"], ["inputFilter", ""], ["id", "btnFilter", 1, "btn", "filter", 3, "ngClass", "disabled"], ["btnFiltro", ""], ["class", "panel-filter-tags", 4, "ngIf"], [3, "ngTemplateOutlet"], [3, "ngValue"], ["id", "dateTime", 1, "group-datetime"], ["id", "valorDate", "formControlName", "value"], ["valorFiltro", ""], [1, "input-time"], ["id", "valorTime", "type", "time", "value", "12:00", 1, "has-input-icon"], ["filterHourValue", ""], ["aria-hidden", "true", 1, "fa", "fa-clock-o", "input-icon"], ["id", "valor", "formControlName", "value", "formControlValidationMsg", "", 3, "type", "placeholder"], ["id", "valorTime", "type", "time", "formControlName", "value"], ["id", "valorSelect", "formControlName", "value", 3, "options"], [1, "panel-filter-tags"], ["class", "filter-tag", 4, "ngFor", "ngForOf"], [1, "filter-tag"], [1, "fa", "fa-times", "remove", 3, "click"]], template: function SearchFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "form", 1);
        ɵngcc0.ɵɵlistener("ngSubmit", function SearchFilterComponent_Template_form_ngSubmit_1_listener() { return ctx.filter(); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, SearchFilterComponent_div_4_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "select", 8);
        ɵngcc0.ɵɵtemplate(9, SearchFilterComponent_option_9_Template, 2, 2, "option", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 10);
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "select", 11);
        ɵngcc0.ɵɵtemplate(13, SearchFilterComponent_option_13_Template, 2, 2, "option", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 12);
        ɵngcc0.ɵɵelementStart(15, "div", 7);
        ɵngcc0.ɵɵtemplate(16, SearchFilterComponent_div_16_Template, 7, 0, "div", 13);
        ɵngcc0.ɵɵelementStart(17, "div", 14, 15);
        ɵngcc0.ɵɵtemplate(19, SearchFilterComponent_div_19_Template, 3, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(20, SearchFilterComponent_div_20_Template, 3, 0, "div", 4);
        ɵngcc0.ɵɵtemplate(21, SearchFilterComponent_div_21_Template, 3, 0, "div", 4);
        ɵngcc0.ɵɵtemplate(22, SearchFilterComponent_div_22_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(23, SearchFilterComponent_div_23_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "button", 16, 17);
        ɵngcc0.ɵɵtext(26, " Filtrar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(27, SearchFilterComponent_div_27_Template, 2, 1, "div", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.filterItens.at(0));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.beforeExtraElement);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.classInput);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fieldsModels);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("compareWith", ctx.compareWith());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.filterOptions);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isDateTime());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isDate() && !ctx.isDateTime() && !ctx.isEnum && !ctx.isBoolean && !ctx.isTime());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isDate());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isTime());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEnum);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isBoolean);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c42, ctx.isDateTime()))("disabled", !ctx.form.valid || !ctx.allowSearch || !ctx.filterItens.at(0).get("value").value && ctx.filterItens.at(0).get("value").value !== false);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filterItens.length > 0);
    } }, directives: function () { return [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.FormArrayName, ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgForOf, ɵngcc2.NgTemplateOutlet, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DatePickerComponent, ɵngcc3.DefaultValueAccessor, EloSelectComponent]; }, encapsulation: 2 });
SearchFilterComponent.ctorParameters = () => [
    { type: FormBuilder }
];
SearchFilterComponent.propDecorators = {
    defaultField: [{ type: Input }],
    classInput: [{ type: Input }],
    filtersDefaults: [{ type: Input }],
    fieldsModels: [{ type: Input }],
    onFilter: [{ type: Output }],
    filtro: [{ type: ViewChild, args: ['valorFiltro',] }],
    filterHour: [{ type: ViewChild, args: ['filterHourValue',] }],
    btnFiltro: [{ type: ViewChild, args: ['btnFiltro', { static: true },] }],
    inputFilter: [{ type: ViewChild, args: ['inputFilter', { static: true },] }],
    beforeExtraElement: [{ type: Input }],
    allowSearch: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SearchFilterComponent, [{
        type: Component,
        args: [{
                selector: 'search-filter',
                template: "<div class=\"panel-table-filter\">\n  <form [formGroup]=\"form\" (ngSubmit)=\"filter()\">\n    <div formArrayName=\"filterItens\">\n      <div [formGroup]=\"filterItens.at(0)\">\n        <div *ngIf=\"beforeExtraElement\">\n          <ng-container [ngTemplateOutlet]=\"beforeExtraElement\"></ng-container>\n        </div>\n        <div class=\"row\" [ngClass]=\"classInput\">\n          <div class=\"col-sm-3\">\n            <div class=\"form-group\">\n              <select id=\"filter-fields\" type=\"select\" placeholder=\"Campos\" formControlName=\"field\">\n                <option *ngFor=\"let field of fieldsModels\" [ngValue]=\"field\">{{field.caption}} </option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"form-group\">\n              <select id=\"filter-operators\" type=\"select\" placeholder=\"Op\u00E7\u00F5es\" formControlName=\"operator\"\n                [compareWith]=\"compareWith()\">\n                <option *ngFor=\"let option of filterOptions\" [ngValue]=\"option\"> {{option.caption}}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-sm-7\">\n            <div class=\"form-group\">\n              <div *ngIf=\"isDateTime()\" class=\"group-datetime\" id=\"dateTime\">\n                <elo-datepicker id=\"valorDate\" #valorFiltro formControlName=\"value\"></elo-datepicker>\n                <div class=\"input-time\">\n                  <input id=\"valorTime\" class=\"has-input-icon\" #filterHourValue type=\"time\" value=\"12:00\" />\n                  <i aria-hidden=\"true\" class=\"fa fa-clock-o input-icon\"></i>\n                </div>\n              </div>\n              <div id=\"inputFilter\" #inputFilter class=\"button-input\">\n                <div *ngIf=\"!isDate() && !isDateTime() && !isEnum && !isBoolean && !isTime()\">\n                  <input id=\"valor\" #valorFiltro type={{filterType}} formControlName=\"value\" formControlValidationMsg\n                    [placeholder]=\"placeHolder\" />\n                </div>\n                <div *ngIf=\"isDate()\">\n                  <elo-datepicker id=\"valorDate\" #valorFiltro formControlName=\"value\"></elo-datepicker>\n                </div>\n                <div *ngIf=\"isTime()\">\n                  <div class=\"input-time\">\n                    <input id=\"valorTime\" type=\"time\" formControlName=\"value\" />\n                  </div>\n                </div>\n                <div *ngIf=\"isEnum\">\n                  <elo-select id=\"valorSelect\" [options]=\"enumOptions\" formControlName=\"value\">\n                  </elo-select>\n                </div>\n                <div *ngIf=\"isBoolean\">\n                  <elo-select id=\"valorSelect\" [options]=\"booleanOptions\" formControlName=\"value\">\n                  </elo-select>\n                </div>\n              </div>\n              <button id=\"btnFilter\" #btnFiltro class=\"btn filter\" [ngClass]=\"{'has-input-datetime': isDateTime()}\"\n                [disabled]=\"!form.valid || !allowSearch || (!filterItens.at(0).get('value').value && filterItens.at(0).get('value').value !== false)\">\n                Filtrar\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-filter-tags\" *ngIf=\"filterItens.length > 0\">\n      <span *ngFor=\"let filterItem of getValidFilter()\" class=\"filter-tag\">{{filterItem.field.caption}}\n        {{filterItem.operator.caption}} {{getSearchTagValue(filterItem)}}<i class=\"fa fa-times remove\"\n          (click)=\"removeFilter(filterItem)\"></i>\n      </span>\n    </div>\n  </form>\n</div>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { classInput: [{
            type: Input
        }], filtersDefaults: [{
            type: Input
        }], fieldsModels: [{
            type: Input
        }], onFilter: [{
            type: Output
        }], allowSearch: [{
            type: Input
        }], defaultField: [{
            type: Input
        }], filtro: [{
            type: ViewChild,
            args: ['valorFiltro']
        }], filterHour: [{
            type: ViewChild,
            args: ['filterHourValue']
        }], btnFiltro: [{
            type: ViewChild,
            args: ['btnFiltro', { static: true }]
        }], inputFilter: [{
            type: ViewChild,
            args: ['inputFilter', { static: true }]
        }], beforeExtraElement: [{
            type: Input
        }] }); })();

class RouterUtils {
    static refreshCurrentPage(router, activatedRoute) {
        router.routeReuseStrategy.shouldReuseRoute = () => false;
        let currentUrl = router.url;
        currentUrl = currentUrl.split('?')[0];
        router.navigateByUrl(currentUrl).then(() => {
            router.navigated = false;
            router.navigate([currentUrl], { queryParams: activatedRoute.snapshot.queryParams });
        });
    }
    static sendToLogs(router, model, label, fields) {
        router.navigate(['/log'], {
            queryParams: {
                model, label, fields: fields.join(',')
            }
        });
    }
}

class AbstractAuthHttp {
}
AbstractAuthHttp.ɵfac = function AbstractAuthHttp_Factory(t) { return new (t || AbstractAuthHttp)(); };
AbstractAuthHttp.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AbstractAuthHttp, factory: AbstractAuthHttp.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbstractAuthHttp, [{
        type: Injectable
    }], null, null); })();

class CrudSearchComponent {
    constructor(routerService, router, windowService, location, activatedRoute, authHttp, eloNotificationService) {
        this.routerService = routerService;
        this.router = router;
        this.windowService = windowService;
        this.location = location;
        this.activatedRoute = activatedRoute;
        this.authHttp = authHttp;
        this.eloNotificationService = eloNotificationService;
        this.eventSelected = new EventEmitter();
        this.onClickRadioButton = new EventEmitter();
        this.shouldReuseFilter = true;
        this.sortable = true;
        this.enableRemove = true;
        this.showSearchFilter = true;
        this.enableEdit = true;
        this.enableCreate = true;
        this.enableTablePrint = true;
        this.removeVisibleWhenAttribute = '';
        this.visibleWhenAttribute = '';
        this.visibleWhenFunction = null;
        this.searchSelect = false;
        this.refreshEmit = null;
        this.changeLocationOnFilter = true;
        this.filterDefault = '';
        this.deleteFunction = null;
        this.editFunction = null;
        this.role = '';
        this.disableSpinner = false;
        this.quickViewOpener = false;
        this.titleNewButton = 'Novo';
        this.manyActions = true;
        this.callServiceFunction = null;
        this.classDataTable = '';
        this.expansivePanel = false;
        this.showButtonPanel = false;
        this.onReceivePage = new EventEmitter();
        this.onNewItem = new EventEmitter();
        this.onSearchEmitFilter = new EventEmitter();
        this.selectionMode = '';
        this.hasLinks = false;
        this.getLinks = null;
        this.visibleWhenFunctionLink = null;
        this.titleButtonNovo = 'Novo';
        this.enableRemoveAll = false;
        this.fixedSizeWhenMultipleSelection = true;
        this.useQueryParams = true;
        this.classInputFilter = '';
        this.onIconClicked = new EventEmitter();
        this.removeAllClicked = new EventEmitter();
        this.showDelete = false;
        this.strFiltroPage = '';
        this.pageParameters = PageParameters.newPage(20);
        this.filtersDefaults = [];
        this.rowDoubleClickFunction = null;
        this.allowSearch = true;
        this.enableScrollX = false;
        this.navigationExtras = { queryParams: null };
        this.listenToRouteChanges = false;
        this.filtroPesquisa = new SearchFilter();
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.entityService, 'entity service');
        AssertUtilsApp.assert(this.entityService.loadFieldModels, 'entity service loadFieldModels not found');
        AssertUtilsApp.assert(this.entityService.findAll, 'entity service findAll not found');
        this.loadFiltersFromQueryParams();
        this.entityService.loadFieldModels(this.getFieldsToModel())
            .subscribe(model => this.setFieldsModels(model));
        if (this.orderBy) {
            this.pageParameters.sort = this.orderBy;
        }
        this.getEntities(this.strFiltroPage);
        if (this.refreshEmit) {
            this.refreshEmit.subscribe(() => this.getEntities(this.strFiltroPage));
        }
        if (this.role !== '') {
            this.verifyPermissions();
        }
    }
    ngAfterContentInit() {
        this.eloTableActions.forEach(tb => this.dataTable.addTableActions(tb));
    }
    onSelected(selected) {
        this.eventSelected.emit(selected);
    }
    clickRadioButton(selected) {
        this.onClickRadioButton.emit(selected);
    }
    onClickLink(object) {
        this.onIconClicked.emit(object);
    }
    onRemoveAllClicked(object) {
        this.removeAllClicked.emit(object);
    }
    getEntities(search) {
        if (this.callServiceFunction) {
            this.onSearchEmitFilter.emit(search);
            this.callServiceFunction(search, this.pageParameters).subscribe((data) => {
                this.crudPage = data;
                this.onReceivePage.emit({ data: this.crudPage, pagination: this.pageParameters });
            });
        }
        else {
            const filter = StringUtils.join([search, this.filterDefault], 'and');
            this.onSearchEmitFilter.emit(filter);
            this.entityService
                .findAll(this.pageParameters, filter, 'id,' + this.fieldsToDisplay.toString(), this.disableSpinner)
                .subscribe(data => {
                this.crudPage = data;
                this.onReceivePage.emit(this.crudPage);
            });
        }
    }
    edit(crud) {
        if (this.editFunction) {
            this.editFunction(crud.id);
        }
        else {
            this.router.navigate([this.crudResource, crud.id], this.navigationExtras);
        }
    }
    onPrint() {
        this.entityService.print(this.strFiltroPage, this.fieldsToPrint ? this.fieldsToPrint.toString() : this.fieldsToDisplay.toString(), this.pageParameters).subscribe(url => {
            const tab = this.windowService.openTab(url);
            if (tab) {
                tab.print();
            }
        });
    }
    viewLogs() {
        RouterUtils.sendToLogs(this.router, this.modelName, this.labelModelName, this.fieldsToDisplayForModelName);
    }
    new() {
        this.router.navigate([this.crudResource, 'new'], this.navigationExtras);
    }
    onPageChange(pageParameters) {
        this.pageParameters.size = pageParameters.size;
        this.pageParameters.page = pageParameters.page;
        this.getEntities(this.strFiltroPage);
    }
    onDelete(itemToRemove) {
        this.itemToRemove = itemToRemove;
        this.showDelete = true;
    }
    cancelDelete() {
        this.showDelete = false;
    }
    delete() {
        this.showDelete = false;
        const deleteFunc = this.deleteFunction ? this.deleteFunction : id => this.entityService.remove(id);
        deleteFunc(this.itemToRemove.id).subscribe(() => {
            this.getEntities(this.strFiltroPage);
            if (this.showDeleteMessage) {
                this.eloNotificationService.success(this.caption, 'Deletado(a) com sucesso');
            }
        });
    }
    onTableHeadClick(column) {
        const order = this.isAscSort(column) ? 'desc' : 'asc';
        this.pageParameters.sort = `${column},${order}`;
        this.pageParameters.sortWithTranslation = `${this.getColumnTranslated(column)},${order}`;
        this.getEntities(this.strFiltroPage);
    }
    onFilter(filters) {
        this.strFiltroPage = this.filtroPesquisa.onFilter(filters, this.location, this.activatedRoute, this.routerService, this.changeLocationOnFilter);
        this.pageParameters = PageParameters.newPage(this.pageParameters.size);
        if (this.orderBy) {
            this.pageParameters.sort = this.orderBy;
        }
        this.getEntities(this.strFiltroPage);
    }
    loadFiltersFromQueryParams() {
        this.filtroPesquisa.setUseQueryParams(this.useQueryParams);
        if (this.listenToRouteChanges && this.useQueryParams) {
            this.activatedRoute.queryParams.subscribe(({ filter }) => {
                if (filter) {
                    this.filtersDefaults = this.deserializeFilters(filter);
                    this.strFiltroPage = this.filtroPesquisa.attrFilters(this.filtersDefaults);
                }
            });
        }
        else if (this.hasFilter()) {
            this.filtersDefaults = this.deserializeFilters(this.activatedRoute.snapshot.queryParams['filter']);
            this.strFiltroPage = this.filtroPesquisa.attrFilters(this.filtersDefaults);
        }
    }
    verifyPermissions() {
        this.authHttp.getPermissionsByRole(this.role).subscribe(permissions => {
            this.verifyNew(permissions);
            this.verifyUpdate(permissions);
            this.verifyDelete(permissions);
        });
    }
    verifyNew(permissions) {
        this.enableCreate = this.enableCreate && permissions.some(p => p.toUpperCase().indexOf('CREATE') >= 0);
    }
    verifyUpdate(permissions) {
        this.enableEdit = this.enableEdit && permissions.some(p => p.toUpperCase().indexOf('UPDATE') >= 0);
    }
    verifyDelete(permissions) {
        this.enableRemove = this.enableRemove && permissions.some(p => p.toUpperCase().indexOf('DELETE') >= 0);
    }
    onNewItemEvent() {
        this.onNewItem.emit();
    }
    isFixedSize() {
        return this.selectionMode === 'multiple' && this.fixedSizeWhenMultipleSelection;
    }
    getFieldsToModel() {
        let fields = [];
        if (this.fieldsToFilter) {
            fields.push(...this.fieldsToFilter);
        }
        if (this.fieldsToDisplay) {
            fields.push(...this.fieldsToDisplay);
        }
        return Array.from(new Set(fields)).join(',');
    }
    isAscSort(column) {
        return this.pageParameters.sort && this.pageParameters.sort.indexOf(column) !== -1 && this.pageParameters.sort.indexOf('asc') !== -1;
    }
    hasFilter() {
        return this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams['filter'] && this.useQueryParams;
    }
    deserializeFilters(filters) {
        return filters.split(',').map(filter => {
            const arrayValues = filter.split(';');
            return { field: arrayValues[0], op: parseInt(arrayValues[1]), value: arrayValues[2] };
        });
    }
    setFieldsModels(model) {
        this.fieldsModels = this.filtroPesquisa.handleModel(model, this.fieldsToDisplay);
        this.fieldsModelsFilter = this.fieldsToFilter ? this.filtroPesquisa.handleModel(model, this.fieldsToFilter) : this.fieldsModels;
    }
    getColumnTranslated(column) {
        let founds = this.fieldsModels.filter(f => f.fieldName === column);
        if (founds[0] && founds[0].isCalculatedModel) {
            return founds[0].fieldPath;
        }
        return column;
    }
}
CrudSearchComponent.ɵfac = function CrudSearchComponent_Factory(t) { return new (t || CrudSearchComponent)(ɵngcc0.ɵɵdirectiveInject(RouterService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router), ɵngcc0.ɵɵdirectiveInject(WindowService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Location), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(AbstractAuthHttp), ɵngcc0.ɵɵdirectiveInject(EloNotificationService)); };
CrudSearchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudSearchComponent, selectors: [["crud-search"]], contentQueries: function CrudSearchComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c34, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c20, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, EloTableActionsComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.eloColumnsTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.expandTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.eloTableActions = _t);
    } }, viewQuery: function CrudSearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(EloDatatableComponent, true);
        ɵngcc0.ɵɵstaticViewQuery(SearchFilterComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dataTable = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchFilter = _t.first);
    } }, inputs: { shouldReuseFilter: "shouldReuseFilter", sortable: "sortable", enableRemove: "enableRemove", showSearchFilter: "showSearchFilter", enableEdit: "enableEdit", enableCreate: "enableCreate", enableTablePrint: "enableTablePrint", removeVisibleWhenAttribute: "removeVisibleWhenAttribute", visibleWhenAttribute: "visibleWhenAttribute", visibleWhenFunction: "visibleWhenFunction", searchSelect: "searchSelect", refreshEmit: "refreshEmit", changeLocationOnFilter: "changeLocationOnFilter", filterDefault: "filterDefault", deleteFunction: "deleteFunction", editFunction: "editFunction", role: "role", disableSpinner: "disableSpinner", quickViewOpener: "quickViewOpener", titleNewButton: "titleNewButton", manyActions: "manyActions", callServiceFunction: "callServiceFunction", classDataTable: "classDataTable", expansivePanel: "expansivePanel", showButtonPanel: "showButtonPanel", selectionMode: "selectionMode", hasLinks: "hasLinks", getLinks: "getLinks", visibleWhenFunctionLink: "visibleWhenFunctionLink", titleButtonNovo: "titleButtonNovo", enableRemoveAll: "enableRemoveAll", fixedSizeWhenMultipleSelection: "fixedSizeWhenMultipleSelection", useQueryParams: "useQueryParams", classInputFilter: "classInputFilter", pageParameters: "pageParameters", rowDoubleClickFunction: "rowDoubleClickFunction", allowSearch: "allowSearch", enableScrollX: "enableScrollX", navigationExtras: "navigationExtras", listenToRouteChanges: "listenToRouteChanges", caption: "caption", crudResource: "crudResource", entityService: "entityService", fieldsToDisplay: "fieldsToDisplay", fieldsToFilter: "fieldsToFilter", fieldsToPrint: "fieldsToPrint", defaultField: "defaultField", orderBy: "orderBy", selection: "selection", dataTableFooterDynamic: "dataTableFooterDynamic", dataTableSubtitlesDynamic: "dataTableSubtitlesDynamic", modelName: "modelName", labelModelName: "labelModelName", fieldsToDisplayForModelName: "fieldsToDisplayForModelName", beforeExtraElement: "beforeExtraElement", showDeleteMessage: "showDeleteMessage" }, outputs: { eventSelected: "eventSelected", onClickRadioButton: "onClickRadioButton", onReceivePage: "onReceivePage", onNewItem: "onNewItem", onSearchEmitFilter: "onSearchEmitFilter", onIconClicked: "onIconClicked", removeAllClicked: "removeAllClicked" }, ngContentSelectors: _c0, decls: 23, vars: 37, consts: [["id", "dialog-delete", 3, "show", "onOkEvent", "onCancelEvent"], [3, "title", "hasTable", "hasForm", "expansive", "showButton", "titleButtonNovo", "enableScrollX", "onNewItem"], [3, "filtersDefaults", "fieldsModels", "defaultField", "beforeExtraElement", "allowSearch", "classInput", "onFilter", 4, "ngIf"], [3, "values", "pageParameters", "sortable", "selection", "selectionMode", "isQuickViewOpener", "manyActions", "paramExpandTemplate", "rowDoubleClickFunction", "enableScrollX", "onTableHeadClick", "onModifySelection", "onSelectOne", "onClickRadioButton"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], ["dataTableFooter", ""], ["id", "removeAll", "icon", "fa fa-trash", "description", "Remover Todos", 3, "onClickIconButton", 4, "ngIf"], ["id", "btn-print", "icon", "fa fa-print", "description", "Imprimir", 3, "onClickIconButton", 4, "ngIf"], ["id", "log", "icon", "fa fa-history", "description", "Ver Logs", 3, "onClickIconButton", 4, "ngIf"], ["icon", "fa fa-pencil", "id", "idedit", 3, "title", "visibleWhenAttribute", "visibleWhenFunction", "onClickIconButton", 4, "ngIf"], ["id", "btn-add", "icon", "fa fa-plus", 3, "title", "onClickIconButton", 4, "ngIf"], ["icon", "fa fa-trash", "id", "idremove", 3, "title", "visibleWhenAttribute", "removeAutoFocus", "visibleWhenFunction", "onClickIconButton", 4, "ngIf"], ["icon", "fa fa-list-ul", "id", "idLinks", 3, "visibleWhenFunction", "linksFunction", "hasLinks", "onClickLink", 4, "ngIf"], [3, "hidden", "currentPage", "numberOfPages", "pageSize", "allowShowAllItens", "onPageChange"], [1, "subtitles"], ["dataTableSubtitles", ""], [4, "ngTemplateOutlet"], ["class", "btn-save", 4, "ngIf"], [3, "filtersDefaults", "fieldsModels", "defaultField", "beforeExtraElement", "allowSearch", "classInput", "onFilter"], [3, "enumOptions", "field", "header", "isDate", "isDateTime", 4, "ngFor", "ngForOf"], [3, "enumOptions", "field", "header", "isDate", "isDateTime"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngTemplateOutlet"], ["id", "removeAll", "icon", "fa fa-trash", "description", "Remover Todos", 3, "onClickIconButton"], ["id", "btn-print", "icon", "fa fa-print", "description", "Imprimir", 3, "onClickIconButton"], ["id", "log", "icon", "fa fa-history", "description", "Ver Logs", 3, "onClickIconButton"], ["icon", "fa fa-pencil", "id", "idedit", 3, "title", "visibleWhenAttribute", "visibleWhenFunction", "onClickIconButton"], ["id", "btn-add", "icon", "fa fa-plus", 3, "title", "onClickIconButton"], ["icon", "fa fa-trash", "id", "idremove", 3, "title", "visibleWhenAttribute", "removeAutoFocus", "visibleWhenFunction", "onClickIconButton"], ["icon", "fa fa-list-ul", "id", "idLinks", 3, "visibleWhenFunction", "linksFunction", "hasLinks", "onClickLink"], [1, "btn-save"], ["type", "button", "title", "Novo", "id", "novo", "ref", "novo", 1, "btn", "neutral", "hint", "clean", "module-color", 3, "click"], [1, "hint-content"]], template: function CrudSearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "elo-dialog", 0);
        ɵngcc0.ɵɵlistener("onOkEvent", function CrudSearchComponent_Template_elo_dialog_onOkEvent_2_listener() { return ctx.delete(); })("onCancelEvent", function CrudSearchComponent_Template_elo_dialog_onCancelEvent_2_listener() { return ctx.cancelDelete(); });
        ɵngcc0.ɵɵtext(3, " Apagar? ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "elo-panel-expansive", 1);
        ɵngcc0.ɵɵlistener("onNewItem", function CrudSearchComponent_Template_elo_panel_expansive_onNewItem_4_listener() { return ctx.onNewItemEvent(); });
        ɵngcc0.ɵɵtemplate(5, CrudSearchComponent_search_filter_5_Template, 1, 6, "search-filter", 2);
        ɵngcc0.ɵɵelementStart(6, "elo-datatable", 3);
        ɵngcc0.ɵɵlistener("onTableHeadClick", function CrudSearchComponent_Template_elo_datatable_onTableHeadClick_6_listener($event) { return ctx.onTableHeadClick($event); })("onModifySelection", function CrudSearchComponent_Template_elo_datatable_onModifySelection_6_listener($event) { return ctx.onSelected($event); })("onSelectOne", function CrudSearchComponent_Template_elo_datatable_onSelectOne_6_listener($event) { return ctx.onSelected($event); })("onClickRadioButton", function CrudSearchComponent_Template_elo_datatable_onClickRadioButton_6_listener($event) { return ctx.clickRadioButton($event); });
        ɵngcc0.ɵɵtemplate(7, CrudSearchComponent_div_7_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(8, CrudSearchComponent_div_8_Template, 1, 5, "div", 5);
        ɵngcc0.ɵɵtemplate(9, CrudSearchComponent_ng_template_9_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(11, CrudSearchComponent_elo_header_actions_11_Template, 1, 0, "elo-header-actions", 7);
        ɵngcc0.ɵɵtemplate(12, CrudSearchComponent_elo_header_actions_12_Template, 1, 0, "elo-header-actions", 8);
        ɵngcc0.ɵɵtemplate(13, CrudSearchComponent_elo_header_actions_13_Template, 1, 0, "elo-header-actions", 9);
        ɵngcc0.ɵɵtemplate(14, CrudSearchComponent_elo_table_actions_14_Template, 1, 3, "elo-table-actions", 10);
        ɵngcc0.ɵɵtemplate(15, CrudSearchComponent_elo_table_actions_15_Template, 1, 1, "elo-table-actions", 11);
        ɵngcc0.ɵɵtemplate(16, CrudSearchComponent_elo_table_actions_16_Template, 1, 4, "elo-table-actions", 12);
        ɵngcc0.ɵɵtemplate(17, CrudSearchComponent_elo_table_actions_17_Template, 1, 3, "elo-table-actions", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "pagination-comp", 14);
        ɵngcc0.ɵɵlistener("onPageChange", function CrudSearchComponent_Template_pagination_comp_onPageChange_18_listener($event) { return ctx.onPageChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 15, 16);
        ɵngcc0.ɵɵtemplate(21, CrudSearchComponent_ng_container_21_Template, 1, 0, "ng-container", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(22, CrudSearchComponent_div_22_Template, 4, 1, "div", 18);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("show", ctx.showDelete);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ctx.caption);
        ɵngcc0.ɵɵproperty("hasTable", true)("hasForm", false)("expansive", ctx.expansivePanel)("showButton", ctx.showButtonPanel)("titleButtonNovo", ctx.titleButtonNovo)("enableScrollX", ctx.enableScrollX);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSearchFilter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap("striped fancy " + (ctx.isFixedSize() ? "fixed " : "") + ctx.classDataTable);
        ɵngcc0.ɵɵproperty("values", ctx.crudPage == null ? null : ctx.crudPage.content)("pageParameters", ctx.pageParameters)("sortable", ctx.sortable)("selection", ctx.selection)("selectionMode", ctx.selectionMode)("isQuickViewOpener", ctx.quickViewOpener)("manyActions", ctx.manyActions)("paramExpandTemplate", ctx.expandTemplate)("rowDoubleClickFunction", ctx.rowDoubleClickFunction)("enableScrollX", ctx.enableScrollX);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.eloColumnsTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.eloColumnsTemplate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableRemoveAll);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableTablePrint && !ctx.searchSelect);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.modelName && ctx.fieldsToDisplayForModelName && ctx.labelModelName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.searchSelect && ctx.enableEdit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchSelect);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.searchSelect && ctx.enableRemove);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasLinks);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", (ctx.crudPage == null ? null : ctx.crudPage.content == null ? null : ctx.crudPage.content.length) == 0)("currentPage", (ctx.crudPage == null ? null : ctx.crudPage.number) + 1)("numberOfPages", ctx.crudPage == null ? null : ctx.crudPage.totalPages)("pageSize", ctx.pageParameters.size)("allowShowAllItens", ctx.selectionMode == "multiple");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.dataTableSubtitlesDynamic);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableCreate);
    } }, directives: function () { return [DialogComponent, PanelExpansiveComponent, ɵngcc2.NgIf, EloDatatableComponent, PaginationComponent, ɵngcc2.NgTemplateOutlet, SearchFilterComponent, ɵngcc2.NgForOf, EloColumnComponent, EloHeaderActionsComponent, EloTableActionsComponent]; }, encapsulation: 2 });
CrudSearchComponent.ctorParameters = () => [
    { type: RouterService },
    { type: Router },
    { type: WindowService },
    { type: Location },
    { type: ActivatedRoute },
    { type: AbstractAuthHttp },
    { type: EloNotificationService }
];
CrudSearchComponent.propDecorators = {
    eventSelected: [{ type: Output }],
    onClickRadioButton: [{ type: Output }],
    shouldReuseFilter: [{ type: Input }],
    caption: [{ type: Input }],
    crudResource: [{ type: Input }],
    entityService: [{ type: Input }],
    fieldsToDisplay: [{ type: Input }],
    fieldsToFilter: [{ type: Input }],
    fieldsToPrint: [{ type: Input }],
    defaultField: [{ type: Input }],
    orderBy: [{ type: Input }],
    sortable: [{ type: Input }],
    enableRemove: [{ type: Input }],
    showSearchFilter: [{ type: Input }],
    enableEdit: [{ type: Input }],
    enableCreate: [{ type: Input }],
    enableTablePrint: [{ type: Input }],
    removeVisibleWhenAttribute: [{ type: Input }],
    visibleWhenAttribute: [{ type: Input }],
    visibleWhenFunction: [{ type: Input }],
    searchSelect: [{ type: Input }],
    refreshEmit: [{ type: Input }],
    changeLocationOnFilter: [{ type: Input }],
    filterDefault: [{ type: Input }],
    deleteFunction: [{ type: Input }],
    editFunction: [{ type: Input }],
    role: [{ type: Input }],
    disableSpinner: [{ type: Input }],
    quickViewOpener: [{ type: Input }],
    titleNewButton: [{ type: Input }],
    manyActions: [{ type: Input }],
    callServiceFunction: [{ type: Input }],
    classDataTable: [{ type: Input }],
    expansivePanel: [{ type: Input }],
    showButtonPanel: [{ type: Input }],
    onReceivePage: [{ type: Output }],
    onNewItem: [{ type: Output }],
    onSearchEmitFilter: [{ type: Output }],
    selection: [{ type: Input }],
    selectionMode: [{ type: Input }],
    dataTableFooterDynamic: [{ type: Input }],
    dataTableSubtitlesDynamic: [{ type: Input }],
    hasLinks: [{ type: Input }],
    getLinks: [{ type: Input }],
    visibleWhenFunctionLink: [{ type: Input }],
    titleButtonNovo: [{ type: Input }],
    modelName: [{ type: Input }],
    labelModelName: [{ type: Input }],
    fieldsToDisplayForModelName: [{ type: Input }],
    enableRemoveAll: [{ type: Input }],
    fixedSizeWhenMultipleSelection: [{ type: Input }],
    useQueryParams: [{ type: Input }],
    classInputFilter: [{ type: Input }],
    onIconClicked: [{ type: Output }],
    removeAllClicked: [{ type: Output }],
    eloColumnsTemplate: [{ type: ContentChild, args: ['eloColumns',] }],
    expandTemplate: [{ type: ContentChild, args: ['dataTableExpand',] }],
    pageParameters: [{ type: Input }],
    eloTableActions: [{ type: ContentChildren, args: [EloTableActionsComponent,] }],
    dataTable: [{ type: ViewChild, args: [EloDatatableComponent, { static: true },] }],
    searchFilter: [{ type: ViewChild, args: [SearchFilterComponent, { static: true },] }],
    beforeExtraElement: [{ type: Input }],
    rowDoubleClickFunction: [{ type: Input }],
    allowSearch: [{ type: Input }],
    enableScrollX: [{ type: Input }],
    navigationExtras: [{ type: Input }],
    showDeleteMessage: [{ type: Input }],
    listenToRouteChanges: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudSearchComponent, [{
        type: Component,
        args: [{
                selector: 'crud-search',
                template: "<div>\n  <ng-content></ng-content>\n\n  <elo-dialog id=\"dialog-delete\" [show]=\"showDelete\" (onOkEvent)=\"delete()\" (onCancelEvent)=\"cancelDelete()\">\n    Apagar?\n  </elo-dialog>\n\n  <elo-panel-expansive title=\"{{caption}}\" [hasTable]=\"true\" [hasForm]=\"false\" [expansive]=\"expansivePanel\"\n    [showButton]=\"showButtonPanel\" (onNewItem)=\"onNewItemEvent()\" [titleButtonNovo]=\"titleButtonNovo\"\n    [enableScrollX]=\"enableScrollX\">\n\n    <search-filter *ngIf=\"showSearchFilter\" [filtersDefaults]=\"filtersDefaults\" [fieldsModels]=\"fieldsModelsFilter\"\n      (onFilter)=\"onFilter($event)\" [defaultField]=\"defaultField\" [beforeExtraElement]=\"beforeExtraElement\"\n      [allowSearch]=\"allowSearch\" [classInput]=\"classInputFilter\">\n    </search-filter>\n\n    <elo-datatable [values]=\"crudPage?.content\"\n      [class]=\"'striped fancy ' + (isFixedSize() ? 'fixed ' : '') + classDataTable\" [pageParameters]=\"pageParameters\"\n      [sortable]=\"sortable\" (onTableHeadClick)=\"onTableHeadClick($event)\" [selection]=\"selection\"\n      [selectionMode]=\"selectionMode\" (onModifySelection)=\"onSelected($event)\" (onSelectOne)=\"onSelected($event)\"\n      [isQuickViewOpener]=\"quickViewOpener\" [manyActions]=\"manyActions\" [paramExpandTemplate]=\"expandTemplate\"\n      [rowDoubleClickFunction]=\"rowDoubleClickFunction\" [enableScrollX]=\"enableScrollX\"\n      (onClickRadioButton)=\"clickRadioButton($event)\">\n      <div *ngIf=\"!eloColumnsTemplate\">\n        <elo-column *ngFor=\"let field of fieldsModels\" [enumOptions]=\"field.enumOptions\"\n          [field]=\"field.isCalculatedModel ? field.fieldName : field.fieldPath\" [header]=field.caption\n          [isDate]=\"field.dataType === 'LocalDate'\" [isDateTime]=\"field.dataType === 'LocalDateTime'\"></elo-column>\n      </div>\n      <div *ngIf=\"eloColumnsTemplate\" [ngTemplateOutlet]=\"eloColumnsTemplate\"\n        [ngTemplateOutletContext]=\"{dataTable: dataTable, fieldsModels: fieldsModels}\"></div>\n\n      <ng-template #dataTableFooter>\n        <ng-container [ngTemplateOutlet]=\"dataTableFooterDynamic\"></ng-container>\n      </ng-template>\n\n      <elo-header-actions id=\"removeAll\" icon='fa fa-trash' description='Remover Todos'\n        (onClickIconButton)=\"onRemoveAllClicked($event)\" *ngIf=\"enableRemoveAll\">\n      </elo-header-actions>\n\n      <elo-header-actions id=\"btn-print\" icon='fa fa-print' description='Imprimir' (onClickIconButton)=\"onPrint()\"\n        *ngIf=\"enableTablePrint && !searchSelect\"></elo-header-actions>\n\n      <elo-header-actions id=\"log\" icon='fa fa-history' description='Ver Logs' (onClickIconButton)=\"viewLogs()\"\n        *ngIf=\"modelName && fieldsToDisplayForModelName && labelModelName\">\n      </elo-header-actions>\n\n      <elo-table-actions [title]=\"'Editar'\" *ngIf=\"!searchSelect && enableEdit\" icon='fa fa-pencil' id=\"idedit\"\n        (onClickIconButton)=\"edit($event)\" [visibleWhenAttribute]=\"visibleWhenAttribute\"\n        [visibleWhenFunction]=\"visibleWhenFunction\"></elo-table-actions>\n\n      <elo-table-actions id=\"btn-add\" [title]=\"'Adicionar'\" *ngIf=\"searchSelect\" icon='fa fa-plus'\n        (onClickIconButton)=\"onSelected($event)\"></elo-table-actions>\n\n      <elo-table-actions [title]=\"'Remover'\" *ngIf=\"!searchSelect && enableRemove\" icon='fa fa-trash' id=\"idremove\"\n        (onClickIconButton)=\"onDelete($event)\" [visibleWhenAttribute]=\"visibleWhenAttribute\" [removeAutoFocus]=\"true\"\n        [visibleWhenFunction]=\"visibleWhenFunction\"></elo-table-actions>\n\n      <elo-table-actions [visibleWhenFunction]=\"visibleWhenFunctionLink\" icon='fa fa-list-ul' id=\"idLinks\"\n        (onClickLink)=\"onClickLink($event)\" [linksFunction]=\"getLinks\" [hasLinks]=\"hasLinks\" *ngIf=\"hasLinks\">\n      </elo-table-actions>\n\n    </elo-datatable>\n\n    <pagination-comp [hidden]=\"crudPage?.content?.length == 0\" [currentPage]=\"crudPage?.number+1\"\n      [numberOfPages]=\"crudPage?.totalPages\" (onPageChange)=\"onPageChange($event)\" [pageSize]=\"pageParameters.size\"\n      [allowShowAllItens]=\"(selectionMode == 'multiple')\">\n    </pagination-comp>\n\n    <div #dataTableSubtitles class=\"subtitles\">\n      <ng-container *ngTemplateOutlet=\"dataTableSubtitlesDynamic\"></ng-container>\n    </div>\n\n  </elo-panel-expansive>\n\n  <div *ngIf=\"enableCreate\" class=\"btn-save\">\n    <button type=\"button\" title=\"Novo\" id=\"novo\" ref=\"novo\" class=\"btn neutral hint clean module-color\" (click)=\"new()\">\n      <div class=\"hint-content\">\n        {{titleNewButton}}\n      </div>\n    </button>\n  </div>\n</div>"
            }]
    }], function () { return [{ type: RouterService }, { type: ɵngcc6.Router }, { type: WindowService }, { type: ɵngcc2.Location }, { type: ɵngcc6.ActivatedRoute }, { type: AbstractAuthHttp }, { type: EloNotificationService }]; }, { eventSelected: [{
            type: Output
        }], onClickRadioButton: [{
            type: Output
        }], shouldReuseFilter: [{
            type: Input
        }], sortable: [{
            type: Input
        }], enableRemove: [{
            type: Input
        }], showSearchFilter: [{
            type: Input
        }], enableEdit: [{
            type: Input
        }], enableCreate: [{
            type: Input
        }], enableTablePrint: [{
            type: Input
        }], removeVisibleWhenAttribute: [{
            type: Input
        }], visibleWhenAttribute: [{
            type: Input
        }], visibleWhenFunction: [{
            type: Input
        }], searchSelect: [{
            type: Input
        }], refreshEmit: [{
            type: Input
        }], changeLocationOnFilter: [{
            type: Input
        }], filterDefault: [{
            type: Input
        }], deleteFunction: [{
            type: Input
        }], editFunction: [{
            type: Input
        }], role: [{
            type: Input
        }], disableSpinner: [{
            type: Input
        }], quickViewOpener: [{
            type: Input
        }], titleNewButton: [{
            type: Input
        }], manyActions: [{
            type: Input
        }], callServiceFunction: [{
            type: Input
        }], classDataTable: [{
            type: Input
        }], expansivePanel: [{
            type: Input
        }], showButtonPanel: [{
            type: Input
        }], onReceivePage: [{
            type: Output
        }], onNewItem: [{
            type: Output
        }], onSearchEmitFilter: [{
            type: Output
        }], selectionMode: [{
            type: Input
        }], hasLinks: [{
            type: Input
        }], getLinks: [{
            type: Input
        }], visibleWhenFunctionLink: [{
            type: Input
        }], titleButtonNovo: [{
            type: Input
        }], enableRemoveAll: [{
            type: Input
        }], fixedSizeWhenMultipleSelection: [{
            type: Input
        }], useQueryParams: [{
            type: Input
        }], classInputFilter: [{
            type: Input
        }], onIconClicked: [{
            type: Output
        }], removeAllClicked: [{
            type: Output
        }], pageParameters: [{
            type: Input
        }], rowDoubleClickFunction: [{
            type: Input
        }], allowSearch: [{
            type: Input
        }], enableScrollX: [{
            type: Input
        }], navigationExtras: [{
            type: Input
        }], listenToRouteChanges: [{
            type: Input
        }], caption: [{
            type: Input
        }], crudResource: [{
            type: Input
        }], entityService: [{
            type: Input
        }], fieldsToDisplay: [{
            type: Input
        }], fieldsToFilter: [{
            type: Input
        }], fieldsToPrint: [{
            type: Input
        }], defaultField: [{
            type: Input
        }], orderBy: [{
            type: Input
        }], selection: [{
            type: Input
        }], dataTableFooterDynamic: [{
            type: Input
        }], dataTableSubtitlesDynamic: [{
            type: Input
        }], modelName: [{
            type: Input
        }], labelModelName: [{
            type: Input
        }], fieldsToDisplayForModelName: [{
            type: Input
        }], eloColumnsTemplate: [{
            type: ContentChild,
            args: ['eloColumns']
        }], expandTemplate: [{
            type: ContentChild,
            args: ['dataTableExpand']
        }], eloTableActions: [{
            type: ContentChildren,
            args: [EloTableActionsComponent]
        }], dataTable: [{
            type: ViewChild,
            args: [EloDatatableComponent, { static: true }]
        }], searchFilter: [{
            type: ViewChild,
            args: [SearchFilterComponent, { static: true }]
        }], beforeExtraElement: [{
            type: Input
        }], showDeleteMessage: [{
            type: Input
        }] }); })();

/**
 * Created by custodio on 07/07/2016.
 */
class PaginationComponent {
    constructor() {
        this.numberOfPages = 0;
        this.pageLinkSize = 5;
        this.highLight = false;
        this.hiddenOnlyPages = false;
        this.pageSize = 20;
        this.onPageChange = new EventEmitter();
        this.pageNumbers = [];
        this.pageSizes = [5, 10, 15, 20, 30, 40, 50];
        this.currentPage = 1;
        this.allowShowAllItens = false;
    }
    ngOnChanges() {
        this.loadPageNumbers(this.currentPage);
    }
    first(event) {
        this.onChangePageNumber(1, event);
    }
    previous(event) {
        event.preventDefault();
        if (this.canGoPrevious()) {
            this.onChangePageNumber(this.currentPage - 1, event);
        }
    }
    next(event) {
        event.preventDefault();
        if (this.canGoNext()) {
            this.onChangePageNumber(this.currentPage + 1, event);
        }
    }
    last(event) {
        this.onChangePageNumber(this.numberOfPages, event);
    }
    onChangePageSize(value) {
        this.pageSize = value;
        this.currentPage = 1;
        this.emitOnPageChange();
    }
    onChangePageNumber(newCurrentPage, event) {
        event.preventDefault();
        if (this.currentPage !== newCurrentPage) {
            this.loadPageNumbers(newCurrentPage);
            this.currentPage = newCurrentPage;
            this.emitOnPageChange();
        }
    }
    emitOnPageChange() {
        this.onPageChange.emit(new PageParameters(this.pageSize, this.currentPage - 1));
    }
    loadPageNumbers(pageToGo) {
        if (this.pageLinkSize < 3) {
            this.pageLinkSize = 3;
        }
        this.pageNumbers = [];
        const FIRST_PAGE = 1;
        let start = Math.max(FIRST_PAGE, Math.ceil(pageToGo - (this.pageLinkSize / 2)));
        let end = Math.min(this.numberOfPages, (start + this.pageLinkSize - 1));
        if (this.isLastPage(end)) {
            start = Math.max(FIRST_PAGE, end - this.pageLinkSize + 1);
        }
        this.pageNumbers = [];
        for (let i = start; i <= end; i++) {
            this.pageNumbers.push(i);
        }
    }
    isLastPage(end) {
        return end === this.numberOfPages;
    }
    canGoPrevious() {
        return this.currentPage > 1;
    }
    canGoNext() {
        return this.currentPage < this.numberOfPages;
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(); };
PaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["pagination-comp"]], inputs: { numberOfPages: "numberOfPages", pageLinkSize: "pageLinkSize", highLight: "highLight", hiddenOnlyPages: "hiddenOnlyPages", pageSize: "pageSize", pageSizes: "pageSizes", currentPage: "currentPage", allowShowAllItens: "allowShowAllItens" }, outputs: { onPageChange: "onPageChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 6, vars: 3, consts: [[1, "panel-pagination"], [1, "sisters"], ["class", "number-itens", 4, "ngIf"], ["class", "panel-pagination-inner", 4, "ngIf"], ["class", "sisters", 4, "ngIf"], [1, "number-itens"], ["id", "pageSize", "name", "pageSize", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngIf"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [1, "panel-pagination-inner"], [1, "page-item", 3, "click"], ["href", "#", "aria-label", "Previous", 1, "page-link"], [1, "fa", "fa-step-backward"], ["aria-hidden", "true"], ["class", "page-item", 3, "value", "active", "click", 4, "ngFor", "ngForOf"], ["href", "#", "aria-label", "Next", 1, "page-link"], [1, "fa", "fa-step-forward"], [1, "page-item", 3, "value", "click"], ["href", "#", 1, "page-link"], [1, "highLight"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, PaginationComponent_div_2_Template, 8, 3, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtemplate(4, PaginationComponent_ul_4_Template, 16, 1, "ul", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, PaginationComponent_div_5_Template, 3, 0, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hiddenOnlyPages);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hiddenOnlyPages && ctx.pageSize !== 9999);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.highLight);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc2.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
PaginationComponent.propDecorators = {
    numberOfPages: [{ type: Input }],
    pageLinkSize: [{ type: Input }],
    highLight: [{ type: Input }],
    hiddenOnlyPages: [{ type: Input }],
    pageSize: [{ type: Input }],
    onPageChange: [{ type: Output }],
    pageSizes: [{ type: Input }],
    currentPage: [{ type: Input }],
    allowShowAllItens: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: 'pagination-comp',
                template: "<div class=\"panel-pagination\">\n\n  <div class=\"sisters\">\n    <div class=\"number-itens\" *ngIf=\"!hiddenOnlyPages\">\n      <b> Mostrar </b>\n\n      <select id=\"pageSize\" name=\"pageSize\" [ngModel]=\"pageSize\" (ngModelChange)=\"onChangePageSize($event)\">\n        <option *ngIf=\"allowShowAllItens\" [ngValue]=\"9999\">Todos</option>\n        <option *ngFor=\"let c of pageSizes\" [ngValue]=\"c\">{{c}}</option>\n      </select>\n\n      <b> Itens </b>\n    </div> <!-- numberitens -->\n  </div><!-- sisters -->\n\n  <div class=\"sisters\">\n    <ul class=\"panel-pagination-inner\" *ngIf=\"!hiddenOnlyPages && pageSize !== 9999\">\n\n      <li class=\"page-item\" (click)=\"first($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-backward\"></span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"previous($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span aria-hidden=\"true\">&laquo;</span>\n        </a>\n      </li>\n\n      <li *ngFor=\"let p of pageNumbers\" [value]=\"p\" [class.active]=\"p === currentPage\"\n        (click)=\"onChangePageNumber(p,$event)\" class=\"page-item\"><a class=\"page-link\" href=\"#\">{{p}}</a></li>\n\n      <li class=\"page-item\" (click)=\"next($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Next\">\n          <span aria-hidden=\"true\">&raquo;</span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"last($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-forward\"></span>\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"sisters\" *ngIf=\"highLight\">\n    <div class=\"highLight\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>"
            }]
    }], function () { return []; }, { numberOfPages: [{
            type: Input
        }], pageLinkSize: [{
            type: Input
        }], highLight: [{
            type: Input
        }], hiddenOnlyPages: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], onPageChange: [{
            type: Output
        }], pageSizes: [{
            type: Input
        }], currentPage: [{
            type: Input
        }], allowShowAllItens: [{
            type: Input
        }] }); })();

class PaginationModule {
}
PaginationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PaginationModule });
PaginationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PaginationModule_Factory(t) { return new (t || PaginationModule)(); }, imports: [[CommonModule$1, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PaginationModule, { declarations: function () { return [PaginationComponent]; }, imports: function () { return [CommonModule$1, FormsModule]; }, exports: function () { return [PaginationComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaginationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, FormsModule],
                exports: [PaginationComponent],
                declarations: [PaginationComponent]
            }]
    }], null, null); })();

const DROPDOWN_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => EloSelectComponent),
    multi: true
};
/**
 * @see https://angular.io/docs/ts/latest/api/forms/index/SelectControlValueAccessor-directive.html
 *
 * If your option values are simple strings, you can bind to the normal value property on the option.
 * If your option values happen to be objects (and you'd like to save the selection in your form as an object), use ngValue
 *
 * Neste componente, não foi utilizado ngValue, pois na época não funcionava.
 * */
class EloSelectComponent {
    constructor() {
        this.selectedValue = null;
        this.onSelectChange = new EventEmitter();
        this.selectedIndex = 0;
    }
    ngOnInit() {
        this.defineSelectedIndex(this.selectedValue);
    }
    set value(index) {
        this.selectedIndex = index;
        this.onSelectChange.emit(this.realValue());
        if (this.onModelChange) {
            this.onModelChange(this.realValue());
        }
    }
    realValue() {
        return this.optionsOfCombo[this.selectedIndex].value;
    }
    get value() {
        return this.selectedIndex;
    }
    get optionsOfCombo() {
        if (this.onModelChange) {
            return [{ label: 'Selecione', value: null }].concat(this.options);
        }
        return this.options;
    }
    writeValue(value) {
        if (value) {
            this.defineSelectedIndex(value);
        }
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    defineSelectedIndex(value) {
        if (value) {
            const selectedComparator = this.compareWith || defaultComparator;
            const compararatorFn = (a) => (b) => selectedComparator(a, b);
            const opt = this.optionsOfCombo.filter(compararatorFn(value))[0];
            this.selectedIndex = this.optionsOfCombo.indexOf(opt);
        }
    }
}
EloSelectComponent.ɵfac = function EloSelectComponent_Factory(t) { return new (t || EloSelectComponent)(); };
EloSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloSelectComponent, selectors: [["elo-select"]], inputs: { selectedValue: "selectedValue", options: "options", required: "required", compareWith: "compareWith" }, outputs: { onSelectChange: "onSelectChange" }, features: [ɵngcc0.ɵɵProvidersFeature([DROPDOWN_VALUE_ACCESSOR])], decls: 2, vars: 3, consts: [["id", "select-filter", "name", "select-filter", 3, "required", "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function EloSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "select", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function EloSelectComponent_Template_select_ngModelChange_0_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵtemplate(1, EloSelectComponent_option_1_Template, 2, 2, "option", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("required", ctx.required)("ngModel", ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.optionsOfCombo);
    } }, directives: [ɵngcc3.SelectControlValueAccessor, ɵngcc3.RequiredValidator, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc2.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
EloSelectComponent.propDecorators = {
    selectedValue: [{ type: Input }],
    options: [{ type: Input }],
    required: [{ type: Input }],
    compareWith: [{ type: Input }],
    onSelectChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloSelectComponent, [{
        type: Component,
        args: [{
                selector: 'elo-select',
                providers: [DROPDOWN_VALUE_ACCESSOR],
                template: `
    <select id="select-filter" name="select-filter" [required]="required" [(ngModel)]="value" >
      <option *ngFor="let option of optionsOfCombo; let i = index" [value]="i" >{{option?.label}}</option>
    </select>
`
            }]
    }], function () { return []; }, { selectedValue: [{
            type: Input
        }], onSelectChange: [{
            type: Output
        }], options: [{
            type: Input
        }], required: [{
            type: Input
        }], compareWith: [{
            type: Input
        }] }); })();
function defaultComparator(value, opt) {
    return JSON.stringify(opt.value) === JSON.stringify(value);
}

class EloSelectModule {
}
EloSelectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloSelectModule });
EloSelectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloSelectModule_Factory(t) { return new (t || EloSelectModule)(); }, providers: [], imports: [[CommonModule$1, FormsModule, ReactiveFormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloSelectModule, { declarations: function () { return [EloSelectComponent]; }, imports: function () { return [CommonModule$1, FormsModule, ReactiveFormsModule]; }, exports: function () { return [EloSelectComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloSelectModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, FormsModule, ReactiveFormsModule],
                declarations: [EloSelectComponent],
                exports: [EloSelectComponent],
                providers: []
            }]
    }], null, null); })();

class CrudSearchModule {
}
CrudSearchModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudSearchModule });
CrudSearchModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudSearchModule_Factory(t) { return new (t || CrudSearchModule)(); }, providers: [WindowService], imports: [[EloDatatableModule, CommonModule$1, PaginationModule,
            DialogModule, PanelExpansiveModule, FormsModule, ReactiveFormsModule, DatePickerModule, EloSelectModule], CommonModule$1] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudSearchModule, { declarations: function () { return [CrudSearchComponent, SearchFilterComponent]; }, imports: function () { return [EloDatatableModule, CommonModule$1, PaginationModule, DialogModule, PanelExpansiveModule, FormsModule, ReactiveFormsModule, DatePickerModule, EloSelectModule]; }, exports: function () { return [CrudSearchComponent, CommonModule$1, SearchFilterComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudSearchModule, [{
        type: NgModule,
        args: [{
                imports: [EloDatatableModule, CommonModule$1, PaginationModule,
                    DialogModule, PanelExpansiveModule, FormsModule, ReactiveFormsModule, DatePickerModule, EloSelectModule],
                exports: [CrudSearchComponent, CommonModule$1, SearchFilterComponent],
                declarations: [CrudSearchComponent, SearchFilterComponent],
                providers: [WindowService]
            }]
    }], null, null); })();

class CrudFormSimpleChildPaginatedComponent {
    constructor() {
        this.fieldsToDisplay = [];
        this.orderBy = '';
        this.checkBoxLabel = '';
        this.filterChild = '';
        this.refreshSearchEmit = new EventEmitter();
        this.internalFilterChild = '';
    }
    addChild(child) {
        this.addChildFunction(child).subscribe(() => this.refreshSearchEmit.emit());
    }
    removeChild(child) {
        this.removeChildFunction(child).subscribe(() => this.refreshSearchEmit.emit());
    }
    allowRemove() {
        return data => this.allowRemoveChildFunction(data);
    }
    allowAdd() {
        return data => !this.allowRemoveChildFunction(data);
    }
    applyFilterChild() {
        if (this.internalFilterChild) {
            this.internalFilterChild = '';
        }
        else {
            this.internalFilterChild = this.filterChild;
        }
        setTimeout(() => this.refreshSearchEmit.emit());
    }
}
CrudFormSimpleChildPaginatedComponent.ɵfac = function CrudFormSimpleChildPaginatedComponent_Factory(t) { return new (t || CrudFormSimpleChildPaginatedComponent)(); };
CrudFormSimpleChildPaginatedComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudFormSimpleChildPaginatedComponent, selectors: [["crud-form-simple-child-paginated"]], inputs: { fieldsToDisplay: "fieldsToDisplay", orderBy: "orderBy", checkBoxLabel: "checkBoxLabel", filterChild: "filterChild", addChildFunction: "addChildFunction", removeChildFunction: "removeChildFunction", allowRemoveChildFunction: "allowRemoveChildFunction", service: "service" }, decls: 7, vars: 16, consts: [[1, "row"], [3, "checked", "onClick"], [3, "orderBy", "enableEdit", "fieldsToDisplay", "entityService", "filterDefault", "enableCreate", "enableRemove", "disableSpinner", "changeLocationOnFilter", "refreshEmit"], ["icon", "fa fa-check-circle-o", 3, "title", "visibleWhenFunction", "onClickIconButton"], ["icon", "fa fa-circle-o", 3, "title", "visibleWhenFunction", "onClickIconButton"]], template: function CrudFormSimpleChildPaginatedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "elo-checkbox", 1);
        ɵngcc0.ɵɵlistener("onClick", function CrudFormSimpleChildPaginatedComponent_Template_elo_checkbox_onClick_2_listener() { return ctx.applyFilterChild(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementStart(4, "crud-search", 2);
        ɵngcc0.ɵɵelementStart(5, "elo-table-actions", 3);
        ɵngcc0.ɵɵlistener("onClickIconButton", function CrudFormSimpleChildPaginatedComponent_Template_elo_table_actions_onClickIconButton_5_listener($event) { return ctx.removeChild($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "elo-table-actions", 4);
        ɵngcc0.ɵɵlistener("onClickIconButton", function CrudFormSimpleChildPaginatedComponent_Template_elo_table_actions_onClickIconButton_6_listener($event) { return ctx.addChild($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("checked", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.checkBoxLabel, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("orderBy", ctx.orderBy)("enableEdit", false)("fieldsToDisplay", ctx.fieldsToDisplay)("entityService", ctx.service)("filterDefault", ctx.internalFilterChild)("enableCreate", false)("enableRemove", false)("disableSpinner", true)("changeLocationOnFilter", false)("refreshEmit", ctx.refreshSearchEmit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", "Remover")("visibleWhenFunction", ctx.allowRemove());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", "Adicionar")("visibleWhenFunction", ctx.allowAdd());
    } }, directives: [EloCheckboxComponent, CrudSearchComponent, EloTableActionsComponent], encapsulation: 2 });
CrudFormSimpleChildPaginatedComponent.propDecorators = {
    fieldsToDisplay: [{ type: Input }],
    addChildFunction: [{ type: Input }],
    removeChildFunction: [{ type: Input }],
    allowRemoveChildFunction: [{ type: Input }],
    service: [{ type: Input }],
    orderBy: [{ type: Input }],
    checkBoxLabel: [{ type: Input }],
    filterChild: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudFormSimpleChildPaginatedComponent, [{
        type: Component,
        args: [{
                selector: 'crud-form-simple-child-paginated',
                template: "<div>\n   <div class=\"row\">\n    <elo-checkbox  [checked]=\"false\"    (onClick)=\"applyFilterChild()\"></elo-checkbox>{{checkBoxLabel}}\n    <crud-search [orderBy]=\"orderBy\" [enableEdit]=\"false\" [fieldsToDisplay]=\"fieldsToDisplay\"\n      [entityService]=\"service\"\n      [filterDefault]=\"internalFilterChild\"\n      [enableCreate]=\"false\"\n      [enableRemove]=\"false\"\n      [disableSpinner]=\"true\"\n      [changeLocationOnFilter]=\"false\"\n      [refreshEmit]=\"refreshSearchEmit\">\n      <elo-table-actions [title]=\"'Remover'\" icon='fa fa-check-circle-o' [visibleWhenFunction]=\"allowRemove()\"\n        (onClickIconButton)=\"removeChild($event)\" >\n      </elo-table-actions>\n      <elo-table-actions [title]=\"'Adicionar'\" icon='fa fa-circle-o' [visibleWhenFunction]=\"allowAdd()\"\n        (onClickIconButton)=\"addChild($event)\" >\n        </elo-table-actions>\n      </crud-search>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { fieldsToDisplay: [{
            type: Input
        }], orderBy: [{
            type: Input
        }], checkBoxLabel: [{
            type: Input
        }], filterChild: [{
            type: Input
        }], addChildFunction: [{
            type: Input
        }], removeChildFunction: [{
            type: Input
        }], allowRemoveChildFunction: [{
            type: Input
        }], service: [{
            type: Input
        }] }); })();

class CrudFormSimpleChildPaginatedModule {
}
CrudFormSimpleChildPaginatedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudFormSimpleChildPaginatedModule });
CrudFormSimpleChildPaginatedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudFormSimpleChildPaginatedModule_Factory(t) { return new (t || CrudFormSimpleChildPaginatedModule)(); }, imports: [[FormsModule, ReactiveFormsModule, CrudSearchModule, FormLabelColumnModule,
            PanelExpansiveModule, AutoCompleteModule, EloDatatableModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudFormSimpleChildPaginatedModule, { declarations: function () { return [CrudFormSimpleChildPaginatedComponent]; }, imports: function () { return [FormsModule, ReactiveFormsModule, CrudSearchModule, FormLabelColumnModule, PanelExpansiveModule, AutoCompleteModule, EloDatatableModule]; }, exports: function () { return [CrudFormSimpleChildPaginatedComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudFormSimpleChildPaginatedModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, ReactiveFormsModule, CrudSearchModule, FormLabelColumnModule,
                    PanelExpansiveModule, AutoCompleteModule, EloDatatableModule],
                exports: [CrudFormSimpleChildPaginatedComponent],
                declarations: [CrudFormSimpleChildPaginatedComponent]
            }]
    }], null, null); })();

class CrudOnePageEditableComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.isReverse = false;
        this.createContextItem = (form, index) => ({ form, index });
    }
    set entity(entity) {
        if (entity) {
            this.loadForm(entity, this.form.get(this.arrayPropertyName));
        }
    }
    ngOnInit() {
        AssertUtilsApp.assert(this.form, 'form');
        AssertUtilsApp.assert(this.formCreate, 'formCreate');
        AssertUtilsApp.assert(this.itemTemplate, 'itemTemplate');
        AssertUtilsApp.assert(this.arrayPropertyName, 'arrayPropertyName');
    }
    getControls(control) {
        return control.controls;
    }
    loadForm(entity, formArray) {
        const objArray = entity[this.arrayPropertyName];
        if (!this.arrayPropertyNameChild) {
            this.arrayPropertyNameChild = this.arrayPropertyName;
        }
        while (formArray.length > 0) {
            formArray.removeAt(0);
        }
        objArray.forEach(obj => {
            let form = this.formCreate();
            form.patchValue(obj);
            if (this.isReverse) {
                obj[this.arrayPropertyNameChild].slice().reverse().forEach(a => this.addChilds(form, a));
            }
            else {
                obj[this.arrayPropertyNameChild].forEach(a => this.addChilds(form, a));
            }
            formArray.insert(this.form.get(this.arrayPropertyName).value.length, form);
        });
    }
    addChilds(formPai, entity) {
        let formArray = formPai.get(this.arrayPropertyNameChild);
        let formSon = this.formCreate();
        formSon.patchValue(entity);
        formArray.push(formSon);
        if (entity[this.arrayPropertyNameChild] && entity[this.arrayPropertyNameChild].length > 0) {
            if (this.isReverse) {
                entity[this.arrayPropertyNameChild].slice().reverse().forEach(ac => this.addChilds(formSon, ac));
            }
            else {
                entity[this.arrayPropertyNameChild].forEach(ac => this.addChilds(formSon, ac));
            }
        }
    }
}
CrudOnePageEditableComponent.ɵfac = function CrudOnePageEditableComponent_Factory(t) { return new (t || CrudOnePageEditableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
CrudOnePageEditableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudOnePageEditableComponent, selectors: [["crud-one-page-editable"]], inputs: { isReverse: "isReverse", entity: "entity", arrayPropertyNameChild: "arrayPropertyNameChild", form: "form", title: "title", formCreate: "formCreate", itemTemplate: "itemTemplate", arrayPropertyName: "arrayPropertyName" }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [["class", "table-editable", 4, "ngIf"], [1, "table-editable"], [1, "table-editable-header", "hidden-xs"], [1, "table-editable-content"], ["recursiveList", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["notReverse", ""], [4, "ngIf"]], template: function CrudOnePageEditableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CrudOnePageEditableComponent_div_0_Template, 7, 5, "div", 0);
    } if (rf & 2) {
        var tmp_0_0 = null;
        ɵngcc0.ɵɵproperty("ngIf", (ctx.form == null ? null : (tmp_0_0 = ctx.form.get(ctx.arrayPropertyName)) == null ? null : tmp_0_0.length) > 0);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgForOf], encapsulation: 2 });
CrudOnePageEditableComponent.ctorParameters = () => [
    { type: FormBuilder }
];
CrudOnePageEditableComponent.propDecorators = {
    form: [{ type: Input }],
    title: [{ type: Input }],
    formCreate: [{ type: Input }],
    itemTemplate: [{ type: Input }],
    arrayPropertyName: [{ type: Input }],
    arrayPropertyNameChild: [{ type: Input }],
    isReverse: [{ type: Input }],
    entity: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudOnePageEditableComponent, [{
        type: Component,
        args: [{
                selector: 'crud-one-page-editable',
                template: "<div class=\"table-editable\" *ngIf=\"form?.get(arrayPropertyName)?.length > 0\">\n  <div class=\"table-editable-header hidden-xs\">\n    <ng-content></ng-content>\n  </div>\n\n  <div class=\"table-editable-content\">\n    <ng-template #recursiveList let-controls let-prefix=\"prefix\">\n      <ng-container *ngFor=\"let item of controls; let i = index\">\n        <ng-container *ngIf=\"isReverse; else notReverse\">\n\n          <ng-container *ngIf=\"getControls(item.get(arrayPropertyNameChild))?.length\">\n            <ng-container\n              *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(item.get(arrayPropertyNameChild)), prefix: prefix + i + '.' + arrayPropertyNameChild + '.'  }\">\n            </ng-container>\n          </ng-container>\n          <ng-container *ngTemplateOutlet=\"itemTemplate;context:createContextItem(item, i)\">\n          </ng-container>\n\n        </ng-container>\n        <ng-template #notReverse>\n\n          <ng-container *ngTemplateOutlet=\"itemTemplate;context:createContextItem(item, i)\">\n          </ng-container>\n          <ng-container *ngIf=\"getControls(item.get(arrayPropertyNameChild))?.length\">\n            <ng-container\n              *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(item.get(arrayPropertyNameChild)), prefix: prefix + i + '.' + arrayPropertyNameChild + '.'  }\">\n            </ng-container>\n          </ng-container>\n\n        </ng-template>\n      </ng-container>\n    </ng-template>\n\n    <ng-container\n      *ngTemplateOutlet=\"recursiveList; context:{ $implicit: getControls(form?.get(arrayPropertyName)), prefix: arrayPropertyNameChild + '.' }\">\n    </ng-container>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { isReverse: [{
            type: Input
        }], entity: [{
            type: Input
        }], arrayPropertyNameChild: [{
            type: Input
        }], form: [{
            type: Input
        }], title: [{
            type: Input
        }], formCreate: [{
            type: Input
        }], itemTemplate: [{
            type: Input
        }], arrayPropertyName: [{
            type: Input
        }] }); })();

class CrudOnePageEditableModule {
}
CrudOnePageEditableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudOnePageEditableModule });
CrudOnePageEditableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudOnePageEditableModule_Factory(t) { return new (t || CrudOnePageEditableModule)(); }, imports: [[
            CommonModule$1,
            ReactiveFormsModule,
            PanelModule,
            DialogModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudOnePageEditableModule, { declarations: function () { return [CrudOnePageEditableComponent]; }, imports: function () { return [CommonModule$1,
        ReactiveFormsModule, PanelModule, DialogModule]; }, exports: function () { return [CrudOnePageEditableComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudOnePageEditableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    ReactiveFormsModule,
                    PanelModule,
                    DialogModule
                ],
                declarations: [CrudOnePageEditableComponent],
                exports: [CrudOnePageEditableComponent]
            }]
    }], null, null); })();

class EntityLogService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.nameModel = '';
        this.resource = '/api/log';
    }
    findAll(page, search, fields, disableSpinner) {
        return this.httpClient.get({
            resource: `${this.resource}/${this.nameModel}`,
            page: page,
            search: this.buildSearch(search),
            disableSpinner: disableSpinner,
            fields: this.calculeFields(fields),
            location: this.location
        });
    }
    compareLog(revisionNumber, id) {
        return this.httpClient.get({
            resource: `${this.resource}/${this.nameModel}/${revisionNumber}/${id}`,
        });
    }
    loadFieldModels() {
        return this.httpClient.get({
            resource: `${this.resource}/${this.nameModel}/model`,
        });
    }
}
EntityLogService.ɵfac = function EntityLogService_Factory(t) { return new (t || EntityLogService)(ɵngcc0.ɵɵinject(HttpClient)); };
EntityLogService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EntityLogService, factory: EntityLogService.ɵfac });
EntityLogService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityLogService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class CrudSearchLogComponent {
    constructor(entityLogService, activatedRoute) {
        this.entityLogService = entityLogService;
        this.activatedRoute = activatedRoute;
        this.fieldsToDisplay = [];
        this.visao = 'user';
    }
    ngOnInit() {
        this.setModel();
        this.setFieldsToFilter();
    }
    setModel() {
        this.nameModel = this.activatedRoute.snapshot.queryParams['model'];
        this.entityLogService.nameModel = this.nameModel;
    }
    setFieldsToFilter() {
        this.fieldsToDisplay = ['revisionType', 'userName', 'revisionNumber', 'revisionDate',
            'remoteIpAddress', 'activeView']
            .concat(this.activatedRoute.snapshot.queryParams['fields'].split(','));
    }
    onDetails(object) {
        object.expand = !object.expand;
        if (!object.revision) {
            this.entityLogService.compareLog(object.object.revisionNumber, object.id).subscribe(value => {
                this.entityLogService.loadFieldModels().subscribe(model => {
                    object.comparisonsDev = JsonUtil.getComparisonsFromJson(value.before, value.actual);
                    object.comparisonsUser = JsonUtil.getComparisonsFromJson(JsonUtil.replaceKeyWithFieldModel(value.before, model), JsonUtil.replaceKeyWithFieldModel(value.actual, model));
                });
            });
        }
    }
}
CrudSearchLogComponent.ɵfac = function CrudSearchLogComponent_Factory(t) { return new (t || CrudSearchLogComponent)(ɵngcc0.ɵɵdirectiveInject(EntityLogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ActivatedRoute)); };
CrudSearchLogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudSearchLogComponent, selectors: [["crud-search-log"]], decls: 8, vars: 9, consts: [["crudResource", "/log", 3, "fieldsToDisplay", "entityService", "orderBy", "enableRemove", "enableEdit", "enableCreate", "enableTablePrint", "beforeExtraElement"], ["eloColumns", ""], ["title", "Detalhes", "icon", "fa fa-chevron-down", "id", "idDetails", 3, "removeAutoFocus", "onClickIconButton"], ["dataTableExpand", ""], ["interfaceUserTecnico", ""], [3, "field", "header", "dataTable"], ["dataTableCell", ""], [3, "field", "header", "dataTable", "isDateTime"], [1, "col-md-6"], ["class", "chip-container positive outlined center", 4, "ngIf"], ["class", "chip-container warning outlined center", 4, "ngIf"], ["class", "chip-container negative outlined center", 4, "ngIf"], [1, "chip-container", "positive", "outlined", "center"], [1, "chip-text"], [1, "chip-container", "warning", "outlined", "center"], [1, "chip-container", "negative", "outlined", "center"], [1, "table-editable", "panel-table-outer"], [1, "table-editable-header"], [1, "row"], [1, "col-md-4", "column"], [1, "col-md-5", "column"], ["class", "table-editable-content", 4, "ngIf"], [1, "table-editable-content"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "column", "col-md-4"], [1, "col-sm-12"], [1, "form-group"], [3, "ngModel", "ngModelChange"], ["title", "Usu\u00E1rio", "value", "user", 1, ""], ["title", "T\u00E9cnico", "value", "dev"]], template: function CrudSearchLogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "crud-search", 0);
        ɵngcc0.ɵɵtemplate(1, CrudSearchLogComponent_ng_template_1_Template, 18, 20, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(3, "elo-table-actions", 2);
        ɵngcc0.ɵɵlistener("onClickIconButton", function CrudSearchLogComponent_Template_elo_table_actions_onClickIconButton_3_listener($event) { return ctx.onDetails($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, CrudSearchLogComponent_ng_template_4_Template, 15, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, CrudSearchLogComponent_ng_template_6_Template, 6, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r4 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵproperty("fieldsToDisplay", ctx.fieldsToDisplay)("entityService", ctx.entityLogService)("orderBy", "id,asc")("enableRemove", false)("enableEdit", false)("enableCreate", false)("enableTablePrint", false)("beforeExtraElement", _r4);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("removeAutoFocus", true);
    } }, directives: function () { return [CrudSearchComponent, EloTableActionsComponent, EloColumnComponent, ɵngcc2.NgIf, PanelComponent, ɵngcc2.NgForOf, SwitchButtonComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, SwitchButtonItemComponent]; }, pipes: function () { return [ɵngcc2.DatePipe]; }, encapsulation: 2 });
CrudSearchLogComponent.ctorParameters = () => [
    { type: EntityLogService },
    { type: ActivatedRoute }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudSearchLogComponent, [{
        type: Component,
        args: [{
                selector: 'crud-search-log',
                template: "<crud-search crudResource=\"/log\" [fieldsToDisplay]=\"fieldsToDisplay\" [entityService]=\"entityLogService\"\n  [orderBy]=\"'id,asc'\" [enableRemove]=\"false\" [enableEdit]=\"false\" [enableCreate]=\"false\" [enableTablePrint]=\"false\"\n  [beforeExtraElement]=\"interfaceUserTecnico\">\n  <ng-template #eloColumns let-dataTable=\"dataTable\">\n    <elo-column [field]=\"'revisionNumber'\" [header]=\"'Revis\u00E3o / C\u00F3digo'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">\n        {{ object?.object?.revisionNumber }}/{{object.id}}\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'revType'\" [header]=\"'Tipo Movimento'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">\n        <div class=\"col-md-6\">\n          <div class=\"chip-container positive outlined center\" *ngIf=\"object.revType === 'ADD'\">\n            <p class=\"chip-text\">Adi\u00E7\u00E3o</p>\n          </div>\n          <div class=\"chip-container warning outlined center\" *ngIf=\"object.revType === 'MOD'\">\n            <p class=\"chip-text\">Edi\u00E7\u00E3o</p>\n          </div>\n          <div class=\"chip-container negative outlined center\" *ngIf=\"object.revType === 'DEL'\">\n            <p class=\"chip-text\">Remo\u00E7\u00E3o</p>\n          </div>\n        </div>\n\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'revisionDate'\" [header]=\"'Data'\" [dataTable]=\"dataTable\" [isDateTime]=\"true\">\n      <ng-template #dataTableCell let-object=\"object\">\n        {{ object?.object?.revisionDate | date: \"dd/MM/yyyy HH:mm\" }}\n      </ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'userName'\" [header]=\"'Usu\u00E1rio'\" [dataTable]=\"dataTable\" [isDateTime]=\"true\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.userName }}</ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'remoteIpAddress'\" [header]=\"'Ip'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.remoteIpAddress }}</ng-template>\n    </elo-column>\n\n    <elo-column [field]=\"'activeView'\" [header]=\"'Tela'\" [dataTable]=\"dataTable\">\n      <ng-template #dataTableCell let-object=\"object\">{{ object?.object?.activeView }}</ng-template>\n    </elo-column>\n\n\n  </ng-template>\n\n  <elo-table-actions title=\"Detalhes\" icon=\"fa fa-chevron-down\" id=\"idDetails\" (onClickIconButton)=\"onDetails($event)\"\n    [removeAutoFocus]=\"true\"></elo-table-actions>\n\n  <ng-template #dataTableExpand let-object=\"object\">\n    <elo-panel>\n      <div class=\"table-editable panel-table-outer\">\n        <div class=\"table-editable-header\">\n          <div class=\"row\">\n            <div class=\"col-md-4 column\"><span> Campo </span></div>\n            <div class=\"col-md-5 column \"><span> Valor Anterior </span></div>\n            <div class=\"col-md-5 column\"><span> Valor Atual </span></div>\n          </div>\n        </div>\n        <div class=\"table-editable-content\" *ngIf=\"visao === 'user'\">\n          <div class=\"row\" *ngFor=\"let compare of object?.comparisonsUser\">\n            <div class=\"column col-md-4\"><span> {{ compare?.path }} </span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.before }}</span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.after }} </span></div>\n          </div>\n        </div>\n        <div class=\"table-editable-content\" *ngIf=\"visao === 'dev'\">\n          <div class=\"row\" *ngFor=\"let compare of object?.comparisonsDev\">\n            <div class=\"column col-md-4\"><span> {{ compare?.path }} </span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.before }}</span></div>\n            <div class=\"column col-md-4\"><span> {{ compare?.after }} </span></div>\n          </div>\n        </div>\n      </div>\n    </elo-panel>\n  </ng-template>\n\n</crud-search>\n\n<ng-template #interfaceUserTecnico>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"form-group\">\n        <elo-switch-button [(ngModel)]=\"visao\">\n          <elo-switch-button-item class=\"\" title=\"Usu\u00E1rio\" value=\"user\"></elo-switch-button-item>\n          <elo-switch-button-item title=\"T\u00E9cnico\" value=\"dev\"></elo-switch-button-item>\n        </elo-switch-button>\n      </div>\n    </div>\n  </div>\n</ng-template>"
            }]
    }], function () { return [{ type: EntityLogService }, { type: ɵngcc6.ActivatedRoute }]; }, null); })();

class TableReportComponent {
    constructor() {
        this.small = true;
    }
}
TableReportComponent.ɵfac = function TableReportComponent_Factory(t) { return new (t || TableReportComponent)(); };
TableReportComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableReportComponent, selectors: [["elo-table-report"]], inputs: { small: "small", visible: "visible" }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [["class", "table-report", 3, "small", 4, "ngIf"], [1, "table-report"]], template: function TableReportComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TableReportComponent_div_0_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.visible);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
TableReportComponent.propDecorators = {
    visible: [{ type: Input }],
    small: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TableReportComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-report',
                template: "<div class=\"table-report\" [class.small]=\"small\" *ngIf=\"visible\">\n    <ng-content></ng-content>\n</div>\n"
            }]
    }], function () { return []; }, { small: [{
            type: Input
        }], visible: [{
            type: Input
        }] }); })();

class TableReportGroupComponent {
}
TableReportGroupComponent.ɵfac = function TableReportGroupComponent_Factory(t) { return new (t || TableReportGroupComponent)(); };
TableReportGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableReportGroupComponent, selectors: [["elo-table-report-group"]], inputs: { label: "label", description: "description", extraLabel: "extraLabel", extraDescription: "extraDescription", hasSubNivel: "hasSubNivel", columnFirstGroup: "columnFirstGroup", columnSecondGroup: "columnSecondGroup" }, ngContentSelectors: _c0, decls: 11, vars: 12, consts: [[1, "group-title", "col-xs-12"]], template: function TableReportGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "ul");
        ɵngcc0.ɵɵelementStart(1, "li", 0);
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelementStart(3, "b");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div");
        ɵngcc0.ɵɵelementStart(7, "b");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("has-subnivel", ctx.hasSubNivel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ctx.columnFirstGroup ? ctx.columnFirstGroup : "col-md-10 col-xs-6");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.description, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.columnSecondGroup ? "group-extra " + ctx.columnSecondGroup : "group-extra col-md-2 col-xs-6 text-right");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.extraLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.extraDescription, " ");
    } }, encapsulation: 2 });
TableReportGroupComponent.propDecorators = {
    label: [{ type: Input }],
    description: [{ type: Input }],
    extraLabel: [{ type: Input }],
    extraDescription: [{ type: Input }],
    hasSubNivel: [{ type: Input }],
    columnFirstGroup: [{ type: Input }],
    columnSecondGroup: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TableReportGroupComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-report-group',
                template: "<ul [class.has-subnivel]=\"hasSubNivel\">\n  <li class=\"group-title col-xs-12\">\n    <div class=\"{{ columnFirstGroup ? columnFirstGroup : 'col-md-10 col-xs-6' }}\">\n      <b>{{label}}</b> {{description}}\n    </div>\n    <div class=\"{{ columnSecondGroup ? 'group-extra ' + columnSecondGroup : 'group-extra col-md-2 col-xs-6 text-right'}}\">\n      <b>{{extraLabel}}</b>{{extraDescription}}\n    </div>\n  </li>\n\n  <ng-content></ng-content>\n</ul>\n"
            }]
    }], null, { label: [{
            type: Input
        }], description: [{
            type: Input
        }], extraLabel: [{
            type: Input
        }], extraDescription: [{
            type: Input
        }], hasSubNivel: [{
            type: Input
        }], columnFirstGroup: [{
            type: Input
        }], columnSecondGroup: [{
            type: Input
        }] }); })();

class TableReportGroupItensComponent {
    constructor() {
        this.scroll = false;
    }
}
TableReportGroupItensComponent.ɵfac = function TableReportGroupItensComponent_Factory(t) { return new (t || TableReportGroupItensComponent)(); };
TableReportGroupItensComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableReportGroupItensComponent, selectors: [["elo-table-report-group-itens"]], inputs: { scroll: "scroll", headers: "headers", maxHeightOnScroll: "maxHeightOnScroll" }, ngContentSelectors: _c0, decls: 6, vars: 6, consts: [[1, "row"], [1, "col-md-12", "hidden-xs"], [1, "group-header"], [3, "class", 4, "ngFor", "ngForOf"], [1, "group-itens", 3, "ngStyle"]], template: function TableReportGroupItensComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, TableReportGroupItensComponent_div_3_Template, 2, 5, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul", 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.headers);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("scroll", ctx.scroll);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c31, ctx.maxHeightOnScroll ? ctx.maxHeightOnScroll : ""));
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgStyle], encapsulation: 2 });
TableReportGroupItensComponent.propDecorators = {
    headers: [{ type: Input }],
    scroll: [{ type: Input }],
    maxHeightOnScroll: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TableReportGroupItensComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-report-group-itens',
                template: "<div class=\"row\">\n    <div class=\"col-md-12 hidden-xs\">\n        <div class=\"group-header\" >\n            <div *ngFor=\"let header of headers\" class=\"col-md-{{header.column}} {{header.columnSize}}\">\n                {{header.name}}\n            </div>\n        </div>\n    </div>\n</div>\n<ul class=\"group-itens\" [class.scroll]=\"scroll\" [ngStyle]=\"{'max-height': maxHeightOnScroll ? maxHeightOnScroll : ''}\">\n    <ng-content></ng-content>\n</ul>\n"
            }]
    }], function () { return []; }, { scroll: [{
            type: Input
        }], headers: [{
            type: Input
        }], maxHeightOnScroll: [{
            type: Input
        }] }); })();

class TableReportItemComponent {
    constructor() {
        this.clickable = false;
        this.showError = false;
    }
}
TableReportItemComponent.ɵfac = function TableReportItemComponent_Factory(t) { return new (t || TableReportItemComponent)(); };
TableReportItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableReportItemComponent, selectors: [["elo-table-report-item"]], inputs: { clickable: "clickable", showError: "showError", item: "item" }, decls: 4, vars: 5, consts: [[1, "group-item"], [1, "row"], [1, "col-md-12"], [3, "class", "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], [4, "ngIf", "ngIfElse"], ["default", ""]], template: function TableReportItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "li", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, TableReportItemComponent_div_3_Template, 4, 9, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pointer", ctx.clickable)("error", ctx.showError);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.item);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgClass, ɵngcc2.NgIf], pipes: [DecimalFormatPipe], encapsulation: 2 });
TableReportItemComponent.propDecorators = {
    item: [{ type: Input }],
    clickable: [{ type: Input }],
    showError: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TableReportItemComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-report-item',
                template: "<li class=\"group-item\" [class.pointer]=\"clickable\" [class.error]=\"showError\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div *ngFor=\"let val of item\" class=\"col-md-{{val.column}} group-column {{val.columnSize}}\" [attr.data-header]=\"val.dataHeader\" [ngClass]=\"val.blurValue ? 'blur-value': ''\" [ngClass]=\"val.dataHeader === 'Data'? 'group-date': ''\">\n                <p *ngIf=\"val.isDecimal; else default\">{{val.value | decimalformat : \"1.2-2\"}}</p>\n                <ng-template #default>\n                  <p>{{val.value}}</p>\n                </ng-template>\n            </div>\n        </div>\n    </div>\n</li>\n"
            }]
    }], function () { return []; }, { clickable: [{
            type: Input
        }], showError: [{
            type: Input
        }], item: [{
            type: Input
        }] }); })();

class TableReportTotalComponent {
    constructor() {
        this.geral = false;
    }
}
TableReportTotalComponent.ɵfac = function TableReportTotalComponent_Factory(t) { return new (t || TableReportTotalComponent)(); };
TableReportTotalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableReportTotalComponent, selectors: [["elo-table-report-total"]], inputs: { geral: "geral", columnSize: "columnSize", totals: "totals" }, decls: 5, vars: 6, consts: [[1, "row"], [1, "col-md-12"], [1, "total"], [3, "class", 4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["default", ""]], template: function TableReportTotalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵtemplate(4, TableReportTotalComponent_div_4_Template, 4, 6, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("geral", ctx.geral);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.columnSize);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.totals);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf], pipes: [DecimalFormatPipe], encapsulation: 2 });
TableReportTotalComponent.propDecorators = {
    columnSize: [{ type: Input }],
    geral: [{ type: Input }],
    totals: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TableReportTotalComponent, [{
        type: Component,
        args: [{
                selector: 'elo-table-report-total',
                template: "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <div class=\"total\" [class.geral]=\"geral\">\n            <div class=\"{{columnSize}}\">\n                <div *ngFor=\"let total of totals\" class=\"{{total.columnSize}}\" [attr.data-header]=\"total.dataHeader\">\n                    <b *ngIf=\"total.isDecimal; else default\">{{total.value | decimalformat : \"1.2-2\"}}</b>\n                    <ng-template #default>\n                      <b>{{total.value}}</b>\n                    </ng-template>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return []; }, { geral: [{
            type: Input
        }], columnSize: [{
            type: Input
        }], totals: [{
            type: Input
        }] }); })();

class TableReportModule {
}
TableReportModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TableReportModule });
TableReportModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TableReportModule_Factory(t) { return new (t || TableReportModule)(); }, imports: [[CommonModule$1, PipeModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TableReportModule, { declarations: function () { return [TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportTotalComponent]; }, imports: function () { return [CommonModule$1, PipeModule]; }, exports: function () { return [TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportTotalComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TableReportModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, PipeModule],
                exports: [TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportTotalComponent],
                declarations: [TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportTotalComponent]
            }]
    }], null, null); })();

class SwitchButtonItemComponent {
    constructor() {
        this.selected = false;
        this.isDisabled = false;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
}
SwitchButtonItemComponent.ɵfac = function SwitchButtonItemComponent_Factory(t) { return new (t || SwitchButtonItemComponent)(); };
SwitchButtonItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwitchButtonItemComponent, selectors: [["elo-switch-button-item"]], inputs: { selected: "selected", title: "title", value: "value" }, decls: 0, vars: 0, template: function SwitchButtonItemComponent_Template(rf, ctx) { }, encapsulation: 2 });
SwitchButtonItemComponent.propDecorators = {
    title: [{ type: Input }],
    selected: [{ type: Input }],
    value: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchButtonItemComponent, [{
        type: Component,
        args: [{
                selector: 'elo-switch-button-item',
                template: ''
            }]
    }], function () { return []; }, { selected: [{
            type: Input
        }], title: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class SwitchButtonComponent {
    constructor() {
        this.onSelected = new EventEmitter();
        this.flat = false;
        this.onChange = null;
        this.onTouched = null;
        this.valueBeforeContentInit = null;
    }
    selectButton(button) {
        this.clearSelecteds();
        button.selected = true;
        this.onSelected.emit({ selectedButton: button });
        if (this.onChange) {
            this.onChange(button.value);
        }
    }
    get visibleButtons() {
        return this.buttons.filter(button => button.title !== '');
    }
    writeValue(obj) {
        if (this.buttons && obj) {
            this.clearSelecteds();
            this.buttons.filter(btn => btn.value === obj).forEach(btn => btn.selected = true);
        }
        else {
            this.valueBeforeContentInit = obj;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    ngAfterContentInit() {
        if (this.valueBeforeContentInit) {
            this.writeValue(this.valueBeforeContentInit);
        }
    }
    clearSelecteds() {
        this.buttons.forEach(button => button.selected = false);
    }
}
SwitchButtonComponent.ɵfac = function SwitchButtonComponent_Factory(t) { return new (t || SwitchButtonComponent)(); };
SwitchButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwitchButtonComponent, selectors: [["elo-switch-button"]], contentQueries: function SwitchButtonComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SwitchButtonItemComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttons = _t);
    } }, inputs: { flat: "flat" }, outputs: { onSelected: "onSelected" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: SwitchButtonComponent }
        ])], decls: 2, vars: 3, consts: [[1, "switch-buttons"], ["class", "btn", "type", "button", 3, "active", "click", 4, "ngFor", "ngForOf"], ["type", "button", 1, "btn", 3, "click"]], template: function SwitchButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SwitchButtonComponent_button_1_Template, 2, 3, "button", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("flat", ctx.flat);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.visibleButtons);
    } }, directives: [ɵngcc2.NgForOf], encapsulation: 2 });
SwitchButtonComponent.propDecorators = {
    buttons: [{ type: ContentChildren, args: [SwitchButtonItemComponent,] }],
    onSelected: [{ type: Output }],
    flat: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchButtonComponent, [{
        type: Component,
        args: [{
                selector: 'elo-switch-button',
                template: "<div class=\"switch-buttons\" [class.flat]=\"flat\">\n    <button *ngFor=\"let button of visibleButtons\" (click)=\"selectButton(button)\" class=\"btn\" [class.active]=\"button.selected\" type=\"button\">\n      {{button.title}}\n    </button>\n</div>\n",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: SwitchButtonComponent }
                ]
            }]
    }], function () { return []; }, { onSelected: [{
            type: Output
        }], flat: [{
            type: Input
        }], buttons: [{
            type: ContentChildren,
            args: [SwitchButtonItemComponent]
        }] }); })();

class SwitchButtonModule {
}
SwitchButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SwitchButtonModule });
SwitchButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SwitchButtonModule_Factory(t) { return new (t || SwitchButtonModule)(); }, imports: [[CommonModule$1], ReactiveFormsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SwitchButtonModule, { declarations: function () { return [SwitchButtonComponent, SwitchButtonItemComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [SwitchButtonComponent, SwitchButtonItemComponent, ReactiveFormsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [SwitchButtonComponent, SwitchButtonItemComponent, ReactiveFormsModule],
                declarations: [SwitchButtonComponent, SwitchButtonItemComponent]
            }]
    }], null, null); })();

class CanActivateRoute {
}

const routes = [
    { path: '', component: CrudSearchLogComponent, canActivate: [CanActivateRoute] }
];
class CrudSearchLogModule {
}
CrudSearchLogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudSearchLogModule });
CrudSearchLogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudSearchLogModule_Factory(t) { return new (t || CrudSearchLogModule)(); }, providers: [EntityLogService], imports: [[RouterModule.forChild(routes),
            CommonModule$1,
            TableReportModule,
            PipeModule,
            PanelModule,
            FormLabelColumnModule,
            FormsModule,
            CrudSearchModule,
            EloDatatableModule,
            SwitchButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudSearchLogModule, { declarations: function () { return [CrudSearchLogComponent]; }, imports: function () { return [ɵngcc6.RouterModule, CommonModule$1, TableReportModule, PipeModule, PanelModule, FormLabelColumnModule, FormsModule, CrudSearchModule, EloDatatableModule, SwitchButtonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudSearchLogModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes),
                    CommonModule$1,
                    TableReportModule,
                    PipeModule,
                    PanelModule,
                    FormLabelColumnModule,
                    FormsModule,
                    CrudSearchModule,
                    EloDatatableModule,
                    SwitchButtonModule
                ],
                declarations: [CrudSearchLogComponent],
                providers: [EntityLogService]
            }]
    }], null, null); })();

class ButtonLogComponent {
    constructor() {
        this.label = 'Ver Logs';
        this.onClick = new EventEmitter();
    }
    onClickButton() {
        this.onClick.emit();
    }
}
ButtonLogComponent.ɵfac = function ButtonLogComponent_Factory(t) { return new (t || ButtonLogComponent)(); };
ButtonLogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ButtonLogComponent, selectors: [["button-log"]], inputs: { label: "label" }, outputs: { onClick: "onClick" }, decls: 4, vars: 1, consts: [["id", "btnLogs", "type", "button", 1, "btn", "circle", "pull-right", 3, "click"], [1, "fa", "fa-history"], [1, "btn-actions-label"]], template: function ButtonLogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function ButtonLogComponent_Template_button_click_0_listener() { return ctx.onClickButton(); });
        ɵngcc0.ɵɵelement(1, "em", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, encapsulation: 2 });
ButtonLogComponent.propDecorators = {
    label: [{ type: Input }],
    onClick: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonLogComponent, [{
        type: Component,
        args: [{
                selector: 'button-log',
                template: `
    <button id="btnLogs" class="btn circle pull-right" type="button" (click)="onClickButton()">
      <em class="fa fa-history"></em>
      <div class="btn-actions-label">{{ label }}</div>
    </button>
  `
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], onClick: [{
            type: Output
        }] }); })();

class ButtonLogModule {
}
ButtonLogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ButtonLogModule });
ButtonLogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ButtonLogModule_Factory(t) { return new (t || ButtonLogModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonLogModule, { declarations: function () { return [ButtonLogComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [ButtonLogComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonLogModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [ButtonLogComponent],
                exports: [ButtonLogComponent]
            }]
    }], null, null); })();

class CrudTreeComponent {
    constructor() {
        this.children = [];
        this.fieldNameSuperior = 'superior';
        this.onRequestChildren = new EventEmitter();
        this.permissionEdit = true;
        this.permissionCreate = true;
        this.permissionRemove = false;
        this.maxLevels = Number.MAX_SAFE_INTEGER;
        this.onRemove = new EventEmitter();
        this.isSelected = false;
        this.isEditing = false;
        this.ctx = { objectSelected: null, onCloseForm: new EventEmitter() };
        this.groups = [];
        this._namesLevels = [];
    }
    set namesLevels(values) {
        this._namesLevels = values;
        for (let i = 0; i < this.groups.length; i++) {
            this.groups[i].titleDefault = this._namesLevels[i];
        }
    }
    ngOnInit() {
        this.onRequestChildren.emit(null);
        this.addGroup(null);
        this.groups[0].isChecked = true;
        this.ctx.onCloseForm.subscribe(() => this.onClose());
    }
    edit(event, object) {
        event.stopPropagation();
        this.objectSelected = object;
        this.ctx.objectSelected = this.objectSelected;
        this.changeToEditMode(true);
    }
    onAddButton() {
        const objectSuperior = this.groups[this.groups.length - 1].object;
        this.objectSelected = {};
        if (objectSuperior) {
            this.objectSelected[this.fieldNameSuperior] = objectSuperior;
        }
        this.ctx.objectSelected = this.objectSelected;
        this.changeToEditMode(true);
    }
    changeToEditMode(value) {
        this.isEditing = value;
        const group = this.groups[this.groups.length - 1];
        group.isEditing = value;
    }
    onChangeGroup(event) {
        this.groups = this.groups.slice(0, event.indice + 1);
        const group = this.groups[this.groups.length - 1];
        this.onRequestChildren.emit(group.object);
        group.itemSelected = false;
        group.titleDefault = this.getTitleDefault(this.groups.length - 1);
        group.isChecked = true;
        group.isEditing = false;
        this.isEditing = false;
    }
    onClose() {
        this.changeToEditMode(false);
        const group = this.groups[this.groups.length - 1];
        this.onRequestChildren.emit(group.object);
    }
    choice(object) {
        if (!this.reachedMaxLevel()) {
            const group = this.groups[this.groups.length - 1];
            group.itemSelected = object.descricao;
            group.isChecked = false;
            group.isEditing = true;
            this.addGroup(object);
            this.onRequestChildren.emit(object);
        }
    }
    reachedMaxLevel() {
        return this.groups.length >= this.maxLevels;
    }
    onClickRemove(event, object) {
        event.stopPropagation();
        this.onRemove.emit(object);
    }
    addGroup(object) {
        this.groups.push({
            indice: this.groups.length,
            titleDefault: this.getTitleDefault(this.groups.length),
            itemSelected: false,
            id: this.groups.length,
            opacity: 1 - this.groups.length * 0.15,
            isChecked: true,
            isEditing: false,
            object: object
        });
    }
    getTitleDefault(index) {
        return this._namesLevels[index] ? this._namesLevels[index] : `Nível ${index + 1}`;
    }
}
CrudTreeComponent.ɵfac = function CrudTreeComponent_Factory(t) { return new (t || CrudTreeComponent)(); };
CrudTreeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudTreeComponent, selectors: [["crud-tree"]], inputs: { children: "children", fieldNameSuperior: "fieldNameSuperior", permissionEdit: "permissionEdit", permissionCreate: "permissionCreate", permissionRemove: "permissionRemove", maxLevels: "maxLevels", namesLevels: "namesLevels", crudTemplateRef: "crudTemplateRef", otherField: "otherField" }, outputs: { onRequestChildren: "onRequestChildren", onRemove: "onRemove" }, decls: 2, vars: 1, consts: [["id", "accordionItem", "class", "advtree-item", 3, "ngClass", "obj", "hasPermission", "addButtons", "onChangeGroupSelected", 4, "ngFor", "ngForOf"], ["id", "accordionItem", 1, "advtree-item", 3, "ngClass", "obj", "hasPermission", "addButtons", "onChangeGroupSelected"], [1, "advtree-content"], ["id", "empty-objects", "class", "info primary icon", 4, "ngIf"], ["id", "list-objects", "class", "list", 4, "ngIf"], ["id", "form-template", 4, "ngIf"], ["id", "empty-objects", 1, "info", "primary", "icon"], [1, "icon"], [1, "fa", "fa-info-circle"], ["id", "list-objects", 1, "list"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"], [1, "description"], [4, "ngIf"], [1, "btn-actions"], ["class", "btn circle", "type", "button", 4, "ngIf"], ["class", "btn circle", 3, "click", 4, "ngIf"], ["id", "btnRemove", "class", "btn circle", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "circle"], [1, "fa", "fa-level-up"], [1, "btn-actions-label"], [1, "btn", "circle", 3, "click"], [1, "fa", "fa-pencil"], ["id", "btnRemove", 1, "btn", "circle", 3, "click"], [1, "fa", "fa-trash"], ["id", "form-template"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function CrudTreeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "elo-accordion");
        ɵngcc0.ɵɵtemplate(1, CrudTreeComponent_elo_accordion_item_1_Template, 5, 9, "elo-accordion-item", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.groups);
    } }, directives: [AccordionComponent, ɵngcc2.NgForOf, AccordionItemComponent, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
CrudTreeComponent.propDecorators = {
    children: [{ type: Input }],
    crudTemplateRef: [{ type: Input }],
    fieldNameSuperior: [{ type: Input }],
    onRequestChildren: [{ type: Output }],
    permissionEdit: [{ type: Input }],
    permissionCreate: [{ type: Input }],
    permissionRemove: [{ type: Input }],
    otherField: [{ type: Input }],
    maxLevels: [{ type: Input }],
    onRemove: [{ type: Output }],
    namesLevels: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudTreeComponent, [{
        type: Component,
        args: [{
                selector: 'crud-tree',
                template: "<elo-accordion>\n\n  <elo-accordion-item id=\"accordionItem\" class=\"advtree-item\" [ngClass]=\"{'checked': group.isChecked, 'done': group.itemSelected}\"\n    *ngFor=\"let group of groups\" [obj]=\"group\"\n    [hasPermission]=\"permissionCreate\" (addButtons)=\"onAddButton()\" (onChangeGroupSelected)=\"onChangeGroup($event)\">\n\n    <div class=\"advtree-content\">\n\n      <div id=\"empty-objects\" class=\"info primary icon\" *ngIf=\"children.length === 0 && !isEditing && group.isChecked\">\n        <div class=\"icon\">\n          <em class=\"fa fa-info-circle\"></em></div>\n        <article>\n          <p>N\u00E3o existem itens cadastrados neste n\u00EDvel.</p>\n        </article>\n      </div>\n\n      <ul id=\"list-objects\" class=\"list\" *ngIf=\"!isEditing && children.length > 0\">\n        <li *ngFor=\"let object of children\" (click)=\"choice(object)\">\n\n          <div class=\"description\">{{ object.codigo }} - {{ object.descricao }}\n            <ng-container\n              *ngIf=\"otherField && object[otherField.field] && object[otherField.field][otherField.children]\">\n              - {{object[otherField.field][otherField.children]}}\n            </ng-container>\n          </div>\n\n          <div class=\"btn-actions\">\n            <button class=\"btn circle\" type=\"button\" *ngIf=\"!reachedMaxLevel()\">\n              <i class=\"fa fa-level-up\"></i>\n              <div class=\"btn-actions-label\">\n                Entrar N\u00EDvel\n              </div>\n            </button>\n            <button class=\"btn circle\" *ngIf=\"permissionEdit\" (click)=\"edit($event, object)\">\n              <i class=\"fa fa-pencil\"></i>\n              <div class=\"btn-actions-label\">\n                Editar\n              </div>\n            </button>\n            <button id=\"btnRemove\" *ngIf=\"permissionRemove\" class=\"btn circle\" (click)=\"onClickRemove($event, object)\">\n              <i class=\"fa fa-trash\"></i>\n              <div class=\"btn-actions-label\">\n                Remover\n              </div>\n            </button>\n          </div>\n        </li>\n      </ul>\n\n      <div id=\"form-template\" *ngIf=\"isEditing\">\n        <ng-container *ngTemplateOutlet=\"crudTemplateRef;context:ctx\">\n        </ng-container>\n      </div>\n    </div>\n\n  </elo-accordion-item>\n</elo-accordion>\n"
            }]
    }], function () { return []; }, { children: [{
            type: Input
        }], fieldNameSuperior: [{
            type: Input
        }], onRequestChildren: [{
            type: Output
        }], permissionEdit: [{
            type: Input
        }], permissionCreate: [{
            type: Input
        }], permissionRemove: [{
            type: Input
        }], maxLevels: [{
            type: Input
        }], onRemove: [{
            type: Output
        }], namesLevels: [{
            type: Input
        }], crudTemplateRef: [{
            type: Input
        }], otherField: [{
            type: Input
        }] }); })();

class CrudTreeModule {
}
CrudTreeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudTreeModule });
CrudTreeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudTreeModule_Factory(t) { return new (t || CrudTreeModule)(); }, imports: [[CommonModule$1, AccordionModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudTreeModule, { declarations: function () { return [CrudTreeComponent]; }, imports: function () { return [CommonModule$1, AccordionModule]; }, exports: function () { return [CrudTreeComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudTreeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, AccordionModule],
                declarations: [CrudTreeComponent],
                exports: [CrudTreeComponent]
            }]
    }], null, null); })();

class DetailInformationComponent {
    constructor() {
        this.title = '';
        this.items = [];
    }
    addItem(item) {
        this.items.push(item);
    }
}
DetailInformationComponent.ɵfac = function DetailInformationComponent_Factory(t) { return new (t || DetailInformationComponent)(); };
DetailInformationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DetailInformationComponent, selectors: [["elo-detail-information"]], inputs: { title: "title" }, decls: 6, vars: 2, consts: [[1, "panel", "panel-default"], [1, "panel-heading"], [1, "panel-body"], [1, "list-group"], [4, "ngFor", "ngForOf"], [3, "item"]], template: function DetailInformationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, DetailInformationComponent_div_5_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: function () { return [ɵngcc2.NgForOf, ItemDetailInformationComponent]; }, styles: [".panel[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto;margin-top:20px;padding:5px;width:90%}.panel-heading[_ngcontent-%COMP%]{color:#5d5d5d;font-size:110%;font-weight:700}"] });
DetailInformationComponent.propDecorators = {
    title: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DetailInformationComponent, [{
        type: Component,
        args: [{
                selector: 'elo-detail-information',
                template: "<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    {{title}}\n  </div>\n  <div class=\"panel-body\">\n     <div class=\"list-group\">\n        <div *ngFor=\"let item of items\">\n          <elo-item-detail-information [item]=\"item\" ></elo-item-detail-information>\n        </div>\n     </div>\n  </div>\n</div>\n",
                styles: [".panel{margin-left:auto;margin-right:auto;margin-top:20px;padding:5px;width:90%}.panel-heading{color:#5d5d5d;font-size:110%;font-weight:700}"]
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }] }); })();

class ItemDetailInformationDirective {
    constructor(detailInformation) {
        this.detailInformation = detailInformation;
        this.md = 0;
        this.lineTitle = '';
        this.lineValue = '';
        this.detailInformation.addItem(this);
    }
}
ItemDetailInformationDirective.ɵfac = function ItemDetailInformationDirective_Factory(t) { return new (t || ItemDetailInformationDirective)(ɵngcc0.ɵɵdirectiveInject(DetailInformationComponent)); };
ItemDetailInformationDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ItemDetailInformationDirective, selectors: [["", "itemDetailInformation", ""]], inputs: { md: "md", lineTitle: "lineTitle", lineValue: "lineValue" } });
ItemDetailInformationDirective.ctorParameters = () => [
    { type: DetailInformationComponent }
];
ItemDetailInformationDirective.propDecorators = {
    md: [{ type: Input }],
    lineTitle: [{ type: Input }],
    lineValue: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ItemDetailInformationDirective, [{
        type: Directive,
        args: [{
                selector: '[itemDetailInformation]'
            }]
    }], function () { return [{ type: DetailInformationComponent }]; }, { md: [{
            type: Input
        }], lineTitle: [{
            type: Input
        }], lineValue: [{
            type: Input
        }] }); })();

class ItemDetailInformationComponent {
}
ItemDetailInformationComponent.ɵfac = function ItemDetailInformationComponent_Factory(t) { return new (t || ItemDetailInformationComponent)(); };
ItemDetailInformationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ItemDetailInformationComponent, selectors: [["elo-item-detail-information"]], inputs: { item: "item" }, decls: 7, vars: 5, consts: [[1, "list-group-item"], [1, "list-group-item-heading"], [1, "lineTitle"], [1, "lineValue"]], template: function ItemDetailInformationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "a", 0);
        ɵngcc0.ɵɵelementStart(2, "p", 1);
        ɵngcc0.ɵɵelementStart(3, "span", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("col-md-", ctx.item.md, "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.item.lineTitle, ": ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.item.lineValue);
    } }, styles: [".lineTitle[_ngcontent-%COMP%]{color:#226e92;font-size:98%;font-weight:700}.lineValue[_ngcontent-%COMP%]{font-size:100%}.col-lg-1[_ngcontent-%COMP%], .col-lg-2[_ngcontent-%COMP%], .col-lg-3[_ngcontent-%COMP%], .col-lg-4[_ngcontent-%COMP%], .col-lg-5[_ngcontent-%COMP%], .col-lg-6[_ngcontent-%COMP%], .col-lg-7[_ngcontent-%COMP%], .col-lg-8[_ngcontent-%COMP%], .col-lg-9[_ngcontent-%COMP%], .col-lg-10[_ngcontent-%COMP%], .col-lg-11[_ngcontent-%COMP%], .col-lg-12[_ngcontent-%COMP%], .col-md-1[_ngcontent-%COMP%], .col-md-2[_ngcontent-%COMP%], .col-md-3[_ngcontent-%COMP%], .col-md-4[_ngcontent-%COMP%], .col-md-5[_ngcontent-%COMP%], .col-md-6[_ngcontent-%COMP%], .col-md-7[_ngcontent-%COMP%], .col-md-8[_ngcontent-%COMP%], .col-md-9[_ngcontent-%COMP%], .col-md-10[_ngcontent-%COMP%], .col-md-11[_ngcontent-%COMP%], .col-md-12[_ngcontent-%COMP%], .col-sm-1[_ngcontent-%COMP%], .col-sm-2[_ngcontent-%COMP%], .col-sm-3[_ngcontent-%COMP%], .col-sm-4[_ngcontent-%COMP%], .col-sm-5[_ngcontent-%COMP%], .col-sm-6[_ngcontent-%COMP%], .col-sm-7[_ngcontent-%COMP%], .col-sm-8[_ngcontent-%COMP%], .col-sm-9[_ngcontent-%COMP%], .col-sm-10[_ngcontent-%COMP%], .col-sm-11[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%], .col-xs-1[_ngcontent-%COMP%], .col-xs-2[_ngcontent-%COMP%], .col-xs-3[_ngcontent-%COMP%], .col-xs-4[_ngcontent-%COMP%], .col-xs-5[_ngcontent-%COMP%], .col-xs-6[_ngcontent-%COMP%], .col-xs-7[_ngcontent-%COMP%], .col-xs-8[_ngcontent-%COMP%], .col-xs-9[_ngcontent-%COMP%], .col-xs-10[_ngcontent-%COMP%], .col-xs-11[_ngcontent-%COMP%], .col-xs-12[_ngcontent-%COMP%]{margin-left:-15px;margin-right:-15px}*[_ngcontent-%COMP%], [_ngcontent-%COMP%]:after, [_ngcontent-%COMP%]:before{box-sizing:content-box}"] });
ItemDetailInformationComponent.propDecorators = {
    item: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ItemDetailInformationComponent, [{
        type: Component,
        args: [{
                selector: 'elo-item-detail-information',
                template: "<div class=\"col-md-{{item.md}}\">\n  <a class=\"list-group-item\">\n    <p class=\"list-group-item-heading\">\n      <span class=\"lineTitle\">{{item.lineTitle}}: </span>\n      <span class=\"lineValue\">{{item.lineValue}}</span>\n    </p>\n  </a>\n</div>\n",
                styles: [".lineTitle{color:#226e92;font-size:98%;font-weight:700}.lineValue{font-size:100%}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{margin-left:-15px;margin-right:-15px}*,:after,:before{box-sizing:content-box}"]
            }]
    }], null, { item: [{
            type: Input
        }] }); })();

class DetailInformationModule {
}
DetailInformationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DetailInformationModule });
DetailInformationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DetailInformationModule_Factory(t) { return new (t || DetailInformationModule)(); }, imports: [[
            CommonModule$1
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DetailInformationModule, { declarations: function () { return [DetailInformationComponent, ItemDetailInformationComponent, ItemDetailInformationDirective]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [DetailInformationComponent, ItemDetailInformationDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DetailInformationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DetailInformationComponent,
                    ItemDetailInformationComponent,
                    ItemDetailInformationDirective
                ],
                imports: [
                    CommonModule$1
                ],
                exports: [DetailInformationComponent, ItemDetailInformationDirective]
            }]
    }], null, null); })();

class EntidadeSelectorComponent {
    constructor(authParams) {
        this.authParams = authParams;
        this.onSelectEntidade = new EventEmitter();
        this.expansive = false;
        this.collapsed = false;
        this.title = 'Entidades';
        this.entidades = [];
        this.entidadesPadrao = [];
    }
    ngOnInit() {
        this.entidadeService.findAllUnlimited('', new PageParameters(9999, 0, 'nome'))
            .subscribe(entidades => {
            this.entidades = entidades;
            this.entidadesPadrao = this.entidades.filter(e => e.id === this.authParams.getUsuarioInfo().entidadePadrao.id);
            this.selectEntidade(this.entidadesPadrao);
        });
    }
    selectEntidade(entidadesSelecionadas) {
        this.entidadesPadrao = entidadesSelecionadas;
        this.onSelectEntidade.emit(this.entidadesPadrao.map((entidade) => entidade.id).join('-'));
    }
}
EntidadeSelectorComponent.ɵfac = function EntidadeSelectorComponent_Factory(t) { return new (t || EntidadeSelectorComponent)(ɵngcc0.ɵɵdirectiveInject(AbstractAuthHttp)); };
EntidadeSelectorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EntidadeSelectorComponent, selectors: [["entidade-selector"]], inputs: { expansive: "expansive", collapsed: "collapsed", title: "title", entidadeService: "entidadeService" }, outputs: { onSelectEntidade: "onSelectEntidade" }, decls: 4, vars: 9, consts: [[1, "mt-sm"], [3, "title", "hasTable", "expansive", "collapsed"], ["selectionModeId", "entidades", "id", "entidades", "selectionMode", "multiple", 3, "emptyMessage", "values", "selection", "onModifySelection"], ["field", "nome", "header", "Nome"]], template: function EntidadeSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "elo-panel-expansive", 1);
        ɵngcc0.ɵɵelementStart(2, "elo-datatable", 2);
        ɵngcc0.ɵɵlistener("onModifySelection", function EntidadeSelectorComponent_Template_elo_datatable_onModifySelection_2_listener($event) { return ctx.selectEntidade($event); });
        ɵngcc0.ɵɵelement(3, "elo-column", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ctx.title)("hasTable", true)("expansive", ctx.expansive)("collapsed", ctx.collapsed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap("fancy fixed");
        ɵngcc0.ɵɵproperty("emptyMessage", "N\u00E3o foi encontrado entidades.")("values", ctx.entidades)("selection", ctx.entidadesPadrao);
    } }, directives: [PanelExpansiveComponent, EloDatatableComponent, EloColumnComponent], encapsulation: 2 });
EntidadeSelectorComponent.ctorParameters = () => [
    { type: AbstractAuthHttp }
];
EntidadeSelectorComponent.propDecorators = {
    onSelectEntidade: [{ type: Output }],
    entidadeService: [{ type: Input }],
    expansive: [{ type: Input }],
    collapsed: [{ type: Input }],
    title: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntidadeSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'entidade-selector',
                template: "<div class=\"mt-sm\">\n  <elo-panel-expansive [title]=\"title\" [hasTable]=\"true\" [expansive]=\"expansive\" [collapsed]=\"collapsed\">\n    <elo-datatable selectionModeId=\"entidades\" [emptyMessage]=\"'N\u00E3o foi encontrado entidades.'\" id=\"entidades\"\n      selectionMode=\"multiple\" [values]=\"entidades\" (onModifySelection)=\"selectEntidade($event)\"\n      [selection]=\"entidadesPadrao\" [class]=\"'fancy fixed'\">\n      <elo-column field=\"nome\" header=\"Nome\"></elo-column>\n    </elo-datatable>\n  </elo-panel-expansive>\n</div>\n"
            }]
    }], function () { return [{ type: AbstractAuthHttp }]; }, { onSelectEntidade: [{
            type: Output
        }], expansive: [{
            type: Input
        }], collapsed: [{
            type: Input
        }], title: [{
            type: Input
        }], entidadeService: [{
            type: Input
        }] }); })();

class EntidadeSelectorModule {
}
EntidadeSelectorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EntidadeSelectorModule });
EntidadeSelectorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EntidadeSelectorModule_Factory(t) { return new (t || EntidadeSelectorModule)(); }, imports: [[
            CommonModule$1,
            PanelExpansiveModule,
            EloDatatableModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EntidadeSelectorModule, { declarations: function () { return [EntidadeSelectorComponent]; }, imports: function () { return [CommonModule$1, PanelExpansiveModule, EloDatatableModule]; }, exports: function () { return [EntidadeSelectorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntidadeSelectorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    PanelExpansiveModule,
                    EloDatatableModule,
                ],
                declarations: [
                    EntidadeSelectorComponent
                ],
                exports: [
                    EntidadeSelectorComponent
                ]
            }]
    }], null, null); })();

class EnviarEmailComponent {
    constructor(_formBuilder) {
        this._formBuilder = _formBuilder;
        this.onEnviar = new EventEmitter();
        this.createForm();
    }
    ngOnInit() {
        this.setarFocoCampoInvalido();
    }
    addItem() {
        const emails = this.form.get('emails');
        emails.push(this.createEmailItem());
        this.setarFocoCampoInvalido();
    }
    removerItem(indice) {
        const emails = this.form.get('emails');
        emails.removeAt(indice);
        this.setarFocoCampoInvalido();
    }
    getEmails() {
        return this.form.get('emails');
    }
    enviar() {
        const emailsForm = this.getEmails();
        const emails = [];
        emailsForm.controls.forEach(email => {
            emails.push(email.value.email);
        });
        this.onEnviar.emit(emails);
    }
    createForm() {
        this.form = this._formBuilder.group({
            'emails': this._formBuilder.array([this.createEmailItem()])
        });
    }
    createEmailItem() {
        return this._formBuilder.group({
            email: [null, Validators.compose([Validators.required, EloValidators.email()])]
        });
    }
    setarFocoCampoInvalido() {
        const self = this;
        setTimeout(() => {
            let index = 0;
            const emails = self.form.get('emails');
            for (let item of emails.controls) {
                if (item.get('email').invalid) {
                    document.getElementById('email_' + index).focus();
                    return;
                }
                index++;
            }
        }, 0);
    }
}
EnviarEmailComponent.ɵfac = function EnviarEmailComponent_Factory(t) { return new (t || EnviarEmailComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
EnviarEmailComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EnviarEmailComponent, selectors: [["enviar-email"]], outputs: { onEnviar: "onEnviar" }, decls: 15, vars: 4, consts: [["hasForm", "true", 3, "title"], [3, "formGroup"], [1, "row"], [1, "col-sm-12"], [1, "form-group"], ["formArrayName", "emails", 4, "ngFor", "ngForOf"], ["id", "btnAdd", 1, "btn", "icon-left", "module-color", "full-xs", "inline", 3, "click"], [1, "fa", "fa-plus"], ["id", "btnEnviarEmail", 1, "btn", "icon-left", "positive", "full-xs", "inline", 3, "disabled", "click"], [1, "fa", "fa-paper-plane"], ["formArrayName", "emails"], [1, "padding-input", 3, "formGroupName"], [1, "col-xs-9"], ["formControlName", "email", "formControlValidationMsg", "", 3, "id"], [1, "col-xs-3"], [1, "btn", "negative", "icon", "icon-left", 3, "id", "disabled", "click"], [1, "fa", "fa-trash"]], template: function EnviarEmailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "elo-panel", 0);
        ɵngcc0.ɵɵelementStart(1, "form", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, EnviarEmailComponent_div_5_Template, 8, 4, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 2);
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵelementStart(9, "button", 6);
        ɵngcc0.ɵɵlistener("click", function EnviarEmailComponent_Template_button_click_9_listener() { return ctx.addItem(); });
        ɵngcc0.ɵɵelement(10, "i", 7);
        ɵngcc0.ɵɵtext(11, " Adicionar outro ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "button", 8);
        ɵngcc0.ɵɵlistener("click", function EnviarEmailComponent_Template_button_click_12_listener() { return ctx.enviar(); });
        ɵngcc0.ɵɵelement(13, "i", 9);
        ɵngcc0.ɵɵtext(14, " Enviar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", "Informe os emails");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.getEmails().controls);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("disabled", ctx.form.invalid);
    } }, directives: [PanelComponent, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc2.NgForOf, ɵngcc3.FormArrayName, ɵngcc3.FormGroupName, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, FormControlValidationMsgDirective], styles: [".padding-input[_ngcontent-%COMP%]{padding-bottom:50px}"] });
EnviarEmailComponent.ctorParameters = () => [
    { type: FormBuilder }
];
EnviarEmailComponent.propDecorators = {
    onEnviar: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnviarEmailComponent, [{
        type: Component,
        args: [{
                selector: 'enviar-email',
                template: "<elo-panel hasForm=\"true\" [title]=\"'Informe os emails'\">\n\n  <form [formGroup]=\"form\">\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n\n          <div formArrayName=\"emails\"\n               *ngFor=\"let item of getEmails().controls; let i = index;\">\n\n            <div [formGroupName]=\"i\" class=\"padding-input\">\n              <div class=\"col-xs-9\">\n                <input id=\"email_{{i}}\" formControlName=\"email\" formControlValidationMsg>\n              </div>\n              <div class=\"col-xs-3\">\n                <button id=\"btnRemover_{{i}}\" class=\"btn negative icon icon-left\" (click)=\"removerItem(i)\"\n                  [disabled]=\"getEmails().controls.length === 1\">\n                  <i class=\"fa fa-trash\"></i> Remover\n                </button>\n              </div>\n            </div>\n\n          </div>\n\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <button id=\"btnAdd\" class=\"btn icon-left module-color full-xs inline\" (click)=\"addItem()\">\n            <i class=\"fa fa-plus\"></i> Adicionar outro\n          </button>\n\n          <button id=\"btnEnviarEmail\" class=\"btn icon-left positive full-xs inline\" [disabled]=\"form.invalid\"\n              (click)=\"enviar()\">\n            <i class=\"fa fa-paper-plane\"></i> Enviar\n          </button>\n        </div>\n      </div>\n    </div>\n\n  </form>\n\n</elo-panel>\n\n",
                styles: [".padding-input{padding-bottom:50px}"]
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { onEnviar: [{
            type: Output
        }] }); })();

class EnviarEmailModule {
}
EnviarEmailModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EnviarEmailModule });
EnviarEmailModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EnviarEmailModule_Factory(t) { return new (t || EnviarEmailModule)(); }, imports: [[
            CommonModule$1,
            PanelModule,
            FormsModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            DirectivesModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EnviarEmailModule, { declarations: function () { return [EnviarEmailComponent]; }, imports: function () { return [CommonModule$1, PanelModule, FormsModule,
        ReactiveFormsModule, FormControlValidationMsgModule, DirectivesModule]; }, exports: function () { return [EnviarEmailComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnviarEmailModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    PanelModule,
                    FormsModule,
                    ReactiveFormsModule,
                    FormControlValidationMsgModule,
                    DirectivesModule
                ],
                declarations: [EnviarEmailComponent],
                exports: [EnviarEmailComponent]
            }]
    }], null, null); })();

class LeisAtosAutoCompleteModalComponent {
    constructor(controlContainer) {
        this.controlContainer = controlContainer;
        this.isDisabled = false;
        this.findToOptions = null;
        this.objToOptions = null;
        this.showLeisAtos = true;
        this.fieldsToFilter = ['id', 'numero', 'exercicio', 'escopo.descricao', 'tipoLeiDocumento.descricao', 'idTCE'];
        this.fieldsToDisplay = ['id', 'numero', 'exercicio', 'escopo.codigo', 'escopo.descricao', 'tipoLeiDocumento.descricao', 'idTCE'];
        this.isActiveModal = false;
    }
    ngOnInit() {
        this.form = this.controlContainer.control;
        AssertUtilsApp.assert(this.form, 'Informe o form do leis atos.');
    }
    openModal() {
        this.isActiveModal = !this.isActiveModal;
    }
    selecionarLeisAtos(leisatos) {
        this.form.get(this.controlName).patchValue(leisatos);
        this.openModal();
        this.form.markAsDirty();
    }
}
LeisAtosAutoCompleteModalComponent.ɵfac = function LeisAtosAutoCompleteModalComponent_Factory(t) { return new (t || LeisAtosAutoCompleteModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ControlContainer)); };
LeisAtosAutoCompleteModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LeisAtosAutoCompleteModalComponent, selectors: [["leis-atos-autocomplete-modal"]], inputs: { isDisabled: "isDisabled", findToOptions: "findToOptions", objToOptions: "objToOptions", showLeisAtos: "showLeisAtos", label: "label", service: "service", controlName: "controlName", column: "column", filterDefault: "filterDefault", hintMessage: "hintMessage" }, decls: 1, vars: 1, consts: [["id", "leisatos", 3, "formGroup", 4, "ngIf"], ["id", "leisatos", 3, "formGroup"], [3, "label", "column", "hintMessage"], ["id", "leisatos", "placeholder", "Selecione uma lei", "formControlValidationMsg", "", 3, "service", "formControlName", "searchModal", "isDisabled", "findToOptions", "onSearchModal"], [3, "isOpen", "openClose", 4, "ngIf"], [3, "isOpen", "openClose"], ["hasTable", "true", 3, "title"], ["crudResource", "/leis-atos", 3, "fieldsToFilter", "fieldsToDisplay", "entityService", "enableCreate", "searchSelect", "enableRemove", "changeLocationOnFilter", "orderBy", "filterDefault", "eventSelected"], ["eloColumns", ""], ["field", "id", "header", "C\u00F3digo", 3, "dataTable"], ["field", "numero", "header", "Leis/Atos", 3, "dataTable"], ["dataTableCell", ""], ["field", "escopo.descricao", "header", "Escopo", 3, "dataTable"], ["field", "tipoLeiDocumento.descricao", "header", "Tipo Documento", 3, "dataTable"], ["field", "idTCE", "header", "C\u00F3digo TCE", 3, "dataTable"]], template: function LeisAtosAutoCompleteModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LeisAtosAutoCompleteModalComponent_ng_container_0_Template, 4, 10, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLeisAtos);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, FormLabelColumnComponent, AutoCompleteComponent, FormControlValidationMsgDirective, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, EloModalComponent, PanelComponent, CrudSearchComponent, EloColumnComponent]; }, encapsulation: 2 });
LeisAtosAutoCompleteModalComponent.ctorParameters = () => [
    { type: ControlContainer }
];
LeisAtosAutoCompleteModalComponent.propDecorators = {
    label: [{ type: Input }],
    service: [{ type: Input }],
    controlName: [{ type: Input }],
    column: [{ type: Input }],
    isDisabled: [{ type: Input }],
    findToOptions: [{ type: Input }],
    objToOptions: [{ type: Input }],
    showLeisAtos: [{ type: Input }],
    filterDefault: [{ type: Input }],
    hintMessage: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LeisAtosAutoCompleteModalComponent, [{
        type: Component,
        args: [{
                selector: 'leis-atos-autocomplete-modal',
                template: "<ng-container id=\"leisatos\" [formGroup]=\"form\" *ngIf=\"showLeisAtos\">\n  <elo-form-label-column [label]=\"label\" [column]=\"column\" [hintMessage]=\"hintMessage\">\n    <elo-autocomplete id=\"leisatos\" placeholder=\"Selecione uma lei\" [service]=\"service\" [formControlName]=\"controlName\"\n      formControlValidationMsg [searchModal]=\"true\" (onSearchModal)=\"openModal()\" [isDisabled]=\"isDisabled\"\n      [findToOptions]=\"findToOptions\">\n    </elo-autocomplete>\n  </elo-form-label-column>\n\n  <elo-modal [isOpen]=\"isActiveModal\" (openClose)=\"openModal()\" *ngIf=\"isActiveModal\">\n    <elo-panel hasTable=true [title]=\"'Pesquisa de Leis/Atos'\">\n      <crud-search crudResource='/leis-atos' [fieldsToFilter]=\"fieldsToFilter\" [fieldsToDisplay]=\"fieldsToDisplay\"\n        [entityService]=\"service\" (eventSelected)=\"selecionarLeisAtos($event)\" [enableCreate]=\"false\"\n        [searchSelect]=\"true\" [enableRemove]=\"true\" [changeLocationOnFilter]=\"false\" [orderBy]=\"'id,asc'\"\n        [filterDefault]=\"filterDefault\">\n        <ng-template #eloColumns let-dataTable=\"dataTable\">\n          <elo-column field=\"id\" header=\"C\u00F3digo\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"numero\" header=\"Leis/Atos\" [dataTable]=\"dataTable\">\n            <ng-template #dataTableCell let-object=\"object\">\n              {{ object.numero }}/{{ object.exercicio }}\n            </ng-template>\n          </elo-column>\n          <elo-column field=\"escopo.descricao\" header=\"Escopo\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"tipoLeiDocumento.descricao\" header=\"Tipo Documento\" [dataTable]=\"dataTable\"></elo-column>\n          <elo-column field=\"idTCE\" header=\"C\u00F3digo TCE\" [dataTable]=\"dataTable\"></elo-column>\n        </ng-template>\n      </crud-search>\n    </elo-panel>\n  </elo-modal>\n</ng-container>"
            }]
    }], function () { return [{ type: ɵngcc3.ControlContainer }]; }, { isDisabled: [{
            type: Input
        }], findToOptions: [{
            type: Input
        }], objToOptions: [{
            type: Input
        }], showLeisAtos: [{
            type: Input
        }], label: [{
            type: Input
        }], service: [{
            type: Input
        }], controlName: [{
            type: Input
        }], column: [{
            type: Input
        }], filterDefault: [{
            type: Input
        }], hintMessage: [{
            type: Input
        }] }); })();

class EloModalComponent {
    constructor() {
        this.isOpen = false;
        this.openClose = new EventEmitter();
        this.isCentralized = false;
        this.switchOpenClose = () => {
            this.isOpen = !this.isOpen;
            this.openClose.emit(this.isOpen);
        };
    }
    handleKeyboardEvent(event) {
        if (event.code === 'Escape' && this.isOpen) {
            this.switchOpenClose();
        }
    }
    onMousedown(event) {
        const element = event.target;
        if (element.classList.contains('modal') && element.classList.contains('open')) {
            this.switchOpenClose();
        }
    }
}
EloModalComponent.ɵfac = function EloModalComponent_Factory(t) { return new (t || EloModalComponent)(); };
EloModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloModalComponent, selectors: [["elo-modal"]], hostBindings: function EloModalComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function EloModalComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, false, ɵngcc0.ɵɵresolveDocument)("mousedown", function EloModalComponent_mousedown_HostBindingHandler($event) { return ctx.onMousedown($event); });
    } }, inputs: { isOpen: "isOpen", isCentralized: "isCentralized", customWidth: "customWidth" }, outputs: { openClose: "openClose" }, ngContentSelectors: _c0, decls: 4, vars: 7, consts: [[1, "modal", "modalIndex"], [1, "container", 3, "ngStyle"], ["title", "Fechar", 1, "close", "close-modal", 3, "click"]], template: function EloModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵlistener("click", function EloModalComponent_Template_span_click_2_listener() { return ctx.switchOpenClose(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("open", ctx.isOpen)("centralized", ctx.isCentralized);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c45, ctx.customWidth));
    } }, directives: [ɵngcc2.NgStyle], styles: [".modalIndex[_ngcontent-%COMP%]{z-index:9999!important}"] });
EloModalComponent.propDecorators = {
    isOpen: [{ type: Input }],
    customWidth: [{ type: Input }],
    openClose: [{ type: Output }],
    isCentralized: [{ type: Input }],
    handleKeyboardEvent: [{ type: HostListener, args: ['document:keydown', ['$event'],] }],
    onMousedown: [{ type: HostListener, args: ['mousedown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloModalComponent, [{
        type: Component,
        args: [{
                selector: 'elo-modal',
                template: "<div class=\"modal modalIndex\" [class.open]=\"isOpen\" [class.centralized]=\"isCentralized\">\n\n  <div class=\"container\" [ngStyle]=\"{'width': customWidth}\">\n    <span class=\"close close-modal\" (click)=\"switchOpenClose()\" title=\"Fechar\"></span>\n    <ng-content></ng-content>\n  </div>\n\n</div>\n",
                styles: [".modalIndex{z-index:9999!important}"]
            }]
    }], function () { return []; }, { isOpen: [{
            type: Input
        }], openClose: [{
            type: Output
        }], isCentralized: [{
            type: Input
        }], handleKeyboardEvent: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], onMousedown: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }], customWidth: [{
            type: Input
        }] }); })();

class EloModalModule {
}
EloModalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloModalModule });
EloModalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloModalModule_Factory(t) { return new (t || EloModalModule)(); }, providers: [], imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloModalModule, { declarations: function () { return [EloModalComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [EloModalComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloModalModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [EloModalComponent],
                exports: [EloModalComponent],
                providers: []
            }]
    }], null, null); })();

class LeisAtosAutoCompleteModalModule {
}
LeisAtosAutoCompleteModalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LeisAtosAutoCompleteModalModule });
LeisAtosAutoCompleteModalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LeisAtosAutoCompleteModalModule_Factory(t) { return new (t || LeisAtosAutoCompleteModalModule)(); }, imports: [[
            PanelModule,
            CrudSearchModule,
            FormsModule,
            CommonModule$1,
            AutoCompleteModule,
            EloDatatableModule,
            FormLabelColumnModule,
            CrudFormModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            EloModalModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LeisAtosAutoCompleteModalModule, { declarations: function () { return [LeisAtosAutoCompleteModalComponent]; }, imports: function () { return [PanelModule, CrudSearchModule, FormsModule,
        CommonModule$1, AutoCompleteModule, EloDatatableModule, FormLabelColumnModule, CrudFormModule, ReactiveFormsModule, FormControlValidationMsgModule, EloModalModule]; }, exports: function () { return [LeisAtosAutoCompleteModalComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LeisAtosAutoCompleteModalModule, [{
        type: NgModule,
        args: [{
                imports: [
                    PanelModule,
                    CrudSearchModule,
                    FormsModule,
                    CommonModule$1,
                    AutoCompleteModule,
                    EloDatatableModule,
                    FormLabelColumnModule,
                    CrudFormModule,
                    ReactiveFormsModule,
                    FormControlValidationMsgModule,
                    EloModalModule
                ],
                declarations: [LeisAtosAutoCompleteModalComponent],
                exports: [LeisAtosAutoCompleteModalComponent]
            }]
    }], null, null); })();

class FancySlideComponent {
    constructor() {
        this.isModalActive = false;
        this.toggleModal = new EventEmitter();
        this.prevClick = new EventEmitter();
        this.nextClick = new EventEmitter();
    }
    toggleModalHandle() {
        this.toggleModal.emit();
    }
    prevClickHandle() {
        this.prevClick.emit();
    }
    nextClickHandle() {
        this.nextClick.emit();
    }
    handleKeyboardEvent(event) {
        if (event.code === 'Escape' && this.isModalActive) {
            this.toggleModalHandle();
        }
        if (event.code === 'ArrowLeft' && this.isModalActive) {
            this.prevClickHandle();
        }
        if (event.code === 'ArrowRight' && this.isModalActive) {
            this.nextClickHandle();
        }
    }
    onMousedown(event) {
        const element = event.target;
        if (element.classList.contains('fancy-slide') && element.classList.contains('active')) {
            this.toggleModalHandle();
        }
    }
}
FancySlideComponent.ɵfac = function FancySlideComponent_Factory(t) { return new (t || FancySlideComponent)(); };
FancySlideComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FancySlideComponent, selectors: [["fancy-slide"]], hostBindings: function FancySlideComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function FancySlideComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, false, ɵngcc0.ɵɵresolveDocument)("mousedown", function FancySlideComponent_mousedown_HostBindingHandler($event) { return ctx.onMousedown($event); });
    } }, inputs: { isModalActive: "isModalActive" }, outputs: { toggleModal: "toggleModal", prevClick: "prevClick", nextClick: "nextClick" }, ngContentSelectors: _c0, decls: 12, vars: 2, consts: [[1, "fancy-slide"], [1, "fancy-container"], [1, "panel"], [1, "panel-title"], [1, "fancy-close"], [1, "fa", "fa-times", 3, "click"], [1, "panel-body"], [1, "fancy-nav"], [1, "nav-button", "prev", "fa", "fa-chevron-left", 3, "click"], [1, "nav-button", "next", "fa", "fa-chevron-right", 3, "click"]], template: function FancySlideComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4, " Title ");
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "em", 5);
        ɵngcc0.ɵɵlistener("click", function FancySlideComponent_Template_em_click_6_listener() { return ctx.toggleModalHandle(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "div", 8);
        ɵngcc0.ɵɵlistener("click", function FancySlideComponent_Template_div_click_10_listener() { return ctx.prevClickHandle(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵlistener("click", function FancySlideComponent_Template_div_click_11_listener() { return ctx.nextClickHandle(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.isModalActive);
    } }, encapsulation: 2 });
FancySlideComponent.propDecorators = {
    isModalActive: [{ type: Input }],
    toggleModal: [{ type: Output }],
    prevClick: [{ type: Output }],
    nextClick: [{ type: Output }],
    handleKeyboardEvent: [{ type: HostListener, args: ['document:keydown', ['$event'],] }],
    onMousedown: [{ type: HostListener, args: ['mousedown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FancySlideComponent, [{
        type: Component,
        args: [{
                selector: 'fancy-slide',
                template: "<div class=\"fancy-slide\" [class.active]=\"isModalActive\">\n    <div class=\"fancy-container\">\n        <div class=\"panel\">\n            <div class=\"panel-title\">\n                Title\n                <div class=\"fancy-close\">\n                    <em class=\"fa fa-times\" (click)=\"toggleModalHandle()\"></em>\n                </div>\n            </div>\n            <div class=\"panel-body\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n        <div class=\"fancy-nav\">\n            <div class=\"nav-button prev fa fa-chevron-left\" (click)=\"prevClickHandle()\"></div>\n            <div class=\"nav-button next fa fa-chevron-right\" (click)=\"nextClickHandle()\"></div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return []; }, { isModalActive: [{
            type: Input
        }], toggleModal: [{
            type: Output
        }], prevClick: [{
            type: Output
        }], nextClick: [{
            type: Output
        }], handleKeyboardEvent: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], onMousedown: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }] }); })();

class FancySlideItemComponent {
}
FancySlideItemComponent.ɵfac = function FancySlideItemComponent_Factory(t) { return new (t || FancySlideItemComponent)(); };
FancySlideItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FancySlideItemComponent, selectors: [["fancy-slide-item"]], inputs: { isItemModalActive: "isItemModalActive", modalItemOption: "modalItemOption" }, ngContentSelectors: _c0, decls: 2, vars: 5, template: function FancySlideItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("fancy-slide-item ", ctx.modalItemOption, "");
        ɵngcc0.ɵɵclassProp("active", ctx.isItemModalActive);
    } }, encapsulation: 2 });
FancySlideItemComponent.propDecorators = {
    isItemModalActive: [{ type: Input }],
    modalItemOption: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FancySlideItemComponent, [{
        type: Component,
        args: [{
                selector: 'fancy-slide-item',
                template: "<div class=\"fancy-slide-item {{modalItemOption}}\" [class.active]=\"isItemModalActive\">\n    <ng-content></ng-content>\n</div>\n"
            }]
    }], null, { isItemModalActive: [{
            type: Input
        }], modalItemOption: [{
            type: Input
        }] }); })();

class FancySlideModule {
}
FancySlideModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FancySlideModule });
FancySlideModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FancySlideModule_Factory(t) { return new (t || FancySlideModule)(); }, imports: [[CommonModule$1], CommonModule$1] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FancySlideModule, { declarations: function () { return [FancySlideComponent, FancySlideItemComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [FancySlideComponent, FancySlideItemComponent, CommonModule$1]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FancySlideModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [FancySlideComponent, FancySlideItemComponent, CommonModule$1],
                declarations: [FancySlideComponent, FancySlideItemComponent]
            }]
    }], null, null); })();

class ConfiguracaoEntidadeKeycloakService {
    constructor() {
        this._update = new EventEmitter();
    }
    update() {
        this._update.emit();
    }
    updateListener(action) {
        this._update.subscribe(action);
    }
}
ConfiguracaoEntidadeKeycloakService.ɵfac = function ConfiguracaoEntidadeKeycloakService_Factory(t) { return new (t || ConfiguracaoEntidadeKeycloakService)(); };
ConfiguracaoEntidadeKeycloakService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ConfiguracaoEntidadeKeycloakService, factory: ConfiguracaoEntidadeKeycloakService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfiguracaoEntidadeKeycloakService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class FeatureModuleStateService {
    constructor() {
        this.moduleVisibleSource = new Subject();
        this.moduleVisibleObserver = this.moduleVisibleSource.asObservable();
        this.userVisibleSource = new Subject();
        this.userVisibleObserver = this.userVisibleSource.asObservable();
        this.notificationVisibleSource = new Subject();
        this.notificationVisibleObserver = this.notificationVisibleSource.asObservable();
        this.acessibilidadeVisibleSource = new Subject();
        this.acessibilidadeVisibleObserver = this.acessibilidadeVisibleSource.asObservable();
        this.acessibilidadeContrasteVisebleSource = new Subject();
        this.acessibilidadeContrasteVisebleObserver = this.acessibilidadeContrasteVisebleSource.asObservable();
        this.configuracaoEntidadeVisibleSource = new ReplaySubject();
        this.configuracaoEntidadeVisibleObserver = this.configuracaoEntidadeVisibleSource.asObservable();
        this.contribuinteVisibleSource = new Subject();
        this.contribuinteVisibleObserver = this.contribuinteVisibleSource.asObservable();
        this.notificationReportVisibleSource = new Subject();
        this.notificationReportVisibleObserver = this.notificationReportVisibleSource.asObservable();
        this.sobreSistemaVisibleSource = new Subject();
        this.sobreSistemaVisibleObserver = this.sobreSistemaVisibleSource.asObservable();
        this.tourCaller = new EventEmitter();
        this.feature = {
            user: 'user',
            module: 'module',
            notification: 'notification',
            acessibilidade: 'acessibilidade',
            configuracaoEntidade: 'configuracaoEntidade',
            contribuinte: 'contribuinte',
            notificationReportJasper: 'notificationReportJasper',
            acessibilidadeConstraste: 'contraste',
            sobreSistema: 'sobreSistema',
        };
    }
    alternateStatus(feature) {
        switch (feature) {
            case this.feature.user:
                this.userVisibleSource.next();
                break;
            case this.feature.module:
                this.moduleVisibleSource.next();
                break;
            case this.feature.notification:
                this.notificationVisibleSource.next();
                break;
            case this.feature.notificationReportJasper:
                this.notificationReportVisibleSource.next();
                break;
            case this.feature.acessibilidade:
                this.acessibilidadeVisibleSource.next();
                break;
            case this.feature.acessibilidadeConstraste:
                this.acessibilidadeContrasteVisebleSource.next();
                break;
            case this.feature.configuracaoEntidade:
                this.configuracaoEntidadeVisibleSource.next();
                break;
            case this.feature.contribuinte:
                this.contribuinteVisibleSource.next();
                break;
            case this.feature.sobreSistema:
                this.sobreSistemaVisibleSource.next();
                break;
        }
    }
    hideMenu(feature) {
        switch (feature) {
            case this.feature.user:
                this.userVisibleSource.next(false);
                break;
            case this.feature.module:
                this.moduleVisibleSource.next(false);
                break;
            case this.feature.notification:
                this.notificationVisibleSource.next(false);
                break;
            case this.feature.notificationReportJasper:
                this.notificationReportVisibleSource.next(false);
                break;
            case this.feature.acessibilidade:
                this.acessibilidadeVisibleSource.next(false);
                break;
            case this.feature.acessibilidadeConstraste:
                this.acessibilidadeContrasteVisebleSource.next(false);
                break;
            case this.feature.configuracaoEntidade:
                this.configuracaoEntidadeVisibleSource.next(false);
                break;
            case this.feature.contribuinte:
                this.contribuinteVisibleSource.next(false);
                break;
            case this.feature.sobreSistema:
                this.sobreSistemaVisibleSource.next(false);
                break;
        }
    }
}
FeatureModuleStateService.ɵfac = function FeatureModuleStateService_Factory(t) { return new (t || FeatureModuleStateService)(); };
FeatureModuleStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FeatureModuleStateService, factory: FeatureModuleStateService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureModuleStateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ConfiguracaoEntidadeObservable {
    constructor() {
        this.entidades = of([]);
        this.exercicios = of([]);
        this.competencias = of([]);
    }
}

class ConfiguracaoEntidadeKeycloakComponent {
    constructor(_notification, _featureModuleStateService, _abstractAuthHttp, _configuracaoEntidadeKeycloakService) {
        this._notification = _notification;
        this._featureModuleStateService = _featureModuleStateService;
        this._abstractAuthHttp = _abstractAuthHttp;
        this._configuracaoEntidadeKeycloakService = _configuracaoEntidadeKeycloakService;
        this.onGetExercicios = new EventEmitter();
        this.onGetCompetencias = new EventEmitter();
        this.onSetHeaderTitle = new EventEmitter();
        this.configuracaoEntidade = new ConfiguracaoEntidadeObservable();
        this.activeDataOperacaoField = false;
        this.toggled = false;
        this._configuraExercicioAtual = () => {
            this.configuracaoEntidade.exercicios.subscribe((exercicios) => {
                const exercicioAtual = DateUtils.getYearByDate(DateUtils.getDateFromString(DateUtils.format(DateUtils.now(), TO_FORMAT, FROM_FORMAT)));
                this.exercicio = exercicios
                    .filter((exercicio) => exercicio.exercicio === exercicioAtual)
                    .reduce((atual, seguinte) => {
                    if (atual && atual.exercicio === seguinte.exercicio) {
                        return atual;
                    }
                    return seguinte;
                }, null);
                if (this.exercicio && this.exercicio.exercicio) {
                    this.onGetCompetencias.emit({
                        exercicio: this.exercicio,
                        entidade: this.entidade,
                    });
                }
            });
        };
    }
    ngOnInit() {
        this._configuracaoEntidadeKeycloakService.updateListener(() => {
            this.updateConfiguracaoEntidade();
        });
        this.updateConfiguracaoEntidade();
        this._handleCompetenciaStateObserver();
    }
    changeEntidade() {
        this.configuracaoEntidade.competencias = of([]);
        this.configuracaoEntidade.exercicios = of([]);
        this.onGetExercicios.emit(this.entidade);
        this.exercicio = null;
        this.competencia = null;
        this._configuraExercicioAtual();
    }
    voltarAjustes() {
        this._featureModuleStateService.alternateStatus('configuracaoEntidade');
        this._featureModuleStateService.alternateStatus('user');
    }
    changeExercicio() {
        this.configuracaoEntidade.competencias = of([]);
        this.onGetCompetencias.emit({
            exercicio: this.exercicio,
            entidade: this.entidade,
        });
        this.competencia = null;
    }
    comparing() {
        return FormUtils.equals('id');
    }
    comparingByExercicio() {
        return FormUtils.equals('exercicio');
    }
    comparingByMes() {
        return FormUtils.equals('mes');
    }
    resetToCurrentDateOperacaoField() {
        this.dataOperacao = this._getCurrentDate();
        this.confirm();
    }
    confirm() {
        const { entidade, exercicio, competencia, dataOperacao } = this;
        this.dataOperacaoIsCurrentDate =
            dataOperacao === null || dataOperacao === this._getCurrentDate();
        if (entidade && exercicio && competencia) {
            const usuarioInfo = {
                entidadePadrao: entidade,
                exercicioPadrao: exercicio.exercicio,
                mesPadrao: competencia.mes,
                situacaoPadrao: competencia.situacaoDescricao,
                dataOperacao: this.dataOperacaoIsCurrentDate ? null : dataOperacao,
            };
            this._abstractAuthHttp.setUsuarioInfo(usuarioInfo);
            this.close();
            this._notification.success('Definições de entidade', 'Definido com sucesso!');
            window.location.reload();
        }
        else {
            this._notification.error('Definições de entidade', 'Preencha todos os campos para definir!');
        }
    }
    close() {
        this._featureModuleStateService.hideMenu('configuracaoEntidade');
        this.updateBodyOverlay();
    }
    updateConfiguracaoEntidade() {
        if (this._abstractAuthHttp.getUsuarioInfo()) {
            const { entidadePadrao, exercicioPadrao, mesPadrao, situacaoPadrao, dataOperacao, } = this._abstractAuthHttp.getUsuarioInfo();
            if (dataOperacao) {
                this.dataOperacao = dataOperacao;
                this.dataOperacaoIsCurrentDate = false;
            }
            else if (this.activeDataOperacaoField) {
                this.dataOperacao = this._getCurrentDate();
                this.dataOperacaoIsCurrentDate = true;
            }
            if (entidadePadrao) {
                this.entidade = entidadePadrao;
            }
            if (entidadePadrao && exercicioPadrao && mesPadrao) {
                this.exercicio = { exercicio: exercicioPadrao };
                this.competencia = {
                    mes: mesPadrao,
                    situacaoDescricao: situacaoPadrao,
                };
                this.onGetExercicios.emit(this.entidade);
                this.onGetCompetencias.emit({
                    exercicio: this.exercicio,
                    entidade: this.entidade,
                });
            }
        }
    }
    updateBodyOverlay() {
        const body = document.getElementsByTagName('body')[0];
        body.removeAttribute('class');
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents &&
                parents.length > 0 &&
                parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map((parent) => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('features-configuracao-entidade')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.toggled)
                this._featureModuleStateService.hideMenu('configuracaoEntidade');
        }
    }
    _handleCompetenciaStateObserver() {
        this._featureModuleStateService.configuracaoEntidadeVisibleObserver.subscribe((value) => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
    _getCurrentDate() {
        return DateUtils.format(new Date(), TO_FORMAT, FROM_FORMAT);
    }
}
ConfiguracaoEntidadeKeycloakComponent.ɵfac = function ConfiguracaoEntidadeKeycloakComponent_Factory(t) { return new (t || ConfiguracaoEntidadeKeycloakComponent)(ɵngcc0.ɵɵdirectiveInject(EloNotificationService), ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService), ɵngcc0.ɵɵdirectiveInject(AbstractAuthHttp), ɵngcc0.ɵɵdirectiveInject(ConfiguracaoEntidadeKeycloakService)); };
ConfiguracaoEntidadeKeycloakComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfiguracaoEntidadeKeycloakComponent, selectors: [["configuracao-entidade-keycloak"]], viewQuery: function ConfiguracaoEntidadeKeycloakComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DatePickerComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePickerComponent = _t.first);
    } }, hostBindings: function ConfiguracaoEntidadeKeycloakComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ConfiguracaoEntidadeKeycloakComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { configuracaoEntidade: "configuracaoEntidade", activeDataOperacaoField: "activeDataOperacaoField" }, outputs: { onGetExercicios: "onGetExercicios", onGetCompetencias: "onGetCompetencias", onSetHeaderTitle: "onSetHeaderTitle" }, decls: 46, vars: 53, consts: [[1, "features-configuracao-entidade", "overflow-visible"], [1, "title"], [1, "read", "hint", "clean", "center-left", "neutral", 3, "click"], [1, "fa", "fa-chevron-left"], [1, "hint-content"], [1, "user-actions", "inputs"], ["class", "top-helper-message bg-yellow-20", 4, "ngIf"], ["class", "top-helper-message bg-blue-20", "href", "javascript:void(0)", 3, "click", 4, "ngIf"], [1, "form-group"], ["for", "entidade", 1, "label"], ["id", "entidades", "placeholder", "Selecione a Entidade", 3, "ngModel", "compareWith", "required", "change", "ngModelChange"], ["id", "entidade", 3, "ngValue", 4, "ngFor", "ngForOf"], ["for", "exercicio", 1, "label"], ["id", "exercicio", "placeholder", "Selecione o Exerc\u00EDcio", 3, "ngModel", "compareWith", "required", "disabled", "change", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["for", "competencia", 1, "label"], ["id", "competencias", "placeholder", "Selecione a Compet\u00EAncia", 3, "ngModel", "compareWith", "required", "disabled", "ngModelChange"], ["id", "competencia", 3, "ngValue", "disabled", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "form-group", "right"], ["id", "btnConfirm", "type", "button", 1, "btn", "inline", "module-color", "full-xs", "mr-none", 3, "click"], [1, "top-helper-message", "bg-yellow-20"], ["href", "javascript:void(0)", 1, "top-helper-message", "bg-blue-20", 3, "click"], ["id", "entidade", 3, "ngValue"], [3, "ngValue"], ["id", "competencia", 3, "ngValue", "disabled"], ["for", "dataOperacao", 1, "label"], ["id", "dataOperacao", "formControlValidationMsg", "", 3, "ngModel", "required", "ngModelChange"]], template: function ConfiguracaoEntidadeKeycloakComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "aside", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function ConfiguracaoEntidadeKeycloakComponent_Template_div_click_2_listener() { return ctx.voltarAjustes(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtext(5, "Voltar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(6, "Defini\u00E7\u00F5es de entidade ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵtemplate(8, ConfiguracaoEntidadeKeycloakComponent_p_8_Template, 2, 0, "p", 6);
        ɵngcc0.ɵɵtemplate(9, ConfiguracaoEntidadeKeycloakComponent_a_9_Template, 2, 0, "a", 7);
        ɵngcc0.ɵɵelementStart(10, "div", 8);
        ɵngcc0.ɵɵelementStart(11, "label", 9);
        ɵngcc0.ɵɵtext(12, "Entidade");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "select", 10);
        ɵngcc0.ɵɵlistener("change", function ConfiguracaoEntidadeKeycloakComponent_Template_select_change_13_listener() { return ctx.changeEntidade(); })("ngModelChange", function ConfiguracaoEntidadeKeycloakComponent_Template_select_ngModelChange_13_listener($event) { return ctx.entidade = $event; });
        ɵngcc0.ɵɵtemplate(14, ConfiguracaoEntidadeKeycloakComponent_option_14_Template, 2, 2, "option", 11);
        ɵngcc0.ɵɵpipe(15, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div");
        ɵngcc0.ɵɵpipe(17, "async");
        ɵngcc0.ɵɵpipe(18, "async");
        ɵngcc0.ɵɵelementStart(19, "div", 8);
        ɵngcc0.ɵɵelementStart(20, "label", 12);
        ɵngcc0.ɵɵtext(21, "Exerc\u00EDcios");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "select", 13);
        ɵngcc0.ɵɵlistener("change", function ConfiguracaoEntidadeKeycloakComponent_Template_select_change_22_listener() { return ctx.changeExercicio(); })("ngModelChange", function ConfiguracaoEntidadeKeycloakComponent_Template_select_ngModelChange_22_listener($event) { return ctx.exercicio = $event; });
        ɵngcc0.ɵɵpipe(23, "async");
        ɵngcc0.ɵɵpipe(24, "async");
        ɵngcc0.ɵɵtemplate(25, ConfiguracaoEntidadeKeycloakComponent_option_25_Template, 2, 2, "option", 14);
        ɵngcc0.ɵɵpipe(26, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "div");
        ɵngcc0.ɵɵpipe(28, "async");
        ɵngcc0.ɵɵpipe(29, "async");
        ɵngcc0.ɵɵpipe(30, "async");
        ɵngcc0.ɵɵpipe(31, "async");
        ɵngcc0.ɵɵelementStart(32, "div", 8);
        ɵngcc0.ɵɵelementStart(33, "label", 15);
        ɵngcc0.ɵɵtext(34, "Compet\u00EAncias");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "select", 16);
        ɵngcc0.ɵɵlistener("ngModelChange", function ConfiguracaoEntidadeKeycloakComponent_Template_select_ngModelChange_35_listener($event) { return ctx.competencia = $event; });
        ɵngcc0.ɵɵpipe(36, "async");
        ɵngcc0.ɵɵpipe(37, "async");
        ɵngcc0.ɵɵpipe(38, "async");
        ɵngcc0.ɵɵpipe(39, "async");
        ɵngcc0.ɵɵtemplate(40, ConfiguracaoEntidadeKeycloakComponent_option_40_Template, 3, 6, "option", 17);
        ɵngcc0.ɵɵpipe(41, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(42, ConfiguracaoEntidadeKeycloakComponent_ng_container_42_Template, 5, 2, "ng-container", 18);
        ɵngcc0.ɵɵelementStart(43, "div", 19);
        ɵngcc0.ɵɵelementStart(44, "button", 20);
        ɵngcc0.ɵɵlistener("click", function ConfiguracaoEntidadeKeycloakComponent_Template_button_click_44_listener() { return ctx.confirm(); });
        ɵngcc0.ɵɵtext(45, " Definir ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var tmp_7_0 = null;
        var tmp_11_0 = null;
        var tmp_13_0 = null;
        var tmp_17_0 = null;
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngIf", ctx.activeDataOperacaoField && !ctx.dataOperacaoIsCurrentDate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.activeDataOperacaoField && !ctx.dataOperacaoIsCurrentDate);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.entidade)("compareWith", ctx.comparing())("required", !ctx.entidade);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(15, 23, ctx.configuracaoEntidade.entidades));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("placeholder-loader", !((tmp_7_0 = ɵngcc0.ɵɵpipeBind1(17, 25, ctx.configuracaoEntidade.exercicios)) == null ? null : tmp_7_0.length) && !(((tmp_7_0 = ɵngcc0.ɵɵpipeBind1(18, 27, ctx.configuracaoEntidade.exercicios)) == null ? null : tmp_7_0.length) === 0));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.exercicio)("compareWith", ctx.comparingByExercicio())("required", !ctx.exercicio)("disabled", !((tmp_11_0 = ɵngcc0.ɵɵpipeBind1(23, 29, ctx.configuracaoEntidade.exercicios)) == null ? null : tmp_11_0.length) && !(((tmp_11_0 = ɵngcc0.ɵɵpipeBind1(24, 31, ctx.configuracaoEntidade.exercicios)) == null ? null : tmp_11_0.length) === 0));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(26, 33, ctx.configuracaoEntidade.exercicios));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("placeholder-loader", !((tmp_13_0 = ɵngcc0.ɵɵpipeBind1(28, 35, ctx.configuracaoEntidade.exercicios)) == null ? null : tmp_13_0.length) && !(((tmp_13_0 = ɵngcc0.ɵɵpipeBind1(29, 37, ctx.configuracaoEntidade.exercicios)) == null ? null : tmp_13_0.length) === 0) || !((tmp_13_0 = ɵngcc0.ɵɵpipeBind1(30, 39, ctx.configuracaoEntidade.competencias)) == null ? null : tmp_13_0.length) && !(((tmp_13_0 = ɵngcc0.ɵɵpipeBind1(31, 41, ctx.configuracaoEntidade.competencias)) == null ? null : tmp_13_0.length) === 0));
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.competencia)("compareWith", ctx.comparingByMes())("required", !ctx.competencia)("disabled", !((tmp_17_0 = ɵngcc0.ɵɵpipeBind1(36, 43, ctx.configuracaoEntidade.exercicios)) == null ? null : tmp_17_0.length) && !(((tmp_17_0 = ɵngcc0.ɵɵpipeBind1(37, 45, ctx.configuracaoEntidade.exercicios)) == null ? null : tmp_17_0.length) === 0) || !((tmp_17_0 = ɵngcc0.ɵɵpipeBind1(38, 47, ctx.configuracaoEntidade.competencias)) == null ? null : tmp_17_0.length) && !(((tmp_17_0 = ɵngcc0.ɵɵpipeBind1(39, 49, ctx.configuracaoEntidade.competencias)) == null ? null : tmp_17_0.length) === 0));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(41, 51, ctx.configuracaoEntidade.competencias));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.activeDataOperacaoField);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.RequiredValidator, ɵngcc2.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DatePickerComponent]; }, pipes: function () { return [ɵngcc2.AsyncPipe, MonthNamePipe]; }, encapsulation: 2 });
ConfiguracaoEntidadeKeycloakComponent.ctorParameters = () => [
    { type: EloNotificationService },
    { type: FeatureModuleStateService },
    { type: AbstractAuthHttp },
    { type: ConfiguracaoEntidadeKeycloakService }
];
ConfiguracaoEntidadeKeycloakComponent.propDecorators = {
    onGetExercicios: [{ type: Output }],
    onGetCompetencias: [{ type: Output }],
    onSetHeaderTitle: [{ type: Output }],
    configuracaoEntidade: [{ type: Input }],
    activeDataOperacaoField: [{ type: Input }],
    datePickerComponent: [{ type: ViewChild, args: [DatePickerComponent,] }],
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfiguracaoEntidadeKeycloakComponent, [{
        type: Component,
        args: [{
                selector: 'configuracao-entidade-keycloak',
                template: "<aside class=\"features-configuracao-entidade overflow-visible\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <div class=\"read hint clean center-left neutral\" (click)=\"voltarAjustes()\"><i\n        class=\"fa fa-chevron-left\"></i>\n      <div class=\"hint-content\">Voltar</div>\n    </div>Defini\u00E7\u00F5es de entidade\n  </h2>\n  <div class=\"user-actions inputs\">\n    <p *ngIf=\"activeDataOperacaoField && !dataOperacaoIsCurrentDate\" class=\"top-helper-message bg-yellow-20\">\n      Data opera\u00E7\u00E3o diferente do dia atual.\n    </p>\n    <a class=\"top-helper-message bg-blue-20\" *ngIf=\"activeDataOperacaoField && !dataOperacaoIsCurrentDate\"\n      href=\"javascript:void(0)\" (click)=\"resetToCurrentDateOperacaoField()\">\n      Clique para voltar a data atual.\n    </a>\n    <div class=\"form-group\">\n      <label for=\"entidade\" class=\"label\">Entidade</label>\n      <select id=\"entidades\" placeholder=\"Selecione a Entidade\" (change)=\"changeEntidade()\" [(ngModel)]=\"entidade\"\n        [compareWith]=\"comparing()\" [required]=\"!entidade\">\n        <option id=\"entidade\" [ngValue]=\"entidade\" *ngFor=\"let entidade of configuracaoEntidade.entidades | async\">\n          {{entidade.nome}}</option>\n      </select>\n    </div>\n\n    <div [class.placeholder-loader]=\"!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)\">\n      <div class=\"form-group\">\n        <label for=\"exercicio\" class=\"label\">Exerc\u00EDcios</label>\n        <select id=\"exercicio\" placeholder=\"Selecione o Exerc\u00EDcio\" (change)=\"changeExercicio()\" [(ngModel)]=\"exercicio\"\n          [compareWith]=\"comparingByExercicio()\" [required]=\"!exercicio\" \n          [disabled]=\"!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)\">\n          <option [ngValue]=\"exercicio\" *ngFor=\"let exercicio of configuracaoEntidade.exercicios | async\">\n            {{exercicio.exercicio}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div [class.placeholder-loader]=\"(!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)) \n                                    || (!(configuracaoEntidade.competencias | async)?.length && !((configuracaoEntidade.competencias | async)?.length === 0))\">\n      <div class=\"form-group\">\n        <label for=\"competencia\" class=\"label\">Compet\u00EAncias</label>\n        <select id=\"competencias\" placeholder=\"Selecione a Compet\u00EAncia\" [(ngModel)]=\"competencia\"\n          [compareWith]=\"comparingByMes()\" [required]=\"!competencia\"\n          [disabled]=\"(!(configuracaoEntidade.exercicios | async)?.length && !((configuracaoEntidade.exercicios | async)?.length === 0)) \n          || (!(configuracaoEntidade.competencias | async)?.length && !((configuracaoEntidade.competencias | async)?.length === 0))\">\n          <option id=\"competencia\" [ngValue]=\"competencia\"\n              *ngFor=\"let competencia of configuracaoEntidade.competencias | async\"\n            [disabled]=\"competencia.situacaoDescricao === 'Bloqueado'\">{{competencia.mes | monthname}} -\n            {{competencia.situacaoDescricao}}</option>\n        </select>\n      </div>\n    </div>\n\n    <ng-container *ngIf=\"activeDataOperacaoField\">\n      <div class=\"form-group\">\n        <label for=\"dataOperacao\" class=\"label\"> Data Opera\u00E7\u00E3o</label>\n        <elo-datepicker id=\"dataOperacao\" [(ngModel)]=\"dataOperacao\" formControlValidationMsg\n          [required]=\"!dataOperacao\"></elo-datepicker>\n      </div>\n    </ng-container>\n\n    <div class=\"form-group right\">\n      <button id=\"btnConfirm\" type=\"button\" (click)=\"confirm()\" class=\"btn inline module-color full-xs mr-none\">\n        Definir\n      </button>\n    </div>\n  </div>\n</aside>"
            }]
    }], function () { return [{ type: EloNotificationService }, { type: FeatureModuleStateService }, { type: AbstractAuthHttp }, { type: ConfiguracaoEntidadeKeycloakService }]; }, { onGetExercicios: [{
            type: Output
        }], onGetCompetencias: [{
            type: Output
        }], onSetHeaderTitle: [{
            type: Output
        }], configuracaoEntidade: [{
            type: Input
        }], activeDataOperacaoField: [{
            type: Input
        }], clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], datePickerComponent: [{
            type: ViewChild,
            args: [DatePickerComponent]
        }] }); })();

class FeatureAcessibilidadeContrasteComponent {
    constructor(featureModuleStateService) {
        this.featureModuleStateService = featureModuleStateService;
        this.toggled = false;
        this.tipoContraste = {
            normal: 'normal',
            invert: 'invert',
            protanopia: 'protanopia',
            deuteranopia: 'deuteranopia',
            tritanopia: 'tritanopia',
        };
    }
    ngOnInit() {
        this.handleStateObserver();
        this.changeContrasteAtivo(this.tipoContraste.normal);
    }
    voltarParaAcessibilidade() {
        this.featureModuleStateService.alternateStatus('contraste');
        this.featureModuleStateService.alternateStatus('acessibilidade');
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents &&
                parents.length > 0 &&
                parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map((parent) => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('accessibility')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.toggled)
                this.featureModuleStateService.hideMenu('contraste');
        }
    }
    changeContrasteAtivo(tipo) {
        this.contrasteAtivo = tipo;
        document.body.parentElement.classList.remove(this.tipoContraste.invert);
        document.body.parentElement.classList.remove(this.tipoContraste.protanopia);
        document.body.parentElement.classList.remove(this.tipoContraste.deuteranopia);
        document.body.parentElement.classList.remove(this.tipoContraste.tritanopia);
        switch (tipo) {
            case this.tipoContraste.invert:
                document.body.parentElement.classList.add(this.tipoContraste.invert);
                break;
            case this.tipoContraste.protanopia:
                document.body.parentElement.classList.add(this.tipoContraste.protanopia);
                break;
            case this.tipoContraste.deuteranopia:
                document.body.parentElement.classList.add(this.tipoContraste.deuteranopia);
                break;
            case this.tipoContraste.tritanopia:
                document.body.parentElement.classList.add(this.tipoContraste.tritanopia);
                break;
        }
    }
    handleStateObserver() {
        this.featureModuleStateService.acessibilidadeContrasteVisebleObserver.subscribe((value) => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
}
FeatureAcessibilidadeContrasteComponent.ɵfac = function FeatureAcessibilidadeContrasteComponent_Factory(t) { return new (t || FeatureAcessibilidadeContrasteComponent)(ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService)); };
FeatureAcessibilidadeContrasteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeatureAcessibilidadeContrasteComponent, selectors: [["feature-acessibilidade-contraste"]], hostBindings: function FeatureAcessibilidadeContrasteComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeContrasteComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, decls: 34, vars: 12, consts: [[1, "features-user", "auto-height", "accessibility"], [1, "title"], [1, "read", "hint", "clean", "center-left", "neutral", 3, "click"], [1, "fa", "fa-chevron-left"], [1, "hint-content"], [1, "features-group-container"], [1, "row"], [1, "col-md-12"], [1, "switch-container", "form-group", 3, "click"], [1, "switch", "module-color"], [1, "switch-caption"], [1, "col-md-12", "form-group"], ["type", "button", 1, "btn", "text", "neutral", "right", 3, "click"]], template: function FeatureAcessibilidadeContrasteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeContrasteComponent_Template_div_click_2_listener() { return ctx.voltarParaAcessibilidade(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtext(5, "Voltar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(6, "Contraste ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "div", 8);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeContrasteComponent_Template_div_click_10_listener() { return ctx.changeContrasteAtivo(ctx.tipoContraste.normal); });
        ɵngcc0.ɵɵelement(11, "em", 9);
        ɵngcc0.ɵɵelementStart(12, "span", 10);
        ɵngcc0.ɵɵtext(13, "Normal");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 8);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeContrasteComponent_Template_div_click_14_listener() { return ctx.changeContrasteAtivo(ctx.tipoContraste.invert); });
        ɵngcc0.ɵɵelement(15, "em", 9);
        ɵngcc0.ɵɵelementStart(16, "span", 10);
        ɵngcc0.ɵɵtext(17, "Escuro");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 8);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeContrasteComponent_Template_div_click_18_listener() { return ctx.changeContrasteAtivo(ctx.tipoContraste.protanopia); });
        ɵngcc0.ɵɵelement(19, "em", 9);
        ɵngcc0.ɵɵelementStart(20, "span", 10);
        ɵngcc0.ɵɵtext(21, "Protanopia");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 8);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeContrasteComponent_Template_div_click_22_listener() { return ctx.changeContrasteAtivo(ctx.tipoContraste.deuteranopia); });
        ɵngcc0.ɵɵelement(23, "em", 9);
        ɵngcc0.ɵɵelementStart(24, "span", 10);
        ɵngcc0.ɵɵtext(25, "Deuteranopia");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 8);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeContrasteComponent_Template_div_click_26_listener() { return ctx.changeContrasteAtivo(ctx.tipoContraste.tritanopia); });
        ɵngcc0.ɵɵelement(27, "em", 9);
        ɵngcc0.ɵɵelementStart(28, "span", 10);
        ɵngcc0.ɵɵtext(29, "Tritanopia");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 6);
        ɵngcc0.ɵɵelementStart(31, "div", 11);
        ɵngcc0.ɵɵelementStart(32, "button", 12);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeContrasteComponent_Template_button_click_32_listener() { return ctx.changeContrasteAtivo("normal"); });
        ɵngcc0.ɵɵtext(33, "restaurar defini\u00E7\u00F5es");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵclassProp("active", ctx.contrasteAtivo === ctx.tipoContraste.normal);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("active", ctx.contrasteAtivo === ctx.tipoContraste.invert);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("active", ctx.contrasteAtivo === ctx.tipoContraste.protanopia);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("active", ctx.contrasteAtivo === ctx.tipoContraste.deuteranopia);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("active", ctx.contrasteAtivo === ctx.tipoContraste.tritanopia);
    } }, encapsulation: 2 });
FeatureAcessibilidadeContrasteComponent.ctorParameters = () => [
    { type: FeatureModuleStateService }
];
FeatureAcessibilidadeContrasteComponent.propDecorators = {
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureAcessibilidadeContrasteComponent, [{
        type: Component,
        args: [{
                selector: 'feature-acessibilidade-contraste',
                template: "<div class=\"features-user auto-height accessibility\" [class.active]=\"toggled\">\n    <h2 class=\"title\">\n        <div class=\"read hint clean center-left neutral\" (click)=\"voltarParaAcessibilidade()\"><i class=\"fa fa-chevron-left\"></i>\n            <div class=\"hint-content\" >Voltar</div>\n        </div>Contraste\n    </h2>\n    <div class=\"features-group-container\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.normal)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.normal\"></em><span class=\"switch-caption\">Normal</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.invert)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.invert\"></em><span class=\"switch-caption\">Escuro</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.protanopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.protanopia\"></em><span class=\"switch-caption\">Protanopia</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.deuteranopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.deuteranopia\"></em><span class=\"switch-caption\">Deuteranopia</span>\n                </div>\n                <div class=\"switch-container form-group\"  (click)=\"changeContrasteAtivo(tipoContraste.tritanopia)\">\n                    <em class=\"switch module-color\" [class.active]=\"contrasteAtivo === tipoContraste.tritanopia\"></em><span class=\"switch-caption\">Tritanopia</span>\n                </div> \n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 form-group\">\n                <button class=\"btn text neutral right\" type=\"button\" (click)=\"changeContrasteAtivo('normal')\">restaurar defini\u00E7\u00F5es</button></div>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: FeatureModuleStateService }]; }, { clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

class FeatureAcessibilidadeComponent {
    constructor(featureModuleStateService) {
        this.featureModuleStateService = featureModuleStateService;
        this.toggled = false;
        this.zoomLevel = 0;
        this.defaultProps = {
            className: '',
            reduced: false,
            autoHeight: false,
            hasReadOptions: false,
            scaleIncrement: 0.03,
            zoomIncrement: 5,
            minZoomLevel: -3,
            maxZoomLevel: 3,
        };
    }
    ngOnInit() {
        this.handleStateObserver();
    }
    decrementZoom() {
        this.onChangeZoom(-1);
    }
    incrementZoom() {
        this.onChangeZoom(1);
    }
    clearZoom() {
        this.zoomLevel = 0;
        this.setZoom(0);
    }
    acessibilidadeContraste() {
        this.featureModuleStateService.alternateStatus('contraste');
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents &&
                parents.length > 0 &&
                parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map((parent) => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('btn-group')) {
                        isFeatureOpen = true;
                    }
                    if (parent.classList.value.includes('features-acessibilidade')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.toggled)
                this.featureModuleStateService.hideMenu('acessibilidade');
        }
    }
    setZoom(zoomLevel) {
        const newScale = 1 + zoomLevel * this.defaultProps.scaleIncrement;
        const newZoom = 100 + zoomLevel * this.defaultProps.zoomIncrement;
        document.body.style['-moz-transform'] = `scale(${newScale})`;
        document.body.style['-moz-transform-origin'] = 'top center';
        // tslint:disable-next-line:deprecation
        document.body.style.zoom = `${newZoom}%`;
    }
    onChangeZoom(increment) {
        const newZoom = this.zoomLevel + increment;
        if (newZoom >= this.defaultProps.minZoomLevel &&
            newZoom <= this.defaultProps.maxZoomLevel) {
            this.zoomLevel = newZoom;
            this.setZoom(newZoom);
        }
    }
    handleStateObserver() {
        this.featureModuleStateService.acessibilidadeVisibleObserver.subscribe((value) => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
}
FeatureAcessibilidadeComponent.ɵfac = function FeatureAcessibilidadeComponent_Factory(t) { return new (t || FeatureAcessibilidadeComponent)(ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService)); };
FeatureAcessibilidadeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeatureAcessibilidadeComponent, selectors: [["feature-acessibilidade"]], hostBindings: function FeatureAcessibilidadeComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, decls: 16, vars: 2, consts: [[1, "features-user", "auto-height", "accessibility"], [1, "title"], [1, "user-actions"], [1, "no-link", "zoom"], ["aria-hidden", "true", "focusable", "false", "data-prefix", "fas", "data-icon", "search", "role", "img", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 512 512", 1, "svg-inline--fa", "fa-search", "fa-w-16", "icon"], ["fill", "currentColor", "d", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"], [1, "btn-group", "right"], ["type", "button", 1, "btn", "neutral", "pt-none", "pb-none", "fa", "fa-plus", 3, "click"], ["type", "button", 1, "btn", "neutral", "pt-none", "pb-none", "fa", "fa-minus", 3, "click"], ["type", "button", 1, "btn", "neutral", "pt-none", "pb-none", "fa", "fa-expand", 3, "click"], [3, "click"], ["aria-hidden", "true", "focusable", "false", "data-prefix", "fas", "data-icon", "adjust", "role", "img", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 512 512", 1, "svg-inline--fa", "fa-adjust", "fa-w-16", "icon"], ["fill", "currentColor", "d", "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"]], template: function FeatureAcessibilidadeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵtext(2, "Acessibilidade");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "ul", 2);
        ɵngcc0.ɵɵelementStart(4, "li", 3);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(5, "svg", 4);
        ɵngcc0.ɵɵelement(6, "path", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, " Zoom ");
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "button", 7);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeComponent_Template_button_click_9_listener() { return ctx.incrementZoom(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 8);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeComponent_Template_button_click_10_listener() { return ctx.decrementZoom(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 9);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeComponent_Template_button_click_11_listener() { return ctx.clearZoom(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "li", 10);
        ɵngcc0.ɵɵlistener("click", function FeatureAcessibilidadeComponent_Template_li_click_12_listener() { return ctx.acessibilidadeContraste(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(13, "svg", 11);
        ɵngcc0.ɵɵelement(14, "path", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(15, "Contraste");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
    } }, encapsulation: 2 });
FeatureAcessibilidadeComponent.ctorParameters = () => [
    { type: FeatureModuleStateService }
];
FeatureAcessibilidadeComponent.propDecorators = {
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureAcessibilidadeComponent, [{
        type: Component,
        args: [{
                selector: 'feature-acessibilidade',
                template: "<div class=\"features-user auto-height accessibility\" [class.active]=\"toggled\">\n  <h2 class=\"title\">Acessibilidade</h2>\n  <ul class=\"user-actions\">\n    <li class=\"no-link zoom\"><svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"search\"\n        class=\"svg-inline--fa fa-search fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 512 512\">\n        <path fill=\"currentColor\"\n          d=\"M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z\">\n        </path>\n      </svg>\n      Zoom\n      <div class=\"btn-group right\">\n        <button class=\"btn neutral pt-none pb-none fa fa-plus\" type=\"button\" (click)=\"incrementZoom()\"></button>\n\n        <button class=\"btn neutral pt-none pb-none fa fa-minus\" type=\"button\" (click)=\"decrementZoom()\"></button>\n\n        <button class=\"btn neutral pt-none pb-none fa fa-expand\"  type=\"button\" (click)=\"clearZoom()\"></button>\n      </div>\n    </li>\n    <li (click)=\"acessibilidadeContraste()\"><svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"adjust\"\n        class=\"svg-inline--fa fa-adjust fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 512 512\">\n        <path fill=\"currentColor\"\n          d=\"M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z\">\n        </path>\n      </svg>Contraste</li>\n  </ul>\n</div>\n"
            }]
    }], function () { return [{ type: FeatureModuleStateService }]; }, { clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

class ConfiguracaoEntidade {
    constructor() {
        this.onChangeSource = new ReplaySubject();
        this.onChangeObservers = this.onChangeSource.asObservable();
        this._entidades = [];
        this._exercicios = [];
        this._competencias = [];
        this._exerciciosCallTimes = 0;
        this._competenciasCallTimes = 0;
        this._entidadesCallTimes = 0;
    }
    set entidades(value) {
        if (value !== this._entidades) {
            this._entidades = value;
            if (this._entidadesCallTimes === 0) {
                this._entidadesCallTimes++;
                this.onChangeSource.next(this);
            }
        }
    }
    get entidades() {
        return this._entidades;
    }
    set exercicios(value) {
        if (value !== this._exercicios) {
            this._exercicios = value;
            if (this._exerciciosCallTimes === 0) {
                this._exerciciosCallTimes++;
                this.onChangeSource.next(this);
            }
        }
    }
    get exercicios() {
        return this._exercicios;
    }
    set competencias(value) {
        if (value !== this._competencias) {
            this._competencias = value;
            if (this._competenciasCallTimes === 0) {
                this._competenciasCallTimes++;
                this.onChangeSource.next(this);
            }
        }
    }
    get competencias() {
        return this._competencias;
    }
}

class FeatureConfiguracaoEntidadeComponent {
    constructor(notification, featureModuleStateService, authParams) {
        this.notification = notification;
        this.featureModuleStateService = featureModuleStateService;
        this.authParams = authParams;
        this.onGetExercicios = new EventEmitter();
        this.onGetCompetencias = new EventEmitter();
        this.onCompetenciaSelecionada = new EventEmitter();
        this.onSetHeaderTitle = new EventEmitter();
        this.configuracaoEntidade = new ConfiguracaoEntidade();
        this.showCompetencia = true;
        this.showExercicio = true;
        this.toggled = false;
    }
    ngOnInit() {
        this.configuracaoEntidade.onChangeObservers.subscribe(value => this.handleConfiguracaoEntidadeChanges(value));
        this.handleCompetenciaStateObserver();
    }
    handleConfiguracaoEntidadeChanges(config) {
        const usuarioInfo = this.authParams.getUsuarioInfo();
        if (!this.entidade) {
            this.entidade = UsuarioInfoUtils.getEntidadePrincipal(this.authParams.getUsuarioInfo());
        }
        if (this.entidade) {
            if (config.exercicios.length === 0) {
                this.onGetExercicios.emit(this.entidade);
            }
            this.setExercicio(config, usuarioInfo);
        }
        if (this.exercicio) {
            if (config.competencias.length === 0) {
                this.onGetCompetencias.emit({ 'exercicio': this.exercicio, 'entidade': this.entidade });
            }
            if (config.competencias && config.competencias.length > 0 && !this.competencia) {
                this.setCompetencia(config);
            }
        }
    }
    filterCompetencias(config, filter) {
        return config.competencias.filter(competencia => competencia.situacao === filter);
    }
    setMaxCompetencia(competencias) {
        competencias.forEach(competencia => {
            if (!this.competencia || competencia.mes > this.competencia.mes) {
                this.competencia = competencia;
            }
        });
        if (this.authParams.getUsuarioInfo().mesPadrao) {
            this.competencia = competencias.filter(c => c.mes === this.authParams.getUsuarioInfo().mesPadrao)[0];
        }
    }
    setCompetencia(config) {
        const competencias = this.filterCompetencias(config, 'A');
        if (competencias.length !== 0) {
            this.setMaxCompetencia(competencias);
        }
        else {
            this.setMaxCompetencia(this.filterCompetencias(config, 'F'));
        }
        if (!this.authParams.getUsuarioInfo().mesPadrao) {
            this.setUsuarioInfo();
        }
    }
    setUsuarioInfo() {
        const usuarioInfo = this.authParams.getUsuarioInfo();
        if (this.showCompetencia && this.competencia) {
            usuarioInfo.entidadePadrao = this.entidade;
            usuarioInfo.exercicioPadrao = this.exercicio.exercicio;
        }
        if (this.showCompetencia && this.competencia) {
            usuarioInfo.mesPadrao = this.competencia.mes;
            usuarioInfo.situacaoPadrao = this.competencia.situacaoDescricao;
        }
        this.authParams.setUsuarioInfo(usuarioInfo, false);
    }
    setExercicio(config, usuarioInfo) {
        if (config.exercicios && config.exercicios.length > 0 && !this.exercicio) {
            this.exercicio = config.exercicios.find(exercicio => exercicio.exercicio === usuarioInfo.exercicioPadrao);
        }
    }
    changeEntidade(selectedEntidade) {
        this.configuracaoEntidade.competencias = [];
        this.configuracaoEntidade.exercicios = [];
        this.onGetExercicios.emit(this.configuracaoEntidade.entidades[selectedEntidade]);
        this.exercicio = null;
        this.competencia = null;
    }
    changeExercicio(selectedExercicio) {
        this.configuracaoEntidade.competencias = [];
        let entidade = this.configuracaoEntidade.entidade || this.entidade;
        this.onGetCompetencias.emit({ 'exercicio': this.configuracaoEntidade.exercicios[selectedExercicio], 'entidade': entidade });
        this.competencia = null;
    }
    comparing() {
        return FormUtils.equals('id');
    }
    comparingByExercicio() {
        return FormUtils.equals('exercicio');
    }
    comparingByMes() {
        return FormUtils.equals('mes');
    }
    confirm() {
        const { entidade, exercicio, competencia } = this;
        if (entidade && (exercicio || !this.showExercicio) && (competencia || !this.showCompetencia)) {
            const usuarioInfo = this.authParams.getUsuarioInfo();
            usuarioInfo.entidadePadrao = entidade;
            if (this.showExercicio) {
                usuarioInfo.exercicioPadrao = exercicio.exercicio;
            }
            if (this.showCompetencia) {
                usuarioInfo.mesPadrao = competencia.mes;
                usuarioInfo.situacaoPadrao = competencia.situacaoDescricao;
            }
            this.authParams.setUsuarioInfo(usuarioInfo, false);
            this.close();
            this.notification.success('Definições de entidade', 'Definido com sucesso!');
            window.location.reload();
        }
        else {
            this.notification.error('Definições de entidade', 'Preencha todos os campos para definir!');
        }
    }
    close() {
        this.featureModuleStateService.hideMenu('configuracaoEntidade');
        this.updateBodyOverlay();
    }
    updateBodyOverlay() {
        const body = document.getElementsByTagName('body')[0];
        body.removeAttribute('class');
    }
    handleCompetenciaStateObserver() {
        this.featureModuleStateService.configuracaoEntidadeVisibleObserver.subscribe(value => {
            if (value === undefined) {
                this.updateBodyOverlay();
                this.toggled = !this.toggled;
            }
            else {
                this.toggled = value;
            }
        });
    }
}
FeatureConfiguracaoEntidadeComponent.ɵfac = function FeatureConfiguracaoEntidadeComponent_Factory(t) { return new (t || FeatureConfiguracaoEntidadeComponent)(ɵngcc0.ɵɵdirectiveInject(EloNotificationService), ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService), ɵngcc0.ɵɵdirectiveInject(AuthParams)); };
FeatureConfiguracaoEntidadeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeatureConfiguracaoEntidadeComponent, selectors: [["feature-configuracao-entidade"]], inputs: { configuracaoEntidade: "configuracaoEntidade", showCompetencia: "showCompetencia", showExercicio: "showExercicio" }, outputs: { onGetExercicios: "onGetExercicios", onGetCompetencias: "onGetCompetencias", onCompetenciaSelecionada: "onCompetenciaSelecionada", onSetHeaderTitle: "onSetHeaderTitle" }, decls: 13, vars: 5, consts: [[1, "features-configuracao-entidade", "overflow-visible"], [1, "title"], ["aria-hidden", "true"], [1, "user-actions", "inputs"], ["class", "form-group", 4, "ngIf"], [1, "form-group", 2, "display", "block"], ["id", "btnConfirm", "type", "button", 1, "btn", "inline", "positive", "full-xs", 3, "click"], ["id", "btnCancel", "type", "button", 1, "btn", "inline", "negative", "full-xs", 3, "click"], [1, "form-group"], ["for", "entidade"], ["id", "entidades", "placeholder", "Selecione a Entidade", "required", "", 3, "ngModel", "compareWith", "change", "ngModelChange"], ["id", "entidade", 3, "ngValue", 4, "ngFor", "ngForOf"], ["id", "entidade", 3, "ngValue"], ["for", "exercicio"], ["id", "exercicio", "placeholder", "Selecione o Exerc\u00EDcio", "required", "", 3, "ngModel", "compareWith", "change", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], ["for", "competencia"], ["id", "competencias", "placeholder", "Selecione a Compet\u00EAncia", "required", "", 3, "ngModel", "compareWith", "ngModelChange"], ["id", "competencia", 3, "ngValue", "disabled", 4, "ngFor", "ngForOf"], ["id", "competencia", 3, "ngValue", "disabled"]], template: function FeatureConfiguracaoEntidadeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "aside", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵtext(3, "Defini\u00E7\u00F5es de entidade ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, FeatureConfiguracaoEntidadeComponent_div_5_Template, 5, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(6, FeatureConfiguracaoEntidadeComponent_div_6_Template, 5, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(7, FeatureConfiguracaoEntidadeComponent_div_7_Template, 5, 3, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "button", 6);
        ɵngcc0.ɵɵlistener("click", function FeatureConfiguracaoEntidadeComponent_Template_button_click_9_listener() { return ctx.confirm(); });
        ɵngcc0.ɵɵtext(10, " Definir ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 7);
        ɵngcc0.ɵɵlistener("click", function FeatureConfiguracaoEntidadeComponent_Template_button_click_11_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(12, " Cancelar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configuracaoEntidade);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configuracaoEntidade && ctx.showExercicio);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configuracaoEntidade && ctx.showCompetencia);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc3.SelectControlValueAccessor, ɵngcc3.RequiredValidator, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc2.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x]; }, pipes: function () { return [MonthNamePipe]; }, encapsulation: 2 });
FeatureConfiguracaoEntidadeComponent.ctorParameters = () => [
    { type: EloNotificationService },
    { type: FeatureModuleStateService },
    { type: AuthParams }
];
FeatureConfiguracaoEntidadeComponent.propDecorators = {
    onGetExercicios: [{ type: Output }],
    onGetCompetencias: [{ type: Output }],
    onCompetenciaSelecionada: [{ type: Output }],
    onSetHeaderTitle: [{ type: Output }],
    configuracaoEntidade: [{ type: Input }],
    showCompetencia: [{ type: Input }],
    showExercicio: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureConfiguracaoEntidadeComponent, [{
        type: Component,
        args: [{
                selector: 'feature-configuracao-entidade',
                template: "<aside class=\"features-configuracao-entidade overflow-visible\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <i aria-hidden=\"true\"></i>Defini\u00E7\u00F5es de entidade\n  </h2>\n  <div class=\"user-actions inputs\">\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade\">\n      <label for=\"entidade\">Entidade</label>\n      <select id=\"entidades\" placeholder=\"Selecione a Entidade\" (change)=\"changeEntidade($event.target.selectedIndex)\" [(ngModel)]=\"entidade\"\n        [compareWith]=\"comparing()\" required>\n        <option id=\"entidade\" [ngValue]=\"entidade\" *ngFor=\"let entidade of configuracaoEntidade.entidades\">{{entidade.nome}}</option>\n      </select>\n    </div>\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade && showExercicio\">\n      <label for=\"exercicio\">Exerc\u00EDcio</label>\n      <select id=\"exercicio\" placeholder=\"Selecione o Exerc\u00EDcio\" (change)=\"changeExercicio($event.target.selectedIndex)\" [(ngModel)]=\"exercicio\"\n        [compareWith]=\"comparingByExercicio()\" required>\n        <option [ngValue]=\"exercicio\" *ngFor=\"let exercicio of configuracaoEntidade.exercicios\">{{exercicio.exercicio}}</option>\n      </select>\n    </div>\n    <div class=\"form-group\" *ngIf=\"configuracaoEntidade && showCompetencia\">\n      <label for=\"competencia\">Compet\u00EAncia</label>\n      <select id=\"competencias\" placeholder=\"Selecione a Compet\u00EAncia\"\n        [(ngModel)]=\"competencia\" [compareWith]=\"comparingByMes()\" required>\n        <option  id=\"competencia\" [ngValue]=\"competencia\" *ngFor=\"let competencia of configuracaoEntidade.competencias\" [disabled]=\"competencia.situacaoDescricao === 'Bloqueado'\">{{competencia.mes | monthname}} - {{competencia.situacaoDescricao}}</option>\n      </select>\n    </div>\n    <div class=\"form-group\" style=\"display:block\">\n      <button id=\"btnConfirm\" type=\"button\" (click)=\"confirm()\" class=\"btn inline positive full-xs\">\n        Definir\n      </button>\n      <button id=\"btnCancel\" type=\"button\" (click)=\"close()\" class=\"btn inline negative full-xs\">\n        Cancelar\n      </button>\n    </div>\n  </div>\n</aside>\n"
            }]
    }], function () { return [{ type: EloNotificationService }, { type: FeatureModuleStateService }, { type: AuthParams }]; }, { onGetExercicios: [{
            type: Output
        }], onGetCompetencias: [{
            type: Output
        }], onCompetenciaSelecionada: [{
            type: Output
        }], onSetHeaderTitle: [{
            type: Output
        }], configuracaoEntidade: [{
            type: Input
        }], showCompetencia: [{
            type: Input
        }], showExercicio: [{
            type: Input
        }] }); })();

class FeatureContribuinteComponent {
    constructor(_renderer, _featureModuleStateService, _router) {
        this._renderer = _renderer;
        this._featureModuleStateService = _featureModuleStateService;
        this._router = _router;
        this.toggled = false;
        this.feature = {
            contribuinte: 'contribuinte'
        };
    }
    ngOnInit() {
        this.handleGlobalClick();
        this.handleContribuinteStateObserver();
    }
    alterarContribuinte() {
        if (this._router.url.startsWith('/acessar-contribuinte')) {
            return;
        }
        this._router.navigate(['/acessar-contribuinte'], {
            queryParams: {
                redirect: window.location.href
            }
        });
    }
    ngOnDestroy() {
        this.globalClick();
    }
    static notContribuinteButton(event) {
        if (event.target.className.indexOf) {
            return event.target.className.indexOf('contribuinte') < 0;
        }
    }
    handleGlobalClick() {
        this.globalClick = this._renderer.listen('body', 'click', (event) => {
            this.hideContribuinteMenu(event);
        });
    }
    handleContribuinteStateObserver() {
        this._featureModuleStateService.contribuinteVisibleObserver.subscribe(value => {
            if (value === undefined) {
                this.toggled = !this.toggled;
            }
            else {
                this.toggled = value;
            }
        });
    }
    hideContribuinteMenu(event) {
        if (FeatureContribuinteComponent.notContribuinteButton(event)) {
            this._featureModuleStateService.hideMenu(this.feature.contribuinte);
        }
    }
}
FeatureContribuinteComponent.ɵfac = function FeatureContribuinteComponent_Factory(t) { return new (t || FeatureContribuinteComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router)); };
FeatureContribuinteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeatureContribuinteComponent, selectors: [["feature-contribuinte"]], inputs: { contribuinte: "contribuinte" }, decls: 1, vars: 1, consts: [["class", "features-contribuinte", 3, "active", 4, "ngIf"], [1, "features-contribuinte"], [1, "title"], ["aria-hidden", "true"], [1, "container", "contribuinte-actions"], [1, "row"], [1, "col-sm-12"], [1, "form-group"], [1, "label"], ["id", "btnAlterarContribuinte", 1, "btn", "module-color", "icon-left", "inline", "full-xs", 3, "click"], [1, "fa", "fa-pencil"]], template: function FeatureContribuinteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FeatureContribuinteComponent_aside_0_Template, 46, 9, "aside", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.contribuinte);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
FeatureContribuinteComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: FeatureModuleStateService },
    { type: Router }
];
FeatureContribuinteComponent.propDecorators = {
    contribuinte: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureContribuinteComponent, [{
        type: Component,
        args: [{
                selector: 'feature-contribuinte',
                template: "<aside *ngIf=\"contribuinte\" class=\"features-contribuinte\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <i aria-hidden=\"true\"></i>Contribuinte\n  </h2>\n\n  <div class=\"container contribuinte-actions\">\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">{{contribuinte.cnpjCpf?.length > 14 ? 'Raz\u00E3o Social' : 'Nome'}}</label>\n          <span>{{contribuinte.razaoSocialNome}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">{{contribuinte.cnpjCpf?.length > 14 ? 'CNPJ' : 'CPF'}}</label>\n          <span>{{contribuinte.cnpjCpf}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Inscri\u00E7\u00E3o Municipal</label>\n          <span>{{contribuinte.cadastro}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Cidade</label>\n          <span>{{contribuinte.cidade}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <label class=\"label\">Regime Fiscal</label>\n          <span>{{contribuinte.regimeFiscal}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"form-group\">\n          <button id=\"btnAlterarContribuinte\" class=\"btn module-color icon-left inline full-xs\" (click)=\"alterarContribuinte()\">\n            <i class=\"fa fa-pencil\"></i>\n            Alterar\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n</aside>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: FeatureModuleStateService }, { type: ɵngcc6.Router }]; }, { contribuinte: [{
            type: Input
        }] }); })();

class ElectronModule {
    constructor() {
        this.module = null;
        this.childProcess = null;
        this.desktop = '<%= DESKTOP %>';
    }
    getModule() {
        if (!this.module) {
            // this.module = require('@node/electron');
        }
        return this.module;
    }
    getChildProcess() {
        if (!this.childProcess) {
            //  this.child_process = require('@node/child_process');
        }
        return this.childProcess;
    }
    isElectron() {
        return this.desktop === 'electron';
    }
}

const AREAS = {
    'data': [
        {
            'titulo': 'Geral',
            'cssAdicionalTitulo': 'cadastrounico',
            'iconeTitulo': 'cadastrounico.png',
            'iconeTituloSmall': 'cadastrounico-small.png',
            'iconeTituloBig': 'cadastrounico-big.png',
            'modulos': [
                {
                    'id': 90,
                    'descricao': 'Cadastro único',
                    'icone': 'cadastrounico.png',
                    'iconeSmall': 'cadastrounico-small.png',
                    'iconBig': 'cadastrounico-big.png',
                    'url': ''
                },
            ]
        },
        {
            'titulo': 'Arrecadação',
            'cssAdicionalTitulo': 'arrecadacao',
            'iconeTitulo': 'oxy-arrecadacao.svg',
            'iconeTituloSmall': 'oxy-arrecadacao.svg',
            'modulos': [
                {
                    'id': 26,
                    'descricao': 'Mais ISS',
                    'icone': 'arrecadacao-nfe.png',
                    'iconeSmall': 'arrecadacao-nfe-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 41,
                    'descricao': 'Receitas Não Tributárias',
                    'icone': 'arrecadacao-receitasnaotributarias.png',
                    'iconeSmall': 'arrecadacao-receitasnaotributarias-small.png',
                    'iconBig': 'arrecadacao-receitasnaotributarias-big.png',
                    'url': ''
                },
                {
                    'id': 38,
                    'descricao': 'Cemitério',
                    'icone': 'arrecadacao-cemiterio.png',
                    'iconeSmall': 'arrecadacao-cemiterio-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 39,
                    'descricao': 'Processo Judicial ',
                    'icone': 'arrecadacao-processosjudiciais.png',
                    'iconeSmall': 'arrecadacao-processosjudiciais-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 40,
                    'descricao': 'Alvará On-line',
                    'icone': 'arrecadacao-alvaraonline.png',
                    'iconeSmall': 'arrecadacao-alvaraonline-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 43,
                    'descricao': 'Fiscalização',
                    'icone': 'arrecadacao-fiscalizacao.png',
                    'iconeSmall': 'arrecadacao-fiscalizacao-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 27,
                    'descricao': 'Gerador de Relatórios',
                    'icone': 'arrecadacao.png',
                    'iconeSmall': 'arrecadacao-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        },
        {
            'titulo': 'Contabilidade',
            'cssAdicionalTitulo': 'contabil',
            'iconeTitulo': 'oxy-contabil.svg',
            'iconeTituloSmall': 'oxy-contabil.svg',
            'modulos': [
                {
                    'id': 2,
                    'descricao': 'Planejamento Orçamentário',
                    'icone': 'contabil-planejamentoorcamentario.png',
                    'iconeSmall': 'contabil-planejamentoorcamentario-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 12,
                    'descricao': 'Controle Interno',
                    'icone': 'contabil-controleinterno.png',
                    'iconeSmall': 'contabil-controleinterno-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 20,
                    'descricao': 'LRF',
                    'icone': 'contabil-lrf.png',
                    'iconeSmall': 'contabil-lrf-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 15,
                    'descricao': 'Tesouraria e Gestão Financeira',
                    'icone': 'contabil-tgf.png',
                    'iconeSmall': 'contabil-tgf-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 3,
                    'descricao': 'Contabil',
                    'icone': 'contabil-contabilidadepublica.png',
                    'iconeSmall': 'contabil-contabilidadepublica-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 34,
                    'descricao': 'Portal Transparencia',
                    'icone': 'contabil-portaltransparencia.png',
                    'iconeSmall': 'contabil-portaltransparencia-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 5,
                    'descricao': 'Portal Contribuinte',
                    'icone': 'contabil-portalcontribuinte.png',
                    'iconeSmall': 'contabil-portalcontribuinte-small.png',
                    'iconBig': 'contabil-portalcontribuinte-big.png',
                    'url': ''
                },
            ]
        },
        {
            'titulo': 'Administração',
            'cssAdicionalTitulo': 'administracao',
            'iconeTitulo': 'oxy-administrativo.svg',
            'iconeTituloSmall': 'oxy-administrativo.svg',
            'modulos': [
                {
                    'id': 19,
                    'descricao': 'Almoxarifado e Logística',
                    'icone': 'administracao-almoxarifadologistica.png',
                    'iconeSmall': 'administracao-almoxarifadologistica-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 7,
                    'descricao': 'Patrimônio',
                    'icone': 'administracao-controlepatrimonial.png',
                    'iconeSmall': 'administracao-controlepatrimonial-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 25,
                    'descricao': 'Obras',
                    'icone': 'administracao-controleobras.png',
                    'iconeSmall': 'administracao-controleobras-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 8,
                    'descricao': 'Frotas e Veículos',
                    'icone': 'administracao-frotasveiculos.png',
                    'iconeSmall': 'administracao-frotasveiculos-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 17,
                    'descricao': 'Ouvidoria',
                    'icone': 'administracao-ouvidoria.png',
                    'iconeSmall': 'administracao-ouvidoria-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 18,
                    'descricao': 'Legislação',
                    'icone': 'administracao-legislacao.png',
                    'iconeSmall': 'administracao-legislacao-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 10,
                    'descricao': 'Compras e Licitação',
                    'icone': 'administracao-compraslicitacoes.png',
                    'iconeSmall': 'administracao-compraslicitacoes-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 4,
                    'descricao': 'Controle de Processos',
                    'icone': 'administracao-controleprocessos.png',
                    'iconeSmall': 'administracao-controleprocessos-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        },
        {
            'titulo': 'Recursos Humanos',
            'cssAdicionalTitulo': 'recursoshumanos',
            'iconeTitulo': 'oxy-rh.svg',
            'iconeTituloSmall': 'oxy-rh.svg',
            'modulos': [
                {
                    'id': 67,
                    'descricao': 'Folha de Pagamento',
                    'icone': 'recursoshumanos-folhapagamento.png',
                    'iconeSmall': 'recursoshumanos-folhapagamento-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 30,
                    'descricao': 'eSocial',
                    'icone': 'recursoshumanos-esocial.png',
                    'iconeSmall': 'recursoshumanos-esocial-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 42,
                    'descricao': 'Portal RH (Portal do Servidor)',
                    'icone': 'recursoshumanos-portalservidor.png',
                    'iconeSmall': 'recursoshumanos-portalservidor-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        },
        {
            'titulo': 'Saúde',
            'cssAdicionalTitulo': 'saude',
            'iconeTitulo': 'oxy-social.svg',
            'iconeTituloSmall': 'oxy-social.svg',
            'modulos': [
                {
                    'id': 6,
                    'descricao': 'Saúde',
                    'icone': 'saude.png',
                    'iconeSmall': 'saude-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        },
        {
            'titulo': 'Educacional',
            'cssAdicionalTitulo': 'educacional',
            'iconeTitulo': 'oxy-educacional.svg',
            'iconeTituloSmall': 'oxy-educacional.svg',
            'modulos': [
                {
                    'id': 21,
                    'descricao': 'Educação',
                    'icone': 'educacional.png',
                    'iconeSmall': 'educacional-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                },
                {
                    'id': 16,
                    'descricao': 'Biblioteca',
                    'icone': 'educacional-biblioteca.png',
                    'iconeSmall': 'educacional-biblioteca-small.png',
                    'iconBig': '-big.png',
                    'url': ''
                }
            ]
        }
    ]
};

class ListaModulosService {
    constructor(authHttp, authResourcesConfig) {
        this.authHttp = authHttp;
        this.authResourcesConfig = authResourcesConfig;
        this.electron = new ElectronModule();
    }
    getModulosUsuario() {
        return forkJoin([
            of(AREAS),
            this.authHttp.getUsuarioLogado()
        ]).pipe(map((data) => {
            let areas = data[0].data;
            let usuario = data[1];
            for (let area of areas) {
                for (let moduloDaArea of area.modulos) {
                    moduloDaArea.podeAcessar = this.usuarioPodeAcessarModulo(usuario, moduloDaArea);
                }
            }
            return areas;
        }));
    }
    moduloClick(modulo) {
        let url = this.isDev() ? `${this.authResourcesConfig.hostDev}/${modulo.url}/` : `/${modulo.url}/`;
        window.open(url);
        return false;
    }
    isDev() {
        return this.authResourcesConfig.isDev;
    }
    usuarioPodeAcessarModulo(usuario, moduloDaArea) {
        if (usuario.modulos) {
            for (let modulosDoUsuario of usuario.modulos) {
                if (moduloDaArea.id === modulosDoUsuario.modulo.id) {
                    moduloDaArea.url = modulosDoUsuario.modulo.url;
                    moduloDaArea.path = modulosDoUsuario.modulo.path;
                    return true;
                }
            }
        }
        return false;
    }
}
ListaModulosService.ɵfac = function ListaModulosService_Factory(t) { return new (t || ListaModulosService)(ɵngcc0.ɵɵinject(AbstractAuthHttp), ɵngcc0.ɵɵinject(AUTH_RESOURCES_CONFIG)); };
ListaModulosService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ListaModulosService, factory: ListaModulosService.ɵfac });
ListaModulosService.ctorParameters = () => [
    { type: AbstractAuthHttp },
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_RESOURCES_CONFIG,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListaModulosService, [{
        type: Injectable
    }], function () { return [{ type: AbstractAuthHttp }, { type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_RESOURCES_CONFIG]
            }] }]; }, null); })();

class FeatureModulesComponent {
    constructor(authParams, listaModulosService, featureModuleStateService, elementRef, keyCloakService) {
        this.authParams = authParams;
        this.listaModulosService = listaModulosService;
        this.featureModuleStateService = featureModuleStateService;
        this.elementRef = elementRef;
        this.keyCloakService = keyCloakService;
        this.moduleOrFavorite = false;
        this.modulos = [];
        this.areas = [];
        this.toggled = false;
        this.buildModuloUrl = (moduloUri) => {
            return `${window.location.origin}/${moduloUri}`;
        };
    }
    ngOnInit() {
        this.handleStateObserver();
        if (this.keyCloakService) {
            this.keyCloakService.getModulos().subscribe((response) => {
                if (response.length > 0) {
                    this.modulos = response;
                    for (const modulo of response) {
                        const nova = {
                            area: modulo.area,
                            descricaoArea: modulo.descricaoArea,
                            open: true
                        };
                        if (modulo.area === 'COMUM') {
                            this.comum = nova;
                        }
                        else if (!this.areas.find((area) => area.area === nova.area)) {
                            this.areas.push(nova);
                        }
                    }
                    if (this.comum) {
                        this.areas.push(this.comum);
                    }
                }
            }, (erro) => {
                console.warn('Erro ao recuperar modulos: ', erro);
            });
        }
        else {
            this.authParams.onLoginObservers.subscribe(login => {
                if (login) {
                    this.listaModulosService.getModulosUsuario().subscribe(area => this.listModules(area));
                }
                else {
                    this.modulos = [];
                }
            });
        }
    }
    clickedOutside($event) {
        if (this.contentRef && this.contentRef.nativeElement.contains(($event.target))) {
            return;
        }
        if (this.toggled) {
            this.featureModuleStateService.hideMenu('module');
        }
    }
    hideModules(areaSelecionada) {
        areaSelecionada.open = !areaSelecionada.open;
    }
    ShowModulesOrFavorites() {
        this.moduleOrFavorite = !this.moduleOrFavorite;
    }
    showListModules(area) {
        return this.modulos.filter(modulo => modulo.area === area);
    }
    getImage(area) {
        switch (area) {
            case 'ADMINISTRATIVO':
                return 'img/modules/oxy-administrativo.svg';
            case 'ARRECADACAO':
                return 'img/modules/oxy-arrecadacao.svg';
            case 'CONTABIL':
                return 'img/modules/oxy-contabil.svg';
            case 'EDUCACIONAL':
                return 'img/modules/oxy-educacional.svg';
            case 'RECURSOS_HUMANOS':
                return 'img/modules/oxy-rh.svg';
            case 'SOCIAL':
                return 'img/modules/oxy-social.svg';
            case 'COMUM':
                return 'img/modules/oxy-logo.svg';
        }
    }
    handleStateObserver() {
        this.featureModuleStateService.moduleVisibleObserver.subscribe(value => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
    listModules(areas) {
        this.modulos = [];
        areas.forEach(area => {
            area.modulos.forEach(modulo => {
                if ((modulo.podeAcessar) && (modulo.url)) {
                    this.modulos.push(modulo);
                }
            });
        });
    }
}
FeatureModulesComponent.ɵfac = function FeatureModulesComponent_Factory(t) { return new (t || FeatureModulesComponent)(ɵngcc0.ɵɵdirectiveInject(AuthParams), ɵngcc0.ɵɵdirectiveInject(ListaModulosService), ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(KeycloakAuthHttp, 8)); };
FeatureModulesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeatureModulesComponent, selectors: [["feature-modules"]], viewQuery: function FeatureModulesComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c46, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentRef = _t.first);
    } }, hostBindings: function FeatureModulesComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FeatureModulesComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, decls: 9, vars: 3, consts: [["contentRef", ""], [1, "features-modules"], [1, "title"], [1, "tab"], [1, "active"], ["id", "divModules", 1, "features-body"], ["class", "module-list no-logo expansible", 3, "open", "click", 4, "ngFor", "ngForOf"], [1, "module-list", "no-logo", "expansible", 3, "click"], [1, "features-section"], ["aria-hidden", "", 1, "module-color", "icon", 2, "enable-background", "new 0 0 566.9 566.9", 3, "src"], ["class", "sister", 4, "ngFor", "ngForOf"], [1, "sister"], ["target", "_blank", "rel", "noopener noreferrer", 3, "href"]], template: function FeatureModulesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "h2", 2);
        ɵngcc0.ɵɵtext(4, "M\u00F3dulos");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "ul", 3);
        ɵngcc0.ɵɵelementStart(6, "li", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵtemplate(8, FeatureModulesComponent_ul_8_Template, 7, 5, "ul", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.areas);
    } }, directives: [ɵngcc2.NgForOf], encapsulation: 2 });
FeatureModulesComponent.ctorParameters = () => [
    { type: AuthParams },
    { type: ListaModulosService },
    { type: FeatureModuleStateService },
    { type: ElementRef },
    { type: KeycloakAuthHttp, decorators: [{ type: Optional }] }
];
FeatureModulesComponent.propDecorators = {
    contentRef: [{ type: ViewChild, args: ['contentRef', { static: true },] }],
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureModulesComponent, [{
        type: Component,
        args: [{
                selector: 'feature-modules',
                template: "<div #contentRef>\n  <div class=\"features-modules\" [class.active]=\"toggled\">\n    <h2 class=\"title\">M\u00F3dulos</h2>\n    <ul class=\"tab\">\n      <li class=\"active\">\n        <div id=\"divModules\" class=\"features-body\">\n          <ul class=\"module-list no-logo expansible\" [class.open]=\"area.open\" (click)=\"hideModules(area)\" *ngFor=\"let area of areas\">\n            <li class=\"features-section\"><a>\n                <img src=\"{{getImage(area?.area)}}\" aria-hidden class=\"module-color icon\"\n                  style=\"enable-background:new 0 0 566.9 566.9\" />\n                <span>{{area?.descricaoArea}}</span></a></li>\n            <li class='sister' *ngFor=\"let modulo of showListModules(area.area)\">\n              <a target=\"_blank\" rel=\"noopener noreferrer\"\n                [href]=\"buildModuloUrl(modulo?.uri)\"><span>{{modulo?.descricao}}</span></a>\n            </li>\n          </ul>\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>"
            }]
    }], function () { return [{ type: AuthParams }, { type: ListaModulosService }, { type: FeatureModuleStateService }, { type: ɵngcc0.ElementRef }, { type: KeycloakAuthHttp, decorators: [{
                type: Optional
            }] }]; }, { clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], contentRef: [{
            type: ViewChild,
            args: ['contentRef', { static: true }]
        }] }); })();

class FeatureNotificationComponent {
    constructor(featureModuleStateService) {
        this.featureModuleStateService = featureModuleStateService;
        this.toggled = false;
    }
    ngOnInit() {
        this.handleStateObserver();
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents && parents.length > 0 && parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('features-notification')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.toggled)
                this.featureModuleStateService.hideMenu('notification');
        }
    }
    handleStateObserver() {
        this.featureModuleStateService.notificationVisibleObserver.subscribe(value => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
}
FeatureNotificationComponent.ɵfac = function FeatureNotificationComponent_Factory(t) { return new (t || FeatureNotificationComponent)(ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService)); };
FeatureNotificationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeatureNotificationComponent, selectors: [["feature-notification"]], hostBindings: function FeatureNotificationComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FeatureNotificationComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, decls: 11, vars: 2, consts: [[1, "features-notifications", "reduced", "auto-height", "read-options"], [1, "title"], [1, "read", "hint", "clean", "center-left"], [1, "fa", "fa-envelope"], [1, "features-body"], [1, "notification-list"], [1, "nowrap"]], template: function FeatureNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "em", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(4, "Notifica\u00E7\u00F5es ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "ul", 5);
        ɵngcc0.ɵɵelementStart(7, "li");
        ɵngcc0.ɵɵelementStart(8, "article");
        ɵngcc0.ɵɵelementStart(9, "p", 6);
        ɵngcc0.ɵɵtext(10, "N\u00E3o existem novas notifica\u00E7\u00F5es.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
    } }, encapsulation: 2 });
FeatureNotificationComponent.ctorParameters = () => [
    { type: FeatureModuleStateService }
];
FeatureNotificationComponent.propDecorators = {
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureNotificationComponent, [{
        type: Component,
        args: [{
                selector: 'feature-notification',
                template: "<div class=\"features-notifications reduced auto-height read-options\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <div class=\"read hint clean center-left\">\n      <em class=\"fa fa-envelope\"></em>\n    </div>Notifica\u00E7\u00F5es\n  </h2>\n  <div class=\"features-body\">\n    <ul class=\"notification-list\">\n      <li>\n        <article>\n          <p class=\"nowrap\">N\u00E3o existem novas notifica\u00E7\u00F5es.</p>\n        </article>\n      </li>\n    </ul>\n  </div>\n</div>"
            }]
    }], function () { return [{ type: FeatureModuleStateService }]; }, { clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

class FeatureSobreSistemaService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.resource = '/actuator/info';
    }
    getCurrentVersion() {
        return this.httpClient.get({
            resource: `${this.resource}`
        });
    }
}
FeatureSobreSistemaService.ɵfac = function FeatureSobreSistemaService_Factory(t) { return new (t || FeatureSobreSistemaService)(ɵngcc0.ɵɵinject(HttpClient)); };
FeatureSobreSistemaService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FeatureSobreSistemaService, factory: FeatureSobreSistemaService.ɵfac });
FeatureSobreSistemaService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureSobreSistemaService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class FeatureSobreSistemaComponent {
    constructor(featureSobreSistemaService, featureModuleStateService) {
        this.featureSobreSistemaService = featureSobreSistemaService;
        this.featureModuleStateService = featureModuleStateService;
        this.getVersaoSobreSistema = undefined;
        this.getTotalAcessosSobreSistema = undefined;
        this.showNovidadesVersao = false;
        this.versaoBuild = undefined;
        this.dataBuild = undefined;
        this.isVersaoDefined = false;
        this.versaoSubscription = undefined;
        this.isTotalAcessosDefined = false;
        this.totalAcessosSubscription = undefined;
        this.toggled = false;
    }
    voltarParaAjustes() {
        this.featureModuleStateService.alternateStatus('sobreSistema');
        this.featureModuleStateService.alternateStatus('user');
    }
    ngOnInit() {
        this.isTotalAcessosDefined = this.getTotalAcessosSobreSistema !== undefined;
        this.handleStateObserver();
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents &&
                parents.length > 0 &&
                parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map((parent) => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('usuario')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.toggled)
                this.featureModuleStateService.hideMenu('sobreSistema');
        }
    }
    handleStateObserver() {
        this.featureModuleStateService.sobreSistemaVisibleObserver.subscribe((value) => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
                if (this.toggled) {
                    if (!this.getVersaoSobreSistema) {
                        this.versaoSubscription = this.featureSobreSistemaService.getCurrentVersion().subscribe((response) => {
                            this.versaoBuild = response.build.version;
                            this.dataBuild = response.build.time;
                        });
                    }
                    else {
                        this.versaoSubscription = this.getVersaoSobreSistema().subscribe((response) => {
                            this.versaoBuild = response.build.version;
                            this.dataBuild = response.build.time;
                        });
                    }
                    if (this.getTotalAcessosSobreSistema) {
                        this.totalAcessosSubscription = this.getTotalAcessosSobreSistema().subscribe((response) => {
                            this.totalAcessos = response;
                        });
                    }
                }
                else {
                    if (this.versaoSubscription) {
                        this.versaoSubscription.unsubscribe();
                    }
                    this.versaoSubscription = undefined;
                    if (this.totalAcessosSubscription) {
                        this.totalAcessosSubscription.unsubscribe();
                    }
                    this.totalAcessosSubscription = undefined;
                    this.versaoBuild = undefined;
                    this.dataBuild = undefined;
                    this.totalAcessos = undefined;
                }
            }, 50);
        });
    }
}
FeatureSobreSistemaComponent.ɵfac = function FeatureSobreSistemaComponent_Factory(t) { return new (t || FeatureSobreSistemaComponent)(ɵngcc0.ɵɵdirectiveInject(FeatureSobreSistemaService), ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService)); };
FeatureSobreSistemaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeatureSobreSistemaComponent, selectors: [["feature-user-sobre-sistema"]], hostBindings: function FeatureSobreSistemaComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FeatureSobreSistemaComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { getVersaoSobreSistema: "getVersaoSobreSistema", getTotalAcessosSobreSistema: "getTotalAcessosSobreSistema", showNovidadesVersao: "showNovidadesVersao", urlNovidades: "urlNovidades" }, decls: 33, vars: 8, consts: [[1, "features-user", "auto-height", "usuario"], [1, "title"], [1, "read", "hint", "clean", "center-left", "neutral", 3, "click"], [1, "fa", "fa-chevron-left"], [1, "hint-content"], [1, "user-actions", "sobre-sistema"], [1, "col-md-12", "form-group", "mb-xs"], ["id", "versao"], ["id", "totalAcessos", 4, "ngIf"], ["class", "form-group", "id", "novidades", 4, "ngIf"], [1, "footer-oxy-logo", "hidden-sm", "hidden-xs"], ["width", "1131.886", "height", "135.779", "viewBox", "0 0 1131.886 135.779"], ["id", "Grupo_1234", "data-name", "Grupo 1234", "transform", "translate(-128.114 -351.26)"], ["id", "Caminho_2", "data-name", "Caminho 2", "d", "M4-.319V-6.78H-29.305V-.319h13.056V40.648h7.194V-.319ZM42.5,40.648V34.187H19.389V19.932H39.107V13.537H19.389V-.319H42.5V-6.78H12.2V40.648ZM84.6,26.46H77.343c-1.132,4.8-4.4,8.127-9.659,8.127a9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788S58.358,4.677,60.69,2.146A9.477,9.477,0,0,1,67.684-.719c5.262,0,8.46,3.331,9.592,8.127H84.6C82.938-2.051,76.41-7.18,67.684-7.18A17.187,17.187,0,0,0,55.227-2.117c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.187,17.187,0,0,0,12.457,5.063C76.277,41.048,83,35.919,84.6,26.46Zm45.3,14.189V-6.78h-7.194V26.526L100.791-6.78H94.2V40.648h7.194V7.275l21.916,33.373Zm44.764-23.714c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,157.612-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C174.8,31.322,174.665,26.06,174.665,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C167,4.744,167.471,7.408,167.471,16.934Zm47.895,23.714V34.187H192.517V-6.78h-7.194V40.648ZM254.2,16.934c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,237.148-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C254.334,31.322,254.2,26.06,254.2,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C246.541,4.744,247.007,7.408,247.007,16.934ZM297.5,22.263V15H280.18v6.128h10.125V23.8a10.715,10.715,0,0,1-2.4,7.461,10.054,10.054,0,0,1-7.727,3.331,9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788s.533-12.19,2.864-14.722A9.527,9.527,0,0,1,280.18-.719c5.329,0,8.793,3.064,9.992,8.26h7.261C296.1-.585,290.239-7.18,280.18-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a18.178,18.178,0,0,0,25.513-.333C296.367,32.322,297.5,28.391,297.5,22.263Zm17.786,18.385V-6.78h-7.194V40.648Zm47.3,0L345.195-6.78h-5.8L322.013,40.648h7.661l3.264-9.526h18.718l3.264,9.526ZM349.658,24.994H335.07l7.394-21.05Z", "transform", "translate(157.419 401.566)", "fill", "#a8a8a8"], ["id", "Grupo_1237", "data-name", "Grupo 1237", "transform", "translate(518 307.26)"], ["id", "Caminho_132", "data-name", "Caminho 132", "d", "M276.665,279.579V244.641H254.529v135.72h22.135V301.714h22.042L311.4,279.579Z", "transform", "translate(117.787 -200.582)", "fill", "#b0b0b5"], ["id", "Caminho_133", "data-name", "Caminho 133", "d", "M460.674,279.544a50.156,50.156,0,0,0-28.292,8.679V244.607H410.247v135.72h22.135V330.876a28.874,28.874,0,0,1,27.734-29.19,28.26,28.26,0,0,1,28.79,28.254v50.387h22.135v-49.05c0-27.709-22.653-51.716-50.365-51.732", "transform", "translate(230.958 -200.607)", "fill", "#b0b0b5"], ["id", "Caminho_134", "data-name", "Caminho 134", "d", "M236.808,264.6A50.4,50.4,0,1,0,287.2,315a50.4,50.4,0,0,0-50.4-50.4m3.673,78.424a28.27,28.27,0,1,1,24.355-24.358,28.271,28.271,0,0,1-24.355,24.358", "transform", "translate(67.949 -185.647)", "fill", "#b0b0b5"], ["id", "Caminho_135", "data-name", "Caminho 135", "d", "M196.675,303.934A50.4,50.4,0,1,0,147.5,365.393H172.05l12.69-22.139H147.5a28.264,28.264,0,1,1,26.038-39.32c.192.453.338.93.508,1.383H147.5a9.682,9.682,0,0,0,0,19.364h49.447a50.3,50.3,0,0,0-.27-20.747", "transform", "translate(2.904 -185.671)", "fill", "#b0b0b5"], ["id", "Caminho_136", "data-name", "Caminho 136", "d", "M385.676,303.934A50.4,50.4,0,1,0,336.5,365.393h24.55l12.709-22.138H336.5a28.264,28.264,0,1,1,26.038-39.321c.189.453.338.93.505,1.383H336.5a9.682,9.682,0,1,0,0,19.364h49.447a50.253,50.253,0,0,0-.266-20.747", "transform", "translate(140.546 -185.671)", "fill", "#b0b0b5"], ["id", "Caminho_137", "data-name", "Caminho 137", "d", "M375.375,315a28.285,28.285,0,0,1,28.273-28.27h19.937l12.69-22.129H403.648a50.389,50.389,0,1,0,0,100.778l19.937,0,12.69-22.126H403.648A28.268,28.268,0,0,1,375.375,315", "transform", "translate(189.621 -185.65)", "fill", "#b0b0b5"], ["id", "Ret\\xE2ngulo_757", "data-name", "Ret\\xE2ngulo 757", "width", "22.135", "height", "135.72", "transform", "translate(216.234 44)", "fill", "#b0b0b5"], ["id", "totalAcessos"], ["id", "novidades", 1, "form-group"], ["target", "_blank", 3, "href"], [1, "fa", "fa-info-circle", "icon"]], template: function FeatureSobreSistemaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function FeatureSobreSistemaComponent_Template_div_click_2_listener() { return ctx.voltarParaAjustes(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtext(5, "Voltar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(6, " Sobre o sistema ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "ul", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "article", 7);
        ɵngcc0.ɵɵelementStart(10, "label");
        ɵngcc0.ɵɵtext(11, "Vers\u00E3o");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "p");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Data");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "p");
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "datehourformat");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, FeatureSobreSistemaComponent_article_19_Template, 5, 1, "article", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(20, FeatureSobreSistemaComponent_li_20_Template, 4, 1, "li", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 10);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(22, "svg", 11);
        ɵngcc0.ɵɵelementStart(23, "g", 12);
        ɵngcc0.ɵɵelement(24, "path", 13);
        ɵngcc0.ɵɵelementStart(25, "g", 14);
        ɵngcc0.ɵɵelement(26, "path", 15);
        ɵngcc0.ɵɵelement(27, "path", 16);
        ɵngcc0.ɵɵelement(28, "path", 17);
        ɵngcc0.ɵɵelement(29, "path", 18);
        ɵngcc0.ɵɵelement(30, "path", 19);
        ɵngcc0.ɵɵelement(31, "path", 20);
        ɵngcc0.ɵɵelement(32, "rect", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵtextInterpolate(ctx.versaoBuild ? ctx.versaoBuild : "Carregando...");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.dataBuild ? ɵngcc0.ɵɵpipeBind1(18, 6, ctx.dataBuild) : "Carregando...");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isTotalAcessosDefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNovidadesVersao);
    } }, directives: [ɵngcc2.NgIf], pipes: [DateHourFormatPipe], encapsulation: 2 });
FeatureSobreSistemaComponent.ctorParameters = () => [
    { type: FeatureSobreSistemaService },
    { type: FeatureModuleStateService }
];
FeatureSobreSistemaComponent.propDecorators = {
    getVersaoSobreSistema: [{ type: Input }],
    getTotalAcessosSobreSistema: [{ type: Input }],
    showNovidadesVersao: [{ type: Input }],
    urlNovidades: [{ type: Input }],
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureSobreSistemaComponent, [{
        type: Component,
        args: [{
                selector: 'feature-user-sobre-sistema',
                template: "<div class=\"features-user auto-height usuario\" [class.active]=\"toggled\">\n  <h2 class=\"title\">\n    <div\n      class=\"read hint clean center-left neutral\"\n      (click)=\"voltarParaAjustes()\"\n    >\n      <i class=\"fa fa-chevron-left\"></i>\n      <div class=\"hint-content\">Voltar</div>\n    </div>\n    Sobre o sistema\n  </h2>\n  <ul class=\"user-actions sobre-sistema\">\n    <div class=\"col-md-12 form-group mb-xs\">\n      <article id=\"versao\">\n        <label>Vers\u00E3o</label>\n        <p>{{ versaoBuild ? versaoBuild : 'Carregando...' }}</p>\n        <label>Data</label>\n        <p>{{ dataBuild ? (dataBuild | datehourformat) : 'Carregando...' }}</p>\n      </article>\n      <article *ngIf=\"isTotalAcessosDefined\" id=\"totalAcessos\">\n        <label>Total de Acessos</label>\n        <p>{{ totalAcessos ? totalAcessos : 'Carregando...' }}</p>\n      </article>\n    </div>\n    <li *ngIf=\"showNovidadesVersao\" class=\"form-group\" id=\"novidades\">\n      <a href=\"{{urlNovidades}}\" target=\"_blank\">\n          <i class=\"fa fa-info-circle icon\"></i>Confira as novidades da vers\u00E3o</a>\n    </li>\n  </ul>\n  <div class=\"footer-oxy-logo hidden-sm hidden-xs\">\n    <svg width=\"1131.886\" height=\"135.779\" viewBox=\"0 0 1131.886 135.779\">\n      <g\n        id=\"Grupo_1234\"\n        data-name=\"Grupo 1234\"\n        transform=\"translate(-128.114 -351.26)\"\n      >\n        <path\n          id=\"Caminho_2\"\n          data-name=\"Caminho 2\"\n          d=\"M4-.319V-6.78H-29.305V-.319h13.056V40.648h7.194V-.319ZM42.5,40.648V34.187H19.389V19.932H39.107V13.537H19.389V-.319H42.5V-6.78H12.2V40.648ZM84.6,26.46H77.343c-1.132,4.8-4.4,8.127-9.659,8.127a9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788S58.358,4.677,60.69,2.146A9.477,9.477,0,0,1,67.684-.719c5.262,0,8.46,3.331,9.592,8.127H84.6C82.938-2.051,76.41-7.18,67.684-7.18A17.187,17.187,0,0,0,55.227-2.117c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.187,17.187,0,0,0,12.457,5.063C76.277,41.048,83,35.919,84.6,26.46Zm45.3,14.189V-6.78h-7.194V26.526L100.791-6.78H94.2V40.648h7.194V7.275l21.916,33.373Zm44.764-23.714c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,157.612-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C174.8,31.322,174.665,26.06,174.665,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C167,4.744,167.471,7.408,167.471,16.934Zm47.895,23.714V34.187H192.517V-6.78h-7.194V40.648ZM254.2,16.934c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,237.148-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C254.334,31.322,254.2,26.06,254.2,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C246.541,4.744,247.007,7.408,247.007,16.934ZM297.5,22.263V15H280.18v6.128h10.125V23.8a10.715,10.715,0,0,1-2.4,7.461,10.054,10.054,0,0,1-7.727,3.331,9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788s.533-12.19,2.864-14.722A9.527,9.527,0,0,1,280.18-.719c5.329,0,8.793,3.064,9.992,8.26h7.261C296.1-.585,290.239-7.18,280.18-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a18.178,18.178,0,0,0,25.513-.333C296.367,32.322,297.5,28.391,297.5,22.263Zm17.786,18.385V-6.78h-7.194V40.648Zm47.3,0L345.195-6.78h-5.8L322.013,40.648h7.661l3.264-9.526h18.718l3.264,9.526ZM349.658,24.994H335.07l7.394-21.05Z\"\n          transform=\"translate(157.419 401.566)\"\n          fill=\"#a8a8a8\"\n        ></path>\n        <g\n          id=\"Grupo_1237\"\n          data-name=\"Grupo 1237\"\n          transform=\"translate(518 307.26)\"\n        >\n          <path\n            id=\"Caminho_132\"\n            data-name=\"Caminho 132\"\n            d=\"M276.665,279.579V244.641H254.529v135.72h22.135V301.714h22.042L311.4,279.579Z\"\n            transform=\"translate(117.787 -200.582)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_133\"\n            data-name=\"Caminho 133\"\n            d=\"M460.674,279.544a50.156,50.156,0,0,0-28.292,8.679V244.607H410.247v135.72h22.135V330.876a28.874,28.874,0,0,1,27.734-29.19,28.26,28.26,0,0,1,28.79,28.254v50.387h22.135v-49.05c0-27.709-22.653-51.716-50.365-51.732\"\n            transform=\"translate(230.958 -200.607)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_134\"\n            data-name=\"Caminho 134\"\n            d=\"M236.808,264.6A50.4,50.4,0,1,0,287.2,315a50.4,50.4,0,0,0-50.4-50.4m3.673,78.424a28.27,28.27,0,1,1,24.355-24.358,28.271,28.271,0,0,1-24.355,24.358\"\n            transform=\"translate(67.949 -185.647)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_135\"\n            data-name=\"Caminho 135\"\n            d=\"M196.675,303.934A50.4,50.4,0,1,0,147.5,365.393H172.05l12.69-22.139H147.5a28.264,28.264,0,1,1,26.038-39.32c.192.453.338.93.508,1.383H147.5a9.682,9.682,0,0,0,0,19.364h49.447a50.3,50.3,0,0,0-.27-20.747\"\n            transform=\"translate(2.904 -185.671)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_136\"\n            data-name=\"Caminho 136\"\n            d=\"M385.676,303.934A50.4,50.4,0,1,0,336.5,365.393h24.55l12.709-22.138H336.5a28.264,28.264,0,1,1,26.038-39.321c.189.453.338.93.505,1.383H336.5a9.682,9.682,0,1,0,0,19.364h49.447a50.253,50.253,0,0,0-.266-20.747\"\n            transform=\"translate(140.546 -185.671)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <path\n            id=\"Caminho_137\"\n            data-name=\"Caminho 137\"\n            d=\"M375.375,315a28.285,28.285,0,0,1,28.273-28.27h19.937l12.69-22.129H403.648a50.389,50.389,0,1,0,0,100.778l19.937,0,12.69-22.126H403.648A28.268,28.268,0,0,1,375.375,315\"\n            transform=\"translate(189.621 -185.65)\"\n            fill=\"#b0b0b5\"\n          ></path>\n          <rect\n            id=\"Ret\\xE2ngulo_757\"\n            data-name=\"Ret\\xE2ngulo 757\"\n            width=\"22.135\"\n            height=\"135.72\"\n            transform=\"translate(216.234 44)\"\n            fill=\"#b0b0b5\"\n          ></rect>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: FeatureSobreSistemaService }, { type: FeatureModuleStateService }]; }, { getVersaoSobreSistema: [{
            type: Input
        }], getTotalAcessosSobreSistema: [{
            type: Input
        }], showNovidadesVersao: [{
            type: Input
        }], clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], urlNovidades: [{
            type: Input
        }] }); })();

const isRebrandingActive = () => !(window.location.hostname.includes('.iss.elotech.com.br') || window.location.hostname.includes('.oxy.elotech.com.br'));
const shouldRenderNewTheme = () => isRebrandingActive()
    ? window.localStorage.getItem('new-theme') === 'true'
    : false;
const switchTheme = () => {
    window.localStorage.setItem('new-theme', String(true));
    window.location.reload();
};

class FeatureUserComponent {
    constructor(featureModuleStateService, authParams, authHttp) {
        this.featureModuleStateService = featureModuleStateService;
        this.authParams = authParams;
        this.authHttp = authHttp;
        this.showMinhaConta = true;
        this.showCreateUser = false;
        this.logout = new EventEmitter();
        this.routeMe = '/me';
        this.renderParametros = true;
        this.usuarioLogado = true;
        this.showCompetencia = true;
        this.toggled = false;
        this.goMinhaContaFunction = this.goMinhaConta();
    }
    ngOnInit() {
        this.loadUser();
        this.handleUserStateObserver();
        this.getEntidadeCompetencia();
    }
    onLogout() {
        this.logout.emit();
    }
    onChangeTheme() {
        switchTheme();
    }
    isRebrandingActive() {
        return isRebrandingActive();
    }
    shouldRenderParametros() {
        return this.usuarioLogado && this.renderParametros;
    }
    goMinhaConta() {
        if (this.goMinhaContaFunction) {
            return (window.location.href = this.goMinhaContaFunction());
        }
    }
    callTour() {
        this.featureModuleStateService.tourCaller.emit();
    }
    onChangeEntidade() {
        this.featureModuleStateService.alternateStatus('user');
        this.featureModuleStateService.alternateStatus('configuracaoEntidade');
    }
    onClickSobreSistema() {
        this.featureModuleStateService.alternateStatus('sobreSistema');
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents &&
                parents.length > 0 &&
                parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map((parent) => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('features-usuario')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.toggled)
                this.featureModuleStateService.hideMenu('user');
        }
    }
    static notUserButton(event) {
        if (event.target.className.indexOf) {
            return event.target.className.indexOf('user') < 0;
        }
    }
    loadUser() {
        if (this.getUsuarioLogado) {
            this.getUsuarioLogado.then((profile) => (this.usuario = { nome: profile.name }));
        }
        else {
            this.authParams.onLoginObservers.subscribe((logged) => {
                if (logged) {
                    this.authHttp.getUsuarioLogado().subscribe((user) => {
                        this.usuario = user;
                    });
                }
                else {
                    this.usuario = null;
                }
            });
        }
    }
    handleUserStateObserver() {
        this.featureModuleStateService.userVisibleObserver.subscribe((value) => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
    getEntidadeCompetencia() {
        if (this.authHttp.getUsuarioInfo()) {
            const { entidadePadrao, exercicioPadrao, mesPadrao, } = this.authHttp.getUsuarioInfo();
            if (entidadePadrao && exercicioPadrao && mesPadrao) {
                this.entidadePadrao = entidadePadrao.nome;
                this.competenciaExercicioPadrao = `${mesPadrao + '/' + exercicioPadrao}`;
            }
        }
    }
}
FeatureUserComponent.ɵfac = function FeatureUserComponent_Factory(t) { return new (t || FeatureUserComponent)(ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService), ɵngcc0.ɵɵdirectiveInject(AuthParams), ɵngcc0.ɵɵdirectiveInject(AbstractAuthHttp)); };
FeatureUserComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeatureUserComponent, selectors: [["feature-user"]], hostBindings: function FeatureUserComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FeatureUserComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { showMinhaConta: "showMinhaConta", showCreateUser: "showCreateUser", routeMe: "routeMe", renderParametros: "renderParametros", usuarioLogado: "usuarioLogado", showCompetencia: "showCompetencia", goMinhaContaFunction: "goMinhaContaFunction", routeCreateUser: "routeCreateUser", getUsuarioLogado: "getUsuarioLogado" }, outputs: { logout: "logout" }, decls: 15, vars: 10, consts: [[1, "features-user", "auto-height", "usuario"], [1, "title"], [1, "user-actions"], ["class", "features-section", 4, "ngIf"], [3, "click", 4, "ngIf"], ["routerLink", "/auth", 4, "ngIf"], [3, "title", "click", 4, "ngIf"], [3, "click"], [1, "fa", "fa-info-circle", "icon"], ["class", "logout", 3, "click", 4, "ngIf"], [1, "features-section"], ["aria-hidden", "true", "focusable", "false", "data-prefix", "fas", "data-icon", "plane-departure", "role", "img", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 640 512", 1, "svg-inline--fa", "fa-plane-departure", "fa-w-20", "Icon-sc-26zt4v-0", "kjHNoM", "icon"], ["fill", "currentColor", "d", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"], ["id", "tour"], ["aria-hidden", "true", "focusable", "false", "data-prefix", "fas", "data-icon", "user", "role", "img", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 448 512", 1, "svg-inline--fa", "fa-user", "fa-w-14", "icon"], ["fill", "currentColor", "d", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"], ["id", "userName"], ["routerLink", "/auth"], [1, "fa", "fa-sign-in", "icon"], [3, "title", "click"], ["aria-hidden", "true", "focusable", "false", "data-prefix", "fas", "data-icon", "building", "role", "img", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 448 512", 1, "svg-inline--fa", "fa-building", "fa-w-14", "icon"], ["fill", "currentColor", "d", "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"], [1, "nowrap"], ["aria-hidden", "true", "focusable", "false", "data-prefix", "fas", "data-icon", "calendar-alt", "role", "img", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 448 512", 1, "svg-inline--fa", "fa-calendar-alt", "fa-w-14", "icon"], ["fill", "currentColor", "d", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"], [1, "logout", 3, "click"], [1, "fa", "fa-sign-out", "icon"]], template: function FeatureUserComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵtext(2, "Ajustes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "ul", 2);
        ɵngcc0.ɵɵtemplate(4, FeatureUserComponent_li_4_Template, 2, 0, "li", 3);
        ɵngcc0.ɵɵtemplate(5, FeatureUserComponent_li_5_Template, 6, 0, "li", 4);
        ɵngcc0.ɵɵtemplate(6, FeatureUserComponent_li_6_Template, 7, 1, "li", 4);
        ɵngcc0.ɵɵtemplate(7, FeatureUserComponent_a_7_Template, 4, 0, "a", 5);
        ɵngcc0.ɵɵtemplate(8, FeatureUserComponent_li_8_Template, 2, 0, "li", 3);
        ɵngcc0.ɵɵtemplate(9, FeatureUserComponent_li_9_Template, 7, 2, "li", 6);
        ɵngcc0.ɵɵtemplate(10, FeatureUserComponent_li_10_Template, 7, 1, "li", 4);
        ɵngcc0.ɵɵelementStart(11, "li", 7);
        ɵngcc0.ɵɵlistener("click", function FeatureUserComponent_Template_li_click_11_listener() { return ctx.onClickSobreSistema(); });
        ɵngcc0.ɵɵelement(12, "i", 8);
        ɵngcc0.ɵɵtext(13, "Sobre o sistema ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, FeatureUserComponent_li_14_Template, 3, 0, "li", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado && ctx.usuario);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado && !ctx.usuario);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.shouldRenderParametros());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.shouldRenderParametros());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.shouldRenderParametros() && ctx.showCompetencia);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado && ctx.usuario);
    } }, directives: [ɵngcc2.NgIf, ɵngcc6.RouterLinkWithHref], encapsulation: 2 });
FeatureUserComponent.ctorParameters = () => [
    { type: FeatureModuleStateService },
    { type: AuthParams },
    { type: AbstractAuthHttp }
];
FeatureUserComponent.propDecorators = {
    showMinhaConta: [{ type: Input }],
    showCreateUser: [{ type: Input }],
    logout: [{ type: Output }],
    routeMe: [{ type: Input }],
    routeCreateUser: [{ type: Input }],
    getUsuarioLogado: [{ type: Input }],
    renderParametros: [{ type: Input }],
    usuarioLogado: [{ type: Input }],
    showCompetencia: [{ type: Input }],
    goMinhaContaFunction: [{ type: Input }],
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureUserComponent, [{
        type: Component,
        args: [{
                selector: 'feature-user',
                template: "<div class=\"features-user auto-height usuario\" [class.active]=\"toggled\">\n  <h2 class=\"title\">Ajustes</h2>\n  <ul class=\"user-actions\">\n    <li *ngIf=\"usuarioLogado\" class=\"features-section\">Minha Conta</li>\n    <li *ngIf=\"usuarioLogado\" (click)=\"callTour()\">\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"plane-departure\"\n        class=\"svg-inline--fa fa-plane-departure fa-w-20 Icon-sc-26zt4v-0 kjHNoM icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 640 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z\"\n        ></path>\n      </svg>\n      <article id=\"tour\"><label>Fazer o tour novamente.</label></article>\n    </li>\n    <li (click)=\"goMinhaConta()\" *ngIf=\"usuarioLogado && usuario\">\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"user\"\n        class=\"svg-inline--fa fa-user fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z\"\n        ></path>\n      </svg>\n      <article id=\"userName\"><label>Usu\u00E1rio</label>{{ usuario?.nome }}</article>\n    </li>\n\n    <a routerLink=\"/auth\" *ngIf=\"usuarioLogado && !usuario\"> \n      <li>\n          <i class=\"fa fa-sign-in icon\"></i> Login\n      </li>\n    </a>\n\n    <li *ngIf=\"shouldRenderParametros()\" class=\"features-section\">\n      Par\u00E2metros\n    </li>\n    <li\n      *ngIf=\"shouldRenderParametros()\"\n      title=\"{{ entidadePadrao }}\"\n      (click)=\"onChangeEntidade()\"\n    >\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"building\"\n        class=\"svg-inline--fa fa-building fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z\"\n        ></path>\n      </svg>\n      <article class=\"nowrap\">\n        <label>Entidade</label>{{ entidadePadrao }}\n      </article>\n    </li>\n    <li\n      *ngIf=\"shouldRenderParametros() && showCompetencia\"\n      (click)=\"onChangeEntidade()\"\n    >\n      <svg\n        aria-hidden=\"true\"\n        focusable=\"false\"\n        data-prefix=\"fas\"\n        data-icon=\"calendar-alt\"\n        class=\"svg-inline--fa fa-calendar-alt fa-w-14 icon\"\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 448 512\"\n      >\n        <path\n          fill=\"currentColor\"\n          d=\"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z\"\n        ></path>\n      </svg>\n      <article class=\"nowrap\">\n        <label>Compet\u00EAncia</label>{{ competenciaExercicioPadrao }}\n      </article>\n    </li>\n    <li  (click)=\"onClickSobreSistema()\">\n      <i class=\"fa fa-info-circle icon\"></i>Sobre o sistema\n    </li>\n    <li class=\"logout\" (click)=\"onLogout()\" *ngIf=\"usuarioLogado && usuario\">\n      <i class=\"fa fa-sign-out icon\"></i>Sair\n    </li>\n  </ul>\n</div>\n"
            }]
    }], function () { return [{ type: FeatureModuleStateService }, { type: AuthParams }, { type: AbstractAuthHttp }]; }, { showMinhaConta: [{
            type: Input
        }], showCreateUser: [{
            type: Input
        }], logout: [{
            type: Output
        }], routeMe: [{
            type: Input
        }], renderParametros: [{
            type: Input
        }], usuarioLogado: [{
            type: Input
        }], showCompetencia: [{
            type: Input
        }], goMinhaContaFunction: [{
            type: Input
        }], clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], routeCreateUser: [{
            type: Input
        }], getUsuarioLogado: [{
            type: Input
        }] }); })();

class UrlUtils {
    static getMinhaContaUrl() {
        const windowRef = WindowService.getWindow();
        const minhaContaUrl = windowRef.location.href.indexOf('localhost') > -1 || windowRef.location.href.indexOf('localnet') > -1
            ? `${windowRef.location.protocol}//localhost:3050`
            : `${windowRef.location.origin}/minha-conta`;
        return `${minhaContaUrl}?referrer=${encodeURIComponent(document.title)}&referrer_uri=${encodeURIComponent(windowRef.location.href)}`;
    }
    static getTenant() {
        const windowRef = WindowService.getWindow();
        const hostname = windowRef.location.hostname;
        return hostname.substr(0, hostname.includes('.') ? hostname.indexOf('.') : hostname.length);
    }
}

class FeaturesGroupComponent {
    constructor() {
        this.logout = new EventEmitter();
        this.onGetExercicios = new EventEmitter();
        this.onGetCompetencias = new EventEmitter();
        this.onCompetenciaSelecionada = new EventEmitter();
        this.configuracaoEntidade = [];
        this.showMinhaConta = true;
        this.routeMe = '/me';
        this.showCreateUser = false;
        this.showCompetencia = true;
        this.showExercicio = true;
        this.configuracaoEntidadeKeycloak = false;
        this.showNotificationReport = false;
        this.activeDataOperacaoField = false;
        this.renderParametros = true;
        this.showModulos = true;
        this.goMinhaContaFunction = this.goMinhaConta();
        this.usuarioLogado = true;
        this.getVersaoSobreSistema = undefined;
        this.getTotalAcessosSobreSistema = undefined;
        this.showNovidadesVersao = false;
        this.urlNovidades = '';
    }
    onLogout() {
        this.logout.emit();
    }
    getExercicios(entidade) {
        this.onGetExercicios.emit(entidade);
    }
    getCompetencias(object) {
        this.onGetCompetencias.emit({ exercicio: object.exercicio, entidade: object.entidade });
    }
    competenciaSelecionada(object) {
        this.onCompetenciaSelecionada.emit(object);
    }
    goMinhaConta() {
        return () => UrlUtils.getMinhaContaUrl();
    }
}
FeaturesGroupComponent.ɵfac = function FeaturesGroupComponent_Factory(t) { return new (t || FeaturesGroupComponent)(); };
FeaturesGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeaturesGroupComponent, selectors: [["elo-features-group"]], inputs: { configuracaoEntidade: "configuracaoEntidade", showMinhaConta: "showMinhaConta", routeMe: "routeMe", showCreateUser: "showCreateUser", showCompetencia: "showCompetencia", showExercicio: "showExercicio", configuracaoEntidadeKeycloak: "configuracaoEntidadeKeycloak", showNotificationReport: "showNotificationReport", activeDataOperacaoField: "activeDataOperacaoField", renderParametros: "renderParametros", showModulos: "showModulos", goMinhaContaFunction: "goMinhaContaFunction", usuarioLogado: "usuarioLogado", getVersaoSobreSistema: "getVersaoSobreSistema", getTotalAcessosSobreSistema: "getTotalAcessosSobreSistema", showNovidadesVersao: "showNovidadesVersao", urlNovidades: "urlNovidades", usuario: "usuario", contribuinte: "contribuinte", routeCreateUser: "routeCreateUser", getUsuarioLogado: "getUsuarioLogado" }, outputs: { logout: "logout", onGetExercicios: "onGetExercicios", onGetCompetencias: "onGetCompetencias", onCompetenciaSelecionada: "onCompetenciaSelecionada" }, decls: 11, vars: 21, consts: [[1, "features-group"], [4, "ngIf"], [3, "showMinhaConta", "routeMe", "getUsuarioLogado", "showCreateUser", "showCompetencia", "routeCreateUser", "renderParametros", "goMinhaContaFunction", "usuarioLogado", "logout"], [3, "configuracaoEntidade", "showCompetencia", "showExercicio", "onGetExercicios", "onCompetenciaSelecionada", "onGetCompetencias", 4, "ngIf"], [3, "configuracaoEntidade", "activeDataOperacaoField", "onGetExercicios", "onGetCompetencias", 4, "ngIf"], [3, "contribuinte", 4, "ngIf"], [3, "getVersaoSobreSistema", "getTotalAcessosSobreSistema", "showNovidadesVersao", "urlNovidades"], [3, "configuracaoEntidade", "showCompetencia", "showExercicio", "onGetExercicios", "onCompetenciaSelecionada", "onGetCompetencias"], [3, "configuracaoEntidade", "activeDataOperacaoField", "onGetExercicios", "onGetCompetencias"], [3, "contribuinte"]], template: function FeaturesGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FeaturesGroupComponent_feature_modules_1_Template, 1, 0, "feature-modules", 1);
        ɵngcc0.ɵɵtemplate(2, FeaturesGroupComponent_feature_notification_2_Template, 1, 0, "feature-notification", 1);
        ɵngcc0.ɵɵelement(3, "feature-acessibilidade");
        ɵngcc0.ɵɵelement(4, "feature-acessibilidade-contraste");
        ɵngcc0.ɵɵtemplate(5, FeaturesGroupComponent_notification_report_jasper_5_Template, 1, 0, "notification-report-jasper", 1);
        ɵngcc0.ɵɵelementStart(6, "feature-user", 2);
        ɵngcc0.ɵɵlistener("logout", function FeaturesGroupComponent_Template_feature_user_logout_6_listener() { return ctx.onLogout(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, FeaturesGroupComponent_feature_configuracao_entidade_7_Template, 1, 3, "feature-configuracao-entidade", 3);
        ɵngcc0.ɵɵtemplate(8, FeaturesGroupComponent_configuracao_entidade_keycloak_8_Template, 1, 2, "configuracao-entidade-keycloak", 4);
        ɵngcc0.ɵɵtemplate(9, FeaturesGroupComponent_feature_contribuinte_9_Template, 1, 1, "feature-contribuinte", 5);
        ɵngcc0.ɵɵelement(10, "feature-user-sobre-sistema", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("new", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado && ctx.showModulos);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNotificationReport);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("showMinhaConta", ctx.showMinhaConta)("routeMe", ctx.routeMe)("getUsuarioLogado", ctx.getUsuarioLogado)("showCreateUser", ctx.showCreateUser)("showCompetencia", ctx.showCompetencia)("routeCreateUser", ctx.routeCreateUser)("renderParametros", ctx.renderParametros)("goMinhaContaFunction", ctx.goMinhaContaFunction)("usuarioLogado", ctx.usuarioLogado);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado && !ctx.configuracaoEntidadeKeycloak && ctx.renderParametros);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado && ctx.configuracaoEntidadeKeycloak);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuarioLogado);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("getVersaoSobreSistema", ctx.getVersaoSobreSistema)("getTotalAcessosSobreSistema", ctx.getTotalAcessosSobreSistema)("showNovidadesVersao", true)("urlNovidades", ctx.urlNovidades);
    } }, directives: function () { return [ɵngcc2.NgIf, FeatureAcessibilidadeComponent, FeatureAcessibilidadeContrasteComponent, FeatureUserComponent, FeatureSobreSistemaComponent, FeatureModulesComponent, FeatureNotificationComponent, NotificationReportJasperComponent, FeatureConfiguracaoEntidadeComponent, ConfiguracaoEntidadeKeycloakComponent, FeatureContribuinteComponent]; }, encapsulation: 2 });
FeaturesGroupComponent.propDecorators = {
    logout: [{ type: Output }],
    onGetExercicios: [{ type: Output }],
    onGetCompetencias: [{ type: Output }],
    onCompetenciaSelecionada: [{ type: Output }],
    configuracaoEntidade: [{ type: Input }],
    usuario: [{ type: Input }],
    showMinhaConta: [{ type: Input }],
    routeMe: [{ type: Input }],
    contribuinte: [{ type: Input }],
    showCreateUser: [{ type: Input }],
    routeCreateUser: [{ type: Input }],
    getUsuarioLogado: [{ type: Input }],
    showCompetencia: [{ type: Input }],
    showExercicio: [{ type: Input }],
    configuracaoEntidadeKeycloak: [{ type: Input }],
    showNotificationReport: [{ type: Input }],
    activeDataOperacaoField: [{ type: Input }],
    renderParametros: [{ type: Input }],
    showModulos: [{ type: Input }],
    goMinhaContaFunction: [{ type: Input }],
    usuarioLogado: [{ type: Input }],
    getVersaoSobreSistema: [{ type: Input }],
    getTotalAcessosSobreSistema: [{ type: Input }],
    showNovidadesVersao: [{ type: Input }],
    urlNovidades: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeaturesGroupComponent, [{
        type: Component,
        args: [{
                selector: 'elo-features-group',
                template: "<div class=\"features-group\" [class.new]=\"true\">\n  <feature-modules *ngIf=\"usuarioLogado && showModulos\"></feature-modules>\n  <feature-notification *ngIf=\"usuarioLogado\"></feature-notification>\n  <feature-acessibilidade></feature-acessibilidade>\n  <feature-acessibilidade-contraste></feature-acessibilidade-contraste>\n  <notification-report-jasper\n    *ngIf=\"showNotificationReport\"\n  ></notification-report-jasper>\n  <feature-user\n    [showMinhaConta]=\"showMinhaConta\"\n    [routeMe]=\"routeMe\"\n    [getUsuarioLogado]=\"getUsuarioLogado\"\n    (logout)=\"onLogout()\"\n    [showCreateUser]=\"showCreateUser\"\n    [showCompetencia]=\"showCompetencia\"\n    [routeCreateUser]=\"routeCreateUser\"\n    [renderParametros]=\"renderParametros\"\n    [goMinhaContaFunction]=\"goMinhaContaFunction\"\n    [usuarioLogado]=\"usuarioLogado\"\n  >\n  </feature-user>\n  <feature-configuracao-entidade\n    *ngIf=\"usuarioLogado && !configuracaoEntidadeKeycloak && renderParametros\"\n    [configuracaoEntidade]=\"configuracaoEntidade\"\n    (onGetExercicios)=\"getExercicios($event)\"\n    (onCompetenciaSelecionada)=\"competenciaSelecionada($event)\"\n    (onGetCompetencias)=\"getCompetencias($event)\"\n    [showCompetencia]=\"showCompetencia\"\n    [showExercicio]=\"showExercicio\"\n  ></feature-configuracao-entidade>\n  <configuracao-entidade-keycloak\n    *ngIf=\"usuarioLogado && configuracaoEntidadeKeycloak\"\n    [configuracaoEntidade]=\"configuracaoEntidade\"\n    (onGetExercicios)=\"getExercicios($event)\"\n    (onGetCompetencias)=\"getCompetencias($event)\"\n    [activeDataOperacaoField]=\"activeDataOperacaoField\"\n  >\n  </configuracao-entidade-keycloak>\n  <feature-contribuinte\n    *ngIf=\"usuarioLogado\"\n    [contribuinte]=\"contribuinte\"\n  ></feature-contribuinte>\n  <feature-user-sobre-sistema\n    [getVersaoSobreSistema]=\"getVersaoSobreSistema\"\n    [getTotalAcessosSobreSistema]=\"getTotalAcessosSobreSistema\"\n    [showNovidadesVersao]=\"true\"\n    [urlNovidades]=\"urlNovidades\"\n  >\n  </feature-user-sobre-sistema>\n</div>\n"
            }]
    }], function () { return []; }, { logout: [{
            type: Output
        }], onGetExercicios: [{
            type: Output
        }], onGetCompetencias: [{
            type: Output
        }], onCompetenciaSelecionada: [{
            type: Output
        }], configuracaoEntidade: [{
            type: Input
        }], showMinhaConta: [{
            type: Input
        }], routeMe: [{
            type: Input
        }], showCreateUser: [{
            type: Input
        }], showCompetencia: [{
            type: Input
        }], showExercicio: [{
            type: Input
        }], configuracaoEntidadeKeycloak: [{
            type: Input
        }], showNotificationReport: [{
            type: Input
        }], activeDataOperacaoField: [{
            type: Input
        }], renderParametros: [{
            type: Input
        }], showModulos: [{
            type: Input
        }], goMinhaContaFunction: [{
            type: Input
        }], usuarioLogado: [{
            type: Input
        }], getVersaoSobreSistema: [{
            type: Input
        }], getTotalAcessosSobreSistema: [{
            type: Input
        }], showNovidadesVersao: [{
            type: Input
        }], urlNovidades: [{
            type: Input
        }], usuario: [{
            type: Input
        }], contribuinte: [{
            type: Input
        }], routeCreateUser: [{
            type: Input
        }], getUsuarioLogado: [{
            type: Input
        }] }); })();

class JasperService {
    constructor(authResourcesConfig, httpClient, eloNotificationService) {
        this.authResourcesConfig = authResourcesConfig;
        this.httpClient = httpClient;
        this.eloNotificationService = eloNotificationService;
        this.reports = [];
        this.onChangeReport = new Subject();
        this.onChangeObservable = this.onChangeReport.asObservable();
        this.sessionActive = false;
    }
    executeReport(request) {
        const headers = new HttpHeaders()
            .append('Content-Type', 'application/x-www-form-urlencoded')
            .append('Accept', 'application/xml');
        return this.httpClient.post('/jasperserver/rest_v2/login?j_username=jasperadmin&j_password=jasperadmin', null, { headers: headers, observe: 'response' }) // TODO INCLUDE LOGIN SSO
            .pipe(map(resp => {
            if (resp.url.includes('error')) {
                throw 'login error!';
            }
        }), mergeMap(() => this.searchRequestWithTenant(request).pipe(mergeMap(useTenant => this.internalExecuteReport(request, useTenant, false)
            .pipe(map((resp) => `${JasperService.EXECUTION_URL}/${resp.requestId}/exports/${resp.exports[0].id}/outputResource`))))));
    }
    executeAsyncReport(reportName, request, callback) {
        iif(() => this.sessionActive, of(''), this.login()).pipe(switchMap(() => this.searchRequestWithTenant(request).pipe(mergeMap(useTenant => this.internalExecuteReport(request, useTenant, true))))).subscribe((resp) => {
            this.eloNotificationService.info(`${reportName} está sendo gerado`, 'Verifique a fila de relatórios.');
            this.addAsyncReport(resp, reportName, callback);
        });
    }
    getRequestReportOutputURL(requestID, exportID) {
        return `${JasperService.EXECUTION_URL}/${requestID}/exports/${exportID}/outputResource`;
    }
    requestReportOutput(requestID, exportID) {
        return this.httpClient.get(this.getRequestReportOutputURL(requestID, exportID), { observe: 'response', responseType: 'arraybuffer' });
    }
    clearReports() {
        this.reports = this.reports.filter(r => r.status === 'execution');
        this.onChangeReport.next(this.reports);
    }
    login() {
        const headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded')
            .append('Accept', 'application/json');
        return this.httpClient.post('/jasperserver/rest_v2/login?j_username=jasperadmin&j_password=jasperadmin', null, { headers: headers, observe: 'response' }) // TODO INCLUDE LOGIN SSO
            .pipe(map(resp => {
            if (resp.url.includes('error')) {
                this.sessionActive = false;
                throw 'login error!';
            }
            this.sessionActive = true;
            this.subscriptionInterval = interval(900000).pipe(switchMap(() => this.serveInfo())).subscribe();
        }));
    }
    polling() {
        const validStatus = ['queued', 'execution'];
        this.subscriptionPolling = interval(1000)
            .pipe(takeWhile(() => this.reports.filter(r => validStatus.includes(r.status)).length > 0)).subscribe(() => this.reports.filter(r => r.status !== 'ready' && r.status !== 'failed').forEach(r => {
            this.httpClient.get(`${JasperService.EXECUTION_URL}/${r.requestId}`, { headers: new HttpHeaders({ 'Accept': 'application/json' }) })
                .subscribe((result) => {
                r.status = result && result.status;
                if (r.status === 'ready') {
                    this.eloNotificationService.success(`${r.reportName} foi concluído`, 'Verifique a fila de relatórios.');
                }
                if (r.status === 'failed') {
                    let errorMessage = { message: '' };
                    try {
                        errorMessage = JSON.parse(result.errorDescriptor.message);
                    }
                    catch (_a) {
                        errorMessage = { message: result.errorDescriptor.message };
                    }
                    this.eloNotificationService.error(`${r.reportName}`, errorMessage.message);
                    r.messageError = `Falha na geração: ${errorMessage.message}`;
                }
                this.onChangeReport.next(this.reports);
            }, () => {
                r.status = 'error';
                r.messageError = 'Não foi possível gerar, tente novamente.';
            });
        }));
    }
    getJasperRequestUriParamsFrom(request) {
        const indexLast = request.uri.lastIndexOf('/');
        return { folder: request.uri.substr(0, indexLast), file: request.uri.substr(indexLast + 1) };
    }
    searchRequestWithTenant(request) {
        const jasperRequestUriParams = this.getJasperRequestUriParamsFrom(request);
        const tenant = UrlUtils.getTenant();
        return this.httpClient
            .get(`${JasperService.SEARCH_URL}?folderUri=${jasperRequestUriParams.folder}&q=${jasperRequestUriParams.file}.${tenant}`, { observe: 'response' })
            .pipe(map(resp => resp.status === 200));
    }
    internalExecuteReport(request, useTenant, async) {
        const headersExecute = new HttpHeaders().append('X-REMOTE-DOMAIN', '1');
        const tenant = UrlUtils.getTenant();
        return this.httpClient.post(JasperService.EXECUTION_URL, {
            reportUnitUri: useTenant ? `${request.uri}.${tenant}` : request.uri,
            outputFormat: request.format,
            async: async,
            parameters: {
                reportParameter: this.mountParams(request.params)
            }
        }, { headers: headersExecute });
    }
    serveInfo() {
        return this.httpClient.get(`${JasperService.SERVER_INFO}`);
    }
    addAsyncReport(response, reportName, callback) {
        this.reports.push(Object.assign(Object.assign({}, response), { reportName, reportDate: `${DateUtils.now()} às ${DateUtils.nowHour()}`, callback }));
        this.polling();
    }
    mountParams(params) {
        const overrideParams = [{ name: 'HOST_ORIGIN', value: location.hostname }];
        if (this.authResourcesConfig.isDev) {
            overrideParams.push({ name: 'EUREKA_HOST', value: location.protocol + '//' + this.authResourcesConfig.eurekaHost + ':8761' });
        }
        return [...params, ...overrideParams].map(p => ({ name: p.name, value: [p.value] }));
    }
}
JasperService.ɵfac = function JasperService_Factory(t) { return new (t || JasperService)(ɵngcc0.ɵɵinject(AUTH_RESOURCES_CONFIG), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(EloNotificationService)); };
JasperService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: JasperService, factory: JasperService.ɵfac });
JasperService.EXECUTION_URL = '/jasperserver/rest_v2/reportExecutions';
JasperService.SERVER_INFO = '/jasperserver/rest_v2/serverInfo';
JasperService.SEARCH_URL = '/jasperserver/rest_v2/resources';
JasperService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_RESOURCES_CONFIG,] }] },
    { type: HttpClient$1 },
    { type: EloNotificationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JasperService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_RESOURCES_CONFIG]
            }] }, { type: ɵngcc1.HttpClient }, { type: EloNotificationService }]; }, null); })();

class NotificationReportJasperComponent {
    constructor(featureModuleStateService, jasperService) {
        this.featureModuleStateService = featureModuleStateService;
        this.jasperService = jasperService;
        this.toggled = false;
        this.reports = [];
        this.showDialogAssinar = false;
        this.showDigitalCertificateForm = false;
    }
    ngOnInit() {
        this.handleStateObserver();
        this.jasperService.onChangeObservable.subscribe(reports => this.reports = reports);
    }
    onClick(report) {
        if (report.status === 'ready') {
            if (report.callback) {
                this.clickedReport = report;
                this.showDialogAssinar = true;
            }
            else {
                this.getReport(report);
            }
            this.toggled = false;
        }
    }
    clickedOutside($event) {
        if (this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents && parents.length > 0 && parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value
                    && parent.classList.value.includes('notification-report-jasper')) {
                    isFeatureOpen = true;
                }
            });
            if (!isFeatureOpen && this.toggled)
                this.featureModuleStateService.hideMenu('notificationReportJasper');
        }
    }
    clearReports() {
        this.jasperService.clearReports();
    }
    onAssinarOk() {
        this.showDialogAssinar = false;
        this.showDigitalCertificateForm = true;
    }
    onAssinarCancel() {
        this.showDialogAssinar = false;
        this.getReport(this.clickedReport);
    }
    onAssinar(digitalCertificate) {
        this.jasperService.requestReportOutput(this.clickedReport.requestId, this.clickedReport.exports[0].id)
            .subscribe(response => {
            this.clickedReport.callback(response, digitalCertificate);
            this.showDigitalCertificateForm = false;
        });
    }
    onOpenCloseModal(isOpen) {
        this.showDigitalCertificateForm = isOpen;
    }
    getReport(report) {
        window.open(this.jasperService.getRequestReportOutputURL(report.requestId, report.exports[0].id), '_blank');
    }
    handleStateObserver() {
        this.featureModuleStateService.notificationReportVisibleObserver.subscribe(value => {
            setTimeout(() => {
                if (value === undefined) {
                    this.toggled = !this.toggled;
                }
                else {
                    this.toggled = value;
                }
            }, 50);
        });
    }
}
NotificationReportJasperComponent.ɵfac = function NotificationReportJasperComponent_Factory(t) { return new (t || NotificationReportJasperComponent)(ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService), ɵngcc0.ɵɵdirectiveInject(JasperService)); };
NotificationReportJasperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NotificationReportJasperComponent, selectors: [["notification-report-jasper"]], hostBindings: function NotificationReportJasperComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NotificationReportJasperComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, decls: 11, vars: 9, consts: [[1, "features-notifications", "reduced", "auto-height", "read-options"], [1, "title"], ["id", "clearReports", "class", "read hint clean center-left neutral", 3, "click", 4, "ngIf"], [1, "features-body"], [1, "notification-list"], ["class", "has-icon", 3, "id", "title", "click", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "show", "tittleOk", "tittleCancel", "onOkEvent", "onCancelEvent"], [3, "isOpen", "customWidth", "openClose", 4, "ngIf"], ["id", "clearReports", 1, "read", "hint", "clean", "center-left", "neutral", 3, "click"], [1, "fa", "fa-eraser"], [1, "hint-content"], [1, "has-icon", 3, "id", "title", "click"], [1, "typography-medium"], ["class", "datehour", 4, "ngIf"], [1, "nowrap"], ["class", "fa fa-times-circle negative", 4, "ngIf"], ["class", "fa fa-check-circle positive", 4, "ngIf"], ["class", "fa fa-circle-o-notch fa-spin module-color", 4, "ngIf"], ["class", "fa fa-hourglass-1 module-color", 4, "ngIf"], [1, "datehour"], [1, "fa", "fa-times-circle", "negative"], [1, "fa", "fa-check-circle", "positive"], [1, "fa", "fa-circle-o-notch", "fa-spin", "module-color"], [1, "fa", "fa-hourglass-1", "module-color"], ["id", "reportsEmpty", 1, "nowrap", "center"], [3, "isOpen", "customWidth", "openClose"], [3, "onAssinar"]], template: function NotificationReportJasperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h2", 1);
        ɵngcc0.ɵɵtemplate(2, NotificationReportJasperComponent_div_2_Template, 4, 0, "div", 2);
        ɵngcc0.ɵɵtext(3, " Relat\u00F3rios ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "ul", 4);
        ɵngcc0.ɵɵtemplate(6, NotificationReportJasperComponent_li_6_Template, 13, 12, "li", 5);
        ɵngcc0.ɵɵtemplate(7, NotificationReportJasperComponent_li_7_Template, 3, 0, "li", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "elo-dialog", 7);
        ɵngcc0.ɵɵlistener("onOkEvent", function NotificationReportJasperComponent_Template_elo_dialog_onOkEvent_8_listener() { return ctx.onAssinarOk(); })("onCancelEvent", function NotificationReportJasperComponent_Template_elo_dialog_onCancelEvent_8_listener() { return ctx.onAssinarCancel(); });
        ɵngcc0.ɵɵtext(9, " Deseja assinar o documento com certificado digital?\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, NotificationReportJasperComponent_elo_modal_10_Template, 2, 2, "elo-modal", 8);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.toggled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.reports.length);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.reports);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.reports.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("show", ctx.showDialogAssinar)("tittleOk", "Sim")("tittleCancel", "N\u00E3o");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDigitalCertificateForm);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc2.NgForOf, DialogComponent, EloModalComponent, DigitalCertificateComponent]; }, encapsulation: 2 });
NotificationReportJasperComponent.ctorParameters = () => [
    { type: FeatureModuleStateService },
    { type: JasperService }
];
NotificationReportJasperComponent.propDecorators = {
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationReportJasperComponent, [{
        type: Component,
        args: [{
                selector: 'notification-report-jasper',
                template: "<div class=\"features-notifications reduced auto-height read-options\" [class.active]=\"toggled\">\n\n  <h2 class=\"title\">\n\n    <div id=\"clearReports\" *ngIf=\"reports.length\" class=\"read hint clean center-left neutral\" (click)=\"clearReports()\">\n      <em class=\"fa fa-eraser\"></em>\n      <div class=\"hint-content\">Limpar notifica\u00E7\u00F5es</div>\n    </div>\n\n    Relat\u00F3rios\n  </h2>\n\n  <div class=\"features-body\">\n    <ul class=\"notification-list\">\n      <li *ngFor=\"let report of reports\" class=\"has-icon\" id=\"report_{{report.requestId}}\" (click)=\"onClick(report)\"\n        title=\"{{report.messageError ? report.messageError : report.reportName}}\">\n        <div class=\"typography-medium\">{{report?.reportName}}</div>\n        <div class=\"datehour\" *ngIf=\"report?.reportDate\">\n          <span>{{report?.reportDate}}</span>\n        </div>\n        <article class=\"nowrap\">\n          <p *ngIf=\"report.status === 'error' || report.status === 'failed'\">\n            Falha\n          </p>\n          <p *ngIf=\"report.status === 'ready'\">\n            Click para baixar\n          </p>\n          <p *ngIf=\"report.status === 'execution'\">\n            Executando\n          </p>\n          <p *ngIf=\"report.status === 'queued'\">\n            Aguardando Execu\u00E7\u00E3o\n          </p>\n        </article>\n        <em class=\"fa fa-times-circle negative\" *ngIf=\"report.status === 'error' || report.status === 'failed'\"></em>\n        <em class=\"fa fa-check-circle positive\" *ngIf=\"report.status === 'ready'\"></em>\n        <em class=\"fa fa-circle-o-notch fa-spin module-color\" *ngIf=\"report.status === 'execution'\"></em>\n        <em class=\"fa fa-hourglass-1 module-color\" *ngIf=\"report.status === 'queued'\"></em>\n      </li>\n      <li *ngIf=\"!reports.length\">\n        <article id=\"reportsEmpty\" class=\"nowrap center\"> Nenhum relat\u00F3rio dispon\u00EDvel. </article>\n      </li>\n    </ul>\n  </div>\n</div>\n\n<elo-dialog [show]=\"showDialogAssinar\" [tittleOk]=\"'Sim'\" [tittleCancel]=\"'N\u00E3o'\" (onOkEvent)=\"onAssinarOk()\"\n  (onCancelEvent)=\"onAssinarCancel()\">\n  Deseja assinar o documento com certificado digital?\n</elo-dialog>\n\n<elo-modal *ngIf=\"showDigitalCertificateForm\" [isOpen]=\"showDigitalCertificateForm\"\n  (openClose)=\"onOpenCloseModal($event)\" [customWidth]=\"'30%'\">\n  <digital-certificate (onAssinar)=\"onAssinar($event)\"></digital-certificate>\n</elo-modal>"
            }]
    }], function () { return [{ type: FeatureModuleStateService }, { type: JasperService }]; }, { clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

class MonthNamePipe {
    constructor() {
        this.datePipe = new DatePipe('pt');
    }
    transform(value) {
        if (value < 1 || value > 12) {
            return '';
        }
        return StringUtils.capitalizeEachWord(this.datePipe.transform(new Date(2017, value - 1, 1), 'MMMM'));
    }
}
MonthNamePipe.ɵfac = function MonthNamePipe_Factory(t) { return new (t || MonthNamePipe)(); };
MonthNamePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "monthname", type: MonthNamePipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MonthNamePipe, [{
        type: Pipe,
        args: [{
                name: 'monthname'
            }]
    }], function () { return []; }, null); })();

class MonthNamePipeModule {
}
MonthNamePipeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MonthNamePipeModule });
MonthNamePipeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MonthNamePipeModule_Factory(t) { return new (t || MonthNamePipeModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MonthNamePipeModule, { declarations: function () { return [MonthNamePipe]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [MonthNamePipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MonthNamePipeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [MonthNamePipe],
                exports: [MonthNamePipe]
            }]
    }], null, null); })();

class DigitalCertificateComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.onAssinar = new EventEmitter();
        this.createForm();
    }
    assinar() {
        this.onAssinar.emit(this.form.value);
    }
    createForm() {
        this.form = this.formBuilder.group({
            path: ['/A1_PMPG_2020.pfx', Validators.required],
            alias: ['a1_pmpg_2020', Validators.required],
            password: ['123456', Validators.required]
        });
    }
}
DigitalCertificateComponent.ɵfac = function DigitalCertificateComponent_Factory(t) { return new (t || DigitalCertificateComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
DigitalCertificateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DigitalCertificateComponent, selectors: [["digital-certificate"]], outputs: { onAssinar: "onAssinar" }, decls: 14, vars: 3, consts: [[3, "formGroup"], ["hasForm", "true", 1, "panel", 3, "title"], [1, "row"], ["label", "Local do certificado", "column", "12"], ["id", "path", "formControlName", "path", "maxlength", "255", "placeholder", "Informe o local do certificado", "formControlValidationMsg", ""], ["label", "Alias", "column", "6"], ["id", "alias", "formControlName", "alias", "maxlength", "255", "placeholder", "Informe o alias", "formControlValidationMsg", ""], ["label", "Senha", "column", "6"], ["id", "password", "formControlName", "password", "type", "password", "maxlength", "255", "placeholder", "Informe a senha", "formControlValidationMsg", "", 1, "password"], ["column", "12", 1, "pull-right"], ["id", "btnAssinar", "type", "button", 1, "btn", "module-color", "icon-left", "mb-xs", "inline", 3, "disabled", "click"]], template: function DigitalCertificateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "elo-panel", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "elo-form-label-column", 3);
        ɵngcc0.ɵɵelement(4, "input", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵelementStart(6, "elo-form-label-column", 5);
        ɵngcc0.ɵɵelement(7, "input", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "elo-form-label-column", 7);
        ɵngcc0.ɵɵelement(9, "input", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 2);
        ɵngcc0.ɵɵelementStart(11, "elo-form-label-column", 9);
        ɵngcc0.ɵɵelementStart(12, "button", 10);
        ɵngcc0.ɵɵlistener("click", function DigitalCertificateComponent_Template_button_click_12_listener() { return ctx.assinar(); });
        ɵngcc0.ɵɵtext(13, " Assinar ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", "Certificado Digital");
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵproperty("disabled", ctx.form.invalid);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, PanelComponent, FormLabelColumnComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.MaxLengthValidator, FormControlValidationMsgDirective], encapsulation: 2 });
DigitalCertificateComponent.ctorParameters = () => [
    { type: FormBuilder }
];
DigitalCertificateComponent.propDecorators = {
    onAssinar: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DigitalCertificateComponent, [{
        type: Component,
        args: [{
                selector: 'digital-certificate',
                template: "<div [formGroup]=\"form\">\n  <elo-panel class=\"panel\" hasForm=\"true\" [title]=\"'Certificado Digital'\">\n\n    <div class=\"row\">\n      <elo-form-label-column label=\"Local do certificado\" column=\"12\">\n        <input id=\"path\" formControlName=\"path\" maxlength=\"255\" placeholder=\"Informe o local do certificado\" formControlValidationMsg>\n      </elo-form-label-column>\n    </div>\n\n    <div class=\"row\">\n      <elo-form-label-column label=\"Alias\" column=\"6\">\n        <input id=\"alias\" formControlName=\"alias\" maxlength=\"255\" placeholder=\"Informe o alias\" formControlValidationMsg>\n      </elo-form-label-column>\n\n      <elo-form-label-column label=\"Senha\" column=\"6\">\n        <input id=\"password\" formControlName=\"password\" class=\"password\" type=\"password\" maxlength=\"255\" \n          placeholder=\"Informe a senha\" formControlValidationMsg>\n      </elo-form-label-column>\n    </div>\n\n    <div class=\"row\">\n      <elo-form-label-column column=\"12\" class=\"pull-right\">\n        <button id=\"btnAssinar\" class=\"btn module-color icon-left mb-xs inline\" type=\"button\" (click)=\"assinar()\" [disabled]=\"form.invalid\">\n          Assinar\n        </button>\n      </elo-form-label-column>\n    </div>\n\n  </elo-panel>\n</div>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { onAssinar: [{
            type: Output
        }] }); })();

class DigitalCertificateModule {
}
DigitalCertificateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DigitalCertificateModule });
DigitalCertificateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DigitalCertificateModule_Factory(t) { return new (t || DigitalCertificateModule)(); }, imports: [[
            CommonModule$1,
            PanelModule,
            FormsModule,
            ReactiveFormsModule,
            FormControlValidationMsgModule,
            FormLabelColumnModule,
            DirectivesModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DigitalCertificateModule, { declarations: function () { return [DigitalCertificateComponent]; }, imports: function () { return [CommonModule$1, PanelModule, FormsModule,
        ReactiveFormsModule, FormControlValidationMsgModule, FormLabelColumnModule, DirectivesModule]; }, exports: function () { return [DigitalCertificateComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DigitalCertificateModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    PanelModule,
                    FormsModule,
                    ReactiveFormsModule,
                    FormControlValidationMsgModule,
                    FormLabelColumnModule,
                    DirectivesModule
                ],
                declarations: [DigitalCertificateComponent],
                exports: [DigitalCertificateComponent]
            }]
    }], null, null); })();

class EloNotificationComponent {
    constructor(eloNotificationService, _zone) {
        this.eloNotificationService = eloNotificationService;
        this._zone = _zone;
        this.notifications = [];
        this.timeOut = 5000;
        this.eloNotificationService.notificationObservers.subscribe(notification => {
            this._zone.run(() => {
                this.notifications.push(notification);
                of(notification).pipe(delay(this.timeOut)).subscribe(notification => this.removeNotification(notification));
            });
        });
    }
    removeNotification(notification) {
        this.notifications.splice(this.notifications.indexOf(notification), 1);
    }
}
EloNotificationComponent.ɵfac = function EloNotificationComponent_Factory(t) { return new (t || EloNotificationComponent)(ɵngcc0.ɵɵdirectiveInject(EloNotificationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
EloNotificationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloNotificationComponent, selectors: [["elo-notification"]], inputs: { timeOut: "timeOut" }, decls: 2, vars: 1, consts: [[1, "notification-box", 2, "z-index", "999999"], ["class", "notification-box-iten open", 3, "positive", "negative", "neutral", 4, "ngFor", "ngForOf"], [1, "notification-box-iten", "open"], [1, "close", 3, "click"], ["id", "idNotificationBoxTitle", 1, "notification-box-title"], ["id", "idNotificationBoxText", 1, "notification-box-text"]], template: function EloNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, EloNotificationComponent_div_1_Template, 6, 8, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.notifications);
    } }, directives: [ɵngcc2.NgForOf], encapsulation: 2 });
EloNotificationComponent.ctorParameters = () => [
    { type: EloNotificationService },
    { type: NgZone }
];
EloNotificationComponent.propDecorators = {
    timeOut: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloNotificationComponent, [{
        type: Component,
        args: [{
                selector: 'elo-notification',
                template: "<div class=\"notification-box\" style=\"z-index: 999999\">\n  <div *ngFor=\"let notification of notifications\" [class.positive]=\"notification.type === 0\"\n    [class.negative]=\"notification.type === 1\" [class.neutral]=\"notification.type === 2\"\n    class=\"notification-box-iten open\">\n    <span class=\"close\" (click)=\"removeNotification(notification)\"></span>\n\n    <h1 class=\"notification-box-title\" id=\"idNotificationBoxTitle\">\n      {{notification.title}}\n    </h1>\n    <p class=\"notification-box-text\" id=\"idNotificationBoxText\">\n      {{notification.content}}\n    </p>\n  </div>\n</div>"
            }]
    }], function () { return [{ type: EloNotificationService }, { type: ɵngcc0.NgZone }]; }, { timeOut: [{
            type: Input
        }] }); })();

class EloNotificationsModule {
}
EloNotificationsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloNotificationsModule });
EloNotificationsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloNotificationsModule_Factory(t) { return new (t || EloNotificationsModule)(); }, providers: [EloNotificationService], imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloNotificationsModule, { declarations: function () { return [EloNotificationComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [EloNotificationComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloNotificationsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [EloNotificationComponent],
                providers: [EloNotificationService],
                exports: [EloNotificationComponent]
            }]
    }], null, null); })();

class FeaturesGroupModule {
}
FeaturesGroupModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FeaturesGroupModule });
FeaturesGroupModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FeaturesGroupModule_Factory(t) { return new (t || FeaturesGroupModule)(); }, providers: [ListaModulosService, ConfiguracaoEntidadeKeycloakService, FeatureSobreSistemaService], imports: [[
            CommonModule$1,
            MonthNamePipeModule,
            HttpClientModule,
            DigitalCertificateModule,
            DialogModule,
            RouterModule,
            EloModalModule,
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            EloNotificationsModule,
            DatePickerModule,
            PipeModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FeaturesGroupModule, { declarations: function () { return [FeaturesGroupComponent, FeatureUserComponent, FeatureConfiguracaoEntidadeComponent, FeatureNotificationComponent, ConfiguracaoEntidadeKeycloakComponent, FeatureModulesComponent, FeatureContribuinteComponent, FeatureAcessibilidadeComponent, FeatureAcessibilidadeContrasteComponent, NotificationReportJasperComponent, FeatureSobreSistemaComponent]; }, imports: function () { return [CommonModule$1, MonthNamePipeModule, HttpClientModule, DigitalCertificateModule, DialogModule, RouterModule, EloModalModule, BrowserModule,
        FormsModule,
        ReactiveFormsModule, EloNotificationsModule, DatePickerModule, PipeModule]; }, exports: function () { return [FeaturesGroupComponent, FeatureModulesComponent, FeatureUserComponent, FeatureConfiguracaoEntidadeComponent, ConfiguracaoEntidadeKeycloakComponent, FeatureNotificationComponent, FeatureContribuinteComponent, FeatureAcessibilidadeComponent, FeatureAcessibilidadeContrasteComponent, NotificationReportJasperComponent, FeatureSobreSistemaComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeaturesGroupModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    MonthNamePipeModule,
                    HttpClientModule,
                    DigitalCertificateModule,
                    DialogModule,
                    RouterModule,
                    EloModalModule,
                    BrowserModule,
                    FormsModule,
                    ReactiveFormsModule,
                    EloNotificationsModule,
                    DatePickerModule,
                    PipeModule
                ],
                declarations: [
                    FeaturesGroupComponent,
                    FeatureUserComponent,
                    FeatureConfiguracaoEntidadeComponent,
                    FeatureNotificationComponent,
                    ConfiguracaoEntidadeKeycloakComponent,
                    FeatureModulesComponent,
                    FeatureContribuinteComponent,
                    FeatureAcessibilidadeComponent,
                    FeatureAcessibilidadeContrasteComponent,
                    NotificationReportJasperComponent,
                    FeatureSobreSistemaComponent,
                ],
                providers: [ListaModulosService, ConfiguracaoEntidadeKeycloakService, FeatureSobreSistemaService],
                exports: [
                    FeaturesGroupComponent,
                    FeatureModulesComponent,
                    FeatureUserComponent,
                    FeatureConfiguracaoEntidadeComponent,
                    ConfiguracaoEntidadeKeycloakComponent,
                    FeatureNotificationComponent,
                    FeatureContribuinteComponent,
                    FeatureAcessibilidadeComponent,
                    FeatureAcessibilidadeContrasteComponent,
                    NotificationReportJasperComponent,
                    FeatureSobreSistemaComponent,
                ]
            }]
    }], null, null); })();

class FileUploadComponent {
    constructor(eloNotificationService) {
        this.eloNotificationService = eloNotificationService;
        this.requiredMessage = '(requerido)';
        this.invalid = false;
        this.invalidMessage = 'Tipo do arquivo não permitido';
        this.fileSelected = null;
        this.allowedFileType = [];
        this.required = false;
        this.maxLengthNameFile = 28;
        this.multipartForm = false;
        this.defaultMessage = 'Clique ou arraste para anexar';
        this.onChangeFile = new EventEmitter();
        this.onChange = null;
        this.onTouched = null;
    }
    ngOnInit() {
        this.showRequiredMessage = this.required;
    }
    handleInputChange(event) {
        const file = event.target.files[0];
        if (file) {
            let name = file.name;
            let extension = name.substr(name.lastIndexOf('.') + 1);
            if (this.allowedFileType.length) {
                let allowFileTypeFormatted = this.formatAllowedFileType();
                let isSuccess = this.allowedFileType.indexOf(extension) > -1;
                if (!isSuccess) {
                    this.eloNotificationService.error('Tipo de arquivo não permitido!', 'Tipos aceitos: ' + allowFileTypeFormatted);
                    this.invalid = true;
                    this.clear();
                    return;
                }
            }
            let reader = new FileReader();
            reader.onloadend = () => {
                let name = file.name;
                this.fileSelected = {};
                this.fileSelected.name = name;
                this.fileSelected.fileNameFormated = name && name.length > this.maxLengthNameFile ?
                    this.formatString(name) : name;
                const result = reader.result;
                this.fileSelected.file = result.substring(result.indexOf(',') + 1, result.length);
                this.showRequiredMessage = (this.required &&
                    this.fileSelected.name.toString().length <= 0);
                if (this.multipartForm) {
                    this.emitOnChangeFile(file);
                }
                else {
                    this.emitOnChangeFile(this.fileSelected);
                }
            };
            this.reset();
            reader.readAsDataURL(file);
        }
    }
    formatString(nameFile) {
        let extension = nameFile.substr(nameFile.lastIndexOf('.') + 1);
        return nameFile.substr(0, (this.maxLengthNameFile - extension.length)) + '.' + extension;
    }
    formatAllowedFileType() {
        let allowedFileTypeFormatted = '';
        this.allowedFileType.map((type, index) => {
            if (index === 0) {
                allowedFileTypeFormatted += type;
            }
            else if (index === this.allowedFileType.length - 1) {
                allowedFileTypeFormatted += ' e ' + type + '.';
            }
            else {
                allowedFileTypeFormatted = allowedFileTypeFormatted ? allowedFileTypeFormatted += ', ' + type : type;
            }
        });
        return allowedFileTypeFormatted;
    }
    clear() {
        const hasFileSelected = !!this.fileSelected;
        this.showRequiredMessage = this.required;
        this.fileSelected = null;
        this.fileInput.nativeElement.value = '';
        if (hasFileSelected) {
            this.emitOnChangeFile(this.fileSelected);
        }
    }
    reset() {
        this.invalid = false;
    }
    writeValue(obj) {
        if (obj) {
            this.fileSelected = obj;
        }
        else {
            this.fileSelected = null;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    emitOnChangeFile(value) {
        this.onChange(value);
        this.onChangeFile.emit(value);
    }
}
FileUploadComponent.ɵfac = function FileUploadComponent_Factory(t) { return new (t || FileUploadComponent)(ɵngcc0.ɵɵdirectiveInject(EloNotificationService)); };
FileUploadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileUploadComponent, selectors: [["file-upload"]], viewQuery: function FileUploadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c47, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { allowedFileType: "allowedFileType", required: "required", maxLengthNameFile: "maxLengthNameFile", multipartForm: "multipartForm", defaultMessage: "defaultMessage", showRequiredMessage: "showRequiredMessage" }, outputs: { onChangeFile: "onChangeFile" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: FileUploadComponent }
        ])], decls: 6, vars: 8, consts: [[1, "file-uploader"], ["type", "file", "id", "inputFile", 1, "file-uploader-input", 3, "title", "change"], ["file", ""], ["for", "inputFile", 1, "input"], ["for", "inputFile", 1, "file-uploader-icon", 3, "click"], ["class", "help-message", 4, "ngIf"], [1, "help-message"]], template: function FileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("change", function FileUploadComponent_Template_input_change_1_listener($event) { return ctx.handleInputChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "label", 3);
        ɵngcc0.ɵɵelementStart(4, "label", 4);
        ɵngcc0.ɵɵlistener("click", function FileUploadComponent_Template_label_click_4_listener() { return ctx.clear(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, FileUploadComponent_span_5_Template, 2, 1, "span", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("error", ctx.invalid)("onselect", ctx.fileSelected);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ctx.fileSelected ? ctx.fileSelected.fileNameFormated : ctx.defaultMessage);
        ɵngcc0.ɵɵattribute("data-title", ctx.fileSelected ? ctx.fileSelected.fileNameFormated : ctx.defaultMessage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("data-title", ctx.fileSelected ? ctx.fileSelected.fileNameFormated : ctx.defaultMessage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRequiredMessage || ctx.invalid);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
FileUploadComponent.ctorParameters = () => [
    { type: EloNotificationService }
];
FileUploadComponent.propDecorators = {
    showRequiredMessage: [{ type: Input }],
    fileInput: [{ type: ViewChild, args: ['file', { static: true },] }],
    allowedFileType: [{ type: Input }],
    required: [{ type: Input }],
    maxLengthNameFile: [{ type: Input }],
    multipartForm: [{ type: Input }],
    defaultMessage: [{ type: Input }],
    onChangeFile: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileUploadComponent, [{
        type: Component,
        args: [{
                selector: 'file-upload',
                template: "<div class=\"file-uploader\" [class.error]=\"invalid\" [class.onselect]=\"fileSelected\">\n    <input #file type=\"file\" class=\"file-uploader-input\" id=\"inputFile\" (change)=\"handleInputChange($event)\" [attr.data-title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\" [title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\">\n    <label\n        for=\"inputFile\"\n        class=\"input\"\n        [attr.data-title]=\"fileSelected ? fileSelected.fileNameFormated : defaultMessage\"\n    ></label>\n    <label for=\"inputFile\" class=\"file-uploader-icon\" (click)=\"clear()\"></label>\n</div>\n<span class=\"help-message\" *ngIf=\"showRequiredMessage || invalid\"> {{ invalid ? invalidMessage : showRequiredMessage ? requiredMessage : '' }} </span>\n",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: FileUploadComponent }
                ]
            }]
    }], function () { return [{ type: EloNotificationService }]; }, { allowedFileType: [{
            type: Input
        }], required: [{
            type: Input
        }], maxLengthNameFile: [{
            type: Input
        }], multipartForm: [{
            type: Input
        }], defaultMessage: [{
            type: Input
        }], onChangeFile: [{
            type: Output
        }], showRequiredMessage: [{
            type: Input
        }], fileInput: [{
            type: ViewChild,
            args: ['file', { static: true }]
        }] }); })();

class FileUploadModule {
}
FileUploadModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FileUploadModule });
FileUploadModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FileUploadModule_Factory(t) { return new (t || FileUploadModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FileUploadModule, { declarations: function () { return [FileUploadComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [FileUploadComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileUploadModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [FileUploadComponent],
                exports: [FileUploadComponent]
            }]
    }], null, null); })();

class FloatButtonComponent {
    constructor() {
        this.hover = false;
    }
    clickMenu() {
        this.hover = !this.hover;
    }
    mouseEnter() {
        if (window.innerWidth > 991)
            this.hover = true;
    }
    mouseLeave() {
        this.hover = false;
    }
}
FloatButtonComponent.ɵfac = function FloatButtonComponent_Factory(t) { return new (t || FloatButtonComponent)(); };
FloatButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FloatButtonComponent, selectors: [["float-button"]], inputs: { hintContent: "hintContent" }, ngContentSelectors: _c0, decls: 5, vars: 3, consts: [["id", "idFloatButton", 1, "btn-save", "vertical-options", 3, "click", "mouseenter", "mouseleave"], [1, "options"], ["type", "button", 1, "btn", "hint", "fa", "fa-ellipsis-v", "module-color", "hideHintOnMobile"], ["class", "hint-content", 4, "ngIf"], [1, "hint-content"]], template: function FloatButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function FloatButtonComponent_Template_div_click_0_listener() { return ctx.clickMenu(); })("mouseenter", function FloatButtonComponent_Template_div_mouseenter_0_listener() { return ctx.mouseEnter(); })("mouseleave", function FloatButtonComponent_Template_div_mouseleave_0_listener() { return ctx.mouseLeave(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 2);
        ɵngcc0.ɵɵtemplate(4, FloatButtonComponent_div_4_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hover", ctx.hover);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hintContent);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
FloatButtonComponent.propDecorators = {
    hintContent: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FloatButtonComponent, [{
        type: Component,
        args: [{
                selector: 'float-button',
                template: "<div id=\"idFloatButton\" class=\"btn-save vertical-options\" (click)=\"clickMenu()\" (mouseenter)='mouseEnter()'\n  (mouseleave)=\"mouseLeave()\" [class.hover]=\"hover\">\n  <div class=\"options\">\n    <ng-content></ng-content>\n  </div>\n  <button class=\"btn hint fa fa-ellipsis-v module-color hideHintOnMobile\" type=\"button\">\n    <div class=\"hint-content\" *ngIf=\"hintContent\">{{ hintContent }}</div>\n  </button>\n</div>"
            }]
    }], function () { return []; }, { hintContent: [{
            type: Input
        }] }); })();

class FloatButtonModule {
}
FloatButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FloatButtonModule });
FloatButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FloatButtonModule_Factory(t) { return new (t || FloatButtonModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FloatButtonModule, { declarations: function () { return [FloatButtonComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [FloatButtonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FloatButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [FloatButtonComponent],
                exports: [FloatButtonComponent]
            }]
    }], null, null); })();

class FloatSidebarService {
    constructor() {
        this.onOpenSideBar = new Subject();
        this.onEventToOpen = this.onOpenSideBar.asObservable();
    }
    openFloatSideBar() {
        this.onOpenSideBar.next();
    }
}
FloatSidebarService.ɵfac = function FloatSidebarService_Factory(t) { return new (t || FloatSidebarService)(); };
FloatSidebarService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FloatSidebarService, factory: FloatSidebarService.ɵfac });
FloatSidebarService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FloatSidebarService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class FloatSideBarComponent {
    constructor(floatSidebarService) {
        this.floatSidebarService = floatSidebarService;
        this.titleDef = '';
        this.icon = '';
        this.active = false;
        this.moving = false;
        this.currentY = 0;
        this.initialY = 0;
        this.initialX = 0;
        this.hasMoved = false;
    }
    ngOnInit() {
        this.floatSidebarService.onEventToOpen.subscribe(() => setTimeout(() => this.active = true, 0));
    }
    showSideBar() {
        if (!this.hasMoved) {
            this.active = !this.active;
        }
        this.hasMoved = false;
    }
    onResize() {
        this.openButton.nativeElement.style.top = '0px';
    }
    mouseDown(e) {
        this.initialX = e.clientX;
        this.initialY = e.clientY;
        this.moving = true;
    }
    mouseMove(e) {
        if (this.moving) {
            e.preventDefault();
            const sidebar = this.floatSidebar.nativeElement;
            if (e.clientY < sidebar.clientHeight + sidebar.offsetTop
                && e.clientX > this.initialX - FloatSideBarComponent.DISTANCIA_MAX_MOUSE
                && e.clientY > sidebar.offsetTop + FloatSideBarComponent.DISTANCIA_MAX_MOUSE) {
                this.currentY = this.initialY - e.clientY;
                this.initialY = e.clientY;
                this._calcularPosicao();
                if (e.clientX !== this.initialX)
                    this.hasMoved = true;
            }
            else {
                this.hasMoved = false;
                this.moving = false;
            }
        }
    }
    onClick(event) {
        if (this.active) {
            const { offsetTop, offsetLeft } = this.floatSidebar.nativeElement;
            const clickedInside = event.clientX + 35 > offsetLeft && event.clientY > offsetTop;
            if (!clickedInside) {
                this.active = false;
            }
        }
    }
    _calcularPosicao() {
        const offsetFinal = (this.openButton.nativeElement.offsetTop - this.currentY);
        const limiteTopo = ((window.innerHeight - 230) / 2) + offsetFinal;
        const limiteRodape = ((window.innerHeight + 130) / 2) + offsetFinal;
        const offSetAnterior = this.openButton.nativeElement.style.top.replace('px', '');
        if (offSetAnterior !== offsetFinal && limiteTopo > 0 && limiteRodape < window.innerHeight) {
            this.openButton.nativeElement.style.top = offsetFinal + 'px';
        }
    }
}
FloatSideBarComponent.ɵfac = function FloatSideBarComponent_Factory(t) { return new (t || FloatSideBarComponent)(ɵngcc0.ɵɵdirectiveInject(FloatSidebarService)); };
FloatSideBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FloatSideBarComponent, selectors: [["float-sidebar"]], viewQuery: function FloatSideBarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c48, true);
        ɵngcc0.ɵɵstaticViewQuery(_c49, true);
        ɵngcc0.ɵɵviewQuery(_c50, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.openButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.floatSidebar = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, hostBindings: function FloatSideBarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function FloatSideBarComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow)("mousemove", function FloatSideBarComponent_mousemove_HostBindingHandler($event) { return ctx.mouseMove($event); }, false, ɵngcc0.ɵɵresolveDocument)("click", function FloatSideBarComponent_click_HostBindingHandler($event) { return ctx.onClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { titleDef: "titleDef", icon: "icon", hintTemplate: "hintTemplate", containerTemplate: "containerTemplate" }, decls: 10, vars: 6, consts: [[1, "float-sidebar"], ["floatSidebar", ""], ["id", "open-button", 1, "float-button", "hint", "center-right", "module-color", 3, "ngClass", "click", "mousedown", "mouseup"], ["openButton", ""], [1, "hint-content"], [4, "ngTemplateOutlet"], [1, "title"], [1, "container"]], template: function FloatSideBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵlistener("click", function FloatSideBarComponent_Template_div_click_2_listener() { return ctx.showSideBar(); })("mousedown", function FloatSideBarComponent_Template_div_mousedown_2_listener($event) { return ctx.mouseDown($event); })("mouseup", function FloatSideBarComponent_Template_div_mouseup_2_listener() { return ctx.moving = false; });
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, FloatSideBarComponent_ng_container_5_Template, 1, 0, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵtemplate(9, FloatSideBarComponent_ng_container_9_Template, 1, 0, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.active);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.icon);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.hintTemplate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.titleDef);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.containerTemplate);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
FloatSideBarComponent.DISTANCIA_MAX_MOUSE = 50;
FloatSideBarComponent.ctorParameters = () => [
    { type: FloatSidebarService }
];
FloatSideBarComponent.propDecorators = {
    titleDef: [{ type: Input }],
    icon: [{ type: Input }],
    hintTemplate: [{ type: Input }],
    containerTemplate: [{ type: Input }],
    openButton: [{ type: ViewChild, args: ['openButton', { static: true },] }],
    floatSidebar: [{ type: ViewChild, args: ['floatSidebar', { static: true },] }],
    container: [{ type: ViewChild, args: ['container',] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }],
    mouseMove: [{ type: HostListener, args: ['document:mousemove', ['$event'],] }],
    onClick: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FloatSideBarComponent, [{
        type: Component,
        args: [{
                selector: 'float-sidebar',
                template: "<div #floatSidebar class=\"float-sidebar\" [class.active]=\"active\">\n  <div id=\"open-button\" #openButton [ngClass]=\"icon\" class=\"float-button hint center-right module-color\"\n    (click)=\"showSideBar()\" (mousedown)=\"mouseDown($event)\" (mouseup)=\"moving = false\">\n    <div class=\"hint-content\">\n      <ng-container *ngTemplateOutlet=\"hintTemplate\"></ng-container>\n    </div>\n  </div>\n  <div class=\"title\">{{ titleDef }}</div>\n  <div class=\"container\">\n    <ng-container *ngTemplateOutlet=\"containerTemplate\"></ng-container>\n  </div>\n</div>"
            }]
    }], function () { return [{ type: FloatSidebarService }]; }, { titleDef: [{
            type: Input
        }], icon: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], mouseMove: [{
            type: HostListener,
            args: ['document:mousemove', ['$event']]
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], hintTemplate: [{
            type: Input
        }], containerTemplate: [{
            type: Input
        }], openButton: [{
            type: ViewChild,
            args: ['openButton', { static: true }]
        }], floatSidebar: [{
            type: ViewChild,
            args: ['floatSidebar', { static: true }]
        }], container: [{
            type: ViewChild,
            args: ['container']
        }] }); })();

class FloatSideBarModule {
}
FloatSideBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FloatSideBarModule });
FloatSideBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FloatSideBarModule_Factory(t) { return new (t || FloatSideBarModule)(); }, providers: [FloatSidebarService], imports: [[CommonModule$1,]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FloatSideBarModule, { declarations: function () { return [FloatSideBarComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [FloatSideBarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FloatSideBarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1,],
                declarations: [FloatSideBarComponent],
                exports: [FloatSideBarComponent],
                providers: [FloatSidebarService]
            }]
    }], null, null); })();

class FooterService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.resource = '/actuator/info';
    }
    findBuildVersion() {
        return this.httpClient.get({ resource: this.resource });
    }
}
FooterService.ɵfac = function FooterService_Factory(t) { return new (t || FooterService)(ɵngcc0.ɵɵinject(HttpClient)); };
FooterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FooterService, factory: FooterService.ɵfac });
FooterService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FooterService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class HeaderTitle {
    toString() {
        let headerTitleToString = '';
        if (this.nomeEntidade) {
            headerTitleToString = headerTitleToString + this.nomeEntidade;
        }
        if (this.competencia) {
            headerTitleToString = headerTitleToString + ' - ' + this.competencia;
        }
        if (this.exercicio) {
            headerTitleToString = headerTitleToString + '/' + this.exercicio;
        }
        return headerTitleToString;
    }
}

class HeaderComponent {
    constructor(featureModuleStateService, sanitizer, httpClient) {
        this.featureModuleStateService = featureModuleStateService;
        this.sanitizer = sanitizer;
        this.httpClient = httpClient;
        this.headerTitle = '';
        this.headerSubtitle = '';
        this.nomeCidadeEntidade = new HeaderTitle();
        this.toggled = false;
        this.visibleUser = false;
        this.visibleContribuinte = false;
        this.visibleConfiguracaoEntidadeMenu = false;
        this.visibleModules = false;
        this.visibleAcessibilidade = false;
        this.visibleNotifications = false;
        this.visibleNotificationsReportJasper = false;
        this.visibleNotificationConfiguracaoEntidade = false;
        this.visibleConfigEntidade = false;
        this.flex = false;
        this.activeOldColor = false;
        this.onClickToToggled = new EventEmitter();
        this.defaultHeaderClickFeature = 'configuracaoEntidade';
        this.logoOxy = false;
        this.fancy = false;
    }
    ngOnInit() {
        if (this.imgModuleRebranding) {
            let httpHeader = new HttpHeaders({
                'Content-Type': 'image/svg+xml'
            });
            this.httpClient.get(this.imgModuleRebranding, { headers: httpHeader, responseType: 'text' }).subscribe(data => {
                this.htmlRender = this.sanitizer.bypassSecurityTrustHtml(data);
            });
        }
    }
    onClickToggledButton() {
        this.onClickToToggled.emit();
    }
    onClick(feature) {
        this.item = feature;
        this.featureModuleStateService.alternateStatus(feature);
    }
    clickedOutside($event) {
        if (this.item) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFeatureOpen = false;
            if (parents && parents.length > 0 && parents[0].localName === 'app-root') {
                isFeatureOpen = true;
            }
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('features')) {
                        isFeatureOpen = true;
                    }
                }
            });
            if (!isFeatureOpen && this.item !== '')
                this.item = '';
        }
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.HttpClient)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["elo-header"]], hostBindings: function HeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function HeaderComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { headerTitle: "headerTitle", headerSubtitle: "headerSubtitle", nomeCidadeEntidade: "nomeCidadeEntidade", toggled: "toggled", visibleUser: "visibleUser", visibleContribuinte: "visibleContribuinte", visibleConfiguracaoEntidadeMenu: "visibleConfiguracaoEntidadeMenu", visibleModules: "visibleModules", visibleAcessibilidade: "visibleAcessibilidade", visibleNotifications: "visibleNotifications", visibleNotificationsReportJasper: "visibleNotificationsReportJasper", visibleNotificationConfiguracaoEntidade: "visibleNotificationConfiguracaoEntidade", visibleConfigEntidade: "visibleConfigEntidade", flex: "flex", activeOldColor: "activeOldColor", defaultHeaderClickFeature: "defaultHeaderClickFeature", logoOxy: "logoOxy", fancy: "fancy", brasaoByteArray: "brasaoByteArray", imgModuleMain: "imgModuleMain", imgModule: "imgModule", imgModuleRebranding: "imgModuleRebranding", nameModule: "nameModule" }, outputs: { onClickToToggled: "onClickToToggled" }, decls: 27, vars: 22, consts: [[1, "flex", "header", "sidebar-toggle", "new"], [1, "header-content"], [1, "logo"], ["id", "svgRender", 3, "innerHTML"], ["aria-label", "Expandir menu", 1, "header-toggle-sidebar", "toggle-control", "sidebar-toggle", "hidden-lg", "hidden-md", "hidden-sm", 3, "click"], [1, "fa", "fa-bars"], [1, "header-title", "hidden-xs"], [1, "content-title"], ["class", "brasao", 4, "ngIf"], [3, "click"], ["class", "label", 4, "ngIf"], [1, "header-features"], [3, "active", "click", 4, "ngIf"], ["id", "contribuinte", 3, "click", 4, "ngIf"], ["title", "Acessibilidade", 3, "active", "click", 4, "ngIf"], ["title", "Notifica\u00E7\u00F5es", 3, "active", "click", 4, "ngIf"], ["title", "Ajustes", 3, "active", "click", 4, "ngIf"], ["title", "M\u00F3dulos", 3, "active", "click", 4, "ngIf"], [1, "header-content-mobile", "hidden-lg", "hidden-md", "hidden-sm"], [1, "header-title"], [1, "brasao"], ["id", "headerBrasao", "onerror", "this.style.display='none'", 3, "src"], [1, "label"], [1, "fa", "fa-download"], [1, "hidden-xs"], ["id", "contribuinte", 3, "click"], [1, "contribuinte"], ["title", "Acessibilidade", 3, "click"], [1, "fa", "fa-wheelchair"], ["title", "Notifica\u00E7\u00F5es", 3, "click"], [1, "fa", "fa-bell"], ["title", "Ajustes", 3, "click"], ["aria-hidden", "true", "focusable", "false", "data-prefix", "fas", "data-icon", "tools", "role", "img", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 512 512", 1, "svg-inline--fa", "fa-tools", "fa-w-16", "icon"], ["fill", "currentColor", "d", "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"], ["title", "M\u00F3dulos", 3, "click"], [1, "fa", "fa-th"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "header", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 4);
        ɵngcc0.ɵɵlistener("click", function HeaderComponent_Template_button_click_5_listener() { return ctx.onClickToggledButton(); });
        ɵngcc0.ɵɵelement(6, "em", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵtemplate(9, HeaderComponent_figure_9_Template, 2, 1, "figure", 8);
        ɵngcc0.ɵɵelementStart(10, "span", 9);
        ɵngcc0.ɵɵlistener("click", function HeaderComponent_Template_span_click_10_listener() { return ctx.onClick(ctx.defaultHeaderClickFeature); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵtemplate(12, HeaderComponent_label_12_Template, 2, 1, "label", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "ul", 11);
        ɵngcc0.ɵɵtemplate(14, HeaderComponent_li_14_Template, 4, 2, "li", 12);
        ɵngcc0.ɵɵtemplate(15, HeaderComponent_li_15_Template, 4, 0, "li", 13);
        ɵngcc0.ɵɵtemplate(16, HeaderComponent_li_16_Template, 4, 2, "li", 14);
        ɵngcc0.ɵɵtemplate(17, HeaderComponent_li_17_Template, 4, 2, "li", 15);
        ɵngcc0.ɵɵtemplate(18, HeaderComponent_li_18_Template, 5, 2, "li", 16);
        ɵngcc0.ɵɵtemplate(19, HeaderComponent_li_19_Template, 4, 2, "li", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 18);
        ɵngcc0.ɵɵelementStart(21, "div", 19);
        ɵngcc0.ɵɵelementStart(22, "div", 7);
        ɵngcc0.ɵɵtemplate(23, HeaderComponent_figure_23_Template, 2, 1, "figure", 8);
        ɵngcc0.ɵɵelementStart(24, "span", 9);
        ɵngcc0.ɵɵlistener("click", function HeaderComponent_Template_span_click_24_listener() { return ctx.onClick(ctx.defaultHeaderClickFeature); });
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵtemplate(26, HeaderComponent_label_26_Template, 2, 1, "label", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("fancy", ctx.fancy);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("bg-primary-color", ctx.fancy);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("logo-oxy", ctx.logoOxy);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.htmlRender, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.nameModule, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.brasaoByteArray);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.headerTitle == null ? null : ctx.headerTitle.toString(), " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerSubtitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.visibleNotificationsReportJasper);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.visibleContribuinte);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.visibleAcessibilidade);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.visibleNotifications);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.visibleUser);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.visibleModules);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("bg-primary-color", ctx.fancy);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.brasaoByteArray);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.headerTitle == null ? null : ctx.headerTitle.toString(), " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerSubtitle);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
HeaderComponent.ctorParameters = () => [
    { type: FeatureModuleStateService },
    { type: DomSanitizer },
    { type: HttpClient$1 }
];
HeaderComponent.propDecorators = {
    headerTitle: [{ type: Input }],
    headerSubtitle: [{ type: Input }],
    nomeCidadeEntidade: [{ type: Input }],
    toggled: [{ type: Input }],
    visibleUser: [{ type: Input }],
    visibleContribuinte: [{ type: Input }],
    visibleConfiguracaoEntidadeMenu: [{ type: Input }],
    visibleModules: [{ type: Input }],
    visibleAcessibilidade: [{ type: Input }],
    visibleNotifications: [{ type: Input }],
    visibleNotificationsReportJasper: [{ type: Input }],
    visibleNotificationConfiguracaoEntidade: [{ type: Input }],
    brasaoByteArray: [{ type: Input }],
    visibleConfigEntidade: [{ type: Input }],
    flex: [{ type: Input }],
    activeOldColor: [{ type: Input }],
    onClickToToggled: [{ type: Output }],
    imgModuleMain: [{ type: Input }],
    imgModule: [{ type: Input }],
    imgModuleRebranding: [{ type: Input }],
    nameModule: [{ type: Input }],
    defaultHeaderClickFeature: [{ type: Input }],
    logoOxy: [{ type: Input }],
    fancy: [{ type: Input }],
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'elo-header',
                template: "<header class=\"flex header sidebar-toggle new\" [class.fancy]=\"fancy\">\n  <div class=\"header-content\" [class.bg-primary-color]=\"fancy\">\n    <div class=\"logo\" [class.logo-oxy]=\"logoOxy\">\n      <div id=\"svgRender\" [innerHTML]=\"htmlRender\"></div>\n      {{nameModule}}\n    </div>\n\n    <button class=\"header-toggle-sidebar toggle-control sidebar-toggle hidden-lg hidden-md hidden-sm\"\n      aria-label=\"Expandir menu\" (click)=\"onClickToggledButton()\">\n      <em class=\"fa fa-bars\"></em>\n    </button>\n\n    <div class=\"header-title hidden-xs\">\n      <div class=\"content-title\">\n        <figure *ngIf=\"brasaoByteArray\" class=\"brasao\">\n          <img id=\"headerBrasao\" onerror=\"this.style.display='none'\"\n            src=\"{{ 'data:image/jpg;base64,' + brasaoByteArray }}\" />\n        </figure>\n        <span (click)=\"onClick(defaultHeaderClickFeature)\">{{ headerTitle?.toString() }}\n          <label class=\"label\" *ngIf=\"headerSubtitle\">{{ headerSubtitle }}</label>\n        </span>\n      </div>\n    </div>\n    <ul class=\"header-features\">\n      <li *ngIf=\"visibleNotificationsReportJasper\" [class.active]=\"item==='notificationReportJasper'\"\n        (click)=\"onClick('notificationReportJasper')\"><i class=\"fa fa-download\"></i><small\n          class=\"hidden-xs\">Relat\u00F3rios</small></li>\n      <li *ngIf=\"visibleContribuinte\" id=\"contribuinte\" (click)=\"onClick('contribuinte')\"><i\n          class=\"contribuinte\"></i><small class=\"hidden-xs\">Contribuinte</small></li>\n      <li *ngIf=\"visibleAcessibilidade\" [class.active]=\"item==='acessibilidade'\" title=\"Acessibilidade\"\n        (click)=\"onClick('acessibilidade')\"><i class=\"fa fa-wheelchair\"></i><small\n          class=\"hidden-xs\">Acessibilidade</small></li>\n      <li *ngIf=\"visibleNotifications\" [class.active]=\"item==='notification'\" title=\"Notifica\u00E7\u00F5es\"\n        (click)=\"onClick('notification')\"><i class=\"fa fa-bell\"></i><small class=\"hidden-xs\">Notifica\u00E7\u00F5es</small></li>\n      <li *ngIf=\"visibleUser\" [class.active]=\"item==='user'\" title=\"Ajustes\" (click)=\"onClick('user')\"><svg\n          aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"tools\"\n          class=\"svg-inline--fa fa-tools fa-w-16 icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 512 512\">\n          <path fill=\"currentColor\"\n            d=\"M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z\">\n          </path>\n        </svg><small class=\"hidden-xs\">Ajustes</small></li>\n      <li *ngIf=\"visibleModules\" [class.active]=\"item==='module'\" title=\"M\u00F3dulos\" (click)=\"onClick('module')\"><i\n          class=\"fa fa-th\"></i><small class=\"hidden-xs\">M\u00F3dulos</small></li>\n    </ul>\n  </div>\n\n  <div class=\"header-content-mobile hidden-lg hidden-md hidden-sm\">\n    <div class=\"header-title\">\n      <div class=\"content-title\" [class.bg-primary-color]=\"fancy\">\n        <figure *ngIf=\"brasaoByteArray\" class=\"brasao\">\n          <img id=\"headerBrasao\" onerror=\"this.style.display='none'\"\n            src=\"{{ 'data:image/jpg;base64,' + brasaoByteArray }}\" />\n        </figure>\n        <span (click)=\"onClick(defaultHeaderClickFeature)\">{{ headerTitle?.toString() }}\n          <label class=\"label\" *ngIf=\"headerSubtitle\">{{ headerSubtitle }}</label>\n        </span>\n      </div>\n    </div>\n  </div>\n</header>"
            }]
    }], function () { return [{ type: FeatureModuleStateService }, { type: ɵngcc4.DomSanitizer }, { type: ɵngcc1.HttpClient }]; }, { headerTitle: [{
            type: Input
        }], headerSubtitle: [{
            type: Input
        }], nomeCidadeEntidade: [{
            type: Input
        }], toggled: [{
            type: Input
        }], visibleUser: [{
            type: Input
        }], visibleContribuinte: [{
            type: Input
        }], visibleConfiguracaoEntidadeMenu: [{
            type: Input
        }], visibleModules: [{
            type: Input
        }], visibleAcessibilidade: [{
            type: Input
        }], visibleNotifications: [{
            type: Input
        }], visibleNotificationsReportJasper: [{
            type: Input
        }], visibleNotificationConfiguracaoEntidade: [{
            type: Input
        }], visibleConfigEntidade: [{
            type: Input
        }], flex: [{
            type: Input
        }], activeOldColor: [{
            type: Input
        }], onClickToToggled: [{
            type: Output
        }], defaultHeaderClickFeature: [{
            type: Input
        }], logoOxy: [{
            type: Input
        }], fancy: [{
            type: Input
        }], clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], brasaoByteArray: [{
            type: Input
        }], imgModuleMain: [{
            type: Input
        }], imgModule: [{
            type: Input
        }], imgModuleRebranding: [{
            type: Input
        }], nameModule: [{
            type: Input
        }] }); })();

class HeaderModule {
}
HeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function HeaderModule_Factory(t) { return new (t || HeaderModule)(); }, imports: [[CommonModule$1, HttpClientModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeaderModule, { declarations: function () { return [HeaderComponent]; }, imports: function () { return [CommonModule$1, HttpClientModule]; }, exports: function () { return [HeaderComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, HttpClientModule],
                declarations: [HeaderComponent],
                exports: [HeaderComponent]
            }]
    }], null, null); })();

class ImageUploadComponent {
    constructor(eloNotificationService) {
        this.eloNotificationService = eloNotificationService;
        this.imageSelected = null;
        this.onChange = null;
        this.onTouched = null;
    }
    handleInputChange(event) {
        let extension = event.target.files[0].type;
        let isSuccess = ImageUploadComponent.FILE_TYPES.indexOf(extension) > -1;
        if (!isSuccess) {
            this.eloNotificationService.error('Tipo de arquivo não permitido!', 'Tipos aceitos: jpg, jpeg e png.');
            return;
        }
        const file = event.target.files[0];
        if (this.maxUploadSize && file.size > this.maxUploadSize) {
            this.eloNotificationService.error('Tamanho do arquivo excedido!', this.messageErroMaxUploadSize);
            return;
        }
        let reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            const removedPrefix = result.substring(result.indexOf(',') + 1, result.length);
            this.imageSelected = result;
            this.onChange(removedPrefix);
        };
        reader.readAsDataURL(file);
    }
    clear() {
        this.imageSelected = null;
        this.onChange(this.imageSelected);
        this.file.nativeElement.value = '';
    }
    writeValue(obj) {
        if (obj) {
            this.imageSelected = ImageUploadComponent.BASE64 + obj;
        }
        else {
            this.imageSelected = null;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
}
ImageUploadComponent.ɵfac = function ImageUploadComponent_Factory(t) { return new (t || ImageUploadComponent)(ɵngcc0.ɵɵdirectiveInject(EloNotificationService)); };
ImageUploadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ImageUploadComponent, selectors: [["image-upload"]], viewQuery: function ImageUploadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c47, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.file = _t.first);
    } }, inputs: { maxUploadSize: "maxUploadSize", messageErroMaxUploadSize: "messageErroMaxUploadSize" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: ImageUploadComponent }
        ])], decls: 6, vars: 1, consts: [[1, "image-uploader"], [1, "image-uploader-label"], ["type", "file", "accept", "image/*", 1, "image-uploader-input", 3, "change"], ["file", ""], [1, "image-uploader-remove", 3, "click"], ["class", "image-uploader-image", 3, "src", 4, "ngIf"], [1, "image-uploader-image", 3, "src"]], template: function ImageUploadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "label", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("change", function ImageUploadComponent_Template_input_change_2_listener($event) { return ctx.handleInputChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "em", 4);
        ɵngcc0.ɵɵlistener("click", function ImageUploadComponent_Template_em_click_4_listener() { return ctx.clear(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, ImageUploadComponent_img_5_Template, 1, 1, "img", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageSelected);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
ImageUploadComponent.BASE64 = 'data:image/jpeg;base64,';
ImageUploadComponent.FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
ImageUploadComponent.ctorParameters = () => [
    { type: EloNotificationService }
];
ImageUploadComponent.propDecorators = {
    file: [{ type: ViewChild, args: ['file', { static: true },] }],
    maxUploadSize: [{ type: Input }],
    messageErroMaxUploadSize: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ImageUploadComponent, [{
        type: Component,
        args: [{
                selector: 'image-upload',
                template: "<div class=\"image-uploader\">\n  <label class=\"image-uploader-label\"></label>\n  <input #file type=\"file\" class=\"image-uploader-input\" accept=\"image/*\" (change)=\"handleInputChange($event)\">\n  <em class=\"image-uploader-remove\" (click)=\"clear()\"></em>\n  <img *ngIf=\"imageSelected\" class=\"image-uploader-image\" [src]=\"imageSelected\">\n</div>\n",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: ImageUploadComponent }
                ]
            }]
    }], function () { return [{ type: EloNotificationService }]; }, { file: [{
            type: ViewChild,
            args: ['file', { static: true }]
        }], maxUploadSize: [{
            type: Input
        }], messageErroMaxUploadSize: [{
            type: Input
        }] }); })();

class ImageUploadModule {
}
ImageUploadModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ImageUploadModule });
ImageUploadModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ImageUploadModule_Factory(t) { return new (t || ImageUploadModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ImageUploadModule, { declarations: function () { return [ImageUploadComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [ImageUploadComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ImageUploadModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [ImageUploadComponent],
                exports: [ImageUploadComponent]
            }]
    }], null, null); })();

class InformationComponent {
    constructor() {
        this.condition = true;
        this.type = 'info';
        this.classInformation = '';
        this.buttonName = 'Informação';
        this.enableButton = false;
        this.buttonAction = new EventEmitter();
    }
    get icon() {
        switch (this.type) {
            case 'info':
                return 'fa fa-info-circle';
            case 'positive':
                return 'fa fa-check-circle';
            case 'negative':
                return 'fa fa-times-circle';
            case 'warning':
                return 'fa fa-exclamation-triangle';
            default:
                return 'fa fa-info-circle';
        }
    }
    buttonClick() {
        this.buttonAction.emit();
    }
}
InformationComponent.ɵfac = function InformationComponent_Factory(t) { return new (t || InformationComponent)(); };
InformationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: InformationComponent, selectors: [["elo-information"]], inputs: { condition: "condition", type: "type", classInformation: "classInformation", buttonName: "buttonName", enableButton: "enableButton", title: "title" }, outputs: { buttonAction: "buttonAction" }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [[3, "class", "ngClass", 4, "ngIf"], [3, "ngClass"], ["id", "informationMessageIcon", 1, "icon"], ["id", "informationMessageTitle"], ["id", "informationMessageArea"], ["id", "btnInformation", "class", "btn right module-color", 3, "click", 4, "ngIf"], ["id", "btnInformation", 1, "btn", "right", "module-color", 3, "click"]], template: function InformationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, InformationComponent_div_0_Template, 9, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.condition);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass], encapsulation: 2 });
InformationComponent.propDecorators = {
    title: [{ type: Input }],
    condition: [{ type: Input }],
    type: [{ type: Input }],
    classInformation: [{ type: Input }],
    buttonName: [{ type: Input }],
    enableButton: [{ type: Input }],
    buttonAction: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InformationComponent, [{
        type: Component,
        args: [{
                selector: 'elo-information',
                template: "<div class=\"info primary icon mb-xs {{classInformation}}\" [ngClass]=\"type\" *ngIf=\"condition\">\n\n  <div class=\"icon\" id=\"informationMessageIcon\">\n    <em [ngClass]=\"icon\"></em>\n  </div>\n\n  <article>\n    <h4 id=\"informationMessageTitle\">{{title}}</h4>\n    <div id=\"informationMessageArea\">\n      <ng-content></ng-content>\n    </div>\n  </article>\n\n  <button id=\"btnInformation\" *ngIf=\"enableButton\" class=\"btn right module-color\"\n    (click)=\"buttonClick()\">{{buttonName}}</button>\n\n</div>"
            }]
    }], function () { return []; }, { condition: [{
            type: Input
        }], type: [{
            type: Input
        }], classInformation: [{
            type: Input
        }], buttonName: [{
            type: Input
        }], enableButton: [{
            type: Input
        }], buttonAction: [{
            type: Output
        }], title: [{
            type: Input
        }] }); })();

class InformationModule {
}
InformationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: InformationModule });
InformationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function InformationModule_Factory(t) { return new (t || InformationModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InformationModule, { declarations: function () { return [InformationComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [InformationComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InformationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [InformationComponent],
                declarations: [InformationComponent]
            }]
    }], null, null); })();

class EloQuickAccessButtonComponent {
}
EloQuickAccessButtonComponent.ɵfac = function EloQuickAccessButtonComponent_Factory(t) { return new (t || EloQuickAccessButtonComponent)(); };
EloQuickAccessButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloQuickAccessButtonComponent, selectors: [["elo-quick-access-button"]], inputs: { routerLink: "routerLink", icon: "icon", title: "title" }, decls: 4, vars: 5, consts: [[1, "col-sm-3", "col-md-2"], [3, "routerLink"]], template: function EloQuickAccessButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "li", 0);
        ɵngcc0.ɵɵelementStart(1, "a", 1);
        ɵngcc0.ɵɵelement(2, "em");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("routerLink", ctx.routerLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
    } }, directives: [ɵngcc6.RouterLinkWithHref], encapsulation: 2 });
EloQuickAccessButtonComponent.propDecorators = {
    routerLink: [{ type: Input }],
    icon: [{ type: Input }],
    title: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloQuickAccessButtonComponent, [{
        type: Component,
        args: [{
                selector: 'elo-quick-access-button',
                template: "<li class=\"col-sm-3 col-md-2\">\n    <a routerLink=\"{{routerLink}}\"><em class=\"{{icon}}\"></em>{{title}}</a>\n</li>\n"
            }]
    }], null, { routerLink: [{
            type: Input
        }], icon: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();

class EloQuickAccessButtonModule {
}
EloQuickAccessButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloQuickAccessButtonModule });
EloQuickAccessButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloQuickAccessButtonModule_Factory(t) { return new (t || EloQuickAccessButtonModule)(); }, providers: [], imports: [[CommonModule$1, RouterModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloQuickAccessButtonModule, { declarations: function () { return [EloQuickAccessButtonComponent]; }, imports: function () { return [CommonModule$1, RouterModule]; }, exports: function () { return [EloQuickAccessButtonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloQuickAccessButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, RouterModule],
                declarations: [EloQuickAccessButtonComponent],
                exports: [EloQuickAccessButtonComponent],
                providers: []
            }]
    }], null, null); })();

class ModalFormInsertComponent {
    constructor(eloNotificationService) {
        this.eloNotificationService = eloNotificationService;
        this.isOpen = false;
        this.openClose = new EventEmitter();
    }
    ngOnInit() {
        this.subcrition = this.eloNotificationService.notificationObservers.subscribe(notification => {
            if (notification.type === NotificationType.positive && this.isOpen) {
                this.onOpenClose();
            }
        });
    }
    onOpenClose() {
        this.openClose.emit();
    }
    ngOnDestroy() {
        this.subcrition.unsubscribe();
    }
}
ModalFormInsertComponent.ɵfac = function ModalFormInsertComponent_Factory(t) { return new (t || ModalFormInsertComponent)(ɵngcc0.ɵɵdirectiveInject(EloNotificationService)); };
ModalFormInsertComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalFormInsertComponent, selectors: [["modal-form-insert"]], inputs: { isOpen: "isOpen", crudTemplateRef: "crudTemplateRef" }, outputs: { openClose: "openClose" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "isOpen", "openClose"], [4, "ngTemplateOutlet"]], template: function ModalFormInsertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ModalFormInsertComponent_div_0_Template, 3, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: [ɵngcc2.NgIf, EloModalComponent, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
ModalFormInsertComponent.ctorParameters = () => [
    { type: EloNotificationService }
];
ModalFormInsertComponent.propDecorators = {
    isOpen: [{ type: Input }],
    crudTemplateRef: [{ type: Input }],
    openClose: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalFormInsertComponent, [{
        type: Component,
        args: [{
                selector: 'modal-form-insert',
                template: "<div *ngIf=\"isOpen\">\n  <elo-modal [isOpen]=\"isOpen\" (openClose)=\"onOpenClose()\">\n    <ng-container  *ngTemplateOutlet=\"crudTemplateRef\">\n     </ng-container>\n  </elo-modal>\n</div>\n"
            }]
    }], function () { return [{ type: EloNotificationService }]; }, { isOpen: [{
            type: Input
        }], openClose: [{
            type: Output
        }], crudTemplateRef: [{
            type: Input
        }] }); })();

class ModalFormInsertModule {
}
ModalFormInsertModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ModalFormInsertModule });
ModalFormInsertModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ModalFormInsertModule_Factory(t) { return new (t || ModalFormInsertModule)(); }, imports: [[CommonModule$1, EloModalModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalFormInsertModule, { declarations: function () { return [ModalFormInsertComponent]; }, imports: function () { return [CommonModule$1, EloModalModule]; }, exports: function () { return [ModalFormInsertComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalFormInsertModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, EloModalModule],
                declarations: [ModalFormInsertComponent],
                exports: [ModalFormInsertComponent]
            }]
    }], null, null); })();

class ModalMenuComponent {
    constructor() {
        this.title = 'Informações';
        this.isOpen = false;
        this.openClose = new EventEmitter();
        this.informations = [];
        this.menuOptions = [];
    }
    switchOpenClose() {
        this.isOpen = !this.isOpen;
        this.openClose.emit(this.isOpen);
    }
    addOption(option) {
        this.menuOptions.push(option);
    }
}
ModalMenuComponent.ɵfac = function ModalMenuComponent_Factory(t) { return new (t || ModalMenuComponent)(); };
ModalMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalMenuComponent, selectors: [["elo-modal-menu"]], inputs: { title: "title", isOpen: "isOpen", informations: "informations" }, outputs: { openClose: "openClose" }, decls: 9, vars: 5, consts: [[3, "isOpen", "openClose"], [1, "panel", "panel-menu-opcoes"], [1, "panel-body"], [3, "title", "collapsed"], [1, "opcoes-info"], [4, "ngFor", "ngForOf"], [1, "btn-opcoes-flutuante"], ["id", "options", 1, "row"], ["class", "col-xs-4", 4, "ngFor", "ngForOf"], [1, "col-xs-4"], [1, "btn", "icon-left", 3, "click"]], template: function ModalMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "elo-modal", 0);
        ɵngcc0.ɵɵlistener("openClose", function ModalMenuComponent_Template_elo_modal_openClose_0_listener() { return ctx.switchOpenClose(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "elo-panel-expansive", 3);
        ɵngcc0.ɵɵelementStart(4, "ul", 4);
        ɵngcc0.ɵɵtemplate(5, ModalMenuComponent_li_5_Template, 5, 2, "li", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "ul", 7);
        ɵngcc0.ɵɵtemplate(8, ModalMenuComponent_li_8_Template, 4, 4, "li", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("isOpen", ctx.isOpen);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("title", ctx.title);
        ɵngcc0.ɵɵproperty("collapsed", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.informations);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.menuOptions);
    } }, directives: [EloModalComponent, PanelExpansiveComponent, ɵngcc2.NgForOf], encapsulation: 2 });
ModalMenuComponent.propDecorators = {
    title: [{ type: Input }],
    isOpen: [{ type: Input }],
    openClose: [{ type: Output }],
    informations: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalMenuComponent, [{
        type: Component,
        args: [{
                selector: 'elo-modal-menu',
                template: "<elo-modal [isOpen]=\"isOpen\" (openClose)=\"switchOpenClose()\">\n\n  <div class=\"panel panel-menu-opcoes\">\n\n    <div class=\"panel-body\">\n\n      <elo-panel-expansive title=\"{{ title }}\" [collapsed]=\"true\">\n\n        <ul class=\"opcoes-info\">\n          <li *ngFor=\"let item of informations\"><b>{{ item.label }}:</b> <span> {{ item.value }}</span></li>\n        </ul>\n\n      </elo-panel-expansive>\n\n      <div class=\"btn-opcoes-flutuante\">\n\n        <ul id=\"options\" class=\"row\">\n          <li *ngFor=\"let item of menuOptions\" class=\"col-xs-4\">\n            <button class=\"btn icon-left\" (click)=\"item.onClickOption(item)\">\n              <i class=\"{{ item.icon }} module-color\"></i>\n              {{ item.titulo }}\n            </button>\n          </li>\n\n        </ul>\n      </div><!--/btn-opcoes-flutuante-->\n\n    </div><!--/panel-body-->\n\n  </div><!--/panel-->\n\n</elo-modal>\n"
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], isOpen: [{
            type: Input
        }], openClose: [{
            type: Output
        }], informations: [{
            type: Input
        }] }); })();

class ModalMenuOptionComponent {
    constructor(modalMenu) {
        this.onClick = new EventEmitter();
        modalMenu.addOption(this);
    }
    onClickOption(event) {
        this.onClick.emit(event);
    }
}
ModalMenuOptionComponent.ɵfac = function ModalMenuOptionComponent_Factory(t) { return new (t || ModalMenuOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ModalMenuComponent)); };
ModalMenuOptionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalMenuOptionComponent, selectors: [["elo-modal-menu-option"]], inputs: { icon: "icon", titulo: "titulo" }, outputs: { onClick: "onClick" }, decls: 0, vars: 0, template: function ModalMenuOptionComponent_Template(rf, ctx) { }, encapsulation: 2 });
ModalMenuOptionComponent.ctorParameters = () => [
    { type: ModalMenuComponent }
];
ModalMenuOptionComponent.propDecorators = {
    icon: [{ type: Input }],
    titulo: [{ type: Input }],
    onClick: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalMenuOptionComponent, [{
        type: Component,
        args: [{
                selector: 'elo-modal-menu-option',
                template: ''
            }]
    }], function () { return [{ type: ModalMenuComponent }]; }, { onClick: [{
            type: Output
        }], icon: [{
            type: Input
        }], titulo: [{
            type: Input
        }] }); })();

class ModalMenuModule {
}
ModalMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ModalMenuModule });
ModalMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ModalMenuModule_Factory(t) { return new (t || ModalMenuModule)(); }, providers: [], imports: [[CommonModule$1, EloModalModule, PanelExpansiveModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalMenuModule, { declarations: function () { return [ModalMenuComponent, ModalMenuOptionComponent]; }, imports: function () { return [CommonModule$1, EloModalModule, PanelExpansiveModule]; }, exports: function () { return [ModalMenuComponent, ModalMenuOptionComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalMenuModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, EloModalModule, PanelExpansiveModule],
                declarations: [ModalMenuComponent, ModalMenuOptionComponent],
                exports: [ModalMenuComponent, ModalMenuOptionComponent],
                providers: []
            }]
    }], null, null); })();

/**
 * Creates a button of the specified type, with the given classes and text
 *
 * @param button.type The type of button cancel, back, or next
 * @param button.classes Classes to apply to the button
 * @param button.text The text for the button
 * @param button.action The action to call
 */
function makeButton(button) {
    const { classes, disabled, label, secondary, type, text } = button;
    const builtInButtonTypes = ['back', 'cancel', 'next', 'complete'];
    if (!type) {
        return button;
    }
    if (builtInButtonTypes.indexOf(type) === -1) {
        throw new Error(`'type' property must be one of 'back', 'cancel', or 'next'`);
    }
    return {
        action: this[type] && this[type].bind(this),
        classes,
        disabled,
        label,
        secondary,
        text
    };
}

class OnBoardingComponent {
    constructor(_keycloakService, _featureModuleStateService) {
        this._keycloakService = _keycloakService;
        this._featureModuleStateService = _featureModuleStateService;
        this.loadUserProfile = (handler) => {
            const { success, error } = this._keycloakService.getUserProfile();
            if (error) {
                error(msg => {
                    throw msg;
                });
            }
            success(handler);
        };
        this.isPrimeiroAcesso = user => !user.attributes.primeiro_acesso || user.attributes.primeiro_acesso[0] === 'TRUE';
        this.updatePrimeiroAcesso = (user, value) => {
            const newUser = Object.assign(Object.assign({}, user.attributes), { primeiro_acesso: [value] });
            return this._keycloakService.sobrescreverAttributos(newUser)
                .subscribe(_ => undefined);
        };
        this.tour = this._createTour();
    }
    ngOnDestroy() {
        this.tour.cancel();
    }
    ngAfterViewInit() {
        const currSteps = this.steps || steps;
        this.startTourPrimeiroAcesso(currSteps);
        this._featureModuleStateService.tourCaller.subscribe(() => {
            this.startTour(currSteps);
        });
    }
    startTourPrimeiroAcesso(steps) {
        this.loadUserProfile((user) => {
            if (!this.isPrimeiroAcesso(user)) {
                return;
            }
            this.innerStartTour(steps, user);
        });
    }
    startTour(steps) {
        this.loadUserProfile((user) => {
            this.innerStartTour(steps, user);
        });
    }
    innerStartTour(steps, user) {
        if (!steps || !Array.isArray(steps) || steps.length === 0) {
            throw 'Não foi encontrado a variavel steps';
        }
        this._initializeSteps(steps);
        this.tour.once('complete', () => this.updatePrimeiroAcesso(user, 'FALSE'));
        this.tour.start();
    }
    _initializeSteps(steps) {
        steps.forEach((step) => {
            if (step.buttons) {
                step.buttons = step.buttons.map(makeButton.bind(this.tour), this.tour);
            }
            this.tour.addStep(step);
        });
    }
    _createTour() {
        return new Shepherd.Tour({
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true
                }
            },
            exitOnEsc: true,
            useModalOverlay: true
        });
    }
}
OnBoardingComponent.ɵfac = function OnBoardingComponent_Factory(t) { return new (t || OnBoardingComponent)(ɵngcc0.ɵɵdirectiveInject(KeycloakAuthHttp), ɵngcc0.ɵɵdirectiveInject(FeatureModuleStateService)); };
OnBoardingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: OnBoardingComponent, selectors: [["onboarding-component"]], inputs: { steps: "steps" }, decls: 1, vars: 0, template: function OnBoardingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } }, encapsulation: 2 });
OnBoardingComponent.ctorParameters = () => [
    { type: KeycloakAuthHttp },
    { type: FeatureModuleStateService }
];
OnBoardingComponent.propDecorators = {
    steps: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OnBoardingComponent, [{
        type: Component,
        args: [{
                selector: 'onboarding-component',
                template: `<div></div>`
            }]
    }], function () { return [{ type: KeycloakAuthHttp }, { type: FeatureModuleStateService }]; }, { steps: [{
            type: Input
        }] }); })();

class OnBoardingModule {
}
OnBoardingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: OnBoardingModule });
OnBoardingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function OnBoardingModule_Factory(t) { return new (t || OnBoardingModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OnBoardingModule, { declarations: [OnBoardingComponent], exports: [OnBoardingComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OnBoardingModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    OnBoardingComponent,
                ],
                exports: [
                    OnBoardingComponent
                ]
            }]
    }], null, null); })();

class PageCustomizedComponent {
    constructor() {
        this.title = 'Título';
        this.text = 'Texto';
        this.btnName = 'Botão';
        this.icon = 'fa fa-cogs';
        this.btnFunction = null;
    }
    buttonClick() {
        this.btnFunction();
    }
}
PageCustomizedComponent.ɵfac = function PageCustomizedComponent_Factory(t) { return new (t || PageCustomizedComponent)(); };
PageCustomizedComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PageCustomizedComponent, selectors: [["elo-page-customized"]], inputs: { title: "title", text: "text", btnName: "btnName", icon: "icon", btnFunction: "btnFunction" }, decls: 7, vars: 4, consts: [[1, "not-found"], ["id", "page-customized-icon", 3, "ngClass"], ["id", "page-customized-title"], ["id", "page-customized-text"], ["id", "page-customized-btn", "class", "btn module-color icon-right center mt-xs", 3, "click", 4, "ngIf"], ["id", "page-customized-btn", 1, "btn", "module-color", "icon-right", "center", "mt-xs", 3, "click"]], template: function PageCustomizedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "h2", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "small", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, PageCustomizedComponent_button_6_Template, 2, 1, "button", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.text, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.btnFunction);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf], encapsulation: 2 });
PageCustomizedComponent.propDecorators = {
    title: [{ type: Input }],
    text: [{ type: Input }],
    btnName: [{ type: Input }],
    icon: [{ type: Input }],
    btnFunction: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageCustomizedComponent, [{
        type: Component,
        args: [{
                selector: 'elo-page-customized',
                template: "<div class=\"not-found\">\n\t<span id=\"page-customized-icon\" [ngClass]=\"icon\"></span>\n\t<h2 id=\"page-customized-title\">\n\t\t{{ title }}\n\t</h2>\n\t<small id=\"page-customized-text\">\n\t\t{{ text }}\n\t</small>\n\n\t<button *ngIf=\"btnFunction\" (click)=\"buttonClick()\" id=\"page-customized-btn\"\n\t\tclass=\"btn module-color icon-right center mt-xs\">{{btnName}}</button>\n\n</div>"
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], text: [{
            type: Input
        }], btnName: [{
            type: Input
        }], icon: [{
            type: Input
        }], btnFunction: [{
            type: Input
        }] }); })();

class PageCustomizedModule {
}
PageCustomizedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PageCustomizedModule });
PageCustomizedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PageCustomizedModule_Factory(t) { return new (t || PageCustomizedModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageCustomizedModule, { declarations: function () { return [PageCustomizedComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [PageCustomizedComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageCustomizedModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [PageCustomizedComponent],
                exports: [PageCustomizedComponent]
            }]
    }], null, null); })();

class PageBlockedComponent {
}
PageBlockedComponent.ɵfac = function PageBlockedComponent_Factory(t) { return new (t || PageBlockedComponent)(); };
PageBlockedComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PageBlockedComponent, selectors: [["page-blocked"]], decls: 5, vars: 0, consts: [[1, "not-found"], [1, "fa", "fa-ban"]], template: function PageBlockedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵelement(2, "em", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "h2");
        ɵngcc0.ɵɵtext(4, " Desculpe, mas esta p\u00E1gina foi temporariamente bloqueada pelo administrador do sistema. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageBlockedComponent, [{
        type: Component,
        args: [{
                selector: 'page-blocked',
                template: "<div class=\"not-found\">\n  <h1>\n    <em class=\"fa fa-ban\"></em>\n  </h1>\n  <h2>\n    Desculpe, mas esta p\u00E1gina foi temporariamente bloqueada pelo administrador do sistema.\n  </h2>\n</div>\n"
            }]
    }], null, null); })();

class PageBlockedModule {
}
PageBlockedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PageBlockedModule });
PageBlockedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PageBlockedModule_Factory(t) { return new (t || PageBlockedModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageBlockedModule, { declarations: function () { return [PageBlockedComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [PageBlockedComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageBlockedModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [PageBlockedComponent],
                exports: [PageBlockedComponent]
            }]
    }], null, null); })();

class PageNotFoundComponent {
    constructor(_location) {
        this._location = _location;
        this.baseHref = this._location.prepareExternalUrl('');
    }
}
PageNotFoundComponent.ɵfac = function PageNotFoundComponent_Factory(t) { return new (t || PageNotFoundComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Location)); };
PageNotFoundComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PageNotFoundComponent, selectors: [["not-found"]], decls: 11, vars: 1, consts: [[1, "not-found"], [1, "fa", "fa-frown-o"], [3, "href"], [1, "btn", "module-color", "icon-right", "center", "mt-xs"], [1, "fa", "fa-home"]], template: function PageNotFoundComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵelement(2, "em", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "h2");
        ɵngcc0.ɵɵtext(4, " Desculpe, n\u00E3o conseguimos encontrar o que voc\u00EA est\u00E1 procurando. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "small");
        ɵngcc0.ɵɵtext(6, " 404 ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "a", 2);
        ɵngcc0.ɵɵelementStart(8, "button", 3);
        ɵngcc0.ɵɵtext(9, " Volte ao In\u00EDcio ");
        ɵngcc0.ɵɵelement(10, "em", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.baseHref, ɵngcc0.ɵɵsanitizeUrl);
    } }, encapsulation: 2 });
PageNotFoundComponent.ctorParameters = () => [
    { type: Location }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageNotFoundComponent, [{
        type: Component,
        args: [{
                selector: 'not-found',
                template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-frown-o\"></em>\n\t</h1>\n\t<h2>\n\t\tDesculpe, n\u00E3o conseguimos encontrar o que voc\u00EA est\u00E1 procurando.\n\t</h2>\n\t<small>\n\t\t404\n\t</small>\n\t<a href=\"{{baseHref}}\">\n\t\t<button class=\"btn module-color icon-right center mt-xs\">\n\t\t\tVolte ao In\u00EDcio <em class=\"fa fa-home\"></em>\n\t\t</button>\n\t</a>\n</div>"
            }]
    }], function () { return [{ type: ɵngcc2.Location }]; }, null); })();

class PageNotFoundModule {
}
PageNotFoundModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PageNotFoundModule });
PageNotFoundModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PageNotFoundModule_Factory(t) { return new (t || PageNotFoundModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageNotFoundModule, { declarations: function () { return [PageNotFoundComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [PageNotFoundComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageNotFoundModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [PageNotFoundComponent],
                exports: [PageNotFoundComponent]
            }]
    }], null, null); })();

class PageForbiddenComponent {
    constructor(_location) {
        this._location = _location;
        this.baseHref = this._location.prepareExternalUrl('');
    }
}
PageForbiddenComponent.ɵfac = function PageForbiddenComponent_Factory(t) { return new (t || PageForbiddenComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Location)); };
PageForbiddenComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PageForbiddenComponent, selectors: [["page-forbidden"]], decls: 11, vars: 1, consts: [[1, "not-found"], [1, "fa", "fa-lock"], [3, "href"], [1, "btn", "module-color", "icon-right", "center", "mt-xs"], [1, "fa", "fa-home"]], template: function PageForbiddenComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵelement(2, "em", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "h2");
        ɵngcc0.ɵɵtext(4, " Voc\u00EA n\u00E3o possui permiss\u00E3o para acessar esta p\u00E1gina. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "small");
        ɵngcc0.ɵɵtext(6, " 403 ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "a", 2);
        ɵngcc0.ɵɵelementStart(8, "button", 3);
        ɵngcc0.ɵɵtext(9, " Volte ao In\u00EDcio ");
        ɵngcc0.ɵɵelement(10, "em", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.baseHref, ɵngcc0.ɵɵsanitizeUrl);
    } }, encapsulation: 2 });
PageForbiddenComponent.ctorParameters = () => [
    { type: Location }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageForbiddenComponent, [{
        type: Component,
        args: [{
                selector: 'page-forbidden',
                template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-lock\"></em>\n\t</h1>\n\t<h2>\n\t\tVoc\u00EA n\u00E3o possui permiss\u00E3o para acessar esta p\u00E1gina.\n\t</h2>\n\t<small>\n\t\t403\n\t</small>\n\t<a href=\"{{baseHref}}\">\n\t\t<button class=\"btn module-color icon-right center mt-xs\">\n\t\t\tVolte ao In\u00EDcio <em class=\"fa fa-home\"></em>\n\t\t</button>\n\t</a>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc2.Location }]; }, null); })();

class PageForbiddenModule {
}
PageForbiddenModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PageForbiddenModule });
PageForbiddenModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PageForbiddenModule_Factory(t) { return new (t || PageForbiddenModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageForbiddenModule, { declarations: function () { return [PageForbiddenComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [PageForbiddenComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageForbiddenModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [PageForbiddenComponent],
                exports: [PageForbiddenComponent]
            }]
    }], null, null); })();

class PageUnavailableComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
        this.router.navigateByUrl('/unavailable');
    }
}
PageUnavailableComponent.ɵfac = function PageUnavailableComponent_Factory(t) { return new (t || PageUnavailableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router)); };
PageUnavailableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PageUnavailableComponent, selectors: [["page-unavailable"]], decls: 5, vars: 0, consts: [[1, "not-found"], [1, "fa", "fa-exclamation-triangle"]], template: function PageUnavailableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵelement(2, "em", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "h2");
        ɵngcc0.ɵɵtext(4, " Desculpe, esta p\u00E1gina n\u00E3o est\u00E1 dispon\u00EDvel no momento. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
PageUnavailableComponent.ctorParameters = () => [
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageUnavailableComponent, [{
        type: Component,
        args: [{
                selector: 'page-unavailable',
                template: "<div class=\"not-found\">\n\t<h1>\n\t\t<em class=\"fa fa-exclamation-triangle\"></em>\n\t</h1>\n\t<h2>\n\t\tDesculpe, esta p\u00E1gina n\u00E3o est\u00E1 dispon\u00EDvel no momento.\n\t</h2>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc6.Router }]; }, null); })();

class PageUnavailableModule {
}
PageUnavailableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PageUnavailableModule });
PageUnavailableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PageUnavailableModule_Factory(t) { return new (t || PageUnavailableModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageUnavailableModule, { declarations: function () { return [PageUnavailableComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [PageUnavailableComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageUnavailableModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [PageUnavailableComponent],
                exports: [PageUnavailableComponent]
            }]
    }], null, null); })();

class PreviewComponent {
}
PreviewComponent.ɵfac = function PreviewComponent_Factory(t) { return new (t || PreviewComponent)(); };
PreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PreviewComponent, selectors: [["elo-preview"]], inputs: { column: "column", class: "class" }, ngContentSelectors: _c0, decls: 2, vars: 4, template: function PreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate2("preview ", ctx.column, " ", ctx.class, "");
    } }, encapsulation: 2 });
PreviewComponent.propDecorators = {
    column: [{ type: Input }],
    class: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PreviewComponent, [{
        type: Component,
        args: [{
                selector: 'elo-preview',
                template: "<div class=\"preview {{column}} {{class}}\">\n    <ng-content></ng-content>\n</div>\n"
            }]
    }], null, { column: [{
            type: Input
        }], class: [{
            type: Input
        }] }); })();

class PreviewBlockComponent {
}
PreviewBlockComponent.ɵfac = function PreviewBlockComponent_Factory(t) { return new (t || PreviewBlockComponent)(); };
PreviewBlockComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PreviewBlockComponent, selectors: [["elo-preview-block"]], inputs: { title: "title" }, ngContentSelectors: _c0, decls: 5, vars: 1, consts: [[1, "title-block"], [1, "desc"]], template: function PreviewBlockComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "p");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "ul", 1);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
    } }, encapsulation: 2 });
PreviewBlockComponent.propDecorators = {
    title: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PreviewBlockComponent, [{
        type: Component,
        args: [{
                selector: 'elo-preview-block',
                template: "<div class=\"title-block\">\n    <p>{{title}}</p>\n</div>\n\n<ul class=\"desc\">\n   <ng-content></ng-content>\n</ul>\n"
            }]
    }], null, { title: [{
            type: Input
        }] }); })();

class PreviewBlockItemComponent {
}
PreviewBlockItemComponent.ɵfac = function PreviewBlockItemComponent_Factory(t) { return new (t || PreviewBlockItemComponent)(); };
PreviewBlockItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PreviewBlockItemComponent, selectors: [["elo-preview-block-item"]], inputs: { caption: "caption", value: "value" }, decls: 4, vars: 2, template: function PreviewBlockItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "li");
        ɵngcc0.ɵɵelementStart(1, "i");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.caption);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.value, "\n");
    } }, encapsulation: 2 });
PreviewBlockItemComponent.propDecorators = {
    caption: [{ type: Input }],
    value: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PreviewBlockItemComponent, [{
        type: Component,
        args: [{
                selector: 'elo-preview-block-item',
                template: "<li>\n    <i>{{caption}}</i>\n    {{value}}\n</li>"
            }]
    }], null, { caption: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class PreviewModule {
}
PreviewModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PreviewModule });
PreviewModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PreviewModule_Factory(t) { return new (t || PreviewModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PreviewModule, { declarations: function () { return [PreviewComponent, PreviewBlockComponent, PreviewBlockItemComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [PreviewComponent, PreviewBlockComponent, PreviewBlockItemComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PreviewModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [PreviewComponent, PreviewBlockComponent, PreviewBlockItemComponent],
                declarations: [PreviewComponent, PreviewBlockComponent, PreviewBlockItemComponent]
            }]
    }], null, null); })();

class QueryBuilderItemComponent {
    constructor() {
        this.ONLY_NUMBER_LETTER_COMMA_EXP = /[^0-9,a-zA-Z]/g;
        this.queryValue = { 'condition': 'and', 'rules': [] };
        this.config = { fields: {} };
        this.onChangeQueryValue = new EventEmitter();
    }
    onSwitchButton(event, ruleset) {
        ruleset.condition = event.selectedButton.value;
        this.updateQueryValue(this.queryValue);
    }
    updateQueryValue(value) {
        this.onChangeQueryValue.emit(value);
    }
    validateValue(rule) {
        if (this.isKeyboardCharacterValid(rule)) {
            rule.value = rule.value.replace(this.ONLY_NUMBER_LETTER_COMMA_EXP, '');
        }
        this.updateQueryValue(this.queryValue);
    }
    isKeyboardCharacterValid(rule) {
        return rule.value !== undefined;
    }
}
QueryBuilderItemComponent.ɵfac = function QueryBuilderItemComponent_Factory(t) { return new (t || QueryBuilderItemComponent)(); };
QueryBuilderItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: QueryBuilderItemComponent, selectors: [["elo-query-builder-item"]], inputs: { queryValue: "queryValue", config: "config" }, outputs: { onChangeQueryValue: "onChangeQueryValue" }, decls: 6, vars: 3, consts: [[1, "mt-sm"], ["emptyMessage", "A condi\u00E7\u00E3o grupo n\u00E3o pode ser vazia", 3, "ngModel", "config", "ngModelChange"], [4, "queryButtonGroup"], [4, "queryRemoveButton"], [4, "querySwitchGroup"], [4, "queryInput", "queryInputType"], ["id", "buttonAddRuleSet", "type", "button", 1, "btn", "module-color", "inline", "icon-left", 3, "click"], [1, "fa", "fa-plus"], ["id", "buttonAddRule", "type", "button", 1, "btn", "module-color", "inline", "icon-left", 3, "click"], ["id", "buttonRemoveConditionSet", "class", "btn negative inline", "type", "button", 3, "click", 4, "ngIf"], ["id", "buttonRemoveConditionSet", "type", "button", 1, "btn", "negative", "inline", 3, "click"], [1, "fa", "fa-trash"], ["id", "buttonRemoveRule", "type", "button", 1, "btn", "negative", "inline", 3, "click"], [3, "onSelected"], ["title", "E", "value", "and", 3, "selected"], ["title", "Ou", "value", "or", 3, "selected"], ["id", "ruleInput", 2, "margin-top", "10px", "resize", "vertical", 3, "ngModel", "ngModelChange", "keyup"]], template: function QueryBuilderItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "query-builder", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function QueryBuilderItemComponent_Template_query_builder_ngModelChange_1_listener($event) { return ctx.updateQueryValue($event); });
        ɵngcc0.ɵɵtemplate(2, QueryBuilderItemComponent_ng_container_2_Template, 9, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, QueryBuilderItemComponent_ng_container_3_Template, 3, 0, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(4, QueryBuilderItemComponent_ng_container_4_Template, 4, 2, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(5, QueryBuilderItemComponent_ng_container_5_Template, 2, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.queryValue)("config", ctx.config);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("queryInputType", "textarea");
    } }, directives: [ɵngcc8.QueryBuilderComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc8.QueryButtonGroupDirective, ɵngcc8.QueryRemoveButtonDirective, ɵngcc8.QuerySwitchGroupDirective, ɵngcc8.QueryInputDirective, ɵngcc2.NgIf, SwitchButtonComponent, SwitchButtonItemComponent, ɵngcc3.DefaultValueAccessor], styles: ["query-builder .q-tree{padding-left:40px}"], encapsulation: 2 });
QueryBuilderItemComponent.propDecorators = {
    queryValue: [{ type: Input }],
    config: [{ type: Input }],
    onChangeQueryValue: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(QueryBuilderItemComponent, [{
        type: Component,
        args: [{
                encapsulation: ViewEncapsulation.None,
                selector: 'elo-query-builder-item',
                template: "<div class=\"mt-sm\">\n  <query-builder [ngModel]=\"queryValue\" (ngModelChange)=\"updateQueryValue($event)\" [config]=\"config\"\n    emptyMessage=\"A condi\u00E7\u00E3o grupo n\u00E3o pode ser vazia\">\n    <ng-container\n      *queryButtonGroup=\"let ruleset; let addRule=addRule; let addRuleSet=addRuleSet; let removeRuleSet=removeRuleSet\">\n      <div>\n        <button id=\"buttonAddRuleSet\" class=\"btn module-color inline icon-left\" type=\"button\" (click)=\"addRuleSet()\">\n          <em class=\"fa fa-plus\"></em>\n          Grupo\n        </button>\n        <button id=\"buttonAddRule\" class=\"btn module-color inline icon-left\" type=\"button\" (click)=\"addRule()\">\n          <em class=\"fa fa-plus\"></em>\n          Condi\u00E7\u00E3o\n        </button>\n        <button *ngIf=\"removeRuleSet\" id=\"buttonRemoveConditionSet\" class=\"btn negative inline\" type=\"button\"\n          (click)=\"removeRuleSet()\">\n          <em class=\"fa fa-trash\"></em>\n        </button>\n      </div>\n    </ng-container>\n\n    <ng-container *queryRemoveButton=\"let rule; let removeRule=removeRule\">\n      <button id=\"buttonRemoveRule\" class=\"btn negative inline\" type=\"button\" (click)=\"removeRule(rule)\">\n        <em class=\"fa fa-trash\"></em></button>\n    </ng-container>\n\n    <ng-container *querySwitchGroup=\"let ruleset\">\n      <elo-switch-button (onSelected)=\"onSwitchButton($event, ruleset)\">\n        <elo-switch-button-item title=\"E\" value=\"and\" [selected]=\"ruleset?.condition === 'and'\">\n        </elo-switch-button-item>\n        <elo-switch-button-item title=\"Ou\" value=\"or\" [selected]=\"ruleset?.condition === 'or'\">\n        </elo-switch-button-item>\n      </elo-switch-button>\n    </ng-container>\n\n    <ng-container *queryInput=\"let rule; type: 'textarea'\">\n      <textarea id=\"ruleInput\" [(ngModel)]=\"rule.value\" (keyup)=\"validateValue(rule)\"\n        style=\"margin-top: 10px; resize: vertical;\"></textarea>\n\n    </ng-container>\n\n  </query-builder>\n</div>",
                styles: ["query-builder .q-tree{padding-left:40px}"]
            }]
    }], function () { return []; }, { queryValue: [{
            type: Input
        }], config: [{
            type: Input
        }], onChangeQueryValue: [{
            type: Output
        }] }); })();

class QueryBuilderTranslatorComponent {
    constructor() {
        this.queryBuilderValue = '';
        this.createContext = () => ({ queryBuilderValueTranslate: this.queryBuilderValueTranslator });
    }
    static queryBuilderValueTranslator(queryBuilderValue) {
        if (queryBuilderValue) {
            return QueryBuilderTranslatorComponent.internalQueryBuilderValueTranslator(queryBuilderValue.condition, queryBuilderValue.rules);
        }
        return '';
    }
    static internalQueryBuilderValueTranslator(condition, rules) {
        return `(${rules.map(rule => {
            if (rule.condition) {
                return QueryBuilderTranslatorComponent.internalQueryBuilderValueTranslator(rule.condition, rule.rules);
            }
            return `${rule.field.replace(/#\d+/, '')} ${rule.operator} ${rule.value ? rule.value : ''}`;
        }).join(` ${condition === 'and' ? 'e' : 'ou'} `)})`;
    }
    get queryBuilderValueTranslator() {
        return QueryBuilderTranslatorComponent.queryBuilderValueTranslator(this.queryBuilderValue);
    }
}
QueryBuilderTranslatorComponent.ɵfac = function QueryBuilderTranslatorComponent_Factory(t) { return new (t || QueryBuilderTranslatorComponent)(); };
QueryBuilderTranslatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: QueryBuilderTranslatorComponent, selectors: [["elo-query-builder-translator"]], inputs: { queryBuilderValue: "queryBuilderValue", template: "template" }, decls: 1, vars: 2, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function QueryBuilderTranslatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, QueryBuilderTranslatorComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ctx.createContext());
    } }, directives: [ɵngcc2.NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
QueryBuilderTranslatorComponent.propDecorators = {
    queryBuilderValue: [{ type: Input }],
    template: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(QueryBuilderTranslatorComponent, [{
        type: Component,
        args: [{
                selector: 'elo-query-builder-translator',
                template: "<ng-container *ngTemplateOutlet=\"template;context:createContext()\"></ng-container>",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { queryBuilderValue: [{
            type: Input
        }], template: [{
            type: Input
        }] }); })();

class EnumService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
    }
    getSelectItems(resource) {
        let options = [];
        this.httpClient.get({ resource: resource }).subscribe(data => data.forEach((item) => options.push({
            label: item.descricao,
            value: item.codigo
        })));
        return options;
    }
    getEnumValues(resource) {
        return this.httpClient.get({ resource: resource, disableSpinner: true });
    }
}
EnumService.ɵfac = function EnumService_Factory(t) { return new (t || EnumService)(ɵngcc0.ɵɵinject(HttpClient)); };
EnumService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EnumService, factory: EnumService.ɵfac });
EnumService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnumService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

const queryBuilderValueEmpty = { 'condition': 'and', 'rules': [] };
const validQueryBuilderValue = () => {
    return (control) => {
        var _a, _b;
        if (!control.value) {
            return null;
        }
        return ((_b = (_a = control.value) === null || _a === void 0 ? void 0 : _a.rules) === null || _b === void 0 ? void 0 : _b.length) > 0 ? null : { 'semRules': 'condições vazia' };
    };
};
class QueryBuilderComponent {
    constructor(enumService) {
        this.enumService = enumService;
        this.showQueryBuilder = true;
        this.required = false;
        this.fields = [{}];
        this.onReset = new EventEmitter();
        this.queryBuilderConfig = { fields: {} };
        this.queryBuilderValue = Object.assign({}, queryBuilderValueEmpty);
    }
    ngOnInit() {
        if (this.required) {
            setTimeout(() => {
                this.form.get('queryBuilderValue').setValidators(Validators.compose([Validators.required, validQueryBuilderValue()]));
            });
        }
        if (this.fields.length === 0) {
            this.fields = [{}];
        }
        this.applyConfig(null);
        this.onReset.subscribe((entity) => {
            this.formReset(entity);
        });
    }
    formReset(entity) {
        if (this.form.get('id')) {
            this.form.get('id').setValue(entity === null || entity === void 0 ? void 0 : entity.id);
        }
        this.form.get('queryBuilderValue').setValue(entity === null || entity === void 0 ? void 0 : entity.queryBuilderValue);
        this.applyConfig(entity);
    }
    createQueryBuilderConfig(operators) {
        const config = { fields: {} };
        const operatorsMap = operators.map(op => op.descricao);
        this.fields.forEach(field => config.fields[`${field.descricao}#${field.codigo ? field.codigo : field.id}`] = {
            name: field.descricao,
            type: 'textarea',
            operators: operatorsMap
        });
        return config;
    }
    onChangeQueryValue(queryValue) {
        this.form.get('queryBuilderValue').setValue(Object.assign({}, queryValue));
        this.form.markAsDirty();
        if (this.isInvalidQuery(queryValue)) {
            this.form.get('queryBuilderValue').setErrors({ condicaoInvalida: 'Não é permitido grupos sem condições ou condições sem valor.' });
        }
    }
    isInvalidQuery(queryValue) {
        if (!queryValue.condition && !queryValue.value) {
            return this.required;
        }
        return this.isInvalid(queryValue);
    }
    isInvalid(queryValue) {
        if (queryValue.condition) {
            return !queryValue.rules.length
                || queryValue.rules.filter((r) => this.isInvalid(r)).length > 0;
        }
        return !queryValue.value;
    }
    applyConfig(entity) {
        this.enumService.getEnumValues('/api/operadores-condicoes')
            .subscribe(result => {
            this.queryBuilderConfig = this.createQueryBuilderConfig(result);
            this.queryBuilderValue = Object.assign({}, queryBuilderValueEmpty);
            if (entity && entity.queryBuilderValue) {
                this.queryBuilderValue = entity.queryBuilderValue;
            }
        });
    }
}
QueryBuilderComponent.ɵfac = function QueryBuilderComponent_Factory(t) { return new (t || QueryBuilderComponent)(ɵngcc0.ɵɵdirectiveInject(EnumService)); };
QueryBuilderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: QueryBuilderComponent, selectors: [["elo-query-builder"]], inputs: { showQueryBuilder: "showQueryBuilder", required: "required", fields: "fields", onReset: "onReset", form: "form" }, decls: 3, vars: 3, consts: [["inputs", "", 3, "formGroup"], [3, "queryValue", "config", "onChangeQueryValue", 4, "ngIf"], ["class", "align-group", 4, "ngIf"], [3, "queryValue", "config", "onChangeQueryValue"], [1, "align-group"], [1, "help-message"]], template: function QueryBuilderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, QueryBuilderComponent_elo_query_builder_item_1_Template, 1, 2, "elo-query-builder-item", 1);
        ɵngcc0.ɵɵtemplate(2, QueryBuilderComponent_div_2_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var tmp_2_0 = null;
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showQueryBuilder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (tmp_2_0 = ctx.form.get("queryBuilderValue")) == null ? null : tmp_2_0.errors == null ? null : tmp_2_0.errors.condicaoInvalida);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc2.NgIf, QueryBuilderItemComponent], encapsulation: 2 });
QueryBuilderComponent.ctorParameters = () => [
    { type: EnumService }
];
QueryBuilderComponent.propDecorators = {
    showQueryBuilder: [{ type: Input }],
    required: [{ type: Input }],
    fields: [{ type: Input }],
    form: [{ type: Input }],
    onReset: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(QueryBuilderComponent, [{
        type: Component,
        args: [{
                selector: 'elo-query-builder',
                template: "<div [formGroup]=\"form\" inputs>\n\n  <elo-query-builder-item *ngIf=\"showQueryBuilder\" [queryValue]=\"queryBuilderValue\" [config]=\"queryBuilderConfig\"\n    (onChangeQueryValue)=\"onChangeQueryValue($event)\">\n  </elo-query-builder-item>\n\n  <div class=\"align-group\" *ngIf=\"form.get('queryBuilderValue')?.errors?.condicaoInvalida\">\n    <span class=\"help-message\">{{form.get('queryBuilderValue').errors.condicaoInvalida}}</span>\n  </div>\n\n</div>\n"
            }]
    }], function () { return [{ type: EnumService }]; }, { showQueryBuilder: [{
            type: Input
        }], required: [{
            type: Input
        }], fields: [{
            type: Input
        }], onReset: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class EloQueryBuilderModule {
}
EloQueryBuilderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloQueryBuilderModule });
EloQueryBuilderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloQueryBuilderModule_Factory(t) { return new (t || EloQueryBuilderModule)(); }, providers: [
        EnumService
    ], imports: [[
            CommonModule$1,
            FormControlValidationMsgModule,
            FormsModule,
            FormLabelColumnModule,
            DirectivesModule,
            QueryBuilderModule,
            SwitchButtonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloQueryBuilderModule, { declarations: function () { return [QueryBuilderComponent, QueryBuilderTranslatorComponent, QueryBuilderItemComponent]; }, imports: function () { return [CommonModule$1, FormControlValidationMsgModule, FormsModule, FormLabelColumnModule, DirectivesModule, QueryBuilderModule, SwitchButtonModule]; }, exports: function () { return [QueryBuilderComponent, QueryBuilderTranslatorComponent, QueryBuilderItemComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloQueryBuilderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    FormControlValidationMsgModule,
                    FormsModule,
                    FormLabelColumnModule,
                    DirectivesModule,
                    QueryBuilderModule,
                    SwitchButtonModule,
                ],
                exports: [
                    QueryBuilderComponent,
                    QueryBuilderTranslatorComponent,
                    QueryBuilderItemComponent
                ],
                declarations: [
                    QueryBuilderComponent,
                    QueryBuilderTranslatorComponent,
                    QueryBuilderItemComponent
                ],
                providers: [
                    EnumService
                ]
            }]
    }], null, null); })();

class QuickViewComponent {
    constructor() {
        this.onClosed = new EventEmitter();
        this.open = false;
        this.width = undefined;
        this.fixed = false;
    }
    close() {
        this.open = false;
        this.onClosed.emit();
    }
    clickedOutside($event) {
        if (this.open) {
            let parents = $event.path;
            let isQuickViewOpenerElement = false;
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('quickViewOpener') ||
                        parent.classList.value.includes('preview') ||
                        parent.classList.value.includes('quick-view')) {
                        isQuickViewOpenerElement = true;
                    }
                }
            });
            if (!isQuickViewOpenerElement && this.open)
                this.close();
        }
    }
    handleKeyboardEvent(event) {
        if (event.code === 'Escape' && this.open) {
            this.close();
        }
    }
}
QuickViewComponent.ɵfac = function QuickViewComponent_Factory(t) { return new (t || QuickViewComponent)(); };
QuickViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: QuickViewComponent, selectors: [["elo-quick-view"]], hostBindings: function QuickViewComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("document click", function QuickViewComponent_document_click_HostBindingHandler($event) { return ctx.clickedOutside($event); })("keydown", function QuickViewComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { open: "open", width: "width", fixed: "fixed" }, outputs: { onClosed: "onClosed" }, ngContentSelectors: _c0, decls: 3, vars: 6, consts: [[1, "quick-view"], [1, "fa", "fa-close", "no-print", 3, "click"]], template: function QuickViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "i", 1);
        ɵngcc0.ɵɵlistener("click", function QuickViewComponent_Template_i_click_1_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.width ? ctx.width : "");
        ɵngcc0.ɵɵclassProp("open", ctx.open)("fixed", ctx.fixed);
    } }, encapsulation: 2 });
QuickViewComponent.propDecorators = {
    onClosed: [{ type: Output }],
    open: [{ type: Input }],
    width: [{ type: Input }],
    fixed: [{ type: Input }],
    clickedOutside: [{ type: HostListener, args: ['document click', ['$event'],] }],
    handleKeyboardEvent: [{ type: HostListener, args: ['document:keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(QuickViewComponent, [{
        type: Component,
        args: [{
                selector: 'elo-quick-view',
                template: "<div class=\"quick-view\" [class.open]=\"open\" [style.width]=\"width ? width : ''\" [class.fixed]=\"fixed\">\n  <i class=\"fa fa-close no-print\" (click)=\"close()\"></i>\n  <ng-content></ng-content>\n</div>\n"
            }]
    }], function () { return []; }, { onClosed: [{
            type: Output
        }], open: [{
            type: Input
        }], width: [{
            type: Input
        }], fixed: [{
            type: Input
        }], clickedOutside: [{
            type: HostListener,
            args: ['document click', ['$event']]
        }], handleKeyboardEvent: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }] }); })();

class QuickViewModule {
}
QuickViewModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: QuickViewModule });
QuickViewModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function QuickViewModule_Factory(t) { return new (t || QuickViewModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(QuickViewModule, { declarations: function () { return [QuickViewComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [QuickViewComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(QuickViewModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [QuickViewComponent],
                declarations: [QuickViewComponent]
            }]
    }], null, null); })();

class EloQuickAccessComponent {
}
EloQuickAccessComponent.ɵfac = function EloQuickAccessComponent_Factory(t) { return new (t || EloQuickAccessComponent)(); };
EloQuickAccessComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloQuickAccessComponent, selectors: [["elo-quick-access"]], inputs: { title: "title" }, ngContentSelectors: _c0, decls: 5, vars: 1, consts: [[1, "module-access-seperator"], [1, "mas-inner"], [1, "quick-access", "row", "hidden-xs"]], template: function EloQuickAccessComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "ul", 2);
        ɵngcc0.ɵɵprojection(4, 0, ["selector", "quick-access-button"]);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
    } }, encapsulation: 2 });
EloQuickAccessComponent.propDecorators = {
    title: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloQuickAccessComponent, [{
        type: Component,
        args: [{
                selector: 'elo-quick-access',
                template: "<div class=\"module-access-seperator\">\n  <h1 class=\"mas-inner\">{{title}}</h1>\n</div>\n\n<ul class=\"quick-access row hidden-xs\">\n    <ng-content selector=\"quick-access-button\"></ng-content>\n</ul>\n"
            }]
    }], null, { title: [{
            type: Input
        }] }); })();

class EloQuickAccessModule {
}
EloQuickAccessModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloQuickAccessModule });
EloQuickAccessModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloQuickAccessModule_Factory(t) { return new (t || EloQuickAccessModule)(); }, providers: [], imports: [[CommonModule$1, EloQuickAccessButtonModule], EloQuickAccessButtonModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloQuickAccessModule, { declarations: function () { return [EloQuickAccessComponent]; }, imports: function () { return [CommonModule$1, EloQuickAccessButtonModule]; }, exports: function () { return [EloQuickAccessComponent, EloQuickAccessButtonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloQuickAccessModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, EloQuickAccessButtonModule],
                declarations: [EloQuickAccessComponent],
                exports: [EloQuickAccessComponent, EloQuickAccessButtonModule],
                providers: []
            }]
    }], null, null); })();

class ReportSelectorComponent {
    constructor() {
        this.findToOptions = null;
        this.objToOption = null;
        this.onModGroupParent = new EventEmitter();
        this.onSelectReport = new EventEmitter();
        this.onSelectGroup = new EventEmitter();
    }
    ngOnInit() {
        this.onModGroupParent.subscribe(() => {
            this.grupoRelatorio = null;
        });
    }
    onSelect(reportSelected) {
        this.onSelectReport.emit(reportSelected);
        this.relatorioSelecionado = reportSelected;
    }
    onChangeGrupo() {
        this.relatorioSelecionado = null;
        if (this.grupoRelatorio) {
            this.onSelectGroup.emit(this.grupoRelatorio);
        }
    }
}
ReportSelectorComponent.ɵfac = function ReportSelectorComponent_Factory(t) { return new (t || ReportSelectorComponent)(); };
ReportSelectorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ReportSelectorComponent, selectors: [["report-selector"]], inputs: { findToOptions: "findToOptions", objToOption: "objToOption", onModGroupParent: "onModGroupParent", grupoRelatorio: "grupoRelatorio", relatorioSelecionado: "relatorioSelecionado", relatorios: "relatorios" }, outputs: { onSelectReport: "onSelectReport", onSelectGroup: "onSelectGroup" }, decls: 4, vars: 5, consts: [[3, "hasForm", "hasTable", "title"], [1, "row", "mb-xs"], ["label", "Grupo", "column", "12", 4, "ngIf"], ["id", "childs", 3, "title", 4, "ngIf"], ["label", "Grupo", "column", "12"], ["id", "grupoRelatorio", 3, "ngModel", "findToOptions", "objToOption", "ngModelChange", "onChangeValue"], ["id", "childs", 3, "title"], [3, "values", "colSpanActions", "emptyMessage"], [3, "field", "header", "col"], ["icon", "fa fa-print", "id", "selectReport", 3, "title", "onClickIconButton"]], template: function ReportSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "elo-panel", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, ReportSelectorComponent_elo_form_label_column_2_Template, 2, 3, "elo-form-label-column", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ReportSelectorComponent_elo_panel_3_Template, 5, 13, "elo-panel", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hasForm", true)("hasTable", true)("title", "Selecione o relat\u00F3rio desejado");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.findToOptions !== null && ctx.objToOption !== null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.relatorios && !ctx.relatorioSelecionado);
    } }, directives: [PanelComponent, ɵngcc2.NgIf, FormLabelColumnComponent, AutoCompleteComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, EloDatatableComponent, EloColumnComponent, EloTableActionsComponent], encapsulation: 2 });
ReportSelectorComponent.propDecorators = {
    grupoRelatorio: [{ type: Input }],
    relatorioSelecionado: [{ type: Input }],
    findToOptions: [{ type: Input }],
    objToOption: [{ type: Input }],
    relatorios: [{ type: Input }],
    onModGroupParent: [{ type: Input }],
    onSelectReport: [{ type: Output }],
    onSelectGroup: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ReportSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'report-selector',
                template: "<elo-panel [hasForm]=\"true\" [hasTable]=\"true\" [title]=\"'Selecione o relat\u00F3rio desejado'\">\n  <div class=\"row mb-xs\">\n\n    <elo-form-label-column *ngIf=\"findToOptions !== null && objToOption !== null \" label='Grupo' column=\"12\">\n      <elo-autocomplete id=\"grupoRelatorio\" [(ngModel)]=\"grupoRelatorio\" [findToOptions]=\"findToOptions()\"\n        [objToOption]=\"objToOption()\" (onChangeValue)=\"onChangeGrupo()\">\n      </elo-autocomplete>\n    </elo-form-label-column>\n  </div>\n\n  <elo-panel id=\"childs\" *ngIf=\"relatorios && !relatorioSelecionado\" [title]=\"''\">\n    <elo-datatable [class]=\"relatorios?.length > 6 ? 'fixed'  : ''\" [values]=\"relatorios\" [colSpanActions]=\"1\"\n      [emptyMessage]=\"'N\u00E3o foram encontrados tipos de relat\u00F3rio.'\">\n\n      <elo-column [field]=\"'codigo'\" [header]=\"'C\u00F3digo'\" [col]=\"1\"></elo-column>\n      <elo-column [field]=\"'descricao'\" [header]=\"'Descri\u00E7\u00E3o'\" [col]=\"10\"></elo-column>\n      <elo-table-actions [title]=\"'Selecionar'\" icon='fa fa-print' id=\"selectReport\"\n        (onClickIconButton)=\"onSelect($event)\"></elo-table-actions>\n\n    </elo-datatable>\n  </elo-panel>\n</elo-panel>"
            }]
    }], function () { return []; }, { findToOptions: [{
            type: Input
        }], objToOption: [{
            type: Input
        }], onModGroupParent: [{
            type: Input
        }], onSelectReport: [{
            type: Output
        }], onSelectGroup: [{
            type: Output
        }], grupoRelatorio: [{
            type: Input
        }], relatorioSelecionado: [{
            type: Input
        }], relatorios: [{
            type: Input
        }] }); })();

class ReportSelectorModule {
}
ReportSelectorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ReportSelectorModule });
ReportSelectorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ReportSelectorModule_Factory(t) { return new (t || ReportSelectorModule)(); }, imports: [[
            CommonModule$1,
            AutoCompleteModule,
            FormLabelColumnModule,
            FormsModule,
            EloModalModule,
            PanelModule,
            EloDatatableModule,
            PanelExpansiveModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ReportSelectorModule, { declarations: function () { return [ReportSelectorComponent]; }, imports: function () { return [CommonModule$1, AutoCompleteModule, FormLabelColumnModule, FormsModule, EloModalModule, PanelModule, EloDatatableModule, PanelExpansiveModule]; }, exports: function () { return [ReportSelectorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ReportSelectorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    AutoCompleteModule,
                    FormLabelColumnModule,
                    FormsModule,
                    EloModalModule,
                    PanelModule,
                    EloDatatableModule,
                    PanelExpansiveModule
                ],
                declarations: [ReportSelectorComponent],
                exports: [ReportSelectorComponent]
            }]
    }], null, null); })();

class SectionDirective {
    constructor(sectionService) {
        this.sectionService = sectionService;
        this.route = '';
        this.icon = '';
        this.name = '';
    }
    ngOnInit() {
        this.sectionService.registerContent({ route: this.route, icon: this.icon, name: this.name });
    }
}
SectionDirective.ɵfac = function SectionDirective_Factory(t) { return new (t || SectionDirective)(ɵngcc0.ɵɵdirectiveInject(SectionService)); };
SectionDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SectionDirective, selectors: [["", "sectionContent", ""]], inputs: { route: "route", icon: "icon", name: "name" } });
SectionDirective.ctorParameters = () => [
    { type: SectionService }
];
SectionDirective.propDecorators = {
    route: [{ type: Input }],
    icon: [{ type: Input }],
    name: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SectionDirective, [{
        type: Directive,
        args: [{ selector: '[sectionContent]' }]
    }], function () { return [{ type: SectionService }]; }, { route: [{
            type: Input
        }], icon: [{
            type: Input
        }], name: [{
            type: Input
        }] }); })();

class SectionModule {
}
SectionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SectionModule });
SectionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SectionModule_Factory(t) { return new (t || SectionModule)(); }, providers: [
        SectionService,
        IFrameStore
    ], imports: [[RouterModule, CommonModule$1, BreadcrumbModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SectionModule, { declarations: function () { return [SectionComponent, SectionDirective]; }, imports: function () { return [RouterModule, CommonModule$1, BreadcrumbModule]; }, exports: function () { return [SectionComponent, SectionDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SectionModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule, CommonModule$1, BreadcrumbModule],
                declarations: [SectionComponent, SectionDirective],
                exports: [SectionComponent, SectionDirective],
                providers: [
                    SectionService,
                    IFrameStore
                ]
            }]
    }], null, null); })();

class IFrameComponent {
    constructor(sanitizer, _store) {
        this.sanitizer = sanitizer;
        this._store = _store;
        this.bypassSecurity = true;
        this.mainH = 0;
        this.mainW = 0;
    }
    ngOnInit() {
        if (!this.url) {
            throw 'Não foi informado a URL do iframe';
        }
        if (this._store) {
            this._store.hasIframe = true;
        }
        if (this.bypassSecurity) {
            this.resultingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        }
        else {
            this.resultingUrl = this.url;
        }
        this.iframe = document.querySelector('iframe');
        this.onResize();
    }
    ngOnDestroy() {
        if (this._store) {
            this._store.hasIframe = false;
        }
    }
    onResize() {
        this.mainH = window.innerHeight;
        this.mainW = window.innerWidth;
        if (this.mainW > 768) {
            this.iframe.style.height = (this.mainH - 113) + 'px';
        }
        else if (this.mainW <= 768) {
            this.iframe.style.height = (this.mainH - 156) + 'px';
        }
    }
}
IFrameComponent.ɵfac = function IFrameComponent_Factory(t) { return new (t || IFrameComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(IFrameStore, 8)); };
IFrameComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IFrameComponent, selectors: [["iframe-component"]], hostBindings: function IFrameComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function IFrameComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { bypassSecurity: "bypassSecurity", url: "url" }, decls: 1, vars: 1, consts: [[3, "src"]], template: function IFrameComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "iframe", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("src", ctx.resultingUrl, ɵngcc0.ɵɵsanitizeResourceUrl);
    } }, encapsulation: 2 });
IFrameComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: IFrameStore, decorators: [{ type: Optional }] }
];
IFrameComponent.propDecorators = {
    url: [{ type: Input }],
    bypassSecurity: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IFrameComponent, [{
        type: Component,
        args: [{
                selector: 'iframe-component',
                template: `
      <iframe [src]="resultingUrl"></iframe>
  `
            }]
    }], function () { return [{ type: ɵngcc4.DomSanitizer }, { type: IFrameStore, decorators: [{
                type: Optional
            }] }]; }, { bypassSecurity: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], url: [{
            type: Input
        }] }); })();

class IFrameModule {
}
IFrameModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: IFrameModule });
IFrameModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function IFrameModule_Factory(t) { return new (t || IFrameModule)(); }, imports: [[
            CommonModule$1
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IFrameModule, { declarations: function () { return [IFrameComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [IFrameComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IFrameModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1
                ],
                declarations: [
                    IFrameComponent
                ],
                exports: [
                    IFrameComponent,
                ]
            }]
    }], null, null); })();

class DeviceUtils {
    static isMobile() {
        return innerWidth < 800;
    }
}

class SidebarComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.toggled = true;
        this.floatType = false;
        this.focusedSearchInput = false;
        this.fancy = false;
        this.enableShortcut = false;
        this.hideAll = false;
        this.openClose = new EventEmitter();
        this.onOpenSubMenu = new EventEmitter();
        this.onInit = new EventEmitter();
        this.onClickSubMenu = new EventEmitter();
        this.onHideRequest = new EventEmitter();
        this.onClickToToggled = new EventEmitter();
        this.clicked = false;
        this.items = [];
    }
    onMouseEnter() {
        this.clicked = false;
    }
    getSidebarTree() {
        return this.items;
    }
    addItem(item) {
        this.items.push(item);
    }
    onClickToggledButton() {
        this.onClickToToggled.emit();
    }
    ngOnInit() {
        this.onInit.emit(this.getSidebarTree());
        if (this.fancy) {
            this.usuarioLogado.then(profile => this._imgPerfil = { url: profile.picture });
        }
    }
    clickedOutside($event) {
        if (!this.toggled) {
            let parents = $event.path;
            if (!parents) {
                return;
            }
            let isFuncionarioSidebarOpen = false;
            if (parents && parents.length > 0 && parents[0].localName === 'app-root') {
                isFuncionarioSidebarOpen = true;
            }
            parents.map(parent => {
                if (parent && parent.classList && parent.classList.value) {
                    if (parent.classList.value.includes('sidebar')) {
                        isFuncionarioSidebarOpen = true;
                    }
                }
            });
            if (!isFuncionarioSidebarOpen) {
                if (DeviceUtils.isMobile()) {
                    this.onHideRequest.emit();
                }
            }
        }
        if (this.focusedSearchInput) {
            if ($event.target.classList.contains('main-content') || $event.target.closest('.main-content')) {
                this.floatType = true;
                this.focusedSearchInput = false;
            }
        }
    }
    handleKeyboardEvent(event) {
        if (this.hideAll) {
            return;
        }
        const element = this.renderer.selectRootElement('#sidebar-search-input');
        if (this.isEscape(event)) {
            setTimeout(() => element.blur(), 0);
            this.clearSearchInput();
            if (!this.toggled) {
                this.openClose.emit();
            }
        }
        if (this.enableShortcut && this.isCtrlShiftF(event)) {
            this.openClose.emit();
            setTimeout(() => element.focus(), 0);
        }
    }
    handleOnFocus() {
        if (this.floatType) {
            this.floatType = false;
            this.focusedSearchInput = true;
            setTimeout(() => {
                const input = this.renderer.selectRootElement('#sidebar-search-input');
                input.focus();
            }, 500);
        }
    }
    handleOnBlur() {
        if (this.floatType) {
            setTimeout(() => {
                this.focusedSearchInput = false;
            }, 500);
        }
    }
    clickLinkSubMenu() {
        this.onClickSubMenu.emit();
        this.hideRequestIfMobile();
        this.clearSearchInput();
        if (this.focusedSearchInput) {
            this.floatType = true;
            this.focusedSearchInput = false;
        }
    }
    clearActivedMenus() {
        this.clicked = true;
        this.items.map((item) => {
            item.active = false;
            item.items.map((child) => {
                child.active = false;
                child.items.map((childOfChild) => {
                    childOfChild.active = false;
                });
            });
        });
    }
    closeNotActivedMenus() {
        this.items.map((item) => {
            item.open = false;
            item.items.map((child) => {
                child.open = false;
                if (child.active) {
                    item.open = true;
                }
                child.items.map((childOfChild) => {
                    if (childOfChild.active) {
                        item.open = true;
                        child.open = true;
                    }
                });
            });
        });
    }
    hideRequestIfMobile() {
        if (DeviceUtils.isMobile()) {
            this.onHideRequest.emit();
        }
    }
    clearSearchInput() {
        this.searchValue = '';
    }
    isCtrlShiftF(event) {
        return event.ctrlKey && event.shiftKey && event.code === 'KeyF';
    }
    isEscape(event) {
        return event.code === 'Escape';
    }
}
SidebarComponent.ɵfac = function SidebarComponent_Factory(t) { return new (t || SidebarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
SidebarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarComponent, selectors: [["elo-sidebar"]], hostBindings: function SidebarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SidebarComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, ɵngcc0.ɵɵresolveDocument)("keydown", function SidebarComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { toggled: "toggled", floatType: "floatType", focusedSearchInput: "focusedSearchInput", fancy: "fancy", enableShortcut: "enableShortcut", hideAll: "hideAll", title: "title", userName: "userName", imgModuleMain: "imgModuleMain", imgModule: "imgModule", imgModuleRebranding: "imgModuleRebranding", usuarioLogado: "usuarioLogado" }, outputs: { openClose: "openClose", onOpenSubMenu: "onOpenSubMenu", onInit: "onInit", onClickSubMenu: "onClickSubMenu", onHideRequest: "onHideRequest", onClickToToggled: "onClickToToggled" }, decls: 1, vars: 1, consts: [["class", "sidebar new", 3, "sidebar-toggle", "float-type", "focused-search", "clicked", "fancy", "mouseenter", 4, "ngIf"], [1, "sidebar", "new", 3, "mouseenter"], [1, "sidebar-header"], [1, "sidebar-module"], ["class", "module-main", 3, "src", 4, "ngIf"], [1, "sidebar-title"], [1, "sidebar-search"], ["id", "sidebar-search-input", "placeholder", "Buscar em Menu..", "autocomplete", "off", 3, "ngModel", "ngModelChange", "focus"], ["aria-hidden", "true", 1, "fa", "fa-search", 3, "click"], [1, "sidebar-itens"], [4, "ngFor", "ngForOf"], ["aria-label", "Bot\u00E3o para expandir o menu", 1, "header-toggle-sidebar", "toggle-control", "hidden-xs", "hidden-sm", 3, "click"], ["class", "fa fa-angle-double-right", 4, "ngIf"], [4, "ngIf"], [1, "module-main", 3, "src"], ["data-id", "parent", 3, "item", "searchValue", "toggled", "floatType", "focusedSearchInput", "onClearActivedMenus", "onCloseNotActivedMenus"], [1, "fa", "fa-angle-double-right"], [1, "mr-xs", "fa", "fa-angle-double-left"]], template: function SidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SidebarComponent_aside_0_Template, 14, 16, "aside", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideAll);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc2.NgForOf, SidebarItemComponent]; }, encapsulation: 2 });
SidebarComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
SidebarComponent.propDecorators = {
    title: [{ type: Input }],
    toggled: [{ type: Input }],
    floatType: [{ type: Input }],
    focusedSearchInput: [{ type: Input }],
    fancy: [{ type: Input }],
    userName: [{ type: Input }],
    imgModuleMain: [{ type: Input }],
    imgModule: [{ type: Input }],
    imgModuleRebranding: [{ type: Input }],
    usuarioLogado: [{ type: Input }],
    enableShortcut: [{ type: Input }],
    hideAll: [{ type: Input }],
    openClose: [{ type: Output }],
    onOpenSubMenu: [{ type: Output }],
    onInit: [{ type: Output }],
    onClickSubMenu: [{ type: Output }],
    onHideRequest: [{ type: Output }],
    onClickToToggled: [{ type: Output }],
    clickedOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }],
    handleKeyboardEvent: [{ type: HostListener, args: ['document:keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarComponent, [{
        type: Component,
        args: [{
                selector: 'elo-sidebar',
                template: "<aside *ngIf=\"!hideAll\" class=\"sidebar new\" [class.sidebar-toggle]=\"toggled\" [class.float-type]=\"toggled\"\n  [class.focused-search]=\"focusedSearchInput\" (mouseenter)=\"onMouseEnter()\" [class.clicked]=\"clicked\"\n  [class.fancy]=\"fancy\">\n\n  <header class=\"sidebar-header\">\n    <div class=\"sidebar-module\"><img *ngIf=\"imgModule\" class=\"module-main\" src=\"{{imgModuleRebranding}}\"></div>\n    <div class=\"sidebar-title\">{{title}}</div>\n  </header>\n\n  <div class=\"sidebar-search\">\n    <input id=\"sidebar-search-input\" placeholder=\"Buscar em Menu..\" [(ngModel)]=\"searchValue\" (focus)=\"handleOnFocus()\"\n      autocomplete=\"off\">\n    <i class=\"fa fa-search\" aria-hidden=\"true\" (click)=\"handleOnFocus()\"></i>\n  </div>\n\n  <ul class=\"sidebar-itens\">\n    <div *ngFor=\"let item of items\">\n      <elo-sidebar-item data-id=\"parent\" [item]=\"item\" [searchValue]=\"searchValue\"\n        (onClearActivedMenus)=\"clearActivedMenus()\" (onCloseNotActivedMenus)=\"closeNotActivedMenus()\"\n        [toggled]=\"toggled\" [floatType]=\"floatType\" [focusedSearchInput]=\"focusedSearchInput\">\n      </elo-sidebar-item>\n    </div>\n  </ul>\n\n  <button class=\"header-toggle-sidebar toggle-control hidden-xs hidden-sm\" aria-label=\"Bot\u00E3o para expandir o menu\"\n    (click)=\"onClickToggledButton()\">\n    <div *ngIf=\"toggled\" class=\"fa fa-angle-double-right\"></div>\n\n    <ng-container *ngIf=\"!toggled\">\n      <div class=\"mr-xs fa fa-angle-double-left\"></div>\n      Recolher Menu\n    </ng-container>\n  </button>\n</aside>"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { toggled: [{
            type: Input
        }], floatType: [{
            type: Input
        }], focusedSearchInput: [{
            type: Input
        }], fancy: [{
            type: Input
        }], enableShortcut: [{
            type: Input
        }], hideAll: [{
            type: Input
        }], openClose: [{
            type: Output
        }], onOpenSubMenu: [{
            type: Output
        }], onInit: [{
            type: Output
        }], onClickSubMenu: [{
            type: Output
        }], onHideRequest: [{
            type: Output
        }], onClickToToggled: [{
            type: Output
        }], clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], handleKeyboardEvent: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], title: [{
            type: Input
        }], userName: [{
            type: Input
        }], imgModuleMain: [{
            type: Input
        }], imgModule: [{
            type: Input
        }], imgModuleRebranding: [{
            type: Input
        }], usuarioLogado: [{
            type: Input
        }] }); })();

class SideBarItemDirective {
    constructor(sidebar, parent) {
        this.sidebar = sidebar;
        this.parent = parent;
        this.enabled = true;
        this.active = false;
        this.external = false;
        this.toggleMenuOnClick = false;
        this.open = false;
        this.onClickToToggled = new EventEmitter();
        this.items = [];
        if (this.parent) {
            this.parent.items.push(this);
        }
        else {
            this.sidebar.addItem(this);
        }
    }
}
SideBarItemDirective.ɵfac = function SideBarItemDirective_Factory(t) { return new (t || SideBarItemDirective)(ɵngcc0.ɵɵdirectiveInject(SidebarComponent), ɵngcc0.ɵɵdirectiveInject(SideBarItemDirective, 12)); };
SideBarItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SideBarItemDirective, selectors: [["", "sidebaritem", ""]], inputs: { enabled: "enabled", active: "active", external: "external", toggleMenuOnClick: "toggleMenuOnClick", open: "open", name: "name", icon: "icon", route: "route", params: "params", hidden: "hidden", recurso: "recurso", count: "count" }, outputs: { onClickToToggled: "onClickToToggled" } });
SideBarItemDirective.ctorParameters = () => [
    { type: SidebarComponent },
    { type: SideBarItemDirective, decorators: [{ type: SkipSelf }, { type: Optional }] }
];
SideBarItemDirective.propDecorators = {
    name: [{ type: Input }],
    icon: [{ type: Input }],
    route: [{ type: Input }],
    params: [{ type: Input }],
    hidden: [{ type: Input }],
    enabled: [{ type: Input }],
    recurso: [{ type: Input }],
    count: [{ type: Input }],
    active: [{ type: Input }],
    external: [{ type: Input }],
    toggleMenuOnClick: [{ type: Input }],
    open: [{ type: Input }],
    onClickToToggled: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SideBarItemDirective, [{
        type: Directive,
        args: [{
                selector: '[sidebaritem]'
            }]
    }], function () { return [{ type: SidebarComponent }, { type: SideBarItemDirective, decorators: [{
                type: SkipSelf
            }, {
                type: Optional
            }] }]; }, { enabled: [{
            type: Input
        }], active: [{
            type: Input
        }], external: [{
            type: Input
        }], toggleMenuOnClick: [{
            type: Input
        }], open: [{
            type: Input
        }], onClickToToggled: [{
            type: Output
        }], name: [{
            type: Input
        }], icon: [{
            type: Input
        }], route: [{
            type: Input
        }], params: [{
            type: Input
        }], hidden: [{
            type: Input
        }], recurso: [{
            type: Input
        }], count: [{
            type: Input
        }] }); })();

class SidebarItemComponent {
    constructor(sidebar, authHttp, router, location, authResourcesConfig) {
        this.sidebar = sidebar;
        this.authHttp = authHttp;
        this.router = router;
        this.location = location;
        this.authResourcesConfig = authResourcesConfig;
        this.render = true;
        this.hasChildWithAccess = of(true);
        this.hasAccess = of(true);
        this.onOpenSubMenu = new EventEmitter();
        this.onClearActivedMenus = new EventEmitter();
        this.onCloseNotActivedMenus = new EventEmitter();
    }
    set searchValue(value) {
        this.internalSearchValue = value;
        this.render = this.existsOnSearch(this.item);
    }
    ngOnInit() {
        if (this.authHttp.isLogged()) {
            this.hasChildWithAccess = from(this.item.items)
                .pipe(mergeMap(item => this.authHttp.hasPermissionByRoute(item.route)), filter(val => val), defaultIfEmpty(false));
            this.hasAccess = this.authHttp.hasPermissionByRoute(this.item.route);
        }
        const currentUrl = this.location.path().split('/')[1];
        if (this.item.route && currentUrl === this.item.route) {
            this.activeSidebarsPaths();
        }
    }
    onClickSubMenu() {
        this.item.open = !this.item.open;
        if (this.item.open && this.checkVisibleSubMenu()) {
            this.openSubMenu();
        }
    }
    checkVisibleSubMenu() {
        return !this.floatType && window.innerWidth > 1024 || window.innerWidth < 1025 || this.floatType && this.focusedSearchInput;
    }
    handleMouseEnterMenuFloatType($event) {
        if (this.floatType && window.innerWidth > 1024 && !this.focusedSearchInput) {
            document.querySelector('aside.sidebar-toggle').classList.add('hover');
            let child = $event.target.querySelector('ul');
            if (child) {
                let childHeight = child.offsetHeight;
                let bounding = $event.target.getBoundingClientRect();
                let offsetTop = bounding.y;
                let windowHeight = window.innerHeight;
                if (childHeight > windowHeight) {
                    childHeight = windowHeight - 310;
                }
                if (offsetTop + childHeight > windowHeight) {
                    offsetTop = offsetTop - ((offsetTop + childHeight) - windowHeight) - 5;
                }
                child.style.left = bounding.x + bounding.width + 'px';
                child.style.maxHeight = childHeight + 'px';
                child.style.top = offsetTop + 'px';
            }
        }
    }
    handleMouseLeaveMenuFloatType($event) {
        if (this.floatType && window.innerWidth > 1024 && !this.focusedSearchInput) {
            let child = $event.target.querySelector('ul');
            $event.stopPropagation();
            if (child) {
                $event.target.querySelector('ul').style.top = 0;
            }
            document.querySelector('aside.sidebar-toggle').classList.remove('hover');
        }
    }
    openSubMenu() {
        this.onOpenSubMenu.emit();
    }
    clearActivedMenus() {
        this.onClearActivedMenus.emit();
    }
    closeNotActivedMenus() {
        this.onCloseNotActivedMenus.emit();
    }
    clickLink(event) {
        this.onClearActivedMenus.emit();
        this.activeSidebarsPaths();
        if (this.item.external) {
            const host = this.authResourcesConfig.isDev ? this.authResourcesConfig.hostDev : window.location.origin;
            window.open(host + this.item.route);
            return;
        }
        if (!this.item.enabled) {
            this.router.navigate(['page-blocked']);
            event.stopPropagation();
            return;
        }
        if (this.item.toggleMenuOnClick) {
            this.item.onClickToToggled.emit();
        }
        this.router.navigate([this.item.route], this.item.params);
        this.sidebar.clickLinkSubMenu();
    }
    activeSidebarsPaths() {
        setTimeout(() => {
            this.item.active = true;
            if (this.item.parent) {
                this.item.parent.open = true;
                this.item.parent.active = true;
                if (this.item.parent.parent) {
                    this.item.parent.parent.open = true;
                    this.item.parent.parent.active = true;
                }
            }
            this.closeNotActivedMenus();
        }, 200);
    }
    existsOnSearch(sidebarItem) {
        if (!this.internalSearchValue) {
            return true;
        }
        if (sidebarItem.items.length > 0) {
            this.item.open = this.searchMatchFilterItems(sidebarItem);
            return this.item.open;
        }
        else {
            return this.searchMatchFilter(sidebarItem);
        }
    }
    searchMatchFilterItems(sidebarItem) {
        let exists = false;
        sidebarItem.items.forEach(item => {
            if (!exists) {
                exists = this.existsOnSearch(item);
            }
        });
        return exists;
    }
    searchMatchFilter(sidebarItem) {
        return StringUtils.removeAccent(sidebarItem.name).toUpperCase().includes(StringUtils.removeAccent(this.internalSearchValue).toUpperCase());
    }
}
SidebarItemComponent.ɵfac = function SidebarItemComponent_Factory(t) { return new (t || SidebarItemComponent)(ɵngcc0.ɵɵdirectiveInject(SidebarComponent), ɵngcc0.ɵɵdirectiveInject(AbstractAuthHttp), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Location), ɵngcc0.ɵɵdirectiveInject(AUTH_RESOURCES_CONFIG)); };
SidebarItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarItemComponent, selectors: [["elo-sidebar-item"]], inputs: { searchValue: "searchValue", item: "item", toggled: "toggled", floatType: "floatType", focusedSearchInput: "focusedSearchInput" }, outputs: { onOpenSubMenu: "onOpenSubMenu", onClearActivedMenus: "onClearActivedMenus", onCloseNotActivedMenus: "onCloseNotActivedMenus" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "hidden", "on", "mouseenter", "mouseleave", 4, "ngIf"], [3, "hidden", "mouseenter", "mouseleave"], [3, "click"], ["class", "count", 4, "ngIf"], [1, "count"], [1, "dropdown-arrow", 3, "click"], ["ref", "slide"], [3, "item", "searchValue", "toggled", "floatType", "focusedSearchInput", "onClearActivedMenus", "onCloseNotActivedMenus", 4, "ngFor", "ngForOf"], [3, "item", "searchValue", "toggled", "floatType", "focusedSearchInput", "onClearActivedMenus", "onCloseNotActivedMenus"]], template: function SidebarItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SidebarItemComponent_div_0_Template, 4, 4, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.render && ctx.hasAccess));
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, SidebarItemComponent], pipes: [ɵngcc2.AsyncPipe], styles: [".disabled[_ngcontent-%COMP%]{background-color:#ddd!important;cursor:pointer!important;margin-bottom:-1px}.disabled[_ngcontent-%COMP%]   b[_ngcontent-%COMP%]{text-decoration:line-through}"] });
SidebarItemComponent.ctorParameters = () => [
    { type: SidebarComponent },
    { type: AbstractAuthHttp },
    { type: Router },
    { type: Location },
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_RESOURCES_CONFIG,] }] }
];
SidebarItemComponent.propDecorators = {
    item: [{ type: Input }],
    toggled: [{ type: Input }],
    floatType: [{ type: Input }],
    focusedSearchInput: [{ type: Input }],
    onOpenSubMenu: [{ type: Output }],
    onClearActivedMenus: [{ type: Output }],
    onCloseNotActivedMenus: [{ type: Output }],
    searchValue: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarItemComponent, [{
        type: Component,
        args: [{
                selector: 'elo-sidebar-item',
                template: "<div *ngIf=\"render && hasAccess | async\">\n  <li [hidden]=\"item.hidden\" *ngIf=\"item.items.length === 0\" [class.on]=\"item.active\"\n    (mouseenter)=\"handleMouseEnterMenuFloatType($event)\" (mouseleave)=\"handleMouseLeaveMenuFloatType($event)\">\n    <a [class.disabled]=\"!item.enabled\" (click)=\"clickLink($event)\">\n      <i class=\"{{item.enabled ? item.icon : 'fa fa-ban'}}\"></i>\n      <span class=\"count\" *ngIf=\"item.count\">{{item.count}}</span>\n      <b>{{item.name}}</b>\n    </a>\n  </li>\n  <ng-container *ngIf=\"item.items.length > 0 && hasChildWithAccess | async\">\n    <li [hidden]=\"item.hidden\" [class.top]=\"item.open\" (mouseenter)=\"handleMouseEnterMenuFloatType($event)\"\n      (mouseleave)=\"handleMouseLeaveMenuFloatType($event)\" [class.on]=\"item.active\">\n      <a (click)=\"onClickSubMenu()\" class=\"dropdown-arrow\" [class.open]=\"item.open\">\n        <i class=\"{{item.icon}}\"></i>\n        <b> {{item.name}}</b>\n      </a>\n      <ul ref=\"slide\" [attr.attr-parent]=\"item.name\"\n        [class.visible-block]=\"this.item.open && this.checkVisibleSubMenu()\">\n        <elo-sidebar-item *ngFor=\"let itemChild of item.items\" [item]=\"itemChild\" [searchValue]=\"internalSearchValue\"\n          (onClearActivedMenus)=\"clearActivedMenus()\" (onCloseNotActivedMenus)=\"closeNotActivedMenus()\"\n          [toggled]=\"toggled\" [floatType]=\"floatType\" [focusedSearchInput]=\"focusedSearchInput\">\n        </elo-sidebar-item>\n      </ul>\n    </li>\n  </ng-container>\n</div>",
                styles: [".disabled{background-color:#ddd!important;cursor:pointer!important;margin-bottom:-1px}.disabled b{text-decoration:line-through}"]
            }]
    }], function () { return [{ type: SidebarComponent }, { type: AbstractAuthHttp }, { type: ɵngcc6.Router }, { type: ɵngcc2.Location }, { type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_RESOURCES_CONFIG]
            }] }]; }, { onOpenSubMenu: [{
            type: Output
        }], onClearActivedMenus: [{
            type: Output
        }], onCloseNotActivedMenus: [{
            type: Output
        }], searchValue: [{
            type: Input
        }], item: [{
            type: Input
        }], toggled: [{
            type: Input
        }], floatType: [{
            type: Input
        }], focusedSearchInput: [{
            type: Input
        }] }); })();

class SidebarModule {
}
SidebarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SidebarModule });
SidebarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SidebarModule_Factory(t) { return new (t || SidebarModule)(); }, imports: [[CommonModule$1, RouterModule, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SidebarModule, { declarations: function () { return [SidebarComponent, SideBarItemDirective, SidebarItemComponent]; }, imports: function () { return [CommonModule$1, RouterModule, FormsModule]; }, exports: function () { return [SidebarComponent, SideBarItemDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, RouterModule, FormsModule],
                exports: [SidebarComponent, SideBarItemDirective],
                declarations: [SidebarComponent, SideBarItemDirective, SidebarItemComponent]
            }]
    }], null, null); })();

class SortParameters {
    constructor(field, order) {
        this.field = '';
        this.order = '';
        this.field = field;
        this.order = order;
    }
    static newSortParameters(field, order) {
        return new SortParameters(field, order);
    }
    toUrlParameters() {
        let params = new URLSearchParams();
        params.set(this.field, this.order);
        return params;
    }
}

class SortableHeaderComponent {
    constructor() {
        this.onClickToOrder = new EventEmitter();
        this.label = '';
        this.ordem = '';
        this.field = '';
    }
    clickToOrder() {
        this.onClickToOrder.emit(new SortParameters(this.field, (this.ordem === 'asc' ? 'desc' : 'asc')));
    }
}
SortableHeaderComponent.ɵfac = function SortableHeaderComponent_Factory(t) { return new (t || SortableHeaderComponent)(); };
SortableHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SortableHeaderComponent, selectors: [["sortable-header"]], inputs: { label: "label", ordem: "ordem", field: "field" }, outputs: { onClickToOrder: "onClickToOrder" }, decls: 5, vars: 4, consts: [[1, "header-link", 3, "click"], ["class", "fa fa-sort", "aria-hidden", "true", 4, "ngIf"], ["class", "fa fa-sort-asc", "aria-hidden", "true", 4, "ngIf"], ["class", "fa fa-sort-desc", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "fa", "fa-sort"], ["aria-hidden", "true", 1, "fa", "fa-sort-asc"], ["aria-hidden", "true", 1, "fa", "fa-sort-desc"]], template: function SortableHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵlistener("click", function SortableHeaderComponent_Template_span_click_0_listener() { return ctx.clickToOrder(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵtemplate(2, SortableHeaderComponent_i_2_Template, 1, 0, "i", 1);
        ɵngcc0.ɵɵtemplate(3, SortableHeaderComponent_i_3_Template, 1, 0, "i", 2);
        ɵngcc0.ɵɵtemplate(4, SortableHeaderComponent_i_4_Template, 1, 0, "i", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ordem !== "asc" && ctx.ordem !== "desc");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ordem === "asc");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ordem === "desc");
    } }, directives: [ɵngcc2.NgIf], styles: [".header-link[_ngcontent-%COMP%]{cursor:pointer}"] });
SortableHeaderComponent.propDecorators = {
    onClickToOrder: [{ type: Output }],
    label: [{ type: Input }],
    ordem: [{ type: Input }],
    field: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SortableHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'sortable-header',
                template: "<span class=\"header-link\"\n      (click)=\"clickToOrder()\">\n  {{label}}\n\n  <i class=\"fa fa-sort\" aria-hidden=\"true\" *ngIf=\"ordem !== 'asc' && ordem !== 'desc'\"></i>\n  <i class=\"fa fa-sort-asc\" aria-hidden=\"true\" *ngIf=\"ordem === 'asc'\"></i>\n  <i class=\"fa fa-sort-desc\" aria-hidden=\"true\" *ngIf=\"ordem === 'desc'\"></i>\n</span>\n",
                styles: [".header-link{cursor:pointer}"]
            }]
    }], function () { return []; }, { onClickToOrder: [{
            type: Output
        }], label: [{
            type: Input
        }], ordem: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class SortableHeaderModule {
}
SortableHeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SortableHeaderModule });
SortableHeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SortableHeaderModule_Factory(t) { return new (t || SortableHeaderModule)(); }, providers: [], imports: [[
            CommonModule$1,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SortableHeaderModule, { declarations: function () { return [SortableHeaderComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [SortableHeaderComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SortableHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                ],
                declarations: [
                    SortableHeaderComponent
                ],
                exports: [
                    SortableHeaderComponent
                ],
                providers: []
            }]
    }], null, null); })();

class GlobalExceptionHandlerService extends ErrorHandler {
    constructor() {
        super();
        this.errorSource = new Subject();
        this.observers = this.errorSource.asObservable();
    }
    getWindow() {
        return window;
    }
    handleError(error) {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (error && error.message && chunkFailedMessage.test(error.message)) {
            this.getWindow().location.reload();
        }
        else {
            this.emitException(error);
        }
    }
    emitException(error) {
        if (!error) {
            return;
        }
        this.errorSource.next(error);
        if (!('__karma__' in window)) {
            console.error('error ->', error);
        }
    }
}
GlobalExceptionHandlerService.ɵfac = function GlobalExceptionHandlerService_Factory(t) { return new (t || GlobalExceptionHandlerService)(); };
GlobalExceptionHandlerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: GlobalExceptionHandlerService, factory: GlobalExceptionHandlerService.ɵfac });
GlobalExceptionHandlerService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GlobalExceptionHandlerService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Created by anderson on 21/10/16.
 */
class SpinnerService {
    constructor() {
        this.show = new EventEmitter();
    }
}
SpinnerService.ɵfac = function SpinnerService_Factory(t) { return new (t || SpinnerService)(); };
SpinnerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SpinnerService, factory: SpinnerService.ɵfac });
SpinnerService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpinnerService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Created by anderson on 21/10/16.
 */
class SpinnerComponent {
    constructor(spinnerService, changeDetectorRef, exceptionHandler) {
        this.spinnerService = spinnerService;
        this.changeDetectorRef = changeDetectorRef;
        this.exceptionHandler = exceptionHandler;
        this.show = false;
        this.delayValue = 500;
        this.flag = 0;
        this.subscription = null;
    }
    ngOnInit() {
        this.spinnerService.show.subscribe((show) => this.showOrHideSpinner(show));
        if (this.exceptionHandler instanceof GlobalExceptionHandlerService) {
            this.exceptionHandler.observers.subscribe(() => {
                this.show = false;
                this.changeDetectorRef.detectChanges();
            });
        }
    }
    showOrHideSpinner(show) {
        if (show) {
            this.flag++;
        }
        else {
            this.flag--;
        }
        if (this.flag < 0) {
            this.flag = 0;
        }
        const delayValueToUse = this.flag === 0 ? 0 : this.delayValue;
        if (this.subscription && !this.subscription.closed) {
            this.subscription.unsubscribe();
        }
        this.subscription = of(show).pipe(delay(delayValueToUse))
            .subscribe(() => this.updateShowvalue());
    }
    updateShowvalue() {
        this.show = this.flag > 0;
    }
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(ɵngcc0.ɵɵdirectiveInject(SpinnerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ErrorHandler)); };
SpinnerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["elo-spinner"]], inputs: { show: "show", delayValue: "delayValue" }, decls: 9, vars: 2, consts: [[1, "content-loader", "loadOxy", "contain"], ["version", "1.2", "baseProfile", "tiny", "xmlns", "http://www.w3.org/2000/svg", "xlink", "http://www.w3.org/1999/xlink", 1, "content-align"], ["id", "Logo-Text", 1, "animateDraw", "drawText"], ["id", "Caminho_129", "data-name", "Caminho 129", "d", "M206.58,240.235a19.448,19.448,0,1,0,19.448,19.448,19.448,19.448,0,0,0-19.448-19.448M208,270.5a10.909,10.909,0,1,1,9.4-9.4,10.914,10.914,0,0,1-9.4,9.4", "transform", "translate(-187.132 -240.234)"], ["id", "Caminho_130", "data-name", "Caminho 130", "d", "M352.5,240.234v19.43a10.906,10.906,0,1,1-21.811,0V245.131l-8.54-4.9v19.43A19.448,19.448,0,0,0,352.5,275.77v3.344a10.91,10.91,0,0,1-10.911,10.9H327.216l4.9,8.543h9.474a19.45,19.45,0,0,0,19.451-19.447V245.131Z", "transform", "translate(-231.064 -240.234)"], ["id", "Caminho_131", "data-name", "Caminho 131", "d", "M266.245,259.675l-11.96,8.825v10.615l19.154-14.132,19.155,14.132V268.5l-11.961-8.825,11.961-8.825V240.235l-19.155,14.132-19.154-14.132V250.85Z", "transform", "translate(-208.982 -240.234)"], ["viewBox", "0 0 100 100", "space", "preserveAspectRatio", 1, "logo_loading"], ["id", "Draw-Text", "href", "#Logo-Text", 1, "drawText", "animateDraw"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1);
        ɵngcc0.ɵɵelementStart(2, "defs");
        ɵngcc0.ɵɵelementStart(3, "g", 2);
        ɵngcc0.ɵɵelement(4, "path", 3);
        ɵngcc0.ɵɵelement(5, "path", 4);
        ɵngcc0.ɵɵelement(6, "path", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "svg", 6);
        ɵngcc0.ɵɵelement(8, "use", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hide", !ctx.show);
    } }, encapsulation: 2 });
SpinnerComponent.ctorParameters = () => [
    { type: SpinnerService },
    { type: ChangeDetectorRef },
    { type: ErrorHandler }
];
SpinnerComponent.propDecorators = {
    show: [{ type: Input }],
    delayValue: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'elo-spinner',
                template: "<div class=\"content-loader loadOxy contain\" [class.hide]=\"!show\">\n  <svg version=\"1.2\" class=\"content-align\" baseProfile=\"tiny\" xmlns=\"http://www.w3.org/2000/svg\" xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n      <g class=\"animateDraw drawText\" id=\"Logo-Text\">\n        <path id=\"Caminho_129\" data-name=\"Caminho 129\" d=\"M206.58,240.235a19.448,19.448,0,1,0,19.448,19.448,19.448,19.448,0,0,0-19.448-19.448M208,270.5a10.909,10.909,0,1,1,9.4-9.4,10.914,10.914,0,0,1-9.4,9.4\" transform=\"translate(-187.132 -240.234)\"></path>\n        <path id=\"Caminho_130\" data-name=\"Caminho 130\" d=\"M352.5,240.234v19.43a10.906,10.906,0,1,1-21.811,0V245.131l-8.54-4.9v19.43A19.448,19.448,0,0,0,352.5,275.77v3.344a10.91,10.91,0,0,1-10.911,10.9H327.216l4.9,8.543h9.474a19.45,19.45,0,0,0,19.451-19.447V245.131Z\" transform=\"translate(-231.064 -240.234)\"></path>\n        <path id=\"Caminho_131\" data-name=\"Caminho 131\" d=\"M266.245,259.675l-11.96,8.825v10.615l19.154-14.132,19.155,14.132V268.5l-11.961-8.825,11.961-8.825V240.235l-19.155,14.132-19.154-14.132V250.85Z\" transform=\"translate(-208.982 -240.234)\"></path>\n      </g>\n    </defs>\n    <svg class=\"logo_loading\" viewBox=\"0 0 100 100\" space=\"preserveAspectRatio\">\n      <use id=\"Draw-Text\" class=\"drawText animateDraw\" href=\"#Logo-Text\"></use>\n    </svg>\n  </svg>\n</div>"
            }]
    }], function () { return [{ type: SpinnerService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ErrorHandler }]; }, { show: [{
            type: Input
        }], delayValue: [{
            type: Input
        }] }); })();

/**
 * Created by anderson on 25/10/16.
 */
class SpinnerModule {
}
SpinnerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SpinnerModule });
SpinnerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SpinnerModule_Factory(t) { return new (t || SpinnerModule)(); }, providers: [SpinnerService], imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SpinnerModule, { declarations: function () { return [SpinnerComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [SpinnerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpinnerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                declarations: [SpinnerComponent],
                exports: [SpinnerComponent],
                providers: [SpinnerService]
            }]
    }], null, null); })();

/**
 * Created by anderson on 25/10/16.
 */
class SwitchComponent {
    constructor() {
        this.disabled = false;
        this.hintPosition = 'center-right';
        this.onChangeValue = new EventEmitter();
        this.onChange = null;
        this.onTouched = null;
    }
    switchClickEvent() {
        if (!this.disabled) {
            this.active = !this.active;
            if (this.onChange) {
                this.onChange(this.active);
            }
            this.onChangeValue.emit(this.active);
        }
    }
    writeValue(obj) {
        this.active = obj;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
SwitchComponent.ɵfac = function SwitchComponent_Factory(t) { return new (t || SwitchComponent)(); };
SwitchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwitchComponent, selectors: [["elo-switch"]], inputs: { disabled: "disabled", hintPosition: "hintPosition", active: "active", caption: "caption", size: "size", hintMessage: "hintMessage" }, outputs: { onChangeValue: "onChangeValue" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: SwitchComponent }
        ])], decls: 5, vars: 14, consts: [[1, "switch-container"], [3, "click"], [3, "class", 4, "ngIf"], [1, "hint-content"]], template: function SwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "em", 1);
        ɵngcc0.ɵɵlistener("click", function SwitchComponent_Template_em_click_1_listener() { return ctx.switchClickEvent(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵlistener("click", function SwitchComponent_Template_span_click_2_listener() { return ctx.switchClickEvent(); });
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵtemplate(4, SwitchComponent_div_4_Template, 3, 4, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("switch ", ctx.size, "");
        ɵngcc0.ɵɵclassProp("active", ctx.active)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("switch-caption ", ctx.size, "");
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.caption, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hintMessage);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
SwitchComponent.propDecorators = {
    active: [{ type: Input }],
    disabled: [{ type: Input }],
    caption: [{ type: Input }],
    size: [{ type: Input }],
    hintMessage: [{ type: Input }],
    hintPosition: [{ type: Input }],
    onChangeValue: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchComponent, [{
        type: Component,
        args: [{
                selector: 'elo-switch',
                template: "<div class=\"switch-container\">\n  <em class=\"switch {{size}}\" [class.active]=\"active\" (click)=\"switchClickEvent()\" [class.disabled]=\"disabled\"></em>\n  <span [class.disabled]=\"disabled\" class=\"switch-caption {{size}}\" (click)=\"switchClickEvent()\">\n    {{caption}}\n    <div *ngIf=\"hintMessage\" class=\"hint sm clean fa-question-circle module-color inline {{ hintPosition }}\">\n      <div class=\"hint-content\">{{ hintMessage }}</div>\n    </div>\n  </span>\n</div>\n",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: SwitchComponent }
                ]
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], hintPosition: [{
            type: Input
        }], onChangeValue: [{
            type: Output
        }], active: [{
            type: Input
        }], caption: [{
            type: Input
        }], size: [{
            type: Input
        }], hintMessage: [{
            type: Input
        }] }); })();

/**
 * Created by anderson on 25/10/16.
 */
class SwitchModule {
}
SwitchModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SwitchModule });
SwitchModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SwitchModule_Factory(t) { return new (t || SwitchModule)(); }, imports: [[FormsModule, ReactiveFormsModule, CommonModule$1], FormsModule, ReactiveFormsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SwitchModule, { declarations: function () { return [SwitchComponent]; }, imports: function () { return [FormsModule, ReactiveFormsModule, CommonModule$1]; }, exports: function () { return [SwitchComponent, FormsModule, ReactiveFormsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchModule, [{
        type: NgModule,
        args: [{
                imports: [FormsModule, ReactiveFormsModule, CommonModule$1],
                declarations: [SwitchComponent],
                exports: [SwitchComponent, FormsModule, ReactiveFormsModule]
            }]
    }], null, null); })();

class TabItemComponent {
    constructor() {
        this.selected = false;
        this.visible = true;
        this.invalid = false;
        this.table = false;
    }
}
TabItemComponent.ɵfac = function TabItemComponent_Factory(t) { return new (t || TabItemComponent)(); };
TabItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TabItemComponent, selectors: [["elo-tab-item"]], inputs: { selected: "selected", visible: "visible", invalid: "invalid", table: "table", title: "title", badge: "badge" }, ngContentSelectors: _c0, decls: 2, vars: 5, consts: [["data-position", "0", 1, "tab-item-content", "mt-mb-none", 3, "hidden"]], template: function TabItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.selected)("table", ctx.table);
        ɵngcc0.ɵɵproperty("hidden", !ctx.selected);
    } }, encapsulation: 2 });
TabItemComponent.propDecorators = {
    title: [{ type: Input }],
    selected: [{ type: Input }],
    visible: [{ type: Input }],
    invalid: [{ type: Input }],
    table: [{ type: Input }],
    badge: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabItemComponent, [{
        type: Component,
        args: [{
                selector: 'elo-tab-item',
                template: "<div  class=\"tab-item-content mt-mb-none\" [class.active]=\"selected\" [class.table]=\"table\" data-position=\"0\" [hidden]=\"!selected\">\n   <ng-content></ng-content>\n</div>\n"
            }]
    }], function () { return []; }, { selected: [{
            type: Input
        }], visible: [{
            type: Input
        }], invalid: [{
            type: Input
        }], table: [{
            type: Input
        }], title: [{
            type: Input
        }], badge: [{
            type: Input
        }] }); })();

class TabControlComponent {
    constructor() {
        this.hasTableWithRecords = false;
        this.onSelected = new EventEmitter();
        this.hasBadge = false;
    }
    ngAfterContentInit() {
        let selectedTabs = this.tabs.filter(tab => tab.selected);
        if (selectedTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }
        else {
            this.selectTab(selectedTabs[0]);
        }
        this.hasBadge = this.tabs.some(this.existsBadge);
    }
    selectTab(tab) {
        this.tabs.forEach(tab => tab.selected = false);
        tab.selected = true;
        this.onSelected.emit({ selectedTab: tab });
    }
    selectTabByIndex(index) {
        let tabs = this.tabs.toArray();
        if (index in tabs) {
            this.selectTab(tabs[index]);
            return true;
        }
        else {
            return false;
        }
    }
    currentIndex() {
        for (let index in this.tabs.toArray()) {
            if (this.tabs.toArray()[index].selected) {
                return Number(index);
            }
        }
        return null;
    }
    selectTabOffset(offset) {
        let currentIndex = this.currentIndex();
        if (currentIndex === null)
            return false;
        if ((currentIndex + offset) in this.tabs.toArray()) {
            this.selectTabByIndex(currentIndex + offset);
            return true;
        }
        else {
            return false;
        }
    }
    selectTabNext(offset = 1) {
        return this.selectTabOffset(offset);
    }
    selectTabPrev(offset = 1) {
        return this.selectTabOffset(-offset);
    }
    get visibleTabs() {
        return this.tabs.filter(tab => tab.visible);
    }
    existsBadge(tab) {
        return typeof tab.badge === 'number' && tab.badge >= 0 || (tab.badge !== undefined && tab.badge !== null && tab.badge.length > 0);
    }
    getTabClass(tab) {
        return { 'active': tab.selected, 'invalid': tab.invalid, 'table': tab.table, 'has-badge': this.existsBadge(tab) };
    }
}
TabControlComponent.ɵfac = function TabControlComponent_Factory(t) { return new (t || TabControlComponent)(); };
TabControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TabControlComponent, selectors: [["elo-tab-control"]], contentQueries: function TabControlComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabItemComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabs = _t);
    } }, inputs: { hasTableWithRecords: "hasTableWithRecords", class: "class" }, outputs: { onSelected: "onSelected" }, ngContentSelectors: _c54, decls: 7, vars: 10, consts: [[1, "panel-body", 3, "ngClass"], [1, "panel-tab-selector", 3, "ngClass"], ["class", "tab-item-selector table ", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "panel-tab-content"], [1, "tab-item-selector", "table", 3, "ngClass", "click"], ["class", "badge", 4, "ngIf"], [1, "badge"]], template: function TabControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c51);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, TabControlComponent_div_3_Template, 3, 3, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c52, ctx.hasTableWithRecords));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("panel-tab ", ctx.class, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c53, ctx.hasBadge));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.visibleTabs);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf], encapsulation: 2 });
TabControlComponent.propDecorators = {
    tabs: [{ type: ContentChildren, args: [TabItemComponent,] }],
    class: [{ type: Input }],
    hasTableWithRecords: [{ type: Input }],
    onSelected: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabControlComponent, [{
        type: Component,
        args: [{
                selector: 'elo-tab-control',
                template: "<div class=\"panel-body\" [ngClass]=\"{'pb-none': hasTableWithRecords}\">\n  <div class=\"panel-tab {{class}}\">\n    <div class=\"panel-tab-selector\" [ngClass]=\"{'has-badge': hasBadge}\">\n      <div *ngFor=\"let tab of visibleTabs\"\n           (click)=\"selectTab(tab)\"\n           class=\"tab-item-selector table \"\n           [ngClass]=\"getTabClass(tab)\">\n        {{tab.title}}\n        <span *ngIf=\"tab.badge\" class=\"badge\">{{tab.badge}}</span>\n      </div>\n      <ng-content select=\"[buttons]\"></ng-content>\n    </div>\n    <div class=\"panel-tab-content\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { hasTableWithRecords: [{
            type: Input
        }], onSelected: [{
            type: Output
        }], tabs: [{
            type: ContentChildren,
            args: [TabItemComponent]
        }], class: [{
            type: Input
        }] }); })();

class TabControlModule {
}
TabControlModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TabControlModule });
TabControlModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TabControlModule_Factory(t) { return new (t || TabControlModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TabControlModule, { declarations: function () { return [TabControlComponent, TabItemComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [TabControlComponent, TabItemComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabControlModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [TabControlComponent, TabItemComponent],
                declarations: [TabControlComponent, TabItemComponent]
            }]
    }], null, null); })();

class WidgetFrequentlyComponent {
}
WidgetFrequentlyComponent.ɵfac = function WidgetFrequentlyComponent_Factory(t) { return new (t || WidgetFrequentlyComponent)(); };
WidgetFrequentlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WidgetFrequentlyComponent, selectors: [["widget-frequently"]], ngContentSelectors: _c0, decls: 3, vars: 0, consts: [[1, "cms-frequently"], [1, "cms-frequently-list"]], template: function WidgetFrequentlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵprojection(2, 0, ["selector", "widget-frequently-item"]);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetFrequentlyComponent, [{
        type: Component,
        args: [{
                selector: 'widget-frequently',
                template: "<div class=\"cms-frequently\">\n    <ul class=\"cms-frequently-list\">\n        <ng-content selector=\"widget-frequently-item\"></ng-content>\n    </ul>\n</div>"
            }]
    }], null, null); })();

class WidgetFrequentlyItemComponent {
    constructor(authHttp) {
        this.authHttp = authHttp;
    }
    ngOnInit() {
        this.hasPermission = this.authHttp.hasPermissionByRoute(this.routerLink);
    }
}
WidgetFrequentlyItemComponent.ɵfac = function WidgetFrequentlyItemComponent_Factory(t) { return new (t || WidgetFrequentlyItemComponent)(ɵngcc0.ɵɵdirectiveInject(AbstractAuthHttp)); };
WidgetFrequentlyItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WidgetFrequentlyItemComponent, selectors: [["widget-frequently-item"]], inputs: { routerLink: "routerLink", icone: "icone", title: "title", subTitle: "subTitle" }, decls: 2, vars: 3, consts: [["class", "item", 4, "ngIf"], [1, "item"], [3, "routerLink"], [1, "text"], [1, "text-inner"], [1, "father"], [1, "children"]], template: function WidgetFrequentlyItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, WidgetFrequentlyItemComponent_li_0_Template, 9, 6, "li", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.hasPermission));
    } }, directives: [ɵngcc2.NgIf, ɵngcc6.RouterLinkWithHref], pipes: [ɵngcc2.AsyncPipe], encapsulation: 2 });
WidgetFrequentlyItemComponent.ctorParameters = () => [
    { type: AbstractAuthHttp }
];
WidgetFrequentlyItemComponent.propDecorators = {
    routerLink: [{ type: Input }],
    icone: [{ type: Input }],
    title: [{ type: Input }],
    subTitle: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetFrequentlyItemComponent, [{
        type: Component,
        args: [{
                selector: 'widget-frequently-item',
                template: "<li class=\"item\" *ngIf=\"hasPermission | async\">\n    <a [routerLink]=\"routerLink\">\n        <em class=\"{{icone}}\"></em>\n        <div class=\"text\">\n            <div class=\"text-inner\">\n                <span class=\"father\">\n                    {{title}}\n                </span>\n                <div class=\"children\">\n                    {{subTitle}}\n                </div>\n            </div>\n        </div>\n    </a>\n</li>"
            }]
    }], function () { return [{ type: AbstractAuthHttp }]; }, { routerLink: [{
            type: Input
        }], icone: [{
            type: Input
        }], title: [{
            type: Input
        }], subTitle: [{
            type: Input
        }] }); })();

class WidgetFrequentlyItemModule {
}
WidgetFrequentlyItemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WidgetFrequentlyItemModule });
WidgetFrequentlyItemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WidgetFrequentlyItemModule_Factory(t) { return new (t || WidgetFrequentlyItemModule)(); }, providers: [], imports: [[CommonModule$1, RouterModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WidgetFrequentlyItemModule, { declarations: function () { return [WidgetFrequentlyItemComponent]; }, imports: function () { return [CommonModule$1, RouterModule]; }, exports: function () { return [WidgetFrequentlyItemComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetFrequentlyItemModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, RouterModule],
                declarations: [WidgetFrequentlyItemComponent],
                exports: [WidgetFrequentlyItemComponent],
                providers: []
            }]
    }], null, null); })();

class WidgetFrequentlyModule {
}
WidgetFrequentlyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WidgetFrequentlyModule });
WidgetFrequentlyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WidgetFrequentlyModule_Factory(t) { return new (t || WidgetFrequentlyModule)(); }, providers: [], imports: [[CommonModule$1, WidgetFrequentlyItemModule], WidgetFrequentlyItemModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WidgetFrequentlyModule, { declarations: function () { return [WidgetFrequentlyComponent]; }, imports: function () { return [CommonModule$1, WidgetFrequentlyItemModule]; }, exports: function () { return [WidgetFrequentlyComponent, WidgetFrequentlyItemModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetFrequentlyModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, WidgetFrequentlyItemModule],
                declarations: [WidgetFrequentlyComponent],
                exports: [WidgetFrequentlyComponent, WidgetFrequentlyItemModule],
                providers: []
            }]
    }], null, null); })();

class WidgetAreaComponent {
}
WidgetAreaComponent.ɵfac = function WidgetAreaComponent_Factory(t) { return new (t || WidgetAreaComponent)(); };
WidgetAreaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WidgetAreaComponent, selectors: [["elo-widget-area"]], ngContentSelectors: _c0, decls: 2, vars: 0, consts: [[1, "row", "widget-area"]], template: function WidgetAreaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1, 0, ["selector", "elo-widget-panel"]);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetAreaComponent, [{
        type: Component,
        args: [{
                selector: 'elo-widget-area',
                template: "<div class=\"row widget-area\">\n  <ng-content selector=\"elo-widget-panel\"></ng-content>\n</div>\n"
            }]
    }], null, null); })();

class WidgetHighlightComponent {
}
WidgetHighlightComponent.ɵfac = function WidgetHighlightComponent_Factory(t) { return new (t || WidgetHighlightComponent)(); };
WidgetHighlightComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WidgetHighlightComponent, selectors: [["elo-widget-highlight"]], inputs: { text: "text", subtitle: "subtitle" }, ngContentSelectors: _c56, decls: 7, vars: 2, consts: [["widget-body", "", 1, "widget-highlight"], [1, "widget-highlight-text"], [1, "widget-highlight-subtitle"], [1, "widget-highlight-detail"]], template: function WidgetHighlightComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c55);
        ɵngcc0.ɵɵelementStart(0, "article", 0);
        ɵngcc0.ɵɵelementStart(1, "b", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "p", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.text);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.subtitle);
    } }, encapsulation: 2 });
WidgetHighlightComponent.propDecorators = {
    text: [{ type: Input }],
    subtitle: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetHighlightComponent, [{
        type: Component,
        args: [{
                selector: 'elo-widget-highlight',
                template: "  <article class=\"widget-highlight\" widget-body>\n    <b class=\"widget-highlight-text\">{{text}}</b>\n    <p class=\"widget-highlight-subtitle\">{{subtitle}}</p>\n    <div class=\"widget-highlight-detail\">\n      <ng-content select=\"[highlight-detail]\"></ng-content>\n    </div>\n  </article>\n"
            }]
    }], null, { text: [{
            type: Input
        }], subtitle: [{
            type: Input
        }] }); })();

class WidgetNumericComponent {
}
WidgetNumericComponent.ɵfac = function WidgetNumericComponent_Factory(t) { return new (t || WidgetNumericComponent)(); };
WidgetNumericComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WidgetNumericComponent, selectors: [["elo-widget-numeric"]], inputs: { numeric: "numeric", subtitle: "subtitle" }, decls: 5, vars: 2, consts: [["widget-body", "", 1, "widget-numeric"], [1, "widget-numeric-number"], [1, "widget-numeric-subtitle"]], template: function WidgetNumericComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "article", 0);
        ɵngcc0.ɵɵelementStart(1, "b", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "p", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.numeric);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.subtitle);
    } }, encapsulation: 2 });
WidgetNumericComponent.propDecorators = {
    numeric: [{ type: Input }],
    subtitle: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetNumericComponent, [{
        type: Component,
        args: [{
                selector: 'elo-widget-numeric',
                template: "  <article class=\"widget-numeric\" widget-body>\n    <b class=\"widget-numeric-number\">{{numeric}}</b>\n    <p class=\"widget-numeric-subtitle\">{{subtitle}}</p>\n  </article>\n"
            }]
    }], null, { numeric: [{
            type: Input
        }], subtitle: [{
            type: Input
        }] }); })();

class WidgetPanelComponent {
    constructor() {
        this.smCols = 6;
        this.mdCols = 4;
        this.smOffsetCols = 3;
        this.mdOffsetCols = 4;
    }
}
WidgetPanelComponent.ɵfac = function WidgetPanelComponent_Factory(t) { return new (t || WidgetPanelComponent)(); };
WidgetPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WidgetPanelComponent, selectors: [["elo-widget-panel"]], inputs: { smCols: "smCols", mdCols: "mdCols", smOffsetCols: "smOffsetCols", mdOffsetCols: "mdOffsetCols", iconClass: "iconClass" }, ngContentSelectors: _c58, decls: 8, vars: 7, consts: [[1, "panel", "widget"], ["class", "widget-icon", 4, "ngIf"], [1, "panel-title"], [1, "panel-body"], [1, "widget-icon"]], template: function WidgetPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c57);
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtemplate(2, WidgetPanelComponent_span_2_Template, 2, 3, "span", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(7, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate4("col-sm-", ctx.smCols, " col-md-", ctx.mdCols, " col-md-offset-", ctx.mdOffsetCols, " col-sm-offset-", ctx.smOffsetCols, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconClass);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
WidgetPanelComponent.propDecorators = {
    smCols: [{ type: Input }],
    mdCols: [{ type: Input }],
    smOffsetCols: [{ type: Input }],
    mdOffsetCols: [{ type: Input }],
    iconClass: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetPanelComponent, [{
        type: Component,
        args: [{
                selector: 'elo-widget-panel',
                template: "<div class=\"col-sm-{{smCols}} col-md-{{mdCols}} col-md-offset-{{mdOffsetCols}} col-sm-offset-{{smOffsetCols}}\">\n  <div class='panel widget'>\n    <span *ngIf='iconClass' class='widget-icon'>\n\t\t\t\t\t\t<em class=\"{{iconClass}}\"></em>\n\t\t\t\t\t</span>\n\n    <div class='panel-title'>\n      <ng-content select=\"[widget-title]\"></ng-content>\n    </div>\n\n    <div class='panel-body'>\n      <ng-content select=\"[widget-body]\"></ng-content>\n    </div>\n\n    <ng-content select=\"[widget-footer]\">\n    </ng-content>\n\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { smCols: [{
            type: Input
        }], mdCols: [{
            type: Input
        }], smOffsetCols: [{
            type: Input
        }], mdOffsetCols: [{
            type: Input
        }], iconClass: [{
            type: Input
        }] }); })();

class WidgetProgressComponent {
    constructor() {
        /**
        * @param classType positive, negative or neutral
        */
        this.classType = 'neutral';
    }
}
WidgetProgressComponent.ɵfac = function WidgetProgressComponent_Factory(t) { return new (t || WidgetProgressComponent)(); };
WidgetProgressComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WidgetProgressComponent, selectors: [["elo-widget-progress"]], inputs: { classType: "classType", progress: "progress", title: "title", subtitle: "subtitle" }, ngContentSelectors: _c60, decls: 12, vars: 8, consts: [["id", "widgetProgress", 1, "panel", "widget", "widget-same-height", "mt-none"], [1, "panel-body", "center"], [1, "widget-numeric"], ["id", "progressbarCenter"], ["id", "progress"], [1, "progressbar-circle-content-outer"], [1, "progressbar-circle-content"], ["id", "title", 1, "progressbar-circle-title"], ["id", "subtitle", 1, "widget-numeric-subtitle"]], template: function WidgetProgressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c59);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "article", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "h2", 7);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "p", 8);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassMapInterpolate1("progressbar-circle center ", ctx.classType, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("reach-", ctx.progress, " progressbar-circle-reacher");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.subtitle);
    } }, encapsulation: 2 });
WidgetProgressComponent.propDecorators = {
    classType: [{ type: Input }],
    progress: [{ type: Input }],
    title: [{ type: Input }],
    subtitle: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetProgressComponent, [{
        type: Component,
        args: [{
                selector: 'elo-widget-progress',
                template: "<div id=\"widgetProgress\" class=\"panel widget widget-same-height mt-none\">\n  <div class=\"panel-body center\">\n    <article class=\"widget-numeric\">\n      <div id=\"progressbarCenter\" class=\"progressbar-circle center {{classType}}\">\n        <div id=\"progress\" class=\"reach-{{progress}} progressbar-circle-reacher\"></div>\n        <div class=\"progressbar-circle-content-outer\">\n          <div class=\"progressbar-circle-content\">\n            <h2 id=\"title\" class=\"progressbar-circle-title\">{{title}}</h2>\n          </div>\n        </div>\n      </div>\n      <p id=\"subtitle\" class=\"widget-numeric-subtitle\">{{subtitle}}</p>\n    </article>\n  </div>\n\n  <ng-content select=\"[progress-detail]\"></ng-content>\n\n</div>"
            }]
    }], function () { return []; }, { classType: [{
            type: Input
        }], progress: [{
            type: Input
        }], title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }] }); })();

class WidgetModule {
}
WidgetModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WidgetModule });
WidgetModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WidgetModule_Factory(t) { return new (t || WidgetModule)(); }, imports: [[CommonModule$1]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WidgetModule, { declarations: function () { return [WidgetAreaComponent, WidgetPanelComponent, WidgetNumericComponent, WidgetHighlightComponent, WidgetProgressComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [WidgetAreaComponent, WidgetPanelComponent, WidgetNumericComponent, WidgetHighlightComponent, WidgetProgressComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WidgetModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1],
                exports: [
                    WidgetAreaComponent,
                    WidgetPanelComponent,
                    WidgetNumericComponent,
                    WidgetHighlightComponent,
                    WidgetProgressComponent
                ],
                declarations: [
                    WidgetAreaComponent,
                    WidgetPanelComponent,
                    WidgetNumericComponent,
                    WidgetHighlightComponent,
                    WidgetProgressComponent
                ]
            }]
    }], null, null); })();

class WizardStepComponent {
    constructor() {
        this.selected = false;
        this.visible = true;
        this.valid = true;
        this.triedToValidate = false;
        this.done = false;
        this.showErrorMessage = false;
        this.validateStep = () => of(true);
    }
    resetState() {
        this.valid = true;
        this.triedToValidate = false;
    }
}
WizardStepComponent.ɵfac = function WizardStepComponent_Factory(t) { return new (t || WizardStepComponent)(); };
WizardStepComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WizardStepComponent, selectors: [["elo-wizard-step"]], inputs: { selected: "selected", visible: "visible", valid: "valid", triedToValidate: "triedToValidate", done: "done", showErrorMessage: "showErrorMessage", validateStep: "validateStep", title: "title", invalidMessage: "invalidMessage", icon: "icon", order: "order" }, ngContentSelectors: _c0, decls: 2, vars: 1, consts: [[3, "hidden"]], template: function WizardStepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.selected);
    } }, encapsulation: 2 });
WizardStepComponent.propDecorators = {
    title: [{ type: Input }],
    selected: [{ type: Input }],
    visible: [{ type: Input }],
    valid: [{ type: Input }],
    invalidMessage: [{ type: Input }],
    triedToValidate: [{ type: Input }],
    icon: [{ type: Input }],
    done: [{ type: Input }],
    showErrorMessage: [{ type: Input }],
    order: [{ type: Input }],
    validateStep: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WizardStepComponent, [{
        type: Component,
        args: [{
                selector: 'elo-wizard-step',
                template: "<div [hidden]=\"!selected\">\n    <ng-content></ng-content>\n </div>"
            }]
    }], function () { return []; }, { selected: [{
            type: Input
        }], visible: [{
            type: Input
        }], valid: [{
            type: Input
        }], triedToValidate: [{
            type: Input
        }], done: [{
            type: Input
        }], showErrorMessage: [{
            type: Input
        }], validateStep: [{
            type: Input
        }], title: [{
            type: Input
        }], invalidMessage: [{
            type: Input
        }], icon: [{
            type: Input
        }], order: [{
            type: Input
        }] }); })();

class WizardControlComponent {
    constructor() {
        this.onSelected = new EventEmitter();
        this.onClosed = new EventEmitter();
        this.onFinalized = new EventEmitter();
        this.saveAnyStep = false;
        this.previousButtonOn = false;
        this.nextButtonOn = true;
        this.cancelButtonOn = true;
        this.finishButtonOn = true;
        this.showSave = true;
        this.showBackButton = true;
        this.useDynamicOrder = false;
        this.saveButtonOn = false;
    }
    ngAfterContentInit() {
        if (this.useDynamicOrder) {
            const invalidOrder = this.steps.toArray().find(item => !item.order || isNaN(item.order));
            if (invalidOrder) {
                throw new Error('Obrigatório informar [order] para todos os steps');
            }
            this.steps.reset(this.steps.toArray().sort((a, b) => a.order - b.order));
        }
        this.saveButtonOn = this.finishButtonOn;
        let selectedStep = this.steps.filter(step => step.selected);
        if (!selectedStep.length) {
            this.selectStep(this.steps.first);
        }
        else {
            this.selectStep(selectedStep[0]);
        }
    }
    selectStep(step, button) {
        let positionSelectedStep;
        let selectedStep = this.steps.filter((step, index) => {
            if (step.selected) {
                positionSelectedStep = index;
                return step.selected;
            }
        });
        let positionCurrentStep = this.steps.toArray().indexOf(step);
        if (selectedStep.length) {
            if (positionCurrentStep !== positionSelectedStep) {
                let index;
                if (button === 'previous' && this.previousButtonOn || positionCurrentStep >= 0 && positionCurrentStep < positionSelectedStep) {
                    index = button ? positionSelectedStep - 1 : positionCurrentStep;
                    selectedStep[0].done = false;
                    if (!selectedStep[0].valid && selectedStep[0].showErrorMessage) {
                        selectedStep[0].showErrorMessage = false;
                    }
                    this.steps.forEach((step, s) => {
                        if (s >= index) {
                            step.done = false;
                        }
                    });
                }
                if (button === 'next' || positionCurrentStep > positionSelectedStep) {
                    selectedStep[0]
                        .validateStep()
                        .subscribe(isValid => {
                        if (!isValid) {
                            return;
                        }
                        if (selectedStep[0].valid) {
                            index = button ? positionSelectedStep + 1 : positionCurrentStep;
                            if (this.steps.toArray()[index]) {
                                selectedStep[0].done = true;
                                this.steps.forEach((step, s) => {
                                    if (s < index) {
                                        if (step.valid) {
                                            step.done = true;
                                        }
                                        else {
                                            index = s;
                                            this.steps.toArray()[index].triedToValidate = true;
                                            this.validation(this.steps.toArray()[index]);
                                        }
                                    }
                                });
                            }
                        }
                        else {
                            this.validation(selectedStep[0]);
                        }
                        if (this.steps.toArray()[index]) {
                            selectedStep[0].selected = false;
                            this.steps.toArray()[index].selected = true;
                            this.steps.toArray()[index].done = false;
                            this.onSelected.emit({ selectedStep: this.steps.toArray()[index] });
                        }
                        this.updateButtons();
                    });
                }
                else {
                    if (this.steps.toArray()[index]) {
                        selectedStep[0].selected = false;
                        this.steps.toArray()[index].selected = true;
                        this.steps.toArray()[index].done = false;
                        this.onSelected.emit({ selectedStep: this.steps.toArray()[index] });
                    }
                    this.updateButtons();
                }
            }
            else {
                this.validation(selectedStep[0]);
            }
        }
        else {
            step.selected = true;
            this.onSelected.emit({ selectedStep: step });
            this.updateButtons();
        }
    }
    closeButtonClick() {
        let selectedStep = this.steps.filter(step => step.selected);
        this.onClosed.emit({ currentStep: selectedStep[0] });
    }
    finalizeButtonClick() {
        let invalidStep = this.steps.filter(step => !step.valid);
        if (!invalidStep.length) {
            let selectedStep = this.steps.filter(step => step.selected);
            this.onFinalized.emit({ currentStep: selectedStep[0] });
        }
        else {
            return false;
        }
    }
    validation(step) {
        step.triedToValidate = true;
        setTimeout(() => {
            setTimeout(() => {
                step.showErrorMessage = false;
            }, 4000);
            step.showErrorMessage = true;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 200);
    }
    updateButtons() {
        let stepsDone = this.steps.filter((step) => step.done);
        if (stepsDone.length) {
            this.previousButtonOn = true;
        }
        else {
            this.previousButtonOn = false;
            this.nextButtonOn = true;
        }
        if (stepsDone.length === this.steps.toArray().length - 1) {
            this.nextButtonOn = false;
            this.saveButtonOn = true;
        }
        else {
            this.nextButtonOn = true;
            if (!this.saveAnyStep) {
                this.saveButtonOn = false;
            }
        }
    }
    get allSteps() {
        return this.steps.filter(step => step.visible);
    }
}
WizardControlComponent.ɵfac = function WizardControlComponent_Factory(t) { return new (t || WizardControlComponent)(); };
WizardControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WizardControlComponent, selectors: [["elo-wizard-control"]], contentQueries: function WizardControlComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, WizardStepComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.steps = _t);
    } }, inputs: { saveAnyStep: "saveAnyStep", previousButtonOn: "previousButtonOn", nextButtonOn: "nextButtonOn", cancelButtonOn: "cancelButtonOn", finishButtonOn: "finishButtonOn", showSave: "showSave", showBackButton: "showBackButton", useDynamicOrder: "useDynamicOrder", extraButtonsTemplate: "extraButtonsTemplate" }, outputs: { onSelected: "onSelected", onClosed: "onClosed", onFinalized: "onFinalized" }, ngContentSelectors: _c0, decls: 12, vars: 5, consts: [[1, "wizard", "title"], [1, "wizard-header"], ["class", "step", 3, "active", "on", "click", 4, "ngFor", "ngForOf"], [1, "wizard-content"], [1, "footer-wizard"], ["type", "button", "id", "previousButton", 1, "btn", "btn-step-backward", "neutral", "inline", 3, "disabled", "click"], ["id", "nextButton", "type", "button", "class", "btn btn-step-forward module-color", 3, "disabled", "click", 4, "ngIf"], ["id", "saveButton", "type", "button", "class", "btn btn-step-forward module-color", "singleClickButton", "", 3, "disabled", "click", 4, "ngIf"], ["class", "extra-buttons", "role", "group", "id", "extraButtonsTemplate", 4, "ngIf"], [1, "step", 3, "click"], ["class", "error-content", 4, "ngIf"], [1, "title", 3, "id"], [1, "error-content"], ["id", "nextButton", "type", "button", 1, "btn", "btn-step-forward", "module-color", 3, "disabled", "click"], ["id", "saveButton", "type", "button", "singleClickButton", "", 1, "btn", "btn-step-forward", "module-color", 3, "disabled", "click"], ["role", "group", "id", "extraButtonsTemplate", 1, "extra-buttons"], [4, "ngTemplateOutlet"]], template: function WizardControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "elo-panel");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "ul", 1);
        ɵngcc0.ɵɵtemplate(3, WizardControlComponent_li_3_Template, 5, 10, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul", 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function WizardControlComponent_Template_button_click_7_listener() { return ctx.selectStep(null, "previous"); });
        ɵngcc0.ɵɵtext(8, "Anterior");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, WizardControlComponent_button_9_Template, 2, 1, "button", 6);
        ɵngcc0.ɵɵtemplate(10, WizardControlComponent_button_10_Template, 2, 1, "button", 7);
        ɵngcc0.ɵɵtemplate(11, WizardControlComponent_div_11_Template, 2, 1, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.allSteps);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", !ctx.previousButtonOn);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.nextButtonOn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.nextButtonOn && ctx.saveButtonOn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.extraButtonsTemplate);
    } }, directives: [PanelComponent, ɵngcc2.NgForOf, ɵngcc2.NgIf, SingleClickButtonDirective, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
WizardControlComponent.propDecorators = {
    steps: [{ type: ContentChildren, args: [WizardStepComponent,] }],
    onSelected: [{ type: Output }],
    onClosed: [{ type: Output }],
    onFinalized: [{ type: Output }],
    saveAnyStep: [{ type: Input }],
    previousButtonOn: [{ type: Input }],
    nextButtonOn: [{ type: Input }],
    cancelButtonOn: [{ type: Input }],
    finishButtonOn: [{ type: Input }],
    showSave: [{ type: Input }],
    showBackButton: [{ type: Input }],
    useDynamicOrder: [{ type: Input }],
    extraButtonsTemplate: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WizardControlComponent, [{
        type: Component,
        args: [{
                selector: 'elo-wizard-control',
                template: "<elo-panel>\n  <div class=\"wizard title\">\n    <ul class=\"wizard-header\">\n      <li class=\"step\" *ngFor=\"let step of allSteps\" [class.active]=\"step.selected || step.done\"\n        [class.on]=\"step.showErrorMessage\" (click)=\"selectStep(step)\"\n        [attr.data-error]=\"!step.valid && step.triedToValidate\">\n        <em [class]=\"step.icon\"></em>\n        <p class=\"error-content\" *ngIf=\"!step.valid && step.triedToValidate\">{{step.invalidMessage}}</p>\n        <div class=\"title\" id=\"idStep_{{steps?.toArray()?.indexOf(step)}}\">\n          {{step.title}}\n        </div>\n      </li>\n    </ul>\n    <ul class=\"wizard-content\">\n      <ng-content></ng-content>\n    </ul>\n    <!-- wizard -->\n    <div class=\"footer-wizard\">\n\n      <button (click)=\"selectStep(null, 'previous')\" type=\"button\" id=\"previousButton\"\n        class=\"btn btn-step-backward neutral inline\" [disabled]=\"!previousButtonOn\">Anterior</button>\n      <button *ngIf=\"nextButtonOn\" (click)=\"selectStep(null, 'next')\" id=\"nextButton\" type=\"button\"\n        class=\"btn btn-step-forward module-color\" [disabled]=\"!nextButtonOn\">Pr\u00F3ximo</button>\n      <button *ngIf=\"!nextButtonOn && saveButtonOn\" id=\"saveButton\" (click)=\"finalizeButtonClick()\" type=\"button\"\n        class=\"btn btn-step-forward module-color\" [disabled]=\"!finishButtonOn\" singleClickButton>Finalizar</button>\n\n      <div class=\"extra-buttons\" role=\"group\" *ngIf=\"extraButtonsTemplate\" id=\"extraButtonsTemplate\">\n        <ng-container *ngTemplateOutlet=\"extraButtonsTemplate\"></ng-container>\n      </div>\n\n    </div>\n  </div>\n</elo-panel>"
            }]
    }], function () { return []; }, { onSelected: [{
            type: Output
        }], onClosed: [{
            type: Output
        }], onFinalized: [{
            type: Output
        }], saveAnyStep: [{
            type: Input
        }], previousButtonOn: [{
            type: Input
        }], nextButtonOn: [{
            type: Input
        }], cancelButtonOn: [{
            type: Input
        }], finishButtonOn: [{
            type: Input
        }], showSave: [{
            type: Input
        }], showBackButton: [{
            type: Input
        }], useDynamicOrder: [{
            type: Input
        }], steps: [{
            type: ContentChildren,
            args: [WizardStepComponent]
        }], extraButtonsTemplate: [{
            type: Input
        }] }); })();

class WizardControlModule {
}
WizardControlModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WizardControlModule });
WizardControlModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WizardControlModule_Factory(t) { return new (t || WizardControlModule)(); }, imports: [[CommonModule$1, PanelModule, DirectivesModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WizardControlModule, { declarations: function () { return [WizardControlComponent, WizardStepComponent]; }, imports: function () { return [CommonModule$1, PanelModule, DirectivesModule]; }, exports: function () { return [WizardControlComponent, WizardStepComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WizardControlModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, PanelModule, DirectivesModule],
                exports: [WizardControlComponent, WizardStepComponent],
                declarations: [WizardControlComponent, WizardStepComponent]
            }]
    }], null, null); })();

class RotaFavoritaService extends EntityService {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.atalhos = new Array(8).fill({});
        this.quantidadeMax = true;
        this.resource = '/api/rota-favorita';
    }
    isRotaFavorita(route) {
        if (this.atalhos.find(atalho => atalho.rota === route)) {
            return true;
        }
        return false;
    }
    refresh() {
        return new Promise((resolve) => {
            this.httpClient.get({
                resource: `${this.resource}/me`,
            }).subscribe(rotas => {
                this.atalhos = rotas;
                this.quantidadeMax = true;
                while (this.atalhos.length < 8) {
                    this.quantidadeMax = false;
                    this.atalhos.push({ icone: 'fa fa-star-o' });
                }
                resolve(true);
            });
        });
    }
    getMinhasRotasFavoritas() {
        return this.atalhos;
    }
    create(rotaFavorita) {
        return this.httpClient.post({
            resource: `${this.resource}/add`,
            body: rotaFavorita,
        });
    }
}
RotaFavoritaService.ɵfac = function RotaFavoritaService_Factory(t) { return new (t || RotaFavoritaService)(ɵngcc0.ɵɵinject(HttpClient)); };
RotaFavoritaService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: RotaFavoritaService, factory: RotaFavoritaService.ɵfac });
RotaFavoritaService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RotaFavoritaService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class RodaAtalhosComponent {
    constructor(_rotaFavoritaService, _router) {
        this._rotaFavoritaService = _rotaFavoritaService;
        this._router = _router;
        this.enabled = true;
        this.atalhos = new Array(8).fill({});
        this.active = false;
        this.atalhoSelecionado = {};
    }
    ngOnInit() {
        this._carregarAtalhos();
    }
    handleKeyboardEvent(event) {
        if (this.enabled && this.ctrlAlt(event)) {
            this.openCloseTheBar();
            return;
        }
        if (event.code === 'Escape' && this.active) {
            this._close();
            return;
        }
    }
    openCloseTheBar() {
        this._carregarAtalhos();
        this.active = !this.active;
    }
    ocultarRodaEventosQuandoForaItemMenu(evento) {
        if (evento.target.className === 'shortcut-wheel' || evento.target.className === 'shortcut-wheel-container') {
            this._close();
        }
    }
    navegarPara(atalho) {
        if (!atalho.rota) {
            return;
        }
        this._router.navigate([atalho.rota]).then(() => {
            this.active = false;
        });
    }
    mouseEnter(atalho) {
        this.atalhoSelecionado = atalho;
        if (!this.atalhoSelecionado.id) {
            this.atalhoSelecionado.descricao = 'Posição não utilizada';
        }
    }
    mouseLeave() {
        this.atalhoSelecionado = {};
    }
    _carregarAtalhos() {
        this.atalhos = this._rotaFavoritaService.getMinhasRotasFavoritas();
    }
    ctrlAlt(event) {
        return event.ctrlKey &&
            event.altKey;
    }
    _close() {
        this.active = false;
    }
}
RodaAtalhosComponent.ɵfac = function RodaAtalhosComponent_Factory(t) { return new (t || RodaAtalhosComponent)(ɵngcc0.ɵɵdirectiveInject(RotaFavoritaService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router)); };
RodaAtalhosComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RodaAtalhosComponent, selectors: [["roda-atalhos"]], hostBindings: function RodaAtalhosComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function RodaAtalhosComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { enabled: "enabled" }, decls: 5, vars: 5, consts: [[1, "shortcut-wheel-container", 3, "click"], [1, "shortcut-wheel"], ["class", "shortcut-wheel-item", 3, "click", "mouseenter", "mouseleave", 4, "ngFor", "ngForOf"], ["class", "shortcut-wheel-description", 4, "ngIf"], [1, "shortcut-wheel-item", 3, "click", "mouseenter", "mouseleave"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 179.02 91.18"], ["id", "Camada_2", "data-name", "Camada 2"], ["id", "Camada_1-2", "data-name", "Camada 1"], ["d", "M176.33,15A247.08,247.08,0,0,0,2.63,16.53,4.08,4.08,0,0,0,.32,21.92l1.13,2.65a4,4,0,0,1,2.32-5.16,243.91,243.91,0,0,1,171.41-1.5,4,4,0,0,1,2.37,5.28L151.4,87.9a2.29,2.29,0,0,0,.14-.27l27.18-67.27A4.07,4.07,0,0,0,176.33,15Z"], ["d", "M175.18,17.91A243.91,243.91,0,0,0,3.77,19.41a4,4,0,0,0-2.32,5.16L28.67,88.7a4,4,0,0,0,5.1,2.23,166.78,166.78,0,0,1,112.7-1,4,4,0,0,0,4.93-2l26.15-64.71A4,4,0,0,0,175.18,17.91Z"], [1, "shortcut-wheel-description"]], template: function RodaAtalhosComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function RodaAtalhosComponent_Template_div_click_0_listener($event) { return ctx.ocultarRodaEventosQuandoForaItemMenu($event); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, RodaAtalhosComponent_div_2_Template, 8, 3, "div", 2);
        ɵngcc0.ɵɵtemplate(3, RodaAtalhosComponent_p_3_Template, 2, 0, "p", 3);
        ɵngcc0.ɵɵtemplate(4, RodaAtalhosComponent_p_4_Template, 2, 1, "p", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hidden", !ctx.active);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.atalhos);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.atalhoSelecionado);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.atalhoSelecionado);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf], styles: ["[_nghost-%COMP%] i:after{content:none!important}"] });
RodaAtalhosComponent.ctorParameters = () => [
    { type: RotaFavoritaService },
    { type: Router }
];
RodaAtalhosComponent.propDecorators = {
    enabled: [{ type: Input }],
    handleKeyboardEvent: [{ type: HostListener, args: ['document:keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RodaAtalhosComponent, [{
        type: Component,
        args: [{
                selector: 'roda-atalhos',
                template: "<div class=\"shortcut-wheel-container\" (click)=\"ocultarRodaEventosQuandoForaItemMenu($event)\" [class.hidden]=\"!active\">\n  <div class=\"shortcut-wheel\">\n\n    <div class=\"shortcut-wheel-item\"\n         *ngFor=\"let atalho of atalhos\"\n         (click)=\"navegarPara(atalho)\"\n         (mouseenter)=\"mouseEnter(atalho)\"\n         (mouseleave)=\"mouseLeave()\"><i class=\"{{atalho.icone}}\"></i>\n      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 179.02 91.18\">\n        <g id=\"Camada_2\" data-name=\"Camada 2\">\n          <g id=\"Camada_1-2\" data-name=\"Camada 1\">\n            <path\n              d=\"M176.33,15A247.08,247.08,0,0,0,2.63,16.53,4.08,4.08,0,0,0,.32,21.92l1.13,2.65a4,4,0,0,1,2.32-5.16,243.91,243.91,0,0,1,171.41-1.5,4,4,0,0,1,2.37,5.28L151.4,87.9a2.29,2.29,0,0,0,.14-.27l27.18-67.27A4.07,4.07,0,0,0,176.33,15Z\"></path>\n            <path\n              d=\"M175.18,17.91A243.91,243.91,0,0,0,3.77,19.41a4,4,0,0,0-2.32,5.16L28.67,88.7a4,4,0,0,0,5.1,2.23,166.78,166.78,0,0,1,112.7-1,4,4,0,0,0,4.93-2l26.15-64.71A4,4,0,0,0,175.18,17.91Z\"></path>\n            <path\n              d=\"M175.18,17.91A243.91,243.91,0,0,0,3.77,19.41a4,4,0,0,0-2.32,5.16L28.67,88.7a4,4,0,0,0,5.1,2.23,166.78,166.78,0,0,1,112.7-1,4,4,0,0,0,4.93-2l26.15-64.71A4,4,0,0,0,175.18,17.91Z\"></path>\n          </g>\n        </g>\n      </svg>\n    </div>\n\n    <p class=\"shortcut-wheel-description\" *ngIf=\"!atalhoSelecionado\">Selecione ou digite o n\u00FAmero da op\u00E7\u00E3o desejada</p>\n    <p class=\"shortcut-wheel-description\" *ngIf=\"atalhoSelecionado\">{{atalhoSelecionado.descricao}}</p>\n  </div>\n</div> \n",
                styles: [":host>>>i:after{content:none!important}"]
            }]
    }], function () { return [{ type: RotaFavoritaService }, { type: ɵngcc6.Router }]; }, { enabled: [{
            type: Input
        }], handleKeyboardEvent: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }] }); })();

class RodaAtalhosModule {
}
RodaAtalhosModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: RodaAtalhosModule });
RodaAtalhosModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function RodaAtalhosModule_Factory(t) { return new (t || RodaAtalhosModule)(); }, imports: [[
            CommonModule$1
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RodaAtalhosModule, { declarations: function () { return [RodaAtalhosComponent]; }, imports: function () { return [CommonModule$1]; }, exports: function () { return [RodaAtalhosComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RodaAtalhosModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1
                ],
                declarations: [
                    RodaAtalhosComponent,
                ],
                exports: [
                    RodaAtalhosComponent,
                ]
            }]
    }], null, null); })();

class ExceptionHandlerComponent {
    constructor(changeDetectorRef, exceptionHandler, authHttp, notification, baseHref) {
        this.changeDetectorRef = changeDetectorRef;
        this.exceptionHandler = exceptionHandler;
        this.authHttp = authHttp;
        this.notification = notification;
        this.baseHref = baseHref;
        this.errorFKtoNotification = false;
        this.http500 = 500;
        this.http401Unauthorized = 401;
        this.isHttpError = false;
        this.sameError = null;
        this.showReiniciarButton = false;
        this.showError = false;
        this.suggestion = false;
        this.existSuggestion = false;
        if (typeof (this.baseHref) === 'undefined' || this.baseHref === null) {
            this.baseHref = '/';
        }
        if (this.exceptionHandler instanceof GlobalExceptionHandlerService) {
            this.subscribe(this.exceptionHandler);
        }
    }
    subscribe(globalExceptionHandlerService) {
        this.subscription = globalExceptionHandlerService.observers.subscribe((error) => {
            this.handleException(error);
            if (this.validExistSuggestion(error)) {
                this.existSuggestion = true;
            }
            else {
                this.suggestion = false;
                this.existSuggestion = false;
            }
        });
    }
    onBack() {
        location.replace(this.baseHref);
    }
    onClose() {
        this.showError = false;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    onClickMoreInfo() {
        this.suggestion = false;
        this.moreInfo = !this.moreInfo;
    }
    onClickSuggestion() {
        this.suggestion = !this.suggestion;
        this.moreInfo = false;
    }
    handleException(error) {
        this.error = error;
        this.isHttpError = this.error instanceof HttpError;
        if (this.isHttpError && this.error.status === this.http401Unauthorized) {
            this.showError = false;
            console.debug('logoutAndGoToAuthForm by server exception');
            this.authHttp.logoutAndGoToAuthForm();
        }
        else if (this.isHttpError && this.errorFKtoNotification && this.isError500FK(this.error)) {
            this.showError = false;
            this.notification.error('Este registro não pode ser excluído', 'Existem outros registros que dependem dele.');
        }
        else {
            if (this.sameError && this.sameError.name === this.error.name && !this.isHttpError) {
                this.showReiniciarButton = true;
            }
            else {
                this.sameError = this.error;
            }
            this.showError = true;
        }
        this.changeDetectorRef.detectChanges();
        if (this.showError) {
            document.getElementById('okButton').focus();
        }
    }
    validExistSuggestion(error) {
        let exist = false;
        if (error && error.violations) {
            error.violations.forEach(violation => {
                if (violation.suggestion) {
                    exist = true;
                }
            });
        }
        return exist;
    }
    isError500FK(error) {
        if (error && error.message === 'Este registro não pode ser excluído. Existem outros registros que dependem dele.'
            && this.error.status === this.http500) {
            return true;
        }
        return false;
    }
}
ExceptionHandlerComponent.ɵfac = function ExceptionHandlerComponent_Factory(t) { return new (t || ExceptionHandlerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ErrorHandler), ɵngcc0.ɵɵdirectiveInject(AbstractAuthHttp), ɵngcc0.ɵɵdirectiveInject(EloNotificationService), ɵngcc0.ɵɵdirectiveInject(APP_BASE_HREF, 8)); };
ExceptionHandlerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ExceptionHandlerComponent, selectors: [["exception-handler"]], inputs: { errorFKtoNotification: "errorFKtoNotification" }, decls: 1, vars: 1, consts: [["class", "dialoguebox negative open big indexException", 3, "keyup.esc", 4, "ngIf"], [1, "dialoguebox", "negative", "open", "big", "indexException", 3, "keyup.esc"], ["id", "exceptionMessageContainer", "class", "message", 4, "ngIf"], ["id", "reiniciarButton", "class", "btn negative close-dialoguebox", 3, "click", 4, "ngIf"], ["id", "okButton", 1, "btn", "negative", "close-dialoguebox", 3, "click"], ["id", "exceptionMessageContainer", 1, "message"], ["class", "mb-xs", 4, "ngIf"], ["id", "exceptionMessageParagraph", 4, "ngIf"], ["id", "exceptionMessageViolations", 4, "ngFor", "ngForOf"], [1, "more-message-opener", "mt-xs", 2, "display", "unset", "margin-right", "5px", 3, "click"], ["id", "suggestionButton", "class", "more-message-opener mt-xs", "style", "display : unset;", 3, "click", 4, "ngIf"], [4, "ngIf"], [1, "mb-xs"], ["id", "exceptionMessageParagraph"], ["id", "exceptionMessageViolations"], ["id", "suggestionButton", 1, "more-message-opener", "mt-xs", 2, "display", "unset", 3, "click"], [1, "more-message", 2, "display", "block"], [4, "ngFor", "ngForOf"], ["id", "reiniciarButton", 1, "btn", "negative", "close-dialoguebox", 3, "click"]], template: function ExceptionHandlerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ExceptionHandlerComponent_article_0_Template, 6, 3, "article", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showError);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf], pipes: [ɵngcc2.DatePipe], styles: [".indexException[_ngcontent-%COMP%]{z-index:9999999}"] });
ExceptionHandlerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ErrorHandler },
    { type: AbstractAuthHttp },
    { type: EloNotificationService },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [APP_BASE_HREF,] }] }
];
ExceptionHandlerComponent.propDecorators = {
    errorFKtoNotification: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ExceptionHandlerComponent, [{
        type: Component,
        args: [{
                selector: 'exception-handler',
                template: "<article (keyup.esc)=\"onClose()\" *ngIf=\"showError\" class=\"dialoguebox negative open big indexException\">\n  <div id=\"exceptionMessageContainer\" class=\"message\" *ngIf=\"isHttpError\">\n    <h3 *ngIf=\"error.timestamp\" class=\"mb-xs\"> Data e Hora: {{error.timestamp | date: 'dd/MM/yyyy HH:mm:ss'}} </h3>\n    <p id=\"exceptionMessageParagraph\" *ngIf=\"!error.violations || error.violations.length <= 0\"> {{error.message}} </p>\n    <li id=\"exceptionMessageViolations\" *ngFor=\"let violation of error.violations\">\n      {{violation.field}} {{violation.message}}\n    </li>\n    <div>\n      <button class=\"more-message-opener mt-xs\" style=\"display : unset; margin-right: 5px;\" (click)=\"onClickMoreInfo()\">\n        Mais Detalhes\n      </button>\n      <button id=\"suggestionButton\" *ngIf=\"existSuggestion\" class=\"more-message-opener mt-xs\" style=\"display : unset;\" (click)=\"onClickSuggestion()\">\n        Poss\u00EDvel Solu\u00E7\u00E3o\n      </button>\n    </div>\n    <div *ngIf=\"moreInfo\">\n      <p class=\"more-message\" style=\"display : block;\">\n        Status: {{error.status}} <br> Error: {{error.error}} <br> Exception: {{error.exception}}\n        <br> Path: {{error.path}} <br> Detail: {{error.detail}}\n      </p>\n    </div>\n    <div *ngIf=\"suggestion\">\n      <p class=\"more-message\" style=\"display : block;\">\n        <li *ngFor=\"let violation of error.violations\">\n           {{violation.suggestion}}\n        </li>\n      </p>\n    </div>\n  </div>\n\n  <div *ngIf=\"!isHttpError\" id=\"exceptionMessageContainer\" class=\"message\">\n    <div>\n      <p  id=\"exceptionMessageParagraph\">\n        Houve uma instabilidade em nossos servidores, tente mais tarde!\n      </p>\n      <div>\n        <button class=\"more-message-opener mt-xs\" style=\"display : unset; margin-right: 5px;\" (click)=\"onClickMoreInfo()\">\n          Mais Detalhes\n        </button>\n      </div>\n      <div *ngIf=\"moreInfo\">\n        <p class=\"more-message\" style=\"display : block;\">\n         {{error}}\n        </p>\n      </div>\n    </div>\n  </div>\n  \n  <span id=\"reiniciarButton\" class=\"btn negative close-dialoguebox\" *ngIf=\"showReiniciarButton\" (click)=\"onBack()\">\n    Reiniciar </span>\n  <span id=\"okButton\" class=\"btn negative close-dialoguebox\" (click)=\"onClose()\"> Ok</span>\n</article>\n",
                styles: [".indexException{z-index:9999999}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ErrorHandler }, { type: AbstractAuthHttp }, { type: EloNotificationService }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [APP_BASE_HREF]
            }] }]; }, { errorFKtoNotification: [{
            type: Input
        }] }); })();

class ErrorModule {
}
ErrorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ErrorModule });
ErrorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ErrorModule_Factory(t) { return new (t || ErrorModule)(); }, providers: [EloNotificationService], imports: [[CommonModule$1, PanelExpansiveModule, PanelModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ErrorModule, { declarations: function () { return [ExceptionHandlerComponent]; }, imports: function () { return [CommonModule$1, PanelExpansiveModule, PanelModule]; }, exports: function () { return [ExceptionHandlerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, PanelExpansiveModule, PanelModule],
                declarations: [ExceptionHandlerComponent],
                exports: [ExceptionHandlerComponent],
                providers: [EloNotificationService]
            }]
    }], null, null); })();

class EloFilterComponent {
    constructor() {
        /**
         Permite apenas que números positivos sejam digitados, não permite caracteres especiais, letras, ou números negativos
         */
        this.onlyPositiveNumber = false;
        this.required = false;
        this.classFilter = 'filter'; // 'filter' | 'search';
        this.buttonDescription = 'Filtrar';
        this.maxlength = 18;
        this.onClickButtonFilter = new EventEmitter();
        this.placeHolder = 'Digite o filtro...';
        this.inputType = 'text';
        /**
         * Evento disparado ao alterar o select (combobox)
         */
        this.onChangeSelect = new EventEmitter();
        /**
         * Evento disparado ao alterar o input
         */
        this.onChangeInput = new EventEmitter();
        /**
         * Evento disparado ao alterar tanto o select quanto o input text
         */
        this.onChange = new EventEmitter();
    }
    clickButtonFiltrar(inputFilter) {
        let filter = { selectedValue: this.selectedValue, inputFilter: inputFilter };
        this.onClickButtonFilter.emit(filter);
    }
    selectChange(selectedValue) {
        this.selectedValue = selectedValue;
        this.onChangeSelect.emit(selectedValue);
        this.onChange.emit(selectedValue);
    }
    changeInput(changeInput) {
        this.onChangeInput.emit(changeInput);
        this.onChange.emit(changeInput);
    }
}
EloFilterComponent.ɵfac = function EloFilterComponent_Factory(t) { return new (t || EloFilterComponent)(); };
EloFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloFilterComponent, selectors: [["elo-filter"]], inputs: { onlyPositiveNumber: "onlyPositiveNumber", required: "required", classFilter: "classFilter", buttonDescription: "buttonDescription", maxlength: "maxlength", placeHolder: "placeHolder", inputType: "inputType", selectedValue: "selectedValue", options: "options", table: "table" }, outputs: { onClickButtonFilter: "onClickButtonFilter", onChangeSelect: "onChangeSelect", onChangeInput: "onChangeInput", onChange: "onChange" }, decls: 8, vars: 13, consts: [[3, "ngClass"], [1, "row"], [1, "col-sm-4"], [1, "form-group"], [3, "options", "selectedValue", "onSelectChange"], [1, "col-sm-8"], [3, "onlyPositiveNumber", "classFilter", "maxlength", "required", "placeHolder", "buttonDescription", "inputType", "onClickButtonFilter", "onChangeInput"]], template: function EloFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "elo-select", 4);
        ɵngcc0.ɵɵlistener("onSelectChange", function EloFilterComponent_Template_elo_select_onSelectChange_4_listener($event) { return ctx.selectChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "elo-simple-filter", 6);
        ɵngcc0.ɵɵlistener("onClickButtonFilter", function EloFilterComponent_Template_elo_simple_filter_onClickButtonFilter_7_listener($event) { return ctx.clickButtonFiltrar($event); })("onChangeInput", function EloFilterComponent_Template_elo_simple_filter_onChangeInput_7_listener($event) { return ctx.changeInput($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(10, _c61, ctx.table, !ctx.table));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("options", ctx.options)("selectedValue", ctx.selectedValue);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("buttonDescription", ctx.buttonDescription);
        ɵngcc0.ɵɵproperty("onlyPositiveNumber", ctx.onlyPositiveNumber)("classFilter", ctx.classFilter)("maxlength", ctx.maxlength)("required", ctx.required)("placeHolder", ctx.placeHolder)("inputType", ctx.inputType);
    } }, directives: function () { return [ɵngcc2.NgClass, EloSelectComponent, EloSimpleFilterComponent]; }, encapsulation: 2 });
EloFilterComponent.propDecorators = {
    onlyPositiveNumber: [{ type: Input }],
    required: [{ type: Input }],
    classFilter: [{ type: Input }],
    options: [{ type: Input }],
    selectedValue: [{ type: Input }],
    buttonDescription: [{ type: Input }],
    maxlength: [{ type: Input }],
    onClickButtonFilter: [{ type: Output }],
    placeHolder: [{ type: Input }],
    table: [{ type: Input }],
    inputType: [{ type: Input }],
    onChangeSelect: [{ type: Output }],
    onChangeInput: [{ type: Output }],
    onChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloFilterComponent, [{
        type: Component,
        args: [{
                selector: 'elo-filter',
                template: "<div [ngClass]=\"{'panel-table-filter': table, 'panel-filter' : !table}\">\n  <div class=\"row\">\n\n    <div class=\"col-sm-4\">\n      <div class=\"form-group\">\n        <elo-select [options]=\"options\"\n                    [selectedValue]=\"selectedValue\"\n                    (onSelectChange)=\"selectChange($event)\">\n        </elo-select>\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\">\n      <div class=\"form-group\">\n        <elo-simple-filter\n          [onlyPositiveNumber]=\"onlyPositiveNumber\"\n          [classFilter]=\"classFilter\"\n          [maxlength]=\"maxlength\"\n          [required]=\"required\"\n          [placeHolder]=\"placeHolder\"\n          (onClickButtonFilter)=\"clickButtonFiltrar($event)\"\n          (onChangeInput)=\"changeInput($event)\"\n          buttonDescription= {{buttonDescription}}\n          [inputType]=\"inputType\">\n        </elo-simple-filter>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"
            }]
    }], function () { return []; }, { onlyPositiveNumber: [{
            type: Input
        }], required: [{
            type: Input
        }], classFilter: [{
            type: Input
        }], buttonDescription: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], onClickButtonFilter: [{
            type: Output
        }], placeHolder: [{
            type: Input
        }], inputType: [{
            type: Input
        }], onChangeSelect: [{
            type: Output
        }], onChangeInput: [{
            type: Output
        }], onChange: [{
            type: Output
        }], selectedValue: [{
            type: Input
        }], options: [{
            type: Input
        }], table: [{
            type: Input
        }] }); })();

class EloSimpleFilterComponent {
    constructor() {
        this.placeHolder = 'Digite o filtro...';
        this.buttonDescription = 'Filtrar';
        this.classFilter = 'filter'; // 'filter' | 'search';
        this.maxlength = null;
        /**
         Permite apenas que números positivos sejam digitados, não permite caracteres especiais, letras, ou números negativos
         */
        this.onlyPositiveNumber = false;
        this.required = false;
        this.inputType = 'text';
        this.onClickButtonFilter = new EventEmitter();
        /**
         * Evento disparado ao digitar algo no input
         */
        this.onChangeInput = new EventEmitter();
    }
    clickButtonFiltrar() {
        this.onClickButtonFilter.emit(this.inputFilter);
    }
    changeInput(inputChanged) {
        this.onChangeInput.emit(inputChanged);
    }
    keyPressEnter() {
        if (this.required && !this.inputFilter) {
            return;
        }
        this.clickButtonFiltrar();
    }
    ngAfterViewChecked() {
        if (document.getElementById('btnFilter')) {
            let btnWidth = document.getElementById('btnFilter').clientWidth;
            document.getElementById('input-filter').style.width = 'calc(100% - ' + btnWidth + 'px)';
        }
    }
}
EloSimpleFilterComponent.ɵfac = function EloSimpleFilterComponent_Factory(t) { return new (t || EloSimpleFilterComponent)(); };
EloSimpleFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EloSimpleFilterComponent, selectors: [["elo-simple-filter"]], inputs: { placeHolder: "placeHolder", buttonDescription: "buttonDescription", classFilter: "classFilter", maxlength: "maxlength", onlyPositiveNumber: "onlyPositiveNumber", required: "required", inputType: "inputType" }, outputs: { onClickButtonFilter: "onClickButtonFilter", onChangeInput: "onChangeInput" }, decls: 5, vars: 20, consts: [["autofocus", "", "id", "input-filter", 1, "button-input", 3, "ngModel", "placeholder", "required", "maxlength", "type", "ngModelChange", "keyup.enter"], ["type", "text", "eloNumber", "", "id", "input-filter", "autofocus", "", 1, "button-input", 3, "thousands", "align", "placeholder", "ngModel", "required", "maxlength", "ngModelChange", "keyup.enter"], ["id", "btnFilter", 3, "disabled", "click"]], template: function EloSimpleFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "input", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function EloSimpleFilterComponent_Template_input_ngModelChange_1_listener($event) { return ctx.inputFilter = $event; })("ngModelChange", function EloSimpleFilterComponent_Template_input_ngModelChange_1_listener($event) { return ctx.changeInput($event); })("keyup.enter", function EloSimpleFilterComponent_Template_input_keyup_enter_1_listener() { return ctx.keyPressEnter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function EloSimpleFilterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.inputFilter = $event; })("ngModelChange", function EloSimpleFilterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.changeInput($event); })("keyup.enter", function EloSimpleFilterComponent_Template_input_keyup_enter_2_listener() { return ctx.keyPressEnter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 2);
        ɵngcc0.ɵɵlistener("click", function EloSimpleFilterComponent_Template_button_click_3_listener() { return ctx.clickButtonFiltrar(); });
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hidden", ctx.onlyPositiveNumber);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.placeHolder);
        ɵngcc0.ɵɵpropertyInterpolate("maxlength", ctx.maxlength);
        ɵngcc0.ɵɵpropertyInterpolate("type", ctx.inputType);
        ɵngcc0.ɵɵproperty("ngModel", ctx.inputFilter)("required", ctx.required);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hidden", !ctx.onlyPositiveNumber);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.placeHolder);
        ɵngcc0.ɵɵpropertyInterpolate("maxlength", ctx.maxlength);
        ɵngcc0.ɵɵproperty("thousands", "")("align", "left")("ngModel", ctx.inputFilter)("required", ctx.required);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("btn ", ctx.classFilter, "");
        ɵngcc0.ɵɵproperty("disabled", ctx.required && !ctx.inputFilter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.buttonDescription);
    } }, directives: [ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.RequiredValidator, ɵngcc3.MaxLengthValidator, EloNumberDirective], styles: [""] });
EloSimpleFilterComponent.propDecorators = {
    placeHolder: [{ type: Input }],
    buttonDescription: [{ type: Input }],
    classFilter: [{ type: Input }],
    maxlength: [{ type: Input }],
    onlyPositiveNumber: [{ type: Input }],
    required: [{ type: Input }],
    inputType: [{ type: Input }],
    onClickButtonFilter: [{ type: Output }],
    onChangeInput: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloSimpleFilterComponent, [{
        type: Component,
        args: [{
                selector: 'elo-simple-filter',
                template: "<div>\n  <input\n    [class.hidden]=\"onlyPositiveNumber\"\n    autofocus\n    id=\"input-filter\"\n    [(ngModel)]=\"inputFilter\"\n    placeholder=\"{{placeHolder}}\"\n    class=\"button-input\"\n    [required]=\"required\"\n    (ngModelChange)=\"changeInput($event)\"\n    (keyup.enter)=\"keyPressEnter()\"\n    maxlength=\"{{maxlength}}\"\n    type=\"{{inputType}}\">\n\n  <input\n    [class.hidden]=\"!onlyPositiveNumber\"\n    type=\"text\"\n    eloNumber\n    [thousands]=\"''\"\n    [align]=\"'left'\" id=\"input-filter\"\n    class=\"button-input\"\n    autofocus\n    placeholder=\"{{placeHolder}}\"\n    [(ngModel)]=\"inputFilter\"\n    [required]=\"required\"\n    (ngModelChange)=\"changeInput($event)\" (keyup.enter)=\"keyPressEnter()\" maxlength=\"{{maxlength}}\">\n\n  <button id=\"btnFilter\" class=\"btn {{classFilter}}\" [disabled]=\"required && !inputFilter\" (click)=\"clickButtonFiltrar()\">{{buttonDescription}}</button>\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { placeHolder: [{
            type: Input
        }], buttonDescription: [{
            type: Input
        }], classFilter: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], onlyPositiveNumber: [{
            type: Input
        }], required: [{
            type: Input
        }], inputType: [{
            type: Input
        }], onClickButtonFilter: [{
            type: Output
        }], onChangeInput: [{
            type: Output
        }] }); })();

class EloFilterModule {
}
EloFilterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EloFilterModule });
EloFilterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EloFilterModule_Factory(t) { return new (t || EloFilterModule)(); }, providers: [], imports: [[CommonModule$1, FormsModule, ReactiveFormsModule, EloSelectModule, DirectivesModule], EloSelectModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EloFilterModule, { declarations: function () { return [EloFilterComponent, EloSimpleFilterComponent]; }, imports: function () { return [CommonModule$1, FormsModule, ReactiveFormsModule, EloSelectModule, DirectivesModule]; }, exports: function () { return [EloFilterComponent, EloSimpleFilterComponent, EloSelectModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EloFilterModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule$1, FormsModule, ReactiveFormsModule, EloSelectModule, DirectivesModule],
                declarations: [EloFilterComponent, EloSimpleFilterComponent],
                exports: [EloFilterComponent, EloSimpleFilterComponent, EloSelectModule],
                providers: []
            }]
    }], null, null); })();

class Area {
    constructor(titulo, cssAdicionalTitulo, iconeTitulo, modulos, isUnico) {
        this.titulo = titulo;
        this.cssAdicionalTitulo = cssAdicionalTitulo;
        this.iconeTitulo = iconeTitulo;
        this.modulos = modulos;
        this.isUnico = isUnico;
    }
}

class ColumnDrilldown {
}

class Column {
}

/**
 * Created by douglas on 16/06/2016.
 */
class Page {
    constructor() {
        this.content = [];
    }
}

class Periodo {
    constructor(dataInicial, dataFinal) {
        this.dataInicial = dataInicial;
        this.dataFinal = dataFinal;
    }
    conflicts(periodo) {
        if (!periodo)
            return null;
        return DateUtils.isBeforeOrEquals(this.dataInicial, periodo.dataFinal)
            && DateUtils.isAfterOrEquals(this.dataFinal, periodo.dataInicial);
    }
}

class AuthInterceptor {
    constructor(authParams) {
        this.authParams = authParams;
    }
    interceptRequest(httpParams) {
        return of(httpParams).pipe(map(params => {
            if (this.authParams.isLogged()) {
                HttpClientUtils.addToken(params, this.authParams.getToken());
            }
            return params;
        }));
    }
}
AuthInterceptor.ɵfac = function AuthInterceptor_Factory(t) { return new (t || AuthInterceptor)(ɵngcc0.ɵɵinject(AuthParams)); };
AuthInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthInterceptor, factory: AuthInterceptor.ɵfac });
AuthInterceptor.ctorParameters = () => [
    { type: AuthParams }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthParams }]; }, null); })();

const CACHE_SIZE = 100;
class ETagInterceptor {
    constructor() {
        this.etagDataCache = new LRUCache(CACHE_SIZE);
        this.etagCache = new LRUCache(CACHE_SIZE);
    }
    interceptRequest(httpParams) {
        return of(httpParams).pipe(map(params => {
            const url = HttpClientUtils.buildUrlWithBase(params, '');
            const etag = this.etagCache.get(url);
            if (etag && params.requestMethod === 'GET') {
                params.headersExtra = params.headersExtra.append('If-None-Match', etag);
            }
            return params;
        }));
    }
    interceptResponse(httpParams, response) {
        return of(response).pipe(tap((response) => {
            if (response.status === 200 && response.headers) {
                const responseEtag = response.headers.get('Etag');
                const url = HttpClientUtils.buildUrlWithBase(httpParams, '');
                if (responseEtag) {
                    this.etagDataCache.set(url, response.clone({ body: deepCopy(response.body) }));
                    this.etagCache.set(url, responseEtag);
                }
            }
        }));
    }
    catchError(httpParams, error) {
        if (error.status === 304) {
            const url = HttpClientUtils.buildUrlWithBase(httpParams, '');
            const cachedResponse = this.etagDataCache.get(url);
            return of(cachedResponse.clone({ body: deepCopy(cachedResponse.body) }));
        }
        else {
            throw error;
        }
    }
    hasETagForUrl(url) {
        return !!this.etagCache.get(url);
    }
}
ETagInterceptor.ɵfac = function ETagInterceptor_Factory(t) { return new (t || ETagInterceptor)(); };
ETagInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ETagInterceptor, factory: ETagInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ETagInterceptor, [{
        type: Injectable
    }], function () { return []; }, null); })();

const ENDPOINT_USERINFO = '/api/app-info/usuario';
class HeaderParamsInterceptor {
    constructor(httpClient, urlResolver, authParams) {
        this.httpClient = httpClient;
        this.urlResolver = urlResolver;
        this.authParams = authParams;
    }
    interceptRequest(httpParams) {
        if (this.authParams.isLogged()) {
            if (this.authParams.hasUsuarioInfo()) {
                let usuarioInfo = this.authParams.getUsuarioInfo();
                return of(httpParams).pipe(map(params => {
                    this.loadUsuarioInfoToHttpParams(httpParams, usuarioInfo);
                    return params;
                }));
            }
            return this.createHttpGetRequest().pipe(map(usuarioInfo => {
                this.authParams.setUsuarioInfo(usuarioInfo);
                this.loadUsuarioInfoToHttpParams(httpParams, usuarioInfo);
                return httpParams;
            }));
        }
        return of(httpParams);
    }
    loadUsuarioInfoToHttpParams(httpParams, usuarioInfo) {
        if (usuarioInfo.exercicioPadrao) {
            httpParams.headersExtra = httpParams.headersExtra.set('EXERCICIO', usuarioInfo.exercicioPadrao.toString());
        }
        if (usuarioInfo.mesPadrao) {
            httpParams.headersExtra = httpParams.headersExtra.set('COMPETENCIA', usuarioInfo.mesPadrao.toString());
        }
        let entidadeInfo = UsuarioInfoUtils.getEntidadePrincipal(usuarioInfo);
        if (entidadeInfo) {
            httpParams.headersExtra = httpParams.headersExtra.set('ENTIDADE', entidadeInfo.id.toString());
            httpParams.headersExtra = httpParams.headersExtra.set('ENTIDADE_NOME', entidadeInfo.descricao);
        }
        let moduloInfo = UsuarioInfoUtils.getModuloPrincipal(usuarioInfo, this.authParams.getInitialModuloFromUrl());
        if (moduloInfo) {
            httpParams.headersExtra = httpParams.headersExtra.set('MODULO', moduloInfo.id);
        }
    }
    createHttpGetRequest() {
        let interceptParams = { resource: ENDPOINT_USERINFO, headersExtra: new HttpHeaders() };
        HttpClientUtils.addToken(interceptParams, this.authParams.getToken());
        return this.httpClient.get(HttpClientUtils.buildUrl(interceptParams, this.urlResolver), { headers: interceptParams.headersExtra }).pipe(shareReplay());
    }
}
HeaderParamsInterceptor.ɵfac = function HeaderParamsInterceptor_Factory(t) { return new (t || HeaderParamsInterceptor)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(UrlResolver), ɵngcc0.ɵɵinject(AuthParams)); };
HeaderParamsInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HeaderParamsInterceptor, factory: HeaderParamsInterceptor.ɵfac });
HeaderParamsInterceptor.ctorParameters = () => [
    { type: HttpClient$1 },
    { type: UrlResolver },
    { type: AuthParams }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderParamsInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: UrlResolver }, { type: AuthParams }]; }, null); })();

class HeaderParamsKeycloakInterceptor {
    constructor(keycloakService, urlResolver, httpClient) {
        this.keycloakService = keycloakService;
        this.urlResolver = urlResolver;
        this.httpClient = httpClient;
    }
    interceptRequest(httpParams) {
        if (this.keycloakService.isLogged()) {
            let usuarioInfo = this.keycloakService.getUsuarioInfo();
            if (usuarioInfo) {
                return of(httpParams).pipe(tap(() => this.loadUsuarioInfoToHttpParams(httpParams, usuarioInfo)));
            }
            else {
                return this.createHttpGetRequest().pipe(map(usuarioInfo => {
                    this.keycloakService.setUsuarioInfo(usuarioInfo);
                    this.loadUsuarioInfoToHttpParams(httpParams, usuarioInfo);
                    return httpParams;
                }));
            }
        }
        return of(httpParams);
    }
    loadUsuarioInfoToHttpParams(httpParams, usuarioInfo) {
        if (usuarioInfo.dataOperacao) {
            httpParams.headersExtra = httpParams.headersExtra.set('DATA_OPERACAO', usuarioInfo.dataOperacao.toString());
        }
        if (usuarioInfo.exercicioPadrao) {
            httpParams.headersExtra = httpParams.headersExtra.set('EXERCICIO', usuarioInfo.exercicioPadrao.toString());
        }
        if (usuarioInfo.mesPadrao) {
            httpParams.headersExtra = httpParams.headersExtra.set('COMPETENCIA', usuarioInfo.mesPadrao.toString());
        }
        let entidadeInfo = UsuarioInfoUtils.getEntidadePrincipal(usuarioInfo);
        if (entidadeInfo) {
            httpParams.headersExtra = httpParams.headersExtra.set('ENTIDADE', entidadeInfo.id && entidadeInfo.id.toString())
                .set('ENTIDADE_NOME', entidadeInfo.nome);
        }
    }
    createHttpGetRequest() {
        if (this.usuarioInfoGet) {
            return this.usuarioInfoGet;
        }
        let interceptParams = {
            resource: this.urlResolver.getUrlUserInfo(),
            headersExtra: new HttpHeaders()
        };
        HttpClientUtils.addToken(interceptParams, this.keycloakService.getToken());
        this.usuarioInfoGet = this.httpClient.get(HttpClientUtils.buildUrl(interceptParams, this.urlResolver), { headers: interceptParams.headersExtra }).pipe(shareReplay());
        return this.usuarioInfoGet;
    }
}
HeaderParamsKeycloakInterceptor.ɵfac = function HeaderParamsKeycloakInterceptor_Factory(t) { return new (t || HeaderParamsKeycloakInterceptor)(ɵngcc0.ɵɵinject(KeycloakAuthHttp), ɵngcc0.ɵɵinject(UrlResolver), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
HeaderParamsKeycloakInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HeaderParamsKeycloakInterceptor, factory: HeaderParamsKeycloakInterceptor.ɵfac });
HeaderParamsKeycloakInterceptor.ctorParameters = () => [
    { type: KeycloakAuthHttp },
    { type: UrlResolver },
    { type: HttpClient$1 }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderParamsKeycloakInterceptor, [{
        type: Injectable
    }], function () { return [{ type: KeycloakAuthHttp }, { type: UrlResolver }, { type: ɵngcc1.HttpClient }]; }, null); })();

class RouterInterceptor {
    constructor(router) {
        this.router = router;
    }
    interceptRequest(httpParams) {
        return of(httpParams).pipe(map(params => {
            params.headersExtra = params.headersExtra.append('active_view', this.router.url);
            return params;
        }));
    }
}
RouterInterceptor.ɵfac = function RouterInterceptor_Factory(t) { return new (t || RouterInterceptor)(ɵngcc0.ɵɵinject(ɵngcc6.Router)); };
RouterInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: RouterInterceptor, factory: RouterInterceptor.ɵfac });
RouterInterceptor.ctorParameters = () => [
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RouterInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc6.Router }]; }, null); })();

class SpinnerInterceptor {
    constructor(spinnerService) {
        this.spinnerService = spinnerService;
    }
    interceptRequest(httpParams) {
        return of(httpParams).pipe(tap(() => this.showSpinner(true, httpParams)));
    }
    finally(httpParams) {
        this.showSpinner(false, httpParams);
    }
    showSpinner(show, httpParams) {
        if (!httpParams.disableSpinner) {
            this.spinnerService.show.emit(show);
        }
    }
}
SpinnerInterceptor.ɵfac = function SpinnerInterceptor_Factory(t) { return new (t || SpinnerInterceptor)(ɵngcc0.ɵɵinject(SpinnerService)); };
SpinnerInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SpinnerInterceptor, factory: SpinnerInterceptor.ɵfac });
SpinnerInterceptor.ctorParameters = () => [
    { type: SpinnerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpinnerInterceptor, [{
        type: Injectable
    }], function () { return [{ type: SpinnerService }]; }, null); })();

class InterceptorsProviders {
    static providers() {
        return [
            AuthInterceptor,
            {
                provide: HttpClientInterceptorToken,
                useExisting: AuthInterceptor,
                multi: true
            },
            ...InterceptorsProviders.providersKeycloak()
        ];
    }
    static providersKeycloak() {
        return [
            SpinnerInterceptor,
            RouterInterceptor,
            ETagInterceptor,
            {
                provide: HttpClientInterceptorToken,
                useExisting: ETagInterceptor,
                multi: true
            },
            {
                provide: HttpClientInterceptorToken,
                useExisting: SpinnerInterceptor,
                multi: true
            },
            {
                provide: HttpClientInterceptorToken,
                useExisting: RouterInterceptor,
                multi: true
            }
        ];
    }
    static providersWithHeaderParams() {
        return [
            ...InterceptorsProviders.providers(),
            HeaderParamsInterceptor,
            {
                provide: HttpClientInterceptorToken,
                useExisting: HeaderParamsInterceptor,
                multi: true
            }
        ];
    }
}

// tslint:disable-next-line: variable-name
const KeycloakToken = new InjectionToken('KeycloakToken');

class KeycloakInterceptor {
    constructor(_router, _keycloak) {
        this._router = _router;
        this._keycloak = _keycloak;
    }
    interceptRequest(httpParams) {
        return from(this._keycloak.refreshToken()).pipe(map(() => {
            if (this._keycloak.isLogged()) {
                HttpClientUtils.addToken(httpParams, this._keycloak.getToken());
            }
            return httpParams;
        }));
    }
    catchError(httpParams, error) {
        if (error && error.status === 403) {
            this._router.navigate(['/forbidden']);
            return of({});
        }
        else {
            throw error;
        }
    }
}
KeycloakInterceptor.ɵfac = function KeycloakInterceptor_Factory(t) { return new (t || KeycloakInterceptor)(ɵngcc0.ɵɵinject(ɵngcc6.Router), ɵngcc0.ɵɵinject(KeycloakToken)); };
KeycloakInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: KeycloakInterceptor, factory: KeycloakInterceptor.ɵfac });
KeycloakInterceptor.ctorParameters = () => [
    { type: Router },
    { type: KeycloakAuthHttp, decorators: [{ type: Inject, args: [KeycloakToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(KeycloakInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc6.Router }, { type: KeycloakAuthHttp, decorators: [{
                type: Inject,
                args: [KeycloakToken]
            }] }]; }, null); })();

class CanActivateKeyCloak {
    constructor(keycloakAuthHttp, _router) {
        this.keycloakAuthHttp = keycloakAuthHttp;
        this._router = _router;
    }
    getPath(route, path = '') {
        if (route.parent) {
            let pathThisRoute = route.routeConfig.path;
            if (route.params) {
                pathThisRoute = route.params.id === 'new' ? pathThisRoute.replace(':id', 'new') : pathThisRoute;
            }
            pathThisRoute = path ? pathThisRoute + '/' + path : pathThisRoute;
            return this.getPath(route.parent, pathThisRoute);
        }
        return path;
    }
    canActivate(route, state) {
        if (!this.keycloakAuthHttp.isLogged()) {
            return false;
        }
        return this.keycloakAuthHttp.hasPermissionByRoute(this.getPath(route))
            .pipe(tap(hasPermission => {
            if (!hasPermission) {
                this._router.navigate(['/forbidden']);
            }
            return hasPermission;
        }));
    }
}
CanActivateKeyCloak.ɵfac = function CanActivateKeyCloak_Factory(t) { return new (t || CanActivateKeyCloak)(ɵngcc0.ɵɵinject(KeycloakAuthHttp), ɵngcc0.ɵɵinject(ɵngcc6.Router)); };
CanActivateKeyCloak.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CanActivateKeyCloak, factory: CanActivateKeyCloak.ɵfac });
CanActivateKeyCloak.ctorParameters = () => [
    { type: KeycloakAuthHttp },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CanActivateKeyCloak, [{
        type: Injectable
    }], function () { return [{ type: KeycloakAuthHttp }, { type: ɵngcc6.Router }]; }, null); })();

class Role {
}

class ErrorViolation {
}

/**
 * Created by pdi on 12/07/16.
 */
class CanActivateRouteService extends CanActivateRoute {
    constructor(authHttp, router) {
        super();
        this.authHttp = authHttp;
        this.router = router;
    }
    getPath(route, path = '') {
        if (route.parent) {
            let pathThisRoute = route.routeConfig.path;
            if (route.params) {
                pathThisRoute = route.params.id === 'new' ? pathThisRoute.replace(':id', 'new') : pathThisRoute;
            }
            pathThisRoute = path ? pathThisRoute + '/' + path : pathThisRoute;
            return this.getPath(route.parent, pathThisRoute);
        }
        return path;
    }
    canActivate(route, state) {
        if (this.authHttp.authParams.isLogged()) {
            return this.authHttp
                .getUsuarioLogado().pipe(map(usuario => {
                const path = this.getPath(route);
                const permissaoRota = permissions.find(p => p.route === path);
                if (permissaoRota && !usuario.recursos.includes(permissaoRota.recurso)) {
                    this.router.navigate(['/forbidden']);
                    return false;
                }
                return true;
            }));
        }
        else {
            console.debug('logoutAndGoToAuthForm by actived');
            this.authHttp.goToAuthFormIfExists(window.location.origin + state.url);
            return false;
        }
    }
}
CanActivateRouteService.ɵfac = function CanActivateRouteService_Factory(t) { return new (t || CanActivateRouteService)(ɵngcc0.ɵɵinject(AuthHttp), ɵngcc0.ɵɵinject(ɵngcc6.Router)); };
CanActivateRouteService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CanActivateRouteService, factory: CanActivateRouteService.ɵfac });
CanActivateRouteService.ctorParameters = () => [
    { type: AuthHttp },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CanActivateRouteService, [{
        type: Injectable
    }], function () { return [{ type: AuthHttp }, { type: ɵngcc6.Router }]; }, null); })();

class RouteUtils {
    static createCrudRoutes(route, crudSearchClass, crudFormClass, canActivateServices = [CanActivateRoute]) {
        const routes = [
            { path: route, component: crudSearchClass, canActivate: canActivateServices },
            {
                path: route + '/:id', component: crudFormClass, canDeactivate: [CanDeactivateGuard],
                canActivate: canActivateServices
            }
        ];
        return RouterModule.forChild(routes);
    }
    static createCrudLazyRoutes(crudSearchClass, crudFormClass, canActivateServices = [CanActivateRoute]) {
        return [
            { path: '', component: crudSearchClass, canActivate: canActivateServices },
            {
                path: ':id', component: crudFormClass, canDeactivate: [CanDeactivateGuard],
                canActivate: canActivateServices
            }
        ];
    }
    static addRoute(route, component, canActivateServices = [CanActivateRoute]) {
        const routes = [{ path: route, component: component, canActivate: canActivateServices }];
        return RouterModule.forChild(routes);
    }
}

class AcessibilityService {
    constructor() {
        this.subjectOnInverterCores = new Subject();
        this.onInverterCores = this.subjectOnInverterCores.asObservable();
        this.invert = '';
    }
    inverterCores() {
        if (this.invert === 'invert') {
            this.invert = '';
        }
        else {
            this.invert = 'invert';
        }
        this.subjectOnInverterCores.next(this.invert);
    }
}
AcessibilityService.ɵfac = function AcessibilityService_Factory(t) { return new (t || AcessibilityService)(); };
AcessibilityService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AcessibilityService, factory: AcessibilityService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AcessibilityService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AppService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.resource = '/api/app';
    }
    getApiVersion() {
        return this.httpClient.get({
            resource: `${this.resource}/api-version`,
        });
    }
    getClientVersion() {
        return this.httpClient.get({ resource: 'app/version', requestOrigin: true });
    }
}
AppService.ɵfac = function AppService_Factory(t) { return new (t || AppService)(ɵngcc0.ɵɵinject(HttpClient)); };
AppService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AppService, factory: AppService.ɵfac });
AppService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class BaseUrlService {
    constructor(authResourcesConfig) {
        this.authResourcesConfig = authResourcesConfig;
    }
    getBaseUrl() {
        return this.isDev() ? this.dev() : this.origin();
    }
    isDev() {
        return this.authResourcesConfig.isDev;
    }
    origin() {
        return window.location.origin;
    }
    dev() {
        return this.authResourcesConfig.hostDev;
    }
}
BaseUrlService.ɵfac = function BaseUrlService_Factory(t) { return new (t || BaseUrlService)(ɵngcc0.ɵɵinject(AUTH_RESOURCES_CONFIG)); };
BaseUrlService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BaseUrlService, factory: BaseUrlService.ɵfac });
BaseUrlService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_RESOURCES_CONFIG,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BaseUrlService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_RESOURCES_CONFIG]
            }] }]; }, null); })();

class BodyZoomService {
    constructor(document) {
        this.document = document;
        this.zoomAtual = 100 /* NORMAL */;
        this.scaleAtual = 1 /* NORMAL */;
        this.body = this.document.body;
    }
    normal() {
        this.zoomAtual = 100 /* NORMAL */;
        // tslint:disable-next-line:deprecation
        this.body.style.zoom = this.zoomAtual + '%';
        this.normalMozila();
    }
    aumentaTamanho() {
        this.aumentaZoom();
        this.aumentaScale();
    }
    diminuiTamanho() {
        this.diminuiZoom();
        this.diminuiScale();
    }
    normalMozila() {
        this.scaleAtual = 1 /* NORMAL */;
        this.defineMozilaScale();
    }
    aumentaZoom() {
        // tslint:disable-next-line:deprecation
        this.body.style.zoom = this.incrementaZoom() + '%';
    }
    incrementaZoom() {
        if (this.zoomAtual <= 110 /* MAX */) {
            this.zoomAtual = this.zoomAtual + 5 /* INCREMENTO */;
        }
        return this.zoomAtual;
    }
    aumentaScale() {
        this.incrementaScale();
        this.defineMozilaScale();
    }
    incrementaScale() {
        if (this.scaleAtual <= 1.15 /* MAX */) {
            this.scaleAtual = this.scaleAtual + 0.03 /* INCREMENTO */;
        }
    }
    diminuiZoom() {
        // tslint:disable-next-line:deprecation
        this.body.style.zoom = this.decrementaZoom() + '%';
    }
    decrementaZoom() {
        if (this.zoomAtual >= 86 /* MIN */) {
            this.zoomAtual = this.zoomAtual - 5 /* DECREMENTO */;
        }
        return this.zoomAtual;
    }
    diminuiScale() {
        this.decrementaScale();
        this.defineMozilaScale();
    }
    decrementaScale() {
        if (this.scaleAtual >= 0.8 /* MIN */) {
            this.scaleAtual = this.scaleAtual - 0.03 /* DECREMENTO */;
        }
    }
    // Tudo que tem o prefixo  -moz só funciona no mozila, logo já existe um if (mozila).
    defineMozilaScale() {
        this.body.style['-moz-transform'] = 'scale(' + this.scaleAtual + ')';
        this.body.style['-moz-transform-origin'] = 'top center';
    }
}
BodyZoomService.ɵfac = function BodyZoomService_Factory(t) { return new (t || BodyZoomService)(ɵngcc0.ɵɵinject(DOCUMENT)); };
BodyZoomService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BodyZoomService, factory: BodyZoomService.ɵfac });
BodyZoomService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BodyZoomService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class EntidadeService extends EntityService {
    constructor(httpClient, urlResolver) {
        super(httpClient);
        this.httpClient = httpClient;
        this.urlResolver = urlResolver;
        this.resource = '/api/entidades';
    }
    getEntidadePrincipal(includeBrasao) {
        const fields = ['nome', 'cidade.descricao', 'cidade.uf.sigla', 'cidade.unidadeFederacao.sigla'];
        if (includeBrasao) {
            fields.push('brasao');
        }
        return this.httpClient.get({
            resource: `${this.resource}/principal/entidade`,
            fields: fields.toString()
        });
    }
    getCidade() {
        return this.httpClient.get({ resource: `${this.resource}/principal/entidade`, fields: ['cidade.descricao', 'cidade.uf.sigla'].toString() });
    }
    getUrlBrasao() {
        return `${this.urlResolver.getUrlResolved()}${this.resource}/principal/brasao`;
    }
    findUserInfo() {
        return this.httpClient.get({
            resource: `/api/entidades/userInfo`,
            disableSpinner: true
        });
    }
    getNomeEntidade() {
        return this.httpClient.get({ resource: `${this.resource}/principal/entidade`, fields: 'nome' });
    }
    findToOptions(searchValue) {
        return this.findToAutoComplete(this.getSearch(searchValue)).pipe(map(page => page.content));
    }
    objToOption(entidade) {
        return `${entidade.id} - ${entidade.nome}`;
    }
    getSearch(searchValue) {
        return `nome == "*${searchValue}*"` + `${NumberUtils.isNumeric(searchValue) ? ',id==' + NumberUtils.onlyNumbers(searchValue) : ''}`;
    }
}
EntidadeService.ɵfac = function EntidadeService_Factory(t) { return new (t || EntidadeService)(ɵngcc0.ɵɵinject(HttpClient), ɵngcc0.ɵɵinject(UrlResolver)); };
EntidadeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EntidadeService, factory: EntidadeService.ɵfac });
EntidadeService.ctorParameters = () => [
    { type: HttpClient },
    { type: UrlResolver }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntidadeService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: UrlResolver }]; }, null); })();

class TestingUtils {
    static dispatchEvent(element, eventType) {
        element.dispatchEvent(new Event(eventType));
    }
}

var EntidadeTipo;
(function (EntidadeTipo) {
    EntidadeTipo["EXECUTIVO"] = "E";
    EntidadeTipo["LEGISLATIVO"] = "L";
    EntidadeTipo["ADMINISTRACAO_INDIRETA"] = "A";
    EntidadeTipo["RPPS"] = "R";
    EntidadeTipo["ADMINISTRACAO_DIRETA"] = "D";
    EntidadeTipo["CONSORCIO"] = "C";
})(EntidadeTipo || (EntidadeTipo = {}));

// @dynamic
class ArrayUtil {
    /**
     *  Remove objetos duplicados, olhando apenas para um único atributo do objeto.
     *
     * @param myArr array de objetos
     * @param prop propriedade do objeto
     */
    static removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
            return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
        });
    }
    /**
     * Compara dois arrays e retorna se os mesmos possuem elementos distintos.
     *
     * @param currentArray array base da comparação
     * @param comparisonArray array de comparação
     */
    static diffArrays(currentArray, comparisonArray) {
        return currentArray.some(e => !comparisonArray.includes(e));
    }
    /**
     * Agrupa o array pelo atributo determinado do array
     *
     * @example
     *  [
     *    {nome: "dummy1", cidade: "Maringá" },
     *    {nome: "Elton", cidade: "Floresta"},
     *    {nome: "dummy2", cidade: "Maringá"}
     *  ]
     *
     *  Group by cidade
     *
     *  [
     *    [{nome: "dummy1", cidade: "Maringá" }, {nome: "dummy2", cidade: "Maringá"}],
     *    [{nome: "Elton", cidade: "Floresta"}]
     *  ]
     *
     *  @param array array antes do agrupamento
     *  @param f funcao que retorna o atributo que sera agrupado (function(dummy) { return [dummy.cidade]} )
     */
    static groupBy(array, f) {
        let groups = {};
        array.forEach((object) => {
            let group = JSON.stringify(f(object));
            groups[group] = groups[group] || [];
            groups[group].push(object);
        });
        return Object.keys(groups).map((group) => {
            return groups[group];
        });
    }
    /**
     * Verifica se existe duplicados no array
     *
     * @param currentArray array da verificação
     */
    static existsDuplicates(currentArray) {
        return (new Set(currentArray)).size !== currentArray.length;
    }
}

class Desktop {
    static isDesktop() {
        return innerWidth >= 992 /* RESOLUCAO_DESKTOP */;
    }
}

// @dynamic
class FocusUtil {
}
FocusUtil.focus = (id) => {
    setTimeout(() => {
        const input = document.querySelector(`#${id}`);
        if (input) {
            input.focus();
        }
    }, 0);
};
FocusUtil.focusWithIndex = (index, id) => {
    setTimeout(() => {
        const input = document.querySelector(`#${id}_${index}`);
        if (input) {
            input.focus();
        }
    }, 0);
};
FocusUtil.focusWithIndexAndSelectTextInput = (controlName, id, index) => {
    setTimeout(() => {
        const input = document.querySelector(`#${controlName}_${id}_${index}`);
        if (input) {
            input.select();
        }
    }, 0);
};

class ObjectParseService {
    /**
     * Encodes a text string as a valid component of a Uniform Resource Identifier (URI)
     */
    encodeData(data) {
        if (!data) {
            return '';
        }
        return Object.keys(data).map((key) => {
            return [key, data[key]].map(encodeURIComponent).join('=');
        }).join('&');
    }
}
ObjectParseService.ɵfac = function ObjectParseService_Factory(t) { return new (t || ObjectParseService)(); };
ObjectParseService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ObjectParseService, factory: ObjectParseService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ObjectParseService, [{
        type: Injectable
    }], null, null); })();

/**
 * Check and return true if an object is type of string
 */
function isString(obj) {
    return typeof obj === 'string';
}
/**
 * Check and return true if an object is type of number
 */
function isNumber(obj) {
    return typeof obj === 'number';
}
/**
 * Check and return true if an object is type of Function
 */
function isFunction(obj) {
    return typeof obj === 'function';
}

class AssertUtils {
    constructor(fixture) {
        this.fixture = fixture;
    }
    static assert(value, description) {
        if (!value) {
            throw new Error('Assert fails ' + description);
        }
    }
    static config(fixture) {
        AssertUtils.assert(fixture, 'Fixture is null. Use method AssertUtils.config(fixture) with a fixture instance.');
        return new AssertUtils(fixture);
    }
    assertRender(component) {
        AssertUtils.assert(this.fixture.debugElement.query(By.css(component)), `${component} not found`);
        return this;
    }
    assertNotRender(component) {
        AssertUtils.assert(!this.fixture.debugElement.query(By.css(component)), `${component} found`);
        return this;
    }
    /**
     * Usar esta função para testar componentes HTML input. Tipos suportados: select, checkbox e text.
     * @param inputId - Id do input a ser testado
     * @param predicate - consulta a ser passada à fixture.debugElement.query (geralmente o retorno de `By.css`)
     * @param expected - valor experado no input
     * @returns
     */
    assertInputByCss(inputId, predicate, expected) {
        const inputElement = this.fixture.debugElement.query(predicate);
        AssertUtils.assert(inputElement, `${inputId} not found`);
        let element = inputElement.nativeElement;
        if (element.type === 'select') {
            AssertUtils.assert(inputElement.componentInstance.value === expected, inputId);
        }
        else if (element.type === 'checkbox') {
            AssertUtils.assert(element.checked === expected, inputId);
        }
        else {
            AssertUtils.assert(element.value === expected, inputId);
        }
        return this;
    }
    /**
     * Usar esta função para testar componentes HTML input. Tipos suportados: select, checkbox e text.
     * Caso haja mais de um componente com o mesmo id na mesma fixture (por exemplo, um mesmo componente
     * renderizado mais de uma vez), utilize a função `assertInputByCss`
     * @param inputId - Id do input a ser testado
     * @param expected - valor experado no input
     * @returns
     */
    assertInput(inputId, expected) {
        return this.assertInputByCss(inputId, By.css(`#${inputId}`), expected);
    }
    /**
     * Usar esta função para testar se componentes HTML input está desabilitado.
     * @param inputId
     * @returns
     */
    assertInputDisabled(inputId, failedMessage = 'should be disabled') {
        const inputElement = this.fixture.debugElement.query(By.css(`#${inputId}`));
        AssertUtils.assert(inputElement, `Input with id #${inputId} not found`);
        AssertUtils.assert(inputElement.nativeElement.disabled, `${inputId} ${failedMessage}`);
        return this;
    }
    /**
     * Usar esta função para testar se componentes HTML input está habilitado.
     * @param inputId
     * @returns
     */
    assertInputEnabled(inputId) {
        const inputElement = this.fixture.debugElement.query(By.css(`#${inputId}`));
        AssertUtils.assert(inputElement, 'inputElement');
        AssertUtils.assert(!inputElement.nativeElement.disabled, `${inputId} should be enabled`);
        return this;
    }
    /**
   * Usar esta função para testar o componente HTML select;
   * @param selectId
   * @param expectedIndex
   * @returns
   */
    assertHtmlSelect(selectId, expectedIndex) {
        const selectElement = this.fixture.debugElement.query(By.css(`#${selectId}`)).nativeElement;
        AssertUtils.assert(selectElement, `${selectId} not found`);
        AssertUtils.assert(selectElement.selectedIndex === expectedIndex, selectId);
        return this;
    }
    /**
     * Usar esta função para testar o componente elo-select;
     * @param selectId
     * @param expectedIndex
     * @returns
     */
    assertSelect(selectId, expectedIndex) {
        const selectElement = this.fixture.debugElement.query(By.css(`#${selectId}`));
        AssertUtils.assert(selectElement, `${selectId} not found`);
        AssertUtils.assert(selectElement.componentInstance.value === expectedIndex, selectId);
        return this;
    }
    /**
     * Usar esta função para testar o componente elo-autocomplete.
     * @param inputId
     * @param expected
     * @returns
     */
    assertComplete(inputId, expected) {
        return this.assertInput(`${inputId}_input`, expected);
    }
    /**
     * Usar esta função para testar o componente elo-switch.
     * @param switchId
     * @param expected
     * @returns
     */
    assertSwitch(switchId, expected) {
        const eloSwitch = this.fixture.debugElement.query(By.css(`#${switchId}`));
        AssertUtils.assert(eloSwitch, `${switchId} not found`);
        AssertUtils.assert(eloSwitch.componentInstance.active === expected, 'active');
        return this;
    }
}

const bimestreNames = ['1° bimestre', '2° bimestre', '3° bimestre', '4° bimestre', '5° bimestre', '6° bimestre'];
class BimestreUtils {
    static getBimestreName(bimestre) {
        return bimestreNames[bimestre - 1];
    }
    static getBimestres() {
        return bimestreNames;
    }
    static getMesInicial(bimestre) {
        return bimestre * 2 - 1;
    }
    static getMesFinal(bimestre) {
        return bimestre * 2;
    }
}

const quadrimestreNames = ['1° quadrimestre', '2° quadrimestre', '3° quadrimestre'];
class QuadrimestreUtils {
    static getQuadrimestreName(quadrimestre) {
        return quadrimestreNames[quadrimestre - 1];
    }
    static getQuadrimestres() {
        return quadrimestreNames;
    }
    static getMesInicial(quadrimestre) {
        return quadrimestre * 4 - 3;
    }
    static getMesFinal(quadrimestre) {
        return quadrimestre * 4;
    }
}

class RateioUtils {
    static doRateio(valor, vezes) {
        let rateio = [];
        let soma = 0;
        let parcela = NumberUtils.round(valor / vezes);
        for (let i = 0; i < (vezes - 1); i++) {
            rateio.push(parcela);
            soma += parcela;
        }
        let lastValue = NumberUtils.round(valor - soma);
        rateio.push(lastValue);
        return rateio;
    }
}

class RsqlBuilder {
    constructor() {
        this.rsql = 'search=';
    }
    static create() {
        return new RsqlBuilder();
    }
    and() {
        if (!this.terminaCom(' and ') && this.rsql !== 'search=') {
            this.rsql += ' and ';
        }
        return this;
    }
    or() {
        if (!this.terminaCom(' or ') && this.rsql !== 'search=') {
            this.rsql += ' or ';
        }
        return this;
    }
    equal(column, filter) {
        this.addExpression(`${column} == ${filter}`, filter);
        return this;
    }
    equalString(column, filter) {
        this.addExpression(`${column} == '${filter}'`, filter);
        return this;
    }
    diff(column, filter) {
        this.addExpression(`${column} != ${filter}`, filter);
        return this;
    }
    diffString(column, filter) {
        this.addExpression(`${column} != '${filter}'`, filter);
        return this;
    }
    greaterThanEqual(column, filter) {
        this.addExpression(`${column} >= '${filter}'`, filter);
        return this;
    }
    lowerThanEqual(column, filter) {
        this.addExpression(`${column} <= '${filter}'`, filter);
        return this;
    }
    like(column, filter) {
        this.addExpression(`${column} == '*${filter}*'`, filter);
        return this;
    }
    build() {
        this.removeTerminadoCom(' and ');
        this.removeTerminadoCom(' or ');
        if (this.rsql === 'search=') {
            return '';
        }
        return this.rsql;
    }
    addExpression(expression, value) {
        if (value) {
            this.rsql += expression;
        }
        else {
            this.removeTerminadoCom(' and ');
            this.removeTerminadoCom(' or ');
        }
    }
    terminaCom(value) {
        return this.rsql.substr(this.rsql.length - value.length, this.rsql.length - 1) === value;
    }
    removeTerminadoCom(value) {
        if (this.terminaCom(value)) {
            this.rsql = this.rsql.slice(0, this.rsql.length - value.length);
        }
    }
}

const semestreNames = ['1° semestre', '2° semestre'];
class SemestreUtils {
    static getSemestreName(semestre) {
        return semestreNames[semestre - 1];
    }
    static getSemestres() {
        return semestreNames;
    }
    static getMesInicial(semestre) {
        return semestre * 6 - 5;
    }
    static getMesFinal(semestre) {
        return semestre * 6;
    }
}

// @dynamic
class SortUtils {
    static sortNumberAsc(fieldPath) {
        return (a, b) => {
            const valueFromA = this.getValueFromFieldPath(a, fieldPath);
            const valueFromB = this.getValueFromFieldPath(b, fieldPath);
            if (valueFromA > valueFromB) {
                return 1;
            }
            else if (valueFromA < valueFromB) {
                return -1;
            }
            return 0;
        };
    }
    static sortNumberDesc(fieldPath) {
        return (a, b) => {
            const valueFromA = this.getValueFromFieldPath(a, fieldPath);
            const valueFromB = this.getValueFromFieldPath(b, fieldPath);
            if (valueFromB > valueFromA) {
                return 1;
            }
            else if (valueFromB < valueFromA) {
                return -1;
            }
            return 0;
        };
    }
    static sortStringAsc(fieldPath) {
        return (a, b) => {
            const valueFromA = this.getValueFromFieldPath(a, fieldPath);
            const valueFromB = this.getValueFromFieldPath(b, fieldPath);
            return (valueFromA ? valueFromA.toString() : '').localeCompare(valueFromB ? valueFromB.toString() : '');
        };
    }
    static sortStringDesc(fieldPath) {
        return (a, b) => {
            const valueFromA = this.getValueFromFieldPath(a, fieldPath);
            const valueFromB = this.getValueFromFieldPath(b, fieldPath);
            return (valueFromB ? valueFromB.toString() : '').localeCompare(valueFromA ? valueFromA.toString() : '');
        };
    }
    static getValueFromFieldPath(obj, fieldPath) {
        let value = obj;
        fieldPath.split('.').forEach(fieldPart => {
            if (!value) {
                return;
            }
            value = value[fieldPart];
        });
        return value;
    }
}

const trimestreNames = ['1° trimestre', '2° trimestre', '3° trimestre', '4° trimestre'];
class TrimestreUtils {
    static getTrimestreName(trimestre) {
        return trimestreNames[trimestre - 1];
    }
    static getTrimestres() {
        return trimestreNames;
    }
    static getMesInicial(trimestre) {
        return trimestre * 3 - 2;
    }
    static getMesFinal(trimestre) {
        return trimestre * 3;
    }
}

function createAuthResource() {
    return Object.assign(AUTH_RESOURCES_CONFIG_UNICO);
}
function createHttpClientMock() {
    const httpMock = {
        get: () => of([]),
        post: () => of({}),
        patch: () => of({}),
        del: () => of({})
    };
    return httpMock;
}
function createAuthHttpMock() {
    const authHttpMock = { getPermissionsByRole: () => of(['DELETE', 'UPDATE', 'CREATE', 'READ']) };
    return authHttpMock;
}
function createRouterMock() {
    return {};
}
const ɵ0$2 = { snapshot: { params: { id: 'new' } } }, ɵ1 = new EloNotificationService();
class CrudFormTestingModule {
}
CrudFormTestingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudFormTestingModule });
CrudFormTestingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudFormTestingModule_Factory(t) { return new (t || CrudFormTestingModule)(); }, providers: [RouterService,
        { provide: Location, useClass: SpyLocation }, { provide: ActivatedRoute, useValue: ɵ0$2 }, { provide: HttpClient, useFactory: createHttpClientMock },
        { provide: Router, useFactory: createRouterMock },
        { provide: AbstractAuthHttp, useFactory: createAuthHttpMock },
        {
            provide: AUTH_RESOURCES_CONFIG,
            useFactory: createAuthResource
        }, { provide: EloNotificationService, useValue: ɵ1 }
    ] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudFormTestingModule, [{
        type: NgModule,
        args: [{
                providers: [RouterService,
                    { provide: Location, useClass: SpyLocation }, { provide: ActivatedRoute, useValue: ɵ0$2 }, { provide: HttpClient, useFactory: createHttpClientMock },
                    { provide: Router, useFactory: createRouterMock },
                    { provide: AbstractAuthHttp, useFactory: createAuthHttpMock },
                    {
                        provide: AUTH_RESOURCES_CONFIG,
                        useFactory: createAuthResource
                    }, { provide: EloNotificationService, useValue: ɵ1 }
                ]
            }]
    }], null, null); })();

class TestUtils {
    static configure(module, crudForm, options = {}) {
        TestBed.configureTestingModule({
            imports: [module, CrudFormTestingModule],
            declarations: options.declarations,
            providers: options.providers
        });
        return TestBed.compileComponents().then(() => {
            let fixture = TestBed.createComponent(crudForm);
            fixture.detectChanges();
            return fixture;
        });
    }
    static configureOnce(module, options = {}) {
        TestBed.resetTestingModule();
        const modulesDefault = [module, CrudFormTestingModule];
        TestBed.configureTestingModule({
            imports: options.modules ? [...options.modules, ...modulesDefault] : modulesDefault,
            declarations: options.declarations,
            providers: options.providers
        });
        TestBed.resetTestingModule = () => TestBed;
        return TestBed.compileComponents();
    }
    static teardown() {
        TestBed.resetTestingModule = TestUtils.resetTestingModule;
        TestBed.resetTestingModule();
    }
}
TestUtils.resetTestingModule = TestBed.resetTestingModule;

class ReportFormatComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.readonly = false;
        this.onSelectFormat = new EventEmitter();
        this.onChangeFormat = null;
        this.formatTypes = [
            'pdf', 'html', 'xls', 'xlsx', 'rtf', 'csv', 'xml', 'docx', 'odt', 'ods'
        ];
    }
    ngOnInit() {
        if (!this.form) {
            this.form = this.createForm();
        }
        this.onSelect({ target: { value: 'pdf' } });
        this.subscribeOnChangeFormat();
    }
    createForm() {
        const form = this.formBuilder.group({
            'formatType': ['pdf'],
        });
        return form;
    }
    subscribeOnChangeFormat() {
        if (this.onChangeFormat) {
            this.onChangeFormat.subscribe((type) => {
                this.form.patchValue({ formatType: type });
                this.onSelect({ target: { value: type } });
            });
        }
    }
    onSelect(formatType) {
        this.onSelectFormat.emit(formatType.target.value);
    }
}
ReportFormatComponent.ɵfac = function ReportFormatComponent_Factory(t) { return new (t || ReportFormatComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
ReportFormatComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ReportFormatComponent, selectors: [["report-format"]], inputs: { readonly: "readonly", onChangeFormat: "onChangeFormat", form: "form" }, outputs: { onSelectFormat: "onSelectFormat" }, decls: 4, vars: 4, consts: [["inputs", "", 3, "formGroup"], ["label", "Formato do Relat\u00F3rio", "column", "2"], ["id", "formatType", "formControlName", "formatType", 3, "change"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function ReportFormatComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "elo-form-label-column", 1);
        ɵngcc0.ɵɵelementStart(2, "select", 2);
        ɵngcc0.ɵɵlistener("change", function ReportFormatComponent_Template_select_change_2_listener($event) { return ctx.onSelect($event); });
        ɵngcc0.ɵɵtemplate(3, ReportFormatComponent_option_3_Template, 2, 2, "option", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("readonly", ctx.readonly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.formatTypes);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, FormLabelColumnComponent, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
ReportFormatComponent.ctorParameters = () => [
    { type: FormBuilder }
];
ReportFormatComponent.propDecorators = {
    readonly: [{ type: Input }],
    onSelectFormat: [{ type: Output }],
    onChangeFormat: [{ type: Input }],
    form: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ReportFormatComponent, [{
        type: Component,
        args: [{
                selector: 'report-format',
                template: "<form [formGroup]=\"form\" inputs>\n    <elo-form-label-column label='Formato do Relat\u00F3rio' column=\"2\">\n        <select id=\"formatType\" formControlName=\"formatType\" (change)=\"onSelect($event)\" [class.readonly]=\"readonly\">\n            <option *ngFor=\"let formatType of formatTypes\" [value]=\"formatType\">{{ formatType }}</option>\n        </select>\n    </elo-form-label-column>\n</form>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { readonly: [{
            type: Input
        }], onSelectFormat: [{
            type: Output
        }], onChangeFormat: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class ReportFormatModule {
}
ReportFormatModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ReportFormatModule });
ReportFormatModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ReportFormatModule_Factory(t) { return new (t || ReportFormatModule)(); }, imports: [[
            CommonModule$1,
            ReactiveFormsModule,
            FormLabelColumnModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ReportFormatModule, { declarations: function () { return [ReportFormatComponent]; }, imports: function () { return [CommonModule$1,
        ReactiveFormsModule, FormLabelColumnModule, FormsModule]; }, exports: function () { return [ReportFormatComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ReportFormatModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    ReactiveFormsModule,
                    FormLabelColumnModule,
                    FormsModule
                ],
                declarations: [ReportFormatComponent],
                exports: [ReportFormatComponent]
            }]
    }], null, null); })();

var CampoTipoEnum;
(function (CampoTipoEnum) {
    CampoTipoEnum["TEXTO"] = "TEXTO";
    CampoTipoEnum["INTEIRO"] = "INTEIRO";
    CampoTipoEnum["DECIMAL"] = "DECIMAL";
    CampoTipoEnum["DATA"] = "DATA";
    CampoTipoEnum["MULTIPLA_ESCOLHA"] = "MULTIPLA_ESCOLHA";
})(CampoTipoEnum || (CampoTipoEnum = {}));
var TipoValidacaoEnum;
(function (TipoValidacaoEnum) {
    TipoValidacaoEnum["OBRIGATORIO_SE_PRESENTE"] = "OBRIGATORIO_SE_PRESENTE";
    TipoValidacaoEnum["OBRIGATORIO_SE_AUSENTE"] = "OBRIGATORIO_SE_AUSENTE";
    TipoValidacaoEnum["PROIBIDO_SE_PRESENTE"] = "PROIBIDO_SE_PRESENTE";
    TipoValidacaoEnum["PROIBIDO_SE_AUSENTE"] = "PROIBIDO_SE_AUSENTE";
    TipoValidacaoEnum["OBRIGATORIO_SE_IGUAL"] = "OBRIGATORIO_SE_IGUAL";
    TipoValidacaoEnum["PROIBIDO_SE_IGUAL"] = "PROIBIDO_SE_IGUAL";
})(TipoValidacaoEnum || (TipoValidacaoEnum = {}));

const fieldNameRespostaDefault = 'respostas';
const fieldNameGruposDefault = 'grupos';
const limparGrupos = (gruposFormArray) => {
    gruposFormArray.controls.splice(0, gruposFormArray.length);
    gruposFormArray.reset();
};
const ɵ0$3 = limparGrupos;
const initGruposRespostaForm = (form, formBuilder, gruposResposta, fieldNameGrupos = fieldNameGruposDefault) => {
    const gruposFormArray = form.get(fieldNameGrupos);
    limparGrupos(gruposFormArray);
    gruposResposta === null || gruposResposta === void 0 ? void 0 : gruposResposta.forEach((gr) => {
        var _a;
        gruposFormArray.push((gr === null || gr === void 0 ? void 0 : gr.id) &&
            formBuilder.group({
                id: [gr.id],
                descricao: [gr.descricao],
                ativo: [gr.ativo || false],
                [fieldNameRespostaDefault]: formBuilder.array(((_a = gr.respostas) === null || _a === void 0 ? void 0 : _a.map((r) => formBuilder.group({
                    id: [r.id],
                    campo: [r.campo],
                    referencia: [r.referencia],
                    valor: [r.valor],
                    alternativa: [r.alternativa],
                }))) || []),
            }));
    });
};
const buildRespostasFromGrupoRespostaDTO = (values) => {
    const respostas = [];
    const reducedForm = values.reduce((acc, current) => {
        acc[current.id] = current;
        return acc;
    }, {});
    const toResposta = (r) => ({
        id: r.id,
        campo: r.campo,
        valor: r.valor,
        alternativa: r.alternativa,
    });
    Object.values(reducedForm).forEach((gr) => respostas.push(...gr.respostas.map(toResposta)));
    return respostas;
};
const limparRespostas = (respostasFormArray) => {
    respostasFormArray.controls.splice(0, respostasFormArray.length);
    respostasFormArray.reset();
};
const changeRespostasEntityFormArray = (formBuilder, form, fieldNameResposta, fieldNameGrupos) => {
    const respostasFormArray = form.get(fieldNameResposta);
    limparRespostas(respostasFormArray);
    const respostas = buildRespostasFromGrupoRespostaDTO(form.get(fieldNameGrupos).value);
    respostas.forEach((r) => {
        respostasFormArray.push(formBuilder.group({
            id: [r.id],
            campo: [r.campo],
            valor: [r.valor],
            alternativa: [r.alternativa],
        }));
    });
};

const isCampoObrigatorioValorSemResposta = (resposta) => {
    return (resposta.campo.tipo !== CampoTipoEnum.MULTIPLA_ESCOLHA &&
        resposta.campo.obrigatorio &&
        resposta.campo.ativo &&
        !resposta.valor);
};
const ɵ0$4 = isCampoObrigatorioValorSemResposta;
const isCampoObrigatorioMultiplaEscolhaSemResposta = (resposta) => {
    var _a;
    return (resposta.campo.tipo === CampoTipoEnum.MULTIPLA_ESCOLHA &&
        resposta.campo.obrigatorio &&
        resposta.campo.ativo &&
        (!resposta.alternativa || !((_a = resposta.alternativa) === null || _a === void 0 ? void 0 : _a.ativo)));
};
const ɵ1$1 = isCampoObrigatorioMultiplaEscolhaSemResposta;
const getMessageCampoObrigatorio = (campo) => {
    return `${campo.descricao} é obrigatório`;
};
const ɵ2 = getMessageCampoObrigatorio;
const suffixNameElementCampoValor = 'valor';
const suffixNameElementCampoMultiplaEscolha = 'alternativa.id';
const setErrorOnFieldByTipo = (resposta, mensagem) => {
    const mensagemGenerica = {
        valid: false,
        mensagem,
    };
    const campo = resposta.get('campo').value;
    if (campo.tipo === CampoTipoEnum.MULTIPLA_ESCOLHA) {
        resposta.get('alternativa').setErrors({
            mensagemGenerica,
        });
    }
    else {
        resposta.get('valor').setErrors({
            mensagemGenerica,
        });
    }
};
const ɵ3 = setErrorOnFieldByTipo;
const setNullOnError = (resposta) => {
    const campo = resposta.get('campo').value;
    if (campo.tipo === CampoTipoEnum.MULTIPLA_ESCOLHA) {
        resposta.get('alternativa').setErrors(null);
    }
    else {
        resposta.get('valor').setErrors(null);
    }
};
const ɵ4 = setNullOnError;
const validateCamposDinamicos = (form, fieldNameGrupos) => {
    const grupos = form === null || form === void 0 ? void 0 : form.get(fieldNameGrupos);
    grupos === null || grupos === void 0 ? void 0 : grupos.controls.forEach((grupo) => {
        const respostas = grupo.get(fieldNameRespostaDefault);
        respostas === null || respostas === void 0 ? void 0 : respostas.controls.forEach((resposta) => {
            var _a, _b;
            if (!((_a = resposta.value) === null || _a === void 0 ? void 0 : _a.campo)) {
                return;
            }
            if (isCampoObrigatorioValorSemResposta(resposta.value)) {
                setErrorOnFieldByTipo(resposta, getMessageCampoObrigatorio(resposta.value.campo));
            }
            else if (isCampoObrigatorioMultiplaEscolhaSemResposta(resposta.value)) {
                setErrorOnFieldByTipo(resposta, getMessageCampoObrigatorio(resposta.value.campo));
            }
            else if (((_b = resposta.value.campo.validacoes) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                const validationError = resposta.value.campo.validacoes.reduce((error, validation) => {
                    return (error !== null && error !== void 0 ? error : validadoresGrupoResposta[validation.tipo](respostas.value, resposta.value, validation));
                }, undefined);
                if (validationError) {
                    setErrorOnFieldByTipo(resposta, validationError);
                }
                else {
                    setNullOnError(resposta);
                }
            }
            else {
                setNullOnError(resposta);
            }
        });
    });
};
const respostaToFlat = (resposta) => {
    var _a;
    return ({
        descricao: resposta.campo.descricao,
        campoDependente: resposta.campo.identificador,
        valor: resposta.valor,
        alternativa: resposta.alternativa,
        alternativaAtiva: ((_a = resposta.alternativa) === null || _a === void 0 ? void 0 : _a.ativo) || false,
        tipoCampo: resposta.campo.tipo,
        campoAtivo: resposta.campo.ativo,
    });
};
const ɵ5 = respostaToFlat;
const formatStringToDisplayDate = (date) => {
    const newDate = typeof date === 'string' ? new Date(date) : date;
    if (newDate) {
        return DateUtils.format(newDate);
    }
    return newDate;
};
const ɵ6 = formatStringToDisplayDate;
const formatValor = (respostaBase, validacao) => {
    if (respostaBase.tipoCampo === CampoTipoEnum.DATA) {
        return formatStringToDisplayDate(validacao.valor);
    }
    return validacao.valor;
};
const ɵ7 = formatValor;
const getRespostaDinamica = (respostas, nomeCampo) => {
    const match = respostas.find((resposta) => resposta.campo.identificador === nomeCampo);
    return match ? respostaToFlat(match) : undefined;
};
const ɵ8 = getRespostaDinamica;
const validatorBuilder = (innerValidator) => (respostas, resposta, validacao) => {
    const respostaDependente = getRespostaDinamica(respostas, validacao.campoDependente);
    if (!(respostaDependente === null || respostaDependente === void 0 ? void 0 : respostaDependente.campoAtivo)) {
        return;
    }
    return innerValidator({
        resposta: respostaToFlat(resposta),
        respostaBase: respostaDependente,
        validacao,
    });
};
const ɵ9 = validatorBuilder;
const ɵ10 = ({ resposta, respostaBase }) => {
    if (!resposta.valor &&
        !resposta.alternativa &&
        !respostaBase.valor &&
        (!respostaBase.alternativa || !respostaBase.alternativaAtiva)) {
        return `O campo '${resposta.descricao}' deve estar respondido se o campo '${respostaBase.descricao}' não estiver.`;
    }
}, ɵ11 = ({ resposta, respostaBase }) => {
    if ((resposta.valor || resposta.alternativa) &&
        !respostaBase.valor &&
        (!respostaBase.alternativa || !respostaBase.alternativaAtiva)) {
        return `O campo '${resposta.descricao}' não deve estar respondido se o campo '${respostaBase.descricao}' não estiver.`;
    }
}, ɵ12 = ({ resposta, respostaBase }) => {
    if (!resposta.valor &&
        !resposta.alternativa &&
        (respostaBase.valor ||
            (respostaBase.alternativaAtiva && respostaBase.alternativa))) {
        return `O campo '${resposta.descricao}' deve estar respondido se o campo '${respostaBase.descricao}' estiver.`;
    }
}, ɵ13 = ({ resposta, respostaBase }) => {
    if ((resposta.valor || resposta.alternativa) &&
        (respostaBase.valor ||
            (respostaBase.alternativaAtiva && respostaBase.alternativa))) {
        return `O campo '${resposta.descricao}' não pode estar respondido se o campo '${respostaBase.descricao}' estiver.`;
    }
}, ɵ14 = ({ resposta, respostaBase, validacao }) => {
    var _a, _b, _c;
    const valorParaValidacao = respostaBase.valor
        ? respostaBase.valor
        : String((_a = respostaBase === null || respostaBase === void 0 ? void 0 : respostaBase.alternativa) === null || _a === void 0 ? void 0 : _a.codigo);
    if (!resposta.valor &&
        !resposta.alternativa &&
        ((((_b = respostaBase.alternativa) === null || _b === void 0 ? void 0 : _b.id) && respostaBase.alternativaAtiva) ||
            !((_c = respostaBase.alternativa) === null || _c === void 0 ? void 0 : _c.id)) &&
        `${validacao.valor}` === `${valorParaValidacao}`) {
        return `O campo '${resposta.descricao}' é obrigatório se o campo '${respostaBase.descricao}' for igual a ${formatValor(respostaBase, validacao)}.`;
    }
}, ɵ15 = ({ resposta, respostaBase, validacao }) => {
    var _a, _b, _c;
    const valorParaValidacao = respostaBase.valor
        ? respostaBase.valor
        : String((_a = respostaBase === null || respostaBase === void 0 ? void 0 : respostaBase.alternativa) === null || _a === void 0 ? void 0 : _a.codigo);
    if ((resposta.valor || resposta.alternativa) &&
        ((((_b = respostaBase.alternativa) === null || _b === void 0 ? void 0 : _b.id) && respostaBase.alternativaAtiva) ||
            !((_c = respostaBase.alternativa) === null || _c === void 0 ? void 0 : _c.id)) &&
        `${validacao.valor}` === `${valorParaValidacao}`) {
        return `O campo '${resposta.descricao}' é proibido se o campo '${respostaBase.descricao}' for igual a ${formatValor(respostaBase, validacao)}.`;
    }
};
const validadoresGrupoResposta = {
    OBRIGATORIO_SE_AUSENTE: validatorBuilder(ɵ10),
    PROIBIDO_SE_AUSENTE: validatorBuilder(ɵ11),
    OBRIGATORIO_SE_PRESENTE: validatorBuilder(ɵ12),
    PROIBIDO_SE_PRESENTE: validatorBuilder(ɵ13),
    OBRIGATORIO_SE_IGUAL: validatorBuilder(ɵ14),
    PROIBIDO_SE_IGUAL: validatorBuilder(ɵ15),
};

class CamposDinamicosComponent {
    constructor() {
        this.fieldNameResposta = fieldNameRespostaDefault;
        this.fieldNameGrupos = fieldNameGruposDefault;
    }
}
CamposDinamicosComponent.ɵfac = function CamposDinamicosComponent_Factory(t) { return new (t || CamposDinamicosComponent)(); };
CamposDinamicosComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CamposDinamicosComponent, selectors: [["campos-dinamicos-component"]], inputs: { fieldNameResposta: "fieldNameResposta", fieldNameGrupos: "fieldNameGrupos", form: "form" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "formGroup"], [3, "formArrayName"], [4, "ngFor", "ngForOf"], [3, "id", "formGroupName", 4, "ngIf"], [3, "id", "formGroupName"], [1, "row", "mt-xs"], [1, "col-md-12"], [1, "dd-title"], [3, "form", "grupoForm", "indexGrupoResposta", "fieldNameResposta", "fieldNameGrupos"]], template: function CamposDinamicosComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CamposDinamicosComponent_div_0_Template, 4, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !!(ctx.form == null ? null : ctx.form.get(ctx.fieldNameGrupos)));
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.FormArrayName, ɵngcc2.NgForOf, ɵngcc3.FormGroupName, CamposDinamicosRespostasComponent]; }, encapsulation: 2 });
CamposDinamicosComponent.propDecorators = {
    fieldNameResposta: [{ type: Input }],
    fieldNameGrupos: [{ type: Input }],
    form: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CamposDinamicosComponent, [{
        type: Component,
        args: [{
                selector: 'campos-dinamicos-component',
                template: "<div *ngIf=\"!!form?.get(fieldNameGrupos)\">\n  <form [formGroup]=\"form\">\n    <div formArrayName=\"{{ fieldNameGrupos }}\">\n      <div\n        *ngFor=\"\n          let grupo of form.get(fieldNameGrupos)['controls'];\n          let i = index\n        \"\n      >\n        <div\n          id=\"grupo_{{ grupo.value?.id }}\"\n          [formGroupName]=\"i\"\n          *ngIf=\"!!grupo.value?.ativo\"\n        >\n          <div class=\"row mt-xs\">\n            <div class=\"col-md-12\">\n              <b class=\"dd-title\"> {{ grupo.value?.descricao }} </b>\n            </div>\n          </div>\n          <campos-dinamicos-respostas\n            [form]=\"form\"\n            [grupoForm]=\"grupo\"\n            [indexGrupoResposta]=\"i\"\n            [fieldNameResposta]=\"fieldNameResposta\"\n            [fieldNameGrupos]=\"fieldNameGrupos\"\n          ></campos-dinamicos-respostas>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n"
            }]
    }], function () { return []; }, { fieldNameResposta: [{
            type: Input
        }], fieldNameGrupos: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class CamposDinamicosRespostasComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.suffixNameElementCampoValor = 'valor';
        this.getTipoCampoFromEnum = {
            TEXTO: 'text',
            INTEIRO: 'text',
            DECIMAL: 'text',
            DATA: 'date',
            MULTIPLA_ESCOLHA: 'select',
        };
    }
    ngOnInit() {
        this.changeRespostasEntity();
    }
    ngAfterViewInit() {
        validateCamposDinamicos(this.form, this.fieldNameGrupos);
    }
    changeRespostasEntity() {
        changeRespostasEntityFormArray(this.formBuilder, this.form, this.fieldNameResposta, this.fieldNameGrupos);
    }
    compareWith() {
        return FormUtils.equals('id');
    }
    getAlternativasAtivas(alternativas) {
        return alternativas.filter((a) => a.ativo);
    }
}
CamposDinamicosRespostasComponent.ɵfac = function CamposDinamicosRespostasComponent_Factory(t) { return new (t || CamposDinamicosRespostasComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
CamposDinamicosRespostasComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CamposDinamicosRespostasComponent, selectors: [["campos-dinamicos-respostas"]], inputs: { form: "form", grupoForm: "grupoForm", fieldNameResposta: "fieldNameResposta", fieldNameGrupos: "fieldNameGrupos", indexGrupoResposta: "indexGrupoResposta" }, decls: 1, vars: 1, consts: [["class", "row", 3, "formGroup", 4, "ngIf"], [1, "row", 3, "formGroup"], [1, "flex", "wrap", "align-items-left", "mb-xs"], ["formArrayName", "respostas"], [3, "id", 4, "ngFor", "ngForOf"], [3, "id"], [3, "formGroupName", 4, "ngIf"], [3, "formGroupName"], ["column", "3", 3, "label"], [4, "ngIf"], ["formControlName", "valor", "formControlValidationMsg", "", 3, "id", "type", "blur"], ["formControlName", "valor", "formControlValidationMsg", "", "eloNumber", "", 3, "id", "type", "blur"], ["formControlName", "valor", "formControlValidationMsg", "", "eloDecimal", "", 3, "id", "type", "blur"], ["formControlName", "alternativa", "formControlValidationMsg", "", 3, "id", "compareWith", "change"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"]], template: function CamposDinamicosRespostasComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CamposDinamicosRespostasComponent_div_0_Template, 4, 2, "div", 0);
    } if (rf & 2) {
        var tmp_0_0 = null;
        ɵngcc0.ɵɵproperty("ngIf", ((tmp_0_0 = ctx.grupoForm.get("respostas")) == null ? null : tmp_0_0.value) && ctx.grupoForm.get("respostas").value.length > 0);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.FormArrayName, ɵngcc2.NgForOf, ɵngcc3.FormGroupName, FormLabelColumnComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, FormControlValidationMsgDirective, EloNumberDirective, EloDecimalDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
CamposDinamicosRespostasComponent.ctorParameters = () => [
    { type: FormBuilder }
];
CamposDinamicosRespostasComponent.propDecorators = {
    form: [{ type: Input }],
    grupoForm: [{ type: Input }],
    fieldNameResposta: [{ type: Input }],
    fieldNameGrupos: [{ type: Input }],
    indexGrupoResposta: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CamposDinamicosRespostasComponent, [{
        type: Component,
        args: [{
                selector: 'campos-dinamicos-respostas',
                template: "<div\n  [formGroup]=\"grupoForm\"\n  class=\"row\"\n  *ngIf=\"\n    grupoForm.get('respostas')?.value &&\n    grupoForm.get('respostas').value.length > 0\n  \"\n>\n  <div class=\"flex wrap align-items-left mb-xs\">\n    <div formArrayName=\"respostas\">\n      <div\n        id=\"respostas_{{ form?.get('id')?.value }}\"\n        *ngFor=\"\n          let resposta of grupoForm.get('respostas')['controls'];\n          let i = index\n        \"\n      >\n        <div [formGroupName]=\"i\" *ngIf=\"!!resposta.value?.campo?.ativo\">\n          <elo-form-label-column\n            label=\"{{ resposta.value?.campo.descricao }}\"\n            column=\"3\"\n          >\n            <div\n              *ngIf=\"\n                resposta.value?.campo.tipo === 'TEXTO' ||\n                resposta.value?.campo.tipo === 'DATA'\n              \"\n            >\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'INTEIRO'\">\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                eloNumber\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'DECIMAL'\">\n              <input\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                type=\"{{ getTipoCampoFromEnum[resposta.value?.campo.tipo] }}\"\n                formControlName=\"valor\"\n                formControlValidationMsg\n                eloDecimal\n                (blur)=\"changeRespostasEntity()\"\n              />\n            </div>\n            <div *ngIf=\"resposta.value?.campo.tipo === 'MULTIPLA_ESCOLHA'\">\n              <select\n                id=\"campo_{{ resposta.value?.campo.id }}_{{ i }}\"\n                formControlName=\"alternativa\"\n                formControlValidationMsg\n                (change)=\"changeRespostasEntity()\"\n                [compareWith]=\"compareWith()\"\n              >\n                <option [ngValue]=\"\"></option>\n                <option\n                  *ngFor=\"\n                    let a of getAlternativasAtivas(\n                      resposta.value?.campo.alternativas\n                    )\n                  \"\n                  [ngValue]=\"a\"\n                >\n                  {{ a?.codigo }} - {{ a?.descricao }}\n                </option>\n              </select>\n            </div>\n          </elo-form-label-column>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { form: [{
            type: Input
        }], grupoForm: [{
            type: Input
        }], fieldNameResposta: [{
            type: Input
        }], fieldNameGrupos: [{
            type: Input
        }], indexGrupoResposta: [{
            type: Input
        }] }); })();

class CamposDinamicosViewComponent {
}
CamposDinamicosViewComponent.ɵfac = function CamposDinamicosViewComponent_Factory(t) { return new (t || CamposDinamicosViewComponent)(); };
CamposDinamicosViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CamposDinamicosViewComponent, selectors: [["campos-dinamicos-view-component"]], inputs: { gruposRespostas: "gruposRespostas" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "id", 4, "ngIf"], [3, "id"], [1, "row", "mt-xs"], [1, "col-md-12"], [1, "dd-title"], ["class", "mt-xs", 4, "ngIf"], [1, "mt-xs"], [1, "panel", "table"], [1, "panel-body", "pb-none"], [3, "values", "emptyMessage"], ["field", "campo.codigo", "header", "C\u00F3digo"], ["field", "campo.descricao", "header", "Descri\u00E7\u00E3o"], ["field", "valorResposta", "header", "Valor Resposta"], ["dataTableCell", ""]], template: function CamposDinamicosViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CamposDinamicosViewComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.gruposRespostas && ctx.gruposRespostas.length > 0);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, EloDatatableComponent, EloColumnComponent], pipes: [DecimalFormatPipe, DateFormatPipe], encapsulation: 2 });
CamposDinamicosViewComponent.propDecorators = {
    gruposRespostas: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CamposDinamicosViewComponent, [{
        type: Component,
        args: [{
                selector: 'campos-dinamicos-view-component',
                template: "<div *ngIf=\"gruposRespostas && gruposRespostas.length > 0\">\n  <div *ngFor=\"let grupo of gruposRespostas; let i = index\">\n    <div id=\"grupo_{{ grupo.id }}\" *ngIf=\"!!grupo.ativo\">\n      <div class=\"row mt-xs\">\n        <div class=\"col-md-12\">\n          <b class=\"dd-title\"> {{ grupo.descricao }} </b>\n        </div>\n      </div>\n      <div class=\"mt-xs\" *ngIf=\"grupo.respostas.length > 0\">\n        <ng-container>\n          <div class=\"panel table\">\n            <div class=\"panel-body pb-none\">\n              <elo-datatable\n                [values]=\"grupo.respostas\"\n                [class]=\"'fancy fixed'\"\n                [emptyMessage]=\"'Sem registros'\"\n              >\n                <elo-column field=\"campo.codigo\" header=\"C\u00F3digo\"></elo-column>\n                <elo-column\n                  field=\"campo.descricao\"\n                  header=\"Descri\u00E7\u00E3o\"\n                ></elo-column>\n                <elo-column field=\"valorResposta\" header=\"Valor Resposta\">\n                  <ng-template #dataTableCell let-object=\"object\">\n                    <p *ngIf=\"object?.campo?.tipo === 'TEXTO'\">\n                      {{ object.valor }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'INTEIRO'\">\n                      {{ object.valor }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'DECIMAL'\">\n                      {{ object.valor | decimalformat: '1.2-2' }}\n                    </p>\n                    <p *ngIf=\"object?.campo?.tipo === 'DATA'\">\n                      {{ object.valor | dateformat }}\n                    </p>\n                    <div *ngIf=\"object?.campo?.tipo === 'MULTIPLA_ESCOLHA'\">\n                      {{ object.alternativa.codigo }} -\n                      {{ object.alternativa.descricao }}\n                    </div>\n                  </ng-template>\n                </elo-column>\n              </elo-datatable>\n            </div>\n          </div>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n"
            }]
    }], null, { gruposRespostas: [{
            type: Input
        }] }); })();

class CamposDinamicosModule {
}
CamposDinamicosModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CamposDinamicosModule });
CamposDinamicosModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CamposDinamicosModule_Factory(t) { return new (t || CamposDinamicosModule)(); }, imports: [[
            FormControlValidationMsgModule,
            PanelModule,
            FormLabelColumnModule,
            FormsModule,
            DatePickerModule,
            EloDatatableModule,
            CrudFormDetailModule,
            DialogModule,
            PanelExpansiveModule,
            ReactiveFormsModule,
            DirectivesModule,
            CommonModule$1,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CamposDinamicosModule, { declarations: function () { return [CamposDinamicosComponent, CamposDinamicosRespostasComponent, CamposDinamicosViewComponent]; }, imports: function () { return [FormControlValidationMsgModule, PanelModule, FormLabelColumnModule, FormsModule, DatePickerModule, EloDatatableModule, CrudFormDetailModule, DialogModule, PanelExpansiveModule, ReactiveFormsModule, DirectivesModule, CommonModule$1]; }, exports: function () { return [CamposDinamicosComponent, CamposDinamicosViewComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CamposDinamicosModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormControlValidationMsgModule,
                    PanelModule,
                    FormLabelColumnModule,
                    FormsModule,
                    DatePickerModule,
                    EloDatatableModule,
                    CrudFormDetailModule,
                    DialogModule,
                    PanelExpansiveModule,
                    ReactiveFormsModule,
                    DirectivesModule,
                    CommonModule$1,
                ],
                declarations: [
                    CamposDinamicosComponent,
                    CamposDinamicosRespostasComponent,
                    CamposDinamicosViewComponent,
                ],
                exports: [CamposDinamicosComponent, CamposDinamicosViewComponent]
            }]
    }], null, null); })();

// Public API Surface of common

/**
 * Generated bundle index. Do not edit.
 */

export { APPLICATION_JSON_PATCH, AREAS, AUTH_RESOURCES_CONFIG, AUTH_RESOURCES_CONFIG_ISS, AUTH_RESOURCES_CONFIG_PORTAL_SERVICOS, AUTH_RESOURCES_CONFIG_UNICO, AbstractAuthHttp, AccordionComponent, AccordionItemComponent, AccordionModule, AcessibilityService, AppConfigService, AppService, Area, ArquivoComponent, ArquivoModule, ArrayUtil, ArvoreAvancadaChildrenSummaryComponent, ArvoreAvancadaComponent, ArvoreAvancadaModule, ArvoreAvancadaNodeComponent, ArvoreAvancadaNodeFormComponent, ArvoreAvancadaNodeHeaderComponent, AssertUtils, AssertUtilsApp, AssinaturaSelectorComponent, AssinaturaSelectorModule, AuthHttp, AuthInterceptor, AuthParams, AuthenticationComponent, AuthenticationModule, AutoCompleteComponent, AutoCompleteModule, AutofocusDirective, BackConfirmComponent, BackConfirmModule, BaseHref, BaseUrlService, BimestreUtils, BlobPopupComponent, BlobPopupExecutorFactory, BlobPopupModule, BlobPopupService, BlockContentComponent, BlockContentModule, BodyZoomService, BooleanTextPipe, BreadcrumbComponent, BreadcrumbIframeService, BreadcrumbModule, ButtonLogComponent, ButtonLogModule, ButtonSelectOneComponent, ButtonSelectOneModule, CONTAINED_IN_CAPTION, CONTAINED_IN_OPERATION, CONTAINS_CAPTION, CONTAINS_OPERATION, CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR, CURRENCY_MASK_CONFIG, CalendarComponent, CalendarModule, CampoTipoEnum, CamposDinamicosComponent, CamposDinamicosModule, CamposDinamicosRespostasComponent, CamposDinamicosViewComponent, CanActivateKeyCloak, CanActivateRoute, CanActivateRouteService, CanDeactivateGuard, CapitalizePipe, CepDirective, CepPipe, ChipComponent, ChipModule, ClipboardDirective, CnpjCpfDirective, CnpjCpfPipe, CnpjDirective, Column, ColumnDrilldown, CommonComponent, CommonModule, CommonService, Competencia, CompetenciaDirective, CompetenciaUtils, ConfiguracaoEntidade, ConfiguracaoEntidadeKeycloakComponent, ConfiguracaoEntidadeKeycloakService, ConfiguracaoEntidadeObservable, ConsultaDinamicaComponent, ConsultaDinamicaModule, CountdownPipe, CpfDirective, CrudButtonsComponent, CrudButtonsModule, CrudButtonsOperationsComponent, CrudButtonsOperationsModule, CrudDetailInlineComponent, CrudDetailInlineModule, CrudFormComponent, CrudFormDetailComponent, CrudFormDetailModule, CrudFormModule, CrudFormSimpleChildPaginatedComponent, CrudFormSimpleChildPaginatedModule, CrudOnePageEditableComponent, CrudOnePageEditableModule, CrudSearchComponent, CrudSearchLogComponent, CrudSearchLogModule, CrudSearchModule, CrudTreeComponent, CrudTreeModule, CurrencyFormatPipe, CurrencyMaskDirective, DATEHOURMODELFORMAT, DATEHOURVIEWFORMAT, DATEMODELFORMAT, DATEVIEWFORMAT, DAYS_EXPIRES_REMEMBER, DIA_1, DIA_30, DOMINGO, DROPDOWN_VALUE_ACCESSOR, DateFormatPipe, DateHourFormatPipe, DatePickerComponent, DatePickerModule, DateUtils, DecimalFormatPipe, Desktop, DetailInformationComponent, DetailInformationModule, DeviceUtils, DialogComponent, DialogModule, DiasFormatPipe, DiasPorExtensoPipe, DirectivesModule, DisableControlDirective, DomHandlerService, DoubleClickCopyDirective, ELOTECH_DOMAIN, ENDS_WITH_CAPTION, ENDS_WITH_OPERATION, EQUAL_OPERATION, ETagInterceptor, EloCheckboxComponent, EloCheckboxModule, EloColumnComponent, EloDataTableRowComponent, EloDatatableComponent, EloDatatableModule, EloDecimalDirective, EloFilterComponent, EloFilterModule, EloHeaderActionsComponent, EloModalComponent, EloModalModule, EloNotificationComponent, EloNotificationService, EloNotificationsModule, EloNumberDirective, EloQueryBuilderModule, EloQuickAccessButtonComponent, EloQuickAccessButtonModule, EloQuickAccessComponent, EloQuickAccessModule, EloRadioButtonComponent, EloRadioButtonModule, EloSelectComponent, EloSelectModule, EloSimpleFilterComponent, EloTableAction, EloTableActionLinkComponent, EloTableActionType, EloTableActionTypeAware, EloTableActionsComponent, EloTableDrilldownComponent, EloTableDrilldownModule, EloTableSubtitleComponent, EloTimelineHorizontalComponent, EloTimelineHorizontalModule, EloValidators, EntidadeSelectorComponent, EntidadeSelectorModule, EntidadeService, EntidadeTipo, EntityLogService, EntityService, EnumService, EnviarEmailComponent, EnviarEmailModule, ErrorModule, ErrorViolation, ExceptionHandlerComponent, FROM_FORMAT, FancySlideComponent, FancySlideItemComponent, FancySlideModule, FeatureAcessibilidadeComponent, FeatureAcessibilidadeContrasteComponent, FeatureConfiguracaoEntidadeComponent, FeatureContribuinteComponent, FeatureModuleStateService, FeatureModulesComponent, FeatureNotificationComponent, FeatureSobreSistemaComponent, FeatureUserComponent, FeaturesGroupComponent, FeaturesGroupModule, FileUploadComponent, FileUploadModule, FilterPipe, FloatButtonComponent, FloatButtonModule, FloatSideBarComponent, FloatSideBarModule, FloatSidebarService, FocusRemoverDirective, FocusUtil, FooterService, FormControlValidationMsgDirective, FormControlValidationMsgModule, FormLabelColumnComponent, FormLabelColumnModule, FormUtils, GREATER_OPERATION, GREATER_OR_EQUAL_OPERATION, GROUP_ADMIN, GlobalExceptionHandlerService, HTTP_ERROR_LIST, HeaderComponent, HeaderModule, HeaderParamsInterceptor, HeaderParamsKeycloakInterceptor, HeaderTitle, HoraDirective, HoraLancamentoDirective, HttpClient, HttpClientInterceptorToken, HttpClientUtils, HttpError, IFrameComponent, IFrameModule, IFrameStore, ImageUploadComponent, ImageUploadModule, InformationComponent, InformationModule, InterceptorsProviders, ItemDetailInformationComponent, ItemDetailInformationDirective, JasperService, JsonPatchUtil, JsonUpdateOperation, JsonUpdatePartial, JsonUtil, KEYCLOAK_AUTH_RESOURCES_CONFIG, KEY_CODE, KeycloakAuthHttp, KeycloakInterceptor, KeycloakToken, LESS_OPERATION, LESS_OR_EQUAL_OPERATION, LeisAtosAutoCompleteModalComponent, LeisAtosAutoCompleteModalModule, ListaModulosService, MODULO_KEY, MaskFormatDirective, MaskUtils, ModalFormInsertComponent, ModalFormInsertModule, ModalMenuComponent, ModalMenuModule, ModalMenuOptionComponent, MonthUtils, NOT_CONTAINED_IN_CAPTION, NOT_CONTAINED_IN_OPERATION, NOT_CONTAINS_CAPTION, NOT_CONTAINS_OPERATION, NOT_EQUAL_OPERATION, NavigateUtils, NonNegativeDirective, NotificationReportJasperComponent, NumberUtils, ObjectParseService, ObjectUtilService, OnBoardingComponent, OnBoardingModule, PAGE_SIZE, Page, PageBlockedComponent, PageBlockedModule, PageCustomizedComponent, PageCustomizedModule, PageForbiddenComponent, PageForbiddenModule, PageNotFoundComponent, PageNotFoundModule, PageParameters, PageUnavailableComponent, PageUnavailableModule, PaginationComponent, PaginationModule, PanelComponent, PanelExpansiveComponent, PanelExpansiveModule, PanelModule, PercentageFormatPipe, Periodo, PipeModule, PlacaDirective, PreviewBlockComponent, PreviewBlockItemComponent, PreviewComponent, PreviewModule, QuadrimestreUtils, QueryBuilderComponent, QuickViewComponent, QuickViewModule, RateioUtils, ReportFormatComponent, ReportFormatModule, ReportSelectorComponent, ReportSelectorModule, RevisionCompare, RodaAtalhosComponent, RodaAtalhosModule, Role, RolesCache, RotaFavoritaService, RouteUtils, RouterInterceptor, RouterService, RouterUtils, RsqlBuilder, SABADO, STARTS_WITH_CAPTION, STARTS_WITH_OPERATION, SafeUrlPipe, SearchFilter, SearchFilterComponent, SectionComponent, SectionDirective, SectionModule, SectionService, SelectOnFocusDirective, SemestreUtils, SideBarItemDirective, SidebarComponent, SidebarModule, SimNaoPipe, SortParameters, SortUtils, SortableHeaderComponent, SortableHeaderModule, SpinnerComponent, SpinnerInterceptor, SpinnerModule, SpinnerService, StringUtils, SubTipoPipe, SwitchButtonComponent, SwitchButtonItemComponent, SwitchButtonModule, SwitchComponent, SwitchModule, TO_FORMAT, TabControlComponent, TabControlModule, TabItemComponent, TableReportComponent, TableReportGroupComponent, TableReportGroupItensComponent, TableReportItemComponent, TableReportModule, TableReportTotalComponent, TelefoneDirective, TelefonePipe, TestUtils, TestingUtils, TipoValidacaoEnum, TrimestreUtils, UrlResolver, UrlUtils, Usuario, UsuarioInfoUtils, UsuarioTrocaSenha, VIEWFORMAT, VersionReloadHandlerComponent, VersionReloadModule, WidgetAreaComponent, WidgetFrequentlyComponent, WidgetFrequentlyItemComponent, WidgetFrequentlyItemModule, WidgetFrequentlyModule, WidgetHighlightComponent, WidgetModule, WidgetNumericComponent, WidgetPanelComponent, WidgetProgressComponent, WindowService, WizardControlComponent, WizardControlModule, WizardStepComponent, ZeroWhenEmptyDirective, autoCompleteValidator, bimestreNames, buildRespostasFromGrupoRespostaDTO, changeRespostasEntityFormArray, datePickerValidator, deepCopy, deepEqual, fieldNameGruposDefault, fieldNameRespostaDefault, initGruposRespostaForm, isFunction, isNumber, isRebrandingActive, isString, isUserAdmin, limparRespostas, makeButton, moment, monthNames, operatorsFilter, permissions, quadrimestreNames, queryBuilderValueEmpty, semestreNames, shouldRenderNewTheme, suffixNameElementCampoMultiplaEscolha, suffixNameElementCampoValor, switchTheme, trimestreNames, validQueryBuilderValue, validateCamposDinamicos, ɵ0, ɵ1$1 as ɵ1, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, SingleClickButtonDirective as ɵb, PreventMultiClickDirective as ɵc, ActuatorService as ɵd, AccessRecoveryComponent as ɵe, NewPasswordComponent as ɵf, RecoveryMessageComponent as ɵg, MonthNamePipeModule as ɵh, MonthNamePipe as ɵi, DigitalCertificateModule as ɵj, DigitalCertificateComponent as ɵk, FeatureSobreSistemaService as ɵl, QueryBuilderTranslatorComponent as ɵm, QueryBuilderItemComponent as ɵn, SidebarItemComponent as ɵo };

//# sourceMappingURL=elotech-angular-common.js.map